(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire10e4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire10e4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lBpE3", function(module, exports) {
'use strict';

module.exports = (parcelRequire("a58XM"));

});
parcelRegister("a58XM", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $757152ee82640ba0$export$ffb0004e005737fa; }, function (v) { return $757152ee82640ba0$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $757152ee82640ba0$export$34b9dba7ce09269b; }, function (v) { return $757152ee82640ba0$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $757152ee82640ba0$export$25062201e9e25d76; }, function (v) { return $757152ee82640ba0$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $757152ee82640ba0$export$ffb0004e005737fa;
var $757152ee82640ba0$export$34b9dba7ce09269b;
var $757152ee82640ba0$export$25062201e9e25d76;
'use strict';

var $6cds3 = parcelRequire("6cds3");
var $757152ee82640ba0$var$k = Symbol.for("react.element"), $757152ee82640ba0$var$l = Symbol.for("react.fragment"), $757152ee82640ba0$var$m = Object.prototype.hasOwnProperty, $757152ee82640ba0$var$n = $6cds3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $757152ee82640ba0$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $757152ee82640ba0$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$757152ee82640ba0$var$m.call(a, b) && !$757152ee82640ba0$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $757152ee82640ba0$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $757152ee82640ba0$var$n.current
    };
}
$757152ee82640ba0$export$ffb0004e005737fa = $757152ee82640ba0$var$l;
$757152ee82640ba0$export$34b9dba7ce09269b = $757152ee82640ba0$var$q;
$757152ee82640ba0$export$25062201e9e25d76 = $757152ee82640ba0$var$q;

});
parcelRegister("6cds3", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gx6CV"));

});
parcelRegister("gx6CV", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $c094de5bd35107a3$export$dca3b0875bd9a954; }, function (v) { return $c094de5bd35107a3$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $c094de5bd35107a3$export$16fa2f45be04daa8; }, function (v) { return $c094de5bd35107a3$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $c094de5bd35107a3$export$ffb0004e005737fa; }, function (v) { return $c094de5bd35107a3$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $c094de5bd35107a3$export$e2c29f18771995cb; }, function (v) { return $c094de5bd35107a3$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $c094de5bd35107a3$export$221d75b3f55bb0bd; }, function (v) { return $c094de5bd35107a3$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $c094de5bd35107a3$export$5f8d39834fd61797; }, function (v) { return $c094de5bd35107a3$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $c094de5bd35107a3$export$74bf444e3cd11ea5; }, function (v) { return $c094de5bd35107a3$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c094de5bd35107a3$export$ae55be85d98224ed; }, function (v) { return $c094de5bd35107a3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $c094de5bd35107a3$export$e530037191fcd5d7; }, function (v) { return $c094de5bd35107a3$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $c094de5bd35107a3$export$fd42f52fd3ae1109; }, function (v) { return $c094de5bd35107a3$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $c094de5bd35107a3$export$c8a8987d4410bf2d; }, function (v) { return $c094de5bd35107a3$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $c094de5bd35107a3$export$d38cd72104c1f0e9; }, function (v) { return $c094de5bd35107a3$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $c094de5bd35107a3$export$7d1e3a5e95ceca43; }, function (v) { return $c094de5bd35107a3$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $c094de5bd35107a3$export$257a8862b851cb5b; }, function (v) { return $c094de5bd35107a3$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $c094de5bd35107a3$export$a8257692ac88316c; }, function (v) { return $c094de5bd35107a3$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $c094de5bd35107a3$export$488013bae63b21da; }, function (v) { return $c094de5bd35107a3$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $c094de5bd35107a3$export$7c73462e0d25e514; }, function (v) { return $c094de5bd35107a3$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $c094de5bd35107a3$export$7568632d0d33d16d; }, function (v) { return $c094de5bd35107a3$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $c094de5bd35107a3$export$88948ce120ea2619; }, function (v) { return $c094de5bd35107a3$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $c094de5bd35107a3$export$35808ee640e87ca7; }, function (v) { return $c094de5bd35107a3$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $c094de5bd35107a3$export$fae74005e78b1a27; }, function (v) { return $c094de5bd35107a3$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $c094de5bd35107a3$export$dc8fbce3eb94dc1e; }, function (v) { return $c094de5bd35107a3$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $c094de5bd35107a3$export$6a7bc4e911dc01cf; }, function (v) { return $c094de5bd35107a3$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $c094de5bd35107a3$export$6d9c69b0de29b591; }, function (v) { return $c094de5bd35107a3$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $c094de5bd35107a3$export$f680877a34711e37; }, function (v) { return $c094de5bd35107a3$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $c094de5bd35107a3$export$d5a552a76deda3c2; }, function (v) { return $c094de5bd35107a3$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $c094de5bd35107a3$export$aaabe4eda9ed9969; }, function (v) { return $c094de5bd35107a3$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $c094de5bd35107a3$export$e5c5a5f917a5871c; }, function (v) { return $c094de5bd35107a3$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $c094de5bd35107a3$export$1538c33de8887b59; }, function (v) { return $c094de5bd35107a3$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $c094de5bd35107a3$export$13e3392192263954; }, function (v) { return $c094de5bd35107a3$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $c094de5bd35107a3$export$b8f5890fc79d6aca; }, function (v) { return $c094de5bd35107a3$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $c094de5bd35107a3$export$60241385465d0a34; }, function (v) { return $c094de5bd35107a3$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $c094de5bd35107a3$export$306c0aa65ff9ec16; }, function (v) { return $c094de5bd35107a3$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $c094de5bd35107a3$export$7b286972b8d8ccbf; }, function (v) { return $c094de5bd35107a3$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $c094de5bd35107a3$export$83d89fbfd8236492; }, function (v) { return $c094de5bd35107a3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c094de5bd35107a3$export$dca3b0875bd9a954;
var $c094de5bd35107a3$export$16fa2f45be04daa8;
var $c094de5bd35107a3$export$ffb0004e005737fa;
var $c094de5bd35107a3$export$e2c29f18771995cb;
var $c094de5bd35107a3$export$221d75b3f55bb0bd;
var $c094de5bd35107a3$export$5f8d39834fd61797;
var $c094de5bd35107a3$export$74bf444e3cd11ea5;
var $c094de5bd35107a3$export$ae55be85d98224ed;
var $c094de5bd35107a3$export$e530037191fcd5d7;
var $c094de5bd35107a3$export$fd42f52fd3ae1109;
var $c094de5bd35107a3$export$c8a8987d4410bf2d;
var $c094de5bd35107a3$export$d38cd72104c1f0e9;
var $c094de5bd35107a3$export$7d1e3a5e95ceca43;
var $c094de5bd35107a3$export$257a8862b851cb5b;
var $c094de5bd35107a3$export$a8257692ac88316c;
var $c094de5bd35107a3$export$488013bae63b21da;
var $c094de5bd35107a3$export$7c73462e0d25e514;
var $c094de5bd35107a3$export$7568632d0d33d16d;
var $c094de5bd35107a3$export$88948ce120ea2619;
var $c094de5bd35107a3$export$35808ee640e87ca7;
var $c094de5bd35107a3$export$fae74005e78b1a27;
var $c094de5bd35107a3$export$dc8fbce3eb94dc1e;
var $c094de5bd35107a3$export$6a7bc4e911dc01cf;
var $c094de5bd35107a3$export$6d9c69b0de29b591;
var $c094de5bd35107a3$export$f680877a34711e37;
var $c094de5bd35107a3$export$d5a552a76deda3c2;
var $c094de5bd35107a3$export$aaabe4eda9ed9969;
var $c094de5bd35107a3$export$e5c5a5f917a5871c;
var $c094de5bd35107a3$export$1538c33de8887b59;
var $c094de5bd35107a3$export$13e3392192263954;
var $c094de5bd35107a3$export$b8f5890fc79d6aca;
var $c094de5bd35107a3$export$60241385465d0a34;
var $c094de5bd35107a3$export$306c0aa65ff9ec16;
var $c094de5bd35107a3$export$7b286972b8d8ccbf;
var $c094de5bd35107a3$export$83d89fbfd8236492;
'use strict';
var $c094de5bd35107a3$var$l = Symbol.for("react.element"), $c094de5bd35107a3$var$n = Symbol.for("react.portal"), $c094de5bd35107a3$var$p = Symbol.for("react.fragment"), $c094de5bd35107a3$var$q = Symbol.for("react.strict_mode"), $c094de5bd35107a3$var$r = Symbol.for("react.profiler"), $c094de5bd35107a3$var$t = Symbol.for("react.provider"), $c094de5bd35107a3$var$u = Symbol.for("react.context"), $c094de5bd35107a3$var$v = Symbol.for("react.forward_ref"), $c094de5bd35107a3$var$w = Symbol.for("react.suspense"), $c094de5bd35107a3$var$x = Symbol.for("react.memo"), $c094de5bd35107a3$var$y = Symbol.for("react.lazy"), $c094de5bd35107a3$var$z = Symbol.iterator;
function $c094de5bd35107a3$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c094de5bd35107a3$var$z && a[$c094de5bd35107a3$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c094de5bd35107a3$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $c094de5bd35107a3$var$C = Object.assign, $c094de5bd35107a3$var$D = {};
function $c094de5bd35107a3$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c094de5bd35107a3$var$D;
    this.updater = e || $c094de5bd35107a3$var$B;
}
$c094de5bd35107a3$var$E.prototype.isReactComponent = {};
$c094de5bd35107a3$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$c094de5bd35107a3$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $c094de5bd35107a3$var$F() {}
$c094de5bd35107a3$var$F.prototype = $c094de5bd35107a3$var$E.prototype;
function $c094de5bd35107a3$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c094de5bd35107a3$var$D;
    this.updater = e || $c094de5bd35107a3$var$B;
}
var $c094de5bd35107a3$var$H = $c094de5bd35107a3$var$G.prototype = new $c094de5bd35107a3$var$F;
$c094de5bd35107a3$var$H.constructor = $c094de5bd35107a3$var$G;
$c094de5bd35107a3$var$C($c094de5bd35107a3$var$H, $c094de5bd35107a3$var$E.prototype);
$c094de5bd35107a3$var$H.isPureReactComponent = !0;
var $c094de5bd35107a3$var$I = Array.isArray, $c094de5bd35107a3$var$J = Object.prototype.hasOwnProperty, $c094de5bd35107a3$var$K = {
    current: null
}, $c094de5bd35107a3$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $c094de5bd35107a3$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$c094de5bd35107a3$var$J.call(b, d) && !$c094de5bd35107a3$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $c094de5bd35107a3$var$K.current
    };
}
function $c094de5bd35107a3$var$N(a, b) {
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $c094de5bd35107a3$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $c094de5bd35107a3$var$l;
}
function $c094de5bd35107a3$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $c094de5bd35107a3$var$P = /\/+/g;
function $c094de5bd35107a3$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $c094de5bd35107a3$var$escape("" + a.key) : b.toString(36);
}
function $c094de5bd35107a3$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $c094de5bd35107a3$var$l:
                case $c094de5bd35107a3$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $c094de5bd35107a3$var$Q(h, 0) : d, $c094de5bd35107a3$var$I(c) ? (e = "", null != a && (e = a.replace($c094de5bd35107a3$var$P, "$&/") + "/"), $c094de5bd35107a3$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($c094de5bd35107a3$var$O(c) && (c = $c094de5bd35107a3$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($c094de5bd35107a3$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($c094de5bd35107a3$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $c094de5bd35107a3$var$Q(k, g);
        h += $c094de5bd35107a3$var$R(k, b, e, f, c);
    }
    else if (f = $c094de5bd35107a3$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $c094de5bd35107a3$var$Q(k, g++), h += $c094de5bd35107a3$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $c094de5bd35107a3$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $c094de5bd35107a3$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $c094de5bd35107a3$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $c094de5bd35107a3$var$U = {
    current: null
}, $c094de5bd35107a3$var$V = {
    transition: null
}, $c094de5bd35107a3$var$W = {
    ReactCurrentDispatcher: $c094de5bd35107a3$var$U,
    ReactCurrentBatchConfig: $c094de5bd35107a3$var$V,
    ReactCurrentOwner: $c094de5bd35107a3$var$K
};
$c094de5bd35107a3$export$dca3b0875bd9a954 = {
    map: $c094de5bd35107a3$var$S,
    forEach: function(a, b, e) {
        $c094de5bd35107a3$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $c094de5bd35107a3$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $c094de5bd35107a3$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$c094de5bd35107a3$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$c094de5bd35107a3$export$16fa2f45be04daa8 = $c094de5bd35107a3$var$E;
$c094de5bd35107a3$export$ffb0004e005737fa = $c094de5bd35107a3$var$p;
$c094de5bd35107a3$export$e2c29f18771995cb = $c094de5bd35107a3$var$r;
$c094de5bd35107a3$export$221d75b3f55bb0bd = $c094de5bd35107a3$var$G;
$c094de5bd35107a3$export$5f8d39834fd61797 = $c094de5bd35107a3$var$q;
$c094de5bd35107a3$export$74bf444e3cd11ea5 = $c094de5bd35107a3$var$w;
$c094de5bd35107a3$export$ae55be85d98224ed = $c094de5bd35107a3$var$W;
$c094de5bd35107a3$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $c094de5bd35107a3$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $c094de5bd35107a3$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$c094de5bd35107a3$var$J.call(b, f) && !$c094de5bd35107a3$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$c094de5bd35107a3$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $c094de5bd35107a3$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $c094de5bd35107a3$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$c094de5bd35107a3$export$c8a8987d4410bf2d = $c094de5bd35107a3$var$M;
$c094de5bd35107a3$export$d38cd72104c1f0e9 = function(a) {
    var b = $c094de5bd35107a3$var$M.bind(null, a);
    b.type = a;
    return b;
};
$c094de5bd35107a3$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$c094de5bd35107a3$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $c094de5bd35107a3$var$v,
        render: a
    };
};
$c094de5bd35107a3$export$a8257692ac88316c = $c094de5bd35107a3$var$O;
$c094de5bd35107a3$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $c094de5bd35107a3$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $c094de5bd35107a3$var$T
    };
};
$c094de5bd35107a3$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $c094de5bd35107a3$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$c094de5bd35107a3$export$7568632d0d33d16d = function(a) {
    var b = $c094de5bd35107a3$var$V.transition;
    $c094de5bd35107a3$var$V.transition = {};
    try {
        a();
    } finally{
        $c094de5bd35107a3$var$V.transition = b;
    }
};
$c094de5bd35107a3$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$c094de5bd35107a3$export$35808ee640e87ca7 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useCallback(a, b);
};
$c094de5bd35107a3$export$fae74005e78b1a27 = function(a) {
    return $c094de5bd35107a3$var$U.current.useContext(a);
};
$c094de5bd35107a3$export$dc8fbce3eb94dc1e = function() {};
$c094de5bd35107a3$export$6a7bc4e911dc01cf = function(a) {
    return $c094de5bd35107a3$var$U.current.useDeferredValue(a);
};
$c094de5bd35107a3$export$6d9c69b0de29b591 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useEffect(a, b);
};
$c094de5bd35107a3$export$f680877a34711e37 = function() {
    return $c094de5bd35107a3$var$U.current.useId();
};
$c094de5bd35107a3$export$d5a552a76deda3c2 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useImperativeHandle(a, b, e);
};
$c094de5bd35107a3$export$aaabe4eda9ed9969 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useInsertionEffect(a, b);
};
$c094de5bd35107a3$export$e5c5a5f917a5871c = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useLayoutEffect(a, b);
};
$c094de5bd35107a3$export$1538c33de8887b59 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useMemo(a, b);
};
$c094de5bd35107a3$export$13e3392192263954 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useReducer(a, b, e);
};
$c094de5bd35107a3$export$b8f5890fc79d6aca = function(a) {
    return $c094de5bd35107a3$var$U.current.useRef(a);
};
$c094de5bd35107a3$export$60241385465d0a34 = function(a) {
    return $c094de5bd35107a3$var$U.current.useState(a);
};
$c094de5bd35107a3$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useSyncExternalStore(a, b, e);
};
$c094de5bd35107a3$export$7b286972b8d8ccbf = function() {
    return $c094de5bd35107a3$var$U.current.useTransition();
};
$c094de5bd35107a3$export$83d89fbfd8236492 = "18.2.0";

});




parcelRegister("jZA9I", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $e8dfc29dafb3bbd7$export$ae55be85d98224ed; }, function (v) { return $e8dfc29dafb3bbd7$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $e8dfc29dafb3bbd7$export$d39a5bbd09211389; }, function (v) { return $e8dfc29dafb3bbd7$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $e8dfc29dafb3bbd7$export$882461b6382ed46c; }, function (v) { return $e8dfc29dafb3bbd7$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $e8dfc29dafb3bbd7$export$466bfc07425424d5; }, function (v) { return $e8dfc29dafb3bbd7$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4; }, function (v) { return $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $e8dfc29dafb3bbd7$export$fa8d919ba61d84db; }, function (v) { return $e8dfc29dafb3bbd7$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $e8dfc29dafb3bbd7$export$757ceba2d55c277e; }, function (v) { return $e8dfc29dafb3bbd7$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99; }, function (v) { return $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $e8dfc29dafb3bbd7$export$502457920280e6be; }, function (v) { return $e8dfc29dafb3bbd7$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $e8dfc29dafb3bbd7$export$c78a37762a8d58e1; }, function (v) { return $e8dfc29dafb3bbd7$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $e8dfc29dafb3bbd7$export$dc54d992c10e8a18; }, function (v) { return $e8dfc29dafb3bbd7$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $e8dfc29dafb3bbd7$export$83d89fbfd8236492; }, function (v) { return $e8dfc29dafb3bbd7$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $e8dfc29dafb3bbd7$export$ae55be85d98224ed;
var $e8dfc29dafb3bbd7$export$d39a5bbd09211389;
var $e8dfc29dafb3bbd7$export$882461b6382ed46c;
var $e8dfc29dafb3bbd7$export$466bfc07425424d5;
var $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4;
var $e8dfc29dafb3bbd7$export$fa8d919ba61d84db;
var $e8dfc29dafb3bbd7$export$757ceba2d55c277e;
var $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99;
var $e8dfc29dafb3bbd7$export$502457920280e6be;
var $e8dfc29dafb3bbd7$export$c78a37762a8d58e1;
var $e8dfc29dafb3bbd7$export$dc54d992c10e8a18;
var $e8dfc29dafb3bbd7$export$83d89fbfd8236492;
'use strict';

var $6cds3 = parcelRequire("6cds3");

var $1c9zD = parcelRequire("1c9zD");
function $e8dfc29dafb3bbd7$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $e8dfc29dafb3bbd7$var$da = new Set, $e8dfc29dafb3bbd7$var$ea = {};
function $e8dfc29dafb3bbd7$var$fa(a, b) {
    $e8dfc29dafb3bbd7$var$ha(a, b);
    $e8dfc29dafb3bbd7$var$ha(a + "Capture", b);
}
function $e8dfc29dafb3bbd7$var$ha(a, b) {
    $e8dfc29dafb3bbd7$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$e8dfc29dafb3bbd7$var$da.add(b[a]);
}
var $e8dfc29dafb3bbd7$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $e8dfc29dafb3bbd7$var$ja = Object.prototype.hasOwnProperty, $e8dfc29dafb3bbd7$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $e8dfc29dafb3bbd7$var$la = {}, $e8dfc29dafb3bbd7$var$ma = {};
function $e8dfc29dafb3bbd7$var$oa(a) {
    if ($e8dfc29dafb3bbd7$var$ja.call($e8dfc29dafb3bbd7$var$ma, a)) return !0;
    if ($e8dfc29dafb3bbd7$var$ja.call($e8dfc29dafb3bbd7$var$la, a)) return !1;
    if ($e8dfc29dafb3bbd7$var$ka.test(a)) return $e8dfc29dafb3bbd7$var$ma[a] = !0;
    $e8dfc29dafb3bbd7$var$la[a] = !0;
    return !1;
}
function $e8dfc29dafb3bbd7$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $e8dfc29dafb3bbd7$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $e8dfc29dafb3bbd7$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $e8dfc29dafb3bbd7$var$ra = /[\-:]([a-z])/g;
function $e8dfc29dafb3bbd7$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$e8dfc29dafb3bbd7$var$z.xlinkHref = new $e8dfc29dafb3bbd7$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $e8dfc29dafb3bbd7$var$ta(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$z.hasOwnProperty(b) ? $e8dfc29dafb3bbd7$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $e8dfc29dafb3bbd7$var$qa(b, c, e, d) && (c = null), d || null === e ? $e8dfc29dafb3bbd7$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $e8dfc29dafb3bbd7$var$ua = $6cds3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $e8dfc29dafb3bbd7$var$va = Symbol.for("react.element"), $e8dfc29dafb3bbd7$var$wa = Symbol.for("react.portal"), $e8dfc29dafb3bbd7$var$ya = Symbol.for("react.fragment"), $e8dfc29dafb3bbd7$var$za = Symbol.for("react.strict_mode"), $e8dfc29dafb3bbd7$var$Aa = Symbol.for("react.profiler"), $e8dfc29dafb3bbd7$var$Ba = Symbol.for("react.provider"), $e8dfc29dafb3bbd7$var$Ca = Symbol.for("react.context"), $e8dfc29dafb3bbd7$var$Da = Symbol.for("react.forward_ref"), $e8dfc29dafb3bbd7$var$Ea = Symbol.for("react.suspense"), $e8dfc29dafb3bbd7$var$Fa = Symbol.for("react.suspense_list"), $e8dfc29dafb3bbd7$var$Ga = Symbol.for("react.memo"), $e8dfc29dafb3bbd7$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $e8dfc29dafb3bbd7$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $e8dfc29dafb3bbd7$var$Ja = Symbol.iterator;
function $e8dfc29dafb3bbd7$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $e8dfc29dafb3bbd7$var$Ja && a[$e8dfc29dafb3bbd7$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e8dfc29dafb3bbd7$var$A = Object.assign, $e8dfc29dafb3bbd7$var$La;
function $e8dfc29dafb3bbd7$var$Ma(a) {
    if (void 0 === $e8dfc29dafb3bbd7$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $e8dfc29dafb3bbd7$var$La = b && b[1] || "";
    }
    return "\n" + $e8dfc29dafb3bbd7$var$La + a;
}
var $e8dfc29dafb3bbd7$var$Na = !1;
function $e8dfc29dafb3bbd7$var$Oa(a, b) {
    if (!a || $e8dfc29dafb3bbd7$var$Na) return "";
    $e8dfc29dafb3bbd7$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $e8dfc29dafb3bbd7$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $e8dfc29dafb3bbd7$var$Ma(a) : "";
}
function $e8dfc29dafb3bbd7$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $e8dfc29dafb3bbd7$var$Ma(a.type);
        case 16:
            return $e8dfc29dafb3bbd7$var$Ma("Lazy");
        case 13:
            return $e8dfc29dafb3bbd7$var$Ma("Suspense");
        case 19:
            return $e8dfc29dafb3bbd7$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type, !1), a;
        case 11:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $e8dfc29dafb3bbd7$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $e8dfc29dafb3bbd7$var$ya:
            return "Fragment";
        case $e8dfc29dafb3bbd7$var$wa:
            return "Portal";
        case $e8dfc29dafb3bbd7$var$Aa:
            return "Profiler";
        case $e8dfc29dafb3bbd7$var$za:
            return "StrictMode";
        case $e8dfc29dafb3bbd7$var$Ea:
            return "Suspense";
        case $e8dfc29dafb3bbd7$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $e8dfc29dafb3bbd7$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $e8dfc29dafb3bbd7$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $e8dfc29dafb3bbd7$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $e8dfc29dafb3bbd7$var$Ga:
            return b = a.displayName || null, null !== b ? b : $e8dfc29dafb3bbd7$var$Qa(a.type) || "Memo";
        case $e8dfc29dafb3bbd7$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $e8dfc29dafb3bbd7$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $e8dfc29dafb3bbd7$var$Qa(b);
        case 8:
            return b === $e8dfc29dafb3bbd7$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $e8dfc29dafb3bbd7$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $e8dfc29dafb3bbd7$var$Ua(a) {
    var b = $e8dfc29dafb3bbd7$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $e8dfc29dafb3bbd7$var$Va(a) {
    a._valueTracker || (a._valueTracker = $e8dfc29dafb3bbd7$var$Ua(a));
}
function $e8dfc29dafb3bbd7$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $e8dfc29dafb3bbd7$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $e8dfc29dafb3bbd7$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $e8dfc29dafb3bbd7$var$Ya(a, b) {
    var c = b.checked;
    return $e8dfc29dafb3bbd7$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $e8dfc29dafb3bbd7$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $e8dfc29dafb3bbd7$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $e8dfc29dafb3bbd7$var$ab(a, b) {
    b = b.checked;
    null != b && $e8dfc29dafb3bbd7$var$ta(a, "checked", b, !1);
}
function $e8dfc29dafb3bbd7$var$bb(a, b) {
    $e8dfc29dafb3bbd7$var$ab(a, b);
    var c = $e8dfc29dafb3bbd7$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $e8dfc29dafb3bbd7$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $e8dfc29dafb3bbd7$var$cb(a, b.type, $e8dfc29dafb3bbd7$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $e8dfc29dafb3bbd7$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $e8dfc29dafb3bbd7$var$cb(a, b, c) {
    if ("number" !== b || $e8dfc29dafb3bbd7$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $e8dfc29dafb3bbd7$var$eb = Array.isArray;
function $e8dfc29dafb3bbd7$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $e8dfc29dafb3bbd7$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $e8dfc29dafb3bbd7$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($e8dfc29dafb3bbd7$var$p(91));
    return $e8dfc29dafb3bbd7$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $e8dfc29dafb3bbd7$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($e8dfc29dafb3bbd7$var$p(92));
            if ($e8dfc29dafb3bbd7$var$eb(c)) {
                if (1 < c.length) throw Error($e8dfc29dafb3bbd7$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $e8dfc29dafb3bbd7$var$Sa(c)
    };
}
function $e8dfc29dafb3bbd7$var$ib(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Sa(b.value), d = $e8dfc29dafb3bbd7$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $e8dfc29dafb3bbd7$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $e8dfc29dafb3bbd7$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $e8dfc29dafb3bbd7$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $e8dfc29dafb3bbd7$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $e8dfc29dafb3bbd7$var$mb, $e8dfc29dafb3bbd7$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $e8dfc29dafb3bbd7$var$mb = $e8dfc29dafb3bbd7$var$mb || document.createElement("div");
        $e8dfc29dafb3bbd7$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $e8dfc29dafb3bbd7$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $e8dfc29dafb3bbd7$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $e8dfc29dafb3bbd7$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $e8dfc29dafb3bbd7$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($e8dfc29dafb3bbd7$var$pb).forEach(function(a) {
    $e8dfc29dafb3bbd7$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $e8dfc29dafb3bbd7$var$pb[b] = $e8dfc29dafb3bbd7$var$pb[a];
    });
});
function $e8dfc29dafb3bbd7$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $e8dfc29dafb3bbd7$var$pb.hasOwnProperty(a) && $e8dfc29dafb3bbd7$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $e8dfc29dafb3bbd7$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $e8dfc29dafb3bbd7$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $e8dfc29dafb3bbd7$var$tb = $e8dfc29dafb3bbd7$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $e8dfc29dafb3bbd7$var$ub(a, b) {
    if (b) {
        if ($e8dfc29dafb3bbd7$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($e8dfc29dafb3bbd7$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($e8dfc29dafb3bbd7$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($e8dfc29dafb3bbd7$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($e8dfc29dafb3bbd7$var$p(62));
    }
}
function $e8dfc29dafb3bbd7$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $e8dfc29dafb3bbd7$var$wb = null;
function $e8dfc29dafb3bbd7$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $e8dfc29dafb3bbd7$var$yb = null, $e8dfc29dafb3bbd7$var$zb = null, $e8dfc29dafb3bbd7$var$Ab = null;
function $e8dfc29dafb3bbd7$var$Bb(a) {
    if (a = $e8dfc29dafb3bbd7$var$Cb(a)) {
        if ("function" !== typeof $e8dfc29dafb3bbd7$var$yb) throw Error($e8dfc29dafb3bbd7$var$p(280));
        var b = a.stateNode;
        b && (b = $e8dfc29dafb3bbd7$var$Db(b), $e8dfc29dafb3bbd7$var$yb(a.stateNode, a.type, b));
    }
}
function $e8dfc29dafb3bbd7$var$Eb(a) {
    $e8dfc29dafb3bbd7$var$zb ? $e8dfc29dafb3bbd7$var$Ab ? $e8dfc29dafb3bbd7$var$Ab.push(a) : $e8dfc29dafb3bbd7$var$Ab = [
        a
    ] : $e8dfc29dafb3bbd7$var$zb = a;
}
function $e8dfc29dafb3bbd7$var$Fb() {
    if ($e8dfc29dafb3bbd7$var$zb) {
        var a = $e8dfc29dafb3bbd7$var$zb, b = $e8dfc29dafb3bbd7$var$Ab;
        $e8dfc29dafb3bbd7$var$Ab = $e8dfc29dafb3bbd7$var$zb = null;
        $e8dfc29dafb3bbd7$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$e8dfc29dafb3bbd7$var$Bb(b[a]);
    }
}
function $e8dfc29dafb3bbd7$var$Gb(a, b) {
    return a(b);
}
function $e8dfc29dafb3bbd7$var$Hb() {}
var $e8dfc29dafb3bbd7$var$Ib = !1;
function $e8dfc29dafb3bbd7$var$Jb(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$Ib) return a(b, c);
    $e8dfc29dafb3bbd7$var$Ib = !0;
    try {
        return $e8dfc29dafb3bbd7$var$Gb(a, b, c);
    } finally{
        if ($e8dfc29dafb3bbd7$var$Ib = !1, null !== $e8dfc29dafb3bbd7$var$zb || null !== $e8dfc29dafb3bbd7$var$Ab) $e8dfc29dafb3bbd7$var$Hb(), $e8dfc29dafb3bbd7$var$Fb();
    }
}
function $e8dfc29dafb3bbd7$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $e8dfc29dafb3bbd7$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($e8dfc29dafb3bbd7$var$p(231, b, typeof c));
    return c;
}
var $e8dfc29dafb3bbd7$var$Lb = !1;
if ($e8dfc29dafb3bbd7$var$ia) try {
    var $e8dfc29dafb3bbd7$var$Mb = {};
    Object.defineProperty($e8dfc29dafb3bbd7$var$Mb, "passive", {
        get: function() {
            $e8dfc29dafb3bbd7$var$Lb = !0;
        }
    });
    window.addEventListener("test", $e8dfc29dafb3bbd7$var$Mb, $e8dfc29dafb3bbd7$var$Mb);
    window.removeEventListener("test", $e8dfc29dafb3bbd7$var$Mb, $e8dfc29dafb3bbd7$var$Mb);
} catch (a) {
    $e8dfc29dafb3bbd7$var$Lb = !1;
}
function $e8dfc29dafb3bbd7$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $e8dfc29dafb3bbd7$var$Ob = !1, $e8dfc29dafb3bbd7$var$Pb = null, $e8dfc29dafb3bbd7$var$Qb = !1, $e8dfc29dafb3bbd7$var$Rb = null, $e8dfc29dafb3bbd7$var$Sb = {
    onError: function(a) {
        $e8dfc29dafb3bbd7$var$Ob = !0;
        $e8dfc29dafb3bbd7$var$Pb = a;
    }
};
function $e8dfc29dafb3bbd7$var$Tb(a, b, c, d, e, f, g, h, k) {
    $e8dfc29dafb3bbd7$var$Ob = !1;
    $e8dfc29dafb3bbd7$var$Pb = null;
    $e8dfc29dafb3bbd7$var$Nb.apply($e8dfc29dafb3bbd7$var$Sb, arguments);
}
function $e8dfc29dafb3bbd7$var$Ub(a, b, c, d, e, f, g, h, k) {
    $e8dfc29dafb3bbd7$var$Tb.apply(this, arguments);
    if ($e8dfc29dafb3bbd7$var$Ob) {
        if ($e8dfc29dafb3bbd7$var$Ob) {
            var l = $e8dfc29dafb3bbd7$var$Pb;
            $e8dfc29dafb3bbd7$var$Ob = !1;
            $e8dfc29dafb3bbd7$var$Pb = null;
        } else throw Error($e8dfc29dafb3bbd7$var$p(198));
        $e8dfc29dafb3bbd7$var$Qb || ($e8dfc29dafb3bbd7$var$Qb = !0, $e8dfc29dafb3bbd7$var$Rb = l);
    }
}
function $e8dfc29dafb3bbd7$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $e8dfc29dafb3bbd7$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Xb(a) {
    if ($e8dfc29dafb3bbd7$var$Vb(a) !== a) throw Error($e8dfc29dafb3bbd7$var$p(188));
}
function $e8dfc29dafb3bbd7$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $e8dfc29dafb3bbd7$var$Vb(a);
        if (null === b) throw Error($e8dfc29dafb3bbd7$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $e8dfc29dafb3bbd7$var$Xb(e), a;
                if (f === d) return $e8dfc29dafb3bbd7$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($e8dfc29dafb3bbd7$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($e8dfc29dafb3bbd7$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($e8dfc29dafb3bbd7$var$p(190));
    }
    if (3 !== c.tag) throw Error($e8dfc29dafb3bbd7$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $e8dfc29dafb3bbd7$var$Zb(a) {
    a = $e8dfc29dafb3bbd7$var$Yb(a);
    return null !== a ? $e8dfc29dafb3bbd7$var$$b(a) : null;
}
function $e8dfc29dafb3bbd7$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $e8dfc29dafb3bbd7$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$ac = $1c9zD.unstable_scheduleCallback, $e8dfc29dafb3bbd7$var$bc = $1c9zD.unstable_cancelCallback, $e8dfc29dafb3bbd7$var$cc = $1c9zD.unstable_shouldYield, $e8dfc29dafb3bbd7$var$dc = $1c9zD.unstable_requestPaint, $e8dfc29dafb3bbd7$var$B = $1c9zD.unstable_now, $e8dfc29dafb3bbd7$var$ec = $1c9zD.unstable_getCurrentPriorityLevel, $e8dfc29dafb3bbd7$var$fc = $1c9zD.unstable_ImmediatePriority, $e8dfc29dafb3bbd7$var$gc = $1c9zD.unstable_UserBlockingPriority, $e8dfc29dafb3bbd7$var$hc = $1c9zD.unstable_NormalPriority, $e8dfc29dafb3bbd7$var$ic = $1c9zD.unstable_LowPriority, $e8dfc29dafb3bbd7$var$jc = $1c9zD.unstable_IdlePriority, $e8dfc29dafb3bbd7$var$kc = null, $e8dfc29dafb3bbd7$var$lc = null;
function $e8dfc29dafb3bbd7$var$mc(a) {
    if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onCommitFiberRoot) try {
        $e8dfc29dafb3bbd7$var$lc.onCommitFiberRoot($e8dfc29dafb3bbd7$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $e8dfc29dafb3bbd7$var$oc = Math.clz32 ? Math.clz32 : $e8dfc29dafb3bbd7$var$nc, $e8dfc29dafb3bbd7$var$pc = Math.log, $e8dfc29dafb3bbd7$var$qc = Math.LN2;
function $e8dfc29dafb3bbd7$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($e8dfc29dafb3bbd7$var$pc(a) / $e8dfc29dafb3bbd7$var$qc | 0) | 0;
}
var $e8dfc29dafb3bbd7$var$rc = 64, $e8dfc29dafb3bbd7$var$sc = 4194304;
function $e8dfc29dafb3bbd7$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $e8dfc29dafb3bbd7$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $e8dfc29dafb3bbd7$var$tc(h) : (f &= g, 0 !== f && (d = $e8dfc29dafb3bbd7$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $e8dfc29dafb3bbd7$var$tc(g) : 0 !== f && (d = $e8dfc29dafb3bbd7$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $e8dfc29dafb3bbd7$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $e8dfc29dafb3bbd7$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $e8dfc29dafb3bbd7$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $e8dfc29dafb3bbd7$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $e8dfc29dafb3bbd7$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $e8dfc29dafb3bbd7$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $e8dfc29dafb3bbd7$var$yc() {
    var a = $e8dfc29dafb3bbd7$var$rc;
    $e8dfc29dafb3bbd7$var$rc <<= 1;
    0 === ($e8dfc29dafb3bbd7$var$rc & 4194240) && ($e8dfc29dafb3bbd7$var$rc = 64);
    return a;
}
function $e8dfc29dafb3bbd7$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $e8dfc29dafb3bbd7$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $e8dfc29dafb3bbd7$var$oc(b);
    a[b] = c;
}
function $e8dfc29dafb3bbd7$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $e8dfc29dafb3bbd7$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $e8dfc29dafb3bbd7$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $e8dfc29dafb3bbd7$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $e8dfc29dafb3bbd7$var$C = 0;
function $e8dfc29dafb3bbd7$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $e8dfc29dafb3bbd7$var$Ec, $e8dfc29dafb3bbd7$var$Fc, $e8dfc29dafb3bbd7$var$Gc, $e8dfc29dafb3bbd7$var$Hc, $e8dfc29dafb3bbd7$var$Ic, $e8dfc29dafb3bbd7$var$Jc = !1, $e8dfc29dafb3bbd7$var$Kc = [], $e8dfc29dafb3bbd7$var$Lc = null, $e8dfc29dafb3bbd7$var$Mc = null, $e8dfc29dafb3bbd7$var$Nc = null, $e8dfc29dafb3bbd7$var$Oc = new Map, $e8dfc29dafb3bbd7$var$Pc = new Map, $e8dfc29dafb3bbd7$var$Qc = [], $e8dfc29dafb3bbd7$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $e8dfc29dafb3bbd7$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $e8dfc29dafb3bbd7$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $e8dfc29dafb3bbd7$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $e8dfc29dafb3bbd7$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $e8dfc29dafb3bbd7$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $e8dfc29dafb3bbd7$var$Pc.delete(b.pointerId);
    }
}
function $e8dfc29dafb3bbd7$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $e8dfc29dafb3bbd7$var$Cb(b), null !== b && $e8dfc29dafb3bbd7$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $e8dfc29dafb3bbd7$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $e8dfc29dafb3bbd7$var$Lc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $e8dfc29dafb3bbd7$var$Mc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $e8dfc29dafb3bbd7$var$Nc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $e8dfc29dafb3bbd7$var$Oc.set(f, $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $e8dfc29dafb3bbd7$var$Pc.set(f, $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$Vc(a) {
    var b = $e8dfc29dafb3bbd7$var$Wc(a.target);
    if (null !== b) {
        var c = $e8dfc29dafb3bbd7$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $e8dfc29dafb3bbd7$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $e8dfc29dafb3bbd7$var$Ic(a.priority, function() {
                        $e8dfc29dafb3bbd7$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $e8dfc29dafb3bbd7$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $e8dfc29dafb3bbd7$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $e8dfc29dafb3bbd7$var$wb = d;
            c.target.dispatchEvent(d);
            $e8dfc29dafb3bbd7$var$wb = null;
        } else return b = $e8dfc29dafb3bbd7$var$Cb(c), null !== b && $e8dfc29dafb3bbd7$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Zc(a, b, c) {
    $e8dfc29dafb3bbd7$var$Xc(a) && c.delete(b);
}
function $e8dfc29dafb3bbd7$var$$c() {
    $e8dfc29dafb3bbd7$var$Jc = !1;
    null !== $e8dfc29dafb3bbd7$var$Lc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Lc) && ($e8dfc29dafb3bbd7$var$Lc = null);
    null !== $e8dfc29dafb3bbd7$var$Mc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Mc) && ($e8dfc29dafb3bbd7$var$Mc = null);
    null !== $e8dfc29dafb3bbd7$var$Nc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Nc) && ($e8dfc29dafb3bbd7$var$Nc = null);
    $e8dfc29dafb3bbd7$var$Oc.forEach($e8dfc29dafb3bbd7$var$Zc);
    $e8dfc29dafb3bbd7$var$Pc.forEach($e8dfc29dafb3bbd7$var$Zc);
}
function $e8dfc29dafb3bbd7$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $e8dfc29dafb3bbd7$var$Jc || ($e8dfc29dafb3bbd7$var$Jc = !0, $1c9zD.unstable_scheduleCallback($1c9zD.unstable_NormalPriority, $e8dfc29dafb3bbd7$var$$c)));
}
function $e8dfc29dafb3bbd7$var$bd(a) {
    function b(b) {
        return $e8dfc29dafb3bbd7$var$ad(b, a);
    }
    if (0 < $e8dfc29dafb3bbd7$var$Kc.length) {
        $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Kc[0], a);
        for(var c = 1; c < $e8dfc29dafb3bbd7$var$Kc.length; c++){
            var d = $e8dfc29dafb3bbd7$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $e8dfc29dafb3bbd7$var$Lc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Lc, a);
    null !== $e8dfc29dafb3bbd7$var$Mc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Mc, a);
    null !== $e8dfc29dafb3bbd7$var$Nc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Nc, a);
    $e8dfc29dafb3bbd7$var$Oc.forEach(b);
    $e8dfc29dafb3bbd7$var$Pc.forEach(b);
    for(c = 0; c < $e8dfc29dafb3bbd7$var$Qc.length; c++)d = $e8dfc29dafb3bbd7$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $e8dfc29dafb3bbd7$var$Qc.length && (c = $e8dfc29dafb3bbd7$var$Qc[0], null === c.blockedOn);)$e8dfc29dafb3bbd7$var$Vc(c), null === c.blockedOn && $e8dfc29dafb3bbd7$var$Qc.shift();
}
var $e8dfc29dafb3bbd7$var$cd = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$dd = !0;
function $e8dfc29dafb3bbd7$var$ed(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$C, f = $e8dfc29dafb3bbd7$var$cd.transition;
    $e8dfc29dafb3bbd7$var$cd.transition = null;
    try {
        $e8dfc29dafb3bbd7$var$C = 1, $e8dfc29dafb3bbd7$var$fd(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$C = e, $e8dfc29dafb3bbd7$var$cd.transition = f;
    }
}
function $e8dfc29dafb3bbd7$var$gd(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$C, f = $e8dfc29dafb3bbd7$var$cd.transition;
    $e8dfc29dafb3bbd7$var$cd.transition = null;
    try {
        $e8dfc29dafb3bbd7$var$C = 4, $e8dfc29dafb3bbd7$var$fd(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$C = e, $e8dfc29dafb3bbd7$var$cd.transition = f;
    }
}
function $e8dfc29dafb3bbd7$var$fd(a, b, c, d) {
    if ($e8dfc29dafb3bbd7$var$dd) {
        var e = $e8dfc29dafb3bbd7$var$Yc(a, b, c, d);
        if (null === e) $e8dfc29dafb3bbd7$var$hd(a, b, d, $e8dfc29dafb3bbd7$var$id, c), $e8dfc29dafb3bbd7$var$Sc(a, d);
        else if ($e8dfc29dafb3bbd7$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($e8dfc29dafb3bbd7$var$Sc(a, d), b & 4 && -1 < $e8dfc29dafb3bbd7$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $e8dfc29dafb3bbd7$var$Cb(e);
                null !== f && $e8dfc29dafb3bbd7$var$Ec(f);
                f = $e8dfc29dafb3bbd7$var$Yc(a, b, c, d);
                null === f && $e8dfc29dafb3bbd7$var$hd(a, b, d, $e8dfc29dafb3bbd7$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $e8dfc29dafb3bbd7$var$hd(a, b, d, null, c);
    }
}
var $e8dfc29dafb3bbd7$var$id = null;
function $e8dfc29dafb3bbd7$var$Yc(a, b, c, d) {
    $e8dfc29dafb3bbd7$var$id = null;
    a = $e8dfc29dafb3bbd7$var$xb(d);
    a = $e8dfc29dafb3bbd7$var$Wc(a);
    if (null !== a) {
        if (b = $e8dfc29dafb3bbd7$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $e8dfc29dafb3bbd7$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $e8dfc29dafb3bbd7$var$id = a;
    return null;
}
function $e8dfc29dafb3bbd7$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($e8dfc29dafb3bbd7$var$ec()){
                case $e8dfc29dafb3bbd7$var$fc:
                    return 1;
                case $e8dfc29dafb3bbd7$var$gc:
                    return 4;
                case $e8dfc29dafb3bbd7$var$hc:
                case $e8dfc29dafb3bbd7$var$ic:
                    return 16;
                case $e8dfc29dafb3bbd7$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $e8dfc29dafb3bbd7$var$kd = null, $e8dfc29dafb3bbd7$var$ld = null, $e8dfc29dafb3bbd7$var$md = null;
function $e8dfc29dafb3bbd7$var$nd() {
    if ($e8dfc29dafb3bbd7$var$md) return $e8dfc29dafb3bbd7$var$md;
    var a, b = $e8dfc29dafb3bbd7$var$ld, c = b.length, d, e = "value" in $e8dfc29dafb3bbd7$var$kd ? $e8dfc29dafb3bbd7$var$kd.value : $e8dfc29dafb3bbd7$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $e8dfc29dafb3bbd7$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $e8dfc29dafb3bbd7$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $e8dfc29dafb3bbd7$var$pd() {
    return !0;
}
function $e8dfc29dafb3bbd7$var$qd() {
    return !1;
}
function $e8dfc29dafb3bbd7$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $e8dfc29dafb3bbd7$var$pd : $e8dfc29dafb3bbd7$var$qd;
        this.isPropagationStopped = $e8dfc29dafb3bbd7$var$qd;
        return this;
    }
    $e8dfc29dafb3bbd7$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $e8dfc29dafb3bbd7$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $e8dfc29dafb3bbd7$var$pd);
        },
        persist: function() {},
        isPersistent: $e8dfc29dafb3bbd7$var$pd
    });
    return b;
}
var $e8dfc29dafb3bbd7$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $e8dfc29dafb3bbd7$var$td = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$sd), $e8dfc29dafb3bbd7$var$ud = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    view: 0,
    detail: 0
}), $e8dfc29dafb3bbd7$var$vd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$ud), $e8dfc29dafb3bbd7$var$wd, $e8dfc29dafb3bbd7$var$xd, $e8dfc29dafb3bbd7$var$yd, $e8dfc29dafb3bbd7$var$Ad = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $e8dfc29dafb3bbd7$var$yd && ($e8dfc29dafb3bbd7$var$yd && "mousemove" === a.type ? ($e8dfc29dafb3bbd7$var$wd = a.screenX - $e8dfc29dafb3bbd7$var$yd.screenX, $e8dfc29dafb3bbd7$var$xd = a.screenY - $e8dfc29dafb3bbd7$var$yd.screenY) : $e8dfc29dafb3bbd7$var$xd = $e8dfc29dafb3bbd7$var$wd = 0, $e8dfc29dafb3bbd7$var$yd = a);
        return $e8dfc29dafb3bbd7$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $e8dfc29dafb3bbd7$var$xd;
    }
}), $e8dfc29dafb3bbd7$var$Bd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ad), $e8dfc29dafb3bbd7$var$Cd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    dataTransfer: 0
}), $e8dfc29dafb3bbd7$var$Dd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Cd), $e8dfc29dafb3bbd7$var$Ed = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    relatedTarget: 0
}), $e8dfc29dafb3bbd7$var$Fd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ed), $e8dfc29dafb3bbd7$var$Gd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e8dfc29dafb3bbd7$var$Hd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Gd), $e8dfc29dafb3bbd7$var$Id = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $e8dfc29dafb3bbd7$var$Jd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Id), $e8dfc29dafb3bbd7$var$Kd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    data: 0
}), $e8dfc29dafb3bbd7$var$Ld = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Kd), $e8dfc29dafb3bbd7$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $e8dfc29dafb3bbd7$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $e8dfc29dafb3bbd7$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $e8dfc29dafb3bbd7$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $e8dfc29dafb3bbd7$var$Od[a]) ? !!b[a] : !1;
}
function $e8dfc29dafb3bbd7$var$zd() {
    return $e8dfc29dafb3bbd7$var$Pd;
}
var $e8dfc29dafb3bbd7$var$Qd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $e8dfc29dafb3bbd7$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $e8dfc29dafb3bbd7$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $e8dfc29dafb3bbd7$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $e8dfc29dafb3bbd7$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $e8dfc29dafb3bbd7$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $e8dfc29dafb3bbd7$var$Rd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Qd), $e8dfc29dafb3bbd7$var$Sd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $e8dfc29dafb3bbd7$var$Td = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Sd), $e8dfc29dafb3bbd7$var$Ud = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd
}), $e8dfc29dafb3bbd7$var$Vd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ud), $e8dfc29dafb3bbd7$var$Wd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e8dfc29dafb3bbd7$var$Xd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Wd), $e8dfc29dafb3bbd7$var$Yd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $e8dfc29dafb3bbd7$var$Zd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Yd), $e8dfc29dafb3bbd7$var$$d = [
    9,
    13,
    27,
    32
], $e8dfc29dafb3bbd7$var$ae = $e8dfc29dafb3bbd7$var$ia && "CompositionEvent" in window, $e8dfc29dafb3bbd7$var$be = null;
$e8dfc29dafb3bbd7$var$ia && "documentMode" in document && ($e8dfc29dafb3bbd7$var$be = document.documentMode);
var $e8dfc29dafb3bbd7$var$ce = $e8dfc29dafb3bbd7$var$ia && "TextEvent" in window && !$e8dfc29dafb3bbd7$var$be, $e8dfc29dafb3bbd7$var$de = $e8dfc29dafb3bbd7$var$ia && (!$e8dfc29dafb3bbd7$var$ae || $e8dfc29dafb3bbd7$var$be && 8 < $e8dfc29dafb3bbd7$var$be && 11 >= $e8dfc29dafb3bbd7$var$be), $e8dfc29dafb3bbd7$var$ee = String.fromCharCode(32), $e8dfc29dafb3bbd7$var$fe = !1;
function $e8dfc29dafb3bbd7$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $e8dfc29dafb3bbd7$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $e8dfc29dafb3bbd7$var$ie = !1;
function $e8dfc29dafb3bbd7$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $e8dfc29dafb3bbd7$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $e8dfc29dafb3bbd7$var$fe = !0;
            return $e8dfc29dafb3bbd7$var$ee;
        case "textInput":
            return a = b.data, a === $e8dfc29dafb3bbd7$var$ee && $e8dfc29dafb3bbd7$var$fe ? null : a;
        default:
            return null;
    }
}
function $e8dfc29dafb3bbd7$var$ke(a, b) {
    if ($e8dfc29dafb3bbd7$var$ie) return "compositionend" === a || !$e8dfc29dafb3bbd7$var$ae && $e8dfc29dafb3bbd7$var$ge(a, b) ? (a = $e8dfc29dafb3bbd7$var$nd(), $e8dfc29dafb3bbd7$var$md = $e8dfc29dafb3bbd7$var$ld = $e8dfc29dafb3bbd7$var$kd = null, $e8dfc29dafb3bbd7$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $e8dfc29dafb3bbd7$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $e8dfc29dafb3bbd7$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $e8dfc29dafb3bbd7$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$e8dfc29dafb3bbd7$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $e8dfc29dafb3bbd7$var$ne(a, b, c, d) {
    $e8dfc29dafb3bbd7$var$Eb(d);
    b = $e8dfc29dafb3bbd7$var$oe(b, "onChange");
    0 < b.length && (c = new $e8dfc29dafb3bbd7$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $e8dfc29dafb3bbd7$var$pe = null, $e8dfc29dafb3bbd7$var$qe = null;
function $e8dfc29dafb3bbd7$var$re(a) {
    $e8dfc29dafb3bbd7$var$se(a, 0);
}
function $e8dfc29dafb3bbd7$var$te(a) {
    var b = $e8dfc29dafb3bbd7$var$ue(a);
    if ($e8dfc29dafb3bbd7$var$Wa(b)) return a;
}
function $e8dfc29dafb3bbd7$var$ve(a, b) {
    if ("change" === a) return b;
}
var $e8dfc29dafb3bbd7$var$we = !1;
if ($e8dfc29dafb3bbd7$var$ia) {
    var $e8dfc29dafb3bbd7$var$xe;
    if ($e8dfc29dafb3bbd7$var$ia) {
        var $e8dfc29dafb3bbd7$var$ye = "oninput" in document;
        if (!$e8dfc29dafb3bbd7$var$ye) {
            var $e8dfc29dafb3bbd7$var$ze = document.createElement("div");
            $e8dfc29dafb3bbd7$var$ze.setAttribute("oninput", "return;");
            $e8dfc29dafb3bbd7$var$ye = "function" === typeof $e8dfc29dafb3bbd7$var$ze.oninput;
        }
        $e8dfc29dafb3bbd7$var$xe = $e8dfc29dafb3bbd7$var$ye;
    } else $e8dfc29dafb3bbd7$var$xe = !1;
    $e8dfc29dafb3bbd7$var$we = $e8dfc29dafb3bbd7$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $e8dfc29dafb3bbd7$var$Ae() {
    $e8dfc29dafb3bbd7$var$pe && ($e8dfc29dafb3bbd7$var$pe.detachEvent("onpropertychange", $e8dfc29dafb3bbd7$var$Be), $e8dfc29dafb3bbd7$var$qe = $e8dfc29dafb3bbd7$var$pe = null);
}
function $e8dfc29dafb3bbd7$var$Be(a) {
    if ("value" === a.propertyName && $e8dfc29dafb3bbd7$var$te($e8dfc29dafb3bbd7$var$qe)) {
        var b = [];
        $e8dfc29dafb3bbd7$var$ne(b, $e8dfc29dafb3bbd7$var$qe, a, $e8dfc29dafb3bbd7$var$xb(a));
        $e8dfc29dafb3bbd7$var$Jb($e8dfc29dafb3bbd7$var$re, b);
    }
}
function $e8dfc29dafb3bbd7$var$Ce(a, b, c) {
    "focusin" === a ? ($e8dfc29dafb3bbd7$var$Ae(), $e8dfc29dafb3bbd7$var$pe = b, $e8dfc29dafb3bbd7$var$qe = c, $e8dfc29dafb3bbd7$var$pe.attachEvent("onpropertychange", $e8dfc29dafb3bbd7$var$Be)) : "focusout" === a && $e8dfc29dafb3bbd7$var$Ae();
}
function $e8dfc29dafb3bbd7$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $e8dfc29dafb3bbd7$var$te($e8dfc29dafb3bbd7$var$qe);
}
function $e8dfc29dafb3bbd7$var$Ee(a, b) {
    if ("click" === a) return $e8dfc29dafb3bbd7$var$te(b);
}
function $e8dfc29dafb3bbd7$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $e8dfc29dafb3bbd7$var$te(b);
}
function $e8dfc29dafb3bbd7$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e8dfc29dafb3bbd7$var$He = "function" === typeof Object.is ? Object.is : $e8dfc29dafb3bbd7$var$Ge;
function $e8dfc29dafb3bbd7$var$Ie(a, b) {
    if ($e8dfc29dafb3bbd7$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$e8dfc29dafb3bbd7$var$ja.call(b, e) || !$e8dfc29dafb3bbd7$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $e8dfc29dafb3bbd7$var$Ke(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $e8dfc29dafb3bbd7$var$Je(c);
    }
}
function $e8dfc29dafb3bbd7$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $e8dfc29dafb3bbd7$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $e8dfc29dafb3bbd7$var$Me() {
    for(var a = window, b = $e8dfc29dafb3bbd7$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $e8dfc29dafb3bbd7$var$Xa(a.document);
    }
    return b;
}
function $e8dfc29dafb3bbd7$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $e8dfc29dafb3bbd7$var$Oe(a) {
    var b = $e8dfc29dafb3bbd7$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $e8dfc29dafb3bbd7$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $e8dfc29dafb3bbd7$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $e8dfc29dafb3bbd7$var$Ke(c, f);
                var g = $e8dfc29dafb3bbd7$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $e8dfc29dafb3bbd7$var$Pe = $e8dfc29dafb3bbd7$var$ia && "documentMode" in document && 11 >= document.documentMode, $e8dfc29dafb3bbd7$var$Qe = null, $e8dfc29dafb3bbd7$var$Re = null, $e8dfc29dafb3bbd7$var$Se = null, $e8dfc29dafb3bbd7$var$Te = !1;
function $e8dfc29dafb3bbd7$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $e8dfc29dafb3bbd7$var$Te || null == $e8dfc29dafb3bbd7$var$Qe || $e8dfc29dafb3bbd7$var$Qe !== $e8dfc29dafb3bbd7$var$Xa(d) || (d = $e8dfc29dafb3bbd7$var$Qe, "selectionStart" in d && $e8dfc29dafb3bbd7$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $e8dfc29dafb3bbd7$var$Se && $e8dfc29dafb3bbd7$var$Ie($e8dfc29dafb3bbd7$var$Se, d) || ($e8dfc29dafb3bbd7$var$Se = d, d = $e8dfc29dafb3bbd7$var$oe($e8dfc29dafb3bbd7$var$Re, "onSelect"), 0 < d.length && (b = new $e8dfc29dafb3bbd7$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $e8dfc29dafb3bbd7$var$Qe)));
}
function $e8dfc29dafb3bbd7$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $e8dfc29dafb3bbd7$var$We = {
    animationend: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationIteration"),
    animationstart: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationStart"),
    transitionend: $e8dfc29dafb3bbd7$var$Ve("Transition", "TransitionEnd")
}, $e8dfc29dafb3bbd7$var$Xe = {}, $e8dfc29dafb3bbd7$var$Ye = {};
$e8dfc29dafb3bbd7$var$ia && ($e8dfc29dafb3bbd7$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $e8dfc29dafb3bbd7$var$We.animationend.animation, delete $e8dfc29dafb3bbd7$var$We.animationiteration.animation, delete $e8dfc29dafb3bbd7$var$We.animationstart.animation), "TransitionEvent" in window || delete $e8dfc29dafb3bbd7$var$We.transitionend.transition);
function $e8dfc29dafb3bbd7$var$Ze(a) {
    if ($e8dfc29dafb3bbd7$var$Xe[a]) return $e8dfc29dafb3bbd7$var$Xe[a];
    if (!$e8dfc29dafb3bbd7$var$We[a]) return a;
    var b = $e8dfc29dafb3bbd7$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $e8dfc29dafb3bbd7$var$Ye) return $e8dfc29dafb3bbd7$var$Xe[a] = b[c];
    return a;
}
var $e8dfc29dafb3bbd7$var$$e = $e8dfc29dafb3bbd7$var$Ze("animationend"), $e8dfc29dafb3bbd7$var$af = $e8dfc29dafb3bbd7$var$Ze("animationiteration"), $e8dfc29dafb3bbd7$var$bf = $e8dfc29dafb3bbd7$var$Ze("animationstart"), $e8dfc29dafb3bbd7$var$cf = $e8dfc29dafb3bbd7$var$Ze("transitionend"), $e8dfc29dafb3bbd7$var$df = new Map, $e8dfc29dafb3bbd7$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $e8dfc29dafb3bbd7$var$ff(a, b) {
    $e8dfc29dafb3bbd7$var$df.set(a, b);
    $e8dfc29dafb3bbd7$var$fa(b, [
        a
    ]);
}
for(var $e8dfc29dafb3bbd7$var$gf = 0; $e8dfc29dafb3bbd7$var$gf < $e8dfc29dafb3bbd7$var$ef.length; $e8dfc29dafb3bbd7$var$gf++){
    var $e8dfc29dafb3bbd7$var$hf = $e8dfc29dafb3bbd7$var$ef[$e8dfc29dafb3bbd7$var$gf], $e8dfc29dafb3bbd7$var$jf = $e8dfc29dafb3bbd7$var$hf.toLowerCase(), $e8dfc29dafb3bbd7$var$kf = $e8dfc29dafb3bbd7$var$hf[0].toUpperCase() + $e8dfc29dafb3bbd7$var$hf.slice(1);
    $e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$jf, "on" + $e8dfc29dafb3bbd7$var$kf);
}
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$$e, "onAnimationEnd");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$af, "onAnimationIteration");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$bf, "onAnimationStart");
$e8dfc29dafb3bbd7$var$ff("dblclick", "onDoubleClick");
$e8dfc29dafb3bbd7$var$ff("focusin", "onFocus");
$e8dfc29dafb3bbd7$var$ff("focusout", "onBlur");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$cf, "onTransitionEnd");
$e8dfc29dafb3bbd7$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$e8dfc29dafb3bbd7$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$e8dfc29dafb3bbd7$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$e8dfc29dafb3bbd7$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$e8dfc29dafb3bbd7$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$e8dfc29dafb3bbd7$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$e8dfc29dafb3bbd7$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$e8dfc29dafb3bbd7$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$e8dfc29dafb3bbd7$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$e8dfc29dafb3bbd7$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $e8dfc29dafb3bbd7$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $e8dfc29dafb3bbd7$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($e8dfc29dafb3bbd7$var$lf));
function $e8dfc29dafb3bbd7$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $e8dfc29dafb3bbd7$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $e8dfc29dafb3bbd7$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e8dfc29dafb3bbd7$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e8dfc29dafb3bbd7$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($e8dfc29dafb3bbd7$var$Qb) throw a = $e8dfc29dafb3bbd7$var$Rb, $e8dfc29dafb3bbd7$var$Qb = !1, $e8dfc29dafb3bbd7$var$Rb = null, a;
}
function $e8dfc29dafb3bbd7$var$D(a, b) {
    var c = b[$e8dfc29dafb3bbd7$var$of];
    void 0 === c && (c = b[$e8dfc29dafb3bbd7$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($e8dfc29dafb3bbd7$var$pf(b, a, 2, !1), c.add(d));
}
function $e8dfc29dafb3bbd7$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $e8dfc29dafb3bbd7$var$pf(c, a, d, b);
}
var $e8dfc29dafb3bbd7$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $e8dfc29dafb3bbd7$var$sf(a) {
    if (!a[$e8dfc29dafb3bbd7$var$rf]) {
        a[$e8dfc29dafb3bbd7$var$rf] = !0;
        $e8dfc29dafb3bbd7$var$da.forEach(function(b) {
            "selectionchange" !== b && ($e8dfc29dafb3bbd7$var$mf.has(b) || $e8dfc29dafb3bbd7$var$qf(b, !1, a), $e8dfc29dafb3bbd7$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$e8dfc29dafb3bbd7$var$rf] || (b[$e8dfc29dafb3bbd7$var$rf] = !0, $e8dfc29dafb3bbd7$var$qf("selectionchange", !1, b));
    }
}
function $e8dfc29dafb3bbd7$var$pf(a, b, c, d) {
    switch($e8dfc29dafb3bbd7$var$jd(b)){
        case 1:
            var e = $e8dfc29dafb3bbd7$var$ed;
            break;
        case 4:
            e = $e8dfc29dafb3bbd7$var$gd;
            break;
        default:
            e = $e8dfc29dafb3bbd7$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$e8dfc29dafb3bbd7$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $e8dfc29dafb3bbd7$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $e8dfc29dafb3bbd7$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $e8dfc29dafb3bbd7$var$Jb(function() {
        var d = f, e = $e8dfc29dafb3bbd7$var$xb(c), g = [];
        a: {
            var h = $e8dfc29dafb3bbd7$var$df.get(a);
            if (void 0 !== h) {
                var k = $e8dfc29dafb3bbd7$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $e8dfc29dafb3bbd7$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $e8dfc29dafb3bbd7$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $e8dfc29dafb3bbd7$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $e8dfc29dafb3bbd7$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $e8dfc29dafb3bbd7$var$Vd;
                        break;
                    case $e8dfc29dafb3bbd7$var$$e:
                    case $e8dfc29dafb3bbd7$var$af:
                    case $e8dfc29dafb3bbd7$var$bf:
                        k = $e8dfc29dafb3bbd7$var$Hd;
                        break;
                    case $e8dfc29dafb3bbd7$var$cf:
                        k = $e8dfc29dafb3bbd7$var$Xd;
                        break;
                    case "scroll":
                        k = $e8dfc29dafb3bbd7$var$vd;
                        break;
                    case "wheel":
                        k = $e8dfc29dafb3bbd7$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $e8dfc29dafb3bbd7$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $e8dfc29dafb3bbd7$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $e8dfc29dafb3bbd7$var$Kb(w, x), null != F && t.push($e8dfc29dafb3bbd7$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $e8dfc29dafb3bbd7$var$wb && (n = c.relatedTarget || c.fromElement) && ($e8dfc29dafb3bbd7$var$Wc(n) || n[$e8dfc29dafb3bbd7$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $e8dfc29dafb3bbd7$var$Wc(n) : null, null !== n && (J = $e8dfc29dafb3bbd7$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $e8dfc29dafb3bbd7$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $e8dfc29dafb3bbd7$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $e8dfc29dafb3bbd7$var$ue(k);
                        u = null == n ? h : $e8dfc29dafb3bbd7$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $e8dfc29dafb3bbd7$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $e8dfc29dafb3bbd7$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $e8dfc29dafb3bbd7$var$vf(F))u++;
                            for(; 0 < w - u;)t = $e8dfc29dafb3bbd7$var$vf(t), w--;
                            for(; 0 < u - w;)x = $e8dfc29dafb3bbd7$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $e8dfc29dafb3bbd7$var$vf(t);
                                x = $e8dfc29dafb3bbd7$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $e8dfc29dafb3bbd7$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $e8dfc29dafb3bbd7$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $e8dfc29dafb3bbd7$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $e8dfc29dafb3bbd7$var$ve;
                else if ($e8dfc29dafb3bbd7$var$me(h)) {
                    if ($e8dfc29dafb3bbd7$var$we) na = $e8dfc29dafb3bbd7$var$Fe;
                    else {
                        na = $e8dfc29dafb3bbd7$var$De;
                        var xa = $e8dfc29dafb3bbd7$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $e8dfc29dafb3bbd7$var$Ee);
                if (na && (na = na(a, d))) {
                    $e8dfc29dafb3bbd7$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $e8dfc29dafb3bbd7$var$cb(h, "number", h.value);
            }
            xa = d ? $e8dfc29dafb3bbd7$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($e8dfc29dafb3bbd7$var$me(xa) || "true" === xa.contentEditable) $e8dfc29dafb3bbd7$var$Qe = xa, $e8dfc29dafb3bbd7$var$Re = d, $e8dfc29dafb3bbd7$var$Se = null;
                    break;
                case "focusout":
                    $e8dfc29dafb3bbd7$var$Se = $e8dfc29dafb3bbd7$var$Re = $e8dfc29dafb3bbd7$var$Qe = null;
                    break;
                case "mousedown":
                    $e8dfc29dafb3bbd7$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $e8dfc29dafb3bbd7$var$Te = !1;
                    $e8dfc29dafb3bbd7$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($e8dfc29dafb3bbd7$var$Pe) break;
                case "keydown":
                case "keyup":
                    $e8dfc29dafb3bbd7$var$Ue(g, c, e);
            }
            var $a;
            if ($e8dfc29dafb3bbd7$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $e8dfc29dafb3bbd7$var$ie ? $e8dfc29dafb3bbd7$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($e8dfc29dafb3bbd7$var$de && "ko" !== c.locale && ($e8dfc29dafb3bbd7$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $e8dfc29dafb3bbd7$var$ie && ($a = $e8dfc29dafb3bbd7$var$nd()) : ($e8dfc29dafb3bbd7$var$kd = e, $e8dfc29dafb3bbd7$var$ld = "value" in $e8dfc29dafb3bbd7$var$kd ? $e8dfc29dafb3bbd7$var$kd.value : $e8dfc29dafb3bbd7$var$kd.textContent, $e8dfc29dafb3bbd7$var$ie = !0)), xa = $e8dfc29dafb3bbd7$var$oe(d, ba), 0 < xa.length && (ba = new $e8dfc29dafb3bbd7$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $e8dfc29dafb3bbd7$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $e8dfc29dafb3bbd7$var$ce ? $e8dfc29dafb3bbd7$var$je(a, c) : $e8dfc29dafb3bbd7$var$ke(a, c)) d = $e8dfc29dafb3bbd7$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $e8dfc29dafb3bbd7$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $e8dfc29dafb3bbd7$var$se(g, b);
    });
}
function $e8dfc29dafb3bbd7$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $e8dfc29dafb3bbd7$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $e8dfc29dafb3bbd7$var$Kb(a, c), null != f && d.unshift($e8dfc29dafb3bbd7$var$tf(a, f, e)), f = $e8dfc29dafb3bbd7$var$Kb(a, b), null != f && d.push($e8dfc29dafb3bbd7$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $e8dfc29dafb3bbd7$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $e8dfc29dafb3bbd7$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $e8dfc29dafb3bbd7$var$Kb(c, f), null != k && g.unshift($e8dfc29dafb3bbd7$var$tf(c, k, h))) : e || (k = $e8dfc29dafb3bbd7$var$Kb(c, f), null != k && g.push($e8dfc29dafb3bbd7$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $e8dfc29dafb3bbd7$var$xf = /\r\n?/g, $e8dfc29dafb3bbd7$var$yf = /\u0000|\uFFFD/g;
function $e8dfc29dafb3bbd7$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($e8dfc29dafb3bbd7$var$xf, "\n").replace($e8dfc29dafb3bbd7$var$yf, "");
}
function $e8dfc29dafb3bbd7$var$Af(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$zf(b);
    if ($e8dfc29dafb3bbd7$var$zf(a) !== b && c) throw Error($e8dfc29dafb3bbd7$var$p(425));
}
function $e8dfc29dafb3bbd7$var$Bf() {}
var $e8dfc29dafb3bbd7$var$Cf = null, $e8dfc29dafb3bbd7$var$Df = null;
function $e8dfc29dafb3bbd7$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $e8dfc29dafb3bbd7$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $e8dfc29dafb3bbd7$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $e8dfc29dafb3bbd7$var$Hf = "function" === typeof Promise ? Promise : void 0, $e8dfc29dafb3bbd7$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $e8dfc29dafb3bbd7$var$Hf ? function(a) {
    return $e8dfc29dafb3bbd7$var$Hf.resolve(null).then(a).catch($e8dfc29dafb3bbd7$var$If);
} : $e8dfc29dafb3bbd7$var$Ff;
function $e8dfc29dafb3bbd7$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $e8dfc29dafb3bbd7$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $e8dfc29dafb3bbd7$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $e8dfc29dafb3bbd7$var$bd(b);
}
function $e8dfc29dafb3bbd7$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$Nf = Math.random().toString(36).slice(2), $e8dfc29dafb3bbd7$var$Of = "__reactFiber$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Pf = "__reactProps$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$uf = "__reactContainer$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$of = "__reactEvents$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Qf = "__reactListeners$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Rf = "__reactHandles$" + $e8dfc29dafb3bbd7$var$Nf;
function $e8dfc29dafb3bbd7$var$Wc(a) {
    var b = a[$e8dfc29dafb3bbd7$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$e8dfc29dafb3bbd7$var$uf] || c[$e8dfc29dafb3bbd7$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $e8dfc29dafb3bbd7$var$Mf(a); null !== a;){
                if (c = a[$e8dfc29dafb3bbd7$var$Of]) return c;
                a = $e8dfc29dafb3bbd7$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Cb(a) {
    a = a[$e8dfc29dafb3bbd7$var$Of] || a[$e8dfc29dafb3bbd7$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $e8dfc29dafb3bbd7$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($e8dfc29dafb3bbd7$var$p(33));
}
function $e8dfc29dafb3bbd7$var$Db(a) {
    return a[$e8dfc29dafb3bbd7$var$Pf] || null;
}
var $e8dfc29dafb3bbd7$var$Sf = [], $e8dfc29dafb3bbd7$var$Tf = -1;
function $e8dfc29dafb3bbd7$var$Uf(a) {
    return {
        current: a
    };
}
function $e8dfc29dafb3bbd7$var$E(a) {
    0 > $e8dfc29dafb3bbd7$var$Tf || (a.current = $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf], $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf] = null, $e8dfc29dafb3bbd7$var$Tf--);
}
function $e8dfc29dafb3bbd7$var$G(a, b) {
    $e8dfc29dafb3bbd7$var$Tf++;
    $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf] = a.current;
    a.current = b;
}
var $e8dfc29dafb3bbd7$var$Vf = {}, $e8dfc29dafb3bbd7$var$H = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Vf), $e8dfc29dafb3bbd7$var$Wf = $e8dfc29dafb3bbd7$var$Uf(!1), $e8dfc29dafb3bbd7$var$Xf = $e8dfc29dafb3bbd7$var$Vf;
function $e8dfc29dafb3bbd7$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $e8dfc29dafb3bbd7$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $e8dfc29dafb3bbd7$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $e8dfc29dafb3bbd7$var$$f() {
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
}
function $e8dfc29dafb3bbd7$var$ag(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$H.current !== $e8dfc29dafb3bbd7$var$Vf) throw Error($e8dfc29dafb3bbd7$var$p(168));
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, b);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, c);
}
function $e8dfc29dafb3bbd7$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($e8dfc29dafb3bbd7$var$p(108, $e8dfc29dafb3bbd7$var$Ra(a) || "Unknown", e));
    return $e8dfc29dafb3bbd7$var$A({}, c, d);
}
function $e8dfc29dafb3bbd7$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $e8dfc29dafb3bbd7$var$Vf;
    $e8dfc29dafb3bbd7$var$Xf = $e8dfc29dafb3bbd7$var$H.current;
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, a);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, $e8dfc29dafb3bbd7$var$Wf.current);
    return !0;
}
function $e8dfc29dafb3bbd7$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($e8dfc29dafb3bbd7$var$p(169));
    c ? (a = $e8dfc29dafb3bbd7$var$bg(a, b, $e8dfc29dafb3bbd7$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H), $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, a)) : $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, c);
}
var $e8dfc29dafb3bbd7$var$eg = null, $e8dfc29dafb3bbd7$var$fg = !1, $e8dfc29dafb3bbd7$var$gg = !1;
function $e8dfc29dafb3bbd7$var$hg(a) {
    null === $e8dfc29dafb3bbd7$var$eg ? $e8dfc29dafb3bbd7$var$eg = [
        a
    ] : $e8dfc29dafb3bbd7$var$eg.push(a);
}
function $e8dfc29dafb3bbd7$var$ig(a) {
    $e8dfc29dafb3bbd7$var$fg = !0;
    $e8dfc29dafb3bbd7$var$hg(a);
}
function $e8dfc29dafb3bbd7$var$jg() {
    if (!$e8dfc29dafb3bbd7$var$gg && null !== $e8dfc29dafb3bbd7$var$eg) {
        $e8dfc29dafb3bbd7$var$gg = !0;
        var a = 0, b = $e8dfc29dafb3bbd7$var$C;
        try {
            var c = $e8dfc29dafb3bbd7$var$eg;
            for($e8dfc29dafb3bbd7$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $e8dfc29dafb3bbd7$var$eg = null;
            $e8dfc29dafb3bbd7$var$fg = !1;
        } catch (e) {
            throw null !== $e8dfc29dafb3bbd7$var$eg && ($e8dfc29dafb3bbd7$var$eg = $e8dfc29dafb3bbd7$var$eg.slice(a + 1)), $e8dfc29dafb3bbd7$var$ac($e8dfc29dafb3bbd7$var$fc, $e8dfc29dafb3bbd7$var$jg), e;
        } finally{
            $e8dfc29dafb3bbd7$var$C = b, $e8dfc29dafb3bbd7$var$gg = !1;
        }
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$kg = [], $e8dfc29dafb3bbd7$var$lg = 0, $e8dfc29dafb3bbd7$var$mg = null, $e8dfc29dafb3bbd7$var$ng = 0, $e8dfc29dafb3bbd7$var$og = [], $e8dfc29dafb3bbd7$var$pg = 0, $e8dfc29dafb3bbd7$var$qg = null, $e8dfc29dafb3bbd7$var$rg = 1, $e8dfc29dafb3bbd7$var$sg = "";
function $e8dfc29dafb3bbd7$var$tg(a, b) {
    $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg++] = $e8dfc29dafb3bbd7$var$ng;
    $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg++] = $e8dfc29dafb3bbd7$var$mg;
    $e8dfc29dafb3bbd7$var$mg = a;
    $e8dfc29dafb3bbd7$var$ng = b;
}
function $e8dfc29dafb3bbd7$var$ug(a, b, c) {
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$rg;
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$sg;
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$qg;
    $e8dfc29dafb3bbd7$var$qg = a;
    var d = $e8dfc29dafb3bbd7$var$rg;
    a = $e8dfc29dafb3bbd7$var$sg;
    var e = 32 - $e8dfc29dafb3bbd7$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $e8dfc29dafb3bbd7$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $e8dfc29dafb3bbd7$var$rg = 1 << 32 - $e8dfc29dafb3bbd7$var$oc(b) + e | c << e | d;
        $e8dfc29dafb3bbd7$var$sg = f + a;
    } else $e8dfc29dafb3bbd7$var$rg = 1 << f | c << e | d, $e8dfc29dafb3bbd7$var$sg = a;
}
function $e8dfc29dafb3bbd7$var$vg(a) {
    null !== a.return && ($e8dfc29dafb3bbd7$var$tg(a, 1), $e8dfc29dafb3bbd7$var$ug(a, 1, 0));
}
function $e8dfc29dafb3bbd7$var$wg(a) {
    for(; a === $e8dfc29dafb3bbd7$var$mg;)$e8dfc29dafb3bbd7$var$mg = $e8dfc29dafb3bbd7$var$kg[--$e8dfc29dafb3bbd7$var$lg], $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg] = null, $e8dfc29dafb3bbd7$var$ng = $e8dfc29dafb3bbd7$var$kg[--$e8dfc29dafb3bbd7$var$lg], $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg] = null;
    for(; a === $e8dfc29dafb3bbd7$var$qg;)$e8dfc29dafb3bbd7$var$qg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null, $e8dfc29dafb3bbd7$var$sg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null, $e8dfc29dafb3bbd7$var$rg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null;
}
var $e8dfc29dafb3bbd7$var$xg = null, $e8dfc29dafb3bbd7$var$yg = null, $e8dfc29dafb3bbd7$var$I = !1, $e8dfc29dafb3bbd7$var$zg = null;
function $e8dfc29dafb3bbd7$var$Ag(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $e8dfc29dafb3bbd7$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $e8dfc29dafb3bbd7$var$qg ? {
                id: $e8dfc29dafb3bbd7$var$rg,
                overflow: $e8dfc29dafb3bbd7$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $e8dfc29dafb3bbd7$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $e8dfc29dafb3bbd7$var$Eg(a) {
    if ($e8dfc29dafb3bbd7$var$I) {
        var b = $e8dfc29dafb3bbd7$var$yg;
        if (b) {
            var c = b;
            if (!$e8dfc29dafb3bbd7$var$Cg(a, b)) {
                if ($e8dfc29dafb3bbd7$var$Dg(a)) throw Error($e8dfc29dafb3bbd7$var$p(418));
                b = $e8dfc29dafb3bbd7$var$Lf(c.nextSibling);
                var d = $e8dfc29dafb3bbd7$var$xg;
                b && $e8dfc29dafb3bbd7$var$Cg(a, b) ? $e8dfc29dafb3bbd7$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $e8dfc29dafb3bbd7$var$I = !1, $e8dfc29dafb3bbd7$var$xg = a);
            }
        } else {
            if ($e8dfc29dafb3bbd7$var$Dg(a)) throw Error($e8dfc29dafb3bbd7$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $e8dfc29dafb3bbd7$var$I = !1;
            $e8dfc29dafb3bbd7$var$xg = a;
        }
    }
}
function $e8dfc29dafb3bbd7$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $e8dfc29dafb3bbd7$var$xg = a;
}
function $e8dfc29dafb3bbd7$var$Gg(a) {
    if (a !== $e8dfc29dafb3bbd7$var$xg) return !1;
    if (!$e8dfc29dafb3bbd7$var$I) return $e8dfc29dafb3bbd7$var$Fg(a), $e8dfc29dafb3bbd7$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$e8dfc29dafb3bbd7$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $e8dfc29dafb3bbd7$var$yg)) {
        if ($e8dfc29dafb3bbd7$var$Dg(a)) throw $e8dfc29dafb3bbd7$var$Hg(), Error($e8dfc29dafb3bbd7$var$p(418));
        for(; b;)$e8dfc29dafb3bbd7$var$Ag(a, b), b = $e8dfc29dafb3bbd7$var$Lf(b.nextSibling);
    }
    $e8dfc29dafb3bbd7$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($e8dfc29dafb3bbd7$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $e8dfc29dafb3bbd7$var$yg = null;
        }
    } else $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$xg ? $e8dfc29dafb3bbd7$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $e8dfc29dafb3bbd7$var$Hg() {
    for(var a = $e8dfc29dafb3bbd7$var$yg; a;)a = $e8dfc29dafb3bbd7$var$Lf(a.nextSibling);
}
function $e8dfc29dafb3bbd7$var$Ig() {
    $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$xg = null;
    $e8dfc29dafb3bbd7$var$I = !1;
}
function $e8dfc29dafb3bbd7$var$Jg(a) {
    null === $e8dfc29dafb3bbd7$var$zg ? $e8dfc29dafb3bbd7$var$zg = [
        a
    ] : $e8dfc29dafb3bbd7$var$zg.push(a);
}
var $e8dfc29dafb3bbd7$var$Kg = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig;
function $e8dfc29dafb3bbd7$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $e8dfc29dafb3bbd7$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $e8dfc29dafb3bbd7$var$Mg = $e8dfc29dafb3bbd7$var$Uf(null), $e8dfc29dafb3bbd7$var$Ng = null, $e8dfc29dafb3bbd7$var$Og = null, $e8dfc29dafb3bbd7$var$Pg = null;
function $e8dfc29dafb3bbd7$var$Qg() {
    $e8dfc29dafb3bbd7$var$Pg = $e8dfc29dafb3bbd7$var$Og = $e8dfc29dafb3bbd7$var$Ng = null;
}
function $e8dfc29dafb3bbd7$var$Rg(a) {
    var b = $e8dfc29dafb3bbd7$var$Mg.current;
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Mg);
    a._currentValue = b;
}
function $e8dfc29dafb3bbd7$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $e8dfc29dafb3bbd7$var$Tg(a, b) {
    $e8dfc29dafb3bbd7$var$Ng = a;
    $e8dfc29dafb3bbd7$var$Pg = $e8dfc29dafb3bbd7$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($e8dfc29dafb3bbd7$var$Ug = !0), a.firstContext = null);
}
function $e8dfc29dafb3bbd7$var$Vg(a) {
    var b = a._currentValue;
    if ($e8dfc29dafb3bbd7$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $e8dfc29dafb3bbd7$var$Og) {
            if (null === $e8dfc29dafb3bbd7$var$Ng) throw Error($e8dfc29dafb3bbd7$var$p(308));
            $e8dfc29dafb3bbd7$var$Og = a;
            $e8dfc29dafb3bbd7$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $e8dfc29dafb3bbd7$var$Og = $e8dfc29dafb3bbd7$var$Og.next = a;
    }
    return b;
}
var $e8dfc29dafb3bbd7$var$Wg = null;
function $e8dfc29dafb3bbd7$var$Xg(a) {
    null === $e8dfc29dafb3bbd7$var$Wg ? $e8dfc29dafb3bbd7$var$Wg = [
        a
    ] : $e8dfc29dafb3bbd7$var$Wg.push(a);
}
function $e8dfc29dafb3bbd7$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $e8dfc29dafb3bbd7$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $e8dfc29dafb3bbd7$var$Zg(a, d);
}
function $e8dfc29dafb3bbd7$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $e8dfc29dafb3bbd7$var$$g = !1;
function $e8dfc29dafb3bbd7$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $e8dfc29dafb3bbd7$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $e8dfc29dafb3bbd7$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $e8dfc29dafb3bbd7$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $e8dfc29dafb3bbd7$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $e8dfc29dafb3bbd7$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $e8dfc29dafb3bbd7$var$Zg(a, c);
}
function $e8dfc29dafb3bbd7$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e8dfc29dafb3bbd7$var$Cc(a, c);
    }
}
function $e8dfc29dafb3bbd7$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $e8dfc29dafb3bbd7$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $e8dfc29dafb3bbd7$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $e8dfc29dafb3bbd7$var$A({}, q, r);
                            break a;
                        case 2:
                            $e8dfc29dafb3bbd7$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $e8dfc29dafb3bbd7$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $e8dfc29dafb3bbd7$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($e8dfc29dafb3bbd7$var$p(191, e));
            e.call(d);
        }
    }
}
var $e8dfc29dafb3bbd7$var$jh = (new $6cds3.Component).refs;
function $e8dfc29dafb3bbd7$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $e8dfc29dafb3bbd7$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $e8dfc29dafb3bbd7$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $e8dfc29dafb3bbd7$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e8dfc29dafb3bbd7$var$L(), e = $e8dfc29dafb3bbd7$var$lh(a), f = $e8dfc29dafb3bbd7$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e8dfc29dafb3bbd7$var$dh(a, f, e);
        null !== b && ($e8dfc29dafb3bbd7$var$mh(b, a, e, d), $e8dfc29dafb3bbd7$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e8dfc29dafb3bbd7$var$L(), e = $e8dfc29dafb3bbd7$var$lh(a), f = $e8dfc29dafb3bbd7$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e8dfc29dafb3bbd7$var$dh(a, f, e);
        null !== b && ($e8dfc29dafb3bbd7$var$mh(b, a, e, d), $e8dfc29dafb3bbd7$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $e8dfc29dafb3bbd7$var$L(), d = $e8dfc29dafb3bbd7$var$lh(a), e = $e8dfc29dafb3bbd7$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $e8dfc29dafb3bbd7$var$dh(a, e, d);
        null !== b && ($e8dfc29dafb3bbd7$var$mh(b, a, d, c), $e8dfc29dafb3bbd7$var$eh(b, a, d));
    }
};
function $e8dfc29dafb3bbd7$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$e8dfc29dafb3bbd7$var$Ie(c, d) || !$e8dfc29dafb3bbd7$var$Ie(e, f) : !0;
}
function $e8dfc29dafb3bbd7$var$ph(a, b, c) {
    var d = !1, e = $e8dfc29dafb3bbd7$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $e8dfc29dafb3bbd7$var$Vg(f) : (e = $e8dfc29dafb3bbd7$var$Zf(b) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $e8dfc29dafb3bbd7$var$Yf(a, e) : $e8dfc29dafb3bbd7$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $e8dfc29dafb3bbd7$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $e8dfc29dafb3bbd7$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $e8dfc29dafb3bbd7$var$nh.enqueueReplaceState(b, b.state, null);
}
function $e8dfc29dafb3bbd7$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $e8dfc29dafb3bbd7$var$jh;
    $e8dfc29dafb3bbd7$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $e8dfc29dafb3bbd7$var$Vg(f) : (f = $e8dfc29dafb3bbd7$var$Zf(b) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, e.context = $e8dfc29dafb3bbd7$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($e8dfc29dafb3bbd7$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $e8dfc29dafb3bbd7$var$nh.enqueueReplaceState(e, e.state, null), $e8dfc29dafb3bbd7$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $e8dfc29dafb3bbd7$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($e8dfc29dafb3bbd7$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($e8dfc29dafb3bbd7$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $e8dfc29dafb3bbd7$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($e8dfc29dafb3bbd7$var$p(284));
        if (!c._owner) throw Error($e8dfc29dafb3bbd7$var$p(290, a));
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($e8dfc29dafb3bbd7$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $e8dfc29dafb3bbd7$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $e8dfc29dafb3bbd7$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $e8dfc29dafb3bbd7$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $e8dfc29dafb3bbd7$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $e8dfc29dafb3bbd7$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $e8dfc29dafb3bbd7$var$Ha && $e8dfc29dafb3bbd7$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $e8dfc29dafb3bbd7$var$sh(a, b, c), d.return = a, d;
        d = $e8dfc29dafb3bbd7$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $e8dfc29dafb3bbd7$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $e8dfc29dafb3bbd7$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $e8dfc29dafb3bbd7$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $e8dfc29dafb3bbd7$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return c = $e8dfc29dafb3bbd7$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $e8dfc29dafb3bbd7$var$sh(a, null, b), c.return = a, c;
                case $e8dfc29dafb3bbd7$var$wa:
                    return b = $e8dfc29dafb3bbd7$var$zh(b, a.mode, c), b.return = a, b;
                case $e8dfc29dafb3bbd7$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($e8dfc29dafb3bbd7$var$eb(b) || $e8dfc29dafb3bbd7$var$Ka(b)) return b = $e8dfc29dafb3bbd7$var$Ah(b, a.mode, c, null), b.return = a, b;
            $e8dfc29dafb3bbd7$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $e8dfc29dafb3bbd7$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $e8dfc29dafb3bbd7$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($e8dfc29dafb3bbd7$var$eb(c) || $e8dfc29dafb3bbd7$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $e8dfc29dafb3bbd7$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $e8dfc29dafb3bbd7$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $e8dfc29dafb3bbd7$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($e8dfc29dafb3bbd7$var$eb(d) || $e8dfc29dafb3bbd7$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $e8dfc29dafb3bbd7$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $e8dfc29dafb3bbd7$var$Ka(h);
        if ("function" !== typeof l) throw Error($e8dfc29dafb3bbd7$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($e8dfc29dafb3bbd7$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $e8dfc29dafb3bbd7$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $e8dfc29dafb3bbd7$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $e8dfc29dafb3bbd7$var$Ha && $e8dfc29dafb3bbd7$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $e8dfc29dafb3bbd7$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $e8dfc29dafb3bbd7$var$ya ? (d = $e8dfc29dafb3bbd7$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $e8dfc29dafb3bbd7$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $e8dfc29dafb3bbd7$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $e8dfc29dafb3bbd7$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $e8dfc29dafb3bbd7$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $e8dfc29dafb3bbd7$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($e8dfc29dafb3bbd7$var$eb(f)) return n(a, d, f, h);
            if ($e8dfc29dafb3bbd7$var$Ka(f)) return t(a, d, f, h);
            $e8dfc29dafb3bbd7$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $e8dfc29dafb3bbd7$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $e8dfc29dafb3bbd7$var$Bh = $e8dfc29dafb3bbd7$var$vh(!0), $e8dfc29dafb3bbd7$var$Ch = $e8dfc29dafb3bbd7$var$vh(!1), $e8dfc29dafb3bbd7$var$Dh = {}, $e8dfc29dafb3bbd7$var$Eh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Dh), $e8dfc29dafb3bbd7$var$Fh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Dh), $e8dfc29dafb3bbd7$var$Gh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Dh);
function $e8dfc29dafb3bbd7$var$Hh(a) {
    if (a === $e8dfc29dafb3bbd7$var$Dh) throw Error($e8dfc29dafb3bbd7$var$p(174));
    return a;
}
function $e8dfc29dafb3bbd7$var$Ih(a, b) {
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Gh, b);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Fh, a);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Eh, $e8dfc29dafb3bbd7$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $e8dfc29dafb3bbd7$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $e8dfc29dafb3bbd7$var$lb(b, a);
    }
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Eh);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Eh, b);
}
function $e8dfc29dafb3bbd7$var$Jh() {
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Eh);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Fh);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Gh);
}
function $e8dfc29dafb3bbd7$var$Kh(a) {
    $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Gh.current);
    var b = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
    var c = $e8dfc29dafb3bbd7$var$lb(b, a.type);
    b !== c && ($e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Fh, a), $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Eh, c));
}
function $e8dfc29dafb3bbd7$var$Lh(a) {
    $e8dfc29dafb3bbd7$var$Fh.current === a && ($e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Eh), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Fh));
}
var $e8dfc29dafb3bbd7$var$M = $e8dfc29dafb3bbd7$var$Uf(0);
function $e8dfc29dafb3bbd7$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$Nh = [];
function $e8dfc29dafb3bbd7$var$Oh() {
    for(var a = 0; a < $e8dfc29dafb3bbd7$var$Nh.length; a++)$e8dfc29dafb3bbd7$var$Nh[a]._workInProgressVersionPrimary = null;
    $e8dfc29dafb3bbd7$var$Nh.length = 0;
}
var $e8dfc29dafb3bbd7$var$Ph = $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher, $e8dfc29dafb3bbd7$var$Qh = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$Rh = 0, $e8dfc29dafb3bbd7$var$N = null, $e8dfc29dafb3bbd7$var$O = null, $e8dfc29dafb3bbd7$var$P = null, $e8dfc29dafb3bbd7$var$Sh = !1, $e8dfc29dafb3bbd7$var$Th = !1, $e8dfc29dafb3bbd7$var$Uh = 0, $e8dfc29dafb3bbd7$var$Vh = 0;
function $e8dfc29dafb3bbd7$var$Q() {
    throw Error($e8dfc29dafb3bbd7$var$p(321));
}
function $e8dfc29dafb3bbd7$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e8dfc29dafb3bbd7$var$He(a[c], b[c])) return !1;
    return !0;
}
function $e8dfc29dafb3bbd7$var$Xh(a, b, c, d, e, f) {
    $e8dfc29dafb3bbd7$var$Rh = f;
    $e8dfc29dafb3bbd7$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $e8dfc29dafb3bbd7$var$Ph.current = null === a || null === a.memoizedState ? $e8dfc29dafb3bbd7$var$Yh : $e8dfc29dafb3bbd7$var$Zh;
    a = c(d, e);
    if ($e8dfc29dafb3bbd7$var$Th) {
        f = 0;
        do {
            $e8dfc29dafb3bbd7$var$Th = !1;
            $e8dfc29dafb3bbd7$var$Uh = 0;
            if (25 <= f) throw Error($e8dfc29dafb3bbd7$var$p(301));
            f += 1;
            $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$O = null;
            b.updateQueue = null;
            $e8dfc29dafb3bbd7$var$Ph.current = $e8dfc29dafb3bbd7$var$$h;
            a = c(d, e);
        }while ($e8dfc29dafb3bbd7$var$Th);
    }
    $e8dfc29dafb3bbd7$var$Ph.current = $e8dfc29dafb3bbd7$var$ai;
    b = null !== $e8dfc29dafb3bbd7$var$O && null !== $e8dfc29dafb3bbd7$var$O.next;
    $e8dfc29dafb3bbd7$var$Rh = 0;
    $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$O = $e8dfc29dafb3bbd7$var$N = null;
    $e8dfc29dafb3bbd7$var$Sh = !1;
    if (b) throw Error($e8dfc29dafb3bbd7$var$p(300));
    return a;
}
function $e8dfc29dafb3bbd7$var$bi() {
    var a = 0 !== $e8dfc29dafb3bbd7$var$Uh;
    $e8dfc29dafb3bbd7$var$Uh = 0;
    return a;
}
function $e8dfc29dafb3bbd7$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $e8dfc29dafb3bbd7$var$P ? $e8dfc29dafb3bbd7$var$N.memoizedState = $e8dfc29dafb3bbd7$var$P = a : $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$P.next = a;
    return $e8dfc29dafb3bbd7$var$P;
}
function $e8dfc29dafb3bbd7$var$di() {
    if (null === $e8dfc29dafb3bbd7$var$O) {
        var a = $e8dfc29dafb3bbd7$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $e8dfc29dafb3bbd7$var$O.next;
    var b = null === $e8dfc29dafb3bbd7$var$P ? $e8dfc29dafb3bbd7$var$N.memoizedState : $e8dfc29dafb3bbd7$var$P.next;
    if (null !== b) $e8dfc29dafb3bbd7$var$P = b, $e8dfc29dafb3bbd7$var$O = a;
    else {
        if (null === a) throw Error($e8dfc29dafb3bbd7$var$p(310));
        $e8dfc29dafb3bbd7$var$O = a;
        a = {
            memoizedState: $e8dfc29dafb3bbd7$var$O.memoizedState,
            baseState: $e8dfc29dafb3bbd7$var$O.baseState,
            baseQueue: $e8dfc29dafb3bbd7$var$O.baseQueue,
            queue: $e8dfc29dafb3bbd7$var$O.queue,
            next: null
        };
        null === $e8dfc29dafb3bbd7$var$P ? $e8dfc29dafb3bbd7$var$N.memoizedState = $e8dfc29dafb3bbd7$var$P = a : $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$P.next = a;
    }
    return $e8dfc29dafb3bbd7$var$P;
}
function $e8dfc29dafb3bbd7$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $e8dfc29dafb3bbd7$var$fi(a) {
    var b = $e8dfc29dafb3bbd7$var$di(), c = b.queue;
    if (null === c) throw Error($e8dfc29dafb3bbd7$var$p(311));
    c.lastRenderedReducer = a;
    var d = $e8dfc29dafb3bbd7$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($e8dfc29dafb3bbd7$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $e8dfc29dafb3bbd7$var$N.lanes |= m;
                $e8dfc29dafb3bbd7$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $e8dfc29dafb3bbd7$var$He(d, b.memoizedState) || ($e8dfc29dafb3bbd7$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $e8dfc29dafb3bbd7$var$N.lanes |= f, $e8dfc29dafb3bbd7$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $e8dfc29dafb3bbd7$var$gi(a) {
    var b = $e8dfc29dafb3bbd7$var$di(), c = b.queue;
    if (null === c) throw Error($e8dfc29dafb3bbd7$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e8dfc29dafb3bbd7$var$He(f, b.memoizedState) || ($e8dfc29dafb3bbd7$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $e8dfc29dafb3bbd7$var$hi() {}
function $e8dfc29dafb3bbd7$var$ii(a, b) {
    var c = $e8dfc29dafb3bbd7$var$N, d = $e8dfc29dafb3bbd7$var$di(), e = b(), f = !$e8dfc29dafb3bbd7$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $e8dfc29dafb3bbd7$var$Ug = !0);
    d = d.queue;
    $e8dfc29dafb3bbd7$var$ji($e8dfc29dafb3bbd7$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $e8dfc29dafb3bbd7$var$P && $e8dfc29dafb3bbd7$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $e8dfc29dafb3bbd7$var$li(9, $e8dfc29dafb3bbd7$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $e8dfc29dafb3bbd7$var$R) throw Error($e8dfc29dafb3bbd7$var$p(349));
        0 !== ($e8dfc29dafb3bbd7$var$Rh & 30) || $e8dfc29dafb3bbd7$var$ni(c, b, e);
    }
    return e;
}
function $e8dfc29dafb3bbd7$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $e8dfc29dafb3bbd7$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e8dfc29dafb3bbd7$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $e8dfc29dafb3bbd7$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $e8dfc29dafb3bbd7$var$oi(b) && $e8dfc29dafb3bbd7$var$pi(a);
}
function $e8dfc29dafb3bbd7$var$ki(a, b, c) {
    return c(function() {
        $e8dfc29dafb3bbd7$var$oi(b) && $e8dfc29dafb3bbd7$var$pi(a);
    });
}
function $e8dfc29dafb3bbd7$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$e8dfc29dafb3bbd7$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $e8dfc29dafb3bbd7$var$pi(a) {
    var b = $e8dfc29dafb3bbd7$var$Zg(a, 1);
    null !== b && $e8dfc29dafb3bbd7$var$mh(b, a, 1, -1);
}
function $e8dfc29dafb3bbd7$var$qi(a) {
    var b = $e8dfc29dafb3bbd7$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $e8dfc29dafb3bbd7$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $e8dfc29dafb3bbd7$var$ri.bind(null, $e8dfc29dafb3bbd7$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $e8dfc29dafb3bbd7$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $e8dfc29dafb3bbd7$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e8dfc29dafb3bbd7$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $e8dfc29dafb3bbd7$var$si() {
    return $e8dfc29dafb3bbd7$var$di().memoizedState;
}
function $e8dfc29dafb3bbd7$var$ti(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$ci();
    $e8dfc29dafb3bbd7$var$N.flags |= a;
    e.memoizedState = $e8dfc29dafb3bbd7$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $e8dfc29dafb3bbd7$var$ui(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $e8dfc29dafb3bbd7$var$O) {
        var g = $e8dfc29dafb3bbd7$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $e8dfc29dafb3bbd7$var$Wh(d, g.deps)) {
            e.memoizedState = $e8dfc29dafb3bbd7$var$li(b, c, f, d);
            return;
        }
    }
    $e8dfc29dafb3bbd7$var$N.flags |= a;
    e.memoizedState = $e8dfc29dafb3bbd7$var$li(1 | b, c, f, d);
}
function $e8dfc29dafb3bbd7$var$vi(a, b) {
    return $e8dfc29dafb3bbd7$var$ti(8390656, 8, a, b);
}
function $e8dfc29dafb3bbd7$var$ji(a, b) {
    return $e8dfc29dafb3bbd7$var$ui(2048, 8, a, b);
}
function $e8dfc29dafb3bbd7$var$wi(a, b) {
    return $e8dfc29dafb3bbd7$var$ui(4, 2, a, b);
}
function $e8dfc29dafb3bbd7$var$xi(a, b) {
    return $e8dfc29dafb3bbd7$var$ui(4, 4, a, b);
}
function $e8dfc29dafb3bbd7$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $e8dfc29dafb3bbd7$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $e8dfc29dafb3bbd7$var$ui(4, 4, $e8dfc29dafb3bbd7$var$yi.bind(null, b, a), c);
}
function $e8dfc29dafb3bbd7$var$Ai() {}
function $e8dfc29dafb3bbd7$var$Bi(a, b) {
    var c = $e8dfc29dafb3bbd7$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e8dfc29dafb3bbd7$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e8dfc29dafb3bbd7$var$Ci(a, b) {
    var c = $e8dfc29dafb3bbd7$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e8dfc29dafb3bbd7$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e8dfc29dafb3bbd7$var$Di(a, b, c) {
    if (0 === ($e8dfc29dafb3bbd7$var$Rh & 21)) return a.baseState && (a.baseState = !1, $e8dfc29dafb3bbd7$var$Ug = !0), a.memoizedState = c;
    $e8dfc29dafb3bbd7$var$He(c, b) || (c = $e8dfc29dafb3bbd7$var$yc(), $e8dfc29dafb3bbd7$var$N.lanes |= c, $e8dfc29dafb3bbd7$var$hh |= c, a.baseState = !0);
    return b;
}
function $e8dfc29dafb3bbd7$var$Ei(a, b) {
    var c = $e8dfc29dafb3bbd7$var$C;
    $e8dfc29dafb3bbd7$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $e8dfc29dafb3bbd7$var$Qh.transition;
    $e8dfc29dafb3bbd7$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $e8dfc29dafb3bbd7$var$C = c, $e8dfc29dafb3bbd7$var$Qh.transition = d;
    }
}
function $e8dfc29dafb3bbd7$var$Fi() {
    return $e8dfc29dafb3bbd7$var$di().memoizedState;
}
function $e8dfc29dafb3bbd7$var$Gi(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e8dfc29dafb3bbd7$var$Hi(a)) $e8dfc29dafb3bbd7$var$Ii(b, c);
    else if (c = $e8dfc29dafb3bbd7$var$Yg(a, b, c, d), null !== c) {
        var e = $e8dfc29dafb3bbd7$var$L();
        $e8dfc29dafb3bbd7$var$mh(c, a, d, e);
        $e8dfc29dafb3bbd7$var$Ji(c, b, d);
    }
}
function $e8dfc29dafb3bbd7$var$ri(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e8dfc29dafb3bbd7$var$Hi(a)) $e8dfc29dafb3bbd7$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($e8dfc29dafb3bbd7$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $e8dfc29dafb3bbd7$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $e8dfc29dafb3bbd7$var$Yg(a, b, e, d);
        null !== c && (e = $e8dfc29dafb3bbd7$var$L(), $e8dfc29dafb3bbd7$var$mh(c, a, d, e), $e8dfc29dafb3bbd7$var$Ji(c, b, d));
    }
}
function $e8dfc29dafb3bbd7$var$Hi(a) {
    var b = a.alternate;
    return a === $e8dfc29dafb3bbd7$var$N || null !== b && b === $e8dfc29dafb3bbd7$var$N;
}
function $e8dfc29dafb3bbd7$var$Ii(a, b) {
    $e8dfc29dafb3bbd7$var$Th = $e8dfc29dafb3bbd7$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $e8dfc29dafb3bbd7$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e8dfc29dafb3bbd7$var$Cc(a, c);
    }
}
var $e8dfc29dafb3bbd7$var$ai = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: $e8dfc29dafb3bbd7$var$Q,
    useContext: $e8dfc29dafb3bbd7$var$Q,
    useEffect: $e8dfc29dafb3bbd7$var$Q,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$Q,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$Q,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$Q,
    useMemo: $e8dfc29dafb3bbd7$var$Q,
    useReducer: $e8dfc29dafb3bbd7$var$Q,
    useRef: $e8dfc29dafb3bbd7$var$Q,
    useState: $e8dfc29dafb3bbd7$var$Q,
    useDebugValue: $e8dfc29dafb3bbd7$var$Q,
    useDeferredValue: $e8dfc29dafb3bbd7$var$Q,
    useTransition: $e8dfc29dafb3bbd7$var$Q,
    useMutableSource: $e8dfc29dafb3bbd7$var$Q,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$Q,
    useId: $e8dfc29dafb3bbd7$var$Q,
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$Yh = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: function(a, b) {
        $e8dfc29dafb3bbd7$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $e8dfc29dafb3bbd7$var$Vg,
    useEffect: $e8dfc29dafb3bbd7$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $e8dfc29dafb3bbd7$var$ti(4194308, 4, $e8dfc29dafb3bbd7$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $e8dfc29dafb3bbd7$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $e8dfc29dafb3bbd7$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $e8dfc29dafb3bbd7$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $e8dfc29dafb3bbd7$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $e8dfc29dafb3bbd7$var$Gi.bind(null, $e8dfc29dafb3bbd7$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $e8dfc29dafb3bbd7$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $e8dfc29dafb3bbd7$var$qi,
    useDebugValue: $e8dfc29dafb3bbd7$var$Ai,
    useDeferredValue: function(a) {
        return $e8dfc29dafb3bbd7$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $e8dfc29dafb3bbd7$var$qi(!1), b = a[0];
        a = $e8dfc29dafb3bbd7$var$Ei.bind(null, a[1]);
        $e8dfc29dafb3bbd7$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $e8dfc29dafb3bbd7$var$N, e = $e8dfc29dafb3bbd7$var$ci();
        if ($e8dfc29dafb3bbd7$var$I) {
            if (void 0 === c) throw Error($e8dfc29dafb3bbd7$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $e8dfc29dafb3bbd7$var$R) throw Error($e8dfc29dafb3bbd7$var$p(349));
            0 !== ($e8dfc29dafb3bbd7$var$Rh & 30) || $e8dfc29dafb3bbd7$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $e8dfc29dafb3bbd7$var$vi($e8dfc29dafb3bbd7$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $e8dfc29dafb3bbd7$var$li(9, $e8dfc29dafb3bbd7$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $e8dfc29dafb3bbd7$var$ci(), b = $e8dfc29dafb3bbd7$var$R.identifierPrefix;
        if ($e8dfc29dafb3bbd7$var$I) {
            var c = $e8dfc29dafb3bbd7$var$sg;
            var d = $e8dfc29dafb3bbd7$var$rg;
            c = (d & ~(1 << 32 - $e8dfc29dafb3bbd7$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $e8dfc29dafb3bbd7$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $e8dfc29dafb3bbd7$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$Zh = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: $e8dfc29dafb3bbd7$var$Bi,
    useContext: $e8dfc29dafb3bbd7$var$Vg,
    useEffect: $e8dfc29dafb3bbd7$var$ji,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$zi,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$wi,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$xi,
    useMemo: $e8dfc29dafb3bbd7$var$Ci,
    useReducer: $e8dfc29dafb3bbd7$var$fi,
    useRef: $e8dfc29dafb3bbd7$var$si,
    useState: function() {
        return $e8dfc29dafb3bbd7$var$fi($e8dfc29dafb3bbd7$var$ei);
    },
    useDebugValue: $e8dfc29dafb3bbd7$var$Ai,
    useDeferredValue: function(a) {
        var b = $e8dfc29dafb3bbd7$var$di();
        return $e8dfc29dafb3bbd7$var$Di(b, $e8dfc29dafb3bbd7$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $e8dfc29dafb3bbd7$var$fi($e8dfc29dafb3bbd7$var$ei)[0], b = $e8dfc29dafb3bbd7$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e8dfc29dafb3bbd7$var$hi,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$ii,
    useId: $e8dfc29dafb3bbd7$var$Fi,
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$$h = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: $e8dfc29dafb3bbd7$var$Bi,
    useContext: $e8dfc29dafb3bbd7$var$Vg,
    useEffect: $e8dfc29dafb3bbd7$var$ji,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$zi,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$wi,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$xi,
    useMemo: $e8dfc29dafb3bbd7$var$Ci,
    useReducer: $e8dfc29dafb3bbd7$var$gi,
    useRef: $e8dfc29dafb3bbd7$var$si,
    useState: function() {
        return $e8dfc29dafb3bbd7$var$gi($e8dfc29dafb3bbd7$var$ei);
    },
    useDebugValue: $e8dfc29dafb3bbd7$var$Ai,
    useDeferredValue: function(a) {
        var b = $e8dfc29dafb3bbd7$var$di();
        return null === $e8dfc29dafb3bbd7$var$O ? b.memoizedState = a : $e8dfc29dafb3bbd7$var$Di(b, $e8dfc29dafb3bbd7$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $e8dfc29dafb3bbd7$var$gi($e8dfc29dafb3bbd7$var$ei)[0], b = $e8dfc29dafb3bbd7$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e8dfc29dafb3bbd7$var$hi,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$ii,
    useId: $e8dfc29dafb3bbd7$var$Fi,
    unstable_isNewReconciler: !1
};
function $e8dfc29dafb3bbd7$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $e8dfc29dafb3bbd7$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $e8dfc29dafb3bbd7$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $e8dfc29dafb3bbd7$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $e8dfc29dafb3bbd7$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $e8dfc29dafb3bbd7$var$Oi(a, b, c) {
    c = $e8dfc29dafb3bbd7$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $e8dfc29dafb3bbd7$var$Pi || ($e8dfc29dafb3bbd7$var$Pi = !0, $e8dfc29dafb3bbd7$var$Qi = d);
        $e8dfc29dafb3bbd7$var$Mi(a, b);
    };
    return c;
}
function $e8dfc29dafb3bbd7$var$Ri(a, b, c) {
    c = $e8dfc29dafb3bbd7$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $e8dfc29dafb3bbd7$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $e8dfc29dafb3bbd7$var$Mi(a, b);
        "function" !== typeof d && (null === $e8dfc29dafb3bbd7$var$Si ? $e8dfc29dafb3bbd7$var$Si = new Set([
            this
        ]) : $e8dfc29dafb3bbd7$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $e8dfc29dafb3bbd7$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $e8dfc29dafb3bbd7$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $e8dfc29dafb3bbd7$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $e8dfc29dafb3bbd7$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $e8dfc29dafb3bbd7$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $e8dfc29dafb3bbd7$var$ch(-1, 1), b.tag = 2, $e8dfc29dafb3bbd7$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $e8dfc29dafb3bbd7$var$Xi = $e8dfc29dafb3bbd7$var$ua.ReactCurrentOwner, $e8dfc29dafb3bbd7$var$Ug = !1;
function $e8dfc29dafb3bbd7$var$Yi(a, b, c, d) {
    b.child = null === a ? $e8dfc29dafb3bbd7$var$Ch(b, null, c, d) : $e8dfc29dafb3bbd7$var$Bh(b, a.child, c, d);
}
function $e8dfc29dafb3bbd7$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $e8dfc29dafb3bbd7$var$Tg(b, e);
    d = $e8dfc29dafb3bbd7$var$Xh(a, b, c, d, f, e);
    c = $e8dfc29dafb3bbd7$var$bi();
    if (null !== a && !$e8dfc29dafb3bbd7$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e8dfc29dafb3bbd7$var$$i(a, b, e);
    $e8dfc29dafb3bbd7$var$I && c && $e8dfc29dafb3bbd7$var$vg(b);
    b.flags |= 1;
    $e8dfc29dafb3bbd7$var$Yi(a, b, d, e);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$e8dfc29dafb3bbd7$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $e8dfc29dafb3bbd7$var$cj(a, b, f, d, e);
        a = $e8dfc29dafb3bbd7$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $e8dfc29dafb3bbd7$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $e8dfc29dafb3bbd7$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $e8dfc29dafb3bbd7$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $e8dfc29dafb3bbd7$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($e8dfc29dafb3bbd7$var$Ie(f, d) && a.ref === b.ref) {
            if ($e8dfc29dafb3bbd7$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($e8dfc29dafb3bbd7$var$Ug = !0);
            else return b.lanes = a.lanes, $e8dfc29dafb3bbd7$var$$i(a, b, e);
        }
    }
    return $e8dfc29dafb3bbd7$var$dj(a, b, c, d, e);
}
function $e8dfc29dafb3bbd7$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj), $e8dfc29dafb3bbd7$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj), $e8dfc29dafb3bbd7$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj);
            $e8dfc29dafb3bbd7$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj), $e8dfc29dafb3bbd7$var$gj |= d;
    $e8dfc29dafb3bbd7$var$Yi(a, b, e, c);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $e8dfc29dafb3bbd7$var$dj(a, b, c, d, e) {
    var f = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current;
    f = $e8dfc29dafb3bbd7$var$Yf(b, f);
    $e8dfc29dafb3bbd7$var$Tg(b, e);
    c = $e8dfc29dafb3bbd7$var$Xh(a, b, c, d, f, e);
    d = $e8dfc29dafb3bbd7$var$bi();
    if (null !== a && !$e8dfc29dafb3bbd7$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e8dfc29dafb3bbd7$var$$i(a, b, e);
    $e8dfc29dafb3bbd7$var$I && d && $e8dfc29dafb3bbd7$var$vg(b);
    b.flags |= 1;
    $e8dfc29dafb3bbd7$var$Yi(a, b, c, e);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$ij(a, b, c, d, e) {
    if ($e8dfc29dafb3bbd7$var$Zf(c)) {
        var f = !0;
        $e8dfc29dafb3bbd7$var$cg(b);
    } else f = !1;
    $e8dfc29dafb3bbd7$var$Tg(b, e);
    if (null === b.stateNode) $e8dfc29dafb3bbd7$var$jj(a, b), $e8dfc29dafb3bbd7$var$ph(b, c, d), $e8dfc29dafb3bbd7$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $e8dfc29dafb3bbd7$var$Vg(l) : (l = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, l = $e8dfc29dafb3bbd7$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $e8dfc29dafb3bbd7$var$qh(b, g, d, l);
        $e8dfc29dafb3bbd7$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $e8dfc29dafb3bbd7$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $e8dfc29dafb3bbd7$var$Wf.current || $e8dfc29dafb3bbd7$var$$g ? ("function" === typeof m && ($e8dfc29dafb3bbd7$var$kh(b, c, m, d), k = b.memoizedState), (h = $e8dfc29dafb3bbd7$var$$g || $e8dfc29dafb3bbd7$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $e8dfc29dafb3bbd7$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $e8dfc29dafb3bbd7$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $e8dfc29dafb3bbd7$var$Vg(k) : (k = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, k = $e8dfc29dafb3bbd7$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $e8dfc29dafb3bbd7$var$qh(b, g, d, k);
        $e8dfc29dafb3bbd7$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $e8dfc29dafb3bbd7$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $e8dfc29dafb3bbd7$var$Wf.current || $e8dfc29dafb3bbd7$var$$g ? ("function" === typeof y && ($e8dfc29dafb3bbd7$var$kh(b, c, y, d), n = b.memoizedState), (l = $e8dfc29dafb3bbd7$var$$g || $e8dfc29dafb3bbd7$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $e8dfc29dafb3bbd7$var$kj(a, b, c, d, f, e);
}
function $e8dfc29dafb3bbd7$var$kj(a, b, c, d, e, f) {
    $e8dfc29dafb3bbd7$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $e8dfc29dafb3bbd7$var$dg(b, c, !1), $e8dfc29dafb3bbd7$var$$i(a, b, f);
    d = b.stateNode;
    $e8dfc29dafb3bbd7$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $e8dfc29dafb3bbd7$var$Bh(b, a.child, null, f), b.child = $e8dfc29dafb3bbd7$var$Bh(b, null, h, f)) : $e8dfc29dafb3bbd7$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $e8dfc29dafb3bbd7$var$dg(b, c, !0);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $e8dfc29dafb3bbd7$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $e8dfc29dafb3bbd7$var$ag(a, b.context, !1);
    $e8dfc29dafb3bbd7$var$Ih(a, b.containerInfo);
}
function $e8dfc29dafb3bbd7$var$mj(a, b, c, d, e) {
    $e8dfc29dafb3bbd7$var$Ig();
    $e8dfc29dafb3bbd7$var$Jg(e);
    b.flags |= 256;
    $e8dfc29dafb3bbd7$var$Yi(a, b, c, d);
    return b.child;
}
var $e8dfc29dafb3bbd7$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $e8dfc29dafb3bbd7$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $e8dfc29dafb3bbd7$var$pj(a, b, c) {
    var d = b.pendingProps, e = $e8dfc29dafb3bbd7$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, e & 1);
    if (null === a) {
        $e8dfc29dafb3bbd7$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $e8dfc29dafb3bbd7$var$qj(g, d, 0, null), a = $e8dfc29dafb3bbd7$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $e8dfc29dafb3bbd7$var$oj(c), b.memoizedState = $e8dfc29dafb3bbd7$var$nj, a) : $e8dfc29dafb3bbd7$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $e8dfc29dafb3bbd7$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $e8dfc29dafb3bbd7$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $e8dfc29dafb3bbd7$var$wh(h, f) : (f = $e8dfc29dafb3bbd7$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $e8dfc29dafb3bbd7$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $e8dfc29dafb3bbd7$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $e8dfc29dafb3bbd7$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $e8dfc29dafb3bbd7$var$rj(a, b) {
    b = $e8dfc29dafb3bbd7$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $e8dfc29dafb3bbd7$var$tj(a, b, c, d) {
    null !== d && $e8dfc29dafb3bbd7$var$Jg(d);
    $e8dfc29dafb3bbd7$var$Bh(b, a.child, null, c);
    a = $e8dfc29dafb3bbd7$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $e8dfc29dafb3bbd7$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $e8dfc29dafb3bbd7$var$Li(Error($e8dfc29dafb3bbd7$var$p(422))), $e8dfc29dafb3bbd7$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $e8dfc29dafb3bbd7$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $e8dfc29dafb3bbd7$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $e8dfc29dafb3bbd7$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $e8dfc29dafb3bbd7$var$oj(g);
        b.memoizedState = $e8dfc29dafb3bbd7$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $e8dfc29dafb3bbd7$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($e8dfc29dafb3bbd7$var$p(419));
        d = $e8dfc29dafb3bbd7$var$Li(f, d, void 0);
        return $e8dfc29dafb3bbd7$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($e8dfc29dafb3bbd7$var$Ug || h) {
        d = $e8dfc29dafb3bbd7$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $e8dfc29dafb3bbd7$var$Zg(a, e), $e8dfc29dafb3bbd7$var$mh(d, a, e, -1));
        }
        $e8dfc29dafb3bbd7$var$uj();
        d = $e8dfc29dafb3bbd7$var$Li(Error($e8dfc29dafb3bbd7$var$p(421)));
        return $e8dfc29dafb3bbd7$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $e8dfc29dafb3bbd7$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(e.nextSibling);
    $e8dfc29dafb3bbd7$var$xg = b;
    $e8dfc29dafb3bbd7$var$I = !0;
    $e8dfc29dafb3bbd7$var$zg = null;
    null !== a && ($e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$rg, $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$sg, $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$qg, $e8dfc29dafb3bbd7$var$rg = a.id, $e8dfc29dafb3bbd7$var$sg = a.overflow, $e8dfc29dafb3bbd7$var$qg = b);
    b = $e8dfc29dafb3bbd7$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $e8dfc29dafb3bbd7$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $e8dfc29dafb3bbd7$var$Sg(a.return, b, c);
}
function $e8dfc29dafb3bbd7$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $e8dfc29dafb3bbd7$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $e8dfc29dafb3bbd7$var$Yi(a, b, d.children, c);
    d = $e8dfc29dafb3bbd7$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $e8dfc29dafb3bbd7$var$wj(a, c, b);
            else if (19 === a.tag) $e8dfc29dafb3bbd7$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $e8dfc29dafb3bbd7$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $e8dfc29dafb3bbd7$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $e8dfc29dafb3bbd7$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $e8dfc29dafb3bbd7$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $e8dfc29dafb3bbd7$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $e8dfc29dafb3bbd7$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $e8dfc29dafb3bbd7$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $e8dfc29dafb3bbd7$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($e8dfc29dafb3bbd7$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $e8dfc29dafb3bbd7$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $e8dfc29dafb3bbd7$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $e8dfc29dafb3bbd7$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $e8dfc29dafb3bbd7$var$lj(b);
            $e8dfc29dafb3bbd7$var$Ig();
            break;
        case 5:
            $e8dfc29dafb3bbd7$var$Kh(b);
            break;
        case 1:
            $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$cg(b);
            break;
        case 4:
            $e8dfc29dafb3bbd7$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $e8dfc29dafb3bbd7$var$pj(a, b, c);
                $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1);
                a = $e8dfc29dafb3bbd7$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $e8dfc29dafb3bbd7$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $e8dfc29dafb3bbd7$var$ej(a, b, c);
    }
    return $e8dfc29dafb3bbd7$var$$i(a, b, c);
}
var $e8dfc29dafb3bbd7$var$Aj, $e8dfc29dafb3bbd7$var$Bj, $e8dfc29dafb3bbd7$var$Cj, $e8dfc29dafb3bbd7$var$Dj;
$e8dfc29dafb3bbd7$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$e8dfc29dafb3bbd7$var$Bj = function() {};
$e8dfc29dafb3bbd7$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $e8dfc29dafb3bbd7$var$Ya(a, e);
                d = $e8dfc29dafb3bbd7$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $e8dfc29dafb3bbd7$var$A({}, e, {
                    value: void 0
                });
                d = $e8dfc29dafb3bbd7$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $e8dfc29dafb3bbd7$var$gb(a, e);
                d = $e8dfc29dafb3bbd7$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $e8dfc29dafb3bbd7$var$Bf);
        }
        $e8dfc29dafb3bbd7$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $e8dfc29dafb3bbd7$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$e8dfc29dafb3bbd7$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $e8dfc29dafb3bbd7$var$Ej(a, b) {
    if (!$e8dfc29dafb3bbd7$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $e8dfc29dafb3bbd7$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $e8dfc29dafb3bbd7$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $e8dfc29dafb3bbd7$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $e8dfc29dafb3bbd7$var$S(b), null;
        case 1:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), $e8dfc29dafb3bbd7$var$S(b), null;
        case 3:
            d = b.stateNode;
            $e8dfc29dafb3bbd7$var$Jh();
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
            $e8dfc29dafb3bbd7$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $e8dfc29dafb3bbd7$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $e8dfc29dafb3bbd7$var$zg && ($e8dfc29dafb3bbd7$var$Gj($e8dfc29dafb3bbd7$var$zg), $e8dfc29dafb3bbd7$var$zg = null));
            $e8dfc29dafb3bbd7$var$Bj(a, b);
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 5:
            $e8dfc29dafb3bbd7$var$Lh(b);
            var e = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $e8dfc29dafb3bbd7$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(166));
                    $e8dfc29dafb3bbd7$var$S(b);
                    return null;
                }
                a = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
                if ($e8dfc29dafb3bbd7$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$e8dfc29dafb3bbd7$var$Of] = b;
                    d[$e8dfc29dafb3bbd7$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $e8dfc29dafb3bbd7$var$D("cancel", d);
                            $e8dfc29dafb3bbd7$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $e8dfc29dafb3bbd7$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $e8dfc29dafb3bbd7$var$lf.length; e++)$e8dfc29dafb3bbd7$var$D($e8dfc29dafb3bbd7$var$lf[e], d);
                            break;
                        case "source":
                            $e8dfc29dafb3bbd7$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $e8dfc29dafb3bbd7$var$D("error", d);
                            $e8dfc29dafb3bbd7$var$D("load", d);
                            break;
                        case "details":
                            $e8dfc29dafb3bbd7$var$D("toggle", d);
                            break;
                        case "input":
                            $e8dfc29dafb3bbd7$var$Za(d, f);
                            $e8dfc29dafb3bbd7$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $e8dfc29dafb3bbd7$var$D("invalid", d);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$hb(d, f), $e8dfc29dafb3bbd7$var$D("invalid", d);
                    }
                    $e8dfc29dafb3bbd7$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $e8dfc29dafb3bbd7$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $e8dfc29dafb3bbd7$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $e8dfc29dafb3bbd7$var$Va(d);
                            $e8dfc29dafb3bbd7$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$Va(d);
                            $e8dfc29dafb3bbd7$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $e8dfc29dafb3bbd7$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $e8dfc29dafb3bbd7$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$e8dfc29dafb3bbd7$var$Of] = b;
                    a[$e8dfc29dafb3bbd7$var$Pf] = d;
                    $e8dfc29dafb3bbd7$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $e8dfc29dafb3bbd7$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $e8dfc29dafb3bbd7$var$D("cancel", a);
                                $e8dfc29dafb3bbd7$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $e8dfc29dafb3bbd7$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $e8dfc29dafb3bbd7$var$lf.length; e++)$e8dfc29dafb3bbd7$var$D($e8dfc29dafb3bbd7$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $e8dfc29dafb3bbd7$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $e8dfc29dafb3bbd7$var$D("error", a);
                                $e8dfc29dafb3bbd7$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $e8dfc29dafb3bbd7$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $e8dfc29dafb3bbd7$var$Za(a, d);
                                e = $e8dfc29dafb3bbd7$var$Ya(a, d);
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $e8dfc29dafb3bbd7$var$A({}, d, {
                                    value: void 0
                                });
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            case "textarea":
                                $e8dfc29dafb3bbd7$var$hb(a, d);
                                e = $e8dfc29dafb3bbd7$var$gb(a, d);
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $e8dfc29dafb3bbd7$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $e8dfc29dafb3bbd7$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $e8dfc29dafb3bbd7$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $e8dfc29dafb3bbd7$var$ob(a, k) : "number" === typeof k && $e8dfc29dafb3bbd7$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $e8dfc29dafb3bbd7$var$D("scroll", a) : null != k && $e8dfc29dafb3bbd7$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $e8dfc29dafb3bbd7$var$Va(a);
                                $e8dfc29dafb3bbd7$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $e8dfc29dafb3bbd7$var$Va(a);
                                $e8dfc29dafb3bbd7$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $e8dfc29dafb3bbd7$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $e8dfc29dafb3bbd7$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $e8dfc29dafb3bbd7$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $e8dfc29dafb3bbd7$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $e8dfc29dafb3bbd7$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(166));
                c = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Gh.current);
                $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
                if ($e8dfc29dafb3bbd7$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$e8dfc29dafb3bbd7$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $e8dfc29dafb3bbd7$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $e8dfc29dafb3bbd7$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$e8dfc29dafb3bbd7$var$Of] = b, b.stateNode = d;
            }
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 13:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($e8dfc29dafb3bbd7$var$I && null !== $e8dfc29dafb3bbd7$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $e8dfc29dafb3bbd7$var$Hg(), $e8dfc29dafb3bbd7$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $e8dfc29dafb3bbd7$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($e8dfc29dafb3bbd7$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($e8dfc29dafb3bbd7$var$p(317));
                        f[$e8dfc29dafb3bbd7$var$Of] = b;
                    } else $e8dfc29dafb3bbd7$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $e8dfc29dafb3bbd7$var$S(b);
                    f = !1;
                } else null !== $e8dfc29dafb3bbd7$var$zg && ($e8dfc29dafb3bbd7$var$Gj($e8dfc29dafb3bbd7$var$zg), $e8dfc29dafb3bbd7$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($e8dfc29dafb3bbd7$var$M.current & 1) ? 0 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 3) : $e8dfc29dafb3bbd7$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 4:
            return $e8dfc29dafb3bbd7$var$Jh(), $e8dfc29dafb3bbd7$var$Bj(a, b), null === a && $e8dfc29dafb3bbd7$var$sf(b.stateNode.containerInfo), $e8dfc29dafb3bbd7$var$S(b), null;
        case 10:
            return $e8dfc29dafb3bbd7$var$Rg(b.type._context), $e8dfc29dafb3bbd7$var$S(b), null;
        case 17:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), $e8dfc29dafb3bbd7$var$S(b), null;
        case 19:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
            f = b.memoizedState;
            if (null === f) return $e8dfc29dafb3bbd7$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $e8dfc29dafb3bbd7$var$Ej(f, !1);
                else {
                    if (0 !== $e8dfc29dafb3bbd7$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $e8dfc29dafb3bbd7$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $e8dfc29dafb3bbd7$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $e8dfc29dafb3bbd7$var$B() > $e8dfc29dafb3bbd7$var$Hj && (b.flags |= 128, d = !0, $e8dfc29dafb3bbd7$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $e8dfc29dafb3bbd7$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $e8dfc29dafb3bbd7$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$e8dfc29dafb3bbd7$var$I) return $e8dfc29dafb3bbd7$var$S(b), null;
                    } else 2 * $e8dfc29dafb3bbd7$var$B() - f.renderingStartTime > $e8dfc29dafb3bbd7$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $e8dfc29dafb3bbd7$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $e8dfc29dafb3bbd7$var$B(), b.sibling = null, c = $e8dfc29dafb3bbd7$var$M.current, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, d ? c & 1 | 2 : c & 1), b;
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 22:
        case 23:
            return $e8dfc29dafb3bbd7$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($e8dfc29dafb3bbd7$var$gj & 1073741824) && ($e8dfc29dafb3bbd7$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $e8dfc29dafb3bbd7$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($e8dfc29dafb3bbd7$var$p(156, b.tag));
}
function $e8dfc29dafb3bbd7$var$Jj(a, b) {
    $e8dfc29dafb3bbd7$var$wg(b);
    switch(b.tag){
        case 1:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $e8dfc29dafb3bbd7$var$Jh(), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H), $e8dfc29dafb3bbd7$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $e8dfc29dafb3bbd7$var$Lh(b), null;
        case 13:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($e8dfc29dafb3bbd7$var$p(340));
                $e8dfc29dafb3bbd7$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M), null;
        case 4:
            return $e8dfc29dafb3bbd7$var$Jh(), null;
        case 10:
            return $e8dfc29dafb3bbd7$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $e8dfc29dafb3bbd7$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $e8dfc29dafb3bbd7$var$Kj = !1, $e8dfc29dafb3bbd7$var$U = !1, $e8dfc29dafb3bbd7$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $e8dfc29dafb3bbd7$var$V = null;
function $e8dfc29dafb3bbd7$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $e8dfc29dafb3bbd7$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $e8dfc29dafb3bbd7$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $e8dfc29dafb3bbd7$var$W(a, b, d);
    }
}
var $e8dfc29dafb3bbd7$var$Oj = !1;
function $e8dfc29dafb3bbd7$var$Pj(a, b) {
    $e8dfc29dafb3bbd7$var$Cf = $e8dfc29dafb3bbd7$var$dd;
    a = $e8dfc29dafb3bbd7$var$Me();
    if ($e8dfc29dafb3bbd7$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $e8dfc29dafb3bbd7$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $e8dfc29dafb3bbd7$var$dd = !1;
    for($e8dfc29dafb3bbd7$var$V = b; null !== $e8dfc29dafb3bbd7$var$V;)if (b = $e8dfc29dafb3bbd7$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $e8dfc29dafb3bbd7$var$V = a;
    else for(; null !== $e8dfc29dafb3bbd7$var$V;){
        b = $e8dfc29dafb3bbd7$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $e8dfc29dafb3bbd7$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(163));
            }
        } catch (F) {
            $e8dfc29dafb3bbd7$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $e8dfc29dafb3bbd7$var$V = a;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
    n = $e8dfc29dafb3bbd7$var$Oj;
    $e8dfc29dafb3bbd7$var$Oj = !1;
    return n;
}
function $e8dfc29dafb3bbd7$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $e8dfc29dafb3bbd7$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $e8dfc29dafb3bbd7$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $e8dfc29dafb3bbd7$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $e8dfc29dafb3bbd7$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $e8dfc29dafb3bbd7$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$e8dfc29dafb3bbd7$var$Of], delete b[$e8dfc29dafb3bbd7$var$Pf], delete b[$e8dfc29dafb3bbd7$var$of], delete b[$e8dfc29dafb3bbd7$var$Qf], delete b[$e8dfc29dafb3bbd7$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $e8dfc29dafb3bbd7$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $e8dfc29dafb3bbd7$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $e8dfc29dafb3bbd7$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $e8dfc29dafb3bbd7$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $e8dfc29dafb3bbd7$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($e8dfc29dafb3bbd7$var$Wj(a, b, c), a = a.sibling; null !== a;)$e8dfc29dafb3bbd7$var$Wj(a, b, c), a = a.sibling;
}
function $e8dfc29dafb3bbd7$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($e8dfc29dafb3bbd7$var$Xj(a, b, c), a = a.sibling; null !== a;)$e8dfc29dafb3bbd7$var$Xj(a, b, c), a = a.sibling;
}
var $e8dfc29dafb3bbd7$var$X = null, $e8dfc29dafb3bbd7$var$Yj = !1;
function $e8dfc29dafb3bbd7$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$e8dfc29dafb3bbd7$var$ak(a, b, c), c = c.sibling;
}
function $e8dfc29dafb3bbd7$var$ak(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onCommitFiberUnmount) try {
        $e8dfc29dafb3bbd7$var$lc.onCommitFiberUnmount($e8dfc29dafb3bbd7$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $e8dfc29dafb3bbd7$var$U || $e8dfc29dafb3bbd7$var$Mj(c, b);
        case 6:
            var d = $e8dfc29dafb3bbd7$var$X, e = $e8dfc29dafb3bbd7$var$Yj;
            $e8dfc29dafb3bbd7$var$X = null;
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            $e8dfc29dafb3bbd7$var$X = d;
            $e8dfc29dafb3bbd7$var$Yj = e;
            null !== $e8dfc29dafb3bbd7$var$X && ($e8dfc29dafb3bbd7$var$Yj ? (a = $e8dfc29dafb3bbd7$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $e8dfc29dafb3bbd7$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $e8dfc29dafb3bbd7$var$X && ($e8dfc29dafb3bbd7$var$Yj ? (a = $e8dfc29dafb3bbd7$var$X, c = c.stateNode, 8 === a.nodeType ? $e8dfc29dafb3bbd7$var$Kf(a.parentNode, c) : 1 === a.nodeType && $e8dfc29dafb3bbd7$var$Kf(a, c), $e8dfc29dafb3bbd7$var$bd(a)) : $e8dfc29dafb3bbd7$var$Kf($e8dfc29dafb3bbd7$var$X, c.stateNode));
            break;
        case 4:
            d = $e8dfc29dafb3bbd7$var$X;
            e = $e8dfc29dafb3bbd7$var$Yj;
            $e8dfc29dafb3bbd7$var$X = c.stateNode.containerInfo;
            $e8dfc29dafb3bbd7$var$Yj = !0;
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            $e8dfc29dafb3bbd7$var$X = d;
            $e8dfc29dafb3bbd7$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$e8dfc29dafb3bbd7$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $e8dfc29dafb3bbd7$var$Nj(c, b, g) : 0 !== (f & 4) && $e8dfc29dafb3bbd7$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        case 1:
            if (!$e8dfc29dafb3bbd7$var$U && ($e8dfc29dafb3bbd7$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $e8dfc29dafb3bbd7$var$W(c, b, h);
            }
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        case 21:
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($e8dfc29dafb3bbd7$var$U = (d = $e8dfc29dafb3bbd7$var$U) || null !== c.memoizedState, $e8dfc29dafb3bbd7$var$Zj(a, b, c), $e8dfc29dafb3bbd7$var$U = d) : $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        default:
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
    }
}
function $e8dfc29dafb3bbd7$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $e8dfc29dafb3bbd7$var$Lj);
        b.forEach(function(b) {
            var d = $e8dfc29dafb3bbd7$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $e8dfc29dafb3bbd7$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode;
                        $e8dfc29dafb3bbd7$var$Yj = !1;
                        break a;
                    case 3:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode.containerInfo;
                        $e8dfc29dafb3bbd7$var$Yj = !0;
                        break a;
                    case 4:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode.containerInfo;
                        $e8dfc29dafb3bbd7$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $e8dfc29dafb3bbd7$var$X) throw Error($e8dfc29dafb3bbd7$var$p(160));
            $e8dfc29dafb3bbd7$var$ak(f, g, e);
            $e8dfc29dafb3bbd7$var$X = null;
            $e8dfc29dafb3bbd7$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $e8dfc29dafb3bbd7$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$e8dfc29dafb3bbd7$var$ek(b, a), b = b.sibling;
}
function $e8dfc29dafb3bbd7$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 4) {
                try {
                    $e8dfc29dafb3bbd7$var$Qj(3, a, a.return), $e8dfc29dafb3bbd7$var$Rj(3, a);
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
                try {
                    $e8dfc29dafb3bbd7$var$Qj(5, a, a.return);
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            d & 512 && null !== c && $e8dfc29dafb3bbd7$var$Mj(c, c.return);
            break;
        case 5:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            d & 512 && null !== c && $e8dfc29dafb3bbd7$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $e8dfc29dafb3bbd7$var$ob(e, "");
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $e8dfc29dafb3bbd7$var$ab(e, f);
                    $e8dfc29dafb3bbd7$var$vb(h, g);
                    var l = $e8dfc29dafb3bbd7$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $e8dfc29dafb3bbd7$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $e8dfc29dafb3bbd7$var$nb(e, q) : "children" === m ? $e8dfc29dafb3bbd7$var$ob(e, q) : $e8dfc29dafb3bbd7$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $e8dfc29dafb3bbd7$var$bb(e, f);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, f.defaultValue, !0) : $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$e8dfc29dafb3bbd7$var$Pf] = f;
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $e8dfc29dafb3bbd7$var$bd(b.containerInfo);
            } catch (t) {
                $e8dfc29dafb3bbd7$var$W(a, a.return, t);
            }
            break;
        case 4:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            break;
        case 13:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($e8dfc29dafb3bbd7$var$gk = $e8dfc29dafb3bbd7$var$B()));
            d & 4 && $e8dfc29dafb3bbd7$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($e8dfc29dafb3bbd7$var$U = (l = $e8dfc29dafb3bbd7$var$U) || m, $e8dfc29dafb3bbd7$var$dk(b, a), $e8dfc29dafb3bbd7$var$U = l) : $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($e8dfc29dafb3bbd7$var$V = a, m = a.child; null !== m;){
                    for(q = $e8dfc29dafb3bbd7$var$V = m; null !== $e8dfc29dafb3bbd7$var$V;){
                        r = $e8dfc29dafb3bbd7$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $e8dfc29dafb3bbd7$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $e8dfc29dafb3bbd7$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $e8dfc29dafb3bbd7$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $e8dfc29dafb3bbd7$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $e8dfc29dafb3bbd7$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $e8dfc29dafb3bbd7$var$V = y) : $e8dfc29dafb3bbd7$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $e8dfc29dafb3bbd7$var$rb("display", g));
                            } catch (t) {
                                $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            d & 4 && $e8dfc29dafb3bbd7$var$bk(a);
            break;
        case 21:
            break;
        default:
            $e8dfc29dafb3bbd7$var$dk(b, a), $e8dfc29dafb3bbd7$var$fk(a);
    }
}
function $e8dfc29dafb3bbd7$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($e8dfc29dafb3bbd7$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($e8dfc29dafb3bbd7$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($e8dfc29dafb3bbd7$var$ob(e, ""), d.flags &= -33);
                    var f = $e8dfc29dafb3bbd7$var$Vj(a);
                    $e8dfc29dafb3bbd7$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $e8dfc29dafb3bbd7$var$Vj(a);
                    $e8dfc29dafb3bbd7$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(161));
            }
        } catch (k) {
            $e8dfc29dafb3bbd7$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $e8dfc29dafb3bbd7$var$ik(a, b, c) {
    $e8dfc29dafb3bbd7$var$V = a;
    $e8dfc29dafb3bbd7$var$jk(a, b, c);
}
function $e8dfc29dafb3bbd7$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $e8dfc29dafb3bbd7$var$V;){
        var e = $e8dfc29dafb3bbd7$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $e8dfc29dafb3bbd7$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $e8dfc29dafb3bbd7$var$U;
                h = $e8dfc29dafb3bbd7$var$Kj;
                var l = $e8dfc29dafb3bbd7$var$U;
                $e8dfc29dafb3bbd7$var$Kj = g;
                if (($e8dfc29dafb3bbd7$var$U = k) && !l) for($e8dfc29dafb3bbd7$var$V = e; null !== $e8dfc29dafb3bbd7$var$V;)g = $e8dfc29dafb3bbd7$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $e8dfc29dafb3bbd7$var$kk(e) : null !== k ? (k.return = g, $e8dfc29dafb3bbd7$var$V = k) : $e8dfc29dafb3bbd7$var$kk(e);
                for(; null !== f;)$e8dfc29dafb3bbd7$var$V = f, $e8dfc29dafb3bbd7$var$jk(f, b, c), f = f.sibling;
                $e8dfc29dafb3bbd7$var$V = e;
                $e8dfc29dafb3bbd7$var$Kj = h;
                $e8dfc29dafb3bbd7$var$U = l;
            }
            $e8dfc29dafb3bbd7$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $e8dfc29dafb3bbd7$var$V = f) : $e8dfc29dafb3bbd7$var$lk(a, b, c);
    }
}
function $e8dfc29dafb3bbd7$var$lk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $e8dfc29dafb3bbd7$var$U || $e8dfc29dafb3bbd7$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$e8dfc29dafb3bbd7$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $e8dfc29dafb3bbd7$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $e8dfc29dafb3bbd7$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $e8dfc29dafb3bbd7$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $e8dfc29dafb3bbd7$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($e8dfc29dafb3bbd7$var$p(163));
                }
                $e8dfc29dafb3bbd7$var$U || b.flags & 512 && $e8dfc29dafb3bbd7$var$Sj(b);
            } catch (r) {
                $e8dfc29dafb3bbd7$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e8dfc29dafb3bbd7$var$V = c;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$hk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e8dfc29dafb3bbd7$var$V = c;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$kk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Rj(4, b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $e8dfc29dafb3bbd7$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Sj(b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Sj(b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $e8dfc29dafb3bbd7$var$W(b, b.return, k);
        }
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $e8dfc29dafb3bbd7$var$V = h;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
var $e8dfc29dafb3bbd7$var$mk = Math.ceil, $e8dfc29dafb3bbd7$var$nk = $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher, $e8dfc29dafb3bbd7$var$ok = $e8dfc29dafb3bbd7$var$ua.ReactCurrentOwner, $e8dfc29dafb3bbd7$var$pk = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$K = 0, $e8dfc29dafb3bbd7$var$R = null, $e8dfc29dafb3bbd7$var$Y = null, $e8dfc29dafb3bbd7$var$Z = 0, $e8dfc29dafb3bbd7$var$gj = 0, $e8dfc29dafb3bbd7$var$fj = $e8dfc29dafb3bbd7$var$Uf(0), $e8dfc29dafb3bbd7$var$T = 0, $e8dfc29dafb3bbd7$var$qk = null, $e8dfc29dafb3bbd7$var$hh = 0, $e8dfc29dafb3bbd7$var$rk = 0, $e8dfc29dafb3bbd7$var$sk = 0, $e8dfc29dafb3bbd7$var$tk = null, $e8dfc29dafb3bbd7$var$uk = null, $e8dfc29dafb3bbd7$var$gk = 0, $e8dfc29dafb3bbd7$var$Hj = Infinity, $e8dfc29dafb3bbd7$var$vk = null, $e8dfc29dafb3bbd7$var$Pi = !1, $e8dfc29dafb3bbd7$var$Qi = null, $e8dfc29dafb3bbd7$var$Si = null, $e8dfc29dafb3bbd7$var$wk = !1, $e8dfc29dafb3bbd7$var$xk = null, $e8dfc29dafb3bbd7$var$yk = 0, $e8dfc29dafb3bbd7$var$zk = 0, $e8dfc29dafb3bbd7$var$Ak = null, $e8dfc29dafb3bbd7$var$Bk = -1, $e8dfc29dafb3bbd7$var$Ck = 0;
function $e8dfc29dafb3bbd7$var$L() {
    return 0 !== ($e8dfc29dafb3bbd7$var$K & 6) ? $e8dfc29dafb3bbd7$var$B() : -1 !== $e8dfc29dafb3bbd7$var$Bk ? $e8dfc29dafb3bbd7$var$Bk : $e8dfc29dafb3bbd7$var$Bk = $e8dfc29dafb3bbd7$var$B();
}
function $e8dfc29dafb3bbd7$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 2) && 0 !== $e8dfc29dafb3bbd7$var$Z) return $e8dfc29dafb3bbd7$var$Z & -$e8dfc29dafb3bbd7$var$Z;
    if (null !== $e8dfc29dafb3bbd7$var$Kg.transition) return 0 === $e8dfc29dafb3bbd7$var$Ck && ($e8dfc29dafb3bbd7$var$Ck = $e8dfc29dafb3bbd7$var$yc()), $e8dfc29dafb3bbd7$var$Ck;
    a = $e8dfc29dafb3bbd7$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $e8dfc29dafb3bbd7$var$jd(a.type);
    return a;
}
function $e8dfc29dafb3bbd7$var$mh(a, b, c, d) {
    if (50 < $e8dfc29dafb3bbd7$var$zk) throw $e8dfc29dafb3bbd7$var$zk = 0, $e8dfc29dafb3bbd7$var$Ak = null, Error($e8dfc29dafb3bbd7$var$p(185));
    $e8dfc29dafb3bbd7$var$Ac(a, c, d);
    if (0 === ($e8dfc29dafb3bbd7$var$K & 2) || a !== $e8dfc29dafb3bbd7$var$R) a === $e8dfc29dafb3bbd7$var$R && (0 === ($e8dfc29dafb3bbd7$var$K & 2) && ($e8dfc29dafb3bbd7$var$rk |= c), 4 === $e8dfc29dafb3bbd7$var$T && $e8dfc29dafb3bbd7$var$Dk(a, $e8dfc29dafb3bbd7$var$Z)), $e8dfc29dafb3bbd7$var$Ek(a, d), 1 === c && 0 === $e8dfc29dafb3bbd7$var$K && 0 === (b.mode & 1) && ($e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$fg && $e8dfc29dafb3bbd7$var$jg());
}
function $e8dfc29dafb3bbd7$var$Ek(a, b) {
    var c = a.callbackNode;
    $e8dfc29dafb3bbd7$var$wc(a, b);
    var d = $e8dfc29dafb3bbd7$var$uc(a, a === $e8dfc29dafb3bbd7$var$R ? $e8dfc29dafb3bbd7$var$Z : 0);
    if (0 === d) null !== c && $e8dfc29dafb3bbd7$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $e8dfc29dafb3bbd7$var$bc(c);
        if (1 === b) 0 === a.tag ? $e8dfc29dafb3bbd7$var$ig($e8dfc29dafb3bbd7$var$Fk.bind(null, a)) : $e8dfc29dafb3bbd7$var$hg($e8dfc29dafb3bbd7$var$Fk.bind(null, a)), $e8dfc29dafb3bbd7$var$Jf(function() {
            0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$jg();
        }), c = null;
        else {
            switch($e8dfc29dafb3bbd7$var$Dc(d)){
                case 1:
                    c = $e8dfc29dafb3bbd7$var$fc;
                    break;
                case 4:
                    c = $e8dfc29dafb3bbd7$var$gc;
                    break;
                case 16:
                    c = $e8dfc29dafb3bbd7$var$hc;
                    break;
                case 536870912:
                    c = $e8dfc29dafb3bbd7$var$jc;
                    break;
                default:
                    c = $e8dfc29dafb3bbd7$var$hc;
            }
            c = $e8dfc29dafb3bbd7$var$Gk(c, $e8dfc29dafb3bbd7$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $e8dfc29dafb3bbd7$var$Hk(a, b) {
    $e8dfc29dafb3bbd7$var$Bk = -1;
    $e8dfc29dafb3bbd7$var$Ck = 0;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    var c = a.callbackNode;
    if ($e8dfc29dafb3bbd7$var$Ik() && a.callbackNode !== c) return null;
    var d = $e8dfc29dafb3bbd7$var$uc(a, a === $e8dfc29dafb3bbd7$var$R ? $e8dfc29dafb3bbd7$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $e8dfc29dafb3bbd7$var$Jk(a, d);
    else {
        b = d;
        var e = $e8dfc29dafb3bbd7$var$K;
        $e8dfc29dafb3bbd7$var$K |= 2;
        var f = $e8dfc29dafb3bbd7$var$Kk();
        if ($e8dfc29dafb3bbd7$var$R !== a || $e8dfc29dafb3bbd7$var$Z !== b) $e8dfc29dafb3bbd7$var$vk = null, $e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$Lk(a, b);
        for(;;)try {
            $e8dfc29dafb3bbd7$var$Mk();
            break;
        } catch (h) {
            $e8dfc29dafb3bbd7$var$Nk(a, h);
        }
        $e8dfc29dafb3bbd7$var$Qg();
        $e8dfc29dafb3bbd7$var$nk.current = f;
        $e8dfc29dafb3bbd7$var$K = e;
        null !== $e8dfc29dafb3bbd7$var$Y ? b = 0 : ($e8dfc29dafb3bbd7$var$R = null, $e8dfc29dafb3bbd7$var$Z = 0, b = $e8dfc29dafb3bbd7$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $e8dfc29dafb3bbd7$var$xc(a), 0 !== e && (d = e, b = $e8dfc29dafb3bbd7$var$Ok(a, e)));
        if (1 === b) throw c = $e8dfc29dafb3bbd7$var$qk, $e8dfc29dafb3bbd7$var$Lk(a, 0), $e8dfc29dafb3bbd7$var$Dk(a, d), $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), c;
        if (6 === b) $e8dfc29dafb3bbd7$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$e8dfc29dafb3bbd7$var$Pk(e) && (b = $e8dfc29dafb3bbd7$var$Jk(a, d), 2 === b && (f = $e8dfc29dafb3bbd7$var$xc(a), 0 !== f && (d = f, b = $e8dfc29dafb3bbd7$var$Ok(a, f))), 1 === b)) throw c = $e8dfc29dafb3bbd7$var$qk, $e8dfc29dafb3bbd7$var$Lk(a, 0), $e8dfc29dafb3bbd7$var$Dk(a, d), $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($e8dfc29dafb3bbd7$var$p(345));
                case 2:
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                case 3:
                    $e8dfc29dafb3bbd7$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $e8dfc29dafb3bbd7$var$gk + 500 - $e8dfc29dafb3bbd7$var$B(), 10 < b)) {
                        if (0 !== $e8dfc29dafb3bbd7$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $e8dfc29dafb3bbd7$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $e8dfc29dafb3bbd7$var$Ff($e8dfc29dafb3bbd7$var$Qk.bind(null, a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk), b);
                        break;
                    }
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                case 4:
                    $e8dfc29dafb3bbd7$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $e8dfc29dafb3bbd7$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $e8dfc29dafb3bbd7$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $e8dfc29dafb3bbd7$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $e8dfc29dafb3bbd7$var$Ff($e8dfc29dafb3bbd7$var$Qk.bind(null, a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk), d);
                        break;
                    }
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                case 5:
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(329));
            }
        }
    }
    $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B());
    return a.callbackNode === c ? $e8dfc29dafb3bbd7$var$Hk.bind(null, a) : null;
}
function $e8dfc29dafb3bbd7$var$Ok(a, b) {
    var c = $e8dfc29dafb3bbd7$var$tk;
    a.current.memoizedState.isDehydrated && ($e8dfc29dafb3bbd7$var$Lk(a, b).flags |= 256);
    a = $e8dfc29dafb3bbd7$var$Jk(a, b);
    2 !== a && (b = $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$uk = c, null !== b && $e8dfc29dafb3bbd7$var$Gj(b));
    return a;
}
function $e8dfc29dafb3bbd7$var$Gj(a) {
    null === $e8dfc29dafb3bbd7$var$uk ? $e8dfc29dafb3bbd7$var$uk = a : $e8dfc29dafb3bbd7$var$uk.push.apply($e8dfc29dafb3bbd7$var$uk, a);
}
function $e8dfc29dafb3bbd7$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$e8dfc29dafb3bbd7$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Dk(a, b) {
    b &= ~$e8dfc29dafb3bbd7$var$sk;
    b &= ~$e8dfc29dafb3bbd7$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $e8dfc29dafb3bbd7$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $e8dfc29dafb3bbd7$var$Fk(a) {
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    $e8dfc29dafb3bbd7$var$Ik();
    var b = $e8dfc29dafb3bbd7$var$uc(a, 0);
    if (0 === (b & 1)) return $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), null;
    var c = $e8dfc29dafb3bbd7$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $e8dfc29dafb3bbd7$var$xc(a);
        0 !== d && (b = d, c = $e8dfc29dafb3bbd7$var$Ok(a, d));
    }
    if (1 === c) throw c = $e8dfc29dafb3bbd7$var$qk, $e8dfc29dafb3bbd7$var$Lk(a, 0), $e8dfc29dafb3bbd7$var$Dk(a, b), $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), c;
    if (6 === c) throw Error($e8dfc29dafb3bbd7$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
    $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B());
    return null;
}
function $e8dfc29dafb3bbd7$var$Rk(a, b) {
    var c = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 1;
    try {
        return a(b);
    } finally{
        $e8dfc29dafb3bbd7$var$K = c, 0 === $e8dfc29dafb3bbd7$var$K && ($e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$fg && $e8dfc29dafb3bbd7$var$jg());
    }
}
function $e8dfc29dafb3bbd7$var$Sk(a) {
    null !== $e8dfc29dafb3bbd7$var$xk && 0 === $e8dfc29dafb3bbd7$var$xk.tag && 0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$Ik();
    var b = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 1;
    var c = $e8dfc29dafb3bbd7$var$pk.transition, d = $e8dfc29dafb3bbd7$var$C;
    try {
        if ($e8dfc29dafb3bbd7$var$pk.transition = null, $e8dfc29dafb3bbd7$var$C = 1, a) return a();
    } finally{
        $e8dfc29dafb3bbd7$var$C = d, $e8dfc29dafb3bbd7$var$pk.transition = c, $e8dfc29dafb3bbd7$var$K = b, 0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$jg();
    }
}
function $e8dfc29dafb3bbd7$var$Ij() {
    $e8dfc29dafb3bbd7$var$gj = $e8dfc29dafb3bbd7$var$fj.current;
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$fj);
}
function $e8dfc29dafb3bbd7$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $e8dfc29dafb3bbd7$var$Gf(c));
    if (null !== $e8dfc29dafb3bbd7$var$Y) for(c = $e8dfc29dafb3bbd7$var$Y.return; null !== c;){
        var d = c;
        $e8dfc29dafb3bbd7$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $e8dfc29dafb3bbd7$var$$f();
                break;
            case 3:
                $e8dfc29dafb3bbd7$var$Jh();
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
                $e8dfc29dafb3bbd7$var$Oh();
                break;
            case 5:
                $e8dfc29dafb3bbd7$var$Lh(d);
                break;
            case 4:
                $e8dfc29dafb3bbd7$var$Jh();
                break;
            case 13:
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
                break;
            case 19:
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
                break;
            case 10:
                $e8dfc29dafb3bbd7$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $e8dfc29dafb3bbd7$var$Ij();
        }
        c = c.return;
    }
    $e8dfc29dafb3bbd7$var$R = a;
    $e8dfc29dafb3bbd7$var$Y = a = $e8dfc29dafb3bbd7$var$wh(a.current, null);
    $e8dfc29dafb3bbd7$var$Z = $e8dfc29dafb3bbd7$var$gj = b;
    $e8dfc29dafb3bbd7$var$T = 0;
    $e8dfc29dafb3bbd7$var$qk = null;
    $e8dfc29dafb3bbd7$var$sk = $e8dfc29dafb3bbd7$var$rk = $e8dfc29dafb3bbd7$var$hh = 0;
    $e8dfc29dafb3bbd7$var$uk = $e8dfc29dafb3bbd7$var$tk = null;
    if (null !== $e8dfc29dafb3bbd7$var$Wg) {
        for(b = 0; b < $e8dfc29dafb3bbd7$var$Wg.length; b++)if (c = $e8dfc29dafb3bbd7$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $e8dfc29dafb3bbd7$var$Wg = null;
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$Nk(a, b) {
    do {
        var c = $e8dfc29dafb3bbd7$var$Y;
        try {
            $e8dfc29dafb3bbd7$var$Qg();
            $e8dfc29dafb3bbd7$var$Ph.current = $e8dfc29dafb3bbd7$var$ai;
            if ($e8dfc29dafb3bbd7$var$Sh) {
                for(var d = $e8dfc29dafb3bbd7$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $e8dfc29dafb3bbd7$var$Sh = !1;
            }
            $e8dfc29dafb3bbd7$var$Rh = 0;
            $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$O = $e8dfc29dafb3bbd7$var$N = null;
            $e8dfc29dafb3bbd7$var$Th = !1;
            $e8dfc29dafb3bbd7$var$Uh = 0;
            $e8dfc29dafb3bbd7$var$ok.current = null;
            if (null === c || null === c.return) {
                $e8dfc29dafb3bbd7$var$T = 1;
                $e8dfc29dafb3bbd7$var$qk = b;
                $e8dfc29dafb3bbd7$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $e8dfc29dafb3bbd7$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $e8dfc29dafb3bbd7$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $e8dfc29dafb3bbd7$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $e8dfc29dafb3bbd7$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $e8dfc29dafb3bbd7$var$Ti(f, l, b);
                            $e8dfc29dafb3bbd7$var$uj();
                            break a;
                        }
                        k = Error($e8dfc29dafb3bbd7$var$p(426));
                    }
                } else if ($e8dfc29dafb3bbd7$var$I && h.mode & 1) {
                    var J = $e8dfc29dafb3bbd7$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $e8dfc29dafb3bbd7$var$Wi(J, g, h, f, b);
                        $e8dfc29dafb3bbd7$var$Jg($e8dfc29dafb3bbd7$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $e8dfc29dafb3bbd7$var$Ki(k, h);
                4 !== $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 2);
                null === $e8dfc29dafb3bbd7$var$tk ? $e8dfc29dafb3bbd7$var$tk = [
                    f
                ] : $e8dfc29dafb3bbd7$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $e8dfc29dafb3bbd7$var$Oi(f, k, b);
                            $e8dfc29dafb3bbd7$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $e8dfc29dafb3bbd7$var$Si || !$e8dfc29dafb3bbd7$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $e8dfc29dafb3bbd7$var$Ri(f, h, b);
                                $e8dfc29dafb3bbd7$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $e8dfc29dafb3bbd7$var$Tk(c);
        } catch (na) {
            b = na;
            $e8dfc29dafb3bbd7$var$Y === c && null !== c && ($e8dfc29dafb3bbd7$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $e8dfc29dafb3bbd7$var$Kk() {
    var a = $e8dfc29dafb3bbd7$var$nk.current;
    $e8dfc29dafb3bbd7$var$nk.current = $e8dfc29dafb3bbd7$var$ai;
    return null === a ? $e8dfc29dafb3bbd7$var$ai : a;
}
function $e8dfc29dafb3bbd7$var$uj() {
    if (0 === $e8dfc29dafb3bbd7$var$T || 3 === $e8dfc29dafb3bbd7$var$T || 2 === $e8dfc29dafb3bbd7$var$T) $e8dfc29dafb3bbd7$var$T = 4;
    null === $e8dfc29dafb3bbd7$var$R || 0 === ($e8dfc29dafb3bbd7$var$hh & 268435455) && 0 === ($e8dfc29dafb3bbd7$var$rk & 268435455) || $e8dfc29dafb3bbd7$var$Dk($e8dfc29dafb3bbd7$var$R, $e8dfc29dafb3bbd7$var$Z);
}
function $e8dfc29dafb3bbd7$var$Jk(a, b) {
    var c = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 2;
    var d = $e8dfc29dafb3bbd7$var$Kk();
    if ($e8dfc29dafb3bbd7$var$R !== a || $e8dfc29dafb3bbd7$var$Z !== b) $e8dfc29dafb3bbd7$var$vk = null, $e8dfc29dafb3bbd7$var$Lk(a, b);
    for(;;)try {
        $e8dfc29dafb3bbd7$var$Uk();
        break;
    } catch (e) {
        $e8dfc29dafb3bbd7$var$Nk(a, e);
    }
    $e8dfc29dafb3bbd7$var$Qg();
    $e8dfc29dafb3bbd7$var$K = c;
    $e8dfc29dafb3bbd7$var$nk.current = d;
    if (null !== $e8dfc29dafb3bbd7$var$Y) throw Error($e8dfc29dafb3bbd7$var$p(261));
    $e8dfc29dafb3bbd7$var$R = null;
    $e8dfc29dafb3bbd7$var$Z = 0;
    return $e8dfc29dafb3bbd7$var$T;
}
function $e8dfc29dafb3bbd7$var$Uk() {
    for(; null !== $e8dfc29dafb3bbd7$var$Y;)$e8dfc29dafb3bbd7$var$Vk($e8dfc29dafb3bbd7$var$Y);
}
function $e8dfc29dafb3bbd7$var$Mk() {
    for(; null !== $e8dfc29dafb3bbd7$var$Y && !$e8dfc29dafb3bbd7$var$cc();)$e8dfc29dafb3bbd7$var$Vk($e8dfc29dafb3bbd7$var$Y);
}
function $e8dfc29dafb3bbd7$var$Vk(a) {
    var b = $e8dfc29dafb3bbd7$var$Wk(a.alternate, a, $e8dfc29dafb3bbd7$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $e8dfc29dafb3bbd7$var$Tk(a) : $e8dfc29dafb3bbd7$var$Y = b;
    $e8dfc29dafb3bbd7$var$ok.current = null;
}
function $e8dfc29dafb3bbd7$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $e8dfc29dafb3bbd7$var$Fj(c, b, $e8dfc29dafb3bbd7$var$gj), null !== c) {
                $e8dfc29dafb3bbd7$var$Y = c;
                return;
            }
        } else {
            c = $e8dfc29dafb3bbd7$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $e8dfc29dafb3bbd7$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $e8dfc29dafb3bbd7$var$T = 6;
                $e8dfc29dafb3bbd7$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $e8dfc29dafb3bbd7$var$Y = b;
            return;
        }
        $e8dfc29dafb3bbd7$var$Y = b = a;
    }while (null !== b);
    0 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 5);
}
function $e8dfc29dafb3bbd7$var$Qk(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$C, e = $e8dfc29dafb3bbd7$var$pk.transition;
    try {
        $e8dfc29dafb3bbd7$var$pk.transition = null, $e8dfc29dafb3bbd7$var$C = 1, $e8dfc29dafb3bbd7$var$Xk(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$pk.transition = e, $e8dfc29dafb3bbd7$var$C = d;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Xk(a, b, c, d) {
    do $e8dfc29dafb3bbd7$var$Ik();
    while (null !== $e8dfc29dafb3bbd7$var$xk);
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($e8dfc29dafb3bbd7$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $e8dfc29dafb3bbd7$var$Bc(a, f);
    a === $e8dfc29dafb3bbd7$var$R && ($e8dfc29dafb3bbd7$var$Y = $e8dfc29dafb3bbd7$var$R = null, $e8dfc29dafb3bbd7$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $e8dfc29dafb3bbd7$var$wk || ($e8dfc29dafb3bbd7$var$wk = !0, $e8dfc29dafb3bbd7$var$Gk($e8dfc29dafb3bbd7$var$hc, function() {
        $e8dfc29dafb3bbd7$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $e8dfc29dafb3bbd7$var$pk.transition;
        $e8dfc29dafb3bbd7$var$pk.transition = null;
        var g = $e8dfc29dafb3bbd7$var$C;
        $e8dfc29dafb3bbd7$var$C = 1;
        var h = $e8dfc29dafb3bbd7$var$K;
        $e8dfc29dafb3bbd7$var$K |= 4;
        $e8dfc29dafb3bbd7$var$ok.current = null;
        $e8dfc29dafb3bbd7$var$Pj(a, c);
        $e8dfc29dafb3bbd7$var$ek(c, a);
        $e8dfc29dafb3bbd7$var$Oe($e8dfc29dafb3bbd7$var$Df);
        $e8dfc29dafb3bbd7$var$dd = !!$e8dfc29dafb3bbd7$var$Cf;
        $e8dfc29dafb3bbd7$var$Df = $e8dfc29dafb3bbd7$var$Cf = null;
        a.current = c;
        $e8dfc29dafb3bbd7$var$ik(c, a, e);
        $e8dfc29dafb3bbd7$var$dc();
        $e8dfc29dafb3bbd7$var$K = h;
        $e8dfc29dafb3bbd7$var$C = g;
        $e8dfc29dafb3bbd7$var$pk.transition = f;
    } else a.current = c;
    $e8dfc29dafb3bbd7$var$wk && ($e8dfc29dafb3bbd7$var$wk = !1, $e8dfc29dafb3bbd7$var$xk = a, $e8dfc29dafb3bbd7$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($e8dfc29dafb3bbd7$var$Si = null);
    $e8dfc29dafb3bbd7$var$mc(c.stateNode, d);
    $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($e8dfc29dafb3bbd7$var$Pi) throw $e8dfc29dafb3bbd7$var$Pi = !1, a = $e8dfc29dafb3bbd7$var$Qi, $e8dfc29dafb3bbd7$var$Qi = null, a;
    0 !== ($e8dfc29dafb3bbd7$var$yk & 1) && 0 !== a.tag && $e8dfc29dafb3bbd7$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $e8dfc29dafb3bbd7$var$Ak ? $e8dfc29dafb3bbd7$var$zk++ : ($e8dfc29dafb3bbd7$var$zk = 0, $e8dfc29dafb3bbd7$var$Ak = a) : $e8dfc29dafb3bbd7$var$zk = 0;
    $e8dfc29dafb3bbd7$var$jg();
    return null;
}
function $e8dfc29dafb3bbd7$var$Ik() {
    if (null !== $e8dfc29dafb3bbd7$var$xk) {
        var a = $e8dfc29dafb3bbd7$var$Dc($e8dfc29dafb3bbd7$var$yk), b = $e8dfc29dafb3bbd7$var$pk.transition, c = $e8dfc29dafb3bbd7$var$C;
        try {
            $e8dfc29dafb3bbd7$var$pk.transition = null;
            $e8dfc29dafb3bbd7$var$C = 16 > a ? 16 : a;
            if (null === $e8dfc29dafb3bbd7$var$xk) var d = !1;
            else {
                a = $e8dfc29dafb3bbd7$var$xk;
                $e8dfc29dafb3bbd7$var$xk = null;
                $e8dfc29dafb3bbd7$var$yk = 0;
                if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(331));
                var e = $e8dfc29dafb3bbd7$var$K;
                $e8dfc29dafb3bbd7$var$K |= 4;
                for($e8dfc29dafb3bbd7$var$V = a.current; null !== $e8dfc29dafb3bbd7$var$V;){
                    var f = $e8dfc29dafb3bbd7$var$V, g = f.child;
                    if (0 !== ($e8dfc29dafb3bbd7$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($e8dfc29dafb3bbd7$var$V = l; null !== $e8dfc29dafb3bbd7$var$V;){
                                    var m = $e8dfc29dafb3bbd7$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $e8dfc29dafb3bbd7$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $e8dfc29dafb3bbd7$var$V = q;
                                    else for(; null !== $e8dfc29dafb3bbd7$var$V;){
                                        m = $e8dfc29dafb3bbd7$var$V;
                                        var r = m.sibling, y = m.return;
                                        $e8dfc29dafb3bbd7$var$Tj(m);
                                        if (m === l) {
                                            $e8dfc29dafb3bbd7$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $e8dfc29dafb3bbd7$var$V = r;
                                            break;
                                        }
                                        $e8dfc29dafb3bbd7$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $e8dfc29dafb3bbd7$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $e8dfc29dafb3bbd7$var$V = g;
                    else b: for(; null !== $e8dfc29dafb3bbd7$var$V;){
                        f = $e8dfc29dafb3bbd7$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $e8dfc29dafb3bbd7$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $e8dfc29dafb3bbd7$var$V = x;
                            break b;
                        }
                        $e8dfc29dafb3bbd7$var$V = f.return;
                    }
                }
                var w = a.current;
                for($e8dfc29dafb3bbd7$var$V = w; null !== $e8dfc29dafb3bbd7$var$V;){
                    g = $e8dfc29dafb3bbd7$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $e8dfc29dafb3bbd7$var$V = u;
                    else b: for(g = w; null !== $e8dfc29dafb3bbd7$var$V;){
                        h = $e8dfc29dafb3bbd7$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $e8dfc29dafb3bbd7$var$Rj(9, h);
                            }
                        } catch (na) {
                            $e8dfc29dafb3bbd7$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $e8dfc29dafb3bbd7$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $e8dfc29dafb3bbd7$var$V = F;
                            break b;
                        }
                        $e8dfc29dafb3bbd7$var$V = h.return;
                    }
                }
                $e8dfc29dafb3bbd7$var$K = e;
                $e8dfc29dafb3bbd7$var$jg();
                if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onPostCommitFiberRoot) try {
                    $e8dfc29dafb3bbd7$var$lc.onPostCommitFiberRoot($e8dfc29dafb3bbd7$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $e8dfc29dafb3bbd7$var$C = c, $e8dfc29dafb3bbd7$var$pk.transition = b;
        }
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$Yk(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$Ki(c, b);
    b = $e8dfc29dafb3bbd7$var$Oi(a, b, 1);
    a = $e8dfc29dafb3bbd7$var$dh(a, b, 1);
    b = $e8dfc29dafb3bbd7$var$L();
    null !== a && ($e8dfc29dafb3bbd7$var$Ac(a, 1, b), $e8dfc29dafb3bbd7$var$Ek(a, b));
}
function $e8dfc29dafb3bbd7$var$W(a, b, c) {
    if (3 === a.tag) $e8dfc29dafb3bbd7$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $e8dfc29dafb3bbd7$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $e8dfc29dafb3bbd7$var$Si || !$e8dfc29dafb3bbd7$var$Si.has(d))) {
                a = $e8dfc29dafb3bbd7$var$Ki(c, a);
                a = $e8dfc29dafb3bbd7$var$Ri(b, a, 1);
                b = $e8dfc29dafb3bbd7$var$dh(b, a, 1);
                a = $e8dfc29dafb3bbd7$var$L();
                null !== b && ($e8dfc29dafb3bbd7$var$Ac(b, 1, a), $e8dfc29dafb3bbd7$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $e8dfc29dafb3bbd7$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $e8dfc29dafb3bbd7$var$R === a && ($e8dfc29dafb3bbd7$var$Z & c) === c && (4 === $e8dfc29dafb3bbd7$var$T || 3 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$Z & 130023424) === $e8dfc29dafb3bbd7$var$Z && 500 > $e8dfc29dafb3bbd7$var$B() - $e8dfc29dafb3bbd7$var$gk ? $e8dfc29dafb3bbd7$var$Lk(a, 0) : $e8dfc29dafb3bbd7$var$sk |= c);
    $e8dfc29dafb3bbd7$var$Ek(a, b);
}
function $e8dfc29dafb3bbd7$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $e8dfc29dafb3bbd7$var$sc, $e8dfc29dafb3bbd7$var$sc <<= 1, 0 === ($e8dfc29dafb3bbd7$var$sc & 130023424) && ($e8dfc29dafb3bbd7$var$sc = 4194304)));
    var c = $e8dfc29dafb3bbd7$var$L();
    a = $e8dfc29dafb3bbd7$var$Zg(a, b);
    null !== a && ($e8dfc29dafb3bbd7$var$Ac(a, b, c), $e8dfc29dafb3bbd7$var$Ek(a, c));
}
function $e8dfc29dafb3bbd7$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $e8dfc29dafb3bbd7$var$Zk(a, c);
}
function $e8dfc29dafb3bbd7$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($e8dfc29dafb3bbd7$var$p(314));
    }
    null !== d && d.delete(b);
    $e8dfc29dafb3bbd7$var$Zk(a, c);
}
var $e8dfc29dafb3bbd7$var$Wk;
$e8dfc29dafb3bbd7$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $e8dfc29dafb3bbd7$var$Wf.current) $e8dfc29dafb3bbd7$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $e8dfc29dafb3bbd7$var$Ug = !1, $e8dfc29dafb3bbd7$var$zj(a, b, c);
            $e8dfc29dafb3bbd7$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $e8dfc29dafb3bbd7$var$Ug = !1, $e8dfc29dafb3bbd7$var$I && 0 !== (b.flags & 1048576) && $e8dfc29dafb3bbd7$var$ug(b, $e8dfc29dafb3bbd7$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $e8dfc29dafb3bbd7$var$jj(a, b);
            a = b.pendingProps;
            var e = $e8dfc29dafb3bbd7$var$Yf(b, $e8dfc29dafb3bbd7$var$H.current);
            $e8dfc29dafb3bbd7$var$Tg(b, c);
            e = $e8dfc29dafb3bbd7$var$Xh(null, b, d, a, e, c);
            var f = $e8dfc29dafb3bbd7$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $e8dfc29dafb3bbd7$var$Zf(d) ? (f = !0, $e8dfc29dafb3bbd7$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $e8dfc29dafb3bbd7$var$ah(b), e.updater = $e8dfc29dafb3bbd7$var$nh, b.stateNode = e, e._reactInternals = b, $e8dfc29dafb3bbd7$var$rh(b, d, a, c), b = $e8dfc29dafb3bbd7$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $e8dfc29dafb3bbd7$var$I && f && $e8dfc29dafb3bbd7$var$vg(b), $e8dfc29dafb3bbd7$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $e8dfc29dafb3bbd7$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $e8dfc29dafb3bbd7$var$$k(d);
                a = $e8dfc29dafb3bbd7$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $e8dfc29dafb3bbd7$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $e8dfc29dafb3bbd7$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $e8dfc29dafb3bbd7$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $e8dfc29dafb3bbd7$var$aj(null, b, d, $e8dfc29dafb3bbd7$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($e8dfc29dafb3bbd7$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $e8dfc29dafb3bbd7$var$lj(b);
                if (null === a) throw Error($e8dfc29dafb3bbd7$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $e8dfc29dafb3bbd7$var$bh(a, b);
                $e8dfc29dafb3bbd7$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $e8dfc29dafb3bbd7$var$Ki(Error($e8dfc29dafb3bbd7$var$p(423)), b);
                        b = $e8dfc29dafb3bbd7$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $e8dfc29dafb3bbd7$var$Ki(Error($e8dfc29dafb3bbd7$var$p(424)), b);
                        b = $e8dfc29dafb3bbd7$var$mj(a, b, d, c, e);
                        break a;
                    } else for($e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(b.stateNode.containerInfo.firstChild), $e8dfc29dafb3bbd7$var$xg = b, $e8dfc29dafb3bbd7$var$I = !0, $e8dfc29dafb3bbd7$var$zg = null, c = $e8dfc29dafb3bbd7$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $e8dfc29dafb3bbd7$var$Ig();
                    if (d === e) {
                        b = $e8dfc29dafb3bbd7$var$$i(a, b, c);
                        break a;
                    }
                    $e8dfc29dafb3bbd7$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $e8dfc29dafb3bbd7$var$Kh(b), null === a && $e8dfc29dafb3bbd7$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $e8dfc29dafb3bbd7$var$Ef(d, e) ? g = null : null !== f && $e8dfc29dafb3bbd7$var$Ef(d, f) && (b.flags |= 32), $e8dfc29dafb3bbd7$var$hj(a, b), $e8dfc29dafb3bbd7$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $e8dfc29dafb3bbd7$var$Eg(b), null;
        case 13:
            return $e8dfc29dafb3bbd7$var$pj(a, b, c);
        case 4:
            return $e8dfc29dafb3bbd7$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $e8dfc29dafb3bbd7$var$Bh(b, null, d, c) : $e8dfc29dafb3bbd7$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$Zi(a, b, d, e, c);
        case 7:
            return $e8dfc29dafb3bbd7$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $e8dfc29dafb3bbd7$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $e8dfc29dafb3bbd7$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($e8dfc29dafb3bbd7$var$He(f.value, g)) {
                        if (f.children === e.children && !$e8dfc29dafb3bbd7$var$Wf.current) {
                            b = $e8dfc29dafb3bbd7$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $e8dfc29dafb3bbd7$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $e8dfc29dafb3bbd7$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($e8dfc29dafb3bbd7$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $e8dfc29dafb3bbd7$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $e8dfc29dafb3bbd7$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $e8dfc29dafb3bbd7$var$Tg(b, c), e = $e8dfc29dafb3bbd7$var$Vg(e), d = d(e), b.flags |= 1, $e8dfc29dafb3bbd7$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $e8dfc29dafb3bbd7$var$Lg(d, b.pendingProps), e = $e8dfc29dafb3bbd7$var$Lg(d.type, e), $e8dfc29dafb3bbd7$var$aj(a, b, d, e, c);
        case 15:
            return $e8dfc29dafb3bbd7$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$jj(a, b), b.tag = 1, $e8dfc29dafb3bbd7$var$Zf(d) ? (a = !0, $e8dfc29dafb3bbd7$var$cg(b)) : a = !1, $e8dfc29dafb3bbd7$var$Tg(b, c), $e8dfc29dafb3bbd7$var$ph(b, d, e), $e8dfc29dafb3bbd7$var$rh(b, d, e, c), $e8dfc29dafb3bbd7$var$kj(null, b, d, !0, a, c);
        case 19:
            return $e8dfc29dafb3bbd7$var$yj(a, b, c);
        case 22:
            return $e8dfc29dafb3bbd7$var$ej(a, b, c);
    }
    throw Error($e8dfc29dafb3bbd7$var$p(156, b.tag));
};
function $e8dfc29dafb3bbd7$var$Gk(a, b) {
    return $e8dfc29dafb3bbd7$var$ac(a, b);
}
function $e8dfc29dafb3bbd7$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $e8dfc29dafb3bbd7$var$Bg(a, b, c, d) {
    return new $e8dfc29dafb3bbd7$var$al(a, b, c, d);
}
function $e8dfc29dafb3bbd7$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $e8dfc29dafb3bbd7$var$$k(a) {
    if ("function" === typeof a) return $e8dfc29dafb3bbd7$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $e8dfc29dafb3bbd7$var$Da) return 11;
        if (a === $e8dfc29dafb3bbd7$var$Ga) return 14;
    }
    return 2;
}
function $e8dfc29dafb3bbd7$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $e8dfc29dafb3bbd7$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $e8dfc29dafb3bbd7$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $e8dfc29dafb3bbd7$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $e8dfc29dafb3bbd7$var$ya:
            return $e8dfc29dafb3bbd7$var$Ah(c.children, e, f, b);
        case $e8dfc29dafb3bbd7$var$za:
            g = 8;
            e |= 8;
            break;
        case $e8dfc29dafb3bbd7$var$Aa:
            return a = $e8dfc29dafb3bbd7$var$Bg(12, c, b, e | 2), a.elementType = $e8dfc29dafb3bbd7$var$Aa, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Ea:
            return a = $e8dfc29dafb3bbd7$var$Bg(13, c, b, e), a.elementType = $e8dfc29dafb3bbd7$var$Ea, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Fa:
            return a = $e8dfc29dafb3bbd7$var$Bg(19, c, b, e), a.elementType = $e8dfc29dafb3bbd7$var$Fa, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Ia:
            return $e8dfc29dafb3bbd7$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $e8dfc29dafb3bbd7$var$Ba:
                    g = 10;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ca:
                    g = 9;
                    break a;
                case $e8dfc29dafb3bbd7$var$Da:
                    g = 11;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ga:
                    g = 14;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($e8dfc29dafb3bbd7$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $e8dfc29dafb3bbd7$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $e8dfc29dafb3bbd7$var$Ah(a, b, c, d) {
    a = $e8dfc29dafb3bbd7$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $e8dfc29dafb3bbd7$var$qj(a, b, c, d) {
    a = $e8dfc29dafb3bbd7$var$Bg(22, a, d, b);
    a.elementType = $e8dfc29dafb3bbd7$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $e8dfc29dafb3bbd7$var$xh(a, b, c) {
    a = $e8dfc29dafb3bbd7$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $e8dfc29dafb3bbd7$var$zh(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $e8dfc29dafb3bbd7$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $e8dfc29dafb3bbd7$var$zc(0);
    this.expirationTimes = $e8dfc29dafb3bbd7$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $e8dfc29dafb3bbd7$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $e8dfc29dafb3bbd7$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $e8dfc29dafb3bbd7$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $e8dfc29dafb3bbd7$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $e8dfc29dafb3bbd7$var$ah(f);
    return a;
}
function $e8dfc29dafb3bbd7$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $e8dfc29dafb3bbd7$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $e8dfc29dafb3bbd7$var$el(a) {
    if (!a) return $e8dfc29dafb3bbd7$var$Vf;
    a = a._reactInternals;
    a: {
        if ($e8dfc29dafb3bbd7$var$Vb(a) !== a || 1 !== a.tag) throw Error($e8dfc29dafb3bbd7$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($e8dfc29dafb3bbd7$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($e8dfc29dafb3bbd7$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($e8dfc29dafb3bbd7$var$Zf(c)) return $e8dfc29dafb3bbd7$var$bg(a, c, b);
    }
    return b;
}
function $e8dfc29dafb3bbd7$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $e8dfc29dafb3bbd7$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $e8dfc29dafb3bbd7$var$el(null);
    c = a.current;
    d = $e8dfc29dafb3bbd7$var$L();
    e = $e8dfc29dafb3bbd7$var$lh(c);
    f = $e8dfc29dafb3bbd7$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $e8dfc29dafb3bbd7$var$dh(c, f, e);
    a.current.lanes = e;
    $e8dfc29dafb3bbd7$var$Ac(a, e, d);
    $e8dfc29dafb3bbd7$var$Ek(a, d);
    return a;
}
function $e8dfc29dafb3bbd7$var$gl(a, b, c, d) {
    var e = b.current, f = $e8dfc29dafb3bbd7$var$L(), g = $e8dfc29dafb3bbd7$var$lh(e);
    c = $e8dfc29dafb3bbd7$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $e8dfc29dafb3bbd7$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $e8dfc29dafb3bbd7$var$dh(e, b, g);
    null !== a && ($e8dfc29dafb3bbd7$var$mh(a, e, g, f), $e8dfc29dafb3bbd7$var$eh(a, e, g));
    return g;
}
function $e8dfc29dafb3bbd7$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $e8dfc29dafb3bbd7$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $e8dfc29dafb3bbd7$var$jl(a, b) {
    $e8dfc29dafb3bbd7$var$il(a, b);
    (a = a.alternate) && $e8dfc29dafb3bbd7$var$il(a, b);
}
function $e8dfc29dafb3bbd7$var$kl() {
    return null;
}
var $e8dfc29dafb3bbd7$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $e8dfc29dafb3bbd7$var$ml(a) {
    this._internalRoot = a;
}
$e8dfc29dafb3bbd7$var$nl.prototype.render = $e8dfc29dafb3bbd7$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($e8dfc29dafb3bbd7$var$p(409));
    $e8dfc29dafb3bbd7$var$gl(a, b, null, null);
};
$e8dfc29dafb3bbd7$var$nl.prototype.unmount = $e8dfc29dafb3bbd7$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $e8dfc29dafb3bbd7$var$Sk(function() {
            $e8dfc29dafb3bbd7$var$gl(null, a, null, null);
        });
        b[$e8dfc29dafb3bbd7$var$uf] = null;
    }
};
function $e8dfc29dafb3bbd7$var$nl(a) {
    this._internalRoot = a;
}
$e8dfc29dafb3bbd7$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $e8dfc29dafb3bbd7$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $e8dfc29dafb3bbd7$var$Qc.length && 0 !== b && b < $e8dfc29dafb3bbd7$var$Qc[c].priority; c++);
        $e8dfc29dafb3bbd7$var$Qc.splice(c, 0, a);
        0 === c && $e8dfc29dafb3bbd7$var$Vc(a);
    }
};
function $e8dfc29dafb3bbd7$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $e8dfc29dafb3bbd7$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $e8dfc29dafb3bbd7$var$ql() {}
function $e8dfc29dafb3bbd7$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $e8dfc29dafb3bbd7$var$hl(g);
                f.call(a);
            };
        }
        var g = $e8dfc29dafb3bbd7$var$fl(b, d, a, 0, null, !1, !1, "", $e8dfc29dafb3bbd7$var$ql);
        a._reactRootContainer = g;
        a[$e8dfc29dafb3bbd7$var$uf] = g.current;
        $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
        $e8dfc29dafb3bbd7$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $e8dfc29dafb3bbd7$var$hl(k);
            h.call(a);
        };
    }
    var k = $e8dfc29dafb3bbd7$var$cl(a, 0, !1, null, null, !1, !1, "", $e8dfc29dafb3bbd7$var$ql);
    a._reactRootContainer = k;
    a[$e8dfc29dafb3bbd7$var$uf] = k.current;
    $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
    $e8dfc29dafb3bbd7$var$Sk(function() {
        $e8dfc29dafb3bbd7$var$gl(b, k, c, d);
    });
    return k;
}
function $e8dfc29dafb3bbd7$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $e8dfc29dafb3bbd7$var$hl(g);
                h.call(a);
            };
        }
        $e8dfc29dafb3bbd7$var$gl(b, g, a, e);
    } else g = $e8dfc29dafb3bbd7$var$rl(c, b, a, e, d);
    return $e8dfc29dafb3bbd7$var$hl(g);
}
$e8dfc29dafb3bbd7$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $e8dfc29dafb3bbd7$var$tc(b.pendingLanes);
                0 !== c && ($e8dfc29dafb3bbd7$var$Cc(b, c | 1), $e8dfc29dafb3bbd7$var$Ek(b, $e8dfc29dafb3bbd7$var$B()), 0 === ($e8dfc29dafb3bbd7$var$K & 6) && ($e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$jg()));
            }
            break;
        case 13:
            $e8dfc29dafb3bbd7$var$Sk(function() {
                var b = $e8dfc29dafb3bbd7$var$Zg(a, 1);
                if (null !== b) {
                    var c = $e8dfc29dafb3bbd7$var$L();
                    $e8dfc29dafb3bbd7$var$mh(b, a, 1, c);
                }
            }), $e8dfc29dafb3bbd7$var$jl(a, 1);
    }
};
$e8dfc29dafb3bbd7$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $e8dfc29dafb3bbd7$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $e8dfc29dafb3bbd7$var$L();
            $e8dfc29dafb3bbd7$var$mh(b, a, 134217728, c);
        }
        $e8dfc29dafb3bbd7$var$jl(a, 134217728);
    }
};
$e8dfc29dafb3bbd7$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $e8dfc29dafb3bbd7$var$lh(a), c = $e8dfc29dafb3bbd7$var$Zg(a, b);
        if (null !== c) {
            var d = $e8dfc29dafb3bbd7$var$L();
            $e8dfc29dafb3bbd7$var$mh(c, a, b, d);
        }
        $e8dfc29dafb3bbd7$var$jl(a, b);
    }
};
$e8dfc29dafb3bbd7$var$Hc = function() {
    return $e8dfc29dafb3bbd7$var$C;
};
$e8dfc29dafb3bbd7$var$Ic = function(a, b) {
    var c = $e8dfc29dafb3bbd7$var$C;
    try {
        return $e8dfc29dafb3bbd7$var$C = a, b();
    } finally{
        $e8dfc29dafb3bbd7$var$C = c;
    }
};
$e8dfc29dafb3bbd7$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $e8dfc29dafb3bbd7$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $e8dfc29dafb3bbd7$var$Db(d);
                        if (!e) throw Error($e8dfc29dafb3bbd7$var$p(90));
                        $e8dfc29dafb3bbd7$var$Wa(d);
                        $e8dfc29dafb3bbd7$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $e8dfc29dafb3bbd7$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $e8dfc29dafb3bbd7$var$fb(a, !!c.multiple, b, !1);
    }
};
$e8dfc29dafb3bbd7$var$Gb = $e8dfc29dafb3bbd7$var$Rk;
$e8dfc29dafb3bbd7$var$Hb = $e8dfc29dafb3bbd7$var$Sk;
var $e8dfc29dafb3bbd7$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $e8dfc29dafb3bbd7$var$Cb,
        $e8dfc29dafb3bbd7$var$ue,
        $e8dfc29dafb3bbd7$var$Db,
        $e8dfc29dafb3bbd7$var$Eb,
        $e8dfc29dafb3bbd7$var$Fb,
        $e8dfc29dafb3bbd7$var$Rk
    ]
}, $e8dfc29dafb3bbd7$var$ul = {
    findFiberByHostInstance: $e8dfc29dafb3bbd7$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $e8dfc29dafb3bbd7$var$vl = {
    bundleType: $e8dfc29dafb3bbd7$var$ul.bundleType,
    version: $e8dfc29dafb3bbd7$var$ul.version,
    rendererPackageName: $e8dfc29dafb3bbd7$var$ul.rendererPackageName,
    rendererConfig: $e8dfc29dafb3bbd7$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $e8dfc29dafb3bbd7$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $e8dfc29dafb3bbd7$var$ul.findFiberByHostInstance || $e8dfc29dafb3bbd7$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $e8dfc29dafb3bbd7$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$e8dfc29dafb3bbd7$var$wl.isDisabled && $e8dfc29dafb3bbd7$var$wl.supportsFiber) try {
        $e8dfc29dafb3bbd7$var$kc = $e8dfc29dafb3bbd7$var$wl.inject($e8dfc29dafb3bbd7$var$vl), $e8dfc29dafb3bbd7$var$lc = $e8dfc29dafb3bbd7$var$wl;
    } catch (a) {}
}
$e8dfc29dafb3bbd7$export$ae55be85d98224ed = $e8dfc29dafb3bbd7$var$tl;
$e8dfc29dafb3bbd7$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$e8dfc29dafb3bbd7$var$ol(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$dl(a, b, null, c);
};
$e8dfc29dafb3bbd7$export$882461b6382ed46c = function(a, b) {
    if (!$e8dfc29dafb3bbd7$var$ol(a)) throw Error($e8dfc29dafb3bbd7$var$p(299));
    var c = !1, d = "", e = $e8dfc29dafb3bbd7$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $e8dfc29dafb3bbd7$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$e8dfc29dafb3bbd7$var$uf] = b.current;
    $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $e8dfc29dafb3bbd7$var$ml(b);
};
$e8dfc29dafb3bbd7$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($e8dfc29dafb3bbd7$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($e8dfc29dafb3bbd7$var$p(268, a));
    }
    a = $e8dfc29dafb3bbd7$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4 = function(a) {
    return $e8dfc29dafb3bbd7$var$Sk(a);
};
$e8dfc29dafb3bbd7$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$pl(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$sl(null, a, b, !0, c);
};
$e8dfc29dafb3bbd7$export$757ceba2d55c277e = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$ol(a)) throw Error($e8dfc29dafb3bbd7$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $e8dfc29dafb3bbd7$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $e8dfc29dafb3bbd7$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$e8dfc29dafb3bbd7$var$uf] = b.current;
    $e8dfc29dafb3bbd7$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $e8dfc29dafb3bbd7$var$nl(b);
};
$e8dfc29dafb3bbd7$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$pl(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$sl(null, a, b, !1, c);
};
$e8dfc29dafb3bbd7$export$502457920280e6be = function(a) {
    if (!$e8dfc29dafb3bbd7$var$pl(a)) throw Error($e8dfc29dafb3bbd7$var$p(40));
    return a._reactRootContainer ? ($e8dfc29dafb3bbd7$var$Sk(function() {
        $e8dfc29dafb3bbd7$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$e8dfc29dafb3bbd7$var$uf] = null;
        });
    }), !0) : !1;
};
$e8dfc29dafb3bbd7$export$c78a37762a8d58e1 = $e8dfc29dafb3bbd7$var$Rk;
$e8dfc29dafb3bbd7$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$e8dfc29dafb3bbd7$var$pl(c)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($e8dfc29dafb3bbd7$var$p(38));
    return $e8dfc29dafb3bbd7$var$sl(a, b, c, !1, d);
};
$e8dfc29dafb3bbd7$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("1c9zD", function(module, exports) {
'use strict';

module.exports = (parcelRequire("lffg4"));

});
parcelRegister("lffg4", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $f776d5a8b0cafef3$export$c4744153514ff05d; }, function (v) { return $f776d5a8b0cafef3$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7; }, function (v) { return $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $f776d5a8b0cafef3$export$e26fe2ed2fa76875; }, function (v) { return $f776d5a8b0cafef3$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $f776d5a8b0cafef3$export$502329bbf4b505b1; }, function (v) { return $f776d5a8b0cafef3$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $f776d5a8b0cafef3$export$6e3807111c4874c4; }, function (v) { return $f776d5a8b0cafef3$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $f776d5a8b0cafef3$export$c27134553091fb3a; }, function (v) { return $f776d5a8b0cafef3$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $f776d5a8b0cafef3$export$33ee1acdc04fd2a2; }, function (v) { return $f776d5a8b0cafef3$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $f776d5a8b0cafef3$export$b00a404bbd5edef2; }, function (v) { return $f776d5a8b0cafef3$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $f776d5a8b0cafef3$export$8352ce38b91d0c62; }, function (v) { return $f776d5a8b0cafef3$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $f776d5a8b0cafef3$export$d66a1c1c77bd778b; }, function (v) { return $f776d5a8b0cafef3$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $f776d5a8b0cafef3$export$d3dfb8e4810cb555; }, function (v) { return $f776d5a8b0cafef3$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $f776d5a8b0cafef3$export$839f9183b0465a69; }, function (v) { return $f776d5a8b0cafef3$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $f776d5a8b0cafef3$export$72fdf0e06517287b; }, function (v) { return $f776d5a8b0cafef3$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $f776d5a8b0cafef3$export$4b844e58a3e414b4; }, function (v) { return $f776d5a8b0cafef3$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $f776d5a8b0cafef3$export$816d2913ae6b83b1; }, function (v) { return $f776d5a8b0cafef3$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $f776d5a8b0cafef3$export$61bcfe829111a1d0; }, function (v) { return $f776d5a8b0cafef3$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $f776d5a8b0cafef3$export$7ee8c9beb337bc3f; }, function (v) { return $f776d5a8b0cafef3$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $f776d5a8b0cafef3$export$b5836b71941fa3ed; }, function (v) { return $f776d5a8b0cafef3$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $f776d5a8b0cafef3$export$cf845f2c119da08a; }, function (v) { return $f776d5a8b0cafef3$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f776d5a8b0cafef3$export$c4744153514ff05d;
var $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7;
var $f776d5a8b0cafef3$export$e26fe2ed2fa76875;
var $f776d5a8b0cafef3$export$502329bbf4b505b1;
var $f776d5a8b0cafef3$export$6e3807111c4874c4;
var $f776d5a8b0cafef3$export$c27134553091fb3a;
var $f776d5a8b0cafef3$export$33ee1acdc04fd2a2;
var $f776d5a8b0cafef3$export$b00a404bbd5edef2;
var $f776d5a8b0cafef3$export$8352ce38b91d0c62;
var $f776d5a8b0cafef3$export$d66a1c1c77bd778b;
var $f776d5a8b0cafef3$export$d3dfb8e4810cb555;
var $f776d5a8b0cafef3$export$839f9183b0465a69;
var $f776d5a8b0cafef3$export$72fdf0e06517287b;
var $f776d5a8b0cafef3$export$4b844e58a3e414b4;
var $f776d5a8b0cafef3$export$816d2913ae6b83b1;
var $f776d5a8b0cafef3$export$61bcfe829111a1d0;
var $f776d5a8b0cafef3$export$7ee8c9beb337bc3f;
var $f776d5a8b0cafef3$export$b5836b71941fa3ed;
var $f776d5a8b0cafef3$export$cf845f2c119da08a;
'use strict';
function $f776d5a8b0cafef3$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $f776d5a8b0cafef3$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $f776d5a8b0cafef3$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $f776d5a8b0cafef3$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $f776d5a8b0cafef3$var$g(C, c)) n < e && 0 > $f776d5a8b0cafef3$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $f776d5a8b0cafef3$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $f776d5a8b0cafef3$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $f776d5a8b0cafef3$var$l = performance;
    $f776d5a8b0cafef3$export$c4744153514ff05d = function() {
        return $f776d5a8b0cafef3$var$l.now();
    };
} else {
    var $f776d5a8b0cafef3$var$p = Date, $f776d5a8b0cafef3$var$q = $f776d5a8b0cafef3$var$p.now();
    $f776d5a8b0cafef3$export$c4744153514ff05d = function() {
        return $f776d5a8b0cafef3$var$p.now() - $f776d5a8b0cafef3$var$q;
    };
}
var $f776d5a8b0cafef3$var$r = [], $f776d5a8b0cafef3$var$t = [], $f776d5a8b0cafef3$var$u = 1, $f776d5a8b0cafef3$var$v = null, $f776d5a8b0cafef3$var$y = 3, $f776d5a8b0cafef3$var$z = !1, $f776d5a8b0cafef3$var$A = !1, $f776d5a8b0cafef3$var$B = !1, $f776d5a8b0cafef3$var$D = "function" === typeof setTimeout ? setTimeout : null, $f776d5a8b0cafef3$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $f776d5a8b0cafef3$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $f776d5a8b0cafef3$var$G(a) {
    for(var b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t); null !== b;){
        if (null === b.callback) $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$t);
        else if (b.startTime <= a) $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$t), b.sortIndex = b.expirationTime, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$r, b);
        else break;
        b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
    }
}
function $f776d5a8b0cafef3$var$H(a) {
    $f776d5a8b0cafef3$var$B = !1;
    $f776d5a8b0cafef3$var$G(a);
    if (!$f776d5a8b0cafef3$var$A) {
        if (null !== $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r)) $f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J);
        else {
            var b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
            null !== b && $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, b.startTime - a);
        }
    }
}
function $f776d5a8b0cafef3$var$J(a, b) {
    $f776d5a8b0cafef3$var$A = !1;
    $f776d5a8b0cafef3$var$B && ($f776d5a8b0cafef3$var$B = !1, $f776d5a8b0cafef3$var$E($f776d5a8b0cafef3$var$L), $f776d5a8b0cafef3$var$L = -1);
    $f776d5a8b0cafef3$var$z = !0;
    var c = $f776d5a8b0cafef3$var$y;
    try {
        $f776d5a8b0cafef3$var$G(b);
        for($f776d5a8b0cafef3$var$v = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r); null !== $f776d5a8b0cafef3$var$v && (!($f776d5a8b0cafef3$var$v.expirationTime > b) || a && !$f776d5a8b0cafef3$var$M());){
            var d = $f776d5a8b0cafef3$var$v.callback;
            if ("function" === typeof d) {
                $f776d5a8b0cafef3$var$v.callback = null;
                $f776d5a8b0cafef3$var$y = $f776d5a8b0cafef3$var$v.priorityLevel;
                var e = d($f776d5a8b0cafef3$var$v.expirationTime <= b);
                b = $f776d5a8b0cafef3$export$c4744153514ff05d();
                "function" === typeof e ? $f776d5a8b0cafef3$var$v.callback = e : $f776d5a8b0cafef3$var$v === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r) && $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$r);
                $f776d5a8b0cafef3$var$G(b);
            } else $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$r);
            $f776d5a8b0cafef3$var$v = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r);
        }
        if (null !== $f776d5a8b0cafef3$var$v) var w = !0;
        else {
            var m = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
            null !== m && $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $f776d5a8b0cafef3$var$v = null, $f776d5a8b0cafef3$var$y = c, $f776d5a8b0cafef3$var$z = !1;
    }
}
var $f776d5a8b0cafef3$var$N = !1, $f776d5a8b0cafef3$var$O = null, $f776d5a8b0cafef3$var$L = -1, $f776d5a8b0cafef3$var$P = 5, $f776d5a8b0cafef3$var$Q = -1;
function $f776d5a8b0cafef3$var$M() {
    return $f776d5a8b0cafef3$export$c4744153514ff05d() - $f776d5a8b0cafef3$var$Q < $f776d5a8b0cafef3$var$P ? !1 : !0;
}
function $f776d5a8b0cafef3$var$R() {
    if (null !== $f776d5a8b0cafef3$var$O) {
        var a = $f776d5a8b0cafef3$export$c4744153514ff05d();
        $f776d5a8b0cafef3$var$Q = a;
        var b = !0;
        try {
            b = $f776d5a8b0cafef3$var$O(!0, a);
        } finally{
            b ? $f776d5a8b0cafef3$var$S() : ($f776d5a8b0cafef3$var$N = !1, $f776d5a8b0cafef3$var$O = null);
        }
    } else $f776d5a8b0cafef3$var$N = !1;
}
var $f776d5a8b0cafef3$var$S;
if ("function" === typeof $f776d5a8b0cafef3$var$F) $f776d5a8b0cafef3$var$S = function() {
    $f776d5a8b0cafef3$var$F($f776d5a8b0cafef3$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $f776d5a8b0cafef3$var$T = new MessageChannel, $f776d5a8b0cafef3$var$U = $f776d5a8b0cafef3$var$T.port2;
    $f776d5a8b0cafef3$var$T.port1.onmessage = $f776d5a8b0cafef3$var$R;
    $f776d5a8b0cafef3$var$S = function() {
        $f776d5a8b0cafef3$var$U.postMessage(null);
    };
} else $f776d5a8b0cafef3$var$S = function() {
    $f776d5a8b0cafef3$var$D($f776d5a8b0cafef3$var$R, 0);
};
function $f776d5a8b0cafef3$var$I(a) {
    $f776d5a8b0cafef3$var$O = a;
    $f776d5a8b0cafef3$var$N || ($f776d5a8b0cafef3$var$N = !0, $f776d5a8b0cafef3$var$S());
}
function $f776d5a8b0cafef3$var$K(a, b) {
    $f776d5a8b0cafef3$var$L = $f776d5a8b0cafef3$var$D(function() {
        a($f776d5a8b0cafef3$export$c4744153514ff05d());
    }, b);
}
$f776d5a8b0cafef3$export$3e506c1ccc9cc1a7 = 5;
$f776d5a8b0cafef3$export$e26fe2ed2fa76875 = 1;
$f776d5a8b0cafef3$export$502329bbf4b505b1 = 4;
$f776d5a8b0cafef3$export$6e3807111c4874c4 = 3;
$f776d5a8b0cafef3$export$c27134553091fb3a = null;
$f776d5a8b0cafef3$export$33ee1acdc04fd2a2 = 2;
$f776d5a8b0cafef3$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$f776d5a8b0cafef3$export$8352ce38b91d0c62 = function() {
    $f776d5a8b0cafef3$var$A || $f776d5a8b0cafef3$var$z || ($f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J));
};
$f776d5a8b0cafef3$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $f776d5a8b0cafef3$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$f776d5a8b0cafef3$export$d3dfb8e4810cb555 = function() {
    return $f776d5a8b0cafef3$var$y;
};
$f776d5a8b0cafef3$export$839f9183b0465a69 = function() {
    return $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r);
};
$f776d5a8b0cafef3$export$72fdf0e06517287b = function(a) {
    switch($f776d5a8b0cafef3$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $f776d5a8b0cafef3$var$y;
    }
    var c = $f776d5a8b0cafef3$var$y;
    $f776d5a8b0cafef3$var$y = b;
    try {
        return a();
    } finally{
        $f776d5a8b0cafef3$var$y = c;
    }
};
$f776d5a8b0cafef3$export$4b844e58a3e414b4 = function() {};
$f776d5a8b0cafef3$export$816d2913ae6b83b1 = function() {};
$f776d5a8b0cafef3$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $f776d5a8b0cafef3$var$y;
    $f776d5a8b0cafef3$var$y = a;
    try {
        return b();
    } finally{
        $f776d5a8b0cafef3$var$y = c;
    }
};
$f776d5a8b0cafef3$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $f776d5a8b0cafef3$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $f776d5a8b0cafef3$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$t, a), null === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r) && a === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t) && ($f776d5a8b0cafef3$var$B ? ($f776d5a8b0cafef3$var$E($f776d5a8b0cafef3$var$L), $f776d5a8b0cafef3$var$L = -1) : $f776d5a8b0cafef3$var$B = !0, $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, c - d))) : (a.sortIndex = e, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$r, a), $f776d5a8b0cafef3$var$A || $f776d5a8b0cafef3$var$z || ($f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J)));
    return a;
};
$f776d5a8b0cafef3$export$b5836b71941fa3ed = $f776d5a8b0cafef3$var$M;
$f776d5a8b0cafef3$export$cf845f2c119da08a = function(a) {
    var b = $f776d5a8b0cafef3$var$y;
    return function() {
        var c = $f776d5a8b0cafef3$var$y;
        $f776d5a8b0cafef3$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $f776d5a8b0cafef3$var$y = c;
        }
    };
};

});



parcelRegister("3G7m1", function(module, exports) {

$parcel$export(module.exports, "MinutesCalculate", function () { return $2adaffbfc762779f$export$911633b0d191f231; });
$parcel$export(module.exports, "linkName", function () { return $2adaffbfc762779f$export$38ef5288c127d9ef; });
$parcel$export(module.exports, "titleToSlug", function () { return $2adaffbfc762779f$export$dfe6b77737fd172b; });
$parcel$export(module.exports, "capitalized1LetterS", function () { return $2adaffbfc762779f$export$4f5fea94b7868da9; });
$parcel$export(module.exports, "uniqueId", function () { return $2adaffbfc762779f$export$8b15d37bc3f197d4; });
$parcel$export(module.exports, "timeSince", function () { return $2adaffbfc762779f$export$79c01495e306fbf5; });
$parcel$export(module.exports, "calculatePercentagestats", function () { return $2adaffbfc762779f$export$fd5a4de38173f26e; });
$parcel$export(module.exports, "getNextSevenDays", function () { return $2adaffbfc762779f$export$a794d0e6e0892e2; });
$parcel$export(module.exports, "getCurrentDate", function () { return $2adaffbfc762779f$export$adaf307e533580e2; });
$parcel$export(module.exports, "processMyArr", function () { return $2adaffbfc762779f$export$74cfd3024979854f; });
$parcel$export(module.exports, "GetMatchScores", function () { return $2adaffbfc762779f$export$703a17b63fdaca7; });
$parcel$export(module.exports, "ToLowerText", function () { return $2adaffbfc762779f$export$283bbbdc5d2f2467; });
$parcel$export(module.exports, "GetTennisMatchStatus", function () { return $2adaffbfc762779f$export$f3b4cb105c8766c4; });
$parcel$export(module.exports, "CricketScore", function () { return $2adaffbfc762779f$export$7de91069d32803ba; });
$parcel$export(module.exports, "renderBasketballScores", function () { return $2adaffbfc762779f$export$3e3da234307ba07; });
$parcel$export(module.exports, "renderTennisScores", function () { return $2adaffbfc762779f$export$e287e59d2f3a6657; });
$parcel$export(module.exports, "renderCricketScores", function () { return $2adaffbfc762779f$export$c7ae84d7cfd5dc77; });
$parcel$export(module.exports, "getMatchInfo", function () { return $2adaffbfc762779f$export$dd06fda150af72dd; });
$parcel$export(module.exports, "convertDateTime", function () { return $2adaffbfc762779f$export$ba2fe755e108442e; });
$parcel$export(module.exports, "getScoreColor", function () { return $2adaffbfc762779f$export$76c862645cb05a55; });
$parcel$export(module.exports, "getMatchOutcome", function () { return $2adaffbfc762779f$export$6dec73d134243c86; });
$parcel$export(module.exports, "convertDate", function () { return $2adaffbfc762779f$export$3c2ab2c4f3202ceb; });
$parcel$export(module.exports, "getUrlSport", function () { return $2adaffbfc762779f$export$dcd09c90f4315579; });
$parcel$export(module.exports, "renderStatusTag", function () { return $2adaffbfc762779f$export$36a8d11950c00217; });
$parcel$export(module.exports, "transformDataByRound", function () { return $2adaffbfc762779f$export$6d18514047be2b15; });
$parcel$export(module.exports, "seoBaseOpenMatchDetailUrl", function () { return $2adaffbfc762779f$export$758f8843ad513ce2; });
$parcel$export(module.exports, "getRemainingTimeInHoursMinutes", function () { return $2adaffbfc762779f$export$1a7aae38b68cb82f; });
$parcel$export(module.exports, "convertDateDMY", function () { return $2adaffbfc762779f$export$fadf22b1d08590b7; });
$parcel$export(module.exports, "getAgeString", function () { return $2adaffbfc762779f$export$8ae9e67caded8da1; });
$parcel$export(module.exports, "teamLeagueInfoUrl", function () { return $2adaffbfc762779f$export$87b6ac566d1db65d; });
$parcel$export(module.exports, "makeDateUrl", function () { return $2adaffbfc762779f$export$d796689f978a3cea; });
$parcel$export(module.exports, "normalizeSport", function () { return $2adaffbfc762779f$export$cf176c57f7c8ba64; });
$parcel$export(module.exports, "buildTabsList", function () { return $2adaffbfc762779f$export$8e95cad8ca9d533; });
$parcel$export(module.exports, "getClassForResult", function () { return $2adaffbfc762779f$export$262e6583a2649515; });
$parcel$export(module.exports, "getTabsData", function () { return $2adaffbfc762779f$export$a4f015e969d19934; });
$parcel$export(module.exports, "getImageId", function () { return $2adaffbfc762779f$export$8aaf31f1731561fd; });
$parcel$export(module.exports, "getImageUrl", function () { return $2adaffbfc762779f$export$492f76f65bf1bced; });
$parcel$export(module.exports, "getMatchOutcomeClass", function () { return $2adaffbfc762779f$export$3029e69183064c84; });
$parcel$export(module.exports, "navigateToMatch", function () { return $2adaffbfc762779f$export$7bf8c034d5ab1d9e; });
$parcel$export(module.exports, "navigateToLeague", function () { return $2adaffbfc762779f$export$6bb93941aebe85b4; });
$parcel$export(module.exports, "extractScores", function () { return $2adaffbfc762779f$export$3c50dd3ed25de7ac; });
$parcel$export(module.exports, "renderScores", function () { return $2adaffbfc762779f$export$ef3af78ca19353c4; });
$parcel$export(module.exports, "getMatchImageUrl", function () { return $2adaffbfc762779f$export$3a445a7ee2bd69b6; });
$parcel$export(module.exports, "updateMatches", function () { return $2adaffbfc762779f$export$8dc10eaacfa1f110; });
$parcel$export(module.exports, "Icon", function () { return $2adaffbfc762779f$export$f04a61298a47a40f; });
$parcel$export(module.exports, "calculateWinner", function () { return $2adaffbfc762779f$export$a45c37fa7763b745; });
$parcel$export(module.exports, "getTeamLogos", function () { return $2adaffbfc762779f$export$a6d135921f70703; });
$parcel$export(module.exports, "getPredictionWidth", function () { return $2adaffbfc762779f$export$bf86bc1cfd09264; });
$parcel$export(module.exports, "sortByForm", function () { return $2adaffbfc762779f$export$a78037336ff8885b; });

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $kybuc = parcelRequire("kybuc");

var $ba5nK = parcelRequire("ba5nK");

var $R8nvx = parcelRequire("R8nvx");
const $2adaffbfc762779f$export$911633b0d191f231 = (statusName, statusUpdatedDateTime, interruptedMinutes, minutes)=>{
    const s = statusName?.toLowerCase();
    // Handle no status
    if (!s) return minutes === 'Finished' ? 'FT' : minutes || '';
    // Fix: compare against lowercased value
    if (s === 'half time') return 'HT';
    // Parse time robustly (avoid fragile string concat of offsets)
    const statusTime = $2adaffbfc762779f$var$safeParseDate(statusUpdatedDateTime);
    if (!statusTime) {
        // Fallback to given minutes when we can't parse a time
        const num = Number(minutes);
        if (!Number.isNaN(num) && num > 0) return num;
        if (typeof minutes === 'string') {
            if (minutes === 'Finished') return 'FT';
            if (minutes.includes('+')) return minutes;
            return minutes;
        }
        return '';
    }
    const diffMs = Date.now() - statusTime.getTime();
    // If status time is in the future, trust provided minutes (e.g., pre-kickoff or delayed)
    if (diffMs < 0) {
        const num = Number(minutes);
        return !Number.isNaN(num) ? num : minutes?.includes('+') ? minutes : '';
    }
    const extra = Number.parseInt(interruptedMinutes ?? 0, 10) || 0;
    // Correct football minute math: floor + 1
    const elapsedWhole = Math.floor(diffMs / 60000) + extra;
    const tick = elapsedWhole + 1; // 0–59s -> 1'
    // Map by period with correct bases & caps
    if (s === '1st half') return tick > 45 ? '45+' : tick;
    if (s === '2nd half') {
        const m = 45 + tick; // 0' of 2H -> 46'
        return m > 90 ? '90+' : m;
    }
    if (s === 'et 1st half') {
        const m = 90 + tick; // 0' of ET1 -> 91'
        return m > 105 ? '105+' : m;
    }
    if (s === 'et 2nd half') {
        const m = 105 + tick; // 0' of ET2 -> 106'
        return m > 120 ? '120+' : m;
    }
    if (s === 'penalty') return '120+';
    // Unknown/other statuses
    return minutes || 'FT';
};
// Tries hard to parse common backend formats safely.
function $2adaffbfc762779f$var$safeParseDate(value) {
    if (!value) return null;
    if (value instanceof Date) return isNaN(value) ? null : value;
    if (typeof value === 'number') return new Date(value);
    if (typeof value === 'string') {
        // If already ISO-ish or has TZ, let Date handle it.
        const hasTZ = /[+-]\d\d:?\d\d$/.test(value) || value.endsWith('Z');
        const hasT = value.includes('T');
        if (hasTZ || hasT) {
            const d1 = new Date(value);
            if (!isNaN(d1)) return d1;
        }
        // Treat "YYYY-MM-DD HH:mm:ss" as UTC
        const isoGuess = value.replace(' ', 'T') + 'Z';
        const d2 = new Date(isoGuess);
        return isNaN(d2) ? null : d2;
    }
    return null;
}
function $2adaffbfc762779f$export$38ef5288c127d9ef(data) {
    if (!data) return "";
    return $2adaffbfc762779f$export$dfe6b77737fd172b(data?.toLowerCase().replace(/[\s/]+/g, "-")) || "";
}
const $2adaffbfc762779f$export$4f5fea94b7868da9 = (string)=>{
    if (!string) return;
    string = string?.replaceAll(/[_-]/g, " ");
    return string?.trim()?.replace(/\b\w/g, function(l) {
        return l.toLocaleUpperCase();
    });
};
const $2adaffbfc762779f$export$c3e0f520a0aee8fc = (numerator, denominator)=>{
    if (numerator === 0) return 0;
    const percentage = numerator / denominator * 100;
    if (percentage) return percentage || 0;
};
const $2adaffbfc762779f$export$8b15d37bc3f197d4 = (val = 1)=>{
    val = val + 1;
    let id = Date.now();
    id = id * val;
    return id;
};
const $2adaffbfc762779f$export$79c01495e306fbf5 = (date, dictionary)=>{
    const currentTime = new Date();
    const inputTime = new Date(date);
    const timeDiff = currentTime - inputTime;
    const units = [
        {
            label: `${dictionary?.year || "year"}`,
            value: 31536000000
        },
        {
            label: `${dictionary?.month || "month"}`,
            value: 2592000000
        },
        {
            label: `${dictionary?.day || "day"}`,
            value: 86400000
        },
        {
            label: `${dictionary?.hour || "hour"}`,
            value: 3600000
        },
        {
            label: `${dictionary?.minute || "minute"}`,
            value: 60000
        }
    ];
    for (const unit of units){
        const count = Math.floor(timeDiff / unit.value);
        if (count > 0) return count + " " + unit.label + (count === 1 ? ` ${dictionary?.ago || "ago"}` : `s ${dictionary?.ago || "ago"}`);
    }
    return "just now";
};
const $2adaffbfc762779f$export$fd5a4de38173f26e = (value1, value2)=>{
    if (value1 === 0) return 0;
    const value = value1 * 100 / (value1 + value2);
    if (value) return value;
};
const $2adaffbfc762779f$export$4e95ed0b9324844f = (val, ind, splitBy = "-")=>{
    const text = val?.split(splitBy);
    return text[ind] || "";
};
const $2adaffbfc762779f$export$404fa6a38fc53370 = (a, b)=>{
    const dateA = new Date(a.datetime);
    const dateB = new Date(b.datetime);
    return dateA - dateB;
};
const $2adaffbfc762779f$export$609cac6e414c0da5 = (messageData)=>{
    const origin = window.location.origin;
    window.opener.postMessage(messageData, origin);
};
const $2adaffbfc762779f$export$ffd5ae88df0dfdc4 = (pathname)=>{
    let sport = "football";
    if (pathname.includes("tennis")) sport = "tennis";
    else if (pathname.includes("cricket")) sport = "cricket";
    else if (pathname.includes("basketball")) sport = "basketball";
    else if (pathname.includes("rugby-union")) sport = "rugby-union";
    else if (pathname.includes("rugby-league")) sport = "rugby-league";
    return sport;
};
const $2adaffbfc762779f$export$2639aa624b50eb92 = (data, count = 10)=>{
    let totalMatchCount = 0;
    const newTournaments = [];
    for (const tournament of data){
        if (totalMatchCount >= count) break; // Stop if the total match count reaches count
        const remainingMatches = count - totalMatchCount;
        const matchesToAdd = Math.min(remainingMatches, tournament.matches.length);
        newTournaments.push({
            ...tournament,
            matches: tournament.matches.slice(0, matchesToAdd)
        });
        totalMatchCount += matchesToAdd;
    }
    return newTournaments || [];
};
const $2adaffbfc762779f$export$a596301272ec2a23 = (data, sport = "football", count = 15)=>{
    let totalMatchCount = 0;
    const newArrayOfObjects = [];
    for (const obj of data){
        if (totalMatchCount >= count) break;
        const matchesToAdd = Math?.min(count - totalMatchCount, obj?.matches.length);
        newArrayOfObjects.push({
            ...obj,
            matches: obj.matches.slice(0, matchesToAdd)
        });
        totalMatchCount += matchesToAdd;
    }
    let retObj;
    if (sport === "football" || sport === "rugby") retObj = {
        data: newArrayOfObjects || []
    };
    else retObj = newArrayOfObjects || [];
    return retObj;
};
const $2adaffbfc762779f$export$bd1197d7169db278 = (text)=>{
    let clas = "";
    if (text === "W") clas = "draw_win";
    else if (text === "L") clas = "draw_loss";
    else if (text === "D") clas = "draw_mos";
    return clas;
};
function $2adaffbfc762779f$export$83b14b5c4ad1618(url, changeKey, changeValue) {
    // Split the URL into base and parameters
    var urlParts = url.split("?");
    var baseUrl = urlParts[0];
    var params = urlParts[1];
    // Split the parameters into key-value pairs
    var paramList = params.split("&");
    var paramDict = {};
    // Populate the parameters into a dictionary
    paramList.forEach(function(param) {
        var keyValue = param.split("=");
        paramDict[keyValue[0]] = keyValue[1];
    });
    // Update the country parameter value
    paramDict[changeKey] = changeValue;
    // Construct the updated URL
    var updatedParams = Object.keys(paramDict).map(function(key) {
        return key + "=" + paramDict[key];
    }).join("&");
    var updatedURL = baseUrl + "?" + updatedParams;
    return updatedURL;
}
const $2adaffbfc762779f$export$dfe6b77737fd172b = (text)=>{
    if (!text) return "";
    const cleanedText = text.replace(/["',]/g, "") // remove quotes and commas
    .replace(/\//g, "-") // replace slashes with dashes
    .toLowerCase().trim().replace(/\s+/g, "-"); // replace spaces with dashes
    return encodeURIComponent(cleanedText);
};
function $2adaffbfc762779f$export$a794d0e6e0892e2(dictionary) {
    const daysOfWeek = [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ];
    // const monthsOfYear = [
    //   "Jan",
    //   "Feb",
    //   "Mar",
    //   "Apr",
    //   "May",
    //   "Jun",
    //   "Jul",
    //   "Aug",
    //   "Sep",
    //   "Oct",
    //   "Nov",
    //   "Dec",
    // ];
    const today = new Date(); // Get today's date
    const sevenDays = [];
    for(let i = -3; i <= 3; i++){
        const date = new Date(today); // Create a new date object for each day
        date.setDate(today.getDate() + i); // Increment the date by i days
        const dayOfWeek = daysOfWeek[date.getDay()]; // Get the day of the week
        const dayOfMonth = date.getDate(); // Get the day of the month
        // const month = monthsOfYear[date.getMonth()]; // Get the month abbreviation
        let formattedDay;
        if (i === 0) formattedDay = "Today";
        else formattedDay = dayOfWeek;
        const slugDate = date.toISOString().slice(0, 10); // Get the slug date format
        const formattedDate = {
            day: formattedDay,
            date: `${dayOfMonth}`,
            slugDate: slugDate
        }; // Format the date as an object
        sevenDays.push(formattedDate); // Add the formatted date object to the array
    }
    return sevenDays;
}
function $2adaffbfc762779f$export$adaf307e533580e2() {
    const today = new Date(); // Get today's date
    const year = today.getFullYear(); // Get the year
    let month = today.getMonth() + 1; // Get the month (0-indexed)
    let day = today.getDate(); // Get the day of the month
    // Add leading zeros if month or day is a single digit
    month = month < 10 ? "0" + month : month;
    day = day < 10 ? "0" + day : day;
    return `${year}-${month}-${day}`;
}
function $2adaffbfc762779f$export$74cfd3024979854f(MyArr) {
    MyArr = MyArr?.map((val)=>val?.toLowerCase());
    const hasSocial = MyArr?.includes("social");
    const hasNews = MyArr?.includes("News");
    const hasEvents = MyArr?.includes("events");
    const hasInfo = MyArr?.includes("info");
    if (hasSocial && hasNews) MyArr = MyArr?.filter((item)=>item !== "social");
    else if (hasSocial) MyArr = MyArr?.map((item)=>item === "social" ? "news" : item);
    else if (hasEvents) MyArr = MyArr.filter((item)=>item !== "events");
    else if (hasInfo) MyArr = MyArr?.filter((item)=>item !== "info");
    MyArr?.unshift("info");
    const filtered = Array.isArray(MyArr) ? MyArr.filter((item)=>item !== "summary") : [];
    return filtered;
}
function $2adaffbfc762779f$export$2885ece9b4181ddb(arr) {
    const array = $2adaffbfc762779f$export$74cfd3024979854f(arr);
    const filtered = Array.isArray(array) ? array.filter((item)=>item !== "summary") : [];
    return filtered;
}
const $2adaffbfc762779f$export$703a17b63fdaca7 = (scores, status)=>{
    let obj = {};
    let s1 = status === "1st set" ? scores?.find((x)=>$2adaffbfc762779f$export$283bbbdc5d2f2467(x?.ty) === "cs") : scores?.find((x)=>$2adaffbfc762779f$export$283bbbdc5d2f2467(x?.ty) === "1set");
    let s2 = status === "2nd set" ? scores?.find((x)=>$2adaffbfc762779f$export$283bbbdc5d2f2467(x?.ty) === "cs") : scores?.find((x)=>$2adaffbfc762779f$export$283bbbdc5d2f2467(x?.ty) === "2set");
    let s3 = status === "3rd set" ? scores?.find((x)=>$2adaffbfc762779f$export$283bbbdc5d2f2467(x?.ty) === "cs") : scores?.find((x)=>$2adaffbfc762779f$export$283bbbdc5d2f2467(x?.ty) === "3set");
    let s4 = status === "4th set" ? scores?.find((x)=>$2adaffbfc762779f$export$283bbbdc5d2f2467(x?.ty) === "cs") : scores?.find((x)=>$2adaffbfc762779f$export$283bbbdc5d2f2467(x?.ty) === "4set");
    let s5 = status === "5th set" ? scores?.find((x)=>$2adaffbfc762779f$export$283bbbdc5d2f2467(x?.ty) === "cs") : scores?.find((x)=>$2adaffbfc762779f$export$283bbbdc5d2f2467(x?.ty) === "5set");
    let game = scores?.find((x)=>$2adaffbfc762779f$export$283bbbdc5d2f2467(x?.ty) === "cp");
    obj.s1home = s1?.nm?.split(":")?.[0]?.trim();
    obj.s1away = s1?.nm?.split(":")?.[1]?.trim();
    obj.s1hometb = s1?.tb?.split(":")?.[0]?.trim();
    obj.s1awaytb = s1?.tb?.split(":")?.[1]?.trim();
    obj.s2home = s2?.nm?.split(":")?.[0]?.trim();
    obj.s2away = s2?.nm?.split(":")?.[1]?.trim();
    obj.s2hometb = s2?.tb?.split(":")?.[0]?.trim();
    obj.s2awaytb = s2?.tb?.split(":")?.[1]?.trim();
    obj.s3home = s3?.nm?.split(":")?.[0]?.trim();
    obj.s3away = s3?.nm?.split(":")?.[1]?.trim();
    obj.s3hometb = s3?.tb?.split(":")?.[0]?.trim();
    obj.s3awaytb = s3?.tb?.split(":")?.[1]?.trim();
    obj.s4home = s4?.nm?.split(":")?.[0]?.trim();
    obj.s4away = s4?.nm?.split(":")?.[1]?.trim();
    obj.s4hometb = s4?.tb?.split(":")?.[0]?.trim();
    obj.s4awaytb = s4?.tb?.split(":")?.[1]?.trim();
    obj.s5home = s5?.nm?.split(":")?.[0]?.trim();
    obj.s5away = s5?.nm?.split(":")?.[1]?.trim();
    obj.s5hometb = s5?.tb?.split(":")?.[0]?.trim();
    obj.s5awaytb = s5?.tb?.split(":")?.[1]?.trim();
    obj.gamehome = status !== "finished" ? game?.nm?.split(":")?.[0]?.trim() : null;
    obj.gameaway = status !== "finished" ? game?.nm?.split(":")?.[1]?.trim() : null;
    return obj;
};
const $2adaffbfc762779f$export$283bbbdc5d2f2467 = (text)=>{
    try {
        return text?.toLowerCase();
    } catch (error) {
        console.error("Error converting text to lowercase:", error);
    }
};
const $2adaffbfc762779f$export$f3b4cb105c8766c4 = (status, currentperiod)=>{
    const normalizedStatus = $2adaffbfc762779f$export$283bbbdc5d2f2467(status);
    const normalizedPeriod = $2adaffbfc762779f$export$283bbbdc5d2f2467(currentperiod);
    const validPeriods = [
        "1st set",
        "2nd set",
        "3rd set",
        "4th set",
        "5th set"
    ];
    const statusMap = {
        nsy: "nsy",
        "1st set": "1st set",
        "2nd set": "2nd set",
        "3rd set": "3rd set",
        "4th set": "4th set",
        "5th set": "5th set",
        finished: "finished"
    };
    if (statusMap[normalizedStatus]) return statusMap[normalizedStatus];
    if (normalizedStatus === "inprogress" && validPeriods.includes(normalizedPeriod)) return normalizedPeriod;
    return "unknown";
};
function $2adaffbfc762779f$export$7de91069d32803ba(input) {
    const parts = input.split("RR");
    return parts[0].trim();
}
function $2adaffbfc762779f$export$f2fd55569d110c3(data) {
    data = $2adaffbfc762779f$export$7de91069d32803ba(data);
    const [scores, overs] = data.split("(");
    const overValue = overs.replace(" Over)", "").trim();
    return {
        scores: scores.trim(),
        overs: overValue
    };
}
const $2adaffbfc762779f$export$3e3da234307ba07 = (scores, winner, live, cfs, fs)=>{
    // Split cfs into home and away scores
    const [homeCfs, awayCfs] = cfs ? cfs.split("-") : [
        "",
        ""
    ];
    const [totalHomeScore, totalAwayScore] = fs ? fs.split("-") : [
        "",
        ""
    ];
    return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
        children: live ? /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                    className: "game_score",
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                            className: `score bold`,
                            children: homeCfs
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                            className: `score bold`,
                            children: awayCfs
                        })
                    ]
                }),
                scores?.filter((score)=>score.hScore && score.aScore)?.map((score, index)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "set_score_wrp",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "score",
                                children: score.hScore
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "score",
                                children: score.aScore
                            })
                        ]
                    }, index + 1))
            ]
        }) : /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                    className: "game_score",
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                            className: `score bold`,
                            children: totalHomeScore
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                            className: `score bold`,
                            children: totalAwayScore
                        })
                    ]
                }),
                scores?.filter((score)=>score.hScore && score.aScore)?.map((score, index)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "set_score_wrp",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "score",
                                children: score.hScore
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "score",
                                children: score.aScore
                            })
                        ]
                    }, index + 1))
            ]
        })
    });
};
const $2adaffbfc762779f$export$e287e59d2f3a6657 = (matchScore, hscore, ascore, live)=>/*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "game_score",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                        className: `score ${hscore > ascore ? "bold" : ""}`,
                        children: [
                            hscore,
                            /*#__PURE__*/ (0, $lBpE3.jsx)("sup", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                        className: `score ${hscore < ascore ? "bold" : ""}`,
                        children: [
                            ascore,
                            /*#__PURE__*/ (0, $lBpE3.jsx)("sup", {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "set_score_wrp",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "set_score",
                        children: [
                            "s1home",
                            "s2home",
                            "s3home",
                            "s4home",
                            "s5home"
                        ].map((key, index)=>matchScore[key] && /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                className: "score",
                                children: [
                                    matchScore[key],
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("sup", {
                                        children: matchScore[`s${index + 1}hometb`]
                                    })
                                ]
                            }, index + 1))
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "set_score",
                        children: [
                            "s1away",
                            "s2away",
                            "s3away",
                            "s4away",
                            "s5away"
                        ].map((key, index)=>matchScore[key] && /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                className: "score",
                                children: [
                                    matchScore[key],
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("sup", {
                                        children: matchScore[`s${index + 1}awaytb`]
                                    })
                                ]
                            }, index + 1))
                    })
                ]
            }),
            live && matchScore?.gamehome !== undefined && matchScore?.gameaway !== undefined && /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "game_score",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                        className: "score",
                        children: [
                            matchScore.gamehome,
                            /*#__PURE__*/ (0, $lBpE3.jsx)("sup", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                        className: "score",
                        children: [
                            matchScore.gameaway,
                            /*#__PURE__*/ (0, $lBpE3.jsx)("sup", {})
                        ]
                    })
                ]
            })
        ]
    });
const $2adaffbfc762779f$export$c7ae84d7cfd5dc77 = (match)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "game_score",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                className: `${match?.win === 1 ? "bold" : ""}`,
                children: $2adaffbfc762779f$export$7de91069d32803ba(match?.hts) || "-"
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                className: `${match?.win === 2 ? "bold" : ""}`,
                children: $2adaffbfc762779f$export$7de91069d32803ba(match?.ats) || "-"
            })
        ]
    });
const $2adaffbfc762779f$export$dd06fda150af72dd = (match, live)=>{
    const { st: st, dt: dt, ldt: ldt, bs: bs, mins: mins } = match || {};
    let statusText = "";
    if (st === "Finished") statusText = mins === "To Finish" ? "To FT" : "Finished";
    else if (st === "Interrupted") statusText = "Interrupted";
    else if (st === "Innings break") statusText = "Innings break";
    else if (st === "Full Time") statusText = "Finished";
    else if (st === "NSY" || st === "Not Started" || st === "Finished AET" || st === "Finished AP") statusText = st;
    const statusClass = [
        "Finished",
        "Interrupted",
        "Full Time"
    ].includes(st) ? "status red" : "status";
    const liveStatusText = live ? "Live" : bs !== "Delayed" && bs !== "Stumps" && bs !== "Cancelled" ? (0, $kybuc.DateUtility)?.FormatDateh2h(new Date(dt || ldt)) : "";
    return {
        statusText: statusText,
        statusClass: statusClass,
        liveStatusText: liveStatusText
    };
};
function $2adaffbfc762779f$export$40abf5ebdfe03d1d(str, substring) {
    return str.replace(substring, "");
}
function $2adaffbfc762779f$export$ba2fe755e108442e(dateTimeStr) {
    const date = new Date(dateTimeStr?.replace(" ", "T"));
    const options = {
        weekday: "long",
        day: "2-digit",
        month: "short",
        year: "numeric"
    };
    const datePart = date?.toLocaleDateString("en-GB", options);
    return datePart;
}
function $2adaffbfc762779f$export$76c862645cb05a55(pts, par) {
    const score = pts - par;
    if (score === -3) return "double-eagle"; // Double Eagle
    else if (score === -2) return "eagle"; // Eagle
    else if (score === -1) return "birdie"; // Birdie
    else if (score === 0) return "par"; // Par
    else if (score === 1) return "bogey"; // Bogey
    else if (score === 2) return "dou_bogey"; // Double Bogey
    else return "three_bagey"; // Triple Bogey or worse
}
function $2adaffbfc762779f$export$ae8017b4111c3d11(timezone) {
    const now = new Date();
    const formatter = new Intl.DateTimeFormat("en-US", {
        timeZone: timezone,
        timeZoneName: "short"
    });
    const parts = formatter?.formatToParts(now);
    const timeZonePart = parts?.find((part)=>part?.type === "timeZoneName");
    const offsetString = timeZonePart ? timeZonePart?.value : "UTC";
    return $2adaffbfc762779f$var$extractGmtOffset(offsetString);
}
function $2adaffbfc762779f$var$extractGmtOffset(gmtString) {
    const match = gmtString?.match(/GMT([+-]\d+)/);
    return match ? match?.[1] : 0;
}
function $2adaffbfc762779f$export$6dec73d134243c86(team_id, match) {
    const teamId = parseInt(team_id);
    const homeTeam = match?.competitors?.htid;
    const awayTeam = match?.competitors?.atid;
    const finalScore = match?.ft.split("-")?.map(Number);
    const penaltyScore = match?.ps ? match?.ps?.split("-")?.map(Number) : null;
    let teamScore, opponentScore;
    // Determine if the team is playing home or away
    if (teamId === homeTeam) {
        teamScore = finalScore[0];
        opponentScore = finalScore[1];
    } else if (teamId === awayTeam) {
        teamScore = finalScore[1];
        opponentScore = finalScore[0];
    } else throw new Error("Team not found in match");
    // Determine result
    if (teamScore > opponentScore) return "W"; // Win
    else if (teamScore < opponentScore) return "L"; // Loss
    else {
        // If it was a draw after regular time, check penalty shootout if it exists
        if (penaltyScore) {
            const teamPenaltyScore = teamId === homeTeam ? penaltyScore[0] : penaltyScore[1];
            const opponentPenaltyScore = teamId === homeTeam ? penaltyScore[1] : penaltyScore[0];
            return teamPenaltyScore > opponentPenaltyScore ? "W" : "L";
        }
        return "D"; // Draw
    }
}
function $2adaffbfc762779f$export$3c2ab2c4f3202ceb(dateTimeString) {
    // Create a new Date object from the input string
    const date = new Date(dateTimeString);
    // Extract the year, month, and day
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(date.getDate()).padStart(2, "0");
    // Format the date as YYYY-MM-DD
    return `${year}-${month}-${day}`;
}
function $2adaffbfc762779f$export$6990b34ebbba3861(sport, href = "", type) {
    let response = href;
    if (type === "link") response = href?.replace(sport, $2adaffbfc762779f$export$dcd09c90f4315579(sport));
    else if (type === "sport") response = $2adaffbfc762779f$export$99a63a67dc0133c5(sport);
    return response;
}
const $2adaffbfc762779f$export$dcd09c90f4315579 = (sport)=>{
    switch(sport){
        case "football":
            return sport;
        case "rugby":
            return sport;
        case "tennis":
            return sport;
        case "basketball":
            return sport;
        case "cricket":
            return sport;
        default:
            return sport;
    }
};
const $2adaffbfc762779f$export$99a63a67dc0133c5 = (sport)=>{
    const sportEnvMap = {
        football: undefined,
        rugby: undefined,
        tennis: undefined,
        basketball: undefined,
        cricket: undefined
    };
    // Reverse mapping: Find the key if the value matches the input sport
    const reverseMap = Object.entries(sportEnvMap).find(([key, value])=>value === sport);
    // Return the original key or the original value
    return reverseMap ? reverseMap[0] : Object.keys(sportEnvMap).find((key)=>sport === key);
};
const $2adaffbfc762779f$export$da3bc2f57520e3c3 = (page)=>{
    switch(page){
        case "contact-us":
            return "contact";
        case "privacy-policies":
            return "disclaimer";
        default:
            return page;
    }
};
const $2adaffbfc762779f$export$36a8d11950c00217 = (match)=>{
    const { st: st, mins: mins } = match;
    if (st === "Delayed") return /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
        className: "status",
        children: "Dly"
    });
    if (st === "Postponed") return /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
        className: "sts_tg red",
        children: "PPD"
    });
    if ([
        "Abandoned",
        "Cancelled"
    ].includes(st)) return /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
        className: "sts_tg red",
        children: "AB"
    });
    if (st === "TF") return /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
        className: "status red",
        children: "TF"
    });
    if (st === "Finished" && mins === "To Finish") return /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
        className: "status",
        children: "To FT"
    });
    if (st === "Finished" && mins === "FAP") return /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
        className: "status red",
        children: "FAP"
    });
    if (st === "Finished" && mins === "FAET") return /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
        className: "status",
        children: "FAET"
    });
    if (st === "Finished") return /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
        className: "sts_tg",
        children: "Finished"
    });
    if (st === "NSY") return /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
        className: "sts_tg",
        children: "NSY"
    });
    return null;
};
const $2adaffbfc762779f$export$d9842a8ce5c1e2e7 = {
    notStartYet: "NYS",
    finished: "Finished",
    finishedAET: "Finished AET"
};
const $2adaffbfc762779f$export$6d18514047be2b15 = (inputData)=>{
    const result = [];
    for(const round in inputData){
        const roundData = inputData[round];
        let existingRound = result?.find((item)=>item?.round === round);
        if (!existingRound) {
            existingRound = {
                d: round,
                matches: []
            };
            result?.push(existingRound);
        }
        roundData?.forEach((match)=>{
            existingRound?.matches?.push({
                ...match
            });
        });
    }
    return {
        data: result
    };
};
const $2adaffbfc762779f$export$a3f91c6273be157a = (array, checkValue = "table", newItem = "teams")=>{
    const index = array?.indexOf(checkValue);
    if (index !== -1) array?.splice(index + 1, 0, newItem);
    return array;
};
const $2adaffbfc762779f$export$758f8843ad513ce2 = (sport, match, tab = "info")=>{
    if (sport === "cricket") switch(match?.bs){
        case "live":
            tab = "live";
            break;
        case "Live":
            tab = "live";
            break;
        case "Cancelled":
            tab = "scorecard";
            break;
        case "Finished":
            tab = "scorecard";
            break;
        case "Scheduled":
            tab = "info";
            break;
        default:
            tab = "info";
            break;
    }
    return tab;
};
const $2adaffbfc762779f$export$1a7aae38b68cb82f = (dateString)=>{
    const targetDate = new Date(dateString);
    targetDate?.setHours(targetDate?.getHours() + 5);
    const currentDate = new Date();
    const diffInMilliseconds = targetDate - currentDate;
    if (diffInMilliseconds <= 0) return "00:00"; // If the target time has already passed, return 00:00
    const hours = Math?.floor(diffInMilliseconds / (1000 * 60 * 60));
    const minutes = Math?.floor(diffInMilliseconds % (1000 * 60 * 60) / (1000 * 60));
    // Format as HH:mm
    const formattedTime = `${String(hours)?.padStart(2, "0")}:${String(minutes)?.padStart(2, "0")}`;
    return formattedTime;
};
function $2adaffbfc762779f$export$fadf22b1d08590b7(dateTimeString) {
    // Create a new Date object from the input string
    const date = new Date(dateTimeString);
    // Extract the year, month, and day
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(date.getDate()).padStart(2, "0");
    // Format the date as YYYY-MM-DD
    return `${day}-${month}-${year}`;
}
function $2adaffbfc762779f$export$8ae9e67caded8da1(birthDate) {
    if (!birthDate) return "-";
    const date = new Date(birthDate);
    if (isNaN(date)) return "-";
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", {
        month: "short"
    });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
}
const $2adaffbfc762779f$export$87b6ac566d1db65d = ({ dataClient: dataClient, websiteBaseUrl: websiteBaseUrl, category: category, dataPath: dataPath, sport: sport, name: name, id: id, tab: tab = 'info' })=>{
    if (!dataClient) return "#";
    const basePath = websiteBaseUrl || "";
    const pathSegment = dataPath || sport;
    if (!name || !id) return "#";
    return `${basePath}/${pathSegment}/${category}/${$2adaffbfc762779f$export$38ef5288c127d9ef(name)}/${id}/${tab}`;
};
const $2adaffbfc762779f$export$d796689f978a3cea = ({ websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, sport: sport, slug: slug = "" })=>{
    const base = websiteBaseUrl || "";
    const path = dataPath || sport.toLowerCase();
    return `${base}/${path}/${slug}`;
};
const $2adaffbfc762779f$export$cf176c57f7c8ba64 = (sport)=>{
    const allowed = [
        "cricket",
        "football",
        "tennis",
        "basketball",
        "rugby",
        "golf"
    ];
    return allowed.includes(sport.toLowerCase()) ? sport.toLowerCase() : "football";
};
const $2adaffbfc762779f$export$8e95cad8ca9d533 = (sport, state, tabsData)=>{
    if (sport === 'golf' && state === 'player') return [
        'player_card'
    ];
    else {
        const filteredTabs = (tabsData || []).filter((tab)=>sport === "golf" ? tab !== "summary" : tab !== "top_scorers" && tab !== "info");
        const baseTabs = [
            "info",
            ...filteredTabs
        ];
        if (sport === "football" && state === "league") return $2adaffbfc762779f$export$a3f91c6273be157a(baseTabs);
        return baseTabs;
    }
};
const $2adaffbfc762779f$export$262e6583a2649515 = (result)=>{
    if (result === "W") return "clr_green";
    else if (result === "L") return "clr_red";
    return "";
};
const $2adaffbfc762779f$export$a4f015e969d19934 = (dataClient, clientHeadData, headData, sourceData, sport, state)=>{
    if (sport === "golf" && state === "player") return [];
    return dataClient ? clientHeadData?.tabs || sourceData?.tabs : headData?.tabs || sourceData?.tabs;
};
const $2adaffbfc762779f$export$8aaf31f1731561fd = (state, sport, sourceData)=>{
    if (state === "league" || state === "player") return sourceData?.football_category?.fid || sourceData?.cric_category?.fid || sourceData?.tennis_category?.fid || sourceData?.basketball_category?.fid || sourceData?.rugbyCategory?.fid || sourceData?.icehockey_category?.fid || sourceData?.category?.fid || sourceData?.fid;
    return sport === "tennis" ? sourceData?.pid : sourceData?.id;
};
const $2adaffbfc762779f$export$492f76f65bf1bced = (baseURL, state, sport, imgId, path = 'v1', logo = "competitor-logos")=>{
    let sports;
    switch(sport){
        case "ice-hockey":
            sports = "hockey";
            break;
        case "rugby-union":
            sports = "rugby";
            break;
        case 'tennis':
            logo = 'player-pictures';
            break;
        case 'golf':
            logo = 'player-pictures';
            break;
        case "cricket":
            return `https://cric.livescoring.cc/teamflags/${imgId}.png`;
        default:
            sports = sport;
    }
    if (state === "league" || state === "player") return `${baseURL}/public/assets/images/flags/country_${imgId}.png`;
    return `${(0, $R8nvx.getImgUrl)()}/${path}/sports/${sports}/${logo}/${imgId}.png`;
};
const $2adaffbfc762779f$export$3029e69183064c84 = (teamId, match)=>{
    const outcome = $2adaffbfc762779f$export$6dec73d134243c86(teamId, match);
    if (outcome === "W") return "win";
    if (outcome === "L") return "loss";
    return "draw";
};
const $2adaffbfc762779f$export$7bf8c034d5ab1d9e = (match, dataClient, websiteBaseUrl, dataPath)=>{
    if (dataClient) window.location.href = websiteBaseUrl ? `${websiteBaseUrl}/${dataPath}/match-detail/${$2adaffbfc762779f$export$38ef5288c127d9ef(match?.competitors?.htn)}-vs-${$2adaffbfc762779f$export$38ef5288c127d9ef(match?.competitors?.atn)}/${match?.id}/info` : `/${dataPath}/match-detail/${$2adaffbfc762779f$export$38ef5288c127d9ef(match?.competitors?.htn)}-vs-${$2adaffbfc762779f$export$38ef5288c127d9ef(match?.competitors?.atn)}/${match?.id}/info`;
};
const $2adaffbfc762779f$export$6bb93941aebe85b4 = (head, dataClient, websiteBaseUrl, dataPath)=>{
    if (dataClient) window.location.href = websiteBaseUrl ? `${websiteBaseUrl}/${dataPath}/league/${$2adaffbfc762779f$export$dfe6b77737fd172b(head?.nm)}/${head?.id}/info` : `/${dataPath}/league/${$2adaffbfc762779f$export$dfe6b77737fd172b(head?.nm)}/${head?.id}/info`;
};
const $2adaffbfc762779f$export$3c50dd3ed25de7ac = (match, quarter)=>{
    if (match) {
        const score = match[`q${quarter}`]?.split("-") || match[`p${quarter}`]?.split("-") || [];
        return {
            hScore: score[0] || 0,
            aScore: score[1] || 0
        };
    }
    return null;
};
const $2adaffbfc762779f$export$ef3af78ca19353c4 = (sport, scores, matchScore, isHome)=>{
    if (sport === "icehockey" || sport === "basketball") return scores?.map((score, i)=>/*#__PURE__*/ (0, $lBpE3.jsx)("li", {
            className: "clr_score",
            children: isHome ? score?.hScore : score?.aScore
        }, score + i));
    if (sport === "tennis") {
        const sets = isHome ? [
            "s1home",
            "s2home",
            "s3home",
            "s4home",
            "s5home"
        ] : [
            "s1away",
            "s2away",
            "s3away",
            "s4away",
            "s5away"
        ];
        return sets.map((set, idx)=>{
            const score = matchScore[set];
            const tbScore = matchScore[`s${idx + 1}${isHome ? "hometb" : "awaytb"}`];
            return score && /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                className: "score",
                children: [
                    score,
                    /*#__PURE__*/ (0, $lBpE3.jsx)("sup", {
                        children: tbScore
                    })
                ]
            }, set);
        });
    }
    return null;
};
const $2adaffbfc762779f$export$3a445a7ee2bd69b6 = (sport, competitorId)=>$2adaffbfc762779f$export$492f76f65bf1bced("", '', sport, competitorId);
const $2adaffbfc762779f$export$8dc10eaacfa1f110 = (m, tempMatch, sport)=>{
    switch(sport){
        case "basketball":
            return {
                ...m,
                st: tempMatch?.st ?? m.st,
                cp: tempMatch?.cp ?? m.cp,
                ft: tempMatch?.ft ?? m.ft,
                q1: tempMatch?.q1 ?? m.q1,
                q2: tempMatch?.q2 ?? m.q2,
                q3: tempMatch?.q3 ?? m.q3,
                q4: tempMatch?.q4 ?? m.q4,
                odds: tempMatch?.odds ?? m.odds,
                mins: tempMatch?.mins ?? m.mins,
                fot: tempMatch?.fot ?? m.fot,
                cs: tempMatch?.cs ?? m.cs,
                ot: tempMatch?.ot ?? m.ot,
                cfs: tempMatch?.cfs ?? m.cfs
            };
        case "icehockey":
            return {
                ...m,
                st: tempMatch?.st ?? m.st,
                cp: tempMatch?.cp ?? m.cp,
                ft: tempMatch?.ft ?? m.ft,
                p1: tempMatch?.p1 ?? m.p1,
                p2: tempMatch?.p2 ?? m.p2,
                p3: tempMatch?.p3 ?? m.p3,
                odds: tempMatch?.odds ?? m.odds,
                mins: tempMatch?.mins ?? m.mins,
                fot: tempMatch?.fot ?? m.fot,
                cs: tempMatch?.cs ?? m.cs,
                ot: tempMatch?.ot ?? m.ot,
                cfs: tempMatch?.cfs ?? m.cfs
            };
        case "tennis":
            return {
                ...m,
                st: tempMatch?.st ?? m.st,
                cp: tempMatch?.cp ?? m.cp,
                scores: tempMatch?.scores ?? m.scores,
                odds: tempMatch?.odds ?? m.odds,
                fts: tempMatch?.fts ?? m.fts
            };
        case "cricket":
            return {
                ...m,
                st: tempMatch?.st ?? m.st,
                bs: tempMatch?.bs ?? m.bs,
                hts: tempMatch?.hts ?? m.hts,
                ats: tempMatch?.ats ?? m.ats,
                win: tempMatch?.win ?? m.win,
                batid: tempMatch?.batid ?? m.batid,
                botid: tempMatch?.botid ?? m.botid,
                odds: tempMatch?.odds ?? m.odds,
                com: tempMatch?.com ?? m.com,
                rr: tempMatch?.rr ?? m.rr
            };
        default:
            return m; // If no sport matches, return the original match object
    }
};
const $2adaffbfc762779f$export$f04a61298a47a40f = ({ type: type, src: src, width: width, height: height, alt: alt })=>/*#__PURE__*/ (0, $lBpE3.jsx)("span", {
        className: type,
        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
            src: src,
            width: width,
            height: height,
            alt: alt
        })
    });
const $2adaffbfc762779f$export$a45c37fa7763b745 = (scores)=>{
    let totalHomeScore = 0;
    let totalAwayScore = 0;
    scores.forEach((s)=>{
        totalHomeScore += parseInt(s.hScore) || 0;
        totalAwayScore += parseInt(s.aScore) || 0;
    });
    if (totalHomeScore > totalAwayScore) return "home";
    if (totalAwayScore > totalHomeScore) return "away";
    return "draw";
};
const $2adaffbfc762779f$export$a6d135921f70703 = (sport, match)=>{
    if (sport === "tennis") return {
        home: $2adaffbfc762779f$export$492f76f65bf1bced('', '', sport, match?.competitors?.hpid, 'player-pictures'),
        away: $2adaffbfc762779f$export$492f76f65bf1bced('', '', sport, match?.competitors?.apid, 'player-pictures')
    };
    else if (sport === "cricket") return {
        home: `https://cric.livescoring.cc/teamflags/${match?.competitors?.htid}.png`,
        away: `https://cric.livescoring.cc/teamflags/${match?.competitors?.atid}.png`
    };
    return {
        home: $2adaffbfc762779f$export$492f76f65bf1bced('', '', sport, match?.competitors?.htid),
        away: $2adaffbfc762779f$export$492f76f65bf1bced('', '', sport, match?.competitors?.atid)
    };
};
const $2adaffbfc762779f$export$bf86bc1cfd09264 = (t1P, t2P, drawLable, drawP)=>{
    let t1W = "95%";
    let t2W = "95%";
    let drawW = "33.33%";
    if (drawLable) {
        // When showing draws, calculate proportional widths for all three
        // Ensure we have valid numeric values
        const t1Num = typeof t1P === 'number' ? t1P : parseFloat(String(t1P)) || 0;
        const t2Num = typeof t2P === 'number' ? t2P : parseFloat(String(t2P)) || 0;
        const drawNum = typeof drawP === 'number' ? drawP : parseFloat(String(drawP)) || 0;
        const total = t1Num + t2Num + drawNum;
        if (total === 0) {
            // All are 0, show equal bars
            t1W = "33.33%";
            t2W = "33.33%";
            drawW = "33.34%";
        } else {
            // Calculate proportional widths based on percentage values
            const t1Proportion = t1Num / total * 100;
            const t2Proportion = t2Num / total * 100;
            const drawProportion = drawNum / total * 100;
            // Ensure minimum 10% visibility for ALL values (including 0%)
            const minWidth = 10;
            let adjustedT1 = Math.max(minWidth, t1Proportion);
            let adjustedT2 = Math.max(minWidth, t2Proportion);
            let adjustedDraw = Math.max(minWidth, drawProportion);
            // Normalize to ensure they add up to 100%
            const adjustedTotal = adjustedT1 + adjustedT2 + adjustedDraw;
            if (adjustedTotal > 0) {
                // Round to 1 decimal to ensure consistent formatting
                const t1Final = (adjustedT1 / adjustedTotal * 100).toFixed(1);
                const t2Final = (adjustedT2 / adjustedTotal * 100).toFixed(1);
                const drawFinal = (adjustedDraw / adjustedTotal * 100).toFixed(1);
                t1W = `${t1Final}%`;
                t2W = `${t2Final}%`;
                drawW = `${drawFinal}%`;
            } else {
                t1W = "33.33%";
                t2W = "33.33%";
                drawW = "33.34%";
            }
        }
    } else {
        // Convert to numbers for comparison
        const t1Num = parseFloat(t1P) || 0;
        const t2Num = parseFloat(t2P) || 0;
        const total = t1Num + t2Num;
        if (total === 0) {
            // Both are 0, show equal minimal bars
            t1W = "50%";
            t2W = "50%";
        } else if (t1Num === 0 && t2Num > 0) {
            // Only t2 has value
            t1W = "5%";
            t2W = "95%";
        } else if (t2Num === 0 && t1Num > 0) {
            // Only t1 has value
            t1W = "95%";
            t2W = "5%";
        } else if (t1Num === t2Num) {
            // Equal percentages, show equal bars
            t1W = "50%";
            t2W = "50%";
        } else {
            // Calculate proportional widths based on percentage values
            // Calculate each team's proportion of the total
            const t1Proportion = t1Num / total * 100;
            const t2Proportion = t2Num / total * 100;
            // Ensure minimum 10% visibility for smaller value
            const minWidth = 10;
            if (t1Proportion < minWidth) {
                t1W = `${minWidth}%`;
                t2W = `${100 - minWidth}%`;
            } else if (t2Proportion < minWidth) {
                t2W = `${minWidth}%`;
                t1W = `${100 - minWidth}%`;
            } else {
                // Both are above minimum, use proportional widths
                t1W = `${t1Proportion.toFixed(1)}%`;
                t2W = `${t2Proportion.toFixed(1)}%`;
            }
        }
    }
    return {
        t1W: t1W,
        t2W: t2W,
        drawW: drawW
    };
};
const $2adaffbfc762779f$export$b90e09df9d33498a = (formArray)=>{
    const result = {
        score: 0,
        wins: 0,
        draws: 0,
        losses: 0
    };
    if (!formArray || !Array.isArray(formArray)) return result;
    formArray.forEach((item)=>{
        if (item === 'W') {
            result.score += 3;
            result.wins += 1;
        } else if (item === 'D') {
            result.score += 1;
            result.draws += 1;
        } else if (item === 'L') result.losses += 1;
    });
    return result;
};
const $2adaffbfc762779f$export$a78037336ff8885b = (data)=>{
    if (!data || !Array.isArray(data)) return [];
    return [
        ...data
    ].sort((a, b)=>{
        const formA = a?.form ? JSON.parse(a.form) : [];
        const formB = b?.form ? JSON.parse(b.form) : [];
        const scoreA = $2adaffbfc762779f$export$b90e09df9d33498a(formA);
        const scoreB = $2adaffbfc762779f$export$b90e09df9d33498a(formB);
        // Primary sort: by total form score (descending)
        if (scoreB.score !== scoreA.score) return scoreB.score - scoreA.score;
        // Secondary sort: by number of wins (descending)
        if (scoreB.wins !== scoreA.wins) return scoreB.wins - scoreA.wins;
        // Tertiary sort: by fewer losses (ascending)
        return scoreA.losses - scoreB.losses;
    });
};
const $2adaffbfc762779f$export$7eebfad9a0d8c154 = (tournaments, ascending = false)=>{
    if (!tournaments || tournaments?.length === 0) return null;
    const allMatches = [];
    const result = [];
    let currentTournamentId = null;
    tournaments?.forEach((tournament)=>{
        if (tournament?.matches && tournament?.matches.length > 0) tournament?.matches?.forEach((match)=>{
            allMatches.push({
                match: match,
                tournament: tournament
            });
        });
    });
    allMatches?.sort((a, b)=>{
        const dateA = new Date(a?.match?.dt);
        const dateB = new Date(b?.match?.dt);
        return ascending ? dateA - dateB : dateB - dateA;
    });
    allMatches?.forEach(({ match: match, tournament: tournament })=>{
        if (currentTournamentId !== tournament?.id) {
            result?.push({
                ...tournament,
                matches: [
                    match
                ]
            });
            currentTournamentId = tournament?.id;
        } else result[result?.length - 1]?.matches.push(match);
    });
    return {
        data: result
    };
};

});
parcelRegister("kybuc", function(module, exports) {

$parcel$export(module.exports, "DateUtility", function () { return $ef5fe4805660e454$export$59c7f8e6c2d8e631; });
parcelRequire("6cds3");
const $ef5fe4805660e454$var$daysOfWeek = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
const $ef5fe4805660e454$export$59c7f8e6c2d8e631 = {
    FormatTime: (date)=>{
        //input ==> js date object
        //output 23:30
        date = new Date(date);
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const formattedTime = `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
        return formattedTime;
    },
    ConvertCETtoCurrentTimeZoneCounter: (utc_datetime, offset)=>{
        // input: "2023-06-13 10:00:00"
        // output: "2023-06-13 23:30:00"
        const localDate = new Date(utc_datetime.replace(" ", "T"));
        // ensure valid ISO string for JS Date
        const timezoneOffset = offset * 60; // offset in hours → minutes
        localDate.setMinutes(localDate.getMinutes() + timezoneOffset);
        // format YYYY-MM-DD HH:mm:ss
        const pad = (n)=>String(n).padStart(2, "0");
        const year = localDate.getFullYear();
        const month = pad(localDate.getMonth() + 1);
        const day = pad(localDate.getDate());
        const hours = pad(localDate.getHours());
        const minutes = pad(localDate.getMinutes());
        const seconds = pad(localDate.getSeconds());
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    ConvertCETtoCurrentTimeZoneDate: (utc_datetime, offset)=>{
        if (!utc_datetime) return "";
        const localDate = new Date(utc_datetime.replace(" ", "T"));
        if (isNaN(localDate.getTime())) return "";
        const timezoneOffset = (offset || 0) * 60;
        localDate.setMinutes(localDate.getMinutes() + timezoneOffset);
        const pad = (n)=>String(n).padStart(2, "0");
        const year = localDate.getFullYear();
        const month = pad(localDate.getMonth() + 1);
        const day = pad(localDate.getDate());
        return `${year}-${month}-${day}`;
    },
    //Input ===>"2023-06-13 10:00:00", 5(difference)
    //Output ===>"2023-06-13"
    ConvertCETtoCurrentTimeZone: (utc_datetime, offset)=>{
        //input ==> 2023-06-13 10:00:00
        //output 23:30
        const localDate = new Date(utc_datetime);
        const timezoneOffset = offset * 60;
        localDate.setMinutes(localDate.getMinutes() + timezoneOffset);
        const res = localDate.toLocaleString("en-US", {
            hour12: false
        });
        let result = `${res?.split(" ")[1]?.split(":")[0]}:${res?.split(" ")[1]?.split(":")[1]}`;
        return result;
    },
    dateFormat1: (datee, month = "long")=>{
        //input: '2023-05-25T00:00:00.000000Z'
        //output:  25 May
        if (!datee) return "";
        const dateObj = new Date(datee);
        const formattedDate = dateObj.toLocaleDateString("en-GB", {
            day: "numeric",
            month: month
        });
        return formattedDate;
    },
    FormatDate: (date)=>{
        //input ==> 2023-06-13 10:00:00
        // Output: "Thu 15 Jun 2023"
        if (!date) return "";
        date = new Date(date);
        const daysOfWeek = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ];
        const monthsOfYear = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ];
        const dayOfWeek = daysOfWeek[date.getDay()];
        const dayOfMonth = date.getDate();
        const month = monthsOfYear[date.getMonth()];
        const year = date.getFullYear();
        const formattedDate = `${dayOfWeek}, ${dayOfMonth} ${month} ${year}`;
        return formattedDate;
    },
    GetCurrentDateAsString: ()=>{
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0"); // January is month 0
        const day = String(today.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    },
    ConvertDate: (date)=>{
        const year = date.toLocaleString("default", {
            year: "numeric"
        });
        const month = date.toLocaleString("default", {
            month: "2-digit"
        });
        const day = date.toLocaleString("default", {
            day: "2-digit"
        });
        let myDate = `${year}-${month}-${day}`;
        return myDate;
    },
    ConvertDate1: (date)=>{
        // input '2023-07-17 14:10:00'
        // Output: 2023-07-17
        const dateTimeString = date;
        const dateObject = new Date(dateTimeString);
        const dateOnly = dateObject.toISOString().split("T")[0];
        return dateOnly || "";
    },
    FormatDateListing: (date)=>{
        //input ==> 2023-06-15
        //output ==> Thu, 15 June
        const daysOfWeek = [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ];
        const months = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "Sept",
            "October",
            "November",
            "December"
        ];
        const currentDate = new Date(date);
        const dayOfWeek = daysOfWeek[currentDate.getDay()];
        const day = currentDate.getDate();
        const month = months[currentDate.getMonth()];
        const formattedDate = `${dayOfWeek}, ${day} ${month}`;
        return formattedDate;
    },
    FormatDateListing1: (date)=>{
        // input ==> 2023-06-15
        // output ==> 06/15
        const currentDate = new Date(date);
        // Get the month and date
        const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // +1 as months are 0-indexed
        const day = String(currentDate.getDate()).padStart(2, "0"); // pad with 0 for single digits
        const formattedDate = `${month}/${day}`;
        return formattedDate;
    },
    dateFormat9: (datee)=>{
        //input: '2023-05-25T00:00:00.000000Z'
        //output: May 25, 2023
        if (!datee) return "";
        const dateObj = new Date(datee);
        const formattedDate = dateObj.toLocaleDateString("en-US", {
            month: "long",
            day: "numeric",
            year: "numeric"
        });
        return formattedDate;
    },
    CurrentDateAddRem1: (curDate, sign, val = 1)=>{
        if (!curDate || !sign) return;
        let date = new Date(curDate);
        sign === "+" ? date.setDate(date.getDate() + val) : date.setDate(date.getDate() - val);
        const year = date.getFullYear();
        let month = date.getMonth();
        month = month + 1;
        let day = date.getDate();
        if (month < 10) month = `0${month}`;
        if (day < 10) day = `0${day}`;
        return `${year}-${month}-${day}`;
    },
    CurrentDateAddRem: (sign = "+", val = 0)=>{
        let date = new Date();
        sign === "+" ? date.setDate(date.getDate() + val) : date.setDate(date.getDate() - val);
        const year = date.getFullYear();
        let month = date.getMonth();
        month = month + 1;
        let day = date.getDate();
        if (month < 10) month = `0${month}`;
        if (day < 10) day = `0${day}`;
        const data = {
            date: `${year}-${month}-${day}`,
            day: Number(day) || "",
            weekDay: $ef5fe4805660e454$var$daysOfWeek[date.getDay()] || ""
        };
        return data;
    },
    FormatDateh2h: (date)=>{
        const options = {
            day: "numeric",
            month: "short"
        };
        return date.toLocaleDateString("en-US", options);
    },
    get30Dates: ()=>{
        const today = new Date();
        const dates = [];
        for(let i = -30; i <= 30; i++){
            const currentDate = new Date();
            currentDate.setDate(today.getDate() + i);
            const year = currentDate.getFullYear();
            const month = String(currentDate.getMonth() + 1).padStart(2, "0");
            const day = String(currentDate.getDate()).padStart(2, "0");
            const weekDay = i === 0 ? "Today" : $ef5fe4805660e454$var$daysOfWeek[currentDate.getDay()] || "";
            dates.push({
                date: `${year}-${month}-${day}`,
                day: Number(day) || "",
                weekDay: weekDay
            });
        }
        return dates;
    },
    dayFromDate: (myDate)=>{
        // return current day from date
        const today = myDate ? new Date(myDate) : new Date();
        const day = String(today.getDate()).padStart(2, "0");
        return day;
    },
    checkDateTimeIsLess: (myDate)=>{
        // check whether the given time is less than current time or not
        const dated = myDate ? new Date(myDate) : new Date();
        const currentDate = new Date();
        return dated < currentDate;
    },
    formatTo12HourTime (dt) {
        //input: 2025-06-26 18:00:00
        // Outputs: 06:00 PM
        const date = new Date(dt);
        let hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        const minutesStr = minutes < 10 ? "0" + minutes : minutes;
        return `${hours.toString().padStart(2, "0")}:${minutesStr} ${ampm}`;
    },
    formatDateTime (dateTime) {
        const date = new Date(dateTime);
        // Format as DD/MM/YYYY - HH:mm
        const formattedDate = date.toLocaleDateString("en-GB"); // dd/mm/yyyy
        const formattedTime = date.toLocaleTimeString("en-GB", {
            hour: "2-digit",
            minute: "2-digit"
        });
        return `${formattedDate} - ${formattedTime}`;
    }
}; // export default DateUtility;

});

parcelRegister("ba5nK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7a9ea5de20b4d52$export$2e2bcd8739ae039; });

var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");
const $b7a9ea5de20b4d52$var$baseURL = "https://ipublisher-microservices.6lgx.com" ?? "https://ipublisher-microservices.6lgx.com";
const $b7a9ea5de20b4d52$var$ReactImage = ({ src: src = `${$b7a9ea5de20b4d52$var$baseURL}/public/assets/images/svg/team-logo-22x22.svg`, width: width = 22, height: height = 22, clz: clz = "", alt: alt = "Image Description", priority: priority = false, testid: testid = "", fallbackSrc: fallbackSrc = `${$b7a9ea5de20b4d52$var$baseURL}/public/assets/images/svg/team-logo-22x22.svg`, fill: fill = false, sizes: sizes, objectFit: objectFit = "cover", style: style = {}, decoding: decoding = "async" })=>{
    const [errored, setErrored] = (0, $6cds3.useState)(false);
    return /*#__PURE__*/ (0, $lBpE3.jsx)("img", {
        src: errored ? fallbackSrc : src,
        alt: alt,
        width: fill ? "100%" : width,
        height: fill ? "100%" : height,
        className: clz,
        style: {
            objectFit: objectFit,
            ...style
        },
        "data-testid": testid,
        decoding: decoding,
        loading: priority ? "eager" : "lazy",
        onError: ()=>setErrored(true)
    }, src);
};
var $b7a9ea5de20b4d52$export$2e2bcd8739ae039 = $b7a9ea5de20b4d52$var$ReactImage;

});

parcelRegister("R8nvx", function(module, exports) {

$parcel$export(module.exports, "postType", function () { return $09fb73145d482738$export$bab71a2327e19ba7; });
$parcel$export(module.exports, "getImgUrl", function () { return $09fb73145d482738$export$18acc80fdf0e8f1a; });
parcelRequire("6cds3");
const $09fb73145d482738$export$6cd071e99d263f9b = {
    instagram: "ico_instagram2",
    facebook: "ico_facebook",
    twitter: "ico_twitter-x",
    telegram: "ico_telegram",
    bluesky: "ico_bluesky",
    tiktok: "ico_tiktok",
    linkdin: "ico_linkdin",
    pinterest: "ico_Vector-4",
    youtube: "ico_youtube"
};
const $09fb73145d482738$export$f5db0744901a18f8 = {
    instagram: "ico_instagram2",
    telegram: "ico_telegram",
    bluesky: "ico_bluesky",
    tiktok: "ico_tiktok",
    facebook: "ico_facebook",
    twitter: "ico_twitter-x",
    linkdin: "ico_linkdin",
    pinterest: "ico_Vector-4",
    youtube: "ico_youtube"
};
const $09fb73145d482738$export$63152c03c6fc2406 = {
    "Africa/Abidjan": "CIV",
    "Africa/Accra": "GHA",
    "Africa/Addis_Ababa": "ETH",
    "Africa/Algiers": "DZA",
    "Africa/Asmara": "ERI",
    "Africa/Bamako": "MLI",
    "Africa/Bangui": "CAF",
    "Africa/Banjul": "GMB",
    "Africa/Bissau": "GNB",
    "Africa/Blantyre": "MWI",
    "Africa/Brazzaville": "COG",
    "Africa/Bujumbura": "BDI",
    "Africa/Cairo": "EGY",
    "Africa/Casablanca": "MAR",
    "Africa/Conakry": "GIN",
    "Africa/Dakar": "SEN",
    "Africa/Dar_es_Salaam": "TZA",
    "Africa/Djibouti": "DJI",
    "Africa/Douala": "CMR",
    "Africa/El_Aaiun": "ESH",
    "Africa/Freetown": "SLE",
    "Africa/Gaborone": "BWA",
    "Africa/Harare": "ZWE",
    "Africa/Johannesburg": "ZAF",
    "Africa/Juba": "SSD",
    "Africa/Kampala": "UGA",
    "Africa/Khartoum": "SDN",
    "Africa/Kigali": "RWA",
    "Africa/Kinshasa": "COD",
    "Africa/Lagos": "NGA",
    "Africa/Libreville": "GAB",
    "Africa/Lome": "TGO",
    "Africa/Luanda": "AGO",
    "Africa/Lubumbashi": "COD",
    "Africa/Lusaka": "ZMB",
    "Africa/Malabo": "GNQ",
    "Africa/Maputo": "MOZ",
    "Africa/Maseru": "LSO",
    "Africa/Mbabane": "SWZ",
    "Africa/Mogadishu": "SOM",
    "Africa/Monrovia": "LBR",
    "Africa/Nairobi": "KEN",
    "Africa/Ndjamena": "TCD",
    "Africa/Niamey": "NER",
    "Africa/Nouakchott": "MRT",
    "Africa/Ouagadougou": "BFA",
    "Africa/Porto-Novo": "BEN",
    "Africa/Sao_Tome": "STP",
    "Africa/Tripoli": "LBY",
    "Africa/Tunis": "TUN",
    "Africa/Windhoek": "NAM",
    "America/Adak": "USA",
    "America/Anchorage": "USA",
    "America/Anguilla": "AIA",
    "America/Antigua": "ATG",
    "America/Araguaina": "BRA",
    "America/Argentina/Buenos_Aires": "ARG",
    "America/Argentina/Catamarca": "ARG",
    "America/Argentina/Cordoba": "ARG",
    "America/Argentina/Jujuy": "ARG",
    "America/Argentina/La_Rioja": "ARG",
    "America/Argentina/Mendoza": "ARG",
    "America/Argentina/Rio_Gallegos": "ARG",
    "America/Argentina/Salta": "ARG",
    "America/Argentina/San_Juan": "ARG",
    "America/Argentina/San_Luis": "ARG",
    "America/Argentina/Tucuman": "ARG",
    "America/Argentina/Ushuaia": "ARG",
    "America/Aruba": "ABW",
    "America/Asuncion": "PRY",
    "America/Atikokan": "CAN",
    "America/Bahia": "BRA",
    "America/Bahia_Banderas": "MEX",
    "America/Barbados": "BRB",
    "America/Belem": "BRA",
    "America/Belize": "BLZ",
    "America/Blanc-Sablon": "CAN",
    "America/Boa_Vista": "BRA",
    "America/Bogota": "COL",
    "America/Boise": "USA",
    "America/Cambridge_Bay": "CAN",
    "America/Campo_Grande": "BRA",
    "America/Cancun": "MEX",
    "America/Caracas": "VEN",
    "America/Cayenne": "GUF",
    "America/Cayman": "CYM",
    "America/Chicago": "USA",
    "America/Chihuahua": "MEX",
    "America/Costa_Rica": "CRI",
    "America/Creston": "CAN",
    "America/Cuiaba": "BRA",
    "America/Curacao": "CUW",
    "America/Danmarkshavn": "GRL",
    "America/Dawson": "CAN",
    "America/Dawson_Creek": "CAN",
    "America/Denver": "USA",
    "America/Detroit": "USA",
    "America/Dominica": "DMA",
    "America/Edmonton": "CAN",
    "America/Eirunepe": "BRA",
    "America/El_Salvador": "SLV",
    "America/Fort_Nelson": "CAN",
    "America/Fortaleza": "BRA",
    "America/Glace_Bay": "CAN",
    "America/Godthab": "GRL",
    "America/Goose_Bay": "CAN",
    "America/Grand_Turk": "TCA",
    "America/Grenada": "GRD",
    "America/Guadeloupe": "GLP",
    "America/Guatemala": "GTM",
    "America/Guayaquil": "ECU",
    "America/Guyana": "GUY",
    "America/Halifax": "CAN",
    "America/Havana": "CUB",
    "America/Hermosillo": "MEX",
    "America/Indiana/Indianapolis": "USA",
    "America/Indiana/Knox": "USA",
    "America/Indiana/Marengo": "USA",
    "America/Indiana/Petersburg": "USA",
    "America/Indiana/Tell_City": "USA",
    "America/Indiana/Vevay": "USA",
    "America/Indiana/Vincennes": "USA",
    "America/Indiana/Winamac": "USA",
    "America/Inuvik": "CAN",
    "America/Iqaluit": "CAN",
    "America/Jamaica": "JAM",
    "America/Juneau": "USA",
    "America/Kentucky/Louisville": "USA",
    "America/Kentucky/Monticello": "USA",
    "America/Kralendijk": "BES",
    "America/La_Paz": "BOL",
    "America/Lima": "PER",
    "America/Los_Angeles": "USA",
    "America/Lower_Princes": "SXM",
    "America/Maceio": "BRA",
    "America/Managua": "NIC",
    "America/Manaus": "BRA",
    "America/Marigot": "MAF",
    "America/Martinique": "MTQ",
    "America/Matamoros": "MEX",
    "America/Mazatlan": "MEX",
    "America/Menominee": "USA",
    "America/Merida": "MEX",
    "America/Metlakatla": "USA",
    "America/Mexico_City": "MEX",
    "America/Miquelon": "SPM",
    "America/Moncton": "CAN",
    "America/Monterrey": "MEX",
    "America/Montevideo": "URY",
    "America/Montreal": "CAN",
    "America/Montserrat": "MSR",
    "America/Nassau": "BHS",
    "America/New_York": "USA",
    "America/Nipigon": "CAN",
    "America/Nome": "USA",
    "America/Noronha": "BRA",
    "America/North_Dakota/Beulah": "USA",
    "America/North_Dakota/Center": "USA",
    "America/North_Dakota/New_Salem": "USA",
    "America/Ojinaga": "MEX",
    "America/Panama": "PAN",
    "America/Pangnirtung": "CAN",
    "America/Paramaribo": "SUR",
    "America/Phoenix": "USA",
    "America/Port-au-Prince": "HTI",
    "America/Port_of_Spain": "TTO",
    "America/Porto_Velho": "BRA",
    "America/Puerto_Rico": "PRI",
    "America/Punta_Arenas": "CHL",
    "America/Rainy_River": "CAN",
    "America/Rankin_Inlet": "CAN",
    "America/Recife": "BRA",
    "America/Regina": "CAN",
    "America/Resolute": "CAN",
    "America/Rio_Branco": "BRA",
    "America/Santarem": "BRA",
    "America/Santiago": "CHL",
    "America/Santo_Domingo": "DOM",
    "America/Sao_Paulo": "BRA",
    "America/Scoresbysund": "GRL",
    "America/Sitka": "USA",
    "America/St_Barthelemy": "BLM",
    "America/St_Johns": "CAN",
    "America/St_Kitts": "KNA",
    "America/St_Lucia": "LCA",
    "America/St_Thomas": "VIR",
    "America/St_Vincent": "VCT",
    "America/Swift_Current": "CAN",
    "America/Tegucigalpa": "HND",
    "America/Thule": "GRL",
    "America/Thunder_Bay": "CAN",
    "America/Tijuana": "USA",
    "America/Toronto": "CAN",
    "America/Tortola": "VGB",
    "America/Vancouver": "CAN",
    "America/Whitehorse": "CAN",
    "America/Winnipeg": "CAN",
    "America/Yakutat": "USA",
    "America/Yellowknife": "CAN",
    "Antarctica/Casey": "ATA",
    "Antarctica/Davis": "ATA",
    "Antarctica/DumontDUrville": "ATA",
    "Antarctica/Macquarie": "ATA",
    "Antarctica/Mawson": "ATA",
    "Antarctica/McMurdo": "ATA",
    "Antarctica/Palmer": "ATA",
    "Antarctica/Rothera": "ATA",
    "Antarctica/Syowa": "ATA",
    "Antarctica/Troll": "ATA",
    "Antarctica/Vostok": "ATA",
    "Arctic/Longyearbyen": "NOR",
    "Asia/Aden": "YEM",
    "Asia/Almaty": "KAZ",
    "Asia/Amman": "JOR",
    "Asia/Anadyr": "RUS",
    "Asia/Aqtau": "KAZ",
    "Asia/Aqtobe": "KAZ",
    "Asia/Ashgabat": "TKM",
    "Asia/Atyrau": "KAZ",
    "Asia/Baghdad": "IRQ",
    "Asia/Bahrain": "BHR",
    "Asia/Baku": "AZE",
    "Asia/Bangkok": "THA",
    "Asia/Barnaul": "RUS",
    "Asia/Beirut": "LBN",
    "Asia/Bishkek": "KGZ",
    "Asia/Brunei": "BRN",
    "Asia/Chita": "RUS",
    "Asia/Choibalsan": "MNG",
    "Asia/Colombo": "LKA",
    "Asia/Damascus": "SYR",
    "Asia/Dhaka": "BGD",
    "Asia/Dili": "TLS",
    "Asia/Dubai": "ARE",
    "Asia/Dushanbe": "TJK",
    "Asia/Famagusta": "CYP",
    "Asia/Gaza": "PSE",
    "Asia/Hebron": "PSE",
    "Asia/Ho_Chi_Minh": "VNM",
    "Asia/Hong_Kong": "HKG",
    "Asia/Hovd": "MNG",
    "Asia/Irkutsk": "RUS",
    "Asia/Jakarta": "IDN",
    "Asia/Jayapura": "IDN",
    "Asia/Jerusalem": "ISR",
    "Asia/Kabul": "AFG",
    "Asia/Kamchatka": "RUS",
    "Asia/Karachi": "PAK",
    "Asia/Kathmandu": "NPL",
    "Asia/Khandyga": "RUS",
    "Asia/Kolkata": "IND",
    "Asia/Calcutta": "IND",
    "Asia/Krasnoyarsk": "RUS",
    "Asia/Kuala_Lumpur": "MYS",
    "Asia/Kuching": "MYS",
    "Asia/Kuwait": "KWT",
    "Asia/Macau": "MAC",
    "Asia/Magadan": "RUS",
    "Asia/Makassar": "IDN",
    "Asia/Manila": "PHL",
    "Asia/Muscat": "OMN",
    "Asia/Nicosia": "CYP",
    "Asia/Novokuznetsk": "RUS",
    "Asia/Novosibirsk": "RUS",
    "Asia/Omsk": "RUS",
    "Asia/Oral": "KAZ",
    "Asia/Phnom_Penh": "KHM",
    "Asia/Pontianak": "IDN",
    "Asia/Pyongyang": "PRK",
    "Asia/Qatar": "QAT",
    "Asia/Qostanay": "KAZ",
    "Asia/Qyzylorda": "KAZ",
    "Asia/Riyadh": "SAU",
    "Asia/Sakhalin": "RUS",
    "Asia/Samarkand": "UZB",
    "Asia/Seoul": "KOR",
    "Asia/Shanghai": "CHN",
    "Asia/Singapore": "SGP",
    "Asia/Srednekolymsk": "RUS",
    "Asia/Taipei": "TWN",
    "Asia/Tashkent": "UZB",
    "Asia/Tbilisi": "GEO",
    "Asia/Tehran": "IRN",
    "Asia/Thimphu": "BTN",
    "Asia/Tokyo": "JPN",
    "Asia/Tomsk": "RUS",
    "Asia/Ulaanbaatar": "MNG",
    "Asia/Urumqi": "CHN",
    "Asia/Ust-Nera": "RUS",
    "Asia/Vientiane": "LAO",
    "Asia/Vladivostok": "RUS",
    "Asia/Yakutsk": "RUS",
    "Asia/Yangon": "MMR",
    "Asia/Yekaterinburg": "RUS",
    "Asia/Yerevan": "ARM",
    "Europe/Amsterdam": "NLD",
    "Europe/Andorra": "AND",
    "Europe/Astrakhan": "RUS",
    "Europe/Athens": "GRC",
    "Europe/Belgrade": "SRB",
    "Europe/Berlin": "DEU",
    "Europe/Bratislava": "SVK",
    "Europe/Brussels": "BEL",
    "Europe/Bucharest": "ROU",
    "Europe/Budapest": "HUN",
    "Europe/Busingen": "DEU",
    "Europe/Chisinau": "MDA",
    "Europe/Copenhagen": "DNK",
    "Europe/Dublin": "IRL",
    "Europe/Gibraltar": "GIB",
    "Europe/Guernsey": "GGY",
    "Europe/Helsinki": "FIN",
    "Europe/Isle_of_Man": "IMN",
    "Europe/Istanbul": "TUR",
    "Europe/Jersey": "JEY",
    "Europe/Kaliningrad": "RUS",
    "Europe/Kiev": "UKR",
    "Europe/Kirov": "RUS",
    "Europe/Lisbon": "PRT",
    "Europe/Ljubljana": "SVN",
    "Europe/London": "GBR",
    "Europe/Luxembourg": "LUX",
    "Europe/Madrid": "ESP",
    "Europe/Malta": "MLT",
    "Europe/Mariehamn": "ALA",
    "Europe/Minsk": "BLR",
    "Europe/Monaco": "MCO",
    "Europe/Moscow": "RUS",
    "Europe/Oslo": "NOR",
    "Europe/Paris": "FRA",
    "Europe/Podgorica": "MNE",
    "Europe/Prague": "CZE",
    "Europe/Riga": "LVA",
    "Europe/Rome": "ITA",
    "Europe/Samara": "RUS",
    "Europe/San_Marino": "SMR",
    "Europe/Sarajevo": "BIH",
    "Europe/Saratov": "RUS",
    "Europe/Simferopol": "UKR",
    "Europe/Skopje": "MKD",
    "Europe/Sofia": "BGR",
    "Europe/Stockholm": "SWE",
    "Europe/Tallinn": "EST",
    "Europe/Tirane": "ALB",
    "Europe/Ulyanovsk": "RUS",
    "Europe/Uzhgorod": "UKR",
    "Europe/Vaduz": "LIE",
    "Europe/Vatican": "VAT",
    "Europe/Vienna": "AUT",
    "Europe/Vilnius": "LTU",
    "Europe/Volgograd": "RUS",
    "Europe/Warsaw": "POL",
    "Europe/Zagreb": "HRV",
    "Europe/Zaporozhye": "UKR",
    "Europe/Zurich": "CHE",
    "Pacific/Apia": "WSM",
    "Pacific/Auckland": "NZL",
    "Pacific/Bougainville": "PNG",
    "Pacific/Chatham": "NZL",
    "Pacific/Chuuk": "FSM",
    "Pacific/Easter": "CHL",
    "Pacific/Efate": "VUT",
    "Pacific/Enderbury": "KIR",
    "Pacific/Fakaofo": "TKL",
    "Pacific/Fiji": "FJI",
    "Pacific/Funafuti": "TUV",
    "Pacific/Galapagos": "ECU",
    "Pacific/Gambier": "PYF",
    "Pacific/Guadalcanal": "SLB",
    "Pacific/Guam": "GUM",
    "Pacific/Honolulu": "USA",
    "Pacific/Kanton": "KIR",
    "Pacific/Kiritimati": "KIR",
    "Pacific/Kosrae": "FSM",
    "Pacific/Kwajalein": "MHL",
    "Pacific/Majuro": "MHL",
    "Pacific/Marquesas": "PYF",
    "Pacific/Midway": "UMI",
    "Pacific/Nauru": "NRU",
    "Pacific/Niue": "NIU",
    "Pacific/Norfolk": "NFK",
    "Pacific/Noumea": "NCL",
    "Pacific/Pago_Pago": "ASM",
    "Pacific/Palau": "PLW",
    "Pacific/Pitcairn": "PCN",
    "Pacific/Pohnpei": "FSM",
    "Pacific/Port_Moresby": "PNG",
    "Pacific/Rarotonga": "COK",
    "Pacific/Saipan": "MNP",
    "Pacific/Tahiti": "PYF",
    "Pacific/Tarawa": "KIR",
    "Pacific/Tongatapu": "TON",
    "Pacific/Wake": "UMI",
    "Pacific/Wallis": "WLF",
    "Atlantic/Azores": "PRT",
    "Atlantic/Bermuda": "BMU",
    "Atlantic/Canary": "ESP",
    "Atlantic/Cape_Verde": "CPV",
    "Atlantic/Faroe": "FRO",
    "Atlantic/Madeira": "PRT",
    "Atlantic/Reykjavik": "ISL",
    "Atlantic/South_Georgia": "SGS",
    "Atlantic/Stanley": "FLK",
    "Atlantic/St_Helena": "SHN",
    "Indian/Antananarivo": "MDG",
    "Indian/Chagos": "IOT",
    "Indian/Christmas": "CXR",
    "Indian/Cocos": "CCK",
    "Indian/Comoro": "COM",
    "Indian/Kerguelen": "ATF",
    "Indian/Mahe": "SYC",
    "Indian/Maldives": "MDV",
    "Indian/Mauritius": "MUS",
    "Indian/Mayotte": "MYT",
    "Indian/Reunion": "REU"
};
const $09fb73145d482738$export$6a0edaff40da71d9 = "4-4-2";
const $09fb73145d482738$export$bab71a2327e19ba7 = {
    twitter: "twitter"
};
const $09fb73145d482738$export$23edf5beed16cb16 = "/assets/images/ipublisher.jpg";
const $09fb73145d482738$export$d9842a8ce5c1e2e7 = {
    notStartYet: "NYS",
    finished: "Finished",
    finishedAET: "Finished AET"
};
const $09fb73145d482738$export$6cfedb50ed36eaa9 = {
    football: "football",
    cricket: "cricket",
    tennis: "tennis",
    rugby: "rugby",
    basketball: "basketball"
};
const $09fb73145d482738$export$1d6744690e556718 = "https://sportcccmsbackend.6lgx.com";
const $09fb73145d482738$export$18acc80fdf0e8f1a = ()=>{
    if (typeof document === "undefined") return $09fb73145d482738$export$1d6744690e556718;
    const container = document.querySelector(".microservice-cont");
    const baseUrl = container?.getAttribute("data-base-url");
    if (!baseUrl) return $09fb73145d482738$export$1d6744690e556718;
    try {
        const url = new URL(baseUrl);
        // Remove "cms-" or "cms." prefix from hostname
        const hostname = url.hostname.replace(/^cms[-.]/, "");
        return `${url.protocol}//${hostname}`;
    } catch  {
        return $09fb73145d482738$export$1d6744690e556718;
    }
};

});


parcelRegister("2bSDe", function(module, exports) {

$parcel$export(module.exports, "loadStyles", function () { return $1986fc8ffe3114a4$export$277cf3cf4a1518cd; });
parcelRequire("6cds3");
const $1986fc8ffe3114a4$export$277cf3cf4a1518cd = async (cssFileName)=>{
    try {
        const existingStyle = document.getElementById(cssFileName);
        if (!existingStyle) {
            const response = await fetch(`${"https://ipublisher-microservices.6lgx.com/public/assets/css"}/${cssFileName}.min.css`);
            const css = await response.text();
            const style = document.createElement("style");
            style.textContent = css;
            style.id = cssFileName;
            document.head.appendChild(style);
        }
    } catch (error) {
        console.error(`Failed to load ${cssFileName} CSS:`, error);
    }
};

});

parcelRegister("zSRJd", function(module, exports) {

$parcel$export(module.exports, "getData", function () { return $06bdd4294234ab8f$export$7a171f172be0782e; });
parcelRequire("6cds3");

var $iwaoO = parcelRequire("iwaoO");

var $j0vta = parcelRequire("j0vta");

var $d2xIZ = parcelRequire("d2xIZ");

var $grOPW = parcelRequire("grOPW");
const $06bdd4294234ab8f$export$7a171f172be0782e = async ({ dataId: dataId, dataType: dataType, baseUrl: baseUrl, sport: sport, date: date, type: type = "all", difference: difference, leagueId: leagueId, country: country = "PAK" })=>{
    const headers = {
        Token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9",
        country: country,
        difference: difference
    };
    try {
        // Special cases
        if (dataType === "league-stats") return await (0, $iwaoO.getLeagueStats)({
            baseUrl: baseUrl,
            sport: sport,
            dataId: dataId,
            headers: headers
        });
        // This component will work with football Team Api's and TEAM Head for All sports
        if (dataType.startsWith("team-") || dataType === "team") return await (0, $d2xIZ.getTeamData)({
            baseUrl: baseUrl,
            sport: sport,
            dataId: dataId,
            headers: headers,
            dataType: dataType,
            leagueId: leagueId
        });
        // This component will work with football Player Api's and PLAYER Head for All sports
        if (dataType.startsWith("player-") || dataType === "player") return await (0, $j0vta.getPlayerData)({
            baseUrl: baseUrl,
            sport: sport,
            dataId: dataId,
            headers: headers,
            dataType: dataType
        });
        // Cricket player handlers
        if (dataType.startsWith("cricket-player-")) return await (0, $j0vta.getPlayerData)({
            baseUrl: baseUrl,
            sport: sport,
            dataId: dataId,
            headers: headers,
            dataType: dataType
        });
        // URL mapped cases
        const url = (0, $grOPW.getMatchOrLeagueUrl)({
            dataType: dataType,
            dataId: dataId,
            sport: sport,
            baseUrl: baseUrl,
            date: date,
            type: type,
            leagueId: leagueId
        });
        if (!url) throw new Error("Invalid data type");
        const res = await fetch(url, {
            next: {
                revalidate: 0
            },
            headers: headers
        });
        if (!res.ok) throw new Error(`API Fails at: ${url} (Status: ${res.status})`);
        console.log("API Runs at:", url);
        return await res.json();
    } catch (error) {
        console.error("Error fetching data:", error);
        return null;
    }
};

});
parcelRegister("iwaoO", function(module, exports) {

$parcel$export(module.exports, "getLeagueStats", function () { return $d7b3483d4378cc51$export$f2d19cef3e7c1f08; });
parcelRequire("6cds3");
const $d7b3483d4378cc51$export$f2d19cef3e7c1f08 = async ({ baseUrl: baseUrl, sport: sport, dataId: dataId, headers: headers })=>{
    const endpoints = [
        `${baseUrl}/${sport}/stat/league/${dataId}/overview`,
        `${baseUrl}/${sport}/league/${dataId}/top-scorers`,
        `${baseUrl}/${sport}/league/${dataId}/top-assists`
    ];
    const responses = await Promise.all(endpoints.map(async (endpoint)=>{
        const res = await fetch(endpoint, {
            next: {
                revalidate: 0
            },
            headers: headers
        });
        if (!res.ok) throw new Error(`Failed to fetch ${endpoint}`);
        return res.json();
    }));
    return {
        overview: responses[0],
        topScorers: responses[1],
        topAssists: responses[2]
    };
};

});

parcelRegister("j0vta", function(module, exports) {

$parcel$export(module.exports, "getPlayerData", function () { return $dd666d95f1cbd875$export$1fd07a512fec70fb; });
parcelRequire("6cds3");
const $dd666d95f1cbd875$var$fetchJson = async (url, headers)=>{
    const res = await fetch(url, {
        next: {
            revalidate: 0
        },
        headers: headers
    });
    if (!res.ok) throw new Error(`Failed fetch: ${url}`);
    return await res.json();
};
const $dd666d95f1cbd875$export$1fd07a512fec70fb = async ({ baseUrl: baseUrl, sport: sport, dataId: dataId, headers: headers, dataType: dataType })=>{
    switch(dataType){
        case "player-performance":
            {
                const leagues = await $dd666d95f1cbd875$var$fetchJson(`${baseUrl}/${sport}/player/${dataId}/leagues`, headers);
                const firstLeagueId = leagues?.data?.[0]?.id;
                if (!firstLeagueId) throw new Error("No league ID found for player");
                const performance = await $dd666d95f1cbd875$var$fetchJson(`${baseUrl}/${sport}/player/${dataId}/performance?leagueId=${firstLeagueId}`, headers);
                return {
                    league: leagues,
                    performance: performance
                };
            }
        case "player-info":
            {
                const info = await $dd666d95f1cbd875$var$fetchJson(`${baseUrl}/${sport}/player/${dataId}/info`, headers);
                return info;
            }
        case "player-history":
            {
                const history = await $dd666d95f1cbd875$var$fetchJson(`${baseUrl}/${sport}/player/${dataId}/transfer`, headers);
                return history;
            }
        case "player":
            {
                let playerDetail;
                if (sport === "golf") playerDetail = [];
                else {
                    const detailType = sport === "tennis" ? "header" : "detail";
                    playerDetail = await $dd666d95f1cbd875$var$fetchJson(`${baseUrl}/${sport}/player/${dataId}/${detailType}`, headers);
                }
                return playerDetail;
            }
        // Cricket Player - Head (biography header with photo, name, role, etc.)
        case "cricket-player-head":
            {
                const playerHead = await $dd666d95f1cbd875$var$fetchJson(`${baseUrl}/cricket/player/${dataId}/detail`, headers);
                return playerHead;
            }
        // Cricket Player - Info (overview, birthplace, education, teams)
        case "cricket-player-info":
            {
                const playerInfo = await $dd666d95f1cbd875$var$fetchJson(`${baseUrl}/cricket/player/${dataId}/info`, headers);
                return playerInfo;
            }
        // Cricket Player - Stats (batting/bowling statistics)
        case "cricket-player-stats":
            {
                const playerStats = await $dd666d95f1cbd875$var$fetchJson(`${baseUrl}/cricket/player/${dataId}/stats`, headers);
                return playerStats;
            }
        // Cricket Player - Matches (recent matches)
        case "cricket-player-matches":
            {
                const playerMatches = await $dd666d95f1cbd875$var$fetchJson(`${baseUrl}/cricket/player/${dataId}/matches`, headers);
                return playerMatches;
            }
        default:
            return null;
    }
};

});

parcelRegister("d2xIZ", function(module, exports) {

$parcel$export(module.exports, "getTeamData", function () { return $97e59f44a19156d1$export$c11a6707e0ba3a30; });
parcelRequire("6cds3");
const $97e59f44a19156d1$var$fetchJson = async (url, headers)=>{
    const res = await fetch(url, {
        next: {
            revalidate: 0
        },
        headers: headers
    });
    if (!res.ok) throw new Error(`Failed fetch: ${url}`);
    return await res.json();
};
const $97e59f44a19156d1$export$c11a6707e0ba3a30 = async ({ baseUrl: baseUrl, sport: sport, dataId: dataId, headers: headers, dataType: dataType, leagueId: leagueId })=>{
    if (sport !== 'football') {
        const teamHead = await $97e59f44a19156d1$var$fetchJson(`${baseUrl}/${sport}/team/${dataId}/header`, headers);
        return teamHead;
    }
    const leagues = await $97e59f44a19156d1$var$fetchJson(`${baseUrl}/${sport}/team/${dataId}/leagues`, headers);
    const firstLeagueId = leagues?.data?.[0]?.id;
    switch(dataType){
        case "team-standings":
            {
                const standings = await $97e59f44a19156d1$var$fetchJson(`${baseUrl}/${sport}/team/${dataId}/table?leagueId=${firstLeagueId}`, headers);
                return {
                    league: leagues,
                    standings: standings
                };
            }
        case "team-squad":
            {
                const squad = await $97e59f44a19156d1$var$fetchJson(`${baseUrl}/${sport}/stat/team/${dataId}/lineup?leagueId=${firstLeagueId}`, headers);
                return {
                    league: leagues,
                    squad: squad
                };
            }
        case "team-stats":
            {
                const stats = await $97e59f44a19156d1$var$fetchJson(`${baseUrl}/${sport}/stat/team/${dataId}/stats?leagueId=${firstLeagueId}`, headers);
                return {
                    league: leagues,
                    stats: stats
                };
            }
        case "team-player-stats":
            {
                const playerStats = await $97e59f44a19156d1$var$fetchJson(`${baseUrl}/${sport}/stat/team/${dataId}/player-stats?leagueId=${firstLeagueId}`, headers);
                return {
                    league: leagues,
                    stats: playerStats
                };
            }
        case "team":
            {
                const teamHeader = await $97e59f44a19156d1$var$fetchJson(`${baseUrl}/${sport}/team/${dataId}/header?leagueId=${leagueId || firstLeagueId}`, headers);
                return teamHeader;
            }
        case "team-upcoming":
            {
                const upcoming = await $97e59f44a19156d1$var$fetchJson(`${baseUrl}/${sport}/team/${dataId}/matches?type=upcoming`, headers);
                return upcoming;
            }
        case "team-results":
            {
                const results = await $97e59f44a19156d1$var$fetchJson(`${baseUrl}/${sport}/team/${dataId}/matches?type=finished`, headers);
                return results;
            }
        case "team-info":
            {
                const info = await $97e59f44a19156d1$var$fetchJson(`${baseUrl}/${sport}/team/${dataId}/info`, headers);
                return info;
            }
        case "team-news":
            {
                const news = await $97e59f44a19156d1$var$fetchJson(`${baseUrl}/${sport}/team/${dataId}/news`, headers);
                return news;
            }
        default:
            return null;
    }
};

});

parcelRegister("grOPW", function(module, exports) {

$parcel$export(module.exports, "getMatchOrLeagueUrl", function () { return $bf969a15123b294e$export$c01d6c99598415f3; });
parcelRequire("6cds3");
const $bf969a15123b294e$export$c01d6c99598415f3 = ({ dataType: dataType, dataId: dataId, sport: sport, baseUrl: baseUrl, date: date, type: type })=>{
    const mapping = {
        // HEADS
        "match": `/match/${dataId}/detail`,
        "league": `/league/${dataId}/header`,
        // I have handled Team Head in ./teamHandler because it requires LeagueId API.
        // I have handled Player Head in ./playerHandler because it requires LeagueId API.
        //LIVE CENTRE
        "live-centre": `${sport === 'golf' ? `/matches?match_type=${type}&date=${date}` : `/${sport === 'football' ? "new-matches" : "matches"}?type=${type}&date=${date}`}`,
        "live-match-detail": `${sport === 'golf' ? `/matches?match_type=${type}&date=${date}` : `/${sport === 'football' ? "new-matches" : "matches"}?type=${type}&date=${date}`}`,
        "horse-racing-live": `/meetings?date=${date}`,
        "football-live-centre": `/new-matches?type=${type}&date=${date}`,
        "rugby-live-centre": `/matches?type=${type}&date=${date}`,
        "basketball-live-centre": `/matches?type=${type}&date=${date}`,
        "tennis-live-centre": `/matches?type=${type}&date=${date}`,
        "icehockey-live-centre": `/matches?type=${type}&date=${date}`,
        "golf-live-centre": `/matches?match_type=${type}&date=${date}`,
        "horseracing-live-centre": `/meetings?date=${date}`,
        //FOOTBALL
        "match-table": `/match/${dataId}/table?type=3`,
        "match-h2h": `/match/${dataId}/h2h`,
        "match-stats": `/match/${dataId}/stat`,
        "match-lineup": `/match/${dataId}/lineup`,
        "match-info": `/match/${dataId}/summary`,
        "match-summary": `/match/${dataId}/summary`,
        "match-timeline": `/match/${dataId}/summary`,
        "match-editorial": `/match/${dataId}/summary`,
        "match-page": `/match/${dataId}/summary`,
        "match-com": `/match/${dataId}/commentary`,
        "match-news": `/match/${dataId}/news`,
        "league-standings": `/league/${dataId}/table`,
        "league-table": `/league/${dataId}/table`,
        "detailed-league-table": `/league/${dataId}/table?type=list`,
        "preview-league-table": `/league/${dataId}/table?type=list`,
        "league-top-scorers": `/league/${dataId}/top-scorers`,
        "league-info": `/league/${dataId}/info?groupBy=true`,
        "league-upcoming": `/league/${dataId}/matches?match_type=upcoming&groupBy=true`,
        "league-results": `/league/${dataId}/matches?match_type=finished&groupBy=true`,
        "league-finished": `/league/${dataId}/matches?match_type=finished&groupBy=true`,
        "league-news": `/league/${dataId}/news`,
        "league-teams": `/league/${dataId}}/teams`,
        // Cricket
        "cricket-match-info": `/match/${dataId}/info`,
        "cricket-match-live": `/match/${dataId}/live`,
        "cricket-match-standings": `/match/${dataId}/standings`,
        "cricket-match-scorecard": `/match/${dataId}/scorecard`,
        "cricket-match-wickets": `/match/${dataId}/fall-of-wickets`,
        "cricket-match-teams": `/match/${dataId}/teams`,
        "cricket-match-com": `/match/${dataId}/innings`,
        "cricket-league-info": `/league/${dataId}/info`,
        "cricket-league-upcoming": `/league/${dataId}/matches?match_type=upcoming`,
        "cricket-league-results": `/league/${dataId}/matches?match_type=finished`,
        "cricket-league-standings": `/league/${dataId}/table`,
        "cricket-team-info": `/team/${dataId}/info`,
        "cricket-team-upcoming": `/team/${dataId}/matches?match_type=upcoming`,
        "cricket-team-results": `/team/${dataId}/matches?match_type=finished`,
        //TENNIS
        "tennis-match": `/match/${dataId}/detail`,
        "tennis-match-info": `/match/${dataId}/commentary`,
        "tennis-match-stats": `/match/${dataId}/stat`,
        "tennis-rankings": `/rankings`,
        "tennis-league-info": `/league/${dataId}/info`,
        "tennis-league-upcoming": `/league/${dataId}/matches?type=upcoming`,
        "tennis-league-results": `/league/${dataId}/matches?type=finished`,
        "tennis-player-info": `/player/${dataId}/info`,
        "tennis-player-upcoming": `/player/${dataId}/matches?type=upcoming`,
        "tennis-player-results": `/player/${dataId}/matches?type=finished`,
        //BASKETBALL
        "basketball-match": `/match/${dataId}/detail`,
        "basketball-match-info": `/match/${dataId}/info`,
        "basketball-match-stats": `/match/${dataId}/stat`,
        "basketball-match-lineup": `/match/${dataId}/lineup`,
        "basketball-match-h2h": `/match/${dataId}/h2h`,
        "basketball-match-table": `/match/${dataId}/table`,
        "basketball-match-scoring": `/match/${dataId}/scoring`,
        "basketball-team-info": `/team/${dataId}/info`,
        "basketball-team-upcoming": `/team/${dataId}/matches?type=upcoming`,
        "basketball-team-results": `/team/${dataId}/matches?type=finished`,
        "basketball-league-info": `/league/${dataId}/info`,
        "basketball-league-upcoming": `/league/${dataId}/matches?type=upcoming`,
        "basketball-league-results": `/league/${dataId}/matches?type=finished`,
        "basketball-league-standings": `/league/${dataId}/table`,
        //RUGBY 
        "rugby-match": `/match/${dataId}/detail`,
        "rugby-match-detail": `/match/${dataId}/detail`,
        "rugby-match-info": `/match/${dataId}}/info`,
        "rugby-match-lineup": `/match/${dataId}}/lineup`,
        "rugby-match-standings": `/match/${dataId}}/table`,
        "rugby-league-info": `/league/${dataId}/info`,
        "rugby-league-upcoming": `/league/${dataId}/matches?match_type=upcoming`,
        "rugby-league-results": `/league/${dataId}/matches?match_type=finished`,
        "rugby-league-standings": `/league/${dataId}/table`,
        "rugby-team-info": `/team/${dataId}/info`,
        "rugby-team-upcoming": `/team/${dataId}/matches?matches=upcoming`,
        "rugby-team-results": `/team/${dataId}/matches?matches=finished`,
        "rugby-team-standings": `/team/${dataId}/table`,
        //GOLF
        "golf-league-info": `/league/${dataId}/summary`,
        "golf-league-news": `/news/league/${dataId}?page=1&limit=10`,
        "golf-player-card": `/match/${dataId}/summary`,
        //FORMULA 1  (sport = formula1 → base/formula1/…)
        "f1-standings": `/driver-standings`,
        "f1-championship-standings": `/driver-standings`,
        "f1-driver-standings": `/driver-standings`,
        "f1-team-standings": `/team-standings`,
        "f1-races": `/races`,
        "f1-race-calendar": `/races`,
        "f1-race-hero": `/races`,
        "f1-race-results": `/${dataId}/races`,
        "f1-drivers": `/drivers`,
        "f1-teams": `/teams`,
        //Horse Racing
        "horse-racing-cards": `/meeting/${dataId}/runners`,
        //Ice Hockey
        "icehockey-match": `/match/${dataId}/detail`,
        "icehockey-match-info": `/match/${dataId}/summary`,
        "icehockey-match-stats": `/match/${dataId}/stats`,
        "icehockey-match-h2h": `/match/${dataId}/h2h`,
        "icehockey-match-table": `/match/${dataId}/standing`,
        "icehockey-league-info": `/league/${dataId}/info`,
        "icehockey-league-upcoming": `/league/${dataId}/matches?type=upcoming`,
        "icehockey-league-results": `/league/${dataId}/matches?type=finished`,
        "icehockey-league-standings": `/league/${dataId}/table`,
        "icehockey-team-info": `/team/${dataId}/info`,
        "icehockey-team-upcoming": `/team/${dataId}/matches?type=upcoming`,
        "icehockey-team-results": `/team/${dataId}/matches?type=finished`
    };
    const path = mapping[dataType];
    return path ? `${baseUrl}/${sport}${path}` : null;
};

});


parcelRegister("XBIJN", function(module, exports) {

$parcel$export(module.exports, "MatchOptions", function () { return $0b32c552bbb265ad$export$1924024727a20c21; });
parcelRequire("6cds3");
const $0b32c552bbb265ad$export$1924024727a20c21 = {
    footballLiveStatuses: [
        "inprogress",
        "1st half",
        "2nd half",
        "half time",
        "et 2nd half",
        "et 1st half",
        "penalty"
    ],
    footballFTStatuses: [
        "finished",
        "finished ap",
        "finished aet"
    ],
    basketballLiveStatuses: [
        "q1",
        "q2",
        "q3",
        "q4",
        "q5",
        "inprogress",
        "1st Innings",
        "2nd Innings"
    ]
};
const $0b32c552bbb265ad$export$a0a58944f2da054b = ()=>Number(document.querySelector(".nav-tabs .active .count")?.textContent);
const $0b32c552bbb265ad$export$c494add9144a5ebc = (match)=>[
        "finished",
        "finished ap",
        "finished aet",
        "awarded",
        "cancelled",
        "postponed",
        "abandoned",
        "deleted",
        "result only",
        "stumps"
    ]?.includes(match?.st?.toLowerCase() || match?.bs?.toLowerCase());

});

parcelRegister("gtwOm", function(module, exports) {

$parcel$export(module.exports, "useSocket", function () { return $bfe8ce6ccecd7fa8$export$cb4e378d7d3467ee; });

var $6cds3 = parcelRequire("6cds3");

var $55VXG = parcelRequire("55VXG");

var $iOnI3 = parcelRequire("iOnI3");
const $bfe8ce6ccecd7fa8$export$cb4e378d7d3467ee = (url)=>{
    const [socket, setSocket] = (0, $6cds3.useState)(null);
    (0, $6cds3.useEffect)(()=>{
        if (!url) {
            console.warn("Socket URL is required");
            return;
        }
        if (typeof window !== "undefined") {
            window.io = (0, (/*@__PURE__*/$parcel$interopDefault($55VXG)));
            window.Echo = new (0, $iOnI3.default)({
                broadcaster: "socket.io",
                host: url
            });
            const connector = window?.Echo?.connector;
            const _socket = connector?.socket;
            _socket?.on("connect", ()=>{
                console.log("Connected");
            });
            _socket?.on("connect_failed", (e)=>{
                console.error(`Connection failed: ${e}`);
            });
            _socket?.on("error", (e)=>{
                console.error(`Socket error: ${e}`);
            });
            _socket?.on("disconnect", ()=>{
                console.log("Disconnected");
            });
            setSocket(window.Echo);
            return ()=>{
                window?.Echo?.disconnect();
            };
        }
    }, [
        url
    ]);
    return socket;
};

});
parcelRegister("55VXG", function(module, exports) {
/**
 * Module dependencies.
 */ 
var $epCaG = parcelRequire("epCaG");

var $TeDYR = parcelRequire("TeDYR");


var debug = (parcelRequire("fhMUH"))('socket.io-client');
/**
 * Module exports.
 */ module.exports = exports = lookup;
/**
 * Managers cache.
 */ var cache = exports.managers = {};
/**
 * Looks up an existing `Manager` for multiplexing.
 * If the user summons:
 *
 *   `io('http://localhost/a');`
 *   `io('http://localhost/b');`
 *
 * We reuse the existing instance based on same scheme/port/host,
 * and we initialize sockets for each namespace.
 *
 * @api public
 */ function lookup(uri, opts) {
    if (typeof uri === 'object') {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    var parsed = $epCaG(uri);
    var source = parsed.source;
    var id = parsed.id;
    var path = parsed.path;
    var sameNamespace = cache[id] && path in cache[id].nsps;
    var newConnection = opts.forceNew || opts['force new connection'] || false === opts.multiplex || sameNamespace;
    var io;
    if (newConnection) {
        debug('ignoring socket cache for %s', source);
        io = (parcelRequire("4W00a"))(source, opts);
    } else {
        if (!cache[id]) {
            debug('new io instance for %s', source);
            cache[id] = (parcelRequire("4W00a"))(source, opts);
        }
        io = cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.query;
    return io.socket(parsed.path, opts);
}
/**
 * Protocol version.
 *
 * @api public
 */ exports.protocol = $TeDYR.protocol;
/**
 * `connect`.
 *
 * @param {String} uri
 * @api public
 */ exports.connect = lookup;

/**
 * Expose constructors for standalone build.
 *
 * @api public
 */ exports.Manager = (parcelRequire("4W00a"));

exports.Socket = (parcelRequire("5w5Yh"));

});
parcelRegister("epCaG", function(module, exports) {
/**
 * Module dependencies.
 */ 
var $43fDP = parcelRequire("43fDP");

var $a7e10284f0d6503e$var$debug = (parcelRequire("fhMUH"))('socket.io-client:url');
/**
 * Module exports.
 */ module.exports = $a7e10284f0d6503e$var$url;
/**
 * URL parser.
 *
 * @param {String} url
 * @param {Object} An object meant to mimic window.location.
 *                 Defaults to window.location.
 * @api public
 */ function $a7e10284f0d6503e$var$url(uri, loc) {
    var obj = uri;
    // default to window.location
    loc = loc || typeof location !== 'undefined' && location;
    if (null == uri) uri = loc.protocol + '//' + loc.host;
    // relative path support
    if ('string' === typeof uri) {
        if ('/' === uri.charAt(0)) {
            if ('/' === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            $a7e10284f0d6503e$var$debug('protocol-less url %s', uri);
            if ('undefined' !== typeof loc) uri = loc.protocol + '//' + uri;
            else uri = 'https://' + uri;
        }
        // parse
        $a7e10284f0d6503e$var$debug('parse %s', uri);
        obj = $43fDP(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = '80';
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = '443';
    }
    obj.path = obj.path || '/';
    var ipv6 = obj.host.indexOf(':') !== -1;
    var host = ipv6 ? '[' + obj.host + ']' : obj.host;
    // define unique id
    obj.id = obj.protocol + '://' + host + ':' + obj.port;
    // define href
    obj.href = obj.protocol + '://' + host + (loc && loc.port === obj.port ? '' : ':' + obj.port);
    return obj;
}

});
parcelRegister("43fDP", function(module, exports) {
/**
 * Parses an URI
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ var $2f339344a3788d91$var$re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
var $2f339344a3788d91$var$parts = [
    'source',
    'protocol',
    'authority',
    'userInfo',
    'user',
    'password',
    'host',
    'port',
    'relative',
    'path',
    'directory',
    'file',
    'query',
    'anchor'
];
module.exports = function parseuri(str) {
    var src = str, b = str.indexOf('['), e = str.indexOf(']');
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    var m = $2f339344a3788d91$var$re.exec(str || ''), uri = {}, i = 14;
    while(i--)uri[$2f339344a3788d91$var$parts[i]] = m[i] || '';
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }
    uri.pathNames = $2f339344a3788d91$var$pathNames(uri, uri['path']);
    uri.queryKey = $2f339344a3788d91$var$queryKey(uri, uri['query']);
    return uri;
};
function $2f339344a3788d91$var$pathNames(obj, path) {
    var regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.substr(0, 1) == '/' || path.length === 0) names.splice(0, 1);
    if (path.substr(path.length - 1, 1) == '/') names.splice(names.length - 1, 1);
    return names;
}
function $2f339344a3788d91$var$queryKey(uri, query) {
    var data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}

});

parcelRegister("fhMUH", function(module, exports) {
/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */ 
exports = module.exports = (parcelRequire("bdgyR"));
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome && 'undefined' != typeof chrome.storage ? chrome.storage.local : localstorage();
/**
 * Colors.
 */ exports.colors = [
    '#0000CC',
    '#0000FF',
    '#0033CC',
    '#0033FF',
    '#0066CC',
    '#0066FF',
    '#0099CC',
    '#0099FF',
    '#00CC00',
    '#00CC33',
    '#00CC66',
    '#00CC99',
    '#00CCCC',
    '#00CCFF',
    '#3300CC',
    '#3300FF',
    '#3333CC',
    '#3333FF',
    '#3366CC',
    '#3366FF',
    '#3399CC',
    '#3399FF',
    '#33CC00',
    '#33CC33',
    '#33CC66',
    '#33CC99',
    '#33CCCC',
    '#33CCFF',
    '#6600CC',
    '#6600FF',
    '#6633CC',
    '#6633FF',
    '#66CC00',
    '#66CC33',
    '#9900CC',
    '#9900FF',
    '#9933CC',
    '#9933FF',
    '#99CC00',
    '#99CC33',
    '#CC0000',
    '#CC0033',
    '#CC0066',
    '#CC0099',
    '#CC00CC',
    '#CC00FF',
    '#CC3300',
    '#CC3333',
    '#CC3366',
    '#CC3399',
    '#CC33CC',
    '#CC33FF',
    '#CC6600',
    '#CC6633',
    '#CC9900',
    '#CC9933',
    '#CCCC00',
    '#CCCC33',
    '#FF0000',
    '#FF0033',
    '#FF0066',
    '#FF0099',
    '#FF00CC',
    '#FF00FF',
    '#FF3300',
    '#FF3333',
    '#FF3366',
    '#FF3399',
    '#FF33CC',
    '#FF33FF',
    '#FF6600',
    '#FF6633',
    '#FF9900',
    '#FF9933',
    '#FFCC00',
    '#FFCC33'
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') return true;
    // Internet Explorer and Edge do not support colors.
    if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return false;
    // is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ exports.formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (err) {
        return '[UnexpectedJSONParseError]: ' + err.message;
    }
};
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    var useColors = this.useColors;
    args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ') + '+' + exports.humanize(this.diff);
    if (!useColors) return;
    var c = 'color: ' + this.color;
    args.splice(1, 0, c, 'color: inherit');
    // the final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    var index = 0;
    var lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, function(match) {
        if ('%%' === match) return;
        index++;
        if ('%c' === match) // we only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */ function log() {
    // this hackery is required for IE8/9, where
    // the `console.log` function doesn't have 'apply'
    return 'object' === typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
}
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (null == namespaces) exports.storage.removeItem('debug');
        else exports.storage.debug = namespaces;
    } catch (e) {}
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    var r;
    try {
        r = exports.storage.debug;
    } catch (e) {}
    return r;
}
/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */ exports.enable(load());
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        return window.localStorage;
    } catch (e) {}
}

});
parcelRegister("bdgyR", function(module, exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */ exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;

exports.humanize = (parcelRequire("kWcFU"));
/**
 * Active `debug` instances.
 */ exports.instances = [];
/**
 * The currently active debug mode names, and names to skip.
 */ exports.names = [];
exports.skips = [];
/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */ exports.formatters = {};
/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */ function selectColor(namespace) {
    var hash = 0, i;
    for(i in namespace){
        hash = (hash << 5) - hash + namespace.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
    }
    return exports.colors[Math.abs(hash) % exports.colors.length];
}
/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */ function createDebug(namespace) {
    var prevTime;
    function debug() {
        // disabled?
        if (!debug.enabled) return;
        var self = debug;
        // set `diff` timestamp
        var curr = +new Date();
        var ms = curr - (prevTime || curr);
        self.diff = ms;
        self.prev = prevTime;
        self.curr = curr;
        prevTime = curr;
        // turn the `arguments` into a proper Array
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        args[0] = exports.coerce(args[0]);
        if ('string' !== typeof args[0]) // anything else let's inspect with %O
        args.unshift('%O');
        // apply any `formatters` transformations
        var index = 0;
        args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
            // if we encounter an escaped % then don't increase the array index
            if (match === '%%') return match;
            index++;
            var formatter = exports.formatters[format];
            if ('function' === typeof formatter) {
                var val = args[index];
                match = formatter.call(self, val);
                // now we need to remove `args[index]` since it's inlined in the `format`
                args.splice(index, 1);
                index--;
            }
            return match;
        });
        // apply env-specific formatting (colors, etc.)
        exports.formatArgs.call(self, args);
        var logFn = debug.log || exports.log || console.log.bind(console);
        logFn.apply(self, args);
    }
    debug.namespace = namespace;
    debug.enabled = exports.enabled(namespace);
    debug.useColors = exports.useColors();
    debug.color = selectColor(namespace);
    debug.destroy = destroy;
    // env-specific initialization logic for debug instances
    if ('function' === typeof exports.init) exports.init(debug);
    exports.instances.push(debug);
    return debug;
}
function destroy() {
    var index = exports.instances.indexOf(this);
    if (index !== -1) {
        exports.instances.splice(index, 1);
        return true;
    } else return false;
}
/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */ function enable(namespaces) {
    exports.save(namespaces);
    exports.names = [];
    exports.skips = [];
    var i;
    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
    var len = split.length;
    for(i = 0; i < len; i++){
        if (!split[i]) continue; // ignore empty strings
        namespaces = split[i].replace(/\*/g, '.*?');
        if (namespaces[0] === '-') exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
        else exports.names.push(new RegExp('^' + namespaces + '$'));
    }
    for(i = 0; i < exports.instances.length; i++){
        var instance = exports.instances[i];
        instance.enabled = exports.enabled(instance.namespace);
    }
}
/**
 * Disable debug output.
 *
 * @api public
 */ function disable() {
    exports.enable('');
}
/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */ function enabled(name) {
    if (name[name.length - 1] === '*') return true;
    var i, len;
    for(i = 0, len = exports.skips.length; i < len; i++){
        if (exports.skips[i].test(name)) return false;
    }
    for(i = 0, len = exports.names.length; i < len; i++){
        if (exports.names[i].test(name)) return true;
    }
    return false;
}
/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */ function coerce(val) {
    if (val instanceof Error) return val.stack || val.message;
    return val;
}

});
parcelRegister("kWcFU", function(module, exports) {
/**
 * Helpers.
 */ var $f3e30e67428adcf3$var$s = 1000;
var $f3e30e67428adcf3$var$m = $f3e30e67428adcf3$var$s * 60;
var $f3e30e67428adcf3$var$h = $f3e30e67428adcf3$var$m * 60;
var $f3e30e67428adcf3$var$d = $f3e30e67428adcf3$var$h * 24;
var $f3e30e67428adcf3$var$y = $f3e30e67428adcf3$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === 'string' && val.length > 0) return $f3e30e67428adcf3$var$parse(val);
    else if (type === 'number' && isNaN(val) === false) return options.long ? $f3e30e67428adcf3$var$fmtLong(val) : $f3e30e67428adcf3$var$fmtShort(val);
    throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $f3e30e67428adcf3$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || 'ms').toLowerCase();
    switch(type){
        case 'years':
        case 'year':
        case 'yrs':
        case 'yr':
        case 'y':
            return n * $f3e30e67428adcf3$var$y;
        case 'days':
        case 'day':
        case 'd':
            return n * $f3e30e67428adcf3$var$d;
        case 'hours':
        case 'hour':
        case 'hrs':
        case 'hr':
        case 'h':
            return n * $f3e30e67428adcf3$var$h;
        case 'minutes':
        case 'minute':
        case 'mins':
        case 'min':
        case 'm':
            return n * $f3e30e67428adcf3$var$m;
        case 'seconds':
        case 'second':
        case 'secs':
        case 'sec':
        case 's':
            return n * $f3e30e67428adcf3$var$s;
        case 'milliseconds':
        case 'millisecond':
        case 'msecs':
        case 'msec':
        case 'ms':
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $f3e30e67428adcf3$var$fmtShort(ms) {
    if (ms >= $f3e30e67428adcf3$var$d) return Math.round(ms / $f3e30e67428adcf3$var$d) + 'd';
    if (ms >= $f3e30e67428adcf3$var$h) return Math.round(ms / $f3e30e67428adcf3$var$h) + 'h';
    if (ms >= $f3e30e67428adcf3$var$m) return Math.round(ms / $f3e30e67428adcf3$var$m) + 'm';
    if (ms >= $f3e30e67428adcf3$var$s) return Math.round(ms / $f3e30e67428adcf3$var$s) + 's';
    return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $f3e30e67428adcf3$var$fmtLong(ms) {
    return $f3e30e67428adcf3$var$plural(ms, $f3e30e67428adcf3$var$d, 'day') || $f3e30e67428adcf3$var$plural(ms, $f3e30e67428adcf3$var$h, 'hour') || $f3e30e67428adcf3$var$plural(ms, $f3e30e67428adcf3$var$m, 'minute') || $f3e30e67428adcf3$var$plural(ms, $f3e30e67428adcf3$var$s, 'second') || ms + ' ms';
}
/**
 * Pluralization helper.
 */ function $f3e30e67428adcf3$var$plural(ms, n, name) {
    if (ms < n) return;
    if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
    return Math.ceil(ms / n) + ' ' + name + 's';
}

});




parcelRegister("TeDYR", function(module, exports) {

$parcel$export(module.exports, "protocol", function () { return $0a607f21d602988c$export$a51d6b395ff4c65a; }, function (v) { return $0a607f21d602988c$export$a51d6b395ff4c65a = v; });
$parcel$export(module.exports, "types", function () { return $0a607f21d602988c$export$b14ad400b1d09e0f; }, function (v) { return $0a607f21d602988c$export$b14ad400b1d09e0f = v; });
$parcel$export(module.exports, "CONNECT", function () { return $0a607f21d602988c$export$df50b52b1548c0dc; }, function (v) { return $0a607f21d602988c$export$df50b52b1548c0dc = v; });
$parcel$export(module.exports, "DISCONNECT", function () { return $0a607f21d602988c$export$5fd12e2e89ab14dc; }, function (v) { return $0a607f21d602988c$export$5fd12e2e89ab14dc = v; });
$parcel$export(module.exports, "EVENT", function () { return $0a607f21d602988c$export$e39a34cfd532e15; }, function (v) { return $0a607f21d602988c$export$e39a34cfd532e15 = v; });
$parcel$export(module.exports, "ACK", function () { return $0a607f21d602988c$export$8b9f6dafceb64eb3; }, function (v) { return $0a607f21d602988c$export$8b9f6dafceb64eb3 = v; });
$parcel$export(module.exports, "ERROR", function () { return $0a607f21d602988c$export$103bedf43ba882db; }, function (v) { return $0a607f21d602988c$export$103bedf43ba882db = v; });
$parcel$export(module.exports, "BINARY_EVENT", function () { return $0a607f21d602988c$export$4e593a8e75481d89; }, function (v) { return $0a607f21d602988c$export$4e593a8e75481d89 = v; });
$parcel$export(module.exports, "BINARY_ACK", function () { return $0a607f21d602988c$export$153fee94313d337d; }, function (v) { return $0a607f21d602988c$export$153fee94313d337d = v; });
$parcel$export(module.exports, "Encoder", function () { return $0a607f21d602988c$export$a50aceb0e02a00aa; }, function (v) { return $0a607f21d602988c$export$a50aceb0e02a00aa = v; });
$parcel$export(module.exports, "Decoder", function () { return $0a607f21d602988c$export$f9de6ca0bc043724; }, function (v) { return $0a607f21d602988c$export$f9de6ca0bc043724 = v; });
/**
 * Module dependencies.
 */ /**
 * Protocol version.
 *
 * @api public
 */ var $0a607f21d602988c$export$a51d6b395ff4c65a;
/**
 * Packet types.
 *
 * @api public
 */ var $0a607f21d602988c$export$b14ad400b1d09e0f;
/**
 * Packet type `connect`.
 *
 * @api public
 */ var $0a607f21d602988c$export$df50b52b1548c0dc;
/**
 * Packet type `disconnect`.
 *
 * @api public
 */ var $0a607f21d602988c$export$5fd12e2e89ab14dc;
/**
 * Packet type `event`.
 *
 * @api public
 */ var $0a607f21d602988c$export$e39a34cfd532e15;
/**
 * Packet type `ack`.
 *
 * @api public
 */ var $0a607f21d602988c$export$8b9f6dafceb64eb3;
/**
 * Packet type `error`.
 *
 * @api public
 */ var $0a607f21d602988c$export$103bedf43ba882db;
/**
 * Packet type 'binary event'
 *
 * @api public
 */ var $0a607f21d602988c$export$4e593a8e75481d89;
/**
 * Packet type `binary ack`. For acks with binary arguments.
 *
 * @api public
 */ var $0a607f21d602988c$export$153fee94313d337d;
/**
 * Encoder constructor.
 *
 * @api public
 */ var $0a607f21d602988c$export$a50aceb0e02a00aa;
/**
 * Decoder constructor.
 *
 * @api public
 */ var $0a607f21d602988c$export$f9de6ca0bc043724;

var $0a607f21d602988c$var$debug = (parcelRequire("htNgI"))('socket.io-parser');

var $kHJIH = parcelRequire("kHJIH");

var $8Bk0Y = parcelRequire("8Bk0Y");

var $IMBTg = parcelRequire("IMBTg");

var $98Gf8 = parcelRequire("98Gf8");
$0a607f21d602988c$export$a51d6b395ff4c65a = 4;
$0a607f21d602988c$export$b14ad400b1d09e0f = [
    'CONNECT',
    'DISCONNECT',
    'EVENT',
    'ACK',
    'ERROR',
    'BINARY_EVENT',
    'BINARY_ACK'
];
$0a607f21d602988c$export$df50b52b1548c0dc = 0;
$0a607f21d602988c$export$5fd12e2e89ab14dc = 1;
$0a607f21d602988c$export$e39a34cfd532e15 = 2;
$0a607f21d602988c$export$8b9f6dafceb64eb3 = 3;
$0a607f21d602988c$export$103bedf43ba882db = 4;
$0a607f21d602988c$export$4e593a8e75481d89 = 5;
$0a607f21d602988c$export$153fee94313d337d = 6;
$0a607f21d602988c$export$a50aceb0e02a00aa = $0a607f21d602988c$var$Encoder;
$0a607f21d602988c$export$f9de6ca0bc043724 = $0a607f21d602988c$var$Decoder;
/**
 * A socket.io Encoder instance
 *
 * @api public
 */ function $0a607f21d602988c$var$Encoder() {}
var $0a607f21d602988c$var$ERROR_PACKET = $0a607f21d602988c$export$103bedf43ba882db + '"encode error"';
/**
 * Encode a packet as a single string if non-binary, or as a
 * buffer sequence, depending on packet type.
 *
 * @param {Object} obj - packet object
 * @param {Function} callback - function to handle encodings (likely engine.write)
 * @return Calls callback with Array of encodings
 * @api public
 */ $0a607f21d602988c$var$Encoder.prototype.encode = function(obj, callback) {
    $0a607f21d602988c$var$debug('encoding packet %j', obj);
    if ($0a607f21d602988c$export$4e593a8e75481d89 === obj.type || $0a607f21d602988c$export$153fee94313d337d === obj.type) $0a607f21d602988c$var$encodeAsBinary(obj, callback);
    else {
        var encoding = $0a607f21d602988c$var$encodeAsString(obj);
        callback([
            encoding
        ]);
    }
};
/**
 * Encode packet as string.
 *
 * @param {Object} packet
 * @return {String} encoded
 * @api private
 */ function $0a607f21d602988c$var$encodeAsString(obj) {
    // first is type
    var str = '' + obj.type;
    // attachments if we have them
    if ($0a607f21d602988c$export$4e593a8e75481d89 === obj.type || $0a607f21d602988c$export$153fee94313d337d === obj.type) str += obj.attachments + '-';
    // if we have a namespace other than `/`
    // we append it followed by a comma `,`
    if (obj.nsp && '/' !== obj.nsp) str += obj.nsp + ',';
    // immediately followed by the id
    if (null != obj.id) str += obj.id;
    // json data
    if (null != obj.data) {
        var payload = $0a607f21d602988c$var$tryStringify(obj.data);
        if (payload !== false) str += payload;
        else return $0a607f21d602988c$var$ERROR_PACKET;
    }
    $0a607f21d602988c$var$debug('encoded %j as %s', obj, str);
    return str;
}
function $0a607f21d602988c$var$tryStringify(str) {
    try {
        return JSON.stringify(str);
    } catch (e) {
        return false;
    }
}
/**
 * Encode packet as 'buffer sequence' by removing blobs, and
 * deconstructing packet into object with placeholders and
 * a list of buffers.
 *
 * @param {Object} packet
 * @return {Buffer} encoded
 * @api private
 */ function $0a607f21d602988c$var$encodeAsBinary(obj, callback) {
    function writeEncoding(bloblessData) {
        var deconstruction = $8Bk0Y.deconstructPacket(bloblessData);
        var pack = $0a607f21d602988c$var$encodeAsString(deconstruction.packet);
        var buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        callback(buffers); // write all the buffers
    }
    $8Bk0Y.removeBlobs(obj, writeEncoding);
}
/**
 * A socket.io Decoder instance
 *
 * @return {Object} decoder
 * @api public
 */ function $0a607f21d602988c$var$Decoder() {
    this.reconstructor = null;
}
/**
 * Mix in `Emitter` with Decoder.
 */ $kHJIH($0a607f21d602988c$var$Decoder.prototype);
/**
 * Decodes an encoded packet string into packet JSON.
 *
 * @param {String} obj - encoded packet
 * @return {Object} packet
 * @api public
 */ $0a607f21d602988c$var$Decoder.prototype.add = function(obj) {
    var packet;
    if (typeof obj === 'string') {
        if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
        packet = $0a607f21d602988c$var$decodeString(obj);
        if ($0a607f21d602988c$export$4e593a8e75481d89 === packet.type || $0a607f21d602988c$export$153fee94313d337d === packet.type) {
            this.reconstructor = new $0a607f21d602988c$var$BinaryReconstructor(packet);
            // no attachments, labeled binary but no binary data to follow
            if (this.reconstructor.reconPack.attachments === 0) this.emit('decoded', packet);
        } else this.emit('decoded', packet);
    } else if ($98Gf8(obj) || obj.base64) {
        if (!this.reconstructor) throw new Error('got binary data when not reconstructing a packet');
        else {
            packet = this.reconstructor.takeBinaryData(obj);
            if (packet) {
                this.reconstructor = null;
                this.emit('decoded', packet);
            }
        }
    } else throw new Error('Unknown type: ' + obj);
};
function $0a607f21d602988c$var$isPayloadValid(type, payload) {
    switch(type){
        case 0:
            return typeof payload === "object";
        case 1:
            return payload === undefined;
        case 4:
            return typeof payload === "string" || typeof payload === "object";
        case 2:
        case 5:
            return $IMBTg(payload) && (typeof payload[0] === "string" || typeof payload[0] === "number");
        case 3:
        case 6:
            return $IMBTg(payload);
    }
}
/**
 * Decode a packet String (JSON data)
 *
 * @param {String} str
 * @return {Object} packet
 * @api private
 */ function $0a607f21d602988c$var$decodeString(str) {
    var i = 0;
    // look up type
    var p = {
        type: Number(str.charAt(0))
    };
    if (null == $0a607f21d602988c$export$b14ad400b1d09e0f[p.type]) return $0a607f21d602988c$var$error('unknown packet type ' + p.type);
    // look up attachments if type binary
    if ($0a607f21d602988c$export$4e593a8e75481d89 === p.type || $0a607f21d602988c$export$153fee94313d337d === p.type) {
        var start = i + 1;
        while(str.charAt(++i) !== '-' && i != str.length);
        var buf = str.substring(start, i);
        if (buf != Number(buf) || str.charAt(i) !== '-') throw new Error('Illegal attachments');
        p.attachments = Number(buf);
    }
    // look up namespace (if any)
    if ('/' === str.charAt(i + 1)) {
        var start = i + 1;
        while(++i){
            var c = str.charAt(i);
            if (',' === c) break;
            if (i === str.length) break;
        }
        p.nsp = str.substring(start, i);
    } else p.nsp = '/';
    // look up id
    var next = str.charAt(i + 1);
    if ('' !== next && Number(next) == next) {
        var start = i + 1;
        while(++i){
            var c = str.charAt(i);
            if (null == c || Number(c) != c) {
                --i;
                break;
            }
            if (i === str.length) break;
        }
        p.id = Number(str.substring(start, i + 1));
    }
    // look up json data
    if (str.charAt(++i)) {
        var payload = $0a607f21d602988c$var$tryParse(str.substr(i));
        if ($0a607f21d602988c$var$isPayloadValid(p.type, payload)) p.data = payload;
        else throw new Error("invalid payload");
    }
    $0a607f21d602988c$var$debug('decoded %s as %j', str, p);
    return p;
}
function $0a607f21d602988c$var$tryParse(str) {
    try {
        return JSON.parse(str);
    } catch (e) {
        return false;
    }
}
/**
 * Deallocates a parser's resources
 *
 * @api public
 */ $0a607f21d602988c$var$Decoder.prototype.destroy = function() {
    if (this.reconstructor) this.reconstructor.finishedReconstruction();
};
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 * @api private
 */ function $0a607f21d602988c$var$BinaryReconstructor(packet) {
    this.reconPack = packet;
    this.buffers = [];
}
/**
 * Method to be called when binary data received from connection
 * after a BINARY_EVENT packet.
 *
 * @param {Buffer | ArrayBuffer} binData - the raw binary data received
 * @return {null | Object} returns null if more binary data is expected or
 *   a reconstructed packet object if all buffers have been received.
 * @api private
 */ $0a607f21d602988c$var$BinaryReconstructor.prototype.takeBinaryData = function(binData) {
    this.buffers.push(binData);
    if (this.buffers.length === this.reconPack.attachments) {
        var packet = $8Bk0Y.reconstructPacket(this.reconPack, this.buffers);
        this.finishedReconstruction();
        return packet;
    }
    return null;
};
/**
 * Cleans up binary packet reconstruction variables.
 *
 * @api private
 */ $0a607f21d602988c$var$BinaryReconstructor.prototype.finishedReconstruction = function() {
    this.reconPack = null;
    this.buffers = [];
};
function $0a607f21d602988c$var$error(msg) {
    return {
        type: $0a607f21d602988c$export$103bedf43ba882db,
        data: 'parser error: ' + msg
    };
}

});
parcelRegister("htNgI", function(module, exports) {
/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */ 
exports = module.exports = (parcelRequire("54kOV"));
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome && 'undefined' != typeof chrome.storage ? chrome.storage.local : localstorage();
/**
 * Colors.
 */ exports.colors = [
    '#0000CC',
    '#0000FF',
    '#0033CC',
    '#0033FF',
    '#0066CC',
    '#0066FF',
    '#0099CC',
    '#0099FF',
    '#00CC00',
    '#00CC33',
    '#00CC66',
    '#00CC99',
    '#00CCCC',
    '#00CCFF',
    '#3300CC',
    '#3300FF',
    '#3333CC',
    '#3333FF',
    '#3366CC',
    '#3366FF',
    '#3399CC',
    '#3399FF',
    '#33CC00',
    '#33CC33',
    '#33CC66',
    '#33CC99',
    '#33CCCC',
    '#33CCFF',
    '#6600CC',
    '#6600FF',
    '#6633CC',
    '#6633FF',
    '#66CC00',
    '#66CC33',
    '#9900CC',
    '#9900FF',
    '#9933CC',
    '#9933FF',
    '#99CC00',
    '#99CC33',
    '#CC0000',
    '#CC0033',
    '#CC0066',
    '#CC0099',
    '#CC00CC',
    '#CC00FF',
    '#CC3300',
    '#CC3333',
    '#CC3366',
    '#CC3399',
    '#CC33CC',
    '#CC33FF',
    '#CC6600',
    '#CC6633',
    '#CC9900',
    '#CC9933',
    '#CCCC00',
    '#CCCC33',
    '#FF0000',
    '#FF0033',
    '#FF0066',
    '#FF0099',
    '#FF00CC',
    '#FF00FF',
    '#FF3300',
    '#FF3333',
    '#FF3366',
    '#FF3399',
    '#FF33CC',
    '#FF33FF',
    '#FF6600',
    '#FF6633',
    '#FF9900',
    '#FF9933',
    '#FFCC00',
    '#FFCC33'
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') return true;
    // Internet Explorer and Edge do not support colors.
    if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return false;
    // is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ exports.formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (err) {
        return '[UnexpectedJSONParseError]: ' + err.message;
    }
};
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    var useColors = this.useColors;
    args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ') + '+' + exports.humanize(this.diff);
    if (!useColors) return;
    var c = 'color: ' + this.color;
    args.splice(1, 0, c, 'color: inherit');
    // the final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    var index = 0;
    var lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, function(match) {
        if ('%%' === match) return;
        index++;
        if ('%c' === match) // we only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */ function log() {
    // this hackery is required for IE8/9, where
    // the `console.log` function doesn't have 'apply'
    return 'object' === typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
}
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (null == namespaces) exports.storage.removeItem('debug');
        else exports.storage.debug = namespaces;
    } catch (e) {}
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    var r;
    try {
        r = exports.storage.debug;
    } catch (e) {}
    return r;
}
/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */ exports.enable(load());
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        return window.localStorage;
    } catch (e) {}
}

});
parcelRegister("54kOV", function(module, exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */ exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;

exports.humanize = (parcelRequire("bco2J"));
/**
 * Active `debug` instances.
 */ exports.instances = [];
/**
 * The currently active debug mode names, and names to skip.
 */ exports.names = [];
exports.skips = [];
/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */ exports.formatters = {};
/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */ function selectColor(namespace) {
    var hash = 0, i;
    for(i in namespace){
        hash = (hash << 5) - hash + namespace.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
    }
    return exports.colors[Math.abs(hash) % exports.colors.length];
}
/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */ function createDebug(namespace) {
    var prevTime;
    function debug() {
        // disabled?
        if (!debug.enabled) return;
        var self = debug;
        // set `diff` timestamp
        var curr = +new Date();
        var ms = curr - (prevTime || curr);
        self.diff = ms;
        self.prev = prevTime;
        self.curr = curr;
        prevTime = curr;
        // turn the `arguments` into a proper Array
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        args[0] = exports.coerce(args[0]);
        if ('string' !== typeof args[0]) // anything else let's inspect with %O
        args.unshift('%O');
        // apply any `formatters` transformations
        var index = 0;
        args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
            // if we encounter an escaped % then don't increase the array index
            if (match === '%%') return match;
            index++;
            var formatter = exports.formatters[format];
            if ('function' === typeof formatter) {
                var val = args[index];
                match = formatter.call(self, val);
                // now we need to remove `args[index]` since it's inlined in the `format`
                args.splice(index, 1);
                index--;
            }
            return match;
        });
        // apply env-specific formatting (colors, etc.)
        exports.formatArgs.call(self, args);
        var logFn = debug.log || exports.log || console.log.bind(console);
        logFn.apply(self, args);
    }
    debug.namespace = namespace;
    debug.enabled = exports.enabled(namespace);
    debug.useColors = exports.useColors();
    debug.color = selectColor(namespace);
    debug.destroy = destroy;
    // env-specific initialization logic for debug instances
    if ('function' === typeof exports.init) exports.init(debug);
    exports.instances.push(debug);
    return debug;
}
function destroy() {
    var index = exports.instances.indexOf(this);
    if (index !== -1) {
        exports.instances.splice(index, 1);
        return true;
    } else return false;
}
/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */ function enable(namespaces) {
    exports.save(namespaces);
    exports.names = [];
    exports.skips = [];
    var i;
    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
    var len = split.length;
    for(i = 0; i < len; i++){
        if (!split[i]) continue; // ignore empty strings
        namespaces = split[i].replace(/\*/g, '.*?');
        if (namespaces[0] === '-') exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
        else exports.names.push(new RegExp('^' + namespaces + '$'));
    }
    for(i = 0; i < exports.instances.length; i++){
        var instance = exports.instances[i];
        instance.enabled = exports.enabled(instance.namespace);
    }
}
/**
 * Disable debug output.
 *
 * @api public
 */ function disable() {
    exports.enable('');
}
/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */ function enabled(name) {
    if (name[name.length - 1] === '*') return true;
    var i, len;
    for(i = 0, len = exports.skips.length; i < len; i++){
        if (exports.skips[i].test(name)) return false;
    }
    for(i = 0, len = exports.names.length; i < len; i++){
        if (exports.names[i].test(name)) return true;
    }
    return false;
}
/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */ function coerce(val) {
    if (val instanceof Error) return val.stack || val.message;
    return val;
}

});
parcelRegister("bco2J", function(module, exports) {
/**
 * Helpers.
 */ var $82737725dfa16da1$var$s = 1000;
var $82737725dfa16da1$var$m = $82737725dfa16da1$var$s * 60;
var $82737725dfa16da1$var$h = $82737725dfa16da1$var$m * 60;
var $82737725dfa16da1$var$d = $82737725dfa16da1$var$h * 24;
var $82737725dfa16da1$var$y = $82737725dfa16da1$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === 'string' && val.length > 0) return $82737725dfa16da1$var$parse(val);
    else if (type === 'number' && isNaN(val) === false) return options.long ? $82737725dfa16da1$var$fmtLong(val) : $82737725dfa16da1$var$fmtShort(val);
    throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $82737725dfa16da1$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || 'ms').toLowerCase();
    switch(type){
        case 'years':
        case 'year':
        case 'yrs':
        case 'yr':
        case 'y':
            return n * $82737725dfa16da1$var$y;
        case 'days':
        case 'day':
        case 'd':
            return n * $82737725dfa16da1$var$d;
        case 'hours':
        case 'hour':
        case 'hrs':
        case 'hr':
        case 'h':
            return n * $82737725dfa16da1$var$h;
        case 'minutes':
        case 'minute':
        case 'mins':
        case 'min':
        case 'm':
            return n * $82737725dfa16da1$var$m;
        case 'seconds':
        case 'second':
        case 'secs':
        case 'sec':
        case 's':
            return n * $82737725dfa16da1$var$s;
        case 'milliseconds':
        case 'millisecond':
        case 'msecs':
        case 'msec':
        case 'ms':
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $82737725dfa16da1$var$fmtShort(ms) {
    if (ms >= $82737725dfa16da1$var$d) return Math.round(ms / $82737725dfa16da1$var$d) + 'd';
    if (ms >= $82737725dfa16da1$var$h) return Math.round(ms / $82737725dfa16da1$var$h) + 'h';
    if (ms >= $82737725dfa16da1$var$m) return Math.round(ms / $82737725dfa16da1$var$m) + 'm';
    if (ms >= $82737725dfa16da1$var$s) return Math.round(ms / $82737725dfa16da1$var$s) + 's';
    return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $82737725dfa16da1$var$fmtLong(ms) {
    return $82737725dfa16da1$var$plural(ms, $82737725dfa16da1$var$d, 'day') || $82737725dfa16da1$var$plural(ms, $82737725dfa16da1$var$h, 'hour') || $82737725dfa16da1$var$plural(ms, $82737725dfa16da1$var$m, 'minute') || $82737725dfa16da1$var$plural(ms, $82737725dfa16da1$var$s, 'second') || ms + ' ms';
}
/**
 * Pluralization helper.
 */ function $82737725dfa16da1$var$plural(ms, n, name) {
    if (ms < n) return;
    if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
    return Math.ceil(ms / n) + ' ' + name + 's';
}

});



parcelRegister("kHJIH", function(module, exports) {
/**
 * Expose `Emitter`.
 */ module.exports = $f12b49db5a0000fb$var$Emitter;
/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $f12b49db5a0000fb$var$Emitter(obj) {
    if (obj) return $f12b49db5a0000fb$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $f12b49db5a0000fb$var$mixin(obj) {
    for(var key in $f12b49db5a0000fb$var$Emitter.prototype)obj[key] = $f12b49db5a0000fb$var$Emitter.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $f12b49db5a0000fb$var$Emitter.prototype.on = $f12b49db5a0000fb$var$Emitter.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $f12b49db5a0000fb$var$Emitter.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $f12b49db5a0000fb$var$Emitter.prototype.off = $f12b49db5a0000fb$var$Emitter.prototype.removeListener = $f12b49db5a0000fb$var$Emitter.prototype.removeAllListeners = $f12b49db5a0000fb$var$Emitter.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks['$' + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks['$' + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks['$' + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $f12b49db5a0000fb$var$Emitter.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks['$' + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $f12b49db5a0000fb$var$Emitter.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks['$' + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $f12b49db5a0000fb$var$Emitter.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};

});

parcelRegister("8Bk0Y", function(module, exports) {

$parcel$export(module.exports, "deconstructPacket", function () { return $64314df329f0ebbc$export$ac2edb9eb7af56f6; }, function (v) { return $64314df329f0ebbc$export$ac2edb9eb7af56f6 = v; });
$parcel$export(module.exports, "reconstructPacket", function () { return $64314df329f0ebbc$export$a00da3b1ec037a04; }, function (v) { return $64314df329f0ebbc$export$a00da3b1ec037a04 = v; });
$parcel$export(module.exports, "removeBlobs", function () { return $64314df329f0ebbc$export$c546b07ca8124461; }, function (v) { return $64314df329f0ebbc$export$c546b07ca8124461 = v; });
/*global Blob,File*/ /**
 * Module requirements
 */ /**
 * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.
 * Anything with blobs or files should be fed through removeBlobs before coming
 * here.
 *
 * @param {Object} packet - socket.io event packet
 * @return {Object} with deconstructed packet and list of buffers
 * @api public
 */ var $64314df329f0ebbc$export$ac2edb9eb7af56f6;
/**
 * Reconstructs a binary packet from its placeholder packet and buffers
 *
 * @param {Object} packet - event packet with placeholders
 * @param {Array} buffers - binary buffers to put in placeholder positions
 * @return {Object} reconstructed packet
 * @api public
 */ var $64314df329f0ebbc$export$a00da3b1ec037a04;
/**
 * Asynchronously removes Blobs or Files from data via
 * FileReader's readAsArrayBuffer method. Used before encoding
 * data as msgpack. Calls callback with the blobless data.
 *
 * @param {Object} data
 * @param {Function} callback
 * @api private
 */ var $64314df329f0ebbc$export$c546b07ca8124461;

var $IMBTg = parcelRequire("IMBTg");

var $98Gf8 = parcelRequire("98Gf8");
var $64314df329f0ebbc$var$toString = Object.prototype.toString;
var $64314df329f0ebbc$var$withNativeBlob = typeof Blob === 'function' || typeof Blob !== 'undefined' && $64314df329f0ebbc$var$toString.call(Blob) === '[object BlobConstructor]';
var $64314df329f0ebbc$var$withNativeFile = typeof File === 'function' || typeof File !== 'undefined' && $64314df329f0ebbc$var$toString.call(File) === '[object FileConstructor]';
$64314df329f0ebbc$export$ac2edb9eb7af56f6 = function(packet) {
    var buffers = [];
    var packetData = packet.data;
    var pack = packet;
    pack.data = $64314df329f0ebbc$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
};
function $64314df329f0ebbc$var$_deconstructPacket(data, buffers) {
    if (!data) return data;
    if ($98Gf8(data)) {
        var placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if ($IMBTg(data)) {
        var newData = new Array(data.length);
        for(var i = 0; i < data.length; i++)newData[i] = $64314df329f0ebbc$var$_deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === 'object' && !(data instanceof Date)) {
        var newData = {};
        for(var key in data)newData[key] = $64314df329f0ebbc$var$_deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
$64314df329f0ebbc$export$a00da3b1ec037a04 = function(packet, buffers) {
    packet.data = $64314df329f0ebbc$var$_reconstructPacket(packet.data, buffers);
    packet.attachments = undefined; // no longer useful
    return packet;
};
function $64314df329f0ebbc$var$_reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        var isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        else throw new Error("illegal attachments");
    } else if ($IMBTg(data)) for(var i = 0; i < data.length; i++)data[i] = $64314df329f0ebbc$var$_reconstructPacket(data[i], buffers);
    else if (typeof data === 'object') for(var key in data)data[key] = $64314df329f0ebbc$var$_reconstructPacket(data[key], buffers);
    return data;
}
$64314df329f0ebbc$export$c546b07ca8124461 = function(data, callback) {
    function _removeBlobs(obj, curKey, containingObject) {
        if (!obj) return obj;
        // convert any blob
        if ($64314df329f0ebbc$var$withNativeBlob && obj instanceof Blob || $64314df329f0ebbc$var$withNativeFile && obj instanceof File) {
            pendingBlobs++;
            // async filereader
            var fileReader = new FileReader();
            fileReader.onload = function() {
                if (containingObject) containingObject[curKey] = this.result;
                else bloblessData = this.result;
                // if nothing pending its callback time
                if (!--pendingBlobs) callback(bloblessData);
            };
            fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer
        } else if ($IMBTg(obj)) for(var i = 0; i < obj.length; i++)_removeBlobs(obj[i], i, obj);
        else if (typeof obj === 'object' && !$98Gf8(obj)) for(var key in obj)_removeBlobs(obj[key], key, obj);
    }
    var pendingBlobs = 0;
    var bloblessData = data;
    _removeBlobs(bloblessData);
    if (!pendingBlobs) callback(bloblessData);
};

});
parcelRegister("IMBTg", function(module, exports) {
var $0869d122c510fe79$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $0869d122c510fe79$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("98Gf8", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $6a75a105009e80b1$require$Buffer = $gzLuY.Buffer;
module.exports = $6a75a105009e80b1$var$isBuf;
var $6a75a105009e80b1$var$withNativeBuffer = typeof $6a75a105009e80b1$require$Buffer === 'function' && typeof $6a75a105009e80b1$require$Buffer.isBuffer === 'function';
var $6a75a105009e80b1$var$withNativeArrayBuffer = typeof ArrayBuffer === 'function';
var $6a75a105009e80b1$var$isView = function(obj) {
    return typeof ArrayBuffer.isView === 'function' ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
/**
 * Returns true if obj is a buffer or an arraybuffer.
 *
 * @api private
 */ function $6a75a105009e80b1$var$isBuf(obj) {
    return $6a75a105009e80b1$var$withNativeBuffer && $6a75a105009e80b1$require$Buffer.isBuffer(obj) || $6a75a105009e80b1$var$withNativeArrayBuffer && (obj instanceof ArrayBuffer || $6a75a105009e80b1$var$isView(obj));
}

});
parcelRegister("gzLuY", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $c114c26e12685207$export$a143d493d941bafc; }, function (v) { return $c114c26e12685207$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $c114c26e12685207$export$f99ded8fe4b79145; }, function (v) { return $c114c26e12685207$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $c114c26e12685207$export$a143d493d941bafc;
var $c114c26e12685207$export$e4cf37d7f6fb9e0a;
var $c114c26e12685207$export$f99ded8fe4b79145;
var $c114c26e12685207$export$599f31c3813fae4d;
'use strict';

var $7LFKz = parcelRequire("7LFKz");

var $69U7b = parcelRequire("69U7b");
var $c114c26e12685207$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$c114c26e12685207$export$a143d493d941bafc = $c114c26e12685207$var$Buffer;
$c114c26e12685207$export$e4cf37d7f6fb9e0a = $c114c26e12685207$var$SlowBuffer;
$c114c26e12685207$export$f99ded8fe4b79145 = 50;
var $c114c26e12685207$var$K_MAX_LENGTH = 0x7fffffff;
$c114c26e12685207$export$599f31c3813fae4d = $c114c26e12685207$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $c114c26e12685207$var$Buffer.TYPED_ARRAY_SUPPORT = $c114c26e12685207$var$typedArraySupport();
if (!$c114c26e12685207$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $c114c26e12685207$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($c114c26e12685207$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$c114c26e12685207$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($c114c26e12685207$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$c114c26e12685207$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $c114c26e12685207$var$createBuffer(length) {
    if (length > $c114c26e12685207$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $c114c26e12685207$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $c114c26e12685207$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $c114c26e12685207$var$allocUnsafe(arg);
    }
    return $c114c26e12685207$var$from(arg, encodingOrOffset, length);
}
$c114c26e12685207$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $c114c26e12685207$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $c114c26e12685207$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $c114c26e12685207$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($c114c26e12685207$var$isInstance(value, ArrayBuffer) || value && $c114c26e12685207$var$isInstance(value.buffer, ArrayBuffer)) return $c114c26e12685207$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($c114c26e12685207$var$isInstance(value, SharedArrayBuffer) || value && $c114c26e12685207$var$isInstance(value.buffer, SharedArrayBuffer))) return $c114c26e12685207$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $c114c26e12685207$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $c114c26e12685207$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $c114c26e12685207$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $c114c26e12685207$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $c114c26e12685207$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($c114c26e12685207$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($c114c26e12685207$var$Buffer, Uint8Array);
function $c114c26e12685207$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $c114c26e12685207$var$alloc(size, fill, encoding) {
    $c114c26e12685207$var$assertSize(size);
    if (size <= 0) return $c114c26e12685207$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $c114c26e12685207$var$createBuffer(size).fill(fill, encoding) : $c114c26e12685207$var$createBuffer(size).fill(fill);
    return $c114c26e12685207$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $c114c26e12685207$var$Buffer.alloc = function(size, fill, encoding) {
    return $c114c26e12685207$var$alloc(size, fill, encoding);
};
function $c114c26e12685207$var$allocUnsafe(size) {
    $c114c26e12685207$var$assertSize(size);
    return $c114c26e12685207$var$createBuffer(size < 0 ? 0 : $c114c26e12685207$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $c114c26e12685207$var$Buffer.allocUnsafe = function(size) {
    return $c114c26e12685207$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $c114c26e12685207$var$Buffer.allocUnsafeSlow = function(size) {
    return $c114c26e12685207$var$allocUnsafe(size);
};
function $c114c26e12685207$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$c114c26e12685207$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $c114c26e12685207$var$byteLength(string, encoding) | 0;
    var buf = $c114c26e12685207$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $c114c26e12685207$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $c114c26e12685207$var$checked(array.length) | 0;
    var buf = $c114c26e12685207$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $c114c26e12685207$var$fromArrayView(arrayView) {
    if ($c114c26e12685207$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $c114c26e12685207$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $c114c26e12685207$var$fromArrayLike(arrayView);
}
function $c114c26e12685207$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $c114c26e12685207$var$Buffer.prototype);
    return buf;
}
function $c114c26e12685207$var$fromObject(obj) {
    if ($c114c26e12685207$var$Buffer.isBuffer(obj)) {
        var len = $c114c26e12685207$var$checked(obj.length) | 0;
        var buf = $c114c26e12685207$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $c114c26e12685207$var$numberIsNaN(obj.length)) return $c114c26e12685207$var$createBuffer(0);
        return $c114c26e12685207$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $c114c26e12685207$var$fromArrayLike(obj.data);
}
function $c114c26e12685207$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $c114c26e12685207$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $c114c26e12685207$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $c114c26e12685207$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $c114c26e12685207$var$Buffer.alloc(+length);
}
$c114c26e12685207$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $c114c26e12685207$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$c114c26e12685207$var$Buffer.compare = function compare(a, b) {
    if ($c114c26e12685207$var$isInstance(a, Uint8Array)) a = $c114c26e12685207$var$Buffer.from(a, a.offset, a.byteLength);
    if ($c114c26e12685207$var$isInstance(b, Uint8Array)) b = $c114c26e12685207$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$c114c26e12685207$var$Buffer.isBuffer(a) || !$c114c26e12685207$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$c114c26e12685207$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$c114c26e12685207$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $c114c26e12685207$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $c114c26e12685207$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($c114c26e12685207$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $c114c26e12685207$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $c114c26e12685207$var$byteLength(string, encoding) {
    if ($c114c26e12685207$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $c114c26e12685207$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $c114c26e12685207$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $c114c26e12685207$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $c114c26e12685207$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$c114c26e12685207$var$Buffer.byteLength = $c114c26e12685207$var$byteLength;
function $c114c26e12685207$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $c114c26e12685207$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $c114c26e12685207$var$utf8Slice(this, start, end);
        case 'ascii':
            return $c114c26e12685207$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $c114c26e12685207$var$latin1Slice(this, start, end);
        case 'base64':
            return $c114c26e12685207$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $c114c26e12685207$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$c114c26e12685207$var$Buffer.prototype._isBuffer = true;
function $c114c26e12685207$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$c114c26e12685207$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$c114c26e12685207$var$swap(this, i, i + 1);
    return this;
};
$c114c26e12685207$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $c114c26e12685207$var$swap(this, i, i + 3);
        $c114c26e12685207$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$c114c26e12685207$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $c114c26e12685207$var$swap(this, i, i + 7);
        $c114c26e12685207$var$swap(this, i + 1, i + 6);
        $c114c26e12685207$var$swap(this, i + 2, i + 5);
        $c114c26e12685207$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$c114c26e12685207$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $c114c26e12685207$var$utf8Slice(this, 0, length);
    return $c114c26e12685207$var$slowToString.apply(this, arguments);
};
$c114c26e12685207$var$Buffer.prototype.toLocaleString = $c114c26e12685207$var$Buffer.prototype.toString;
$c114c26e12685207$var$Buffer.prototype.equals = function equals(b) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $c114c26e12685207$var$Buffer.compare(this, b) === 0;
};
$c114c26e12685207$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $c114c26e12685207$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($c114c26e12685207$var$customInspectSymbol) $c114c26e12685207$var$Buffer.prototype[$c114c26e12685207$var$customInspectSymbol] = $c114c26e12685207$var$Buffer.prototype.inspect;
$c114c26e12685207$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($c114c26e12685207$var$isInstance(target, Uint8Array)) target = $c114c26e12685207$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$c114c26e12685207$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $c114c26e12685207$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($c114c26e12685207$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $c114c26e12685207$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($c114c26e12685207$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $c114c26e12685207$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $c114c26e12685207$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $c114c26e12685207$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$c114c26e12685207$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$c114c26e12685207$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $c114c26e12685207$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$c114c26e12685207$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $c114c26e12685207$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $c114c26e12685207$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($c114c26e12685207$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $c114c26e12685207$var$utf8Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $c114c26e12685207$var$asciiWrite(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$asciiToBytes(string), buf, offset, length);
}
function $c114c26e12685207$var$base64Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$base64ToBytes(string), buf, offset, length);
}
function $c114c26e12685207$var$ucs2Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$c114c26e12685207$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $c114c26e12685207$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $c114c26e12685207$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $c114c26e12685207$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $c114c26e12685207$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $c114c26e12685207$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$c114c26e12685207$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $c114c26e12685207$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $7LFKz.fromByteArray(buf);
    else return $7LFKz.fromByteArray(buf.slice(start, end));
}
function $c114c26e12685207$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $c114c26e12685207$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $c114c26e12685207$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $c114c26e12685207$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $c114c26e12685207$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $c114c26e12685207$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $c114c26e12685207$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $c114c26e12685207$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$c114c26e12685207$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $c114c26e12685207$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $c114c26e12685207$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$c114c26e12685207$var$Buffer.prototype.readUintLE = $c114c26e12685207$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readUintBE = $c114c26e12685207$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readUint8 = $c114c26e12685207$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$c114c26e12685207$var$Buffer.prototype.readUint16LE = $c114c26e12685207$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$c114c26e12685207$var$Buffer.prototype.readUint16BE = $c114c26e12685207$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$c114c26e12685207$var$Buffer.prototype.readUint32LE = $c114c26e12685207$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$c114c26e12685207$var$Buffer.prototype.readUint32BE = $c114c26e12685207$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$c114c26e12685207$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$c114c26e12685207$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c114c26e12685207$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c114c26e12685207$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$c114c26e12685207$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$c114c26e12685207$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return $69U7b.read(this, offset, true, 23, 4);
};
$c114c26e12685207$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return $69U7b.read(this, offset, false, 23, 4);
};
$c114c26e12685207$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 8, this.length);
    return $69U7b.read(this, offset, true, 52, 8);
};
$c114c26e12685207$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 8, this.length);
    return $69U7b.read(this, offset, false, 52, 8);
};
function $c114c26e12685207$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$c114c26e12685207$var$Buffer.prototype.writeUintLE = $c114c26e12685207$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeUintBE = $c114c26e12685207$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeUint8 = $c114c26e12685207$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$c114c26e12685207$var$Buffer.prototype.writeUint16LE = $c114c26e12685207$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeUint16BE = $c114c26e12685207$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeUint32LE = $c114c26e12685207$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeUint32BE = $c114c26e12685207$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$c114c26e12685207$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $c114c26e12685207$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $c114c26e12685207$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $69U7b.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$c114c26e12685207$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeFloat(this, value, offset, true, noAssert);
};
$c114c26e12685207$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeFloat(this, value, offset, false, noAssert);
};
function $c114c26e12685207$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $69U7b.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$c114c26e12685207$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeDouble(this, value, offset, true, noAssert);
};
$c114c26e12685207$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$c114c26e12685207$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$c114c26e12685207$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$c114c26e12685207$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $c114c26e12685207$var$Buffer.isBuffer(val) ? val : $c114c26e12685207$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $c114c26e12685207$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $c114c26e12685207$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($c114c26e12685207$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $c114c26e12685207$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $c114c26e12685207$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $c114c26e12685207$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $c114c26e12685207$var$base64ToBytes(str) {
    return $7LFKz.toByteArray($c114c26e12685207$var$base64clean(str));
}
function $c114c26e12685207$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $c114c26e12685207$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $c114c26e12685207$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $c114c26e12685207$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("7LFKz", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $5a7d4ee62d502cb1$export$d622b2ad8d90c771; }, function (v) { return $5a7d4ee62d502cb1$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $5a7d4ee62d502cb1$export$6100ba28696e12de; }, function (v) { return $5a7d4ee62d502cb1$export$6100ba28696e12de = v; });
var $5a7d4ee62d502cb1$export$a48f0734ac7c2329;
var $5a7d4ee62d502cb1$export$d622b2ad8d90c771;
var $5a7d4ee62d502cb1$export$6100ba28696e12de;
'use strict';
$5a7d4ee62d502cb1$export$a48f0734ac7c2329 = $5a7d4ee62d502cb1$var$byteLength;
$5a7d4ee62d502cb1$export$d622b2ad8d90c771 = $5a7d4ee62d502cb1$var$toByteArray;
$5a7d4ee62d502cb1$export$6100ba28696e12de = $5a7d4ee62d502cb1$var$fromByteArray;
var $5a7d4ee62d502cb1$var$lookup = [];
var $5a7d4ee62d502cb1$var$revLookup = [];
var $5a7d4ee62d502cb1$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $5a7d4ee62d502cb1$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $5a7d4ee62d502cb1$var$i = 0, $5a7d4ee62d502cb1$var$len = $5a7d4ee62d502cb1$var$code.length; $5a7d4ee62d502cb1$var$i < $5a7d4ee62d502cb1$var$len; ++$5a7d4ee62d502cb1$var$i){
    $5a7d4ee62d502cb1$var$lookup[$5a7d4ee62d502cb1$var$i] = $5a7d4ee62d502cb1$var$code[$5a7d4ee62d502cb1$var$i];
    $5a7d4ee62d502cb1$var$revLookup[$5a7d4ee62d502cb1$var$code.charCodeAt($5a7d4ee62d502cb1$var$i)] = $5a7d4ee62d502cb1$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$5a7d4ee62d502cb1$var$revLookup['-'.charCodeAt(0)] = 62;
$5a7d4ee62d502cb1$var$revLookup['_'.charCodeAt(0)] = 63;
function $5a7d4ee62d502cb1$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $5a7d4ee62d502cb1$var$byteLength(b64) {
    var lens = $5a7d4ee62d502cb1$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5a7d4ee62d502cb1$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5a7d4ee62d502cb1$var$toByteArray(b64) {
    var tmp;
    var lens = $5a7d4ee62d502cb1$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $5a7d4ee62d502cb1$var$Arr($5a7d4ee62d502cb1$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 18 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 2 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 10 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $5a7d4ee62d502cb1$var$tripletToBase64(num) {
    return $5a7d4ee62d502cb1$var$lookup[num >> 18 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num >> 12 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num >> 6 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num & 0x3F];
}
function $5a7d4ee62d502cb1$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($5a7d4ee62d502cb1$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $5a7d4ee62d502cb1$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($5a7d4ee62d502cb1$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($5a7d4ee62d502cb1$var$lookup[tmp >> 2] + $5a7d4ee62d502cb1$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($5a7d4ee62d502cb1$var$lookup[tmp >> 10] + $5a7d4ee62d502cb1$var$lookup[tmp >> 4 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("69U7b", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942; }, function (v) { return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $47bf1c92b6d3ec4f$export$68d8715fc104d294; }, function (v) { return $47bf1c92b6d3ec4f$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $47bf1c92b6d3ec4f$export$aafa59e2e03f2942;
var $47bf1c92b6d3ec4f$export$68d8715fc104d294;
$47bf1c92b6d3ec4f$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$47bf1c92b6d3ec4f$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});





parcelRegister("4W00a", function(module, exports) {
/**
 * Module dependencies.
 */ 
var $krpzr = parcelRequire("krpzr");

var $5w5Yh = parcelRequire("5w5Yh");

var $kHJIH = parcelRequire("kHJIH");

var $TeDYR = parcelRequire("TeDYR");

var $iIMIm = parcelRequire("iIMIm");

var $f98QG = parcelRequire("f98QG");

var $397c948ea443b1ab$var$debug = (parcelRequire("fhMUH"))('socket.io-client:manager');

var $2X0S7 = parcelRequire("2X0S7");

var $85pZE = parcelRequire("85pZE");
/**
 * IE6+ hasOwnProperty
 */ var $397c948ea443b1ab$var$has = Object.prototype.hasOwnProperty;
/**
 * Module exports
 */ module.exports = $397c948ea443b1ab$var$Manager;
/**
 * `Manager` constructor.
 *
 * @param {String} engine instance or engine uri/opts
 * @param {Object} options
 * @api public
 */ function $397c948ea443b1ab$var$Manager(uri, opts) {
    if (!(this instanceof $397c948ea443b1ab$var$Manager)) return new $397c948ea443b1ab$var$Manager(uri, opts);
    if (uri && 'object' === typeof uri) {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    opts.path = opts.path || '/socket.io';
    this.nsps = {};
    this.subs = [];
    this.opts = opts;
    this.reconnection(opts.reconnection !== false);
    this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
    this.reconnectionDelay(opts.reconnectionDelay || 1000);
    this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
    this.randomizationFactor(opts.randomizationFactor || 0.5);
    this.backoff = new $85pZE({
        min: this.reconnectionDelay(),
        max: this.reconnectionDelayMax(),
        jitter: this.randomizationFactor()
    });
    this.timeout(null == opts.timeout ? 20000 : opts.timeout);
    this.readyState = 'closed';
    this.uri = uri;
    this.connecting = [];
    this.lastPing = null;
    this.encoding = false;
    this.packetBuffer = [];
    var _parser = opts.parser || $TeDYR;
    this.encoder = new _parser.Encoder();
    this.decoder = new _parser.Decoder();
    this.autoConnect = opts.autoConnect !== false;
    if (this.autoConnect) this.open();
}
/**
 * Propagate given event to sockets and emit on `this`
 *
 * @api private
 */ $397c948ea443b1ab$var$Manager.prototype.emitAll = function() {
    this.emit.apply(this, arguments);
    for(var nsp in this.nsps)if ($397c948ea443b1ab$var$has.call(this.nsps, nsp)) this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
};
/**
 * Update `socket.id` of all sockets
 *
 * @api private
 */ $397c948ea443b1ab$var$Manager.prototype.updateSocketIds = function() {
    for(var nsp in this.nsps)if ($397c948ea443b1ab$var$has.call(this.nsps, nsp)) this.nsps[nsp].id = this.generateId(nsp);
};
/**
 * generate `socket.id` for the given `nsp`
 *
 * @param {String} nsp
 * @return {String}
 * @api private
 */ $397c948ea443b1ab$var$Manager.prototype.generateId = function(nsp) {
    return (nsp === '/' ? '' : nsp + '#') + this.engine.id;
};
/**
 * Mix in `Emitter`.
 */ $kHJIH($397c948ea443b1ab$var$Manager.prototype);
/**
 * Sets the `reconnection` config.
 *
 * @param {Boolean} true/false if it should automatically reconnect
 * @return {Manager} self or value
 * @api public
 */ $397c948ea443b1ab$var$Manager.prototype.reconnection = function(v) {
    if (!arguments.length) return this._reconnection;
    this._reconnection = !!v;
    return this;
};
/**
 * Sets the reconnection attempts config.
 *
 * @param {Number} max reconnection attempts before giving up
 * @return {Manager} self or value
 * @api public
 */ $397c948ea443b1ab$var$Manager.prototype.reconnectionAttempts = function(v) {
    if (!arguments.length) return this._reconnectionAttempts;
    this._reconnectionAttempts = v;
    return this;
};
/**
 * Sets the delay between reconnections.
 *
 * @param {Number} delay
 * @return {Manager} self or value
 * @api public
 */ $397c948ea443b1ab$var$Manager.prototype.reconnectionDelay = function(v) {
    if (!arguments.length) return this._reconnectionDelay;
    this._reconnectionDelay = v;
    this.backoff && this.backoff.setMin(v);
    return this;
};
$397c948ea443b1ab$var$Manager.prototype.randomizationFactor = function(v) {
    if (!arguments.length) return this._randomizationFactor;
    this._randomizationFactor = v;
    this.backoff && this.backoff.setJitter(v);
    return this;
};
/**
 * Sets the maximum delay between reconnections.
 *
 * @param {Number} delay
 * @return {Manager} self or value
 * @api public
 */ $397c948ea443b1ab$var$Manager.prototype.reconnectionDelayMax = function(v) {
    if (!arguments.length) return this._reconnectionDelayMax;
    this._reconnectionDelayMax = v;
    this.backoff && this.backoff.setMax(v);
    return this;
};
/**
 * Sets the connection timeout. `false` to disable
 *
 * @return {Manager} self or value
 * @api public
 */ $397c948ea443b1ab$var$Manager.prototype.timeout = function(v) {
    if (!arguments.length) return this._timeout;
    this._timeout = v;
    return this;
};
/**
 * Starts trying to reconnect if reconnection is enabled and we have not
 * started reconnecting yet
 *
 * @api private
 */ $397c948ea443b1ab$var$Manager.prototype.maybeReconnectOnOpen = function() {
    // Only try to reconnect if it's the first time we're connecting
    if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
    this.reconnect();
};
/**
 * Sets the current transport `socket`.
 *
 * @param {Function} optional, callback
 * @return {Manager} self
 * @api public
 */ $397c948ea443b1ab$var$Manager.prototype.open = $397c948ea443b1ab$var$Manager.prototype.connect = function(fn, opts) {
    $397c948ea443b1ab$var$debug('readyState %s', this.readyState);
    if (~this.readyState.indexOf('open')) return this;
    $397c948ea443b1ab$var$debug('opening %s', this.uri);
    this.engine = $krpzr(this.uri, this.opts);
    var socket = this.engine;
    var self = this;
    this.readyState = 'opening';
    this.skipReconnect = false;
    // emit `open`
    var openSub = $iIMIm(socket, 'open', function() {
        self.onopen();
        fn && fn();
    });
    // emit `connect_error`
    var errorSub = $iIMIm(socket, 'error', function(data) {
        $397c948ea443b1ab$var$debug('connect_error');
        self.cleanup();
        self.readyState = 'closed';
        self.emitAll('connect_error', data);
        if (fn) {
            var err = new Error('Connection error');
            err.data = data;
            fn(err);
        } else // Only do this if there is no fn to handle the error
        self.maybeReconnectOnOpen();
    });
    // emit `connect_timeout`
    if (false !== this._timeout) {
        var timeout = this._timeout;
        $397c948ea443b1ab$var$debug('connect attempt will timeout after %d', timeout);
        if (timeout === 0) openSub.destroy(); // prevents a race condition with the 'open' event
        // set timer
        var timer = setTimeout(function() {
            $397c948ea443b1ab$var$debug('connect attempt timed out after %d', timeout);
            openSub.destroy();
            socket.close();
            socket.emit('error', 'timeout');
            self.emitAll('connect_timeout', timeout);
        }, timeout);
        this.subs.push({
            destroy: function() {
                clearTimeout(timer);
            }
        });
    }
    this.subs.push(openSub);
    this.subs.push(errorSub);
    return this;
};
/**
 * Called upon transport open.
 *
 * @api private
 */ $397c948ea443b1ab$var$Manager.prototype.onopen = function() {
    $397c948ea443b1ab$var$debug('open');
    // clear old subs
    this.cleanup();
    // mark as open
    this.readyState = 'open';
    this.emit('open');
    // add new subs
    var socket = this.engine;
    this.subs.push($iIMIm(socket, 'data', $f98QG(this, 'ondata')));
    this.subs.push($iIMIm(socket, 'ping', $f98QG(this, 'onping')));
    this.subs.push($iIMIm(socket, 'pong', $f98QG(this, 'onpong')));
    this.subs.push($iIMIm(socket, 'error', $f98QG(this, 'onerror')));
    this.subs.push($iIMIm(socket, 'close', $f98QG(this, 'onclose')));
    this.subs.push($iIMIm(this.decoder, 'decoded', $f98QG(this, 'ondecoded')));
};
/**
 * Called upon a ping.
 *
 * @api private
 */ $397c948ea443b1ab$var$Manager.prototype.onping = function() {
    this.lastPing = new Date();
    this.emitAll('ping');
};
/**
 * Called upon a packet.
 *
 * @api private
 */ $397c948ea443b1ab$var$Manager.prototype.onpong = function() {
    this.emitAll('pong', new Date() - this.lastPing);
};
/**
 * Called with data.
 *
 * @api private
 */ $397c948ea443b1ab$var$Manager.prototype.ondata = function(data) {
    this.decoder.add(data);
};
/**
 * Called when parser fully decodes a packet.
 *
 * @api private
 */ $397c948ea443b1ab$var$Manager.prototype.ondecoded = function(packet) {
    this.emit('packet', packet);
};
/**
 * Called upon socket error.
 *
 * @api private
 */ $397c948ea443b1ab$var$Manager.prototype.onerror = function(err) {
    $397c948ea443b1ab$var$debug('error', err);
    this.emitAll('error', err);
};
/**
 * Creates a new socket for the given `nsp`.
 *
 * @return {Socket}
 * @api public
 */ $397c948ea443b1ab$var$Manager.prototype.socket = function(nsp, opts) {
    var socket = this.nsps[nsp];
    if (!socket) {
        socket = new $5w5Yh(this, nsp, opts);
        this.nsps[nsp] = socket;
        var self = this;
        socket.on('connecting', onConnecting);
        socket.on('connect', function() {
            socket.id = self.generateId(nsp);
        });
        if (this.autoConnect) // manually call here since connecting event is fired before listening
        onConnecting();
    }
    function onConnecting() {
        if (!~$2X0S7(self.connecting, socket)) self.connecting.push(socket);
    }
    return socket;
};
/**
 * Called upon a socket close.
 *
 * @param {Socket} socket
 */ $397c948ea443b1ab$var$Manager.prototype.destroy = function(socket) {
    var index = $2X0S7(this.connecting, socket);
    if (~index) this.connecting.splice(index, 1);
    if (this.connecting.length) return;
    this.close();
};
/**
 * Writes a packet.
 *
 * @param {Object} packet
 * @api private
 */ $397c948ea443b1ab$var$Manager.prototype.packet = function(packet) {
    $397c948ea443b1ab$var$debug('writing packet %j', packet);
    var self = this;
    if (packet.query && packet.type === 0) packet.nsp += '?' + packet.query;
    if (!self.encoding) {
        // encode, then write to engine with result
        self.encoding = true;
        this.encoder.encode(packet, function(encodedPackets) {
            for(var i = 0; i < encodedPackets.length; i++)self.engine.write(encodedPackets[i], packet.options);
            self.encoding = false;
            self.processPacketQueue();
        });
    } else self.packetBuffer.push(packet);
};
/**
 * If packet buffer is non-empty, begins encoding the
 * next packet in line.
 *
 * @api private
 */ $397c948ea443b1ab$var$Manager.prototype.processPacketQueue = function() {
    if (this.packetBuffer.length > 0 && !this.encoding) {
        var pack = this.packetBuffer.shift();
        this.packet(pack);
    }
};
/**
 * Clean up transport subscriptions and packet buffer.
 *
 * @api private
 */ $397c948ea443b1ab$var$Manager.prototype.cleanup = function() {
    $397c948ea443b1ab$var$debug('cleanup');
    var subsLength = this.subs.length;
    for(var i = 0; i < subsLength; i++){
        var sub = this.subs.shift();
        sub.destroy();
    }
    this.packetBuffer = [];
    this.encoding = false;
    this.lastPing = null;
    this.decoder.destroy();
};
/**
 * Close the current socket.
 *
 * @api private
 */ $397c948ea443b1ab$var$Manager.prototype.close = $397c948ea443b1ab$var$Manager.prototype.disconnect = function() {
    $397c948ea443b1ab$var$debug('disconnect');
    this.skipReconnect = true;
    this.reconnecting = false;
    if ('opening' === this.readyState) // `onclose` will not fire because
    // an open event never happened
    this.cleanup();
    this.backoff.reset();
    this.readyState = 'closed';
    if (this.engine) this.engine.close();
};
/**
 * Called upon engine close.
 *
 * @api private
 */ $397c948ea443b1ab$var$Manager.prototype.onclose = function(reason) {
    $397c948ea443b1ab$var$debug('onclose');
    this.cleanup();
    this.backoff.reset();
    this.readyState = 'closed';
    this.emit('close', reason);
    if (this._reconnection && !this.skipReconnect) this.reconnect();
};
/**
 * Attempt a reconnection.
 *
 * @api private
 */ $397c948ea443b1ab$var$Manager.prototype.reconnect = function() {
    if (this.reconnecting || this.skipReconnect) return this;
    var self = this;
    if (this.backoff.attempts >= this._reconnectionAttempts) {
        $397c948ea443b1ab$var$debug('reconnect failed');
        this.backoff.reset();
        this.emitAll('reconnect_failed');
        this.reconnecting = false;
    } else {
        var delay = this.backoff.duration();
        $397c948ea443b1ab$var$debug('will wait %dms before reconnect attempt', delay);
        this.reconnecting = true;
        var timer = setTimeout(function() {
            if (self.skipReconnect) return;
            $397c948ea443b1ab$var$debug('attempting reconnect');
            self.emitAll('reconnect_attempt', self.backoff.attempts);
            self.emitAll('reconnecting', self.backoff.attempts);
            // check again for the case socket closed in above events
            if (self.skipReconnect) return;
            self.open(function(err) {
                if (err) {
                    $397c948ea443b1ab$var$debug('reconnect attempt error');
                    self.reconnecting = false;
                    self.reconnect();
                    self.emitAll('reconnect_error', err.data);
                } else {
                    $397c948ea443b1ab$var$debug('reconnect success');
                    self.onreconnect();
                }
            });
        }, delay);
        this.subs.push({
            destroy: function() {
                clearTimeout(timer);
            }
        });
    }
};
/**
 * Called upon successful reconnect.
 *
 * @api private
 */ $397c948ea443b1ab$var$Manager.prototype.onreconnect = function() {
    var attempt = this.backoff.attempts;
    this.reconnecting = false;
    this.backoff.reset();
    this.updateSocketIds();
    this.emitAll('reconnect', attempt);
};

});
parcelRegister("krpzr", function(module, exports) {

module.exports = (parcelRequire("j3TkI"));

/**
 * Exports parser
 *
 * @api public
 *
 */ module.exports.parser = (parcelRequire("3OROY"));

});
parcelRegister("j3TkI", function(module, exports) {
/**
 * Module dependencies.
 */ 

var $kHJIH = parcelRequire("kHJIH");

var $de09382a2b1dfcae$var$debug = (parcelRequire("lr39n"))('engine.io-client:socket');

var $2X0S7 = parcelRequire("2X0S7");


var $43fDP = parcelRequire("43fDP");

var $gDMgm = parcelRequire("gDMgm");
/**
 * Module exports.
 */ module.exports = $de09382a2b1dfcae$var$Socket;
/**
 * Socket constructor.
 *
 * @param {String|Object} uri or options
 * @param {Object} options
 * @api public
 */ function $de09382a2b1dfcae$var$Socket(uri, opts) {
    if (!(this instanceof $de09382a2b1dfcae$var$Socket)) return new $de09382a2b1dfcae$var$Socket(uri, opts);
    opts = opts || {};
    if (uri && 'object' === typeof uri) {
        opts = uri;
        uri = null;
    }
    if (uri) {
        uri = $43fDP(uri);
        opts.hostname = uri.host;
        opts.secure = uri.protocol === 'https' || uri.protocol === 'wss';
        opts.port = uri.port;
        if (uri.query) opts.query = uri.query;
    } else if (opts.host) opts.hostname = $43fDP(opts.host).host;
    this.secure = null != opts.secure ? opts.secure : typeof location !== 'undefined' && 'https:' === location.protocol;
    if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
    opts.port = this.secure ? '443' : '80';
    this.agent = opts.agent || false;
    this.hostname = opts.hostname || (typeof location !== 'undefined' ? location.hostname : 'localhost');
    this.port = opts.port || (typeof location !== 'undefined' && location.port ? location.port : this.secure ? 443 : 80);
    this.query = opts.query || {};
    if ('string' === typeof this.query) this.query = $gDMgm.decode(this.query);
    this.upgrade = false !== opts.upgrade;
    this.path = (opts.path || '/engine.io').replace(/\/$/, '') + '/';
    this.forceJSONP = !!opts.forceJSONP;
    this.jsonp = false !== opts.jsonp;
    this.forceBase64 = !!opts.forceBase64;
    this.enablesXDR = !!opts.enablesXDR;
    this.withCredentials = false !== opts.withCredentials;
    this.timestampParam = opts.timestampParam || 't';
    this.timestampRequests = opts.timestampRequests;
    this.transports = opts.transports || [
        'polling',
        'websocket'
    ];
    this.transportOptions = opts.transportOptions || {};
    this.readyState = '';
    this.writeBuffer = [];
    this.prevBufferLen = 0;
    this.policyPort = opts.policyPort || 843;
    this.rememberUpgrade = opts.rememberUpgrade || false;
    this.binaryType = null;
    this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
    this.perMessageDeflate = false !== opts.perMessageDeflate ? opts.perMessageDeflate || {} : false;
    if (true === this.perMessageDeflate) this.perMessageDeflate = {};
    if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) this.perMessageDeflate.threshold = 1024;
    // SSL options for Node.js client
    this.pfx = opts.pfx || undefined;
    this.key = opts.key || undefined;
    this.passphrase = opts.passphrase || undefined;
    this.cert = opts.cert || undefined;
    this.ca = opts.ca || undefined;
    this.ciphers = opts.ciphers || undefined;
    this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? true : opts.rejectUnauthorized;
    this.forceNode = !!opts.forceNode;
    // detect ReactNative environment
    this.isReactNative = typeof navigator !== 'undefined' && typeof navigator.product === 'string' && navigator.product.toLowerCase() === 'reactnative';
    // other options for Node.js or ReactNative client
    if (typeof self === 'undefined' || this.isReactNative) {
        if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) this.extraHeaders = opts.extraHeaders;
        if (opts.localAddress) this.localAddress = opts.localAddress;
    }
    // set on handshake
    this.id = null;
    this.upgrades = null;
    this.pingInterval = null;
    this.pingTimeout = null;
    // set on heartbeat
    this.pingIntervalTimer = null;
    this.pingTimeoutTimer = null;
    this.open();
}
$de09382a2b1dfcae$var$Socket.priorWebsocketSuccess = false;
/**
 * Mix in `Emitter`.
 */ $kHJIH($de09382a2b1dfcae$var$Socket.prototype);
/**
 * Protocol version.
 *
 * @api public
 */ $de09382a2b1dfcae$var$Socket.protocol = (parcelRequire("3OROY")).protocol; // this is an int
/**
 * Expose deps for legacy compatibility
 * and standalone browser access.
 */ $de09382a2b1dfcae$var$Socket.Socket = $de09382a2b1dfcae$var$Socket;

$de09382a2b1dfcae$var$Socket.Transport = (parcelRequire("5du6X"));

$de09382a2b1dfcae$var$Socket.transports = (parcelRequire("8jvun"));

$de09382a2b1dfcae$var$Socket.parser = (parcelRequire("3OROY"));
/**
 * Creates transport of the given type.
 *
 * @param {String} transport name
 * @return {Transport}
 * @api private
 */ $de09382a2b1dfcae$var$Socket.prototype.createTransport = function(name) {
    $de09382a2b1dfcae$var$debug('creating transport "%s"', name);
    var query = $de09382a2b1dfcae$var$clone(this.query);
    // append engine.io protocol identifier
    query.EIO = (parcelRequire("3OROY")).protocol;
    // transport name
    query.transport = name;
    // per-transport options
    var options = this.transportOptions[name] || {};
    // session id if we already have one
    if (this.id) query.sid = this.id;
    var transport = new (parcelRequire("8jvun"))[name]({
        query: query,
        socket: this,
        agent: options.agent || this.agent,
        hostname: options.hostname || this.hostname,
        port: options.port || this.port,
        secure: options.secure || this.secure,
        path: options.path || this.path,
        forceJSONP: options.forceJSONP || this.forceJSONP,
        jsonp: options.jsonp || this.jsonp,
        forceBase64: options.forceBase64 || this.forceBase64,
        enablesXDR: options.enablesXDR || this.enablesXDR,
        withCredentials: options.withCredentials || this.withCredentials,
        timestampRequests: options.timestampRequests || this.timestampRequests,
        timestampParam: options.timestampParam || this.timestampParam,
        policyPort: options.policyPort || this.policyPort,
        pfx: options.pfx || this.pfx,
        key: options.key || this.key,
        passphrase: options.passphrase || this.passphrase,
        cert: options.cert || this.cert,
        ca: options.ca || this.ca,
        ciphers: options.ciphers || this.ciphers,
        rejectUnauthorized: options.rejectUnauthorized || this.rejectUnauthorized,
        perMessageDeflate: options.perMessageDeflate || this.perMessageDeflate,
        extraHeaders: options.extraHeaders || this.extraHeaders,
        forceNode: options.forceNode || this.forceNode,
        localAddress: options.localAddress || this.localAddress,
        requestTimeout: options.requestTimeout || this.requestTimeout,
        protocols: options.protocols || void 0,
        isReactNative: this.isReactNative
    });
    return transport;
};
function $de09382a2b1dfcae$var$clone(obj) {
    var o = {};
    for(var i in obj)if (obj.hasOwnProperty(i)) o[i] = obj[i];
    return o;
}
/**
 * Initializes transport to use and starts probe.
 *
 * @api private
 */ $de09382a2b1dfcae$var$Socket.prototype.open = function() {
    var transport;
    if (this.rememberUpgrade && $de09382a2b1dfcae$var$Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') !== -1) transport = 'websocket';
    else if (0 === this.transports.length) {
        // Emit error on next tick so it can be listened to
        var self1 = this;
        setTimeout(function() {
            self1.emit('error', 'No transports available');
        }, 0);
        return;
    } else transport = this.transports[0];
    this.readyState = 'opening';
    // Retry with the next transport if the transport is disabled (jsonp: false)
    try {
        transport = this.createTransport(transport);
    } catch (e) {
        this.transports.shift();
        this.open();
        return;
    }
    transport.open();
    this.setTransport(transport);
};
/**
 * Sets the current transport. Disables the existing one (if any).
 *
 * @api private
 */ $de09382a2b1dfcae$var$Socket.prototype.setTransport = function(transport) {
    $de09382a2b1dfcae$var$debug('setting transport %s', transport.name);
    var self1 = this;
    if (this.transport) {
        $de09382a2b1dfcae$var$debug('clearing existing transport %s', this.transport.name);
        this.transport.removeAllListeners();
    }
    // set up transport
    this.transport = transport;
    // set up transport listeners
    transport.on('drain', function() {
        self1.onDrain();
    }).on('packet', function(packet) {
        self1.onPacket(packet);
    }).on('error', function(e) {
        self1.onError(e);
    }).on('close', function() {
        self1.onClose('transport close');
    });
};
/**
 * Probes a transport.
 *
 * @param {String} transport name
 * @api private
 */ $de09382a2b1dfcae$var$Socket.prototype.probe = function(name) {
    $de09382a2b1dfcae$var$debug('probing transport "%s"', name);
    var transport = this.createTransport(name, {
        probe: 1
    });
    var failed = false;
    var self1 = this;
    $de09382a2b1dfcae$var$Socket.priorWebsocketSuccess = false;
    function onTransportOpen() {
        if (self1.onlyBinaryUpgrades) {
            var upgradeLosesBinary = !this.supportsBinary && self1.transport.supportsBinary;
            failed = failed || upgradeLosesBinary;
        }
        if (failed) return;
        $de09382a2b1dfcae$var$debug('probe transport "%s" opened', name);
        transport.send([
            {
                type: 'ping',
                data: 'probe'
            }
        ]);
        transport.once('packet', function(msg) {
            if (failed) return;
            if ('pong' === msg.type && 'probe' === msg.data) {
                $de09382a2b1dfcae$var$debug('probe transport "%s" pong', name);
                self1.upgrading = true;
                self1.emit('upgrading', transport);
                if (!transport) return;
                $de09382a2b1dfcae$var$Socket.priorWebsocketSuccess = 'websocket' === transport.name;
                $de09382a2b1dfcae$var$debug('pausing current transport "%s"', self1.transport.name);
                self1.transport.pause(function() {
                    if (failed) return;
                    if ('closed' === self1.readyState) return;
                    $de09382a2b1dfcae$var$debug('changing transport and sending upgrade packet');
                    cleanup();
                    self1.setTransport(transport);
                    transport.send([
                        {
                            type: 'upgrade'
                        }
                    ]);
                    self1.emit('upgrade', transport);
                    transport = null;
                    self1.upgrading = false;
                    self1.flush();
                });
            } else {
                $de09382a2b1dfcae$var$debug('probe transport "%s" failed', name);
                var err = new Error('probe error');
                err.transport = transport.name;
                self1.emit('upgradeError', err);
            }
        });
    }
    function freezeTransport() {
        if (failed) return;
        // Any callback called by transport should be ignored since now
        failed = true;
        cleanup();
        transport.close();
        transport = null;
    }
    // Handle any error that happens while probing
    function onerror(err) {
        var error = new Error('probe error: ' + err);
        error.transport = transport.name;
        freezeTransport();
        $de09382a2b1dfcae$var$debug('probe transport "%s" failed because of error: %s', name, err);
        self1.emit('upgradeError', error);
    }
    function onTransportClose() {
        onerror('transport closed');
    }
    // When the socket is closed while we're probing
    function onclose() {
        onerror('socket closed');
    }
    // When the socket is upgraded while we're probing
    function onupgrade(to) {
        if (transport && to.name !== transport.name) {
            $de09382a2b1dfcae$var$debug('"%s" works - aborting "%s"', to.name, transport.name);
            freezeTransport();
        }
    }
    // Remove all listeners on the transport and on self
    function cleanup() {
        transport.removeListener('open', onTransportOpen);
        transport.removeListener('error', onerror);
        transport.removeListener('close', onTransportClose);
        self1.removeListener('close', onclose);
        self1.removeListener('upgrading', onupgrade);
    }
    transport.once('open', onTransportOpen);
    transport.once('error', onerror);
    transport.once('close', onTransportClose);
    this.once('close', onclose);
    this.once('upgrading', onupgrade);
    transport.open();
};
/**
 * Called when connection is deemed open.
 *
 * @api public
 */ $de09382a2b1dfcae$var$Socket.prototype.onOpen = function() {
    $de09382a2b1dfcae$var$debug('socket open');
    this.readyState = 'open';
    $de09382a2b1dfcae$var$Socket.priorWebsocketSuccess = 'websocket' === this.transport.name;
    this.emit('open');
    this.flush();
    // we check for `readyState` in case an `open`
    // listener already closed the socket
    if ('open' === this.readyState && this.upgrade && this.transport.pause) {
        $de09382a2b1dfcae$var$debug('starting upgrade probes');
        for(var i = 0, l = this.upgrades.length; i < l; i++)this.probe(this.upgrades[i]);
    }
};
/**
 * Handles a packet.
 *
 * @api private
 */ $de09382a2b1dfcae$var$Socket.prototype.onPacket = function(packet) {
    if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
        $de09382a2b1dfcae$var$debug('socket receive: type "%s", data "%s"', packet.type, packet.data);
        this.emit('packet', packet);
        // Socket is live - any packet counts
        this.emit('heartbeat');
        switch(packet.type){
            case 'open':
                this.onHandshake(JSON.parse(packet.data));
                break;
            case 'pong':
                this.setPing();
                this.emit('pong');
                break;
            case 'error':
                var err = new Error('server error');
                err.code = packet.data;
                this.onError(err);
                break;
            case 'message':
                this.emit('data', packet.data);
                this.emit('message', packet.data);
                break;
        }
    } else $de09382a2b1dfcae$var$debug('packet received with socket readyState "%s"', this.readyState);
};
/**
 * Called upon handshake completion.
 *
 * @param {Object} handshake obj
 * @api private
 */ $de09382a2b1dfcae$var$Socket.prototype.onHandshake = function(data) {
    this.emit('handshake', data);
    this.id = data.sid;
    this.transport.query.sid = data.sid;
    this.upgrades = this.filterUpgrades(data.upgrades);
    this.pingInterval = data.pingInterval;
    this.pingTimeout = data.pingTimeout;
    this.onOpen();
    // In case open handler closes socket
    if ('closed' === this.readyState) return;
    this.setPing();
    // Prolong liveness of socket on heartbeat
    this.removeListener('heartbeat', this.onHeartbeat);
    this.on('heartbeat', this.onHeartbeat);
};
/**
 * Resets ping timeout.
 *
 * @api private
 */ $de09382a2b1dfcae$var$Socket.prototype.onHeartbeat = function(timeout) {
    clearTimeout(this.pingTimeoutTimer);
    var self1 = this;
    self1.pingTimeoutTimer = setTimeout(function() {
        if ('closed' === self1.readyState) return;
        self1.onClose('ping timeout');
    }, timeout || self1.pingInterval + self1.pingTimeout);
};
/**
 * Pings server every `this.pingInterval` and expects response
 * within `this.pingTimeout` or closes connection.
 *
 * @api private
 */ $de09382a2b1dfcae$var$Socket.prototype.setPing = function() {
    var self1 = this;
    clearTimeout(self1.pingIntervalTimer);
    self1.pingIntervalTimer = setTimeout(function() {
        $de09382a2b1dfcae$var$debug('writing ping packet - expecting pong within %sms', self1.pingTimeout);
        self1.ping();
        self1.onHeartbeat(self1.pingTimeout);
    }, self1.pingInterval);
};
/**
* Sends a ping packet.
*
* @api private
*/ $de09382a2b1dfcae$var$Socket.prototype.ping = function() {
    var self1 = this;
    this.sendPacket('ping', function() {
        self1.emit('ping');
    });
};
/**
 * Called on `drain` event
 *
 * @api private
 */ $de09382a2b1dfcae$var$Socket.prototype.onDrain = function() {
    this.writeBuffer.splice(0, this.prevBufferLen);
    // setting prevBufferLen = 0 is very important
    // for example, when upgrading, upgrade packet is sent over,
    // and a nonzero prevBufferLen could cause problems on `drain`
    this.prevBufferLen = 0;
    if (0 === this.writeBuffer.length) this.emit('drain');
    else this.flush();
};
/**
 * Flush write buffers.
 *
 * @api private
 */ $de09382a2b1dfcae$var$Socket.prototype.flush = function() {
    if ('closed' !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
        $de09382a2b1dfcae$var$debug('flushing %d packets in socket', this.writeBuffer.length);
        this.transport.send(this.writeBuffer);
        // keep track of current length of writeBuffer
        // splice writeBuffer and callbackBuffer on `drain`
        this.prevBufferLen = this.writeBuffer.length;
        this.emit('flush');
    }
};
/**
 * Sends a message.
 *
 * @param {String} message.
 * @param {Function} callback function.
 * @param {Object} options.
 * @return {Socket} for chaining.
 * @api public
 */ $de09382a2b1dfcae$var$Socket.prototype.write = $de09382a2b1dfcae$var$Socket.prototype.send = function(msg, options, fn) {
    this.sendPacket('message', msg, options, fn);
    return this;
};
/**
 * Sends a packet.
 *
 * @param {String} packet type.
 * @param {String} data.
 * @param {Object} options.
 * @param {Function} callback function.
 * @api private
 */ $de09382a2b1dfcae$var$Socket.prototype.sendPacket = function(type, data, options, fn) {
    if ('function' === typeof data) {
        fn = data;
        data = undefined;
    }
    if ('function' === typeof options) {
        fn = options;
        options = null;
    }
    if ('closing' === this.readyState || 'closed' === this.readyState) return;
    options = options || {};
    options.compress = false !== options.compress;
    var packet = {
        type: type,
        data: data,
        options: options
    };
    this.emit('packetCreate', packet);
    this.writeBuffer.push(packet);
    if (fn) this.once('flush', fn);
    this.flush();
};
/**
 * Closes the connection.
 *
 * @api private
 */ $de09382a2b1dfcae$var$Socket.prototype.close = function() {
    if ('opening' === this.readyState || 'open' === this.readyState) {
        this.readyState = 'closing';
        var self1 = this;
        if (this.writeBuffer.length) this.once('drain', function() {
            if (this.upgrading) waitForUpgrade();
            else close();
        });
        else if (this.upgrading) waitForUpgrade();
        else close();
    }
    function close() {
        self1.onClose('forced close');
        $de09382a2b1dfcae$var$debug('socket closing - telling transport to close');
        self1.transport.close();
    }
    function cleanupAndClose() {
        self1.removeListener('upgrade', cleanupAndClose);
        self1.removeListener('upgradeError', cleanupAndClose);
        close();
    }
    function waitForUpgrade() {
        // wait for upgrade to finish since we can't send packets while pausing a transport
        self1.once('upgrade', cleanupAndClose);
        self1.once('upgradeError', cleanupAndClose);
    }
    return this;
};
/**
 * Called upon transport error
 *
 * @api private
 */ $de09382a2b1dfcae$var$Socket.prototype.onError = function(err) {
    $de09382a2b1dfcae$var$debug('socket error %j', err);
    $de09382a2b1dfcae$var$Socket.priorWebsocketSuccess = false;
    this.emit('error', err);
    this.onClose('transport error', err);
};
/**
 * Called upon transport close.
 *
 * @api private
 */ $de09382a2b1dfcae$var$Socket.prototype.onClose = function(reason, desc) {
    if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
        $de09382a2b1dfcae$var$debug('socket close with reason: "%s"', reason);
        var self1 = this;
        // clear timers
        clearTimeout(this.pingIntervalTimer);
        clearTimeout(this.pingTimeoutTimer);
        // stop event from firing again for transport
        this.transport.removeAllListeners('close');
        // ensure transport won't stay open
        this.transport.close();
        // ignore further transport communication
        this.transport.removeAllListeners();
        // set ready state
        this.readyState = 'closed';
        // clear session id
        this.id = null;
        // emit close event
        this.emit('close', reason, desc);
        // clean buffers after, so users can still
        // grab the buffers on `close` event
        self1.writeBuffer = [];
        self1.prevBufferLen = 0;
    }
};
/**
 * Filters upgrades, returning only those matching client transports.
 *
 * @param {Array} server upgrades
 * @api private
 *
 */ $de09382a2b1dfcae$var$Socket.prototype.filterUpgrades = function(upgrades) {
    var filteredUpgrades = [];
    for(var i = 0, j = upgrades.length; i < j; i++)if (~$2X0S7(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);
    return filteredUpgrades;
};

});
parcelRegister("8jvun", function(module, exports) {

$parcel$export(module.exports, "polling", function () { return $60d8861d258452fa$export$bdbf04fbdcf6ac3c; }, function (v) { return $60d8861d258452fa$export$bdbf04fbdcf6ac3c = v; });
$parcel$export(module.exports, "websocket", function () { return $60d8861d258452fa$export$3f859614deccc31b; }, function (v) { return $60d8861d258452fa$export$3f859614deccc31b = v; });
/**
 * Module dependencies
 */ /**
 * Export transports.
 */ var $60d8861d258452fa$export$bdbf04fbdcf6ac3c;
var $60d8861d258452fa$export$3f859614deccc31b;

var $OKFvV = parcelRequire("OKFvV");

var $bTOuK = parcelRequire("bTOuK");

var $8XiXR = parcelRequire("8XiXR");

var $9V4yc = parcelRequire("9V4yc");
$60d8861d258452fa$export$bdbf04fbdcf6ac3c = $60d8861d258452fa$var$polling;
$60d8861d258452fa$export$3f859614deccc31b = $9V4yc;
/**
 * Polling transport polymorphic constructor.
 * Decides on xhr vs jsonp based on feature detection.
 *
 * @api private
 */ function $60d8861d258452fa$var$polling(opts) {
    var xhr;
    var xd = false;
    var xs = false;
    var jsonp = false !== opts.jsonp;
    if (typeof location !== 'undefined') {
        var isSSL = 'https:' === location.protocol;
        var port = location.port;
        // some user agents have empty `location.port`
        if (!port) port = isSSL ? 443 : 80;
        xd = opts.hostname !== location.hostname || port !== opts.port;
        xs = opts.secure !== isSSL;
    }
    opts.xdomain = xd;
    opts.xscheme = xs;
    xhr = new $OKFvV(opts);
    if ('open' in xhr && !opts.forceJSONP) return new $bTOuK(opts);
    else {
        if (!jsonp) throw new Error('JSONP disabled');
        return new $8XiXR(opts);
    }
}

});
parcelRegister("OKFvV", function(module, exports) {
// browser shim for xmlhttprequest module

var $hUbHP = parcelRequire("hUbHP");

var $eBFAY = parcelRequire("eBFAY");
module.exports = function(opts) {
    var xdomain = opts.xdomain;
    // scheme must be same when usign XDomainRequest
    // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
    var xscheme = opts.xscheme;
    // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
    // https://github.com/Automattic/engine.io-client/pull/217
    var enablesXDR = opts.enablesXDR;
    // XMLHttpRequest can be disabled on IE
    try {
        if ('undefined' !== typeof XMLHttpRequest && (!xdomain || $hUbHP)) return new XMLHttpRequest();
    } catch (e) {}
    // Use XDomainRequest for IE8 if enablesXDR is true
    // because loading bar keeps flashing when using jsonp-polling
    // https://github.com/yujiosaka/socke.io-ie8-loading-example
    try {
        if ('undefined' !== typeof XDomainRequest && !xscheme && enablesXDR) return new XDomainRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new $eBFAY[[
            'Active'
        ].concat('Object').join('X')]('Microsoft.XMLHTTP');
    } catch (e) {}
};

});
parcelRegister("hUbHP", function(module, exports) {
/**
 * Module exports.
 *
 * Logic borrowed from Modernizr:
 *
 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
 */ try {
    module.exports = typeof XMLHttpRequest !== 'undefined' && 'withCredentials' in new XMLHttpRequest();
} catch (err) {
    // if XMLHttp support is disabled in IE then it will throw
    // when trying to create
    module.exports = false;
}

});

parcelRegister("eBFAY", function(module, exports) {
module.exports = function() {
    if (typeof self !== 'undefined') return self;
    else if (typeof window !== 'undefined') return window;
    else return Function('return this')(); // eslint-disable-line no-new-func
}();

});


parcelRegister("bTOuK", function(module, exports) {
/* global attachEvent */ /**
 * Module requirements.
 */ 
var $OKFvV = parcelRequire("OKFvV");

var $bQD73 = parcelRequire("bQD73");

var $kHJIH = parcelRequire("kHJIH");

var $13Nwl = parcelRequire("13Nwl");

var $8a9bfffd19c21833$var$debug = (parcelRequire("lr39n"))('engine.io-client:polling-xhr');

var $eBFAY = parcelRequire("eBFAY");
/**
 * Module exports.
 */ module.exports = $8a9bfffd19c21833$var$XHR;
module.exports.Request = $8a9bfffd19c21833$var$Request;
/**
 * Empty function
 */ function $8a9bfffd19c21833$var$empty() {}
/**
 * XHR Polling constructor.
 *
 * @param {Object} opts
 * @api public
 */ function $8a9bfffd19c21833$var$XHR(opts) {
    $bQD73.call(this, opts);
    this.requestTimeout = opts.requestTimeout;
    this.extraHeaders = opts.extraHeaders;
    if (typeof location !== 'undefined') {
        var isSSL = 'https:' === location.protocol;
        var port = location.port;
        // some user agents have empty `location.port`
        if (!port) port = isSSL ? 443 : 80;
        this.xd = typeof location !== 'undefined' && opts.hostname !== location.hostname || port !== opts.port;
        this.xs = opts.secure !== isSSL;
    }
}
/**
 * Inherits from Polling.
 */ $13Nwl($8a9bfffd19c21833$var$XHR, $bQD73);
/**
 * XHR supports binary
 */ $8a9bfffd19c21833$var$XHR.prototype.supportsBinary = true;
/**
 * Creates a request.
 *
 * @param {String} method
 * @api private
 */ $8a9bfffd19c21833$var$XHR.prototype.request = function(opts) {
    opts = opts || {};
    opts.uri = this.uri();
    opts.xd = this.xd;
    opts.xs = this.xs;
    opts.agent = this.agent || false;
    opts.supportsBinary = this.supportsBinary;
    opts.enablesXDR = this.enablesXDR;
    opts.withCredentials = this.withCredentials;
    // SSL options for Node.js client
    opts.pfx = this.pfx;
    opts.key = this.key;
    opts.passphrase = this.passphrase;
    opts.cert = this.cert;
    opts.ca = this.ca;
    opts.ciphers = this.ciphers;
    opts.rejectUnauthorized = this.rejectUnauthorized;
    opts.requestTimeout = this.requestTimeout;
    // other options for Node.js client
    opts.extraHeaders = this.extraHeaders;
    return new $8a9bfffd19c21833$var$Request(opts);
};
/**
 * Sends data.
 *
 * @param {String} data to send.
 * @param {Function} called upon flush.
 * @api private
 */ $8a9bfffd19c21833$var$XHR.prototype.doWrite = function(data, fn) {
    var isBinary = typeof data !== 'string' && data !== undefined;
    var req = this.request({
        method: 'POST',
        data: data,
        isBinary: isBinary
    });
    var self = this;
    req.on('success', fn);
    req.on('error', function(err) {
        self.onError('xhr post error', err);
    });
    this.sendXhr = req;
};
/**
 * Starts a poll cycle.
 *
 * @api private
 */ $8a9bfffd19c21833$var$XHR.prototype.doPoll = function() {
    $8a9bfffd19c21833$var$debug('xhr poll');
    var req = this.request();
    var self = this;
    req.on('data', function(data) {
        self.onData(data);
    });
    req.on('error', function(err) {
        self.onError('xhr poll error', err);
    });
    this.pollXhr = req;
};
/**
 * Request constructor
 *
 * @param {Object} options
 * @api public
 */ function $8a9bfffd19c21833$var$Request(opts) {
    this.method = opts.method || 'GET';
    this.uri = opts.uri;
    this.xd = !!opts.xd;
    this.xs = !!opts.xs;
    this.async = false !== opts.async;
    this.data = undefined !== opts.data ? opts.data : null;
    this.agent = opts.agent;
    this.isBinary = opts.isBinary;
    this.supportsBinary = opts.supportsBinary;
    this.enablesXDR = opts.enablesXDR;
    this.withCredentials = opts.withCredentials;
    this.requestTimeout = opts.requestTimeout;
    // SSL options for Node.js client
    this.pfx = opts.pfx;
    this.key = opts.key;
    this.passphrase = opts.passphrase;
    this.cert = opts.cert;
    this.ca = opts.ca;
    this.ciphers = opts.ciphers;
    this.rejectUnauthorized = opts.rejectUnauthorized;
    // other options for Node.js client
    this.extraHeaders = opts.extraHeaders;
    this.create();
}
/**
 * Mix in `Emitter`.
 */ $kHJIH($8a9bfffd19c21833$var$Request.prototype);
/**
 * Creates the XHR object and sends the request.
 *
 * @api private
 */ $8a9bfffd19c21833$var$Request.prototype.create = function() {
    var opts = {
        agent: this.agent,
        xdomain: this.xd,
        xscheme: this.xs,
        enablesXDR: this.enablesXDR
    };
    // SSL options for Node.js client
    opts.pfx = this.pfx;
    opts.key = this.key;
    opts.passphrase = this.passphrase;
    opts.cert = this.cert;
    opts.ca = this.ca;
    opts.ciphers = this.ciphers;
    opts.rejectUnauthorized = this.rejectUnauthorized;
    var xhr = this.xhr = new $OKFvV(opts);
    var self = this;
    try {
        $8a9bfffd19c21833$var$debug('xhr open %s: %s', this.method, this.uri);
        xhr.open(this.method, this.uri, this.async);
        try {
            if (this.extraHeaders) {
                xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                for(var i in this.extraHeaders)if (this.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this.extraHeaders[i]);
            }
        } catch (e) {}
        if ('POST' === this.method) try {
            if (this.isBinary) xhr.setRequestHeader('Content-type', 'application/octet-stream');
            else xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
        } catch (e) {}
        try {
            xhr.setRequestHeader('Accept', '*/*');
        } catch (e) {}
        // ie6 check
        if ('withCredentials' in xhr) xhr.withCredentials = this.withCredentials;
        if (this.requestTimeout) xhr.timeout = this.requestTimeout;
        if (this.hasXDR()) {
            xhr.onload = function() {
                self.onLoad();
            };
            xhr.onerror = function() {
                self.onError(xhr.responseText);
            };
        } else xhr.onreadystatechange = function() {
            if (xhr.readyState === 2) try {
                var contentType = xhr.getResponseHeader('Content-Type');
                if (self.supportsBinary && contentType === 'application/octet-stream' || contentType === 'application/octet-stream; charset=UTF-8') xhr.responseType = 'arraybuffer';
            } catch (e) {}
            if (4 !== xhr.readyState) return;
            if (200 === xhr.status || 1223 === xhr.status) self.onLoad();
            else // make sure the `error` event handler that's user-set
            // does not throw in the same tick and gets caught here
            setTimeout(function() {
                self.onError(typeof xhr.status === 'number' ? xhr.status : 0);
            }, 0);
        };
        $8a9bfffd19c21833$var$debug('xhr data %s', this.data);
        xhr.send(this.data);
    } catch (e) {
        // Need to defer since .create() is called directly fhrom the constructor
        // and thus the 'error' event can only be only bound *after* this exception
        // occurs.  Therefore, also, we cannot throw here at all.
        setTimeout(function() {
            self.onError(e);
        }, 0);
        return;
    }
    if (typeof document !== 'undefined') {
        this.index = $8a9bfffd19c21833$var$Request.requestsCount++;
        $8a9bfffd19c21833$var$Request.requests[this.index] = this;
    }
};
/**
 * Called upon successful response.
 *
 * @api private
 */ $8a9bfffd19c21833$var$Request.prototype.onSuccess = function() {
    this.emit('success');
    this.cleanup();
};
/**
 * Called if we have data.
 *
 * @api private
 */ $8a9bfffd19c21833$var$Request.prototype.onData = function(data) {
    this.emit('data', data);
    this.onSuccess();
};
/**
 * Called upon error.
 *
 * @api private
 */ $8a9bfffd19c21833$var$Request.prototype.onError = function(err) {
    this.emit('error', err);
    this.cleanup(true);
};
/**
 * Cleans up house.
 *
 * @api private
 */ $8a9bfffd19c21833$var$Request.prototype.cleanup = function(fromError) {
    if ('undefined' === typeof this.xhr || null === this.xhr) return;
    // xmlhttprequest
    if (this.hasXDR()) this.xhr.onload = this.xhr.onerror = $8a9bfffd19c21833$var$empty;
    else this.xhr.onreadystatechange = $8a9bfffd19c21833$var$empty;
    if (fromError) try {
        this.xhr.abort();
    } catch (e) {}
    if (typeof document !== 'undefined') delete $8a9bfffd19c21833$var$Request.requests[this.index];
    this.xhr = null;
};
/**
 * Called upon load.
 *
 * @api private
 */ $8a9bfffd19c21833$var$Request.prototype.onLoad = function() {
    var data;
    try {
        var contentType;
        try {
            contentType = this.xhr.getResponseHeader('Content-Type');
        } catch (e) {}
        if (contentType === 'application/octet-stream' || contentType === 'application/octet-stream; charset=UTF-8') data = this.xhr.response || this.xhr.responseText;
        else data = this.xhr.responseText;
    } catch (e) {
        this.onError(e);
    }
    if (null != data) this.onData(data);
};
/**
 * Check if it has XDomainRequest.
 *
 * @api private
 */ $8a9bfffd19c21833$var$Request.prototype.hasXDR = function() {
    return typeof XDomainRequest !== 'undefined' && !this.xs && this.enablesXDR;
};
/**
 * Aborts the request.
 *
 * @api public
 */ $8a9bfffd19c21833$var$Request.prototype.abort = function() {
    this.cleanup();
};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ $8a9bfffd19c21833$var$Request.requestsCount = 0;
$8a9bfffd19c21833$var$Request.requests = {};
if (typeof document !== 'undefined') {
    if (typeof attachEvent === 'function') attachEvent('onunload', $8a9bfffd19c21833$var$unloadHandler);
    else if (typeof addEventListener === 'function') {
        var $8a9bfffd19c21833$var$terminationEvent = 'onpagehide' in $eBFAY ? 'pagehide' : 'unload';
        addEventListener($8a9bfffd19c21833$var$terminationEvent, $8a9bfffd19c21833$var$unloadHandler, false);
    }
}
function $8a9bfffd19c21833$var$unloadHandler() {
    for(var i in $8a9bfffd19c21833$var$Request.requests)if ($8a9bfffd19c21833$var$Request.requests.hasOwnProperty(i)) $8a9bfffd19c21833$var$Request.requests[i].abort();
}

});
parcelRegister("bQD73", function(module, exports) {
/**
 * Module dependencies.
 */ 
var $5du6X = parcelRequire("5du6X");

var $gDMgm = parcelRequire("gDMgm");

var $3OROY = parcelRequire("3OROY");

var $13Nwl = parcelRequire("13Nwl");

var $2AmE2 = parcelRequire("2AmE2");

var $8a02e40bf8e1cca5$var$debug = (parcelRequire("lr39n"))('engine.io-client:polling');
/**
 * Module exports.
 */ module.exports = $8a02e40bf8e1cca5$var$Polling;

/**
 * Is XHR2 supported?
 */ var $8a02e40bf8e1cca5$var$hasXHR2 = function() {
    var XMLHttpRequest = (parcelRequire("OKFvV"));
    var xhr = new XMLHttpRequest({
        xdomain: false
    });
    return null != xhr.responseType;
}();
/**
 * Polling interface.
 *
 * @param {Object} opts
 * @api private
 */ function $8a02e40bf8e1cca5$var$Polling(opts) {
    var forceBase64 = opts && opts.forceBase64;
    if (!$8a02e40bf8e1cca5$var$hasXHR2 || forceBase64) this.supportsBinary = false;
    $5du6X.call(this, opts);
}
/**
 * Inherits from Transport.
 */ $13Nwl($8a02e40bf8e1cca5$var$Polling, $5du6X);
/**
 * Transport name.
 */ $8a02e40bf8e1cca5$var$Polling.prototype.name = 'polling';
/**
 * Opens the socket (triggers polling). We write a PING message to determine
 * when the transport is open.
 *
 * @api private
 */ $8a02e40bf8e1cca5$var$Polling.prototype.doOpen = function() {
    this.poll();
};
/**
 * Pauses polling.
 *
 * @param {Function} callback upon buffers are flushed and transport is paused
 * @api private
 */ $8a02e40bf8e1cca5$var$Polling.prototype.pause = function(onPause) {
    var self = this;
    this.readyState = 'pausing';
    function pause() {
        $8a02e40bf8e1cca5$var$debug('paused');
        self.readyState = 'paused';
        onPause();
    }
    if (this.polling || !this.writable) {
        var total = 0;
        if (this.polling) {
            $8a02e40bf8e1cca5$var$debug('we are currently polling - waiting to pause');
            total++;
            this.once('pollComplete', function() {
                $8a02e40bf8e1cca5$var$debug('pre-pause polling complete');
                --total || pause();
            });
        }
        if (!this.writable) {
            $8a02e40bf8e1cca5$var$debug('we are currently writing - waiting to pause');
            total++;
            this.once('drain', function() {
                $8a02e40bf8e1cca5$var$debug('pre-pause writing complete');
                --total || pause();
            });
        }
    } else pause();
};
/**
 * Starts polling cycle.
 *
 * @api public
 */ $8a02e40bf8e1cca5$var$Polling.prototype.poll = function() {
    $8a02e40bf8e1cca5$var$debug('polling');
    this.polling = true;
    this.doPoll();
    this.emit('poll');
};
/**
 * Overloads onData to detect payloads.
 *
 * @api private
 */ $8a02e40bf8e1cca5$var$Polling.prototype.onData = function(data) {
    var self = this;
    $8a02e40bf8e1cca5$var$debug('polling got data %s', data);
    var callback = function(packet, index, total) {
        // if its the first message we consider the transport open
        if ('opening' === self.readyState && packet.type === 'open') self.onOpen();
        // if its a close packet, we close the ongoing requests
        if ('close' === packet.type) {
            self.onClose();
            return false;
        }
        // otherwise bypass onData and handle the message
        self.onPacket(packet);
    };
    // decode payload
    $3OROY.decodePayload(data, this.socket.binaryType, callback);
    // if an event did not trigger closing
    if ('closed' !== this.readyState) {
        // if we got data we're not polling
        this.polling = false;
        this.emit('pollComplete');
        if ('open' === this.readyState) this.poll();
        else $8a02e40bf8e1cca5$var$debug('ignoring poll - transport state "%s"', this.readyState);
    }
};
/**
 * For polling, send a close packet.
 *
 * @api private
 */ $8a02e40bf8e1cca5$var$Polling.prototype.doClose = function() {
    var self = this;
    function close() {
        $8a02e40bf8e1cca5$var$debug('writing close packet');
        self.write([
            {
                type: 'close'
            }
        ]);
    }
    if ('open' === this.readyState) {
        $8a02e40bf8e1cca5$var$debug('transport open - closing');
        close();
    } else {
        // in case we're trying to close while
        // handshaking is in progress (GH-164)
        $8a02e40bf8e1cca5$var$debug('transport not open - deferring close');
        this.once('open', close);
    }
};
/**
 * Writes a packets payload.
 *
 * @param {Array} data packets
 * @param {Function} drain callback
 * @api private
 */ $8a02e40bf8e1cca5$var$Polling.prototype.write = function(packets) {
    var self = this;
    this.writable = false;
    var callbackfn = function() {
        self.writable = true;
        self.emit('drain');
    };
    $3OROY.encodePayload(packets, this.supportsBinary, function(data) {
        self.doWrite(data, callbackfn);
    });
};
/**
 * Generates uri for connection.
 *
 * @api private
 */ $8a02e40bf8e1cca5$var$Polling.prototype.uri = function() {
    var query = this.query || {};
    var schema = this.secure ? 'https' : 'http';
    var port = '';
    // cache busting is forced
    if (false !== this.timestampRequests) query[this.timestampParam] = $2AmE2();
    if (!this.supportsBinary && !query.sid) query.b64 = 1;
    query = $gDMgm.encode(query);
    // avoid port if default for schema
    if (this.port && ('https' === schema && Number(this.port) !== 443 || 'http' === schema && Number(this.port) !== 80)) port = ':' + this.port;
    // prepend ? to query
    if (query.length) query = '?' + query;
    var ipv6 = this.hostname.indexOf(':') !== -1;
    return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
};

});
parcelRegister("5du6X", function(module, exports) {
/**
 * Module dependencies.
 */ 
var $3OROY = parcelRequire("3OROY");

var $kHJIH = parcelRequire("kHJIH");
/**
 * Module exports.
 */ module.exports = $3cc58619a9e33724$var$Transport;
/**
 * Transport abstract constructor.
 *
 * @param {Object} options.
 * @api private
 */ function $3cc58619a9e33724$var$Transport(opts) {
    this.path = opts.path;
    this.hostname = opts.hostname;
    this.port = opts.port;
    this.secure = opts.secure;
    this.query = opts.query;
    this.timestampParam = opts.timestampParam;
    this.timestampRequests = opts.timestampRequests;
    this.readyState = '';
    this.agent = opts.agent || false;
    this.socket = opts.socket;
    this.enablesXDR = opts.enablesXDR;
    this.withCredentials = opts.withCredentials;
    // SSL options for Node.js client
    this.pfx = opts.pfx;
    this.key = opts.key;
    this.passphrase = opts.passphrase;
    this.cert = opts.cert;
    this.ca = opts.ca;
    this.ciphers = opts.ciphers;
    this.rejectUnauthorized = opts.rejectUnauthorized;
    this.forceNode = opts.forceNode;
    // results of ReactNative environment detection
    this.isReactNative = opts.isReactNative;
    // other options for Node.js client
    this.extraHeaders = opts.extraHeaders;
    this.localAddress = opts.localAddress;
}
/**
 * Mix in `Emitter`.
 */ $kHJIH($3cc58619a9e33724$var$Transport.prototype);
/**
 * Emits an error.
 *
 * @param {String} str
 * @return {Transport} for chaining
 * @api public
 */ $3cc58619a9e33724$var$Transport.prototype.onError = function(msg, desc) {
    var err = new Error(msg);
    err.type = 'TransportError';
    err.description = desc;
    this.emit('error', err);
    return this;
};
/**
 * Opens the transport.
 *
 * @api public
 */ $3cc58619a9e33724$var$Transport.prototype.open = function() {
    if ('closed' === this.readyState || '' === this.readyState) {
        this.readyState = 'opening';
        this.doOpen();
    }
    return this;
};
/**
 * Closes the transport.
 *
 * @api private
 */ $3cc58619a9e33724$var$Transport.prototype.close = function() {
    if ('opening' === this.readyState || 'open' === this.readyState) {
        this.doClose();
        this.onClose();
    }
    return this;
};
/**
 * Sends multiple packets.
 *
 * @param {Array} packets
 * @api private
 */ $3cc58619a9e33724$var$Transport.prototype.send = function(packets) {
    if ('open' === this.readyState) this.write(packets);
    else throw new Error('Transport not open');
};
/**
 * Called upon open
 *
 * @api private
 */ $3cc58619a9e33724$var$Transport.prototype.onOpen = function() {
    this.readyState = 'open';
    this.writable = true;
    this.emit('open');
};
/**
 * Called with data.
 *
 * @param {String} data
 * @api private
 */ $3cc58619a9e33724$var$Transport.prototype.onData = function(data) {
    var packet = $3OROY.decodePacket(data, this.socket.binaryType);
    this.onPacket(packet);
};
/**
 * Called with a decoded packet.
 */ $3cc58619a9e33724$var$Transport.prototype.onPacket = function(packet) {
    this.emit('packet', packet);
};
/**
 * Called upon close.
 *
 * @api private
 */ $3cc58619a9e33724$var$Transport.prototype.onClose = function() {
    this.readyState = 'closed';
    this.emit('close');
};

});
parcelRegister("3OROY", function(module, exports) {

$parcel$export(module.exports, "protocol", function () { return $2c7fca5de4fc2be9$export$a51d6b395ff4c65a; }, function (v) { return $2c7fca5de4fc2be9$export$a51d6b395ff4c65a = v; });
$parcel$export(module.exports, "packets", function () { return $2c7fca5de4fc2be9$export$8cec925cdbc069a3; }, function (v) { return $2c7fca5de4fc2be9$export$8cec925cdbc069a3 = v; });
$parcel$export(module.exports, "encodePacket", function () { return $2c7fca5de4fc2be9$export$57852049361a8e62; }, function (v) { return $2c7fca5de4fc2be9$export$57852049361a8e62 = v; });
$parcel$export(module.exports, "encodeBase64Packet", function () { return $2c7fca5de4fc2be9$export$1224bd349343a780; }, function (v) { return $2c7fca5de4fc2be9$export$1224bd349343a780 = v; });
$parcel$export(module.exports, "decodePacket", function () { return $2c7fca5de4fc2be9$export$4647901878f33f31; }, function (v) { return $2c7fca5de4fc2be9$export$4647901878f33f31 = v; });
$parcel$export(module.exports, "decodeBase64Packet", function () { return $2c7fca5de4fc2be9$export$d8083abc502764be; }, function (v) { return $2c7fca5de4fc2be9$export$d8083abc502764be = v; });
$parcel$export(module.exports, "encodePayload", function () { return $2c7fca5de4fc2be9$export$144d64fe58dad441; }, function (v) { return $2c7fca5de4fc2be9$export$144d64fe58dad441 = v; });
$parcel$export(module.exports, "encodePayloadAsBlob", function () { return $2c7fca5de4fc2be9$export$189405ab6c76376a; }, function (v) { return $2c7fca5de4fc2be9$export$189405ab6c76376a = v; });
$parcel$export(module.exports, "encodePayloadAsArrayBuffer", function () { return $2c7fca5de4fc2be9$export$ae2b9d31affbcbb7; }, function (v) { return $2c7fca5de4fc2be9$export$ae2b9d31affbcbb7 = v; });
$parcel$export(module.exports, "decodePayload", function () { return $2c7fca5de4fc2be9$export$d10cc2e7f7566a2d; }, function (v) { return $2c7fca5de4fc2be9$export$d10cc2e7f7566a2d = v; });
$parcel$export(module.exports, "decodePayloadAsBinary", function () { return $2c7fca5de4fc2be9$export$94d8cc1d96592971; }, function (v) { return $2c7fca5de4fc2be9$export$94d8cc1d96592971 = v; });
/**
 * Module dependencies.
 */ /**
 * Current protocol version.
 */ var $2c7fca5de4fc2be9$export$a51d6b395ff4c65a;
var $2c7fca5de4fc2be9$export$8cec925cdbc069a3;
/**
 * Encodes a packet.
 *
 *     <packet type id> [ <data> ]
 *
 * Example:
 *
 *     5hello world
 *     3
 *     4
 *
 * Binary is encoded in an identical principle
 *
 * @api private
 */ var $2c7fca5de4fc2be9$export$57852049361a8e62;
/**
 * Encodes a packet with binary data in a base64 string
 *
 * @param {Object} packet, has `type` and `data`
 * @return {String} base64 encoded message
 */ var $2c7fca5de4fc2be9$export$1224bd349343a780;
/**
 * Decodes a packet. Changes format to Blob if requested.
 *
 * @return {Object} with `type` and `data` (if any)
 * @api private
 */ var $2c7fca5de4fc2be9$export$4647901878f33f31;
/**
 * Decodes a packet encoded in a base64 string
 *
 * @param {String} base64 encoded message
 * @return {Object} with `type` and `data` (if any)
 */ var $2c7fca5de4fc2be9$export$d8083abc502764be;
/**
 * Encodes multiple messages (payload).
 *
 *     <length>:data
 *
 * Example:
 *
 *     11:hello world2:hi
 *
 * If any contents are binary, they will be encoded as base64 strings. Base64
 * encoded strings are marked with a b before the length specifier
 *
 * @param {Array} packets
 * @api private
 */ var $2c7fca5de4fc2be9$export$144d64fe58dad441;
/*
 * Decodes data when a payload is maybe expected. Possible binary contents are
 * decoded from their base64 representation
 *
 * @param {String} data, callback method
 * @api public
 */ var $2c7fca5de4fc2be9$export$d10cc2e7f7566a2d;
/**
 * Encodes multiple messages (payload) as binary.
 *
 * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number
 * 255><data>
 *
 * Example:
 * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers
 *
 * @param {Array} packets
 * @return {ArrayBuffer} encoded payload
 * @api private
 */ var $2c7fca5de4fc2be9$export$ae2b9d31affbcbb7;
/**
 * Encode as Blob
 */ var $2c7fca5de4fc2be9$export$189405ab6c76376a;
/*
 * Decodes data when a payload is maybe expected. Strings are decoded by
 * interpreting each byte as a key code for entries marked to start with 0. See
 * description of encodePayloadAsBinary
 *
 * @param {ArrayBuffer} data, callback method
 * @api public
 */ var $2c7fca5de4fc2be9$export$94d8cc1d96592971;

var $7L7J8 = parcelRequire("7L7J8");

var $iIxzO = parcelRequire("iIxzO");

var $Nk0vt = parcelRequire("Nk0vt");

var $1MO0T = parcelRequire("1MO0T");

var $jFNrI = parcelRequire("jFNrI");
var $2c7fca5de4fc2be9$var$base64encoder;

if (typeof ArrayBuffer !== 'undefined') $2c7fca5de4fc2be9$var$base64encoder = (parcelRequire("6sLQI"));
/**
 * Check if we are running an android browser. That requires us to use
 * ArrayBuffer with polling transports...
 *
 * http://ghinda.net/jpeg-blob-ajax-android/
 */ var $2c7fca5de4fc2be9$var$isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);
/**
 * Check if we are running in PhantomJS.
 * Uploading a Blob with PhantomJS does not work correctly, as reported here:
 * https://github.com/ariya/phantomjs/issues/11395
 * @type boolean
 */ var $2c7fca5de4fc2be9$var$isPhantomJS = typeof navigator !== 'undefined' && /PhantomJS/i.test(navigator.userAgent);
/**
 * When true, avoids using Blobs to encode payloads.
 * @type boolean
 */ var $2c7fca5de4fc2be9$var$dontSendBlobs = $2c7fca5de4fc2be9$var$isAndroid || $2c7fca5de4fc2be9$var$isPhantomJS;
$2c7fca5de4fc2be9$export$a51d6b395ff4c65a = 3;
/**
 * Packet types.
 */ var $2c7fca5de4fc2be9$var$packets = $2c7fca5de4fc2be9$export$8cec925cdbc069a3 = {
    open: 0 // non-ws
    ,
    close: 1 // non-ws
    ,
    ping: 2,
    pong: 3,
    message: 4,
    upgrade: 5,
    noop: 6
};
var $2c7fca5de4fc2be9$var$packetslist = $7L7J8($2c7fca5de4fc2be9$var$packets);
/**
 * Premade error packet.
 */ var $2c7fca5de4fc2be9$var$err = {
    type: 'error',
    data: 'parser error'
};

var $3fzb3 = parcelRequire("3fzb3");
$2c7fca5de4fc2be9$export$57852049361a8e62 = function(packet, supportsBinary, utf8encode, callback) {
    if (typeof supportsBinary === 'function') {
        callback = supportsBinary;
        supportsBinary = false;
    }
    if (typeof utf8encode === 'function') {
        callback = utf8encode;
        utf8encode = null;
    }
    var data = packet.data === undefined ? undefined : packet.data.buffer || packet.data;
    if (typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) return $2c7fca5de4fc2be9$var$encodeArrayBuffer(packet, supportsBinary, callback);
    else if (typeof $3fzb3 !== 'undefined' && data instanceof $3fzb3) return $2c7fca5de4fc2be9$var$encodeBlob(packet, supportsBinary, callback);
    // might be an object with { base64: true, data: dataAsBase64String }
    if (data && data.base64) return $2c7fca5de4fc2be9$var$encodeBase64Object(packet, callback);
    // Sending data as a utf-8 string
    var encoded = $2c7fca5de4fc2be9$var$packets[packet.type];
    // data fragment is optional
    if (undefined !== packet.data) encoded += utf8encode ? $jFNrI.encode(String(packet.data), {
        strict: false
    }) : String(packet.data);
    return callback('' + encoded);
};
function $2c7fca5de4fc2be9$var$encodeBase64Object(packet, callback) {
    // packet data is an object { base64: true, data: dataAsBase64String }
    var message = 'b' + $2c7fca5de4fc2be9$export$8cec925cdbc069a3[packet.type] + packet.data.data;
    return callback(message);
}
/**
 * Encode packet helpers for binary types
 */ function $2c7fca5de4fc2be9$var$encodeArrayBuffer(packet, supportsBinary, callback) {
    if (!supportsBinary) return $2c7fca5de4fc2be9$export$1224bd349343a780(packet, callback);
    var data = packet.data;
    var contentArray = new Uint8Array(data);
    var resultBuffer = new Uint8Array(1 + data.byteLength);
    resultBuffer[0] = $2c7fca5de4fc2be9$var$packets[packet.type];
    for(var i = 0; i < contentArray.length; i++)resultBuffer[i + 1] = contentArray[i];
    return callback(resultBuffer.buffer);
}
function $2c7fca5de4fc2be9$var$encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
    if (!supportsBinary) return $2c7fca5de4fc2be9$export$1224bd349343a780(packet, callback);
    var fr = new FileReader();
    fr.onload = function() {
        $2c7fca5de4fc2be9$export$57852049361a8e62({
            type: packet.type,
            data: fr.result
        }, supportsBinary, true, callback);
    };
    return fr.readAsArrayBuffer(packet.data);
}
function $2c7fca5de4fc2be9$var$encodeBlob(packet, supportsBinary, callback) {
    if (!supportsBinary) return $2c7fca5de4fc2be9$export$1224bd349343a780(packet, callback);
    if ($2c7fca5de4fc2be9$var$dontSendBlobs) return $2c7fca5de4fc2be9$var$encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
    var length = new Uint8Array(1);
    length[0] = $2c7fca5de4fc2be9$var$packets[packet.type];
    var blob = new $3fzb3([
        length.buffer,
        packet.data
    ]);
    return callback(blob);
}
$2c7fca5de4fc2be9$export$1224bd349343a780 = function(packet, callback) {
    var message = 'b' + $2c7fca5de4fc2be9$export$8cec925cdbc069a3[packet.type];
    if (typeof $3fzb3 !== 'undefined' && packet.data instanceof $3fzb3) {
        var fr = new FileReader();
        fr.onload = function() {
            var b64 = fr.result.split(',')[1];
            callback(message + b64);
        };
        return fr.readAsDataURL(packet.data);
    }
    var b64data;
    try {
        b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
    } catch (e) {
        // iPhone Safari doesn't let you apply with typed arrays
        var typed = new Uint8Array(packet.data);
        var basic = new Array(typed.length);
        for(var i = 0; i < typed.length; i++)basic[i] = typed[i];
        b64data = String.fromCharCode.apply(null, basic);
    }
    message += btoa(b64data);
    return callback(message);
};
$2c7fca5de4fc2be9$export$4647901878f33f31 = function(data, binaryType, utf8decode) {
    if (data === undefined) return $2c7fca5de4fc2be9$var$err;
    // String data
    if (typeof data === 'string') {
        if (data.charAt(0) === 'b') return $2c7fca5de4fc2be9$export$d8083abc502764be(data.substr(1), binaryType);
        if (utf8decode) {
            data = $2c7fca5de4fc2be9$var$tryDecode(data);
            if (data === false) return $2c7fca5de4fc2be9$var$err;
        }
        var type = data.charAt(0);
        if (Number(type) != type || !$2c7fca5de4fc2be9$var$packetslist[type]) return $2c7fca5de4fc2be9$var$err;
        if (data.length > 1) return {
            type: $2c7fca5de4fc2be9$var$packetslist[type],
            data: data.substring(1)
        };
        else return {
            type: $2c7fca5de4fc2be9$var$packetslist[type]
        };
    }
    var asArray = new Uint8Array(data);
    var type = asArray[0];
    var rest = $Nk0vt(data, 1);
    if ($3fzb3 && binaryType === 'blob') rest = new $3fzb3([
        rest
    ]);
    return {
        type: $2c7fca5de4fc2be9$var$packetslist[type],
        data: rest
    };
};
function $2c7fca5de4fc2be9$var$tryDecode(data) {
    try {
        data = $jFNrI.decode(data, {
            strict: false
        });
    } catch (e) {
        return false;
    }
    return data;
}
$2c7fca5de4fc2be9$export$d8083abc502764be = function(msg, binaryType) {
    var type = $2c7fca5de4fc2be9$var$packetslist[msg.charAt(0)];
    if (!$2c7fca5de4fc2be9$var$base64encoder) return {
        type: type,
        data: {
            base64: true,
            data: msg.substr(1)
        }
    };
    var data = $2c7fca5de4fc2be9$var$base64encoder.decode(msg.substr(1));
    if (binaryType === 'blob' && $3fzb3) data = new $3fzb3([
        data
    ]);
    return {
        type: type,
        data: data
    };
};
$2c7fca5de4fc2be9$export$144d64fe58dad441 = function(packets, supportsBinary, callback) {
    if (typeof supportsBinary === 'function') {
        callback = supportsBinary;
        supportsBinary = null;
    }
    var isBinary = $iIxzO(packets);
    if (supportsBinary && isBinary) {
        if ($3fzb3 && !$2c7fca5de4fc2be9$var$dontSendBlobs) return $2c7fca5de4fc2be9$export$189405ab6c76376a(packets, callback);
        return $2c7fca5de4fc2be9$export$ae2b9d31affbcbb7(packets, callback);
    }
    if (!packets.length) return callback('0:');
    function setLengthHeader(message) {
        return message.length + ':' + message;
    }
    function encodeOne(packet, doneCallback) {
        $2c7fca5de4fc2be9$export$57852049361a8e62(packet, !isBinary ? false : supportsBinary, false, function(message) {
            doneCallback(null, setLengthHeader(message));
        });
    }
    $2c7fca5de4fc2be9$var$map(packets, encodeOne, function(err, results) {
        return callback(results.join(''));
    });
};
/**
 * Async array map using after
 */ function $2c7fca5de4fc2be9$var$map(ary, each, done) {
    var result = new Array(ary.length);
    var next = $1MO0T(ary.length, done);
    var eachWithIndex = function(i, el, cb) {
        each(el, function(error, msg) {
            result[i] = msg;
            cb(error, result);
        });
    };
    for(var i = 0; i < ary.length; i++)eachWithIndex(i, ary[i], next);
}
$2c7fca5de4fc2be9$export$d10cc2e7f7566a2d = function(data, binaryType, callback) {
    if (typeof data !== 'string') return $2c7fca5de4fc2be9$export$94d8cc1d96592971(data, binaryType, callback);
    if (typeof binaryType === 'function') {
        callback = binaryType;
        binaryType = null;
    }
    var packet;
    if (data === '') // parser error - ignoring payload
    return callback($2c7fca5de4fc2be9$var$err, 0, 1);
    var length = '', n, msg;
    for(var i = 0, l = data.length; i < l; i++){
        var chr = data.charAt(i);
        if (chr !== ':') {
            length += chr;
            continue;
        }
        if (length === '' || length != (n = Number(length))) // parser error - ignoring payload
        return callback($2c7fca5de4fc2be9$var$err, 0, 1);
        msg = data.substr(i + 1, n);
        if (length != msg.length) // parser error - ignoring payload
        return callback($2c7fca5de4fc2be9$var$err, 0, 1);
        if (msg.length) {
            packet = $2c7fca5de4fc2be9$export$4647901878f33f31(msg, binaryType, false);
            if ($2c7fca5de4fc2be9$var$err.type === packet.type && $2c7fca5de4fc2be9$var$err.data === packet.data) // parser error in individual packet - ignoring payload
            return callback($2c7fca5de4fc2be9$var$err, 0, 1);
            var ret = callback(packet, i + n, l);
            if (false === ret) return;
        }
        // advance cursor
        i += n;
        length = '';
    }
    if (length !== '') // parser error - ignoring payload
    return callback($2c7fca5de4fc2be9$var$err, 0, 1);
};
$2c7fca5de4fc2be9$export$ae2b9d31affbcbb7 = function(packets, callback) {
    if (!packets.length) return callback(new ArrayBuffer(0));
    function encodeOne(packet, doneCallback) {
        $2c7fca5de4fc2be9$export$57852049361a8e62(packet, true, true, function(data) {
            return doneCallback(null, data);
        });
    }
    $2c7fca5de4fc2be9$var$map(packets, encodeOne, function(err, encodedPackets) {
        var totalLength = encodedPackets.reduce(function(acc, p) {
            var len;
            if (typeof p === 'string') len = p.length;
            else len = p.byteLength;
            return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2
        }, 0);
        var resultArray = new Uint8Array(totalLength);
        var bufferIndex = 0;
        encodedPackets.forEach(function(p) {
            var isString = typeof p === 'string';
            var ab = p;
            if (isString) {
                var view = new Uint8Array(p.length);
                for(var i = 0; i < p.length; i++)view[i] = p.charCodeAt(i);
                ab = view.buffer;
            }
            if (isString) resultArray[bufferIndex++] = 0;
            else resultArray[bufferIndex++] = 1;
            var lenStr = ab.byteLength.toString();
            for(var i = 0; i < lenStr.length; i++)resultArray[bufferIndex++] = parseInt(lenStr[i]);
            resultArray[bufferIndex++] = 255;
            var view = new Uint8Array(ab);
            for(var i = 0; i < view.length; i++)resultArray[bufferIndex++] = view[i];
        });
        return callback(resultArray.buffer);
    });
};
$2c7fca5de4fc2be9$export$189405ab6c76376a = function(packets, callback) {
    function encodeOne(packet, doneCallback) {
        $2c7fca5de4fc2be9$export$57852049361a8e62(packet, true, true, function(encoded) {
            var binaryIdentifier = new Uint8Array(1);
            binaryIdentifier[0] = 1;
            if (typeof encoded === 'string') {
                var view = new Uint8Array(encoded.length);
                for(var i = 0; i < encoded.length; i++)view[i] = encoded.charCodeAt(i);
                encoded = view.buffer;
                binaryIdentifier[0] = 0;
            }
            var len = encoded instanceof ArrayBuffer ? encoded.byteLength : encoded.size;
            var lenStr = len.toString();
            var lengthAry = new Uint8Array(lenStr.length + 1);
            for(var i = 0; i < lenStr.length; i++)lengthAry[i] = parseInt(lenStr[i]);
            lengthAry[lenStr.length] = 255;
            if ($3fzb3) {
                var blob = new $3fzb3([
                    binaryIdentifier.buffer,
                    lengthAry.buffer,
                    encoded
                ]);
                doneCallback(null, blob);
            }
        });
    }
    $2c7fca5de4fc2be9$var$map(packets, encodeOne, function(err, results) {
        return callback(new $3fzb3(results));
    });
};
$2c7fca5de4fc2be9$export$94d8cc1d96592971 = function(data, binaryType, callback) {
    if (typeof binaryType === 'function') {
        callback = binaryType;
        binaryType = null;
    }
    var bufferTail = data;
    var buffers = [];
    while(bufferTail.byteLength > 0){
        var tailArray = new Uint8Array(bufferTail);
        var isString = tailArray[0] === 0;
        var msgLength = '';
        for(var i = 1;; i++){
            if (tailArray[i] === 255) break;
            // 310 = char length of Number.MAX_VALUE
            if (msgLength.length > 310) return callback($2c7fca5de4fc2be9$var$err, 0, 1);
            msgLength += tailArray[i];
        }
        bufferTail = $Nk0vt(bufferTail, 2 + msgLength.length);
        msgLength = parseInt(msgLength);
        var msg = $Nk0vt(bufferTail, 0, msgLength);
        if (isString) try {
            msg = String.fromCharCode.apply(null, new Uint8Array(msg));
        } catch (e) {
            // iPhone Safari doesn't let you apply to typed arrays
            var typed = new Uint8Array(msg);
            msg = '';
            for(var i = 0; i < typed.length; i++)msg += String.fromCharCode(typed[i]);
        }
        buffers.push(msg);
        bufferTail = $Nk0vt(bufferTail, msgLength);
    }
    var total = buffers.length;
    buffers.forEach(function(buffer, i) {
        callback($2c7fca5de4fc2be9$export$4647901878f33f31(buffer, binaryType, true), i, total);
    });
};

});
parcelRegister("7L7J8", function(module, exports) {
/**
 * Gets the keys for an object.
 *
 * @return {Array} keys
 * @api private
 */ module.exports = Object.keys || function keys(obj) {
    var arr = [];
    var has = Object.prototype.hasOwnProperty;
    for(var i in obj)if (has.call(obj, i)) arr.push(i);
    return arr;
};

});

parcelRegister("iIxzO", function(module, exports) {
/* global Blob File */ /*
 * Module requirements.
 */ 
var $gzLuY = parcelRequire("gzLuY");
var $da0661a84897abc2$require$Buffer = $gzLuY.Buffer;

var $aTpG3 = parcelRequire("aTpG3");
var $da0661a84897abc2$var$toString = Object.prototype.toString;
var $da0661a84897abc2$var$withNativeBlob = typeof Blob === 'function' || typeof Blob !== 'undefined' && $da0661a84897abc2$var$toString.call(Blob) === '[object BlobConstructor]';
var $da0661a84897abc2$var$withNativeFile = typeof File === 'function' || typeof File !== 'undefined' && $da0661a84897abc2$var$toString.call(File) === '[object FileConstructor]';
/**
 * Module exports.
 */ module.exports = $da0661a84897abc2$var$hasBinary;
/**
 * Checks for binary data.
 *
 * Supports Buffer, ArrayBuffer, Blob and File.
 *
 * @param {Object} anything
 * @api public
 */ function $da0661a84897abc2$var$hasBinary(obj) {
    if (!obj || typeof obj !== 'object') return false;
    if ($aTpG3(obj)) {
        for(var i = 0, l = obj.length; i < l; i++){
            if ($da0661a84897abc2$var$hasBinary(obj[i])) return true;
        }
        return false;
    }
    if (typeof $da0661a84897abc2$require$Buffer === 'function' && $da0661a84897abc2$require$Buffer.isBuffer && $da0661a84897abc2$require$Buffer.isBuffer(obj) || typeof ArrayBuffer === 'function' && obj instanceof ArrayBuffer || $da0661a84897abc2$var$withNativeBlob && obj instanceof Blob || $da0661a84897abc2$var$withNativeFile && obj instanceof File) return true;
    // see: https://github.com/Automattic/has-binary/pull/4
    if (obj.toJSON && typeof obj.toJSON === 'function' && arguments.length === 1) return $da0661a84897abc2$var$hasBinary(obj.toJSON(), true);
    for(var key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $da0661a84897abc2$var$hasBinary(obj[key])) return true;
    }
    return false;
}

});
parcelRegister("aTpG3", function(module, exports) {
var $7ee2f56479e6ef39$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $7ee2f56479e6ef39$var$toString.call(arr) == '[object Array]';
};

});


parcelRegister("Nk0vt", function(module, exports) {
/**
 * An abstraction for slicing an arraybuffer even when
 * ArrayBuffer.prototype.slice is not supported
 *
 * @api public
 */ module.exports = function(arraybuffer, start, end) {
    var bytes = arraybuffer.byteLength;
    start = start || 0;
    end = end || bytes;
    if (arraybuffer.slice) return arraybuffer.slice(start, end);
    if (start < 0) start += bytes;
    if (end < 0) end += bytes;
    if (end > bytes) end = bytes;
    if (start >= bytes || start >= end || bytes === 0) return new ArrayBuffer(0);
    var abv = new Uint8Array(arraybuffer);
    var result = new Uint8Array(end - start);
    for(var i = start, ii = 0; i < end; i++, ii++)result[ii] = abv[i];
    return result.buffer;
};

});

parcelRegister("1MO0T", function(module, exports) {
module.exports = $14d111c290f3a423$var$after;
function $14d111c290f3a423$var$after(count, callback, err_cb) {
    var bail = false;
    err_cb = err_cb || $14d111c290f3a423$var$noop;
    proxy.count = count;
    return count === 0 ? callback() : proxy;
    function proxy(err, result) {
        if (proxy.count <= 0) throw new Error('after called too many times');
        --proxy.count;
        // after first error, rest are passed to err_cb
        if (err) {
            bail = true;
            callback(err);
            // future error callbacks will go to error handler
            callback = err_cb;
        } else if (proxy.count === 0 && !bail) callback(null, result);
    }
}
function $14d111c290f3a423$var$noop() {}

});

parcelRegister("jFNrI", function(module, exports) {
/*! https://mths.be/utf8js v2.1.2 by @mathias */ var $e528339be879e4ec$var$stringFromCharCode = String.fromCharCode;
// Taken from https://mths.be/punycode
function $e528339be879e4ec$var$ucs2decode(string) {
    var output = [];
    var counter = 0;
    var length = string.length;
    var value;
    var extra;
    while(counter < length){
        value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // high surrogate, and there is a next character
            extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // unmatched surrogate; only append this code unit, in case the next
                // code unit is the high surrogate of a surrogate pair
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
// Taken from https://mths.be/punycode
function $e528339be879e4ec$var$ucs2encode(array) {
    var length = array.length;
    var index = -1;
    var value;
    var output = '';
    while(++index < length){
        value = array[index];
        if (value > 0xFFFF) {
            value -= 0x10000;
            output += $e528339be879e4ec$var$stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
            value = 0xDC00 | value & 0x3FF;
        }
        output += $e528339be879e4ec$var$stringFromCharCode(value);
    }
    return output;
}
function $e528339be879e4ec$var$checkScalarValue(codePoint, strict) {
    if (codePoint >= 0xD800 && codePoint <= 0xDFFF) {
        if (strict) throw Error('Lone surrogate U+' + codePoint.toString(16).toUpperCase() + ' is not a scalar value');
        return false;
    }
    return true;
}
/*--------------------------------------------------------------------------*/ function $e528339be879e4ec$var$createByte(codePoint, shift) {
    return $e528339be879e4ec$var$stringFromCharCode(codePoint >> shift & 0x3F | 0x80);
}
function $e528339be879e4ec$var$encodeCodePoint(codePoint, strict) {
    if ((codePoint & 0xFFFFFF80) == 0) return $e528339be879e4ec$var$stringFromCharCode(codePoint);
    var symbol = '';
    if ((codePoint & 0xFFFFF800) == 0) symbol = $e528339be879e4ec$var$stringFromCharCode(codePoint >> 6 & 0x1F | 0xC0);
    else if ((codePoint & 0xFFFF0000) == 0) {
        if (!$e528339be879e4ec$var$checkScalarValue(codePoint, strict)) codePoint = 0xFFFD;
        symbol = $e528339be879e4ec$var$stringFromCharCode(codePoint >> 12 & 0x0F | 0xE0);
        symbol += $e528339be879e4ec$var$createByte(codePoint, 6);
    } else if ((codePoint & 0xFFE00000) == 0) {
        symbol = $e528339be879e4ec$var$stringFromCharCode(codePoint >> 18 & 0x07 | 0xF0);
        symbol += $e528339be879e4ec$var$createByte(codePoint, 12);
        symbol += $e528339be879e4ec$var$createByte(codePoint, 6);
    }
    symbol += $e528339be879e4ec$var$stringFromCharCode(codePoint & 0x3F | 0x80);
    return symbol;
}
function $e528339be879e4ec$var$utf8encode(string, opts) {
    opts = opts || {};
    var strict = false !== opts.strict;
    var codePoints = $e528339be879e4ec$var$ucs2decode(string);
    var length = codePoints.length;
    var index = -1;
    var codePoint;
    var byteString = '';
    while(++index < length){
        codePoint = codePoints[index];
        byteString += $e528339be879e4ec$var$encodeCodePoint(codePoint, strict);
    }
    return byteString;
}
/*--------------------------------------------------------------------------*/ function $e528339be879e4ec$var$readContinuationByte() {
    if ($e528339be879e4ec$var$byteIndex >= $e528339be879e4ec$var$byteCount) throw Error('Invalid byte index');
    var continuationByte = $e528339be879e4ec$var$byteArray[$e528339be879e4ec$var$byteIndex] & 0xFF;
    $e528339be879e4ec$var$byteIndex++;
    if ((continuationByte & 0xC0) == 0x80) return continuationByte & 0x3F;
    // If we end up here, it’s not a continuation byte
    throw Error('Invalid continuation byte');
}
function $e528339be879e4ec$var$decodeSymbol(strict) {
    var byte1;
    var byte2;
    var byte3;
    var byte4;
    var codePoint;
    if ($e528339be879e4ec$var$byteIndex > $e528339be879e4ec$var$byteCount) throw Error('Invalid byte index');
    if ($e528339be879e4ec$var$byteIndex == $e528339be879e4ec$var$byteCount) return false;
    // Read first byte
    byte1 = $e528339be879e4ec$var$byteArray[$e528339be879e4ec$var$byteIndex] & 0xFF;
    $e528339be879e4ec$var$byteIndex++;
    // 1-byte sequence (no continuation bytes)
    if ((byte1 & 0x80) == 0) return byte1;
    // 2-byte sequence
    if ((byte1 & 0xE0) == 0xC0) {
        byte2 = $e528339be879e4ec$var$readContinuationByte();
        codePoint = (byte1 & 0x1F) << 6 | byte2;
        if (codePoint >= 0x80) return codePoint;
        else throw Error('Invalid continuation byte');
    }
    // 3-byte sequence (may include unpaired surrogates)
    if ((byte1 & 0xF0) == 0xE0) {
        byte2 = $e528339be879e4ec$var$readContinuationByte();
        byte3 = $e528339be879e4ec$var$readContinuationByte();
        codePoint = (byte1 & 0x0F) << 12 | byte2 << 6 | byte3;
        if (codePoint >= 0x0800) return $e528339be879e4ec$var$checkScalarValue(codePoint, strict) ? codePoint : 0xFFFD;
        else throw Error('Invalid continuation byte');
    }
    // 4-byte sequence
    if ((byte1 & 0xF8) == 0xF0) {
        byte2 = $e528339be879e4ec$var$readContinuationByte();
        byte3 = $e528339be879e4ec$var$readContinuationByte();
        byte4 = $e528339be879e4ec$var$readContinuationByte();
        codePoint = (byte1 & 0x07) << 0x12 | byte2 << 0x0C | byte3 << 0x06 | byte4;
        if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) return codePoint;
    }
    throw Error('Invalid UTF-8 detected');
}
var $e528339be879e4ec$var$byteArray;
var $e528339be879e4ec$var$byteCount;
var $e528339be879e4ec$var$byteIndex;
function $e528339be879e4ec$var$utf8decode(byteString, opts) {
    opts = opts || {};
    var strict = false !== opts.strict;
    $e528339be879e4ec$var$byteArray = $e528339be879e4ec$var$ucs2decode(byteString);
    $e528339be879e4ec$var$byteCount = $e528339be879e4ec$var$byteArray.length;
    $e528339be879e4ec$var$byteIndex = 0;
    var codePoints = [];
    var tmp;
    while((tmp = $e528339be879e4ec$var$decodeSymbol(strict)) !== false)codePoints.push(tmp);
    return $e528339be879e4ec$var$ucs2encode(codePoints);
}
module.exports = {
    version: '2.1.2',
    encode: $e528339be879e4ec$var$utf8encode,
    decode: $e528339be879e4ec$var$utf8decode
};

});

parcelRegister("6sLQI", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $4b4a797584b0a7fb$export$c564cdbbe6da493; }, function (v) { return $4b4a797584b0a7fb$export$c564cdbbe6da493 = v; });
$parcel$export(module.exports, "decode", function () { return $4b4a797584b0a7fb$export$2f872c0f2117be69; }, function (v) { return $4b4a797584b0a7fb$export$2f872c0f2117be69 = v; });
var $4b4a797584b0a7fb$export$c564cdbbe6da493;
var $4b4a797584b0a7fb$export$2f872c0f2117be69;
/*
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */ (function(chars) {
    "use strict";
    $4b4a797584b0a7fb$export$c564cdbbe6da493 = function(arraybuffer) {
        var bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = "";
        for(i = 0; i < len; i += 3){
            base64 += chars[bytes[i] >> 2];
            base64 += chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
            base64 += chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
            base64 += chars[bytes[i + 2] & 63];
        }
        if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
        else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
        return base64;
    };
    $4b4a797584b0a7fb$export$2f872c0f2117be69 = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === "=") {
            bufferLength--;
            if (base64[base64.length - 2] === "=") bufferLength--;
        }
        var arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
        for(i = 0; i < len; i += 4){
            encoded1 = chars.indexOf(base64[i]);
            encoded2 = chars.indexOf(base64[i + 1]);
            encoded3 = chars.indexOf(base64[i + 2]);
            encoded4 = chars.indexOf(base64[i + 3]);
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return arraybuffer;
    };
})("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/");

});

parcelRegister("3fzb3", function(module, exports) {
/**
 * Create a blob builder even when vendor prefixes exist
 */ var $25de0f4a9a325c66$var$BlobBuilder = typeof $25de0f4a9a325c66$var$BlobBuilder !== 'undefined' ? $25de0f4a9a325c66$var$BlobBuilder : typeof WebKitBlobBuilder !== 'undefined' ? WebKitBlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : false;
/**
 * Check if Blob constructor is supported
 */ var $25de0f4a9a325c66$var$blobSupported = function() {
    try {
        var a = new Blob([
            'hi'
        ]);
        return a.size === 2;
    } catch (e) {
        return false;
    }
}();
/**
 * Check if Blob constructor supports ArrayBufferViews
 * Fails in Safari 6, so we need to map to ArrayBuffers there.
 */ var $25de0f4a9a325c66$var$blobSupportsArrayBufferView = $25de0f4a9a325c66$var$blobSupported && function() {
    try {
        var b = new Blob([
            new Uint8Array([
                1,
                2
            ])
        ]);
        return b.size === 2;
    } catch (e) {
        return false;
    }
}();
/**
 * Check if BlobBuilder is supported
 */ var $25de0f4a9a325c66$var$blobBuilderSupported = $25de0f4a9a325c66$var$BlobBuilder && $25de0f4a9a325c66$var$BlobBuilder.prototype.append && $25de0f4a9a325c66$var$BlobBuilder.prototype.getBlob;
/**
 * Helper function that maps ArrayBufferViews to ArrayBuffers
 * Used by BlobBuilder constructor and old browsers that didn't
 * support it in the Blob constructor.
 */ function $25de0f4a9a325c66$var$mapArrayBufferViews(ary) {
    return ary.map(function(chunk) {
        if (chunk.buffer instanceof ArrayBuffer) {
            var buf = chunk.buffer;
            // if this is a subarray, make a copy so we only
            // include the subarray region from the underlying buffer
            if (chunk.byteLength !== buf.byteLength) {
                var copy = new Uint8Array(chunk.byteLength);
                copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
                buf = copy.buffer;
            }
            return buf;
        }
        return chunk;
    });
}
function $25de0f4a9a325c66$var$BlobBuilderConstructor(ary, options) {
    options = options || {};
    var bb = new $25de0f4a9a325c66$var$BlobBuilder();
    $25de0f4a9a325c66$var$mapArrayBufferViews(ary).forEach(function(part) {
        bb.append(part);
    });
    return options.type ? bb.getBlob(options.type) : bb.getBlob();
}
function $25de0f4a9a325c66$var$BlobConstructor(ary, options) {
    return new Blob($25de0f4a9a325c66$var$mapArrayBufferViews(ary), options || {});
}
if (typeof Blob !== 'undefined') {
    $25de0f4a9a325c66$var$BlobBuilderConstructor.prototype = Blob.prototype;
    $25de0f4a9a325c66$var$BlobConstructor.prototype = Blob.prototype;
}
module.exports = function() {
    if ($25de0f4a9a325c66$var$blobSupported) return $25de0f4a9a325c66$var$blobSupportsArrayBufferView ? Blob : $25de0f4a9a325c66$var$BlobConstructor;
    else if ($25de0f4a9a325c66$var$blobBuilderSupported) return $25de0f4a9a325c66$var$BlobBuilderConstructor;
    else return undefined;
}();

});



parcelRegister("gDMgm", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $032059b5233e1733$export$c564cdbbe6da493; }, function (v) { return $032059b5233e1733$export$c564cdbbe6da493 = v; });
$parcel$export(module.exports, "decode", function () { return $032059b5233e1733$export$2f872c0f2117be69; }, function (v) { return $032059b5233e1733$export$2f872c0f2117be69 = v; });
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ var $032059b5233e1733$export$c564cdbbe6da493;
/**
 * Parses a simple querystring into an object
 *
 * @param {String} qs
 * @api private
 */ var $032059b5233e1733$export$2f872c0f2117be69;
$032059b5233e1733$export$c564cdbbe6da493 = function(obj) {
    var str = '';
    for(var i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += '&';
        str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
    return str;
};
$032059b5233e1733$export$2f872c0f2117be69 = function(qs) {
    var qry = {};
    var pairs = qs.split('&');
    for(var i = 0, l = pairs.length; i < l; i++){
        var pair = pairs[i].split('=');
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
};

});

parcelRegister("13Nwl", function(module, exports) {
module.exports = function(a, b) {
    var fn = function() {};
    fn.prototype = b.prototype;
    a.prototype = new fn;
    a.prototype.constructor = a;
};

});

parcelRegister("2AmE2", function(module, exports) {
'use strict';
var $1e208254a72fb610$var$alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split(''), $1e208254a72fb610$var$length = 64, $1e208254a72fb610$var$map = {}, $1e208254a72fb610$var$seed = 0, $1e208254a72fb610$var$i = 0, $1e208254a72fb610$var$prev;
/**
 * Return a string representing the specified number.
 *
 * @param {Number} num The number to convert.
 * @returns {String} The string representation of the number.
 * @api public
 */ function $1e208254a72fb610$var$encode(num) {
    var encoded = '';
    do {
        encoded = $1e208254a72fb610$var$alphabet[num % $1e208254a72fb610$var$length] + encoded;
        num = Math.floor(num / $1e208254a72fb610$var$length);
    }while (num > 0);
    return encoded;
}
/**
 * Return the integer value specified by the given string.
 *
 * @param {String} str The string to convert.
 * @returns {Number} The integer value represented by the string.
 * @api public
 */ function $1e208254a72fb610$var$decode(str) {
    var decoded = 0;
    for($1e208254a72fb610$var$i = 0; $1e208254a72fb610$var$i < str.length; $1e208254a72fb610$var$i++)decoded = decoded * $1e208254a72fb610$var$length + $1e208254a72fb610$var$map[str.charAt($1e208254a72fb610$var$i)];
    return decoded;
}
/**
 * Yeast: A tiny growing id generator.
 *
 * @returns {String} A unique id.
 * @api public
 */ function $1e208254a72fb610$var$yeast() {
    var now = $1e208254a72fb610$var$encode(+new Date());
    if (now !== $1e208254a72fb610$var$prev) return $1e208254a72fb610$var$seed = 0, $1e208254a72fb610$var$prev = now;
    return now + '.' + $1e208254a72fb610$var$encode($1e208254a72fb610$var$seed++);
}
//
// Map each character to its index.
//
for(; $1e208254a72fb610$var$i < $1e208254a72fb610$var$length; $1e208254a72fb610$var$i++)$1e208254a72fb610$var$map[$1e208254a72fb610$var$alphabet[$1e208254a72fb610$var$i]] = $1e208254a72fb610$var$i;
//
// Expose the `yeast`, `encode` and `decode` functions.
//
$1e208254a72fb610$var$yeast.encode = $1e208254a72fb610$var$encode;
$1e208254a72fb610$var$yeast.decode = $1e208254a72fb610$var$decode;
module.exports = $1e208254a72fb610$var$yeast;

});

parcelRegister("lr39n", function(module, exports) {
/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */ 
exports = module.exports = (parcelRequire("faDDr"));
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome && 'undefined' != typeof chrome.storage ? chrome.storage.local : localstorage();
/**
 * Colors.
 */ exports.colors = [
    '#0000CC',
    '#0000FF',
    '#0033CC',
    '#0033FF',
    '#0066CC',
    '#0066FF',
    '#0099CC',
    '#0099FF',
    '#00CC00',
    '#00CC33',
    '#00CC66',
    '#00CC99',
    '#00CCCC',
    '#00CCFF',
    '#3300CC',
    '#3300FF',
    '#3333CC',
    '#3333FF',
    '#3366CC',
    '#3366FF',
    '#3399CC',
    '#3399FF',
    '#33CC00',
    '#33CC33',
    '#33CC66',
    '#33CC99',
    '#33CCCC',
    '#33CCFF',
    '#6600CC',
    '#6600FF',
    '#6633CC',
    '#6633FF',
    '#66CC00',
    '#66CC33',
    '#9900CC',
    '#9900FF',
    '#9933CC',
    '#9933FF',
    '#99CC00',
    '#99CC33',
    '#CC0000',
    '#CC0033',
    '#CC0066',
    '#CC0099',
    '#CC00CC',
    '#CC00FF',
    '#CC3300',
    '#CC3333',
    '#CC3366',
    '#CC3399',
    '#CC33CC',
    '#CC33FF',
    '#CC6600',
    '#CC6633',
    '#CC9900',
    '#CC9933',
    '#CCCC00',
    '#CCCC33',
    '#FF0000',
    '#FF0033',
    '#FF0066',
    '#FF0099',
    '#FF00CC',
    '#FF00FF',
    '#FF3300',
    '#FF3333',
    '#FF3366',
    '#FF3399',
    '#FF33CC',
    '#FF33FF',
    '#FF6600',
    '#FF6633',
    '#FF9900',
    '#FF9933',
    '#FFCC00',
    '#FFCC33'
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') return true;
    // Internet Explorer and Edge do not support colors.
    if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return false;
    // is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ exports.formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (err) {
        return '[UnexpectedJSONParseError]: ' + err.message;
    }
};
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    var useColors = this.useColors;
    args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ') + '+' + exports.humanize(this.diff);
    if (!useColors) return;
    var c = 'color: ' + this.color;
    args.splice(1, 0, c, 'color: inherit');
    // the final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    var index = 0;
    var lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, function(match) {
        if ('%%' === match) return;
        index++;
        if ('%c' === match) // we only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */ function log() {
    // this hackery is required for IE8/9, where
    // the `console.log` function doesn't have 'apply'
    return 'object' === typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
}
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (null == namespaces) exports.storage.removeItem('debug');
        else exports.storage.debug = namespaces;
    } catch (e) {}
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    var r;
    try {
        r = exports.storage.debug;
    } catch (e) {}
    return r;
}
/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */ exports.enable(load());
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        return window.localStorage;
    } catch (e) {}
}

});
parcelRegister("faDDr", function(module, exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */ exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;

exports.humanize = (parcelRequire("jGjEY"));
/**
 * Active `debug` instances.
 */ exports.instances = [];
/**
 * The currently active debug mode names, and names to skip.
 */ exports.names = [];
exports.skips = [];
/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */ exports.formatters = {};
/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */ function selectColor(namespace) {
    var hash = 0, i;
    for(i in namespace){
        hash = (hash << 5) - hash + namespace.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
    }
    return exports.colors[Math.abs(hash) % exports.colors.length];
}
/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */ function createDebug(namespace) {
    var prevTime;
    function debug() {
        // disabled?
        if (!debug.enabled) return;
        var self = debug;
        // set `diff` timestamp
        var curr = +new Date();
        var ms = curr - (prevTime || curr);
        self.diff = ms;
        self.prev = prevTime;
        self.curr = curr;
        prevTime = curr;
        // turn the `arguments` into a proper Array
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        args[0] = exports.coerce(args[0]);
        if ('string' !== typeof args[0]) // anything else let's inspect with %O
        args.unshift('%O');
        // apply any `formatters` transformations
        var index = 0;
        args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
            // if we encounter an escaped % then don't increase the array index
            if (match === '%%') return match;
            index++;
            var formatter = exports.formatters[format];
            if ('function' === typeof formatter) {
                var val = args[index];
                match = formatter.call(self, val);
                // now we need to remove `args[index]` since it's inlined in the `format`
                args.splice(index, 1);
                index--;
            }
            return match;
        });
        // apply env-specific formatting (colors, etc.)
        exports.formatArgs.call(self, args);
        var logFn = debug.log || exports.log || console.log.bind(console);
        logFn.apply(self, args);
    }
    debug.namespace = namespace;
    debug.enabled = exports.enabled(namespace);
    debug.useColors = exports.useColors();
    debug.color = selectColor(namespace);
    debug.destroy = destroy;
    // env-specific initialization logic for debug instances
    if ('function' === typeof exports.init) exports.init(debug);
    exports.instances.push(debug);
    return debug;
}
function destroy() {
    var index = exports.instances.indexOf(this);
    if (index !== -1) {
        exports.instances.splice(index, 1);
        return true;
    } else return false;
}
/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */ function enable(namespaces) {
    exports.save(namespaces);
    exports.names = [];
    exports.skips = [];
    var i;
    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
    var len = split.length;
    for(i = 0; i < len; i++){
        if (!split[i]) continue; // ignore empty strings
        namespaces = split[i].replace(/\*/g, '.*?');
        if (namespaces[0] === '-') exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
        else exports.names.push(new RegExp('^' + namespaces + '$'));
    }
    for(i = 0; i < exports.instances.length; i++){
        var instance = exports.instances[i];
        instance.enabled = exports.enabled(instance.namespace);
    }
}
/**
 * Disable debug output.
 *
 * @api public
 */ function disable() {
    exports.enable('');
}
/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */ function enabled(name) {
    if (name[name.length - 1] === '*') return true;
    var i, len;
    for(i = 0, len = exports.skips.length; i < len; i++){
        if (exports.skips[i].test(name)) return false;
    }
    for(i = 0, len = exports.names.length; i < len; i++){
        if (exports.names[i].test(name)) return true;
    }
    return false;
}
/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */ function coerce(val) {
    if (val instanceof Error) return val.stack || val.message;
    return val;
}

});
parcelRegister("jGjEY", function(module, exports) {
/**
 * Helpers.
 */ var $e54130947b18a324$var$s = 1000;
var $e54130947b18a324$var$m = $e54130947b18a324$var$s * 60;
var $e54130947b18a324$var$h = $e54130947b18a324$var$m * 60;
var $e54130947b18a324$var$d = $e54130947b18a324$var$h * 24;
var $e54130947b18a324$var$y = $e54130947b18a324$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === 'string' && val.length > 0) return $e54130947b18a324$var$parse(val);
    else if (type === 'number' && isNaN(val) === false) return options.long ? $e54130947b18a324$var$fmtLong(val) : $e54130947b18a324$var$fmtShort(val);
    throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $e54130947b18a324$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || 'ms').toLowerCase();
    switch(type){
        case 'years':
        case 'year':
        case 'yrs':
        case 'yr':
        case 'y':
            return n * $e54130947b18a324$var$y;
        case 'days':
        case 'day':
        case 'd':
            return n * $e54130947b18a324$var$d;
        case 'hours':
        case 'hour':
        case 'hrs':
        case 'hr':
        case 'h':
            return n * $e54130947b18a324$var$h;
        case 'minutes':
        case 'minute':
        case 'mins':
        case 'min':
        case 'm':
            return n * $e54130947b18a324$var$m;
        case 'seconds':
        case 'second':
        case 'secs':
        case 'sec':
        case 's':
            return n * $e54130947b18a324$var$s;
        case 'milliseconds':
        case 'millisecond':
        case 'msecs':
        case 'msec':
        case 'ms':
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $e54130947b18a324$var$fmtShort(ms) {
    if (ms >= $e54130947b18a324$var$d) return Math.round(ms / $e54130947b18a324$var$d) + 'd';
    if (ms >= $e54130947b18a324$var$h) return Math.round(ms / $e54130947b18a324$var$h) + 'h';
    if (ms >= $e54130947b18a324$var$m) return Math.round(ms / $e54130947b18a324$var$m) + 'm';
    if (ms >= $e54130947b18a324$var$s) return Math.round(ms / $e54130947b18a324$var$s) + 's';
    return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $e54130947b18a324$var$fmtLong(ms) {
    return $e54130947b18a324$var$plural(ms, $e54130947b18a324$var$d, 'day') || $e54130947b18a324$var$plural(ms, $e54130947b18a324$var$h, 'hour') || $e54130947b18a324$var$plural(ms, $e54130947b18a324$var$m, 'minute') || $e54130947b18a324$var$plural(ms, $e54130947b18a324$var$s, 'second') || ms + ' ms';
}
/**
 * Pluralization helper.
 */ function $e54130947b18a324$var$plural(ms, n, name) {
    if (ms < n) return;
    if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
    return Math.ceil(ms / n) + ' ' + name + 's';
}

});





parcelRegister("8XiXR", function(module, exports) {
/**
 * Module requirements.
 */ 
var $bQD73 = parcelRequire("bQD73");

var $13Nwl = parcelRequire("13Nwl");

var $eBFAY = parcelRequire("eBFAY");
/**
 * Module exports.
 */ module.exports = $68528b5a37f7cd12$var$JSONPPolling;
/**
 * Cached regular expressions.
 */ var $68528b5a37f7cd12$var$rNewline = /\n/g;
var $68528b5a37f7cd12$var$rEscapedNewline = /\\n/g;
/**
 * Global JSONP callbacks.
 */ var $68528b5a37f7cd12$var$callbacks;
/**
 * Noop.
 */ function $68528b5a37f7cd12$var$empty() {}
/**
 * JSONP Polling constructor.
 *
 * @param {Object} opts.
 * @api public
 */ function $68528b5a37f7cd12$var$JSONPPolling(opts) {
    $bQD73.call(this, opts);
    this.query = this.query || {};
    // define global callbacks array if not present
    // we do this here (lazily) to avoid unneeded global pollution
    if (!$68528b5a37f7cd12$var$callbacks) // we need to consider multiple engines in the same page
    $68528b5a37f7cd12$var$callbacks = $eBFAY.___eio = $eBFAY.___eio || [];
    // callback identifier
    this.index = $68528b5a37f7cd12$var$callbacks.length;
    // add callback to jsonp global
    var self = this;
    $68528b5a37f7cd12$var$callbacks.push(function(msg) {
        self.onData(msg);
    });
    // append to query string
    this.query.j = this.index;
    // prevent spurious errors from being emitted when the window is unloaded
    if (typeof addEventListener === 'function') addEventListener('beforeunload', function() {
        if (self.script) self.script.onerror = $68528b5a37f7cd12$var$empty;
    }, false);
}
/**
 * Inherits from Polling.
 */ $13Nwl($68528b5a37f7cd12$var$JSONPPolling, $bQD73);
/*
 * JSONP only supports binary as base64 encoded strings
 */ $68528b5a37f7cd12$var$JSONPPolling.prototype.supportsBinary = false;
/**
 * Closes the socket.
 *
 * @api private
 */ $68528b5a37f7cd12$var$JSONPPolling.prototype.doClose = function() {
    if (this.script) {
        this.script.parentNode.removeChild(this.script);
        this.script = null;
    }
    if (this.form) {
        this.form.parentNode.removeChild(this.form);
        this.form = null;
        this.iframe = null;
    }
    $bQD73.prototype.doClose.call(this);
};
/**
 * Starts a poll cycle.
 *
 * @api private
 */ $68528b5a37f7cd12$var$JSONPPolling.prototype.doPoll = function() {
    var self = this;
    var script = document.createElement('script');
    if (this.script) {
        this.script.parentNode.removeChild(this.script);
        this.script = null;
    }
    script.async = true;
    script.src = this.uri();
    script.onerror = function(e) {
        self.onError('jsonp poll error', e);
    };
    var insertAt = document.getElementsByTagName('script')[0];
    if (insertAt) insertAt.parentNode.insertBefore(script, insertAt);
    else (document.head || document.body).appendChild(script);
    this.script = script;
    var isUAgecko = 'undefined' !== typeof navigator && /gecko/i.test(navigator.userAgent);
    if (isUAgecko) setTimeout(function() {
        var iframe = document.createElement('iframe');
        document.body.appendChild(iframe);
        document.body.removeChild(iframe);
    }, 100);
};
/**
 * Writes with a hidden iframe.
 *
 * @param {String} data to send
 * @param {Function} called upon flush.
 * @api private
 */ $68528b5a37f7cd12$var$JSONPPolling.prototype.doWrite = function(data, fn) {
    var self = this;
    if (!this.form) {
        var form = document.createElement('form');
        var area = document.createElement('textarea');
        var id = this.iframeId = 'eio_iframe_' + this.index;
        var iframe;
        form.className = 'socketio';
        form.style.position = 'absolute';
        form.style.top = '-1000px';
        form.style.left = '-1000px';
        form.target = id;
        form.method = 'POST';
        form.setAttribute('accept-charset', 'utf-8');
        area.name = 'd';
        form.appendChild(area);
        document.body.appendChild(form);
        this.form = form;
        this.area = area;
    }
    this.form.action = this.uri();
    function complete() {
        initIframe();
        fn();
    }
    function initIframe() {
        if (self.iframe) try {
            self.form.removeChild(self.iframe);
        } catch (e) {
            self.onError('jsonp polling iframe removal error', e);
        }
        try {
            // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
            var html = '<iframe src="javascript:0" name="' + self.iframeId + '">';
            iframe = document.createElement(html);
        } catch (e) {
            iframe = document.createElement('iframe');
            iframe.name = self.iframeId;
            iframe.src = 'javascript:0';
        }
        iframe.id = self.iframeId;
        self.form.appendChild(iframe);
        self.iframe = iframe;
    }
    initIframe();
    // escape \n to prevent it from being converted into \r\n by some UAs
    // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side
    data = data.replace($68528b5a37f7cd12$var$rEscapedNewline, '\\\n');
    this.area.value = data.replace($68528b5a37f7cd12$var$rNewline, '\\n');
    try {
        this.form.submit();
    } catch (e) {}
    if (this.iframe.attachEvent) this.iframe.onreadystatechange = function() {
        if (self.iframe.readyState === 'complete') complete();
    };
    else this.iframe.onload = complete;
};

});

parcelRegister("9V4yc", function(module, exports) {
/**
 * Module dependencies.
 */ 
var $gzLuY = parcelRequire("gzLuY");
var $738cf79331822cff$require$Buffer = $gzLuY.Buffer;

var $5du6X = parcelRequire("5du6X");

var $3OROY = parcelRequire("3OROY");

var $gDMgm = parcelRequire("gDMgm");

var $13Nwl = parcelRequire("13Nwl");

var $2AmE2 = parcelRequire("2AmE2");

var $738cf79331822cff$var$debug = (parcelRequire("lr39n"))('engine.io-client:websocket');
var $738cf79331822cff$var$BrowserWebSocket, $738cf79331822cff$var$NodeWebSocket;
if (typeof WebSocket !== 'undefined') $738cf79331822cff$var$BrowserWebSocket = WebSocket;
else if (typeof self !== 'undefined') $738cf79331822cff$var$BrowserWebSocket = self.WebSocket || self.MozWebSocket;

if (typeof window === 'undefined') try {
    $738cf79331822cff$var$NodeWebSocket = (parcelRequire("aqbQf"));
} catch (e) {}
/**
 * Get either the `WebSocket` or `MozWebSocket` globals
 * in the browser or try to resolve WebSocket-compatible
 * interface exposed by `ws` for Node-like environment.
 */ var $738cf79331822cff$var$WebSocketImpl = $738cf79331822cff$var$BrowserWebSocket || $738cf79331822cff$var$NodeWebSocket;
/**
 * Module exports.
 */ module.exports = $738cf79331822cff$var$WS;
/**
 * WebSocket transport constructor.
 *
 * @api {Object} connection options
 * @api public
 */ function $738cf79331822cff$var$WS(opts) {
    var forceBase64 = opts && opts.forceBase64;
    if (forceBase64) this.supportsBinary = false;
    this.perMessageDeflate = opts.perMessageDeflate;
    this.usingBrowserWebSocket = $738cf79331822cff$var$BrowserWebSocket && !opts.forceNode;
    this.protocols = opts.protocols;
    if (!this.usingBrowserWebSocket) $738cf79331822cff$var$WebSocketImpl = $738cf79331822cff$var$NodeWebSocket;
    $5du6X.call(this, opts);
}
/**
 * Inherits from Transport.
 */ $13Nwl($738cf79331822cff$var$WS, $5du6X);
/**
 * Transport name.
 *
 * @api public
 */ $738cf79331822cff$var$WS.prototype.name = 'websocket';
/*
 * WebSockets support binary
 */ $738cf79331822cff$var$WS.prototype.supportsBinary = true;
/**
 * Opens socket.
 *
 * @api private
 */ $738cf79331822cff$var$WS.prototype.doOpen = function() {
    if (!this.check()) // let probe timeout
    return;
    var uri = this.uri();
    var protocols = this.protocols;
    var opts = {};
    if (!this.isReactNative) {
        opts.agent = this.agent;
        opts.perMessageDeflate = this.perMessageDeflate;
        // SSL options for Node.js client
        opts.pfx = this.pfx;
        opts.key = this.key;
        opts.passphrase = this.passphrase;
        opts.cert = this.cert;
        opts.ca = this.ca;
        opts.ciphers = this.ciphers;
        opts.rejectUnauthorized = this.rejectUnauthorized;
    }
    if (this.extraHeaders) opts.headers = this.extraHeaders;
    if (this.localAddress) opts.localAddress = this.localAddress;
    try {
        this.ws = this.usingBrowserWebSocket && !this.isReactNative ? protocols ? new $738cf79331822cff$var$WebSocketImpl(uri, protocols) : new $738cf79331822cff$var$WebSocketImpl(uri) : new $738cf79331822cff$var$WebSocketImpl(uri, protocols, opts);
    } catch (err) {
        return this.emit('error', err);
    }
    if (this.ws.binaryType === undefined) this.supportsBinary = false;
    if (this.ws.supports && this.ws.supports.binary) {
        this.supportsBinary = true;
        this.ws.binaryType = 'nodebuffer';
    } else this.ws.binaryType = 'arraybuffer';
    this.addEventListeners();
};
/**
 * Adds event listeners to the socket
 *
 * @api private
 */ $738cf79331822cff$var$WS.prototype.addEventListeners = function() {
    var self1 = this;
    this.ws.onopen = function() {
        self1.onOpen();
    };
    this.ws.onclose = function() {
        self1.onClose();
    };
    this.ws.onmessage = function(ev) {
        self1.onData(ev.data);
    };
    this.ws.onerror = function(e) {
        self1.onError('websocket error', e);
    };
};
/**
 * Writes data to socket.
 *
 * @param {Array} array of packets.
 * @api private
 */ $738cf79331822cff$var$WS.prototype.write = function(packets) {
    var self1 = this;
    this.writable = false;
    // encodePacket efficient as it uses WS framing
    // no need for encodePayload
    var total = packets.length;
    for(var i = 0, l = total; i < l; i++)(function(packet) {
        $3OROY.encodePacket(packet, self1.supportsBinary, function(data) {
            if (!self1.usingBrowserWebSocket) {
                // always create a new object (GH-437)
                var opts = {};
                if (packet.options) opts.compress = packet.options.compress;
                if (self1.perMessageDeflate) {
                    var len = 'string' === typeof data ? $738cf79331822cff$require$Buffer.byteLength(data) : data.length;
                    if (len < self1.perMessageDeflate.threshold) opts.compress = false;
                }
            }
            // Sometimes the websocket has already been closed but the browser didn't
            // have a chance of informing us about it yet, in that case send will
            // throw an error
            try {
                if (self1.usingBrowserWebSocket) // TypeError is thrown when passing the second argument on Safari
                self1.ws.send(data);
                else self1.ws.send(data, opts);
            } catch (e) {
                $738cf79331822cff$var$debug('websocket closed before onclose event');
            }
            --total || done();
        });
    })(packets[i]);
    function done() {
        self1.emit('flush');
        // fake drain
        // defer to next tick to allow Socket to clear writeBuffer
        setTimeout(function() {
            self1.writable = true;
            self1.emit('drain');
        }, 0);
    }
};
/**
 * Called upon close
 *
 * @api private
 */ $738cf79331822cff$var$WS.prototype.onClose = function() {
    $5du6X.prototype.onClose.call(this);
};
/**
 * Closes socket.
 *
 * @api private
 */ $738cf79331822cff$var$WS.prototype.doClose = function() {
    if (typeof this.ws !== 'undefined') this.ws.close();
};
/**
 * Generates uri for connection.
 *
 * @api private
 */ $738cf79331822cff$var$WS.prototype.uri = function() {
    var query = this.query || {};
    var schema = this.secure ? 'wss' : 'ws';
    var port = '';
    // avoid port if default for schema
    if (this.port && ('wss' === schema && Number(this.port) !== 443 || 'ws' === schema && Number(this.port) !== 80)) port = ':' + this.port;
    // append timestamp to URI
    if (this.timestampRequests) query[this.timestampParam] = $2AmE2();
    // communicate binary support capabilities
    if (!this.supportsBinary) query.b64 = 1;
    query = $gDMgm.encode(query);
    // prepend ? to query
    if (query.length) query = '?' + query;
    var ipv6 = this.hostname.indexOf(':') !== -1;
    return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
};
/**
 * Feature detection for WebSocket.
 *
 * @return {Boolean} whether this transport is available.
 * @api public
 */ $738cf79331822cff$var$WS.prototype.check = function() {
    return !!$738cf79331822cff$var$WebSocketImpl && !('__initialize' in $738cf79331822cff$var$WebSocketImpl && this.name === $738cf79331822cff$var$WS.prototype.name);
};

});
parcelRegister("aqbQf", function(module, exports) {
"use strict";

});



parcelRegister("2X0S7", function(module, exports) {
var $2261c49ec31a002c$var$indexOf = [].indexOf;
module.exports = function(arr, obj) {
    if ($2261c49ec31a002c$var$indexOf) return arr.indexOf(obj);
    for(var i = 0; i < arr.length; ++i){
        if (arr[i] === obj) return i;
    }
    return -1;
};

});



parcelRegister("5w5Yh", function(module, exports) {
/**
 * Module dependencies.
 */ 
var $TeDYR = parcelRequire("TeDYR");

var $kHJIH = parcelRequire("kHJIH");

var $2P1gY = parcelRequire("2P1gY");

var $iIMIm = parcelRequire("iIMIm");

var $f98QG = parcelRequire("f98QG");

var debug = (parcelRequire("fhMUH"))('socket.io-client:socket');

var $gDMgm = parcelRequire("gDMgm");

var $iIxzO = parcelRequire("iIxzO");
/**
 * Module exports.
 */ module.exports = exports = Socket;
/**
 * Internal events (blacklisted).
 * These events can't be emitted by the user.
 *
 * @api private
 */ var events = {
    connect: 1,
    connect_error: 1,
    connect_timeout: 1,
    connecting: 1,
    disconnect: 1,
    error: 1,
    reconnect: 1,
    reconnect_attempt: 1,
    reconnect_failed: 1,
    reconnect_error: 1,
    reconnecting: 1,
    ping: 1,
    pong: 1
};
/**
 * Shortcut to `Emitter#emit`.
 */ var emit = $kHJIH.prototype.emit;
/**
 * `Socket` constructor.
 *
 * @api public
 */ function Socket(io, nsp, opts) {
    this.io = io;
    this.nsp = nsp;
    this.json = this; // compat
    this.ids = 0;
    this.acks = {};
    this.receiveBuffer = [];
    this.sendBuffer = [];
    this.connected = false;
    this.disconnected = true;
    this.flags = {};
    if (opts && opts.query) this.query = opts.query;
    if (this.io.autoConnect) this.open();
}
/**
 * Mix in `Emitter`.
 */ $kHJIH(Socket.prototype);
/**
 * Subscribe to open, close and packet events
 *
 * @api private
 */ Socket.prototype.subEvents = function() {
    if (this.subs) return;
    var io = this.io;
    this.subs = [
        $iIMIm(io, 'open', $f98QG(this, 'onopen')),
        $iIMIm(io, 'packet', $f98QG(this, 'onpacket')),
        $iIMIm(io, 'close', $f98QG(this, 'onclose'))
    ];
};
/**
 * "Opens" the socket.
 *
 * @api public
 */ Socket.prototype.open = Socket.prototype.connect = function() {
    if (this.connected) return this;
    this.subEvents();
    if (!this.io.reconnecting) this.io.open(); // ensure open
    if ('open' === this.io.readyState) this.onopen();
    this.emit('connecting');
    return this;
};
/**
 * Sends a `message` event.
 *
 * @return {Socket} self
 * @api public
 */ Socket.prototype.send = function() {
    var args = $2P1gY(arguments);
    args.unshift('message');
    this.emit.apply(this, args);
    return this;
};
/**
 * Override `emit`.
 * If the event is in `events`, it's emitted normally.
 *
 * @param {String} event name
 * @return {Socket} self
 * @api public
 */ Socket.prototype.emit = function(ev) {
    if (events.hasOwnProperty(ev)) {
        emit.apply(this, arguments);
        return this;
    }
    var args = $2P1gY(arguments);
    var packet = {
        type: (this.flags.binary !== undefined ? this.flags.binary : $iIxzO(args)) ? $TeDYR.BINARY_EVENT : $TeDYR.EVENT,
        data: args
    };
    packet.options = {};
    packet.options.compress = !this.flags || false !== this.flags.compress;
    // event ack callback
    if ('function' === typeof args[args.length - 1]) {
        debug('emitting packet with ack id %d', this.ids);
        this.acks[this.ids] = args.pop();
        packet.id = this.ids++;
    }
    if (this.connected) this.packet(packet);
    else this.sendBuffer.push(packet);
    this.flags = {};
    return this;
};
/**
 * Sends a packet.
 *
 * @param {Object} packet
 * @api private
 */ Socket.prototype.packet = function(packet) {
    packet.nsp = this.nsp;
    this.io.packet(packet);
};
/**
 * Called upon engine `open`.
 *
 * @api private
 */ Socket.prototype.onopen = function() {
    debug('transport is open - connecting');
    // write connect packet if necessary
    if ('/' !== this.nsp) {
        if (this.query) {
            var query = typeof this.query === 'object' ? $gDMgm.encode(this.query) : this.query;
            debug('sending connect packet with query %s', query);
            this.packet({
                type: $TeDYR.CONNECT,
                query: query
            });
        } else this.packet({
            type: $TeDYR.CONNECT
        });
    }
};
/**
 * Called upon engine `close`.
 *
 * @param {String} reason
 * @api private
 */ Socket.prototype.onclose = function(reason) {
    debug('close (%s)', reason);
    this.connected = false;
    this.disconnected = true;
    delete this.id;
    this.emit('disconnect', reason);
};
/**
 * Called with socket packet.
 *
 * @param {Object} packet
 * @api private
 */ Socket.prototype.onpacket = function(packet) {
    var sameNamespace = packet.nsp === this.nsp;
    var rootNamespaceError = packet.type === $TeDYR.ERROR && packet.nsp === '/';
    if (!sameNamespace && !rootNamespaceError) return;
    switch(packet.type){
        case $TeDYR.CONNECT:
            this.onconnect();
            break;
        case $TeDYR.EVENT:
            this.onevent(packet);
            break;
        case $TeDYR.BINARY_EVENT:
            this.onevent(packet);
            break;
        case $TeDYR.ACK:
            this.onack(packet);
            break;
        case $TeDYR.BINARY_ACK:
            this.onack(packet);
            break;
        case $TeDYR.DISCONNECT:
            this.ondisconnect();
            break;
        case $TeDYR.ERROR:
            this.emit('error', packet.data);
            break;
    }
};
/**
 * Called upon a server event.
 *
 * @param {Object} packet
 * @api private
 */ Socket.prototype.onevent = function(packet) {
    var args = packet.data || [];
    debug('emitting event %j', args);
    if (null != packet.id) {
        debug('attaching ack callback to event');
        args.push(this.ack(packet.id));
    }
    if (this.connected) emit.apply(this, args);
    else this.receiveBuffer.push(args);
};
/**
 * Produces an ack callback to emit with an event.
 *
 * @api private
 */ Socket.prototype.ack = function(id) {
    var self = this;
    var sent = false;
    return function() {
        // prevent double callbacks
        if (sent) return;
        sent = true;
        var args = $2P1gY(arguments);
        debug('sending ack %j', args);
        self.packet({
            type: $iIxzO(args) ? $TeDYR.BINARY_ACK : $TeDYR.ACK,
            id: id,
            data: args
        });
    };
};
/**
 * Called upon a server acknowlegement.
 *
 * @param {Object} packet
 * @api private
 */ Socket.prototype.onack = function(packet) {
    var ack = this.acks[packet.id];
    if ('function' === typeof ack) {
        debug('calling ack %s with %j', packet.id, packet.data);
        ack.apply(this, packet.data);
        delete this.acks[packet.id];
    } else debug('bad ack %s', packet.id);
};
/**
 * Called upon server connect.
 *
 * @api private
 */ Socket.prototype.onconnect = function() {
    this.connected = true;
    this.disconnected = false;
    this.emitBuffered();
    this.emit('connect');
};
/**
 * Emit buffered events (received and emitted).
 *
 * @api private
 */ Socket.prototype.emitBuffered = function() {
    var i;
    for(i = 0; i < this.receiveBuffer.length; i++)emit.apply(this, this.receiveBuffer[i]);
    this.receiveBuffer = [];
    for(i = 0; i < this.sendBuffer.length; i++)this.packet(this.sendBuffer[i]);
    this.sendBuffer = [];
};
/**
 * Called upon server disconnect.
 *
 * @api private
 */ Socket.prototype.ondisconnect = function() {
    debug('server disconnect (%s)', this.nsp);
    this.destroy();
    this.onclose('io server disconnect');
};
/**
 * Called upon forced client/server side disconnections,
 * this method ensures the manager stops tracking us and
 * that reconnections don't get triggered for this.
 *
 * @api private.
 */ Socket.prototype.destroy = function() {
    if (this.subs) {
        // clean subscriptions to avoid reconnections
        for(var i = 0; i < this.subs.length; i++)this.subs[i].destroy();
        this.subs = null;
    }
    this.io.destroy(this);
};
/**
 * Disconnects the socket manually.
 *
 * @return {Socket} self
 * @api public
 */ Socket.prototype.close = Socket.prototype.disconnect = function() {
    if (this.connected) {
        debug('performing disconnect (%s)', this.nsp);
        this.packet({
            type: $TeDYR.DISCONNECT
        });
    }
    // remove socket from pool
    this.destroy();
    if (this.connected) // fire events
    this.onclose('io client disconnect');
    return this;
};
/**
 * Sets the compress flag.
 *
 * @param {Boolean} if `true`, compresses the sending data
 * @return {Socket} self
 * @api public
 */ Socket.prototype.compress = function(compress) {
    this.flags.compress = compress;
    return this;
};
/**
 * Sets the binary flag
 *
 * @param {Boolean} whether the emitted data contains binary
 * @return {Socket} self
 * @api public
 */ Socket.prototype.binary = function(binary) {
    this.flags.binary = binary;
    return this;
};

});
parcelRegister("2P1gY", function(module, exports) {
module.exports = $20e154f22b3666fd$var$toArray;
function $20e154f22b3666fd$var$toArray(list, index) {
    var array = [];
    index = index || 0;
    for(var i = index || 0; i < list.length; i++)array[i - index] = list[i];
    return array;
}

});

parcelRegister("iIMIm", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $da121fb73cd743b8$var$on;
/**
 * Helper for subscriptions.
 *
 * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
 * @param {String} event name
 * @param {Function} callback
 * @api public
 */ function $da121fb73cd743b8$var$on(obj, ev, fn) {
    obj.on(ev, fn);
    return {
        destroy: function() {
            obj.removeListener(ev, fn);
        }
    };
}

});

parcelRegister("f98QG", function(module, exports) {
/**
 * Slice reference.
 */ var $b06e8f7748eb79c6$var$slice = [].slice;
/**
 * Bind `obj` to `fn`.
 *
 * @param {Object} obj
 * @param {Function|String} fn or string
 * @return {Function}
 * @api public
 */ module.exports = function(obj, fn) {
    if ('string' == typeof fn) fn = obj[fn];
    if ('function' != typeof fn) throw new Error('bind() requires a function');
    var args = $b06e8f7748eb79c6$var$slice.call(arguments, 2);
    return function() {
        return fn.apply(obj, args.concat($b06e8f7748eb79c6$var$slice.call(arguments)));
    };
};

});


parcelRegister("85pZE", function(module, exports) {
/**
 * Expose `Backoff`.
 */ module.exports = $5e32f420483b42c6$var$Backoff;
/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $5e32f420483b42c6$var$Backoff(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $5e32f420483b42c6$var$Backoff.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $5e32f420483b42c6$var$Backoff.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $5e32f420483b42c6$var$Backoff.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $5e32f420483b42c6$var$Backoff.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $5e32f420483b42c6$var$Backoff.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};

});



parcelRegister("iOnI3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db1f49b6482e7ab4$export$2e2bcd8739ae039; });
function $db1f49b6482e7ab4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $db1f49b6482e7ab4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $db1f49b6482e7ab4$var$_typeof(obj);
}
function $db1f49b6482e7ab4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $db1f49b6482e7ab4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $db1f49b6482e7ab4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $db1f49b6482e7ab4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $db1f49b6482e7ab4$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $db1f49b6482e7ab4$var$_extends() {
    $db1f49b6482e7ab4$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $db1f49b6482e7ab4$var$_extends.apply(this, arguments);
}
function $db1f49b6482e7ab4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $db1f49b6482e7ab4$var$_setPrototypeOf(subClass, superClass);
}
function $db1f49b6482e7ab4$var$_getPrototypeOf(o) {
    $db1f49b6482e7ab4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $db1f49b6482e7ab4$var$_getPrototypeOf(o);
}
function $db1f49b6482e7ab4$var$_setPrototypeOf(o, p) {
    $db1f49b6482e7ab4$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $db1f49b6482e7ab4$var$_setPrototypeOf(o, p);
}
function $db1f49b6482e7ab4$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $db1f49b6482e7ab4$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $db1f49b6482e7ab4$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $db1f49b6482e7ab4$var$_assertThisInitialized(self);
}
function $db1f49b6482e7ab4$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $db1f49b6482e7ab4$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $db1f49b6482e7ab4$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $db1f49b6482e7ab4$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $db1f49b6482e7ab4$var$_possibleConstructorReturn(this, result);
    };
}
/**
 * This class represents a basic channel.
 */ var $db1f49b6482e7ab4$export$cfdacaa37f9b4dd7 = /*#__PURE__*/ function() {
    function Channel() {
        $db1f49b6482e7ab4$var$_classCallCheck(this, Channel);
    }
    $db1f49b6482e7ab4$var$_createClass(Channel, [
        {
            key: "listenForWhisper",
            value: /**
     * Listen for a whisper event on the channel instance.
     */ function listenForWhisper(event, callback) {
                return this.listen('.client-' + event, callback);
            }
        },
        {
            key: "notification",
            value: function notification(callback) {
                return this.listen('.Illuminate\\Notifications\\Events\\BroadcastNotificationCreated', callback);
            }
        },
        {
            key: "stopListeningForWhisper",
            value: function stopListeningForWhisper(event, callback) {
                return this.stopListening('.client-' + event, callback);
            }
        }
    ]);
    return Channel;
}();
/**
 * Event name formatter
 */ var $db1f49b6482e7ab4$export$a8f50c7ec96013cf = /*#__PURE__*/ function() {
    /**
   * Create a new class instance.
   */ function EventFormatter(namespace) {
        $db1f49b6482e7ab4$var$_classCallCheck(this, EventFormatter);
        this.namespace = namespace; //
    }
    /**
   * Format the given event name.
   */ $db1f49b6482e7ab4$var$_createClass(EventFormatter, [
        {
            key: "format",
            value: function format(event) {
                if ([
                    '.',
                    '\\'
                ].includes(event.charAt(0))) return event.substring(1);
                else if (this.namespace) event = this.namespace + '.' + event;
                return event.replace(/\./g, '\\');
            }
        },
        {
            key: "setNamespace",
            value: function setNamespace(value) {
                this.namespace = value;
            }
        }
    ]);
    return EventFormatter;
}();
function $db1f49b6482e7ab4$var$isConstructor(obj) {
    try {
        new obj();
    } catch (err) {
        if (err.message.includes('is not a constructor')) return false;
    }
    return true;
}
/**
 * This class represents a Pusher channel.
 */ var $db1f49b6482e7ab4$var$PusherChannel = /*#__PURE__*/ function(_Channel) {
    $db1f49b6482e7ab4$var$_inherits(PusherChannel, _Channel);
    var _super = $db1f49b6482e7ab4$var$_createSuper(PusherChannel);
    /**
   * Create a new class instance.
   */ function PusherChannel(pusher, name, options) {
        var _this;
        $db1f49b6482e7ab4$var$_classCallCheck(this, PusherChannel);
        _this = _super.call(this);
        _this.name = name;
        _this.pusher = pusher;
        _this.options = options;
        _this.eventFormatter = new $db1f49b6482e7ab4$export$a8f50c7ec96013cf(_this.options.namespace);
        _this.subscribe();
        return _this;
    }
    /**
   * Subscribe to a Pusher channel.
   */ $db1f49b6482e7ab4$var$_createClass(PusherChannel, [
        {
            key: "subscribe",
            value: function subscribe() {
                this.subscription = this.pusher.subscribe(this.name);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                this.pusher.unsubscribe(this.name);
            }
        },
        {
            key: "listen",
            value: function listen(event, callback) {
                this.on(this.eventFormatter.format(event), callback);
                return this;
            }
        },
        {
            key: "listenToAll",
            value: function listenToAll(callback) {
                var _this2 = this;
                this.subscription.bind_global(function(event, data) {
                    if (event.startsWith('pusher:')) return;
                    var namespace = _this2.options.namespace.replace(/\./g, '\\');
                    var formattedEvent = event.startsWith(namespace) ? event.substring(namespace.length + 1) : '.' + event;
                    callback(formattedEvent, data);
                });
                return this;
            }
        },
        {
            key: "stopListening",
            value: function stopListening(event, callback) {
                if (callback) this.subscription.unbind(this.eventFormatter.format(event), callback);
                else this.subscription.unbind(this.eventFormatter.format(event));
                return this;
            }
        },
        {
            key: "stopListeningToAll",
            value: function stopListeningToAll(callback) {
                if (callback) this.subscription.unbind_global(callback);
                else this.subscription.unbind_global();
                return this;
            }
        },
        {
            key: "subscribed",
            value: function subscribed(callback) {
                this.on('pusher:subscription_succeeded', function() {
                    callback();
                });
                return this;
            }
        },
        {
            key: "error",
            value: function error(callback) {
                this.on('pusher:subscription_error', function(status) {
                    callback(status);
                });
                return this;
            }
        },
        {
            key: "on",
            value: function on(event, callback) {
                this.subscription.bind(event, callback);
                return this;
            }
        }
    ]);
    return PusherChannel;
}($db1f49b6482e7ab4$export$cfdacaa37f9b4dd7);
/**
 * This class represents a Pusher private channel.
 */ var $db1f49b6482e7ab4$var$PusherPrivateChannel = /*#__PURE__*/ function(_PusherChannel) {
    $db1f49b6482e7ab4$var$_inherits(PusherPrivateChannel, _PusherChannel);
    var _super = $db1f49b6482e7ab4$var$_createSuper(PusherPrivateChannel);
    function PusherPrivateChannel() {
        $db1f49b6482e7ab4$var$_classCallCheck(this, PusherPrivateChannel);
        return _super.apply(this, arguments);
    }
    $db1f49b6482e7ab4$var$_createClass(PusherPrivateChannel, [
        {
            key: "whisper",
            value: /**
     * Send a whisper event to other clients in the channel.
     */ function whisper(eventName, data) {
                this.pusher.channels.channels[this.name].trigger("client-".concat(eventName), data);
                return this;
            }
        }
    ]);
    return PusherPrivateChannel;
}($db1f49b6482e7ab4$var$PusherChannel);
/**
 * This class represents a Pusher private channel.
 */ var $db1f49b6482e7ab4$var$PusherEncryptedPrivateChannel = /*#__PURE__*/ function(_PusherChannel) {
    $db1f49b6482e7ab4$var$_inherits(PusherEncryptedPrivateChannel, _PusherChannel);
    var _super = $db1f49b6482e7ab4$var$_createSuper(PusherEncryptedPrivateChannel);
    function PusherEncryptedPrivateChannel() {
        $db1f49b6482e7ab4$var$_classCallCheck(this, PusherEncryptedPrivateChannel);
        return _super.apply(this, arguments);
    }
    $db1f49b6482e7ab4$var$_createClass(PusherEncryptedPrivateChannel, [
        {
            key: "whisper",
            value: /**
     * Send a whisper event to other clients in the channel.
     */ function whisper(eventName, data) {
                this.pusher.channels.channels[this.name].trigger("client-".concat(eventName), data);
                return this;
            }
        }
    ]);
    return PusherEncryptedPrivateChannel;
}($db1f49b6482e7ab4$var$PusherChannel);
/**
 * This class represents a Pusher presence channel.
 */ var $db1f49b6482e7ab4$var$PusherPresenceChannel = /*#__PURE__*/ function(_PusherPrivateChannel) {
    $db1f49b6482e7ab4$var$_inherits(PusherPresenceChannel, _PusherPrivateChannel);
    var _super = $db1f49b6482e7ab4$var$_createSuper(PusherPresenceChannel);
    function PusherPresenceChannel() {
        $db1f49b6482e7ab4$var$_classCallCheck(this, PusherPresenceChannel);
        return _super.apply(this, arguments);
    }
    $db1f49b6482e7ab4$var$_createClass(PusherPresenceChannel, [
        {
            key: "here",
            value: /**
     * Register a callback to be called anytime the member list changes.
     */ function here(callback) {
                this.on('pusher:subscription_succeeded', function(data) {
                    callback(Object.keys(data.members).map(function(k) {
                        return data.members[k];
                    }));
                });
                return this;
            }
        },
        {
            key: "joining",
            value: function joining(callback) {
                this.on('pusher:member_added', function(member) {
                    callback(member.info);
                });
                return this;
            }
        },
        {
            key: "whisper",
            value: function whisper(eventName, data) {
                this.pusher.channels.channels[this.name].trigger("client-".concat(eventName), data);
                return this;
            }
        },
        {
            key: "leaving",
            value: function leaving(callback) {
                this.on('pusher:member_removed', function(member) {
                    callback(member.info);
                });
                return this;
            }
        }
    ]);
    return PusherPresenceChannel;
}($db1f49b6482e7ab4$var$PusherPrivateChannel);
/**
 * This class represents a Socket.io channel.
 */ var $db1f49b6482e7ab4$var$SocketIoChannel = /*#__PURE__*/ function(_Channel) {
    $db1f49b6482e7ab4$var$_inherits(SocketIoChannel, _Channel);
    var _super = $db1f49b6482e7ab4$var$_createSuper(SocketIoChannel);
    /**
   * Create a new class instance.
   */ function SocketIoChannel(socket, name, options) {
        var _this;
        $db1f49b6482e7ab4$var$_classCallCheck(this, SocketIoChannel);
        _this = _super.call(this);
        /**
     * The event callbacks applied to the socket.
     */ _this.events = {};
        /**
     * User supplied callbacks for events on this channel.
     */ _this.listeners = {};
        _this.name = name;
        _this.socket = socket;
        _this.options = options;
        _this.eventFormatter = new $db1f49b6482e7ab4$export$a8f50c7ec96013cf(_this.options.namespace);
        _this.subscribe();
        return _this;
    }
    /**
   * Subscribe to a Socket.io channel.
   */ $db1f49b6482e7ab4$var$_createClass(SocketIoChannel, [
        {
            key: "subscribe",
            value: function subscribe() {
                this.socket.emit('subscribe', {
                    channel: this.name,
                    auth: this.options.auth || {}
                });
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                this.unbind();
                this.socket.emit('unsubscribe', {
                    channel: this.name,
                    auth: this.options.auth || {}
                });
            }
        },
        {
            key: "listen",
            value: function listen(event, callback) {
                this.on(this.eventFormatter.format(event), callback);
                return this;
            }
        },
        {
            key: "stopListening",
            value: function stopListening(event, callback) {
                this.unbindEvent(this.eventFormatter.format(event), callback);
                return this;
            }
        },
        {
            key: "subscribed",
            value: function subscribed(callback) {
                this.on('connect', function(socket) {
                    callback(socket);
                });
                return this;
            }
        },
        {
            key: "error",
            value: function error(callback) {
                return this;
            }
        },
        {
            key: "on",
            value: function on(event, callback) {
                var _this2 = this;
                this.listeners[event] = this.listeners[event] || [];
                if (!this.events[event]) {
                    this.events[event] = function(channel, data) {
                        if (_this2.name === channel && _this2.listeners[event]) _this2.listeners[event].forEach(function(cb) {
                            return cb(data);
                        });
                    };
                    this.socket.on(event, this.events[event]);
                }
                this.listeners[event].push(callback);
                return this;
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                var _this3 = this;
                Object.keys(this.events).forEach(function(event) {
                    _this3.unbindEvent(event);
                });
            }
        },
        {
            key: "unbindEvent",
            value: function unbindEvent(event, callback) {
                this.listeners[event] = this.listeners[event] || [];
                if (callback) this.listeners[event] = this.listeners[event].filter(function(cb) {
                    return cb !== callback;
                });
                if (!callback || this.listeners[event].length === 0) {
                    if (this.events[event]) {
                        this.socket.removeListener(event, this.events[event]);
                        delete this.events[event];
                    }
                    delete this.listeners[event];
                }
            }
        }
    ]);
    return SocketIoChannel;
}($db1f49b6482e7ab4$export$cfdacaa37f9b4dd7);
/**
 * This class represents a Socket.io private channel.
 */ var $db1f49b6482e7ab4$var$SocketIoPrivateChannel = /*#__PURE__*/ function(_SocketIoChannel) {
    $db1f49b6482e7ab4$var$_inherits(SocketIoPrivateChannel, _SocketIoChannel);
    var _super = $db1f49b6482e7ab4$var$_createSuper(SocketIoPrivateChannel);
    function SocketIoPrivateChannel() {
        $db1f49b6482e7ab4$var$_classCallCheck(this, SocketIoPrivateChannel);
        return _super.apply(this, arguments);
    }
    $db1f49b6482e7ab4$var$_createClass(SocketIoPrivateChannel, [
        {
            key: "whisper",
            value: /**
     * Send a whisper event to other clients in the channel.
     */ function whisper(eventName, data) {
                this.socket.emit('client event', {
                    channel: this.name,
                    event: "client-".concat(eventName),
                    data: data
                });
                return this;
            }
        }
    ]);
    return SocketIoPrivateChannel;
}($db1f49b6482e7ab4$var$SocketIoChannel);
/**
 * This class represents a Socket.io presence channel.
 */ var $db1f49b6482e7ab4$var$SocketIoPresenceChannel = /*#__PURE__*/ function(_SocketIoPrivateChann) {
    $db1f49b6482e7ab4$var$_inherits(SocketIoPresenceChannel, _SocketIoPrivateChann);
    var _super = $db1f49b6482e7ab4$var$_createSuper(SocketIoPresenceChannel);
    function SocketIoPresenceChannel() {
        $db1f49b6482e7ab4$var$_classCallCheck(this, SocketIoPresenceChannel);
        return _super.apply(this, arguments);
    }
    $db1f49b6482e7ab4$var$_createClass(SocketIoPresenceChannel, [
        {
            key: "here",
            value: /**
     * Register a callback to be called anytime the member list changes.
     */ function here(callback) {
                this.on('presence:subscribed', function(members) {
                    callback(members.map(function(m) {
                        return m.user_info;
                    }));
                });
                return this;
            }
        },
        {
            key: "joining",
            value: function joining(callback) {
                this.on('presence:joining', function(member) {
                    return callback(member.user_info);
                });
                return this;
            }
        },
        {
            key: "whisper",
            value: function whisper(eventName, data) {
                this.socket.emit('client event', {
                    channel: this.name,
                    event: "client-".concat(eventName),
                    data: data
                });
                return this;
            }
        },
        {
            key: "leaving",
            value: function leaving(callback) {
                this.on('presence:leaving', function(member) {
                    return callback(member.user_info);
                });
                return this;
            }
        }
    ]);
    return SocketIoPresenceChannel;
}($db1f49b6482e7ab4$var$SocketIoPrivateChannel);
/**
 * This class represents a null channel.
 */ var $db1f49b6482e7ab4$var$NullChannel = /*#__PURE__*/ function(_Channel) {
    $db1f49b6482e7ab4$var$_inherits(NullChannel, _Channel);
    var _super = $db1f49b6482e7ab4$var$_createSuper(NullChannel);
    function NullChannel() {
        $db1f49b6482e7ab4$var$_classCallCheck(this, NullChannel);
        return _super.apply(this, arguments);
    }
    $db1f49b6482e7ab4$var$_createClass(NullChannel, [
        {
            key: "subscribe",
            value: /**
     * Subscribe to a channel.
     */ function subscribe() {}
        },
        {
            key: "unsubscribe",
            value: function unsubscribe() {}
        },
        {
            key: "listen",
            value: function listen(event, callback) {
                return this;
            }
        },
        {
            key: "listenToAll",
            value: function listenToAll(callback) {
                return this;
            }
        },
        {
            key: "stopListening",
            value: function stopListening(event, callback) {
                return this;
            }
        },
        {
            key: "subscribed",
            value: function subscribed(callback) {
                return this;
            }
        },
        {
            key: "error",
            value: function error(callback) {
                return this;
            }
        },
        {
            key: "on",
            value: function on(event, callback) {
                return this;
            }
        }
    ]);
    return NullChannel;
}($db1f49b6482e7ab4$export$cfdacaa37f9b4dd7);
/**
 * This class represents a null private channel.
 */ var $db1f49b6482e7ab4$var$NullPrivateChannel = /*#__PURE__*/ function(_NullChannel) {
    $db1f49b6482e7ab4$var$_inherits(NullPrivateChannel, _NullChannel);
    var _super = $db1f49b6482e7ab4$var$_createSuper(NullPrivateChannel);
    function NullPrivateChannel() {
        $db1f49b6482e7ab4$var$_classCallCheck(this, NullPrivateChannel);
        return _super.apply(this, arguments);
    }
    $db1f49b6482e7ab4$var$_createClass(NullPrivateChannel, [
        {
            key: "whisper",
            value: /**
     * Send a whisper event to other clients in the channel.
     */ function whisper(eventName, data) {
                return this;
            }
        }
    ]);
    return NullPrivateChannel;
}($db1f49b6482e7ab4$var$NullChannel);
/**
 * This class represents a null private channel.
 */ var $db1f49b6482e7ab4$var$NullEncryptedPrivateChannel = /*#__PURE__*/ function(_NullChannel) {
    $db1f49b6482e7ab4$var$_inherits(NullEncryptedPrivateChannel, _NullChannel);
    var _super = $db1f49b6482e7ab4$var$_createSuper(NullEncryptedPrivateChannel);
    function NullEncryptedPrivateChannel() {
        $db1f49b6482e7ab4$var$_classCallCheck(this, NullEncryptedPrivateChannel);
        return _super.apply(this, arguments);
    }
    $db1f49b6482e7ab4$var$_createClass(NullEncryptedPrivateChannel, [
        {
            key: "whisper",
            value: /**
     * Send a whisper event to other clients in the channel.
     */ function whisper(eventName, data) {
                return this;
            }
        }
    ]);
    return NullEncryptedPrivateChannel;
}($db1f49b6482e7ab4$var$NullChannel);
/**
 * This class represents a null presence channel.
 */ var $db1f49b6482e7ab4$var$NullPresenceChannel = /*#__PURE__*/ function(_NullPrivateChannel) {
    $db1f49b6482e7ab4$var$_inherits(NullPresenceChannel, _NullPrivateChannel);
    var _super = $db1f49b6482e7ab4$var$_createSuper(NullPresenceChannel);
    function NullPresenceChannel() {
        $db1f49b6482e7ab4$var$_classCallCheck(this, NullPresenceChannel);
        return _super.apply(this, arguments);
    }
    $db1f49b6482e7ab4$var$_createClass(NullPresenceChannel, [
        {
            key: "here",
            value: /**
     * Register a callback to be called anytime the member list changes.
     */ function here(callback) {
                return this;
            }
        },
        {
            key: "joining",
            value: function joining(callback) {
                return this;
            }
        },
        {
            key: "whisper",
            value: function whisper(eventName, data) {
                return this;
            }
        },
        {
            key: "leaving",
            value: function leaving(callback) {
                return this;
            }
        }
    ]);
    return NullPresenceChannel;
}($db1f49b6482e7ab4$var$NullPrivateChannel);
var $db1f49b6482e7ab4$export$b2278035370d6017 = /*#__PURE__*/ function() {
    /**
   * Create a new class instance.
   */ function Connector(options) {
        $db1f49b6482e7ab4$var$_classCallCheck(this, Connector);
        /**
     * Default connector options.
     */ this._defaultOptions = {
            auth: {
                headers: {}
            },
            authEndpoint: '/broadcasting/auth',
            userAuthentication: {
                endpoint: '/broadcasting/user-auth',
                headers: {}
            },
            broadcaster: 'pusher',
            csrfToken: null,
            bearerToken: null,
            host: null,
            key: null,
            namespace: 'App.Events'
        };
        this.setOptions(options);
        this.connect();
    }
    /**
   * Merge the custom options with the defaults.
   */ $db1f49b6482e7ab4$var$_createClass(Connector, [
        {
            key: "setOptions",
            value: function setOptions(options) {
                this.options = $db1f49b6482e7ab4$var$_extends(this._defaultOptions, options);
                var token = this.csrfToken();
                if (token) {
                    this.options.auth.headers['X-CSRF-TOKEN'] = token;
                    this.options.userAuthentication.headers['X-CSRF-TOKEN'] = token;
                }
                token = this.options.bearerToken;
                if (token) {
                    this.options.auth.headers['Authorization'] = 'Bearer ' + token;
                    this.options.userAuthentication.headers['Authorization'] = 'Bearer ' + token;
                }
                return options;
            }
        },
        {
            key: "csrfToken",
            value: function csrfToken() {
                var selector;
                if (typeof window !== 'undefined' && window['Laravel'] && window['Laravel'].csrfToken) return window['Laravel'].csrfToken;
                else if (this.options.csrfToken) return this.options.csrfToken;
                else if (typeof document !== 'undefined' && typeof document.querySelector === 'function' && (selector = document.querySelector('meta[name="csrf-token"]'))) return selector.getAttribute('content');
                return null;
            }
        }
    ]);
    return Connector;
}();
/**
 * This class creates a connector to Pusher.
 */ var $db1f49b6482e7ab4$var$PusherConnector = /*#__PURE__*/ function(_Connector) {
    $db1f49b6482e7ab4$var$_inherits(PusherConnector, _Connector);
    var _super = $db1f49b6482e7ab4$var$_createSuper(PusherConnector);
    function PusherConnector() {
        var _this;
        $db1f49b6482e7ab4$var$_classCallCheck(this, PusherConnector);
        _this = _super.apply(this, arguments);
        /**
     * All of the subscribed channel names.
     */ _this.channels = {};
        return _this;
    }
    /**
   * Create a fresh Pusher connection.
   */ $db1f49b6482e7ab4$var$_createClass(PusherConnector, [
        {
            key: "connect",
            value: function connect() {
                if (typeof this.options.client !== 'undefined') this.pusher = this.options.client;
                else if (this.options.Pusher) this.pusher = new this.options.Pusher(this.options.key, this.options);
                else this.pusher = new Pusher(this.options.key, this.options);
            }
        },
        {
            key: "signin",
            value: function signin() {
                this.pusher.signin();
            }
        },
        {
            key: "listen",
            value: function listen(name, event, callback) {
                return this.channel(name).listen(event, callback);
            }
        },
        {
            key: "channel",
            value: function channel(name) {
                if (!this.channels[name]) this.channels[name] = new $db1f49b6482e7ab4$var$PusherChannel(this.pusher, name, this.options);
                return this.channels[name];
            }
        },
        {
            key: "privateChannel",
            value: function privateChannel(name) {
                if (!this.channels['private-' + name]) this.channels['private-' + name] = new $db1f49b6482e7ab4$var$PusherPrivateChannel(this.pusher, 'private-' + name, this.options);
                return this.channels['private-' + name];
            }
        },
        {
            key: "encryptedPrivateChannel",
            value: function encryptedPrivateChannel(name) {
                if (!this.channels['private-encrypted-' + name]) this.channels['private-encrypted-' + name] = new $db1f49b6482e7ab4$var$PusherEncryptedPrivateChannel(this.pusher, 'private-encrypted-' + name, this.options);
                return this.channels['private-encrypted-' + name];
            }
        },
        {
            key: "presenceChannel",
            value: function presenceChannel(name) {
                if (!this.channels['presence-' + name]) this.channels['presence-' + name] = new $db1f49b6482e7ab4$var$PusherPresenceChannel(this.pusher, 'presence-' + name, this.options);
                return this.channels['presence-' + name];
            }
        },
        {
            key: "leave",
            value: function leave(name) {
                var _this2 = this;
                var channels = [
                    name,
                    'private-' + name,
                    'private-encrypted-' + name,
                    'presence-' + name
                ];
                channels.forEach(function(name, index) {
                    _this2.leaveChannel(name);
                });
            }
        },
        {
            key: "leaveChannel",
            value: function leaveChannel(name) {
                if (this.channels[name]) {
                    this.channels[name].unsubscribe();
                    delete this.channels[name];
                }
            }
        },
        {
            key: "socketId",
            value: function socketId() {
                return this.pusher.connection.socket_id;
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                this.pusher.disconnect();
            }
        }
    ]);
    return PusherConnector;
}($db1f49b6482e7ab4$export$b2278035370d6017);
/**
 * This class creates a connnector to a Socket.io server.
 */ var $db1f49b6482e7ab4$var$SocketIoConnector = /*#__PURE__*/ function(_Connector) {
    $db1f49b6482e7ab4$var$_inherits(SocketIoConnector, _Connector);
    var _super = $db1f49b6482e7ab4$var$_createSuper(SocketIoConnector);
    function SocketIoConnector() {
        var _this;
        $db1f49b6482e7ab4$var$_classCallCheck(this, SocketIoConnector);
        _this = _super.apply(this, arguments);
        /**
     * All of the subscribed channel names.
     */ _this.channels = {};
        return _this;
    }
    /**
   * Create a fresh Socket.io connection.
   */ $db1f49b6482e7ab4$var$_createClass(SocketIoConnector, [
        {
            key: "connect",
            value: function connect() {
                var _this2 = this;
                var io1 = this.getSocketIO();
                this.socket = io1(this.options.host, this.options);
                this.socket.on('reconnect', function() {
                    Object.values(_this2.channels).forEach(function(channel) {
                        channel.subscribe();
                    });
                });
                return this.socket;
            }
        },
        {
            key: "getSocketIO",
            value: function getSocketIO() {
                if (typeof this.options.client !== 'undefined') return this.options.client;
                if (typeof io !== 'undefined') return io;
                throw new Error('Socket.io client not found. Should be globally available or passed via options.client');
            }
        },
        {
            key: "listen",
            value: function listen(name, event, callback) {
                return this.channel(name).listen(event, callback);
            }
        },
        {
            key: "channel",
            value: function channel(name) {
                if (!this.channels[name]) this.channels[name] = new $db1f49b6482e7ab4$var$SocketIoChannel(this.socket, name, this.options);
                return this.channels[name];
            }
        },
        {
            key: "privateChannel",
            value: function privateChannel(name) {
                if (!this.channels['private-' + name]) this.channels['private-' + name] = new $db1f49b6482e7ab4$var$SocketIoPrivateChannel(this.socket, 'private-' + name, this.options);
                return this.channels['private-' + name];
            }
        },
        {
            key: "presenceChannel",
            value: function presenceChannel(name) {
                if (!this.channels['presence-' + name]) this.channels['presence-' + name] = new $db1f49b6482e7ab4$var$SocketIoPresenceChannel(this.socket, 'presence-' + name, this.options);
                return this.channels['presence-' + name];
            }
        },
        {
            key: "leave",
            value: function leave(name) {
                var _this3 = this;
                var channels = [
                    name,
                    'private-' + name,
                    'presence-' + name
                ];
                channels.forEach(function(name) {
                    _this3.leaveChannel(name);
                });
            }
        },
        {
            key: "leaveChannel",
            value: function leaveChannel(name) {
                if (this.channels[name]) {
                    this.channels[name].unsubscribe();
                    delete this.channels[name];
                }
            }
        },
        {
            key: "socketId",
            value: function socketId() {
                return this.socket.id;
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                this.socket.disconnect();
            }
        }
    ]);
    return SocketIoConnector;
}($db1f49b6482e7ab4$export$b2278035370d6017);
/**
 * This class creates a null connector.
 */ var $db1f49b6482e7ab4$var$NullConnector = /*#__PURE__*/ function(_Connector) {
    $db1f49b6482e7ab4$var$_inherits(NullConnector, _Connector);
    var _super = $db1f49b6482e7ab4$var$_createSuper(NullConnector);
    function NullConnector() {
        var _this;
        $db1f49b6482e7ab4$var$_classCallCheck(this, NullConnector);
        _this = _super.apply(this, arguments);
        /**
     * All of the subscribed channel names.
     */ _this.channels = {};
        return _this;
    }
    /**
   * Create a fresh connection.
   */ $db1f49b6482e7ab4$var$_createClass(NullConnector, [
        {
            key: "connect",
            value: function connect() {}
        },
        {
            key: "listen",
            value: function listen(name, event, callback) {
                return new $db1f49b6482e7ab4$var$NullChannel();
            }
        },
        {
            key: "channel",
            value: function channel(name) {
                return new $db1f49b6482e7ab4$var$NullChannel();
            }
        },
        {
            key: "privateChannel",
            value: function privateChannel(name) {
                return new $db1f49b6482e7ab4$var$NullPrivateChannel();
            }
        },
        {
            key: "encryptedPrivateChannel",
            value: function encryptedPrivateChannel(name) {
                return new $db1f49b6482e7ab4$var$NullEncryptedPrivateChannel();
            }
        },
        {
            key: "presenceChannel",
            value: function presenceChannel(name) {
                return new $db1f49b6482e7ab4$var$NullPresenceChannel();
            }
        },
        {
            key: "leave",
            value: function leave(name) {}
        },
        {
            key: "leaveChannel",
            value: function leaveChannel(name) {}
        },
        {
            key: "socketId",
            value: function socketId() {
                return 'fake-socket-id';
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {}
        }
    ]);
    return NullConnector;
}($db1f49b6482e7ab4$export$b2278035370d6017);
/**
 * This class is the primary API for interacting with broadcasting.
 */ var $db1f49b6482e7ab4$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Create a new class instance.
   */ function Echo(options) {
        $db1f49b6482e7ab4$var$_classCallCheck(this, Echo);
        this.options = options;
        this.connect();
        if (!this.options.withoutInterceptors) this.registerInterceptors();
    }
    /**
   * Get a channel instance by name.
   */ $db1f49b6482e7ab4$var$_createClass(Echo, [
        {
            key: "channel",
            value: function channel(_channel) {
                return this.connector.channel(_channel);
            }
        },
        {
            key: "connect",
            value: function connect() {
                if (this.options.broadcaster == 'reverb') this.connector = new $db1f49b6482e7ab4$var$PusherConnector($db1f49b6482e7ab4$var$_extends($db1f49b6482e7ab4$var$_extends({}, this.options), {
                    cluster: ''
                }));
                else if (this.options.broadcaster == 'pusher') this.connector = new $db1f49b6482e7ab4$var$PusherConnector(this.options);
                else if (this.options.broadcaster == 'socket.io') this.connector = new $db1f49b6482e7ab4$var$SocketIoConnector(this.options);
                else if (this.options.broadcaster == 'null') this.connector = new $db1f49b6482e7ab4$var$NullConnector(this.options);
                else if (typeof this.options.broadcaster == 'function' && $db1f49b6482e7ab4$var$isConstructor(this.options.broadcaster)) this.connector = new this.options.broadcaster(this.options);
                else throw new Error("Broadcaster ".concat($db1f49b6482e7ab4$var$_typeof(this.options.broadcaster), " ").concat(this.options.broadcaster, " is not supported."));
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                this.connector.disconnect();
            }
        },
        {
            key: "join",
            value: function join(channel) {
                return this.connector.presenceChannel(channel);
            }
        },
        {
            key: "leave",
            value: function leave(channel) {
                this.connector.leave(channel);
            }
        },
        {
            key: "leaveChannel",
            value: function leaveChannel(channel) {
                this.connector.leaveChannel(channel);
            }
        },
        {
            key: "leaveAllChannels",
            value: function leaveAllChannels() {
                for(var channel in this.connector.channels)this.leaveChannel(channel);
            }
        },
        {
            key: "listen",
            value: function listen(channel, event, callback) {
                return this.connector.listen(channel, event, callback);
            }
        },
        {
            key: "private",
            value: function _private(channel) {
                return this.connector.privateChannel(channel);
            }
        },
        {
            key: "encryptedPrivate",
            value: function encryptedPrivate(channel) {
                if (this.connector instanceof $db1f49b6482e7ab4$var$SocketIoConnector) throw new Error("Broadcaster ".concat($db1f49b6482e7ab4$var$_typeof(this.options.broadcaster), " ").concat(this.options.broadcaster, " does not support encrypted private channels."));
                return this.connector.encryptedPrivateChannel(channel);
            }
        },
        {
            key: "socketId",
            value: function socketId() {
                return this.connector.socketId();
            }
        },
        {
            key: "registerInterceptors",
            value: function registerInterceptors() {
                if (typeof Vue === 'function' && Vue.http) this.registerVueRequestInterceptor();
                if (typeof axios === 'function') this.registerAxiosRequestInterceptor();
                if (typeof jQuery === 'function') this.registerjQueryAjaxSetup();
                if ((typeof Turbo === "undefined" ? "undefined" : $db1f49b6482e7ab4$var$_typeof(Turbo)) === 'object') this.registerTurboRequestInterceptor();
            }
        },
        {
            key: "registerVueRequestInterceptor",
            value: function registerVueRequestInterceptor() {
                var _this = this;
                Vue.http.interceptors.push(function(request, next) {
                    if (_this.socketId()) request.headers.set('X-Socket-ID', _this.socketId());
                    next();
                });
            }
        },
        {
            key: "registerAxiosRequestInterceptor",
            value: function registerAxiosRequestInterceptor() {
                var _this2 = this;
                axios.interceptors.request.use(function(config) {
                    if (_this2.socketId()) config.headers['X-Socket-Id'] = _this2.socketId();
                    return config;
                });
            }
        },
        {
            key: "registerjQueryAjaxSetup",
            value: function registerjQueryAjaxSetup() {
                var _this3 = this;
                if (typeof jQuery.ajax != 'undefined') jQuery.ajaxPrefilter(function(options, originalOptions, xhr) {
                    if (_this3.socketId()) xhr.setRequestHeader('X-Socket-Id', _this3.socketId());
                });
            }
        },
        {
            key: "registerTurboRequestInterceptor",
            value: function registerTurboRequestInterceptor() {
                var _this4 = this;
                document.addEventListener('turbo:before-fetch-request', function(event) {
                    event.detail.fetchOptions.headers['X-Socket-Id'] = _this4.socketId();
                });
            }
        }
    ]);
    return Echo;
}();

});


parcelRegister("73TcF", function(module, exports) {
'use strict';
module.exports = ()=>{
    const ret = {};
    ret.promise = new Promise((resolve, reject)=>{
        ret.resolve = resolve;
        ret.reject = reject;
    });
    return ret;
};

});

parcelRegister("6KgMW", function(module, exports) {

module.exports = (parcelRequire("9FZDf"))($parcel$resolve("5A5yl")).then(()=>parcelRequire('c5KhD'));

});
parcelRegister("9FZDf", function(module, exports) {
"use strict";

var $9jW6n = parcelRequire("9jW6n");
module.exports = $9jW6n(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("9jW6n", function(module, exports) {
"use strict";
var $6c92f53da2785287$var$cachedBundles = {};
var $6c92f53da2785287$var$cachedPreloads = {};
var $6c92f53da2785287$var$cachedPrefetches = {};
function $6c92f53da2785287$var$getCache(type) {
    switch(type){
        case 'preload':
            return $6c92f53da2785287$var$cachedPreloads;
        case 'prefetch':
            return $6c92f53da2785287$var$cachedPrefetches;
        default:
            return $6c92f53da2785287$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $6c92f53da2785287$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("a9DWi", function(module, exports) {

module.exports = (parcelRequire("9FZDf"))($parcel$resolve("1qKjk")).then(()=>parcelRequire('46gZf'));

});

parcelRegister("9oD4W", function(module, exports) {

module.exports = (parcelRequire("9FZDf"))($parcel$resolve("leU9O")).then(()=>parcelRequire('jPB5B'));

});

parcelRegister("9HvWP", function(module, exports) {

module.exports = (parcelRequire("9FZDf"))($parcel$resolve("7eolF")).then(()=>parcelRequire('iOcXx'));

});

var $c36ed0842b375016$exports = {};
$parcel$extendImportMap({
    "5A5yl": "MatchHeadWidget.2b7e40a7.js",
    "1qKjk": "MatchTimelineWidget.e12ab618.js",
    "leU9O": "MatchStatsWidget.82539623.js",
    "7eolF": "FanVoteWidget.6ecaf26f.js"
});


var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");
var $64d0b1ebdd6bcffe$exports = {};

$parcel$export($64d0b1ebdd6bcffe$exports, "createRoot", function () { return $64d0b1ebdd6bcffe$export$882461b6382ed46c; }, function (v) { return $64d0b1ebdd6bcffe$export$882461b6382ed46c = v; });
$parcel$export($64d0b1ebdd6bcffe$exports, "hydrateRoot", function () { return $64d0b1ebdd6bcffe$export$757ceba2d55c277e; }, function (v) { return $64d0b1ebdd6bcffe$export$757ceba2d55c277e = v; });
var $64d0b1ebdd6bcffe$export$882461b6382ed46c;
var $64d0b1ebdd6bcffe$export$757ceba2d55c277e;
'use strict';
var $6d4849ee44552f5f$exports = {};
'use strict';
function $6d4849ee44552f5f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($6d4849ee44552f5f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$6d4849ee44552f5f$var$checkDCE();

$6d4849ee44552f5f$exports = (parcelRequire("jZA9I"));


var $64d0b1ebdd6bcffe$var$i;
$64d0b1ebdd6bcffe$export$882461b6382ed46c = $6d4849ee44552f5f$exports.createRoot;
$64d0b1ebdd6bcffe$export$757ceba2d55c277e = $6d4849ee44552f5f$exports.hydrateRoot;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $3G7m1 = parcelRequire("3G7m1");
// import "./FootballStandingTable.scss";
const $79281877118afd86$var$FootballStandingTable = ({ data: data, disable: disable = false, name: name })=>{
    const sortedData = (0, $3G7m1.sortByForm)(data);
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: `global_table football_form_table ${disable ? "d-none" : ""}`,
        "data-name": name,
        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "#"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "Table"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "Form"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                    children: sortedData?.map((row, index)=>{
                        if (!row?.form) return null;
                        let result;
                        try {
                            result = typeof row.form === 'string' ? JSON.parse(row.form) : row.form;
                        } catch  {
                            return null;
                        }
                        if (!Array.isArray(result)) return null;
                        return /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                    children: index + 1
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                        className: "des-wrap",
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                            className: "des-text",
                                            children: row?.team?.nm
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                                        className: "match_score_list",
                                        children: result?.map((score, scoreIndex)=>/*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                                className: score === "W" ? "green" : score === "D" ? "grey" : score === "L" ? "red" : "",
                                                children: score
                                            }, `${scoreIndex}-${score}`))
                                    })
                                })
                            ]
                        }, index + row?.nm);
                    })
                })
            ]
        })
    });
};
var $79281877118afd86$export$2e2bcd8739ae039 = $79281877118afd86$var$FootballStandingTable;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $ba5nK = parcelRequire("ba5nK");

var $3G7m1 = parcelRequire("3G7m1");
const $a7a7b81f3f3a07ab$var$LeagueTableRow = ({ data: data, index: index, teams: teams = [], sport: sport = "rugby", websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataClient: dataClient })=>{
    const active = teams.includes(data?.team_id);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
        className: `${active ? "highlight" : ""}`,
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("td", {
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "hi-border",
                        style: {
                            backgroundColor: `${data?.cl}`
                        }
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "d-inline-block align-middle",
                        children: index + 1
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                    className: "des-wrap",
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                            className: "flg_img",
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                src: (0, $3G7m1.getImageUrl)('', '', sport, data.team_id),
                                height: 23,
                                width: 23,
                                alt: "teamLogo",
                                priority: false
                            })
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                            href: (0, $3G7m1.teamLeagueInfoUrl)({
                                dataClient: dataClient,
                                websiteBaseUrl: websiteBaseUrl,
                                dataPath: dataPath,
                                category: "team",
                                sport: sport,
                                name: data?.team?.nm,
                                id: data?.team?.id
                            }),
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "des-text",
                                children: data?.team?.nm || data?.team
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                children: data?.pl
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                children: data?.wo
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                children: data?.dr
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                children: data?.lo
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                children: data?.sc
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                children: data?.cc
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                children: data?.df
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                children: data?.pts
            })
        ]
    });
};
var $a7a7b81f3f3a07ab$export$2e2bcd8739ae039 = $a7a7b81f3f3a07ab$var$LeagueTableRow;


const $4bcd16ab9296460a$var$LeagueTableW = ({ table: table, teams: teams = [], type: type = "table", name: name, matchId: matchId, disable: disable = false, dictionary: dictionary, sport: sport = "rugby", websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataClient: dataClient })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: `global_table standing_table ${disable ? "d-none" : ""}`,
        "data-name": name,
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "#"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: dictionary?.Standings || "Standings"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "P"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "W"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "D"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "L"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "F"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "A"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "GD"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "PTS"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                        children: table?.map((t, i)=>/*#__PURE__*/ (0, $lBpE3.jsx)((0, $a7a7b81f3f3a07ab$export$2e2bcd8739ae039), {
                                data: t,
                                teams: teams,
                                index: i,
                                sport: sport,
                                websiteBaseUrl: websiteBaseUrl,
                                dataClient: dataClient,
                                dataPath: dataPath
                            }, t?.team?.id))
                    })
                ]
            }),
            type === "info" ? /*#__PURE__*/ (0, $lBpE3.jsx)("center", {
                className: "link_black underline_text",
                style: {
                    marginBottom: "10px"
                },
                children: dictionary?.Seeallstanding || "See all standing"
            }) : ""
        ]
    });
};
var $4bcd16ab9296460a$export$2e2bcd8739ae039 = $4bcd16ab9296460a$var$LeagueTableW;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $3G7m1 = parcelRequire("3G7m1");
// import "../table/GroupStage.scss";
const $98fe7d82f4d00250$var$TableGroup = ({ groups: groups, disable: disable = false })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: `group_stages_wrp ${disable ? "d-none" : ""}`,
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
            className: "group_stages",
            children: groups?.length ? groups?.map((group, ind)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                            className: "stg_circle",
                            style: {
                                backgroundColor: group?.color
                            }
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                            className: "stg_test",
                            children: group?.name
                        })
                    ]
                }, (0, $3G7m1.uniqueId)(ind))) : ""
        })
    });
};
var $98fe7d82f4d00250$export$2e2bcd8739ae039 = $98fe7d82f4d00250$var$TableGroup;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");
const $0ce20e138f099eec$var$NoDataFound = ({ text: text = `No record Found!`, type: type })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
            className: "no_record_wrap",
            children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "no_data_found ",
                "data-testid": "no_data_found",
                children: text
            })
        })
    });
};
var $0ce20e138f099eec$export$2e2bcd8739ae039 = $0ce20e138f099eec$var$NoDataFound;



var $2bSDe = parcelRequire("2bSDe");
const $3bb918d7b03f1ba4$var$FootballTable = ({ ServerData: ServerData = {}, dictionary: dictionary, loadCSS: loadCSS = true, dataClient: dataClient = false, title: title, sport: sport = "football", websiteBaseUrl: websiteBaseUrl, dataPath: dataPath })=>{
    const [active, setActive] = (0, $6cds3.useState)("all");
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    const data = dataClient ? clientData : ServerData;
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document?.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    const sortTable = (set)=>{
        return [
            ...set || []
        ].sort((a, b)=>b.pts === a.pts ? b.df - a.df : b.pts - a.pts);
    };
    const tabs = [
        {
            key: "all",
            label: dictionary?.All || "All",
            disable: !data?.table?.all
        },
        {
            key: "home",
            label: dictionary?.Home || "Home",
            disable: !data?.table?.home
        },
        {
            key: "away",
            label: dictionary?.Away || "Away",
            disable: !data?.table?.away
        },
        {
            key: "form",
            label: dictionary?.Form || "Form",
            disable: !data?.table?.all
        }
    ];
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("matchtable");
    }, [
        loadCSS
    ]);
    if (data?.table?.all?.length === 0 && data?.table?.away?.length === 0 && data?.table?.home?.length === 0 && data?.groups?.length === 0 || data && typeof data === "object" && Object.keys(data).length === 0) return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "global_table standing_table",
        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {
            type: 'table'
        })
    });
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "football-table",
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("nav", {
                className: "inner_tab",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                    children: tabs.map(({ key: key, label: label, disable: disable })=>/*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                            className: `${active === key ? "active" : ""} ${disable ? "disabled" : ""}`,
                            onClick: ()=>!disable && setActive(key),
                            "data-name": key,
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                children: label
                            })
                        }, key))
                })
            }),
            active === "form" && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $79281877118afd86$export$2e2bcd8739ae039), {
                data: data?.table?.all,
                disable: false,
                name: "form"
            }),
            tabs.filter((tab)=>tab.key !== "form").map((tab)=>/*#__PURE__*/ (0, $lBpE3.jsx)((0, $4bcd16ab9296460a$export$2e2bcd8739ae039), {
                    table: sortTable(data?.table?.[tab.key]),
                    teams: data?.teams,
                    disable: active !== tab.key,
                    name: tab.key,
                    dictionary: dictionary,
                    sport: sport,
                    websiteBaseUrl: websiteBaseUrl,
                    dataClient: dataClient,
                    dataPath: dataPath
                }, tab.key)),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $98fe7d82f4d00250$export$2e2bcd8739ae039), {
                groups: data?.groups,
                disable: active
            })
        ]
    });
};
var $3bb918d7b03f1ba4$export$2e2bcd8739ae039 = $3bb918d7b03f1ba4$var$FootballTable;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $ba5nK = parcelRequire("ba5nK");

var $3G7m1 = parcelRequire("3G7m1");

var $kybuc = parcelRequire("kybuc");

const $68b69bd46a4c06c0$var$H2HTable = ({ team: team, data: data, plays: plays = false, team_id: team_id, setDataId: setDataId, setDataType: setDataType, setHead: setHead, setLeagueId: setLeagueId, liveCentre: liveCentre, sport: sport = 'football' })=>{
    const getMatchOutcomeClass = (team_id, match)=>{
        const outcome = (0, $3G7m1.getMatchOutcome)(team_id, match);
        let outcomeClass;
        if (outcome === "W") outcomeClass = "win";
        else if (outcome === "L") outcomeClass = "loss";
        else outcomeClass = "draw";
        return outcomeClass;
    };
    const baseURL = "https://ipublisher-microservices.6lgx.com" ?? "https://ipublisher-microservices.6lgx.com";
    const navigateToLeaguePage = (leagueId)=>{
        if (liveCentre) {
            setHead("league");
            setDataId(leagueId);
            setDataType("league-page");
            setLeagueId(leagueId);
        }
    };
    const navigateToMatchPage = (matchId)=>{
        if (liveCentre) {
            setHead("match");
            setDataId(matchId);
            setDataType("match-page");
        }
    };
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "h2h_wrp_boxs",
        children: data?.length ? data?.map((league, leagueIdx)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "h2h_wrp_box",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "h2h_wrp_box_head",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: "icon_wrap",
                                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                    src: `${baseURL}/public/assets/images/flags/country_${league?.fid}.png`,
                                    width: 18,
                                    height: 18,
                                    alt: "avatar"
                                })
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                className: "rgt",
                                onClick: ()=>navigateToLeaguePage(league?.id),
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "title",
                                        children: `${league?.name} ${league?.sea}`
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "countary",
                                        children: league?.nm?.split("-")?.[0]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "global_table h2h_table",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("table", {
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                                children: league?.matches.map((match)=>{
                                    const [homeScore, awayScore] = (match?.ps || match?.ft || "").split("-");
                                    const isHomeActive = parseInt(homeScore) > parseInt(awayScore);
                                    const isAwayActive = parseInt(homeScore) < parseInt(awayScore);
                                    return /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                        style: {
                                            cursor: "pointer"
                                        },
                                        onClick: ()=>navigateToMatchPage(match?.id),
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                                    className: "match-timing",
                                                    children: [
                                                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                            className: "match_date",
                                                            children: (0, $kybuc.DateUtility).FormatDateh2h(new Date(match?.dt))
                                                        }),
                                                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                            className: "match_time ft",
                                                            children: "FT"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                    className: "teams_wrap",
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                                        className: "teams-name",
                                                        children: [
                                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                                className: `team_name ${isHomeActive ? "active" : ""}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                        className: "teams-logo",
                                                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                                            src: (0, $3G7m1.getImageUrl)('', '', sport, match?.competitors?.htid),
                                                                            height: 18,
                                                                            width: 18,
                                                                            alt: "teamLogo",
                                                                            priority: false
                                                                        })
                                                                    }),
                                                                    match?.competitors?.htn
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                                className: `team_name ${isAwayActive ? "active" : ""}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                        className: "teams-logo",
                                                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                                            src: (0, $3G7m1.getImageUrl)('', '', sport, match?.competitors?.atid),
                                                                            height: 18,
                                                                            width: 18,
                                                                            alt: "teamLogo",
                                                                            priority: false
                                                                        })
                                                                    }),
                                                                    match?.competitors?.atn
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                className: "score-td",
                                                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                                    className: "teams-name",
                                                    children: [
                                                        /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                            className: "highlighted-color",
                                                            children: homeScore
                                                        }),
                                                        /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                            className: "team_name highlighted-color",
                                                            children: awayScore
                                                        })
                                                    ]
                                                })
                                            }),
                                            plays && /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                className: "win-td",
                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                    className: "icon-wrap",
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                        className: `icon_status ${getMatchOutcomeClass(team_id, match)}`,
                                                        children: (0, $3G7m1.getMatchOutcome)(team_id, match)
                                                    })
                                                })
                                            })
                                        ]
                                    }, match?.id);
                                })
                            })
                        })
                    })
                ]
            }, league?.id || leagueIdx)) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {})
    });
};
var $68b69bd46a4c06c0$export$2e2bcd8739ae039 = $68b69bd46a4c06c0$var$H2HTable;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $3G7m1 = parcelRequire("3G7m1");
const $9440fa542a51decf$var$PredictionBox = ({ title: title, drawLable: drawLable = false, t1Score: t1Score, t2Score: t2Score, t1P: t1P, t2P: t2P, drawScore: drawScore, drawP: drawP })=>{
    const { t1W: t1W, t2W: t2W, drawW: drawW } = (0, $6cds3.useMemo)(()=>(0, $3G7m1.getPredictionWidth)(t1P, t2P, drawLable, drawP), [
        t1P,
        t2P,
        drawLable,
        drawP
    ]);
    const formatPercentage = (value)=>{
        if (!value && value !== 0) return "0%";
        const stringValue = String(value);
        return stringValue.includes("%") ? stringValue : `${stringValue}%`;
    };
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "prediction",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "leg_head",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                    children: title
                })
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: `predict_box`,
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "predict_head",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                className: "pre_col",
                                children: "Home"
                            }),
                            drawLable ? /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                className: "pre_col",
                                children: "Draw"
                            }) : null,
                            /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                className: "pre_col right",
                                children: "Away"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "predict_body",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                className: "bar-labels",
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "label-left",
                                        children: t1Score
                                    }),
                                    drawLable && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "label-center",
                                        children: drawScore
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "label-right",
                                        children: t2Score
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                className: "continuous-bar",
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "bar-segment left",
                                        style: {
                                            width: t1W
                                        }
                                    }),
                                    drawLable && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "bar-segment center",
                                        style: {
                                            width: drawW
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "bar-segment right",
                                        style: {
                                            width: t2W
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                className: "bar-labels",
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "label-left",
                                        children: formatPercentage(t1W)
                                    }),
                                    drawLable && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "label-center",
                                        children: formatPercentage(drawW)
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "label-right",
                                        children: formatPercentage(t2W)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $9440fa542a51decf$export$2e2bcd8739ae039 = $9440fa542a51decf$var$PredictionBox;



var $2bSDe = parcelRequire("2bSDe");
const $62b4ee31d2bc99dc$var$H2h = ({ serverData: serverData, loadCSS: loadCSS, setDataId: setDataId, setDataType: setDataType, setHead: setHead, setLeagueId: setLeagueId, dataClient: dataClient, title: title, liveCentre: liveCentre })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    const data = dataClient ? clientData : serverData;
    const getInitialTab = ()=>{
        if (data?.h2h?.length) return "meetings";
        if (data?.home_team?.team) return "home";
        if (data?.away_team?.team) return "away";
        return "meetings";
    };
    const [active, setActive] = (0, $6cds3.useState)(getInitialTab());
    (0, $6cds3.useEffect)(()=>{
        setActive(getInitialTab());
    }, [
        data
    ]);
    const getTableProps = ()=>{
        switch(active){
            case "meetings":
                return {
                    data: data?.h2h,
                    plays: false,
                    team: "",
                    team_id: ""
                };
            case "home":
                return {
                    data: data?.home_team?.tournament,
                    plays: true,
                    team: data?.home_team?.team,
                    team_id: data?.home_team?.id
                };
            case "away":
                return {
                    data: data?.away_team?.tournament,
                    plays: true,
                    team: data?.away_team?.team,
                    team_id: data?.away_team?.id
                };
            default:
                return {
                    data: null,
                    plays: false,
                    team: ""
                };
        }
    };
    const tableProps = getTableProps();
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("h2h");
    }, [
        loadCSS
    ]);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("nav", {
                className: "inner_tab",
                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("ul", {
                    children: [
                        data?.h2h?.length ? /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                            className: active === "meetings" ? "active" : "",
                            onClick: ()=>setActive("meetings"),
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                children: "Meetings"
                            })
                        }) : null,
                        data?.home_team?.team ? /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                            className: active === "home" ? "active" : "",
                            onClick: ()=>setActive("home"),
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                children: data.home_team.team
                            })
                        }) : null,
                        data?.away_team?.team ? /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                            className: active === "away" ? "active" : "",
                            onClick: ()=>setActive("away"),
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                children: data.away_team.team
                            })
                        }) : null
                    ]
                })
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $68b69bd46a4c06c0$export$2e2bcd8739ae039), {
                ...tableProps,
                setDataType: setDataType,
                setDataId: setDataId,
                setHead: setHead,
                setLeagueId: setLeagueId,
                liveCentre: liveCentre
            }),
            data?.h2h_stats?.wins && data?.h2h_stats?.draws ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $9440fa542a51decf$export$2e2bcd8739ae039), {
                title: "Match",
                drawLable: true,
                t1Score: data?.h2h_stats?.wins?.t1,
                t2Score: data?.h2h_stats?.wins?.t2,
                t1P: data?.h2h_stats?.wins?.t1p,
                t2P: data?.h2h_stats?.wins?.t2p,
                drawScore: data?.h2h_stats?.draws?.tot,
                drawP: data?.h2h_stats?.draws?.perct
            }) : null,
            data?.h2h_stats?.ht_leading ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $9440fa542a51decf$export$2e2bcd8739ae039), {
                title: "Leading At HT",
                t1Score: data?.h2h_stats?.ht_leading?.t1,
                t2Score: data?.h2h_stats?.ht_leading?.t2,
                t1P: data?.h2h_stats?.ht_leading?.t1p,
                t2P: data?.h2h_stats?.ht_leading?.t2p
            }) : null,
            data?.h2h_stats?.ht_drawing ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $9440fa542a51decf$export$2e2bcd8739ae039), {
                title: "Drawing At HT",
                t1Score: data?.h2h_stats?.ht_drawing?.t1,
                t2Score: data?.h2h_stats?.ht_drawing?.t2,
                t1P: data?.h2h_stats?.ht_drawing?.t1p,
                t2P: data?.h2h_stats?.ht_drawing?.t2p
            }) : null,
            data?.h2h_stats?.ht_losing ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $9440fa542a51decf$export$2e2bcd8739ae039), {
                title: "Losing At HT",
                t1Score: data?.h2h_stats?.ht_losing?.t1,
                t2Score: data?.h2h_stats?.ht_losing?.t2,
                t1P: data?.h2h_stats?.ht_losing?.t1p,
                t2P: data?.h2h_stats?.ht_losing?.t2p
            }) : null
        ]
    });
};
var $62b4ee31d2bc99dc$export$2e2bcd8739ae039 = $62b4ee31d2bc99dc$var$H2h;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");


var $3G7m1 = parcelRequire("3G7m1");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $3G7m1 = parcelRequire("3G7m1");
const $f79ba49286473462$var$MatchStats = ({ stats: stats })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
        className: "stats_list",
        children: stats?.map((s, i)=>{
            const isPercentage = s?.type === "possession_percentage";
            return /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                style: {
                    display: s?.type === "total" ? "none" : undefined
                },
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "bar_status_top",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("strong", {
                                className: "stats_num",
                                children: [
                                    s?.ht,
                                    isPercentage ? "%" : ""
                                ]
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "bar_status",
                                children: (0, $3G7m1.capitalized1LetterS)(s?.type)
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("strong", {
                                className: "stats_num",
                                children: [
                                    s?.at,
                                    isPercentage ? "%" : ""
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "bar-wrap",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: "l_bar",
                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                    className: "stats_bar",
                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: `bar_color ${s?.ht > s?.at ? "higher_bar_color" : "lower_bar_color"}`,
                                        style: {
                                            width: `${s?.htPercent}%`
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: "r_bar",
                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                    className: "stats_bar",
                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: `bar_color ${s?.at > s?.ht ? "higher_bar_color" : "lower_bar_color"}`,
                                        style: {
                                            width: `${s?.atPercent}%`
                                        }
                                    })
                                })
                            })
                        ]
                    })
                ]
            }, (0, $3G7m1.uniqueId)(i));
        })
    });
};
var $f79ba49286473462$export$2e2bcd8739ae039 = $f79ba49286473462$var$MatchStats;



var $2bSDe = parcelRequire("2bSDe");
const $ef8eecb0ad76f456$var$Stats = ({ data: data, loadCSS: loadCSS, dataClient: dataClient = false, title: title })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    const [activeHalf, setActiveHalf] = (0, $6cds3.useState)("total");
    const [activeQuarter, setActiveQuarter] = (0, $6cds3.useState)("first_quarter");
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    const sourceData = dataClient ? clientData : data;
    // Check if this is basketball quarter-based data
    const isBasketballData = sourceData && (sourceData.first_quarter || sourceData.second_quarter || sourceData.third_quarter || sourceData.fourth_quarter);
    // Check if this is football half-based data
    const isFootballData = sourceData && (sourceData.first_half || sourceData.second_half || sourceData.total);
    // Process stats from half/quarter data
    const processStats = (periodData)=>{
        if (!periodData || typeof periodData !== "object") return [];
        return Object.entries(periodData).filter(([key, value])=>value && typeof value === "object" && "ht" in value && "at" in value && key !== "total" && (value.ht !== 0 || value.at !== 0)).sort(([, a], [, b])=>(a.sort || 999) - (b.sort || 999)).map(([type, { ht: ht, at: at }])=>({
                type: type,
                ht: ht,
                at: at,
                htPercent: (0, $3G7m1.calculatePercentagestats)(ht, at),
                atPercent: (0, $3G7m1.calculatePercentagestats)(at, ht)
            }));
    };
    // Legacy stats processing
    const legacyStats = (0, $6cds3.useMemo)(()=>{
        if (!sourceData || typeof sourceData !== "object" || isFootballData || isBasketballData) return [];
        return Object.entries(sourceData).map(([type, { ht: ht, at: at } = {}])=>({
                type: type,
                ht: ht,
                at: at,
                htPercent: (0, $3G7m1.calculatePercentagestats)(ht, at),
                atPercent: (0, $3G7m1.calculatePercentagestats)(at, ht)
            }));
    }, [
        sourceData,
        isFootballData,
        isBasketballData
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("matchstat");
    }, [
        loadCSS
    ]);
    // Basketball quarter-based rendering
    if (isBasketballData) {
        const quarters = [
            {
                key: "first_quarter",
                label: "1st Quarter"
            },
            {
                key: "second_quarter",
                label: "2nd Quarter"
            },
            {
                key: "third_quarter",
                label: "3rd Quarter"
            },
            {
                key: "fourth_quarter",
                label: "4th Quarter"
            }
        ];
        const currentQuarterData = sourceData[activeQuarter];
        let basketballStats = [];
        if (currentQuarterData) {
            // Process scoring stats
            if (currentQuarterData.scoring) {
                const scoring = currentQuarterData.scoring;
                const scoringKeys = [
                    "field_goals_attempted",
                    "field_goals_made",
                    "field_goals_percentage",
                    "two_pointers_attempted",
                    "two_pointers_made",
                    "two_pointers_percentage",
                    "three_pointers_attempted",
                    "three_pointers_made",
                    "three_pointers_percentage",
                    "free_throws_attempted",
                    "free_throws_made",
                    "free_throws_percentage"
                ];
                scoringKeys.forEach((key)=>{
                    if (scoring[key]) basketballStats.push({
                        type: key,
                        ht: scoring[key]?.ht || 0,
                        at: scoring[key]?.at || 0,
                        htPercent: (0, $3G7m1.calculatePercentagestats)(scoring[key]?.ht || 0, scoring[key]?.at || 0),
                        atPercent: (0, $3G7m1.calculatePercentagestats)(scoring[key]?.at || 0, scoring[key]?.ht || 0)
                    });
                });
            }
            // Process rebounds stats
            if (currentQuarterData.rebounds) {
                const rebounds = currentQuarterData.rebounds;
                const reboundKeys = [
                    "rebounds_offensive",
                    "rebounds_defensive",
                    "total_rebounds"
                ];
                reboundKeys.forEach((key)=>{
                    if (rebounds[key]) basketballStats.push({
                        type: key,
                        ht: rebounds[key]?.ht || 0,
                        at: rebounds[key]?.at || 0,
                        htPercent: (0, $3G7m1.calculatePercentagestats)(rebounds[key]?.ht || 0, rebounds[key]?.at || 0),
                        atPercent: (0, $3G7m1.calculatePercentagestats)(rebounds[key]?.at || 0, rebounds[key]?.ht || 0)
                    });
                });
            }
            // Process other stats
            if (currentQuarterData.other) {
                const other = currentQuarterData.other;
                const otherKeys = [
                    "assists",
                    "blocks",
                    "turnovers",
                    "steals",
                    "fouls_personal",
                    "points"
                ];
                otherKeys.forEach((key)=>{
                    if (other[key]) basketballStats.push({
                        type: key,
                        ht: other[key]?.ht || 0,
                        at: other[key]?.at || 0,
                        htPercent: (0, $3G7m1.calculatePercentagestats)(other[key]?.ht || 0, other[key]?.at || 0),
                        atPercent: (0, $3G7m1.calculatePercentagestats)(other[key]?.at || 0, other[key]?.ht || 0)
                    });
                });
            }
        }
        return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
            className: "stats_list_wrp",
            children: [
                title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                    children: title
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: "quarter-tabs",
                    children: quarters.map((quarter)=>/*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                            className: `quarter-tab ${activeQuarter === quarter.key ? "active" : ""}`,
                            onClick: ()=>setActiveQuarter(quarter.key),
                            children: quarter.label
                        }, quarter.key))
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: "stats-holder",
                    children: basketballStats.length > 0 ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $f79ba49286473462$export$2e2bcd8739ae039), {
                        stats: basketballStats
                    }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {})
                })
            ]
        });
    }
    // Football half-based rendering
    if (isFootballData) {
        const halves = [
            {
                key: "total",
                label: "All"
            },
            {
                key: "first_half",
                label: "First Half"
            },
            {
                key: "second_half",
                label: "Second Half"
            }
        ];
        const currentHalfData = sourceData[activeHalf];
        const footballStats = processStats(currentHalfData);
        return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
            className: "stats_list_wrp",
            children: [
                title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                    children: title
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: "quarter-tabs",
                    children: halves.map((half)=>/*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                            className: `quarter-tab ${activeHalf === half.key ? "active" : ""}`,
                            onClick: ()=>setActiveHalf(half.key),
                            children: half.label
                        }, half.key))
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: "stats-holder",
                    children: footballStats.length > 0 ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $f79ba49286473462$export$2e2bcd8739ae039), {
                        stats: footballStats
                    }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {})
                })
            ]
        });
    }
    // Legacy format rendering
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "stats_list_wrp",
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "stats-holder",
                children: legacyStats.length > 0 ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $f79ba49286473462$export$2e2bcd8739ae039), {
                    stats: legacyStats
                }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $ef8eecb0ad76f456$export$2e2bcd8739ae039 = $ef8eecb0ad76f456$var$Stats;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $2bSDe = parcelRequire("2bSDe");

var $zSRJd = parcelRequire("zSRJd");

var $3G7m1 = parcelRequire("3G7m1");
/**
 * MatchLineup — self-contained football lineup / formation widget.
 *
 * Renders (from /match/{id}/lineup):
 *   • Header: crest + team name + coach + formation, for both sides
 *   • Pitch: starters placed by formation (GK + each formation line), with shirt number,
 *     name, captain, card, and subbed-off minute markers
 *   • Substitutions, Substitutes (bench), and Injured & Suspended lists
 *
 * Data source (priority): serverData prop → hydration DOM (data-listingdata) → self-fetch.
 * Styling is token-driven (src/assets/scss/matchLineup.scss).
 */ // player.cards[] → "r" (red wins) | "y" | null
const $7c7ef8b1fa9bd4ec$var$cardKind = (cards)=>{
    const t = (cards || []).map((c)=>String(c?.ty || "").toLowerCase());
    if (t.some((x)=>x.includes("red"))) return "r";
    if (t.some((x)=>x.includes("yellow"))) return "y";
    return null;
};
const $7c7ef8b1fa9bd4ec$var$mapStarter = (p)=>({
        sno: p?.sno,
        name: p?.player?.nm || p?.nm || "",
        isCap: p?.is_cap === 1 || p?.is_cap === true,
        card: $7c7ef8b1fa9bd4ec$var$cardKind(p?.player?.cards),
        subMin: p?.player?.substitutions_out?.minutes || null
    });
// One team's raw lineup object → view model (formation-lined starters + bench/subs/injured).
const $7c7ef8b1fa9bd4ec$var$buildTeam = (team, coachName, sport)=>{
    if (!team) return null;
    const lineup = team.lineup || [];
    const starters = lineup.filter((p)=>p.isb === 0 || p.match_position === "Starting").sort((a, b)=>(a.or || 0) - (b.or || 0));
    const gk = starters.find((p)=>/goal/i.test(p.pos)) || starters[0] || null;
    const outfield = starters.filter((p)=>p !== gk);
    // Split the 10 outfield players into formation lines, e.g. "4-2-3-1" → [4,2,3,1].
    const digits = String(team.formation || "").split("-").map((n)=>parseInt(n, 10)).filter((n)=>n > 0);
    const lines = [];
    if (digits.length) {
        let i = 0;
        for (const d of digits){
            lines.push(outfield.slice(i, i + d));
            i += d;
        }
        if (i < outfield.length && lines.length) // any leftover (data/formation mismatch) joins the last line so nobody is dropped
        lines[lines.length - 1] = lines[lines.length - 1].concat(outfield.slice(i));
    } else {
        // no formation string → group by position
        const byPos = (re)=>outfield.filter((p)=>re.test(p.pos));
        [
            /(def|back)/i,
            /mid/i,
            /(str|forw|att|wing)/i
        ].forEach((re)=>{
            const g = byPos(re);
            if (g.length) lines.push(g);
        });
        if (!lines.length && outfield.length) lines.push(outfield);
    }
    return {
        name: team.nm || team.sn || "",
        coach: coachName || "",
        formation: String(team.formation || "").trim(),
        crest: team.id ? (0, $3G7m1.getImageUrl)("", "", sport, team.id) : null,
        gk: gk ? $7c7ef8b1fa9bd4ec$var$mapStarter(gk) : null,
        lines: lines.map((line)=>line.map($7c7ef8b1fa9bd4ec$var$mapStarter)),
        bench: (team.sub_players || []).map((b)=>({
                sno: b.sno,
                name: b.nm
            })),
        subs: (team.sub || []).map((s)=>({
                min: s.min,
                inName: s.p_in_nm,
                outName: s.p_out_nm
            })),
        injsusp: (team.inj_susp_players || []).map((x)=>({
                sno: x.sno,
                name: x.nm,
                status: x.status || x.reason || x.type || "Injured"
            }))
    };
};
const $7c7ef8b1fa9bd4ec$var$lineupFromRaw = (raw)=>{
    const d = raw?.data || raw || null; // accept {data:{…}} or the object directly
    if (!d || !d.home_team && !d.away_team) return null;
    return d;
};
// ── Small pieces ──────────────────────────────────────────────────────────
const $7c7ef8b1fa9bd4ec$var$Crest = ({ src: src, name: name })=>/*#__PURE__*/ (0, $lBpE3.jsx)("span", {
        className: "ml__crest",
        children: src ? /*#__PURE__*/ (0, $lBpE3.jsx)("img", {
            src: src,
            alt: name ? `${name} crest` : ""
        }) : null
    });
// Substitution arrow — green (in) points up, red (out) points down. Inherits colour.
const $7c7ef8b1fa9bd4ec$var$Arrow = ({ up: up })=>/*#__PURE__*/ (0, $lBpE3.jsx)("svg", {
        className: "ml__arw",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true",
        children: up ? /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsx)("line", {
                    x1: "12",
                    y1: "20",
                    x2: "12",
                    y2: "6"
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("polyline", {
                    points: "6 12 12 6 18 12"
                })
            ]
        }) : /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsx)("line", {
                    x1: "12",
                    y1: "4",
                    x2: "12",
                    y2: "18"
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("polyline", {
                    points: "6 12 12 18 18 12"
                })
            ]
        })
    });
const $7c7ef8b1fa9bd4ec$var$Player = ({ p: p })=>/*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
        className: "ml__pl",
        title: `${p.sno ? p.sno + " \xb7 " : ""}${p.name}`,
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                className: "ml__badge",
                children: [
                    p.sno,
                    p.isCap ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "ml__cap",
                        "aria-label": "Captain",
                        children: "C"
                    }) : null,
                    p.card ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: `ml__cardmark ml__cardmark--${p.card}`,
                        "aria-hidden": "true"
                    }) : null,
                    p.subMin ? /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                        className: "ml__off",
                        children: [
                            "\u2193",
                            p.subMin,
                            "'"
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                className: "ml__pname",
                children: p.name
            })
        ]
    });
const $7c7ef8b1fa9bd4ec$var$Column = ({ players: players })=>/*#__PURE__*/ (0, $lBpE3.jsx)("span", {
        className: "ml__col",
        children: players.map((p, i)=>/*#__PURE__*/ (0, $lBpE3.jsx)($7c7ef8b1fa9bd4ec$var$Player, {
                p: p
            }, `${p.sno}-${i}`))
    });
const $7c7ef8b1fa9bd4ec$var$Half = ({ team: team, side: side })=>/*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: `ml__half ml__half--${side}`,
        children: [
            team.gk ? /*#__PURE__*/ (0, $lBpE3.jsx)($7c7ef8b1fa9bd4ec$var$Column, {
                players: [
                    team.gk
                ]
            }) : null,
            team.lines.map((line, i)=>/*#__PURE__*/ (0, $lBpE3.jsx)($7c7ef8b1fa9bd4ec$var$Column, {
                    players: line
                }, i))
        ]
    });
const $7c7ef8b1fa9bd4ec$var$TeamHead = ({ team: team, side: side })=>/*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: `ml__thead ml__thead--${side}`,
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)($7c7ef8b1fa9bd4ec$var$Crest, {
                src: team.crest,
                name: team.name
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "ml__tmeta",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "ml__tname",
                        children: team.name
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                        className: "ml__tsub",
                        children: [
                            team.formation ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "ml__formation",
                                children: team.formation
                            }) : null,
                            team.coach ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "ml__coach",
                                children: team.coach
                            }) : null
                        ]
                    })
                ]
            })
        ]
    });
const $7c7ef8b1fa9bd4ec$var$MatchLineup = ({ dataId: dataId, baseUrl: baseUrl, sport: sport = "football", difference: difference = "+0", serverData: serverData = null, data: dataProp = null, dataClient: dataClient = false, loadCSS: loadCSS = true })=>{
    (0, $6cds3.useEffect)(()=>{
        (0, $2bSDe.loadStyles)("lineupPitch");
    }, []);
    const [raw, setRaw] = (0, $6cds3.useState)($7c7ef8b1fa9bd4ec$var$lineupFromRaw(serverData || dataProp));
    (0, $6cds3.useEffect)(()=>{
        const r = $7c7ef8b1fa9bd4ec$var$lineupFromRaw(serverData || dataProp);
        if (r) setRaw(r);
    }, [
        serverData,
        dataProp
    ]);
    // Hydration: re-read the serialized lineup off the container
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        try {
            const el = document.querySelector(".microservice-cont");
            const parsed = JSON.parse(el?.getAttribute("data-listingdata") || "null");
            const r = $7c7ef8b1fa9bd4ec$var$lineupFromRaw(parsed?.data);
            if (r) setRaw(r);
        } catch (_) {}
    }, [
        dataClient
    ]);
    // Embed: self-fetch the lineup
    (0, $6cds3.useEffect)(()=>{
        if (raw || dataClient || !dataId || !baseUrl) return;
        let cancelled = false;
        (0, $zSRJd.getData)({
            dataId: dataId,
            dataType: "match-lineup",
            baseUrl: baseUrl,
            sport: sport,
            difference: difference
        }).then((res)=>{
            if (cancelled) return;
            const r = $7c7ef8b1fa9bd4ec$var$lineupFromRaw(res);
            if (r) setRaw(r);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        raw,
        dataClient,
        dataId,
        baseUrl,
        sport,
        difference
    ]);
    if (!raw) return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "ml ml--loading",
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
            children: "Loading lineups\u2026"
        })
    });
    const home = $7c7ef8b1fa9bd4ec$var$buildTeam(raw.home_team, raw.home_team_coach, sport);
    const away = $7c7ef8b1fa9bd4ec$var$buildTeam(raw.away_team, raw.away_team_coach, sport);
    if (!home && !away) return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "ml ml--loading",
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
            children: "Lineups not available"
        })
    });
    const teams = [
        home,
        away
    ].filter(Boolean);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "ml",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "ml__head",
                children: [
                    home ? /*#__PURE__*/ (0, $lBpE3.jsx)($7c7ef8b1fa9bd4ec$var$TeamHead, {
                        team: home,
                        side: "home"
                    }) : /*#__PURE__*/ (0, $lBpE3.jsx)("span", {}),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "ml__vs",
                        children: "vs"
                    }),
                    away ? /*#__PURE__*/ (0, $lBpE3.jsx)($7c7ef8b1fa9bd4ec$var$TeamHead, {
                        team: away,
                        side: "away"
                    }) : /*#__PURE__*/ (0, $lBpE3.jsx)("span", {})
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "ml__pitch",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "ml__pitch-lines",
                        "aria-hidden": "true"
                    }),
                    home ? /*#__PURE__*/ (0, $lBpE3.jsx)($7c7ef8b1fa9bd4ec$var$Half, {
                        team: home,
                        side: "home"
                    }) : null,
                    away ? /*#__PURE__*/ (0, $lBpE3.jsx)($7c7ef8b1fa9bd4ec$var$Half, {
                        team: away,
                        side: "away"
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "ml__subs-sec",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("h4", {
                        className: "ml__panel-title ml__panel-title--blue",
                        children: "Substitutions"
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "ml__subs-row",
                        children: teams.map((t, i)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                className: "ml__subs-team",
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "ml__panel-team",
                                        children: t.name
                                    }),
                                    t.subs.length ? /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                                        className: "ml__subs",
                                        children: t.subs.map((s, j)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                                className: "ml__sub",
                                                children: [
                                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                        className: "ml__sub-min",
                                                        children: [
                                                            s.min,
                                                            "'"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                        className: "ml__sub-swap",
                                                        children: [
                                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                                className: "ml__sub-in",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $lBpE3.jsx)($7c7ef8b1fa9bd4ec$var$Arrow, {
                                                                        up: true
                                                                    }),
                                                                    s.inName
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                                className: "ml__sub-out",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $lBpE3.jsx)($7c7ef8b1fa9bd4ec$var$Arrow, {}),
                                                                    s.outName
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, j))
                                    }) : /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "ml__empty",
                                        children: "\u2014"
                                    })
                                ]
                            }, i))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "ml__legend",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                        className: "ml__lg",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("i", {
                                className: "ml__lg-cap",
                                "aria-hidden": "true"
                            }),
                            " Captain"
                        ]
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                        className: "ml__lg",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("i", {
                                className: "ml__lg-card",
                                "aria-hidden": "true"
                            }),
                            " Card"
                        ]
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                        className: "ml__lg",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("i", {
                                className: "ml__lg-goal",
                                "aria-hidden": "true"
                            }),
                            " Goal"
                        ]
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                        className: "ml__lg",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("i", {
                                className: "ml__lg-off",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0, $lBpE3.jsx)($7c7ef8b1fa9bd4ec$var$Arrow, {})
                            }),
                            " Off"
                        ]
                    })
                ]
            })
        ]
    });
};
var $7c7ef8b1fa9bd4ec$export$2e2bcd8739ae039 = $7c7ef8b1fa9bd4ec$var$MatchLineup;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");
const $750e929a83d3dd03$var$TvSchedule = ({ data: data })=>{
    const isCountryGrouped = data && typeof data === "object" && !Array.isArray(data);
    const hasData = isCountryGrouped ? Object.keys(data).length > 0 : data?.length > 0;
    const countries = (0, $6cds3.useMemo)(()=>{
        return isCountryGrouped ? Object.keys(data).sort() : [];
    }, [
        data,
        isCountryGrouped
    ]);
    const [selectedCountry, setSelectedCountry] = (0, $6cds3.useState)("");
    (0, $6cds3.useEffect)(()=>{
        if (countries.length > 0 && !selectedCountry) setSelectedCountry(countries[0]);
    }, [
        countries,
        selectedCountry
    ]);
    const getChannelsForCountry = ()=>{
        if (!selectedCountry) return [];
        return data[selectedCountry] || [];
    };
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "tv_block",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "leg_head",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                        children: "TV Schedule"
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "country_dropdown",
                        style: {
                            marginBottom: "20px",
                            padding: "10px"
                        },
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("select", {
                            id: "country-select",
                            value: selectedCountry,
                            onChange: (e)=>setSelectedCountry(e.target.value),
                            style: {
                                padding: "8px 12px",
                                fontSize: "14px",
                                borderRadius: "4px",
                                border: "1px solid #ccc",
                                minWidth: "200px"
                            },
                            children: countries?.map((country)=>/*#__PURE__*/ (0, $lBpE3.jsx)("option", {
                                    value: country,
                                    children: country
                                }, country))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "global_table striped tv_tbl",
                children: isCountryGrouped ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
                    children: selectedCountry ? /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "country_schedule",
                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                children: "Channel"
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                children: "Air Time"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                                    children: getChannelsForCountry().length > 0 ? getChannelsForCountry().map((channel, index)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                    children: channel?.channel_name
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                    children: channel?.onair_time ? new Date(channel.onair_time).toLocaleString() : ""
                                                })
                                            ]
                                        }, `${selectedCountry}-${index}`)) : /*#__PURE__*/ (0, $lBpE3.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            colSpan: "2",
                                            children: "No channels available"
                                        })
                                    })
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        style: {
                            padding: "20px",
                            textAlign: "center",
                            color: "#666"
                        },
                        children: "Please select a country to view TV channels"
                    })
                }) : // Render flat array data (backward compatibility)
                /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "Channel"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "Air Time"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                            children: hasData ? data.map((item, index)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            children: item?.channel?.name || item?.channel_name
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            children: item?.onair_time ? new Date(item.onair_time).toLocaleString() : ""
                                        })
                                    ]
                                }, index)) : /*#__PURE__*/ (0, $lBpE3.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                    colSpan: "2",
                                    children: "No schedule available"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $750e929a83d3dd03$export$2e2bcd8739ae039 = $750e929a83d3dd03$var$TvSchedule;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");
const $03eb0d2265e0978f$var$MatchVenue = ({ venue: venue })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "matchVenue_block",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "leg_head",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                    children: "Match Venue"
                })
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "global_table matchVenue_tbl",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("table", {
                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tbody", {
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: "Venue Name:"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: venue?.name ?? "NY"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: "Capacity:"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: venue?.capacity ?? "NY"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $03eb0d2265e0978f$export$2e2bcd8739ae039 = $03eb0d2265e0978f$var$MatchVenue;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");


var $ba5nK = parcelRequire("ba5nK");
const $0b351ec97f838065$var$EventTable = ({ data: data })=>{
    const displayCard = (type)=>{
        const typeClasses = {
            "Yellow card": "card-yellow",
            "Red card": "card-red",
            "Second yellow card": "card-yellowred",
            Penalty: "penalty",
            Goal: "footbal-ico",
            "Own goal": "ongoal",
            "Disallowed goal": "var"
        };
        if (type === "HT" || type === "FT") return null;
        const cardClass = type === "Sub" ? "updown-arrow" : typeClasses[type] || "";
        return /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
            className: type === "Goal" ? "football-bg" : "",
            children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                src: `/assets/images/svg/${cardClass}.svg`,
                width: 12,
                height: 12,
                alt: type
            })
        });
    };
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "summary_table_wrp",
        children: data?.length ? /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
            className: "global_table summary_table",
            children: /*#__PURE__*/ (0, $lBpE3.jsx)("table", {
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                    children: data?.map((event, index)=>{
                        const isHalfTimeOrFullTime = event?.typ === "HT" || event?.typ === "FT";
                        return /*#__PURE__*/ (0, $lBpE3.jsx)("tr", {
                            children: isHalfTimeOrFullTime ? /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                            className: "brand_color",
                                            children: event?.typ
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {}),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                            className: "badge",
                                            children: event?.sc
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {})
                                ]
                            }) : /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                            className: "brand_color",
                                            children: `${event?.mins}'`
                                        })
                                    }),
                                    event?.isH === 0 || event?.isH === false ? /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {}),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: event?.sc && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    className: "badge",
                                                    children: event?.sc
                                                })
                                            })
                                        ]
                                    }) : null,
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                            className: "teams_wrap",
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                                    className: "teams-name",
                                                    children: [
                                                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                            className: "team_name",
                                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                className: "active",
                                                                children: event?.pl_nm || event?.pl_in_nm
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                            className: "team_name",
                                                            children: event?.pl_out_nm || event?.asst
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                    className: "teams-logo",
                                                    children: event?.typ && displayCard(event.typ)
                                                })
                                            ]
                                        })
                                    }),
                                    event?.isH !== 0 && event?.isH !== false ? /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {}),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {})
                                        ]
                                    }) : null
                                ]
                            })
                        }, `${event?.mins}-${index}`);
                    })
                })
            })
        }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {})
    });
};
var $0b351ec97f838065$export$2e2bcd8739ae039 = $0b351ec97f838065$var$EventTable;



var $2bSDe = parcelRequire("2bSDe");
const $254daca3f12a10f3$var$InfoTable = ({ data: data, loadCSS: loadCSS, dataClient: dataClient, matchDetail: matchDetail, title: title })=>{
    const [tvScheduleData, setTvScheduleData] = (0, $6cds3.useState)(null);
    const [venueData, setVenueData] = (0, $6cds3.useState)(null);
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document.querySelector(".microservice-cont");
        if (!container) return;
        const raw = container.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw);
            setTvScheduleData(parsed?.data || {});
            setVenueData(parsed?.headData?.data || {});
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("matchinfo");
    }, [
        loadCSS
    ]);
    const tvDataToShow = dataClient ? tvScheduleData?.tv_schedule : data?.tv_schedule;
    const venueToShow = dataClient ? venueData?.venue : matchDetail?.data?.venue;
    const summaryData = dataClient ? tvScheduleData?.summary?.timeline : data?.timeline;
    const hasTvSchedule = tvDataToShow && Object.keys(tvDataToShow)?.length > 0;
    // const shouldShowEventTable =
    //   matchStatus === typesMatchStatus?.finished ||
    //   matchStatus === typesMatchStatus?.finishedAET;
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            summaryData?.length ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0b351ec97f838065$export$2e2bcd8739ae039), {
                data: summaryData || []
            }) : null,
            hasTvSchedule ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $750e929a83d3dd03$export$2e2bcd8739ae039), {
                data: tvDataToShow || []
            }) : null,
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $03eb0d2265e0978f$export$2e2bcd8739ae039), {
                venue: venueToShow || {}
            })
        ]
    });
};
var $254daca3f12a10f3$export$2e2bcd8739ae039 = $254daca3f12a10f3$var$InfoTable;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");


var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");


var $ba5nK = parcelRequire("ba5nK");

var $R8nvx = parcelRequire("R8nvx");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $ba5nK = parcelRequire("ba5nK");
const $1fd09c44b9f586c6$var$SocialPost = ({ commentaryData: commentaryData, isZeroTime: isZeroTime, timeOnly: timeOnly })=>{
    const { min: min, pmin: pmin, apim: apim, an: an, au: au, com: com, m_im: m_im } = commentaryData || {};
    const hasMedia = m_im && m_im !== "NULL" && m_im.trim() !== "";
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "social_comm",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "social_comm_hd",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "cmntr_time",
                        children: isZeroTime ? timeOnly : /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                            children: [
                                min,
                                pmin ? `+${pmin}` : "",
                                "'"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "comm_hd_dis",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                className: "com_team_nam",
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                        className: "flag",
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("img", {
                                            src: apim,
                                            width: 18,
                                            height: 18,
                                            alt: `${an}'s avatar`
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                        className: "nm_desc",
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                className: "nam",
                                                children: an
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                className: "nam_aut",
                                                children: [
                                                    "@",
                                                    au
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "cmntr_icon_text",
                                dangerouslySetInnerHTML: {
                                    __html: com
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "social_ico",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("i", {
                            className: "ico_twitter-x",
                            "aria-hidden": "true"
                        })
                    })
                ]
            }),
            hasMedia && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "social_comm_img",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                    src: m_im,
                    fill: true,
                    alt: "Social post media"
                })
            })
        ]
    });
};
var $1fd09c44b9f586c6$export$2e2bcd8739ae039 = $1fd09c44b9f586c6$var$SocialPost;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");
const $29485e07ae9510d5$var$NormalPost = ({ commentaryData: commentaryData, timeOnly: timeOnly, displayCard: displayCard })=>{
    const isZeroTime = (!commentaryData?.min || commentaryData?.min === 0) && (!commentaryData?.pmin || commentaryData?.pmin === 0);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "normal_comm",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                className: "cmntr_time",
                children: isZeroTime ? timeOnly : /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                    children: [
                        commentaryData?.min,
                        commentaryData?.pmin ? `+${commentaryData?.pmin}` : "",
                        "'"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                className: "cmntr_icon",
                children: [
                    "card",
                    "sub",
                    "goal"
                ].includes(commentaryData?.type) && displayCard(commentaryData?.com, commentaryData?.type)
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                className: "cmntr_icon_text",
                dangerouslySetInnerHTML: {
                    __html: commentaryData?.com
                }
            })
        ]
    });
};
var $29485e07ae9510d5$export$2e2bcd8739ae039 = $29485e07ae9510d5$var$NormalPost;


const $a3c93b9d86bd3850$var$Commentary = ({ data: data, id: id, title: title, baseUrl: baseUrl })=>{
    const [extraItems, setExtraItems] = (0, $6cds3.useState)([]);
    const [extraMeta, setExtraMeta] = (0, $6cds3.useState)(null);
    const [pageCount, setPageCount] = (0, $6cds3.useState)(1);
    const [loading, setLoading] = (0, $6cds3.useState)(false);
    const [matchDetail, setMatchDetail] = (0, $6cds3.useState)(null);
    // Derive the full commentary by merging prop data with incrementally loaded items
    const commentary = extraMeta ? {
        data: [
            ...data?.data || [],
            ...extraItems
        ],
        metadata: extraMeta
    } : data;
    (0, $6cds3.useEffect)(()=>{
        const fetchMatchDetail = async ()=>{
            try {
                const res = await fetch(`${baseUrl}/football/match/${id}/detail`, {
                    headers: {
                        Token: undefined
                    }
                });
                if (!res.ok) throw new Error(res?.statusText);
                const json = await res?.json();
                setMatchDetail(json);
            } catch (err) {
                console.error("Failed to load match detail:", err);
            }
        };
        if (id && baseUrl) fetchMatchDetail();
    }, [
        id,
        baseUrl
    ]);
    const handleLoadMore = async ()=>{
        const nextPage = pageCount + 1;
        setLoading(true);
        try {
            const res = await fetch(`${baseUrl}/football/match/${id}/commentary?page=${nextPage}`, {
                headers: {
                    Token: undefined
                }
            });
            if (!res.ok) throw new Error(res?.statusText);
            const json = await res?.json();
            setExtraItems((prev)=>[
                    ...prev,
                    ...json?.data || []
                ]);
            setExtraMeta(json?.metadata);
            setPageCount(nextPage);
        } catch (err) {
            console.error("Failed to load more commentary:", err);
        } finally{
            setLoading(false);
        }
    };
    const displayCard = (commentHtml, type)=>{
        if (type === "sub") return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
            src: `${"https://ipublisher-microservices.6lgx.com"}/public/assets/images/svg/double-arrow.svg`,
            width: 16,
            height: 16,
            alt: "substitution"
        });
        let icon = "";
        if (type === "goal") icon = "footbal-ico";
        if (type === "card") {
            if (commentHtml?.includes("yellow")) icon = "card-yellow";
            if (commentHtml?.includes("red")) icon = "card-red";
        }
        return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
            src: `${"https://ipublisher-microservices.6lgx.com"}/public/assets/images/svg/${icon}.svg`,
            width: 16,
            height: 16,
            alt: type
        });
    };
    const rows = commentary?.data || [];
    const finishTime = matchDetail?.data?.f_time;
    const timeOnly = finishTime?.split(" ")[1]?.slice(0, 5) || finishTime;
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            rows?.length ? /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "commentary_wrp",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                    className: "commentary_lst",
                    children: rows.map((c)=>/*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                            children: c?.type === (0, $R8nvx.postType)?.twitter ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $1fd09c44b9f586c6$export$2e2bcd8739ae039), {
                                commentaryData: c,
                                timeOnly: timeOnly
                            }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $29485e07ae9510d5$export$2e2bcd8739ae039), {
                                commentaryData: c,
                                timeOnly: timeOnly,
                                displayCard: displayCard
                            })
                        }, c.id))
                })
            }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {}),
            commentary?.metadata?.pagination?.last_page > pageCount && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "text_center",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                    className: "button button_primary",
                    onClick: ()=>handleLoadMore(),
                    disabled: loading,
                    children: loading ? "Loading..." : "See More"
                })
            })
        ]
    });
};
var $a3c93b9d86bd3850$export$2e2bcd8739ae039 = $a3c93b9d86bd3850$var$Commentary;



var $2bSDe = parcelRequire("2bSDe");
const $5037a3f4b7bc44bc$var$SummaryTable = ({ data: data, commData: commData, id: id, loadCSS: loadCSS, dataClient: dataClient, title: title, baseUrl: baseUrl })=>{
    const [activeTab, setActiveTab] = (0, $6cds3.useState)("events");
    const [timelineData, setTimelineData] = (0, $6cds3.useState)([]);
    const [commentaryData, setCommentaryData] = (0, $6cds3.useState)([]);
    (0, $6cds3.useEffect)(()=>{
        if (dataClient) {
            const container = document.querySelector(".microservice-cont");
            const dataAttr = container?.getAttribute("data-listingdata");
            if (dataAttr) try {
                const parsed = JSON.parse(dataAttr);
                setTimelineData(parsed?.data?.summary?.timeline || []);
                setCommentaryData(parsed?.otherData || []);
            } catch (e) {
                console.error("Failed to parse data-listingdata:", e);
            }
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("matchsummary");
    }, [
        loadCSS
    ]);
    const renderContent = ()=>{
        if (activeTab === "events") return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0b351ec97f838065$export$2e2bcd8739ae039), {
            data: dataClient ? timelineData : data?.timeline || []
        });
        else return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $a3c93b9d86bd3850$export$2e2bcd8739ae039), {
            data: dataClient ? commentaryData : commData || [],
            id: id,
            baseUrl: baseUrl
        });
    };
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("nav", {
                className: "inner_tab",
                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                            className: activeTab === "events" ? "active" : "",
                            onClick: ()=>setActiveTab("events"),
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                children: "Events"
                            })
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                            className: activeTab === "com" ? "active" : "",
                            onClick: ()=>setActiveTab("com"),
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                children: "Commentary"
                            })
                        })
                    ]
                })
            }),
            renderContent()
        ]
    });
};
var $5037a3f4b7bc44bc$export$2e2bcd8739ae039 = $5037a3f4b7bc44bc$var$SummaryTable;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $ba5nK = parcelRequire("ba5nK");

var $3G7m1 = parcelRequire("3G7m1");

var $kybuc = parcelRequire("kybuc");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $kybuc = parcelRequire("kybuc");
const $62bf3e42edf85da2$var$MatchDateTime = ({ match: match, sport: sport = "football", difference: difference })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
            className: `${sport === "basketball" || sport === "tennis" || sport === "cricket" || sport === 'icehockey' ? "time" : "status"}`,
            children: difference ? (0, $kybuc.DateUtility)?.ConvertCETtoCurrentTimeZone(match?.dt || match?.gdt, difference) : (0, $kybuc.DateUtility)?.FormatTime(match?.dt || match?.gdt)
        })
    });
};
var $62bf3e42edf85da2$export$2e2bcd8739ae039 = $62bf3e42edf85da2$var$MatchDateTime;


/* eslint-disable react-hooks/exhaustive-deps */ 
var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $3G7m1 = parcelRequire("3G7m1");
const $3880a40d7a28dcf1$var$MatchMinutes = ({ match: match, cssclass: cssclass })=>{
    const removeCh = [
        "45+",
        "HT",
        "90+",
        "105+",
        "120+"
    ];
    const [currentMint, setCurrentMint] = (0, $6cds3.useState)(()=>(0, $3G7m1.MinutesCalculate)(match?.sun, match?.sut, match?.im, match?.mins, match?.id));
    const [showTick, setShowTick] = (0, $6cds3.useState)(true);
    (0, $6cds3.useEffect)(()=>{
        setCurrentMint((0, $3G7m1.MinutesCalculate)(match?.sun, match?.sut, match?.im, match?.mins, match?.id));
        if (match?.sun?.toLowerCase() === "finished") return;
        const intervalId = setInterval(()=>{
            const next = (0, $3G7m1.MinutesCalculate)(match?.sun, match?.sut, match?.im, match?.mins, match?.id);
            setCurrentMint(next);
            if (next === "FT") clearInterval(intervalId);
        }, 1000);
        return ()=>clearInterval(intervalId);
    }, [
        match
    ]);
    (0, $6cds3.useEffect)(()=>{
        const blinkId = setInterval(()=>{
            setShowTick((prev)=>!prev);
        }, 1000);
        return ()=>clearInterval(blinkId);
    }, []);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
        className: cssclass,
        children: [
            currentMint,
            currentMint && !removeCh.includes(currentMint) && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                style: {
                    visibility: showTick ? "visible" : "hidden"
                },
                children: "\u2018"
            })
        ]
    });
};
var $3880a40d7a28dcf1$export$2e2bcd8739ae039 = $3880a40d7a28dcf1$var$MatchMinutes;



var $XBIJN = parcelRequire("XBIJN");

var $6cds3 = parcelRequire("6cds3");

var $gtwOm = parcelRequire("gtwOm");
const $71a398d188e2be3b$export$69d32079ada77858 = ({ socketUrl: socketUrl, channel: channel, event: event, sport: sport, setMatch: setMatch })=>{
    const socket = (0, $gtwOm.useSocket)(socketUrl);
    (0, $6cds3.useEffect)(()=>{
        if (!socket) return;
        const handleSocketEvent = (e)=>{
            console.log(e?.data, 'socket Data');
            setMatch(sport === "cricket" || sport === "football" ? e?.data?.data : e?.data);
        };
        socket?.channel(channel)?.listen(event, handleSocketEvent);
        return ()=>socket?.connector?.socket?.disconnect();
    }, [
        socket,
        channel,
        event,
        sport,
        setMatch
    ]);
    return socket;
};


const $9ea65155ea9457d3$var$MatchDetailHead = ({ data: data, sport: sport = "football", difference: difference, referee: referee, venue: venue, form: form, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataClient: dataClient, socketUrl: socketUrl, channel: channel, event: event, baseUrl: baseUrl })=>{
    const scores = [];
    const [match, setMatch] = (0, $6cds3.useState)(data);
    const matchStatus = (0, $3G7m1.GetTennisMatchStatus)(match?.st, match?.cp, match);
    const live = (0, $XBIJN.MatchOptions)?.basketballLiveStatuses?.includes(match?.st);
    const scoreType = [
        "1st set",
        "2nd set",
        "3rd set",
        "4th set",
        "5th set"
    ].includes(matchStatus) ? "cfs" : "finished";
    const score = match?.scores?.find((t)=>(0, $3G7m1.ToLowerText)(t?.ty) === scoreType);
    const hscore = score?.nm?.split(":")?.[0]?.trim();
    const ascore = score?.nm?.split(":")?.[1]?.trim();
    const matchScore = (0, $3G7m1.GetMatchScores)(match?.scores, matchStatus);
    const imageUrl = (0, $3G7m1.getImageUrl)("", "", sport, match?.competitors?.[sport === "tennis" ? "hpid" : "htid"]);
    const awayImage = (0, $3G7m1.getImageUrl)("", "", sport, match?.competitors?.[sport === "tennis" ? "apid" : "atid"]);
    if (sport === "basketball" || sport === "icehockey") for(let i = 1; i <= 4; i++)scores.push((0, $3G7m1.extractScores)(match, i));
    const baseURL = "https://ipublisher-microservices.6lgx.com" ?? "https://ipublisher-microservices.6lgx.com";
    (0, $71a398d188e2be3b$export$69d32079ada77858)({
        socketUrl: socketUrl,
        channel: channel,
        event: event,
        sport: sport,
        setMatch: setMatch
    });
    (0, $6cds3.useEffect)(()=>{
        setMatch(data);
    }, [
        data
    ]);
    // Check if sport is basketball-like (basketball, rugby, rugby-union, icehockey)
    const isBasketballLike = sport === "basketball" || sport === "rugby" || sport === "rugby-union" || sport === "icehockey";
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "detail_head_main",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "top_bar",
                children: [
                    isBasketballLike && match?.st !== "NSY" ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: `${match?.st === "Live" ? "stats_tag red" : "stats_tag"}`,
                        children: match?.st
                    }) : null,
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("h1", {
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "icon_flag",
                                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                    src: `${baseURL}/public/assets/images/flags/country_${match?.tournament?.football_category?.fid || match?.tournament?.fid}.png`,
                                    alt: "flag",
                                    width: 22,
                                    height: 22,
                                    priority: false
                                })
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                                href: (0, $3G7m1.teamLeagueInfoUrl)({
                                    dataClient: dataClient,
                                    websiteBaseUrl: websiteBaseUrl,
                                    dataPath: dataPath,
                                    category: "league",
                                    sport: sport,
                                    name: match?.tournament?.nm,
                                    id: match?.tournament?.id
                                }),
                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                    className: "name",
                                    children: match?.tournament?.nm
                                })
                            })
                        ]
                    })
                ]
            }),
            isBasketballLike ? /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "b_detail_head_body",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "b_row_wrp",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: "b_dtl_row",
                                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                    className: "b_body_rgt",
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                            className: "team",
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                    className: "logo_img",
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                        src: imageUrl,
                                                        height: 44,
                                                        width: 44,
                                                        alt: "homeLogo",
                                                        priority: false
                                                    }, match?.competitors?.htid)
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                    className: "name",
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                                                        className: `team_logo_name ${Number(match?.ft?.split("-")?.[0]) > Number(match?.ft?.split("-")?.[1]) ? "bold" : ""}`,
                                                        href: (0, $3G7m1.teamLeagueInfoUrl)({
                                                            dataClient: dataClient,
                                                            websiteBaseUrl: websiteBaseUrl,
                                                            dataPath: dataPath,
                                                            category: sport === "tennis" ? "player" : "team",
                                                            sport: sport,
                                                            name: match?.competitors?.htn,
                                                            id: match?.competitors?.htid
                                                        }),
                                                        children: match?.competitors?.htn
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsxs)("ul", {
                                            className: "b_result_inf",
                                            children: [
                                                match?.competitors?.htf && /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                                                        className: "result_list",
                                                        children: match?.competitors?.htf.map((item, index)=>/*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                                                className: item === "L" ? "clr_red" : item === "W" ? "clr_green" : "",
                                                                children: item
                                                            }, index))
                                                    })
                                                }),
                                                match?.st !== "NSY" ? /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                                                        className: "result_list",
                                                        children: (0, $3G7m1.renderScores)(sport, scores, matchScore, true)
                                                    })
                                                }) : null
                                            ]
                                        }),
                                        match?.st !== "NSY" ? /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                            className: `b_body_score ${Number(match?.ft?.split("-")?.[0]) > Number(match?.ft?.split("-")?.[1]) ? "bold" : ""}`,
                                            children: match?.ft?.split("-")?.[0]
                                        }) : null
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: "b_dtl_row",
                                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                    className: "b_body_rgt",
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                            className: "team",
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                    className: "logo_img",
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                        src: awayImage,
                                                        height: 44,
                                                        width: 44,
                                                        alt: "awayLogo",
                                                        priority: false
                                                    }, match?.competitors?.atid)
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                    className: "name",
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                                                        className: `team_logo_name ${Number(match?.ft?.split("-")?.[0]) < Number(match?.ft?.split("-")?.[1]) ? "bold" : ""}`,
                                                        href: (0, $3G7m1.teamLeagueInfoUrl)({
                                                            dataClient: dataClient,
                                                            websiteBaseUrl: websiteBaseUrl,
                                                            dataPath: dataPath,
                                                            category: sport === "tennis" ? "player" : "team",
                                                            sport: sport,
                                                            name: match?.competitors?.atn,
                                                            id: match?.competitors?.atid
                                                        }),
                                                        children: match?.competitors?.atn
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsxs)("ul", {
                                            className: "b_result_inf",
                                            children: [
                                                match?.competitors?.atf && /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                                                        className: "result_list",
                                                        children: match?.competitors?.atf.map((item, index)=>/*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                                                className: item === "L" ? "clr_red" : item === "W" ? "clr_green" : "",
                                                                children: item
                                                            }, index))
                                                    })
                                                }),
                                                match?.st !== "NSY" ? /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                                                        className: "result_list",
                                                        children: (0, $3G7m1.renderScores)(sport, scores, matchScore, false)
                                                    })
                                                }) : null
                                            ]
                                        }),
                                        match?.st !== "NSY" ? /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                            className: `b_body_score ${Number(match?.ft?.split("-")?.[0]) < Number(match?.ft?.split("-")?.[1]) ? "bold" : ""}`,
                                            children: match?.ft?.split("-")?.[1]
                                        }) : null
                                    ]
                                })
                            })
                        ]
                    }),
                    match?.st === "NSY" ? /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "remaining_time",
                        children: (0, $3G7m1.getRemainingTimeInHoursMinutes)(match?.dt)
                    }) : null
                ]
            }) : /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "detail_head_body",
                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                    className: `body_top ${sport === "tennis" ? "tennis_body_top" : ""}`,
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                            className: "body_top_col",
                            children: [
                                sport !== "tennis" && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                    className: "team_logo",
                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                        src: imageUrl,
                                        height: 44,
                                        width: 44,
                                        alt: "homeLogo",
                                        priority: false
                                    })
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                    className: "player_team_name",
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                                            href: (0, $3G7m1.teamLeagueInfoUrl)({
                                                dataClient: dataClient,
                                                websiteBaseUrl: websiteBaseUrl,
                                                dataPath: dataPath,
                                                category: sport === "tennis" ? "player" : "team",
                                                sport: sport,
                                                name: match?.competitors?.htn,
                                                id: match?.competitors?.htid
                                            }),
                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: `team_logo_name ${match?.win === 1 ? "bold" : ""}`,
                                                children: match?.competitors?.htn
                                            })
                                        }),
                                        sport === "cricket" ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                            className: "cr_team_score",
                                            children: (0, $3G7m1.CricketScore)(match?.hts)
                                        }) : /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                            className: "player_scores",
                                            children: (0, $3G7m1.renderScores)(sport, scores, matchScore, true)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                                    className: "result_list",
                                    children: (sport === "football" ? match?.competitors?.htf : form?.[match?.competitors?.htid])?.slice().reverse().map((item, index)=>/*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                            className: item === "L" ? "clr_red" : item === "W" ? "clr_green" : "",
                                            children: item
                                        }, index))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                            className: "body_top_col timing",
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                    className: "match_list_date_status",
                                    children: [
                                        sport === "cricket" && match?.bs !== "Finished" && /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    className: "status",
                                                    children: match?.bs
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    className: "time",
                                                    children: match?.st
                                                })
                                            ]
                                        }),
                                        sport === "cricket" ? match?.st === "Finished" && /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                            className: "status_wrp",
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    children: match?.com
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    className: "status",
                                                    children: "Finished"
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                                            children: [
                                                match?.st === "Delayed" && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    className: "status",
                                                    children: "Dly"
                                                }),
                                                match?.st === "Interrupted" && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    className: "status",
                                                    children: "Interrupted"
                                                }),
                                                match?.st === "Full Time" && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    className: "status",
                                                    children: "FT"
                                                }),
                                                match?.st === "Finished" && match?.mins === "To Finish" && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    className: "status",
                                                    children: "To FT"
                                                }),
                                                match?.st === "Finished AP" && match?.mins === "FAP" && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    className: "status",
                                                    children: "Fi. AP"
                                                }),
                                                match?.st === "Finished" && match?.mins !== "FAP" && match?.mins !== "FAET" && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    className: "status",
                                                    children: "FT"
                                                }),
                                                match?.st === "Finished" && match?.mins === "FAP" && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    className: "status red",
                                                    children: "FAP"
                                                }),
                                                match?.st === "Finished" && match?.mins === "FAET" && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    className: "status",
                                                    children: "FAET"
                                                }),
                                                match?.st === "Postponed" && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    className: "status",
                                                    children: "PPD"
                                                }),
                                                match?.st === "Abandoned" && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    className: "status",
                                                    children: "AB"
                                                }),
                                                match?.st === "Cancelled" && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    className: "status",
                                                    children: "AB"
                                                }),
                                                match?.st === "TF" && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    className: "status",
                                                    children: "TF"
                                                }),
                                                match?.st === "NSY" && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $62bf3e42edf85da2$export$2e2bcd8739ae039), {
                                                    match: match,
                                                    sport: sport,
                                                    difference: difference
                                                }),
                                                sport === "football" && (0, $XBIJN.MatchOptions).footballLiveStatuses?.some((status)=>status.toLowerCase() === match?.st?.toLowerCase()) ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3880a40d7a28dcf1$export$2e2bcd8739ae039), {
                                                    match: match,
                                                    cssclass: "status"
                                                }) : null
                                            ]
                                        }),
                                        sport === "tennis" && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
                                            children: live && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: "status",
                                                children: (0, $3G7m1.GetTennisMatchStatus)(match?.st, match?.cp, match)
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                    className: "team_score",
                                    children: [
                                        ((0, $XBIJN.MatchOptions).footballLiveStatuses?.some((status)=>status.toLowerCase() === match?.st?.toLowerCase()) || (0, $XBIJN.MatchOptions).basketballLiveStatuses?.some((status)=>status.toLowerCase() === match?.st?.toLowerCase())) && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
                                            children: sport === "tennis" ? /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                        children: matchScore?.gamehome
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                        children: "-"
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                        children: matchScore?.gameaway
                                                    })
                                                ]
                                            }) : sport !== "cricket" && /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                        children: match?.cfs?.split("-")?.[0]
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                        children: "-"
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                        children: match?.cfs?.split("-")?.[1]
                                                    })
                                                ]
                                            })
                                        }),
                                        (0, $XBIJN.MatchOptions).footballFTStatuses?.includes(match?.st) && sport !== "cricket" && sport !== "tennis" && match?.cfs && /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    children: match?.cfs?.split("-")?.[0]
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    children: "-"
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    children: match?.cfs?.split("-")?.[1]
                                                })
                                            ]
                                        }),
                                        (match?.st === "NSY" || match?.st === "Result Only") && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {}),
                                        hscore && !live && /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    children: hscore
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    children: "-"
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    children: ascore
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                sport === "football" && (0, $XBIJN.MatchOptions).footballLiveStatuses?.some((status)=>status.toLowerCase() === match?.st?.toLowerCase()) ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                    children: match?.cp
                                }) : null,
                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                    children: match?.ps ? /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                        children: [
                                            "(",
                                            match.ps,
                                            ")"
                                        ]
                                    }) : null
                                }),
                                (sport === "basketball" || sport === "icehockey") && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
                                    children: ((0, $XBIJN.MatchOptions).footballLiveStatuses?.some((status)=>status.toLowerCase() === match?.st?.toLowerCase()) || (0, $XBIJN.MatchOptions).basketballLiveStatuses?.some((status)=>status.toLowerCase() === match?.st?.toLowerCase())) && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "status",
                                        children: match?.cp
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                            className: "body_top_col reverse",
                            children: [
                                sport !== "tennis" && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                    className: "team_logo heart-r",
                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                        src: awayImage,
                                        height: 44,
                                        width: 44,
                                        alt: "awayLogo",
                                        priority: false
                                    })
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                    className: "player_team_name",
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                                            href: (0, $3G7m1.teamLeagueInfoUrl)({
                                                dataClient: dataClient,
                                                websiteBaseUrl: websiteBaseUrl,
                                                dataPath: dataPath,
                                                category: sport === "tennis" ? "player" : "team",
                                                sport: sport,
                                                name: match?.competitors?.atn,
                                                id: match?.competitors?.atid
                                            }),
                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: `team_logo_name ${match?.win === 2 ? "bold" : ""}`,
                                                children: match?.competitors?.atn
                                            })
                                        }),
                                        sport === "cricket" ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                            className: "cr_team_score",
                                            children: (0, $3G7m1.CricketScore)(match?.ats)
                                        }) : /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                            className: "player_scores",
                                            children: (0, $3G7m1.renderScores)(sport, scores, matchScore, false)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                                    className: "result_list",
                                    children: (sport === "football" ? match?.competitors?.atf : form?.[match?.competitors?.atid])?.slice().reverse().map((item, index)=>/*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                            className: item === "L" ? "clr_red" : item === "W" ? "clr_green" : "",
                                            children: item
                                        }, index))
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "detail_head_btm",
                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("ul", {
                    className: "inf_mch",
                    children: [
                        match?.dt ? /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("i", {
                                    className: "ico ico_calandar02"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                    className: "inf_mch_txt",
                                    children: (0, $kybuc.DateUtility)?.ConvertCETtoCurrentTimeZoneDate ? (0, $kybuc.DateUtility).ConvertCETtoCurrentTimeZoneDate(match?.dt, difference) : (0, $3G7m1.convertDate)(match?.dt)
                                })
                            ]
                        }) : null,
                        venue?.name ? /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("i", {
                                    className: "ico ico_bridge"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                    className: "inf_mch_txt",
                                    children: venue?.name
                                })
                            ]
                        }) : null,
                        referee ? /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("i", {
                                    className: "ico ico_glyph"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                    className: "inf_mch_txt",
                                    children: referee
                                })
                            ]
                        }) : null
                    ]
                })
            })
        ]
    });
};
var $9ea65155ea9457d3$export$2e2bcd8739ae039 = $9ea65155ea9457d3$var$MatchDetailHead;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $3G7m1 = parcelRequire("3G7m1");
const $4b47714d98d2fa0e$var$MatchDetailTabs = ({ tabs: tabs, id: id, sport: sport = "football", dictionary: dictionary, currentTab: currentTab, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, name: name })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsx)("nav", {
        className: "detail_main_tab",
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
            children: tabs?.map((tab)=>{
                const isActive = tab === currentTab || tab === "stats" && currentTab === "season-stats";
                return /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                    type: tab,
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                        className: isActive ? "active" : "",
                        href: (0, $3G7m1.teamLeagueInfoUrl)({
                            dataClient: true,
                            websiteBaseUrl: websiteBaseUrl,
                            dataPath: dataPath,
                            category: "match-detail",
                            sport: sport,
                            name: name,
                            id: id,
                            tab: tab?.replaceAll("_", "-")
                        }),
                        children: tab === "h2h" ? "H2H" : dictionary?.[tab.replaceAll("_", "")] || (0, $3G7m1.capitalized1LetterS)(tab)
                    })
                }, tab);
            })
        })
    });
};
var $4b47714d98d2fa0e$export$2e2bcd8739ae039 = $4b47714d98d2fa0e$var$MatchDetailTabs;



var $3G7m1 = parcelRequire("3G7m1");
const $cc0e4da7c5a2120d$var$Head = ({ matchDetail: matchDetail, difference: difference, sport: sport, setDataId: setDataId, setDataType: setDataType, setHead: setHead, setLeagueId: setLeagueId, dataClient: dataClient, children: children, id: id, currentTab: currentTab, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, title: title, socketUrl: socketUrl, channel: channel, event: event })=>{
    const [clientHeadData, setClientHeadData] = (0, $6cds3.useState)(null);
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document.querySelector(".microservice-cont");
        const dataAttr = container?.getAttribute("data-listingdata");
        if (dataAttr) try {
            const parsed = JSON.parse(dataAttr)?.headData;
            setClientHeadData(parsed);
        } catch (error) {
            console.error("Failed to parse headData:", error);
        }
    }, [
        dataClient
    ]);
    const matchData = dataClient ? clientHeadData?.data : matchDetail?.data;
    const tabsData = dataClient ? clientHeadData?.newtabs || clientHeadData?.tabs : matchDetail?.newtabs;
    const referee = matchData?.match_official?.official?.name;
    const venue = matchData?.venue;
    const form = dataClient ? clientHeadData?.lfm : matchDetail?.lfm;
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "detail_page",
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "detail_head",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)((0, $9ea65155ea9457d3$export$2e2bcd8739ae039), {
                        sport: sport,
                        data: matchData,
                        difference: difference,
                        referee: referee,
                        venue: venue,
                        setDataId: setDataId,
                        setDataType: setDataType,
                        setHead: setHead,
                        setLeagueId: setLeagueId,
                        websiteBaseUrl: websiteBaseUrl,
                        dataPath: dataPath,
                        dataClient: dataClient,
                        form: sport === "tennis" && form,
                        socketUrl: socketUrl,
                        channel: channel,
                        event: event
                    }),
                    dataClient && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $4b47714d98d2fa0e$export$2e2bcd8739ae039), {
                        tabs: (0, $3G7m1.processMyArr)(tabsData) || [],
                        id: id,
                        currentTab: currentTab,
                        websiteBaseUrl: websiteBaseUrl,
                        dataPath: dataPath,
                        name: `${(0, $3G7m1.linkName)(matchData?.competitors?.htn)}-vs-${(0, $3G7m1.linkName)(matchData?.competitors?.atn)}`,
                        sport: sport
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "detail_page_tabs",
                children: children
            })
        ]
    });
};
var $cc0e4da7c5a2120d$export$2e2bcd8739ae039 = $cc0e4da7c5a2120d$var$Head;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");


var $2bSDe = parcelRequire("2bSDe");
const $15e40c9cf1b1f405$var$CommentaryWrap = ({ data: data, id: id, loadCSS: loadCSS, dataClient: dataClient, baseUrl: baseUrl, title: title })=>{
    const [commentaryData, setCommentaryData] = (0, $6cds3.useState)([]);
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document.querySelector(".microservice-cont");
        const dataAttr = container?.getAttribute("data-listingdata");
        if (dataAttr) try {
            const parsed = JSON.parse(dataAttr);
            setCommentaryData(parsed?.data || []);
        } catch (e) {
            console.error("Failed to parse data-listingdata:", e);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("matchtable");
    }, [
        loadCSS
    ]);
    const commentary = dataClient ? commentaryData : data || [];
    return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $a3c93b9d86bd3850$export$2e2bcd8739ae039), {
        data: commentary,
        id: id,
        baseUrl: baseUrl,
        title: title
    });
};
var $15e40c9cf1b1f405$export$2e2bcd8739ae039 = $15e40c9cf1b1f405$var$CommentaryWrap;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");


var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $ba5nK = parcelRequire("ba5nK");

var $3G7m1 = parcelRequire("3G7m1");
parcelRequire("6cds3");
const $2d22661aa7fb4cf1$export$f4b2b660571c63c7 = (url, size = 700)=>{
    if (!url) return "";
    else if (!size || size !== null) return url.replace("/land/700/", `/land/${size}/`);
    else return url;
};
const $2d22661aa7fb4cf1$export$a964851a84ddc42f = (setting)=>{
    return `
:root {

--radius-light: ${setting?.data?.light_mode_styles?.theme?.radius?.value};
--box_shadow-light: ${setting?.data?.light_mode_styles?.theme?.box_shadow?.value};
--section_box_shadow-light: ${setting?.data?.light_mode_styles?.theme?.section_box_shadow?.value};

--body_text-light: ${setting?.data?.light_mode_styles?.body?.body_text?.value};
--body_bg_color-light: ${setting?.data?.light_mode_styles?.body?.body_color?.value};
--icons_color-light: ${setting?.data?.light_mode_styles?.body?.icons_color?.value};
--divider_color-light: ${setting?.data?.light_mode_styles?.body?.divider_color?.value};
--button_text-light: ${setting?.data?.light_mode_styles?.body?.button_text?.value};
--button_bg-light: ${setting?.data?.light_mode_styles?.body?.button_background?.value};
--button_text_hover-light: ${setting?.data?.light_mode_styles?.body?.button_text_hover?.value};
--button_background_hover-light: ${setting?.data?.light_mode_styles?.body?.button_background_hover?.value};
--even_row_bg-light: ${setting?.data?.light_mode_styles?.body?.even_row_background?.value};
 
--footer_text-light: ${setting?.data?.light_mode_styles?.footer?.footer_text?.value};
--footer_icons-light: ${setting?.data?.light_mode_styles?.footer?.footer_icons?.value};
--footer_divider-light: ${setting?.data?.light_mode_styles?.footer?.footer_divider?.value};
--footer_bg-light: ${setting?.data?.light_mode_styles?.footer?.footer_background?.value};
--footer_icon_active-light: ${setting?.data?.light_mode_styles?.footer?.footer_icon_active?.value};
--footer_logo_bg-light: ${setting?.data?.light_mode_styles?.footer?.footer_logo_background?.value};
 
--header_text-light: ${setting?.data?.light_mode_styles?.header?.header_text?.value};
--header_icons-light: ${setting?.data?.light_mode_styles?.header?.header_icons?.value};
--header_active-light: ${setting?.data?.light_mode_styles?.header?.header_active?.value};
--header_logo_bg-light: ${setting?.data?.light_mode_styles?.header?.header_logo_background?.value};
--header_bg_color-light: ${setting?.data?.light_mode_styles?.header?.header_background?.value};
--header_button_text-light: ${setting?.data?.light_mode_styles?.header?.header_button_text_icon?.value};
--header_button_bg-light: ${setting?.data?.light_mode_styles?.header?.header_button_background?.value};
--header_dropdown_text-light: ${setting?.data?.light_mode_styles?.header?.header_dropdown_text_icon?.value};
--header_dropdown_bg-light: ${setting?.data?.light_mode_styles?.header?.header_dropdown_background?.value};
--sub_header_bg_color-light: ${setting?.data?.light_mode_styles?.header?.sub_header_background?.value};
--sub_header_text-light: ${setting?.data?.light_mode_styles?.header?.sub_header_text?.value};
--sub_header_text_active-light: ${setting?.data?.light_mode_styles?.header?.sub_header_text_active?.value};
 
--section_icon-light: ${setting?.data?.light_mode_styles?.section?.section_icon?.value};
--section_text-light: ${setting?.data?.light_mode_styles?.section?.section_text?.value};
--section_border-light: ${setting?.data?.light_mode_styles?.section?.section_border?.value};
--section_dropshadow-light: ${setting?.data?.light_mode_styles?.section?.section_dropshadow?.value};
--section_text_2-light: ${setting?.data?.light_mode_styles?.section?.section_text_2?.value};
--section_divider-light: ${setting?.data?.light_mode_styles?.section?.section_divider?.value};
--section_bg-light: ${setting?.data?.light_mode_styles?.section?.section_background?.value};
--section_button_text-light: ${setting?.data?.light_mode_styles?.section?.section_button_text?.value};
--section_icon_active-light: ${setting?.data?.light_mode_styles?.section?.section_icon_active?.value};
--section_heading_text-light: ${setting?.data?.light_mode_styles?.section?.section_heading_text?.value};
--section_heading_text2-light: ${setting?.data?.light_mode_styles?.section?.section_heading_text2?.value};
--section_team_1_color-light: ${setting?.data?.light_mode_styles?.section?.section_team_1_color?.value};
--section_team_2_color-light: ${setting?.data?.light_mode_styles?.section?.section_team_2_color?.value};
--section_row_highlight-light: ${setting?.data?.light_mode_styles?.section?.section_row_highlight?.value};
--section_button_bg-light: ${setting?.data?.light_mode_styles?.section?.section_button_background?.value};
--section_button_text_hover-light: ${setting?.data?.light_mode_styles?.section?.section_button_text_hover?.value};
--section_search_bg-light: ${setting?.data?.light_mode_styles?.section?.section_search_background?.value};
--section_odd_row_bg-light: ${setting?.data?.light_mode_styles?.section?.section_even_row_background?.value};
--section_button_bg_hover-light: ${setting?.data?.light_mode_styles?.section?.section_button_background_hover?.value};

--heading_text-light: ${setting?.data?.light_mode_styles?.headings?.heading_text?.value};
--sub_heading_text-light: ${setting?.data?.light_mode_styles?.headings?.sub_heading_text?.value};
 
--links-light: ${setting?.data?.light_mode_styles?.tags_links?.links?.value};
--ft_text-light: ${setting?.data?.light_mode_styles?.tags_links?.ft_text?.value};
--tag_text-light: ${setting?.data?.light_mode_styles?.tags_links?.tag_text?.value};
--link_hover-light: ${setting?.data?.light_mode_styles?.tags_links?.link_hover?.value};
--ft_bg-light: ${setting?.data?.light_mode_styles?.tags_links?.ft_background?.value};
--tag_bg-light: ${setting?.data?.light_mode_styles?.tags_links?.tag_background?.value};
 
--red_card-light: #D5364E;
--win_button-light: ${setting?.data?.light_mode_styles?.live_center?.win_button_color?.value};
--draw_button-light: ${setting?.data?.light_mode_styles?.live_center?.draw_button?.value};
--live_button-light: ${setting?.data?.light_mode_styles?.live_center?.live_button_color?.value};
--loss_button-light: ${setting?.data?.light_mode_styles?.live_center?.loss_button?.value};
--yellow_card-light: #FFCE00;
--win_button_text-light: ${setting?.data?.light_mode_styles?.live_center?.win_button_text?.value};
--draw_button_text-light: ${setting?.data?.light_mode_styles?.live_center?.draw_button_text?.value};
--live_button_text-light: ${setting?.data?.light_mode_styles?.live_center?.live_button_text?.value};
--loss_button_text-light: ${setting?.data?.light_mode_styles?.live_center?.loss_button_text?.value};
--postponed_button-light: ${setting?.data?.light_mode_styles?.live_center?.postponed_button?.value};
--postponed_button_text-light: ${setting?.data?.light_mode_styles?.live_center?.postponed_button_text?.value};
--match_detail_head_icon-light: ${setting?.data?.light_mode_styles?.live_center?.match_detail_head_icon?.value};
--match_detail_head_text-light: ${setting?.data?.light_mode_styles?.live_center?.match_detail_head_text?.value};
--match_detail_head_text2-light: ${setting?.data?.light_mode_styles?.live_center?.match_detail_head_text2?.value};
--live_center_brand_color-light: ${setting?.data?.light_mode_styles?.live_center?.live_center_brand_color?.value};
--score_ball_by_ball_text-light: ${setting?.data?.light_mode_styles?.live_center?.score_ball_by_ball_text?.value};
--match_detail_head_divider-light: ${setting?.data?.light_mode_styles?.live_center?.match_detail_head_divider?.value};
--match_detail_head_bg-light: ${setting?.data?.light_mode_styles?.live_center?.match_detail_head_background?.value};
--match_detail_head_icon_active-light: ${setting?.data?.light_mode_styles?.live_center?.match_detail_head_icon_active?.value};
--score_ball_by_ball_4th_bg-light: ${setting?.data?.light_mode_styles?.live_center?.score_ball_by_ball_4th_background?.value};
--score_ball_by_ball_6th_bg-light: ${setting?.data?.light_mode_styles?.live_center?.score_ball_by_ball_6th_background?.value};
--match_detail_head_score_bg-light: ${setting?.data?.light_mode_styles?.live_center?.match_detail_head_score_background?.value};
--score_ball_by_ball_score_bg-light: ${setting?.data?.light_mode_styles?.live_center?.score_ball_by_ball_score_background?.value};
  


--radius-dark: ${setting?.data?.dark_mode_styles?.theme?.radius?.value};
--box_shadow-dark: ${setting?.data?.dark_mode_styles?.theme?.box_shadow?.value};
--section_box_shadow-dark: ${setting?.data?.dark_mode_styles?.theme?.section_box_shadow?.value};


--body_text-dark: ${setting?.data?.dark_mode_styles?.body?.body_text?.value};
--body_bg_color-dark: ${setting?.data?.dark_mode_styles?.body?.body_color?.value};
--button_text-dark: ${setting?.data?.dark_mode_styles?.body?.button_text?.value};
--icons_color-dark: ${setting?.data?.dark_mode_styles?.body?.icons_color?.value};
--divider_color-dark: ${setting?.data?.dark_mode_styles?.body?.divider_color?.value};
--button_bg-dark: ${setting?.data?.dark_mode_styles?.body?.button_background?.value};
--button_text_hover-dark: ${setting?.data?.dark_mode_styles?.body?.button_text_hover?.value};
--button_background_hover-dark: ${setting?.data?.dark_mode_styles?.body?.button_background_hover?.value};
--even_row_bg-dark: ${setting?.data?.dark_mode_styles?.body?.even_row_background?.value};
 
--footer_text-dark: ${setting?.data?.dark_mode_styles?.footer?.footer_text?.value};
--footer_icons-dark: ${setting?.data?.dark_mode_styles?.footer?.footer_icons?.value};
--footer_divider-dark: ${setting?.data?.dark_mode_styles?.footer?.footer_divider?.value};
--footer_bg-dark: ${setting?.data?.dark_mode_styles?.footer?.footer_background?.value};
--footer_icon_active-dark: ${setting?.data?.dark_mode_styles?.footer?.footer_icon_active?.value};
--footer_logo_bg-dark: ${setting?.data?.dark_mode_styles?.footer?.footer_logo_background?.value};
 
--header_text-dark: ${setting?.data?.dark_mode_styles?.header?.header_text?.value};
--header_icons-dark: ${setting?.data?.dark_mode_styles?.header?.header_icons?.value};
--header_active-dark: ${setting?.data?.dark_mode_styles?.header?.header_active?.value};
--header_logo_bg-dark: ${setting?.data?.dark_mode_styles?.header?.header_logo_background?.value};
--header_bg_color-dark: ${setting?.data?.dark_mode_styles?.header?.header_background?.value};
--header_button_text-dark: ${setting?.data?.dark_mode_styles?.header?.header_button_text_icon?.value};
--header_button_bg-dark: ${setting?.data?.dark_mode_styles?.header?.header_button_background?.value};
--header_dropdown_text-dark: ${setting?.data?.dark_mode_styles?.header?.header_dropdown_text_icon?.value};
--header_dropdown_bg-dark: ${setting?.data?.dark_mode_styles?.header?.header_dropdown_background?.value};
--sub_header_bg_color-dark: ${setting?.data?.dark_mode_styles?.header?.sub_header_background?.value};
--sub_header_text-dark: ${setting?.data?.dark_mode_styles?.header?.sub_header_text?.value};
--sub_header_text_active-dark: ${setting?.data?.dark_mode_styles?.header?.sub_header_text_active?.value};
 
--section_icon-dark: ${setting?.data?.dark_mode_styles?.section?.section_icon?.value};
--section_text-dark: ${setting?.data?.dark_mode_styles?.section?.section_text?.value};
--section_border-dark: ${setting?.data?.dark_mode_styles?.section?.section_border?.value};
--section_dropshadow-dark: ${setting?.data?.dark_mode_styles?.section?.section_dropshadow?.value};
--section_text_2-dark: ${setting?.data?.dark_mode_styles?.section?.section_text_2?.value};
--section_divider-dark: ${setting?.data?.dark_mode_styles?.section?.section_divider?.value};
--section_bg-dark: ${setting?.data?.dark_mode_styles?.section?.section_background?.value};
--section_button_text-dark: ${setting?.data?.dark_mode_styles?.section?.section_button_text?.value};
--section_icon_active-dark: ${setting?.data?.dark_mode_styles?.section?.section_icon_active?.value};
--section_heading_text-dark: ${setting?.data?.dark_mode_styles?.section?.section_heading_text?.value};
--section_heading_text2-dark: ${setting?.data?.dark_mode_styles?.section?.section_heading_text2?.value};
--section_team_1_color-dark: ${setting?.data?.dark_mode_styles?.section?.section_team_1_color?.value};
--section_team_2_color-dark: ${setting?.data?.dark_mode_styles?.section?.section_team_2_color?.value};
--section_row_highdark-dark: ${setting?.data?.dark_mode_styles?.section?.section_row_highdark?.value};
--section_button_bg-dark: ${setting?.data?.dark_mode_styles?.section?.section_button_background?.value};
--section_button_text_hover-dark: ${setting?.data?.dark_mode_styles?.section?.section_button_text_hover?.value};
--section_search_bg-dark: ${setting?.data?.dark_mode_styles?.section?.section_search_background?.value};
--section_odd_row_bg-dark: ${setting?.data?.dark_mode_styles?.section?.section_even_row_background?.value};
--section_button_bg_hover-dark: ${setting?.data?.dark_mode_styles?.section?.section_button_background_hover?.value};


--heading_text-dark: ${setting?.data?.dark_mode_styles?.headings?.heading_text?.value};
--sub_heading_text-dark: ${setting?.data?.dark_mode_styles?.headings?.sub_heading_text?.value};
 
--links-dark: ${setting?.data?.dark_mode_styles?.tags_links?.links?.value};
--ft_text-dark: ${setting?.data?.dark_mode_styles?.tags_links?.ft_text?.value};
--tag_text-dark: ${setting?.data?.dark_mode_styles?.tags_links?.tag_text?.value};
--link_hover-dark: ${setting?.data?.dark_mode_styles?.tags_links?.link_hover?.value};
--ft_bg-dark: ${setting?.data?.dark_mode_styles?.tags_links?.ft_background?.value};
--tag_bg-dark: ${setting?.data?.dark_mode_styles?.tags_links?.tag_background?.value};
 
--red_card-dark: #D5364E;
--win_button-dark: ${setting?.data?.dark_mode_styles?.live_center?.win_button_color?.value};
--draw_button-dark: ${setting?.data?.dark_mode_styles?.live_center?.draw_button?.value};
--live_button-dark: ${setting?.data?.dark_mode_styles?.live_center?.live_button_color?.value};
--loss_button-dark: ${setting?.data?.dark_mode_styles?.live_center?.loss_button?.value};
--yellow_card-dark: #FFCE00;
--win_button_text-dark: ${setting?.data?.dark_mode_styles?.live_center?.win_button_text?.value};
--draw_button_text-dark: ${setting?.data?.dark_mode_styles?.live_center?.draw_button_text?.value};
--live_button_text-dark: ${setting?.data?.dark_mode_styles?.live_center?.live_button_text?.value};
--loss_button_text-dark: ${setting?.data?.dark_mode_styles?.live_center?.loss_button_text?.value};
--postponed_button-dark: ${setting?.data?.dark_mode_styles?.live_center?.postponed_button?.value};
--postponed_button_text-dark: ${setting?.data?.dark_mode_styles?.live_center?.postponed_button_text?.value};
--match_detail_head_icon-dark: ${setting?.data?.dark_mode_styles?.live_center?.match_detail_head_icon?.value};
--match_detail_head_text-dark: ${setting?.data?.dark_mode_styles?.live_center?.match_detail_head_text?.value};
--match_detail_head_text2-dark: ${setting?.data?.dark_mode_styles?.live_center?.match_detail_head_text2?.value};
--live_center_brand_color-dark: ${setting?.data?.dark_mode_styles?.live_center?.live_center_brand_color?.value};
--score_ball_by_ball_text-dark: ${setting?.data?.dark_mode_styles?.live_center?.score_ball_by_ball_text?.value};
--match_detail_head_divider-dark: ${setting?.data?.dark_mode_styles?.live_center?.match_detail_head_divider?.value};
--match_detail_head_bg-dark: ${setting?.data?.dark_mode_styles?.live_center?.match_detail_head_background?.value};
--match_detail_head_icon_active-dark: ${setting?.data?.dark_mode_styles?.live_center?.match_detail_head_icon_active?.value};
--score_ball_by_ball_4th_bg-dark: ${setting?.data?.dark_mode_styles?.live_center?.score_ball_by_ball_4th_background?.value};
--score_ball_by_ball_6th_bg-dark: ${setting?.data?.dark_mode_styles?.live_center?.score_ball_by_ball_6th_background?.value};
--match_detail_head_score_bg-dark: ${setting?.data?.dark_mode_styles?.live_center?.match_detail_head_score_background?.value};
--score_ball_by_ball_score_bg-dark: ${setting?.data?.dark_mode_styles?.live_center?.score_ball_by_ball_score_background?.value};

}
`;
};


const $bc96133c7623ab69$export$cc7b5f925acc71d3 = ({ slug: slug, imgURL: imgURL = "", altText: altText, externalLink: externalLink })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "post_image",
        children: slug ? /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
            href: externalLink ? externalLink : "#",
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                src: (0, $2d22661aa7fb4cf1$export$f4b2b660571c63c7)(imgURL, 345),
                fill: true,
                alt: altText,
                objectFit: "cover",
                width: 400,
                height: 300
            })
        }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
            src: (0, $2d22661aa7fb4cf1$export$f4b2b660571c63c7)(imgURL, 345),
            fill: true,
            alt: altText,
            objectFit: "cover",
            width: 400,
            height: 300
        })
    });
};
const $bc96133c7623ab69$export$7e8e6220480f336b = ({ slug: slug, imgURL: imgURL = "", altText: altText, externalLink: externalLink })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "post_image",
        children: slug ? /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
            href: externalLink ? externalLink : "#",
            children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                src: (0, $2d22661aa7fb4cf1$export$f4b2b660571c63c7)(imgURL, 345),
                fill: true,
                alt: altText,
                objectFit: "cover",
                width: 400,
                height: 300
            })
        }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
            src: (0, $2d22661aa7fb4cf1$export$f4b2b660571c63c7)(imgURL, 345),
            fill: true,
            alt: altText,
            objectFit: "cover",
            width: 400,
            height: 300
        })
    });
};
const $bc96133c7623ab69$export$1836329f579c4b91 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "post_description",
        children: children
    });
};
const $bc96133c7623ab69$export$cae754750d6ddba6 = ({ authorName: authorName = "Anonymous", start_date: start_date, dictionary: dictionary, showBy: showBy = true, showStartDate: showStartDate = false, slug: slug })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "post_author",
        children: [
            showBy && (dictionary?.by || "by"),
            slug ? /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                href: `/author/${slug}`,
                children: authorName
            }) : /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                children: authorName
            }),
            start_date && showStartDate && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                className: "post_date",
                children: start_date
            }),
            start_date && !showStartDate && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                className: "post_date",
                children: (0, $3G7m1.timeSince)(start_date, dictionary)
            })
        ]
    });
};
const $bc96133c7623ab69$export$f99233281efd08a0 = ({ slug: slug, children: children, lnk: lnk = true, externalLink: externalLink })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsx)("h3", {
        className: "post_title",
        children: lnk ? /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
            href: externalLink ? externalLink : "#",
            children: children
        }) : children
    });
};
const $bc96133c7623ab69$export$584f572e703da3d0 = ({ slug: slug, children: children, lnk: lnk = true, externalLink: externalLink })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsx)("h3", {
        className: "post_title",
        children: lnk ? /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
            href: externalLink ? externalLink : "#",
            target: "_blank",
            rel: "noreferrer",
            children: children
        }) : children
    });
};
const $bc96133c7623ab69$export$b1cd4efac0d04127 = ({ children: children, lnk: lnk = true, externalLink: externalLink, index: index = 1 })=>{
    const HeadingTag = index === 0 ? "h1" : "h2";
    return /*#__PURE__*/ (0, $lBpE3.jsx)(HeadingTag, {
        className: "post_title_big",
        children: lnk ? /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
            href: externalLink ? externalLink : "#",
            children: children
        }) : children
    });
};
const $bc96133c7623ab69$export$e1f002d6dd9116ab = ({ children: children, lnk: lnk = true, externalLink: externalLink, index: index = 1 })=>{
    const HeadingTag = index === 0 ? "h1" : "h2";
    return /*#__PURE__*/ (0, $lBpE3.jsx)(HeadingTag, {
        className: "post_title_big",
        children: lnk ? /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
            href: externalLink ? externalLink : "#",
            children: children
        }) : children
    });
};
const $bc96133c7623ab69$export$942a7abc2909f356 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
        className: "post_title_big",
        children: children
    });
};
const $bc96133c7623ab69$export$bd66dafc0119b5eb = ({ children: children })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "text_wrp",
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("p", {
            children: children
        })
    });
};
const $bc96133c7623ab69$export$b72686b556e29ca6 = ({ subjects: subjects = [] })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
        children: subjects && /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
            className: "tag_lst",
            children: subjects?.slice(0, 12)?.map((tag)=>/*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                    children: tag?.name
                }, tag.id))
        })
    });
};
// export const Category = ({ categoryTitle }) => {
//   return (
//     <a className="badge" href={`/${titleToSlug(categoryTitle)}`}>
//       {categoryTitle}
//     </a>
//   );
// };
// export const Category2 = ({ categoryTitle }) => {
//   return (
//     <a className="badge2" href={`/${titleToSlug(categoryTitle)}`}>
//       {categoryTitle}
//     </a>
//   );
// };
const $bc96133c7623ab69$var$PostCard = ({ clas: clas = "", children: children })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsx)("article", {
        className: `post_card ${clas}`,
        children: children
    });
};
$bc96133c7623ab69$var$PostCard.Img = $bc96133c7623ab69$export$cc7b5f925acc71d3;
$bc96133c7623ab69$var$PostCard.ImgSlug = $bc96133c7623ab69$export$7e8e6220480f336b;
$bc96133c7623ab69$var$PostCard.Discription = $bc96133c7623ab69$export$1836329f579c4b91;
$bc96133c7623ab69$var$PostCard.Title = $bc96133c7623ab69$export$f99233281efd08a0;
$bc96133c7623ab69$var$PostCard.TitleSlug = $bc96133c7623ab69$export$584f572e703da3d0;
$bc96133c7623ab69$var$PostCard.TitleBig = $bc96133c7623ab69$export$b1cd4efac0d04127;
$bc96133c7623ab69$var$PostCard.TitleBig2 = $bc96133c7623ab69$export$942a7abc2909f356;
$bc96133c7623ab69$var$PostCard.TitleBigSlug = $bc96133c7623ab69$export$e1f002d6dd9116ab;
$bc96133c7623ab69$var$PostCard.TextDiscription = $bc96133c7623ab69$export$bd66dafc0119b5eb;
$bc96133c7623ab69$var$PostCard.Tags = $bc96133c7623ab69$export$b72686b556e29ca6;
$bc96133c7623ab69$var$PostCard.Author = $bc96133c7623ab69$export$cae754750d6ddba6;
var // PostCard.Category = Category;
// PostCard.Category2 = Category2;
$bc96133c7623ab69$export$2e2bcd8739ae039 = $bc96133c7623ab69$var$PostCard;



var $3G7m1 = parcelRequire("3G7m1");

var $2bSDe = parcelRequire("2bSDe");
const $4c03dbc6caeb65b2$var$News = ({ data: data, id: id, newsType: newsType = "match", sport: sport, baseUrl: baseUrl, dataClient: dataClient, loadCSS: loadCSS, title: title })=>{
    const [nData, setNData] = (0, $6cds3.useState)(data);
    const [pageCount, setPageCount] = (0, $6cds3.useState)(1);
    const handleLoadMore = async ()=>{
        const nextPage = pageCount + 1;
        try {
            const res = await fetch(`${baseUrl}/${sport}/${newsType}/${id}/news?page=${nextPage}`, {
                headers: {
                    Token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9"
                }
            });
            if (!res.ok) throw new Error(res?.statusText);
            const json = await res?.json();
            setNData((prev)=>({
                    ...prev,
                    data: [
                        ...prev?.data || [],
                        ...json?.data || []
                    ],
                    metadata: json?.metadata
                }));
            setPageCount(nextPage);
        } catch (err) {
            console.error("Failed to load more news:", err);
        }
    };
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document.querySelector(".microservice-cont");
        const dataAttr = container?.getAttribute("data-listingdata");
        if (dataAttr) try {
            const parsed = JSON.parse(dataAttr);
            setNData(parsed?.data || []);
        } catch (e) {
            console.error("Failed to parse data-listingdata:", e);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("news");
    }, [
        loadCSS
    ]);
    const sourceData = dataClient ? nData : data;
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("section", {
        className: "detail_news",
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            sourceData && sourceData?.data?.length > 0 ? /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "three_columns",
                        children: sourceData && sourceData?.data?.map((item, index)=>/*#__PURE__*/ (0, $lBpE3.jsxs)((0, $bc96133c7623ab69$export$2e2bcd8739ae039), {
                                clas: "vertical_post",
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)((0, $bc96133c7623ab69$export$2e2bcd8739ae039).Img, {
                                        imgURL: item?.imgu || undefined,
                                        externalLink: item?.link,
                                        slug: item?.hdl
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $bc96133c7623ab69$export$2e2bcd8739ae039).Discription, {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $bc96133c7623ab69$export$2e2bcd8739ae039).TitleSlug, {
                                                externalLink: item?.link,
                                                children: item?.hdl || ""
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                                className: "author_date",
                                                children: [
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)((0, $bc96133c7623ab69$export$2e2bcd8739ae039).Author, {
                                                        showBy: false,
                                                        authorName: item?.author?.name
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                        children: (0, $3G7m1.timeSince)(item?.sdt)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, item?.id || index))
                    }),
                    dataClient && sourceData?.pagination?.current_page + 1 < sourceData?.pagination?.last_page ? /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "load-more center_button",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                            className: "button button_primary",
                            onClick: handleLoadMore,
                            children: "See More"
                        })
                    }) : null
                ]
            }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {})
        ]
    });
};
var $4c03dbc6caeb65b2$export$2e2bcd8739ae039 = $4c03dbc6caeb65b2$var$News;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");




var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $ba5nK = parcelRequire("ba5nK");
function $5f32493f28cf587d$export$2e2bcd8739ae039({ children: children, title: title, titleImg: titleImg }) {
    const [isOpen, setIsOpen] = (0, $6cds3.useState)(true);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: `lineup_box_drop ${isOpen ? "open_dropdown" : ""}`,
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                className: "lineup_box_opener",
                onClick: ()=>setIsOpen(!isOpen),
                children: [
                    titleImg && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "icon_wrap",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                            src: titleImg,
                            width: 18,
                            height: 18,
                            alt: "avatar"
                        })
                    }),
                    title
                ]
            }),
            isOpen && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "inner_lineup",
                children: children
            })
        ]
    });
}



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $ba5nK = parcelRequire("ba5nK");
const $50753a1eae9e9152$var$SubstitutionTable = ({ home: home, away: away })=>{
    const baseURL = "https://ipublisher-microservices.6lgx.com" ?? "https://ipublisher-microservices.6lgx.com";
    const renderSubstitutionList = (substitutions)=>substitutions?.map((sub)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "ft_lineup_num",
                        children: sub?.sno
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "teams_wrap",
                        children: [
                            sub?.sub === 1 && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: "teams-logo",
                                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                    src: `${baseURL}/public/assets/images/svg/up-arrow2.svg`,
                                    height: 13,
                                    width: 13,
                                    alt: "teamLogo",
                                    priority: false
                                })
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: "teams-name",
                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                    className: "team_name",
                                    children: sub?.nm
                                })
                            })
                        ]
                    })
                ]
            }, sub?.sno));
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "football_lineup_box",
        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
            className: "ft_lineup_columns",
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                    className: "ft_list_lineup",
                    children: renderSubstitutionList(home)
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                    className: "ft_list_lineup",
                    children: renderSubstitutionList(away)
                })
            ]
        })
    });
};
var $50753a1eae9e9152$export$2e2bcd8739ae039 = $50753a1eae9e9152$var$SubstitutionTable;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $ba5nK = parcelRequire("ba5nK");
const $0fda5f74cdf8c44d$var$FtLineUp = ({ home: home, away: away })=>{
    const baseURL = "https://ipublisher-microservices.6lgx.com" ?? "https://ipublisher-microservices.6lgx.com";
    const renderSubstitutions = (substitutions)=>substitutions?.map((sub, index)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                        className: "ft_lineup_num",
                        children: [
                            sub?.min,
                            "\u2018"
                        ]
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "teams_wrap",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                className: "teams-name",
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "active team_name",
                                        children: sub?.p_in_nm
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "team_name",
                                        children: sub?.p_out_nm
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: "teams-logo",
                                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                    src: `${baseURL}/public/assets/images/svg/updown-arrow2.svg`,
                                    height: 16,
                                    width: 16,
                                    alt: "teamLogo",
                                    priority: false
                                })
                            })
                        ]
                    })
                ]
            }, `${sub?.min}-${index}`));
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "football_lineup_box",
        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
            className: "ft_lineup_columns",
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                    className: "ft_list_lineup",
                    children: renderSubstitutions(home)
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                    className: "ft_list_lineup",
                    children: renderSubstitutions(away)
                })
            ]
        })
    });
};
var $0fda5f74cdf8c44d$export$2e2bcd8739ae039 = $0fda5f74cdf8c44d$var$FtLineUp;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");
function $815f34803c1334be$export$2e2bcd8739ae039({ home: home, away: away }) {
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "football_lineup_box",
        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
            className: "ft_lineup_columns",
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                    className: "ft_list_lineup",
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                            className: "teams_wrap",
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: "teams-name",
                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                    className: "lin_name",
                                    children: home
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                    className: "ft_list_lineup",
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                            className: "teams_wrap",
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: "teams-name",
                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                    className: "lin_name",
                                    children: away
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
}



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $ba5nK = parcelRequire("ba5nK");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");
const $5d79cd15361807de$var$ShirtIcon = ({ kitColor: kitColor = "#7CC4EB" })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("svg", {
        width: "30",
        height: "34",
        viewBox: "0 0 51 60",
        fill: "",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("g", {
                filter: "url(#filter0_d_7730_2391)",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                    d: "M38.1362 31.7882C37.8824 34.0787 39.0805 38.089 38.6364 40.6755L38.5941 40.8869C38.2842 42.3175 38.8408 48.4774 39.3343 50.5354C36.1628 52.7907 31.18 54.2496 25.5346 54.2496C23.3697 54.2562 21.2102 54.0317 19.0929 53.5799C16.1611 52.9386 13.6309 51.8815 11.7425 50.5354C11.954 49.6615 12.2993 44.8549 12.4261 43.9951C12.5951 42.818 12.6586 41.7185 12.4755 40.8869C12.1371 39.3081 12.4826 38.1876 12.7503 35.7007C12.9124 34.1285 13.0392 32.6993 12.9406 31.7821C12.9124 31.5285 12.8842 31.2396 12.8561 30.9153C12.7715 30.0061 12.6939 28.8856 12.6235 27.8002C12.5318 26.4471 12.4544 25.1501 12.412 24.4312C12.3916 24.0576 12.3838 23.8391 12.3838 23.8391L11.298 25.9033C10.8963 25.8329 10.4876 25.7482 10.0933 25.6567C7.88301 25.0935 5.74502 24.2774 3.72168 23.2245C3.72168 23.2245 5.99808 16.9378 6.27392 15.6482C6.54793 14.3731 6.80847 7.72727 11.2698 6.66983C14.4766 5.90864 17.6551 4.28072 19.3247 3.20939C19.342 3.20155 19.3585 3.19212 19.3741 3.18121C19.9237 2.8288 20.3043 2.60951 20.4593 2.44127L20.5087 2.39185C20.5213 2.36997 20.5381 2.35081 20.5581 2.3355C20.5868 2.30317 20.6173 2.27256 20.6496 2.24382C21.1149 1.84915 21.8477 2.10988 22.7006 2.3988C23.6521 2.71589 25.5479 2.66668 25.5479 2.66668C25.5479 2.66668 27.4508 2.71609 28.4023 2.3988C29.3474 2.08171 30.1368 1.72235 30.5954 2.32835C31.054 2.93436 35.4016 5.62688 39.8345 6.68391C44.2958 7.74116 44.5566 14.3872 44.8314 15.6627C45.1134 16.9454 47.3837 23.239 47.3837 23.239C47.3837 23.239 43.6553 25.2688 39.8072 25.9242L38.7217 23.8595C38.7217 23.8595 38.5455 27.0733 38.3481 29.6378C38.2629 30.4633 38.1994 31.2245 38.1362 31.7882Z",
                    fill: `${kitColor}`
                })
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M31.6995 3.17488C31.6763 3.16023 31.6532 3.14549 31.6302 3.13065C31.5704 3.09145 31.5096 3.05143 31.4488 3.01074C31.264 2.88552 31.0836 2.75381 30.9081 2.61583C30.7871 2.51902 30.6745 2.41235 30.5714 2.29694C30.5596 2.28257 30.5482 2.26822 30.5374 2.25391L30.54 2.26118C30.5264 2.24541 30.513 2.22948 30.4997 2.2134C30.437 2.15908 30.3671 2.1136 30.292 2.07823C29.8762 1.90018 29.3342 2.09034 28.7102 2.30928C28.6172 2.34192 28.5224 2.37519 28.4258 2.40798C27.4813 2.72507 25.5345 2.67525 25.5345 2.67525C25.5345 2.67525 23.6407 2.72568 22.69 2.40063L22.6499 2.38716C21.8135 2.10622 21.1235 1.87448 20.6735 2.24709C20.6363 2.27677 20.6022 2.31023 20.5718 2.34693C20.5727 2.34457 20.5736 2.3422 20.5744 2.33984C20.4731 2.45893 20.3374 2.57121 20.1846 2.6798C20.0908 2.74458 19.9827 2.81542 19.865 2.89091C19.8043 2.929 19.7428 2.96687 19.6814 3.00468C19.5705 3.07306 19.4598 3.14123 19.3545 3.21006C19.3472 3.21776 19.338 3.22317 19.3289 3.22854C19.3204 3.23357 19.3119 3.23857 19.3051 3.24538C19.2591 3.43616 19.2386 3.63216 19.244 3.82831C19.2791 4.45555 19.5954 5.03338 19.9629 5.562L20.0262 5.64653C20.6494 6.5254 21.4748 7.24157 22.4327 7.73468C23.3906 8.22776 24.4531 8.48329 25.5305 8.47973C23.522 7.45087 22.0278 5.74515 20.9001 3.94102C20.7321 3.68905 20.6091 3.4098 20.5367 3.11573C20.5346 3.10789 20.5325 3.10004 20.5306 3.09218C20.9135 2.83747 21.9319 3.07434 22.5892 3.36374C23.4843 3.75169 25.5353 3.68083 25.5353 3.68083C25.5353 3.68083 27.6575 3.75332 28.5524 3.36558C29.1883 3.08465 30.1632 2.8574 30.572 3.07385C30.4813 3.38335 30.3422 3.67658 30.1599 3.94268C29.0322 5.74701 27.538 7.45252 25.5293 8.48138C26.6068 8.48495 27.6693 8.22941 28.6273 7.73633C29.5852 7.24321 30.4106 6.52705 31.0338 5.64819L31.0971 5.56366C31.4646 5.03504 31.7809 4.45721 31.816 3.82997C31.8213 3.62321 31.8006 3.4166 31.7545 3.21498C31.7477 3.20817 31.7392 3.20317 31.7307 3.19814C31.7216 3.19277 31.7124 3.18736 31.7051 3.17966L31.6984 3.1753L31.6995 3.17488Z",
                fill: "black",
                fillOpacity: "0.1"
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("defs", {
                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("filter", {
                    id: "filter0_d_7730_2391",
                    x: "0.228722",
                    y: "0.253521",
                    width: "50.6479",
                    height: "59.2359",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("feOffset", {
                            dy: "1.74648"
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("feGaussianBlur", {
                            stdDeviation: "1.74648"
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_7730_2391"
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_7730_2391",
                            result: "shape"
                        })
                    ]
                })
            })
        ]
    });
};
var $5d79cd15361807de$export$2e2bcd8739ae039 = $5d79cd15361807de$var$ShirtIcon;



var $3G7m1 = parcelRequire("3G7m1");
const $46cb78cc3d060de9$var$GOAL_TYPE_ICONS = {
    Goal: "football-outline",
    Penalty: "penalty",
    "Disallowed goal": "var",
    default: "ongoal"
};
const $46cb78cc3d060de9$var$PlayerIcon = ({ src: src, alt: alt, count: count, className: className })=>/*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                src: src,
                width: 12,
                height: 12,
                alt: alt
            }),
            count > 1 ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                className: "count-num",
                children: count
            }) : null
        ]
    });
const $46cb78cc3d060de9$var$PlayerCard = ({ player: player, sno: sno, kitColor: kitColor, baseURL: baseURL, sport: sport })=>{
    const { football_goals: football_goals = [], cards: cards = [], substitutions_out: substitutions_out, assist: assist = [], nm: playerName, id: playerId } = player || {};
    const goalsCount = football_goals?.length;
    const goalType = football_goals?.[0]?.ty;
    const goalIcon = $46cb78cc3d060de9$var$GOAL_TYPE_ICONS[goalType] || $46cb78cc3d060de9$var$GOAL_TYPE_ICONS.default;
    const cardsCount = cards?.length;
    const cardType = cards?.[0]?.ty;
    const cardIcon = cardsCount > 1 ? "card-yellowred" : cardType?.includes("Yellow") ? "card-yellow" : "card-red";
    const hasAssist = assist?.length > 0;
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "shirt_wrap",
        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("a", {
            href: `/${sport}/player/${(0, $3G7m1.linkName)(playerName)}/${playerId}/info`,
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                    className: "img_wrap",
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)((0, $5d79cd15361807de$export$2e2bcd8739ae039), {
                            kitColor: kitColor
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                            className: "shirt_num",
                            children: sno
                        }),
                        goalsCount > 0 ? /*#__PURE__*/ (0, $lBpE3.jsx)($46cb78cc3d060de9$var$PlayerIcon, {
                            src: `${baseURL}/public/assets/images/svg/${goalIcon}.svg`,
                            alt: "goal",
                            count: goalsCount,
                            className: "football_icon"
                        }) : null,
                        hasAssist ? /*#__PURE__*/ (0, $lBpE3.jsx)($46cb78cc3d060de9$var$PlayerIcon, {
                            src: `${baseURL}/public/assets/images/svg/free-kick.svg`,
                            alt: "assist",
                            className: "downLeft_icon"
                        }) : null,
                        cardsCount > 0 ? /*#__PURE__*/ (0, $lBpE3.jsx)($46cb78cc3d060de9$var$PlayerIcon, {
                            src: `${baseURL}/public/assets/images/svg/${cardIcon}.svg`,
                            alt: "card",
                            className: "card_icon"
                        }) : null,
                        substitutions_out ? /*#__PURE__*/ (0, $lBpE3.jsx)($46cb78cc3d060de9$var$PlayerIcon, {
                            src: `${baseURL}/public/assets/images/svg/down-arrow.svg`,
                            alt: "substitution",
                            className: "down_icon"
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                    className: "player_name",
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "pyr_nm_in",
                        children: playerName
                    })
                })
            ]
        })
    });
};
const $46cb78cc3d060de9$var$LineupRow = ({ Team: Team, kitColor: kitColor, sport: sport = "football" })=>{
    const baseURL = "https://ipublisher-microservices.6lgx.com" ?? "https://ipublisher-microservices.6lgx.com";
    return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
        children: Team?.map((row, rowIndex)=>/*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "player-row",
                children: row?.map(({ sno: sno, player: player })=>/*#__PURE__*/ (0, $lBpE3.jsx)($46cb78cc3d060de9$var$PlayerCard, {
                        player: player,
                        sno: sno,
                        kitColor: kitColor,
                        baseURL: baseURL,
                        sport: sport
                    }, sno))
            }, rowIndex))
    });
};
var $46cb78cc3d060de9$export$2e2bcd8739ae039 = $46cb78cc3d060de9$var$LineupRow;




var $ba5nK = parcelRequire("ba5nK");

var $2bSDe = parcelRequire("2bSDe");

var $3G7m1 = parcelRequire("3G7m1");
// Default formation if none provided
const $f2f7db5592e14d7b$var$defaultFormation = "4-4-2";
function $f2f7db5592e14d7b$var$parseFormation(formation) {
    return formation ? formation.split("-").map(Number) : [];
}
const $f2f7db5592e14d7b$var$getShortName = (name)=>{
    if (!name) return "";
    const words = name.split(" ");
    if (words.length === 1) return name.slice(0, 3).toUpperCase();
    return words.map((word)=>word[0]).join("").toUpperCase().slice(0, 3);
};
const $f2f7db5592e14d7b$var$Linesup = ({ serverData: serverData, dataClient: dataClient, loadCSS: loadCSS, title: title, sport: sport = "football", data: propData })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    // Support both direct data prop and serverData/dataClient pattern
    const data = propData || (dataClient ? clientData : serverData);
    const baseURL = "https://ipublisher-microservices.6lgx.com" ?? "https://ipublisher-microservices.6lgx.com";
    const sanitizeKitColor = (kit, fallback)=>typeof kit === "string" && kit.length > 0 ? `#${kit.replace(/^#/, "")}` : fallback;
    const homeTeamKitColor = sanitizeKitColor(data?.home_team?.kit ? `#${data.home_team.kit}` : "#3793D4", "#3793D4");
    const awayTeamKitColor = sanitizeKitColor(data?.away_team?.kit ? `#${data.away_team.kit}` : "#7CC4EB", "#7CC4EB");
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    const homeFormationRaw = data?.home_team?.formation;
    const awayFormationRaw = data?.away_team?.formation;
    const homeFormation = $f2f7db5592e14d7b$var$parseFormation(homeFormationRaw || $f2f7db5592e14d7b$var$defaultFormation);
    const awayFormation = $f2f7db5592e14d7b$var$parseFormation(awayFormationRaw || $f2f7db5592e14d7b$var$defaultFormation);
    const filterLineup = (lineup)=>lineup?.filter((player)=>player.pos !== "gk") || [];
    const homeLineup = filterLineup(data?.home_team?.lineup);
    const awayLineup = filterLineup(data?.away_team?.lineup);
    const buildTeamLineup = (formation, lineup, goalkeaper)=>{
        let count = 1;
        const team = [
            goalkeaper?.filter((player)=>player.pos === "gk" || player.pos === "Goalkeeper")
        ];
        for (const playersCount of formation){
            team.push(lineup.slice(count, count + playersCount));
            count += playersCount;
        }
        return team;
    };
    const homeTeam = buildTeamLineup(homeFormation, homeLineup, data?.home_team?.lineup);
    const awayTeam = buildTeamLineup(awayFormation, awayLineup, data?.away_team?.lineup).reverse();
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("matchlineup");
    }, [
        loadCSS
    ]);
    if (!data) return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "lineup_box_drop",
        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {})
    });
    const homeImageUrl = (0, $3G7m1.getImageUrl)(baseURL, "team", sport, data?.home_team?.id);
    const awayImageUrl = (0, $3G7m1.getImageUrl)(baseURL, "team", sport, data?.away_team?.id);
    // Check what data is available for conditional rendering
    const hasFormation = data?.home_team?.formation || data?.away_team?.formation;
    const hasLineup = data?.home_team?.lineup?.length > 0 || data?.away_team?.lineup?.length > 0;
    const hasSubstitutions = data?.home_team?.sub?.length > 0 || data?.away_team?.sub?.length > 0;
    const hasBenchPlayers = data?.home_team?.sub_players?.length > 0 || data?.away_team?.sub_players?.length > 0;
    const hasInjuredPlayers = data?.home_team?.inj_susp_players?.length > 0 || data?.away_team?.inj_susp_players?.length > 0;
    const hasCoaches = data?.home_team_coach?.length > 0 || data?.away_team_coach?.length > 0;
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            (homeTeam || awayTeam) && hasFormation && /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "ft-team-formation-wrapper",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                className: "ft-team-formation-col",
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("strong", {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                src: homeImageUrl,
                                                height: 22,
                                                width: 22,
                                                alt: "homeLogo",
                                                priority: false
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: "team-name-full",
                                                children: data?.home_team?.nm
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: "team-name-short",
                                                children: $f2f7db5592e14d7b$var$getShortName(data?.home_team?.nm)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        children: data?.home_team?.formation
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                className: "ft-team-formation-col",
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        children: data?.away_team?.formation
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("strong", {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: "team-name-full",
                                                children: data?.away_team?.nm
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: "team-name-short",
                                                children: $f2f7db5592e14d7b$var$getShortName(data?.away_team?.nm)
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                src: awayImageUrl,
                                                height: 22,
                                                width: 22,
                                                alt: "awayLogo",
                                                priority: false
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "linesup_img",
                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                            className: "inner_ground",
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                    className: "team_one",
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                            className: "formation d_md_none",
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    className: "formation_team",
                                                    children: data?.home_team?.nm
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    className: "formation_points",
                                                    children: data?.home_team?.formation
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)((0, $46cb78cc3d060de9$export$2e2bcd8739ae039), {
                                            Team: homeTeam,
                                            kitColor: homeTeamKitColor,
                                            sport: sport
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                    className: "team_two",
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                            className: "formation d_md_none",
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    className: "formation_team",
                                                    children: data?.away_team?.nm
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    className: "formation_points",
                                                    children: data?.away_team?.formation
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)((0, $46cb78cc3d060de9$export$2e2bcd8739ae039), {
                                            Team: awayTeam,
                                            kitColor: awayTeamKitColor,
                                            sport: sport
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            hasSubstitutions && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $5f32493f28cf587d$export$2e2bcd8739ae039), {
                title: "Substitutions",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0fda5f74cdf8c44d$export$2e2bcd8739ae039), {
                    home: data?.home_team?.sub,
                    away: data?.away_team?.sub
                })
            }),
            hasBenchPlayers && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $5f32493f28cf587d$export$2e2bcd8739ae039), {
                title: "Bench Players",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $50753a1eae9e9152$export$2e2bcd8739ae039), {
                    home: data?.home_team?.sub_players,
                    away: data?.away_team?.sub_players
                })
            }),
            hasInjuredPlayers && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $5f32493f28cf587d$export$2e2bcd8739ae039), {
                title: "Injured Players",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $50753a1eae9e9152$export$2e2bcd8739ae039), {
                    home: data?.home_team?.inj_susp_players,
                    away: data?.away_team?.inj_susp_players
                })
            }),
            hasCoaches && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $5f32493f28cf587d$export$2e2bcd8739ae039), {
                title: "Coaches",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $815f34803c1334be$export$2e2bcd8739ae039), {
                    home: data?.home_team_coach,
                    away: data?.away_team_coach
                })
            })
        ]
    });
};
var $f2f7db5592e14d7b$export$2e2bcd8739ae039 = $f2f7db5592e14d7b$var$Linesup;





var $zSRJd = parcelRequire("zSRJd");



var $2bSDe = parcelRequire("2bSDe");
const $bed8b294a9aeadb8$var$MatchPage = ({ data: data, baseUrl: baseUrl, dataType: dataType, difference: difference, sport: sport, dataId: dataId, commData: commData, loadCSS: loadCSS, headData: headData, setDataType: setDataType, setDataId: setDataId, setHead: setHead, setLeagueId: setLeagueId, dataClient: dataClient })=>{
    const [active, setActive] = (0, $6cds3.useState)(headData?.newtabs?.length > 0 && (headData?.newtabs[0] === "commentary" || headData?.newtabs[0] === "events" ? {
        key: "match-summary",
        label: "Match Summary"
    } : {
        key: `match-${headData?.newtabs[0]}`,
        label: headData?.newtabs[0] === "h2h" ? headData?.newtabs[0].toUpperCase() : String(headData?.newtabs[0]).charAt(0).toUpperCase() + String(headData?.newtabs[0]).slice(1)
    }));
    const [activeTabData, setActiveTabData] = (0, $6cds3.useState)(data);
    const [isLoading, setIsLoading] = (0, $6cds3.useState)(false);
    const [commentaryData, setCommentaryData] = (0, $6cds3.useState)(null);
    const [tabs, setTabs] = (0, $6cds3.useState)([]);
    (0, $6cds3.useEffect)(()=>{
        if (headData && headData?.newtabs) {
            setActive(headData?.newtabs[0] === "commentary" || headData?.newtabs[0] === "events" ? {
                key: "match-summary",
                label: "Match Summary"
            } : {
                key: `match-${headData?.newtabs[0]}`,
                label: headData?.newtabs[0] === "h2h" ? headData?.newtabs[0].toUpperCase() : String(headData?.newtabs[0]).charAt(0).toUpperCase() + String(headData?.newtabs[0]).slice(1)
            });
            const matchTabs = headData?.newtabs?.flatMap((hdata)=>hdata !== "commentary" && hdata !== "events" ? [
                    {
                        key: `match-${hdata}`,
                        label: hdata === "h2h" ? hdata.toUpperCase() : String(hdata).charAt(0).toUpperCase() + String(hdata).slice(1)
                    }
                ] : []);
            if (headData?.newtabs?.indexOf("commentary") > -1 || headData?.newtabs?.indexOf("events") > -1) matchTabs.unshift({
                key: "match-summary",
                label: "Summary"
            });
            setTabs(matchTabs);
        }
    }, [
        headData
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("matchpage");
    }, [
        loadCSS
    ]);
    const fetchData = async ()=>{
        try {
            if (active?.key) {
                const data = active.key === "match-news" ? await (0, $zSRJd.getData)({
                    dataId: dataId,
                    dataType: active.key,
                    baseUrl: baseUrl,
                    sport: sport,
                    newsType: "match"
                }) : await (0, $zSRJd.getData)({
                    dataId: dataId,
                    dataType: active.key,
                    baseUrl: baseUrl,
                    sport: sport
                });
                if (active.key === "match-summary") {
                    const otherData = await (0, $zSRJd.getData)({
                        dataId: dataId,
                        dataType: "match-com",
                        baseUrl: baseUrl,
                        sport: sport
                    });
                    setCommentaryData(otherData);
                }
                setActiveTabData(data);
                setIsLoading(false);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setIsLoading(false);
        }
    };
    (0, $6cds3.useEffect)(()=>{
        if (active) fetchData();
    }, [
        active
    ]);
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "match-page",
        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
            className: "detail_page",
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsx)("nav", {
                    className: "detail_main_tab",
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                        children: tabs?.length > 0 && tabs.map(({ key: key, label: label })=>/*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                className: `${active.key === key ? "active" : ""}`,
                                onClick: ()=>{
                                    if (active.key !== key) {
                                        setIsLoading(true);
                                        setActive({
                                            key: key,
                                            label: label
                                        });
                                        setActiveTabData(null);
                                    }
                                },
                                "data-name": key,
                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                    children: label
                                })
                            }, key))
                    })
                }),
                isLoading ? /*#__PURE__*/ (0, $lBpE3.jsx)("h3", {
                    children: "loading..."
                }) : /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                    children: [
                        active?.key === "match-summary" && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
                            children: headData?.newtabs?.indexOf("commentary") > -1 || headData?.newtabs?.indexOf("events") > -1 ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $5037a3f4b7bc44bc$export$2e2bcd8739ae039), {
                                data: activeTabData?.summary,
                                commData: commentaryData ? commentaryData : commData,
                                id: dataId
                            }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {})
                        }),
                        active?.key === "match-stats" && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ef8eecb0ad76f456$export$2e2bcd8739ae039), {
                            data: activeTabData?.data
                        }),
                        active?.key === "match-lineup" && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $f2f7db5592e14d7b$export$2e2bcd8739ae039), {
                            data: activeTabData?.data
                        }),
                        active?.key === "match-table" && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3bb918d7b03f1ba4$export$2e2bcd8739ae039), {
                            data: activeTabData?.data
                        }),
                        active?.key === "match-h2h" && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $62b4ee31d2bc99dc$export$2e2bcd8739ae039), {
                            data: activeTabData?.data,
                            setDataType: setDataType,
                            setDataId: setDataId,
                            setHead: setHead,
                            setLeagueId: setLeagueId
                        }),
                        active?.key === "match-info" && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $254daca3f12a10f3$export$2e2bcd8739ae039), {
                            data: activeTabData?.info || activeTabData?.summary,
                            difference: difference
                        }),
                        active?.key === "match-news" && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $4c03dbc6caeb65b2$export$2e2bcd8739ae039), {
                            data: activeTabData?.data,
                            id: dataId,
                            newsType: "match",
                            sport: sport,
                            baseUrl: baseUrl
                        })
                    ]
                })
            ]
        })
    });
};
var $bed8b294a9aeadb8$export$2e2bcd8739ae039 = $bed8b294a9aeadb8$var$MatchPage;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $2bSDe = parcelRequire("2bSDe");
const $29ddb6bc6c3e1f40$var$EVENT_EMOJI = {
    Goal: "\u26BD",
    "Own goal": "\u26BD",
    "Disallowed goal": "\u274C",
    Penalty: "\u26BD",
    "Yellow card": "\uD83D\uDFE8",
    "Red card": "\uD83D\uDFE5",
    "Second yellow card": "\uD83D\uDFE8",
    Sub: "\uD83D\uDD04"
};
const $29ddb6bc6c3e1f40$var$TimelineEvent = ({ event: event })=>{
    const isHome = event?.isH === 1 || event?.isH === true;
    const emoji = $29ddb6bc6c3e1f40$var$EVENT_EMOJI[event?.typ] || "";
    const playerName = event?.pl_nm || event?.pl_in_nm || "";
    const assist = event?.pl_out_nm || event?.asst || "";
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: `mtl__event mtl__event--${isHome ? "home" : "away"}`,
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                className: `mtl__dot mtl__dot--${isHome ? "home" : "away"}`
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "mtl__event-card",
                children: [
                    emoji && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "mtl__icon-wrap",
                        children: emoji
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "mtl__event-info",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "mtl__player",
                                children: playerName
                            }),
                            assist && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "mtl__assist",
                                children: assist
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                        className: "mtl__minute",
                        children: [
                            event?.mins,
                            "''"
                        ]
                    })
                ]
            })
        ]
    });
};
const $29ddb6bc6c3e1f40$var$MatchTimeline = ({ data: data, dataClient: dataClient = false, loadCSS: loadCSS = true, title: title, matchDetail: matchDetail, matchId: matchId, baseUrl: baseUrl, sport: sport = "football" })=>{
    const [timelineData, setTimelineData] = (0, $6cds3.useState)(data?.timeline || []);
    const [fetchedMatchDetail, setFetchedMatchDetail] = (0, $6cds3.useState)(null);
    (0, $6cds3.useEffect)(()=>{
        (0, $2bSDe.loadStyles)("matchTimeline");
    }, []);
    // Self-fetch mode: fetch both summary (timeline) + detail (teams/score)
    (0, $6cds3.useEffect)(()=>{
        if (!matchId || !baseUrl || data?.timeline) return;
        Promise.all([
            fetch(`${baseUrl}/${sport}/match/${matchId}/summary`).then((r)=>r.ok ? r.json() : null),
            fetch(`${baseUrl}/${sport}/match/${matchId}/detail`).then((r)=>r.ok ? r.json() : null)
        ]).then(([summary, detail])=>{
            if (summary) setTimelineData(summary?.summary?.timeline || []);
            if (detail) setFetchedMatchDetail(detail);
        }).catch(()=>{});
    }, [
        matchId,
        baseUrl,
        sport,
        data
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        try {
            const raw = document.querySelector(".microservice-cont")?.getAttribute("data-listingdata");
            if (!raw) return;
            const parsed = JSON.parse(raw);
            setTimelineData(parsed?.data?.summary?.timeline || []);
        } catch (e) {
            console.error("[MatchTimeline] parse error:", e);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient && data?.timeline) setTimelineData(data.timeline);
    }, [
        data,
        dataClient
    ]);
    const resolvedMatchDetail = matchDetail || fetchedMatchDetail;
    // Key moments only — filter out HT/FT markers and empty events
    const keyEvents = timelineData.filter((e)=>e?.typ && e.typ !== "HT" && e.typ !== "FT" && (e.pl_nm || e.pl_in_nm));
    // Derive score from match detail
    const matchData = resolvedMatchDetail?.data || resolvedMatchDetail;
    const homeTeam = matchData?.competitors?.htn || "";
    const awayTeam = matchData?.competitors?.atn || "";
    const score = matchData?.cfs || "";
    const [homeScore, awayScore] = score.split("-");
    // League name
    const leagueName = matchData?.tournament?.nm || "";
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "mtl",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "mtl__header",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "mtl__header-icon",
                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("svg", {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("circle", {
                                    cx: "12",
                                    cy: "12",
                                    r: "10"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("polyline", {
                                    points: "12 6 12 12 16 14"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "mtl__header-text",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "mtl__header-title",
                                children: "Match Timeline"
                            }),
                            leagueName && /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                className: "mtl__header-sub",
                                children: [
                                    leagueName,
                                    " \xb7 Key Moments"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "mtl__body",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "mtl__spine"
                    }),
                    keyEvents.length > 0 ? keyEvents.map((event, i)=>/*#__PURE__*/ (0, $lBpE3.jsx)($29ddb6bc6c3e1f40$var$TimelineEvent, {
                            event: event
                        }, `${event.mins}-${i}`)) : /*#__PURE__*/ (0, $lBpE3.jsx)("p", {
                        className: "mtl__empty",
                        children: "No events yet"
                    })
                ]
            }),
            score && /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "mtl__footer",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                        className: "mtl__footer-team mtl__footer-team--home",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "mtl__footer-dot mtl__footer-dot--home"
                            }),
                            homeTeam,
                            " ",
                            homeScore
                        ]
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "mtl__footer-sep",
                        children: "-"
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                        className: "mtl__footer-team mtl__footer-team--away",
                        children: [
                            awayScore,
                            " ",
                            awayTeam,
                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "mtl__footer-dot mtl__footer-dot--away"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $29ddb6bc6c3e1f40$export$2e2bcd8739ae039 = $29ddb6bc6c3e1f40$var$MatchTimeline;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $2bSDe = parcelRequire("2bSDe");

var $zSRJd = parcelRequire("zSRJd");


var $3G7m1 = parcelRequire("3G7m1");

var $gtwOm = parcelRequire("gtwOm");
/**
 * EditorialHeader — a self-contained, live football match-header widget.
 *
 * Renders the head + state + events for a match, adapting to match state:
 *   • Upcoming  → kickoff label + "VS" + a live countdown
 *   • Live      → pulsing live minute + current score + goals/cards so far (socket-updated)
 *   • Finished  → final score (FT / AET / Pens) + full goals/cards list
 *
 * Data source (priority):
 *   1. explicit view props (home/away/…) → static render (demo/preview)
 *   2. dataId + baseUrl → fetches /match/{id}/detail (head) AND /match/{id}/summary (events)
 *
 * Styling is fully token-driven (see src/assets/scss/editorialHeader.scss); when baseUrl
 * is present it also fetches /settings and injects <style id="dynamic-colors">.
 */ const $63a37370dc0a1ebe$var$MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
const $63a37370dc0a1ebe$var$pad2 = (n)=>String(n).padStart(2, "0");
// The feed's match.dt is a UTC wall-clock string "YYYY-MM-DD HH:mm:ss" with NO zone suffix
// (confirmed against the live API — the same dt comes back regardless of the difference/country
// headers). Append "Z" so it is parsed as UTC, never as the browser's local zone, giving a
// correct absolute instant on any device.
const $63a37370dc0a1ebe$var$kickoffMs = (dt)=>{
    if (!dt) return NaN;
    let s = String(dt).trim().replace(" ", "T");
    if (!/[zZ]$|[+\-]\d{2}:?\d{2}$/.test(s)) s += "Z";
    return new Date(s).getTime();
};
// Kickoff wall-clock parts. match.dt is UTC. If an explicit `difference` (viewer offset, e.g.
// "+5") is provided we shift by it and read UTC parts (deterministic + SSR-stable). If it is
// 0/absent we fall back to the VIEWER'S OWN device timezone via local getters — so the time is
// right for whoever is looking, without the offset having to be wired up.
const $63a37370dc0a1ebe$var$kickoffParts = (dt, difference)=>{
    const base = $63a37370dc0a1ebe$var$kickoffMs(dt);
    if (isNaN(base)) return null;
    const offH = parseInt(String(difference ?? "").replace("+", ""), 10) || 0;
    if (offH !== 0) {
        const d = new Date(base + offH * 3600000);
        return {
            date: d.getUTCDate(),
            month: d.getUTCMonth(),
            year: d.getUTCFullYear(),
            h: d.getUTCHours(),
            m: d.getUTCMinutes()
        };
    }
    const d = new Date(base); // viewer's device timezone
    return {
        date: d.getDate(),
        month: d.getMonth(),
        year: d.getFullYear(),
        h: d.getHours(),
        m: d.getMinutes()
    };
};
const $63a37370dc0a1ebe$var$formatMatchDate = (dt, difference)=>{
    const p = $63a37370dc0a1ebe$var$kickoffParts(dt, difference);
    if (!p) return "";
    return `${p.date} ${$63a37370dc0a1ebe$var$MONTHS[p.month]} ${p.year}`;
};
const $63a37370dc0a1ebe$var$fmtAttendance = (a)=>{
    if (a == null || a === "") return "";
    const n = typeof a === "number" ? a : parseInt(String(a).replace(/[^0-9]/g, ""), 10);
    return isNaN(n) ? String(a) : n.toLocaleString("en-US");
};
const $63a37370dc0a1ebe$var$splitScore = (s)=>typeof s === "string" && s.includes("-") ? s.split("-").map((x)=>x.trim()) : [
        null,
        null
    ];
// Local kickoff clock label for upcoming matches, e.g. "7 Jul · 00:00". A 19:00 UTC kickoff
// reads as "00:00" next day for a UTC+5 viewer (via explicit "+5" or their device timezone).
const $63a37370dc0a1ebe$var$kickoffLabel = (dt, difference)=>{
    const p = $63a37370dc0a1ebe$var$kickoffParts(dt, difference);
    if (!p) return "Upcoming";
    return `${p.date} ${$63a37370dc0a1ebe$var$MONTHS[p.month]} \xb7 ${$63a37370dc0a1ebe$var$pad2(p.h)}:${$63a37370dc0a1ebe$var$pad2(p.m)}`;
};
// ── Event vocabulary (goals + cards only; subs / HT / FT / disallowed excluded) ──
const $63a37370dc0a1ebe$var$GOAL_TYPES = [
    "Goal",
    "Own goal",
    "Penalty"
];
const $63a37370dc0a1ebe$var$CARD_KIND = {
    "Yellow card": "y",
    "Second yellow card": "y",
    "Red card": "r"
};
const $63a37370dc0a1ebe$var$eventKind = (typ)=>$63a37370dc0a1ebe$var$GOAL_TYPES.includes(typ) ? "goal" : $63a37370dc0a1ebe$var$CARD_KIND[typ] || null;
// Raw summary.timeline events → normalized, filtered, minute-sorted list.
const $63a37370dc0a1ebe$var$normalizeEvents = (rawEvents)=>(rawEvents || []).map((e)=>({
            kind: $63a37370dc0a1ebe$var$eventKind(e?.typ),
            e: e
        })).filter(({ kind: kind, e: e })=>kind && (e?.pl_nm || e?.pl_in_nm)).map(({ kind: kind, e: e })=>({
            kind: kind,
            typ: e.typ,
            mins: e.mins,
            isHome: e.isH === 1 || e.isH === true,
            player: e.pl_nm || e.pl_in_nm
        })).sort((a, b)=>(parseInt(a.mins, 10) || 0) - (parseInt(b.mins, 10) || 0));
// ── Football match-state classification ─────────────────────────────────────
// The feed mixes case ("inprogress" lowercase, "Finished"/"Full Time" capitalized), so ALWAYS
// compare lowercased. `st` is the primary status text; `statusKey` is the numeric status
// (1 = not started, 3 = result only, 4 = finished, 15 = live); the live minute is in `mins`.
const $63a37370dc0a1ebe$var$FB_LIVE = [
    "inprogress",
    "1st half",
    "2nd half",
    "half time",
    "et 1st half",
    "et 2nd half",
    "penalty"
];
// Normal full-time finishes (→ "FT" / "FT · AET" / "FT · Pens").
const $63a37370dc0a1ebe$var$FB_FT = [
    "finished",
    "finished aet",
    "finished ap",
    "full time"
];
// Ended but NOT a normal finish — still "closed" (show final score/events), but each keeps its
// own word instead of a misleading "FT".
const $63a37370dc0a1ebe$var$FB_CLOSED = {
    awarded: "Awarded",
    "result only": "Result",
    cancelled: "Cancelled",
    postponed: "Postponed",
    abandoned: "Abandoned",
    interrupted: "Interrupted",
    deleted: "Cancelled"
};
const $63a37370dc0a1ebe$var$stLower = (match)=>String(match?.st || "").trim().toLowerCase();
const $63a37370dc0a1ebe$var$isLiveStatus = (match)=>parseInt(match?.statusKey, 10) === 15 || $63a37370dc0a1ebe$var$FB_LIVE.includes($63a37370dc0a1ebe$var$stLower(match));
// Raw /match/{id}/detail `.data` object + events → the view model this widget renders.
const $63a37370dc0a1ebe$var$deriveView = (match, events, sport, difference, liveMinute)=>{
    if (!match) return null;
    const c = match.competitors || {};
    const st = String(match.st || "");
    const stLow = st.trim().toLowerCase();
    const sKey = parseInt(match.statusKey, 10);
    const isLive = sKey === 15 || $63a37370dc0a1ebe$var$FB_LIVE.includes(stLow);
    const isFT = sKey === 4 || $63a37370dc0a1ebe$var$FB_FT.includes(stLow); // normal full-time
    // Awarded / cancelled / postponed / … — ended but not a normal FT (statusKey 3 = result only).
    const closedLabel = $63a37370dc0a1ebe$var$FB_CLOSED[stLow] || (sKey === 3 ? "Result" : null);
    const isClosed = !isLive && !!closedLabel;
    const isFinished = !isLive && (isFT || isClosed);
    // Fallback rule: anything NOT recognized as live/finished/closed is UPCOMING — a new/unknown
    // status (e.g. "Suspended") must never render as FT by accident.
    const isUpcoming = !isLive && !isFinished;
    const state = isLive ? "live" : isFinished ? "finished" : "upcoming";
    const [hs, as] = $63a37370dc0a1ebe$var$splitScore(match.cfs || match.fs || "");
    const isAet = /aet/i.test(stLow) || match.mins === "FAET";
    const isPens = /\bap\b/i.test(stLow) || !!match.ps;
    // Winner (finished matches only): compare the DECISIVE score — penalties (ps) when the match
    // was decided on pens, else the full/cfs score. Higher side wins; equal = draw (no winner).
    let winnerSide = null;
    if (isFinished) {
        const decisive = match.mins === "FAP" || match.ps ? match.ps : match.cfs || match.fs;
        const [dh, da] = $63a37370dc0a1ebe$var$splitScore(decisive || "");
        const nh = parseInt(dh, 10);
        const na = parseInt(da, 10);
        if (!isNaN(nh) && !isNaN(na)) winnerSide = nh > na ? "home" : na > nh ? "away" : null;
    }
    // Status chip shows the plain state word (LIVE / UPCOMING / FINISHED — uppercased by CSS).
    // The blinking dot signals "live"; abnormal-ended matches keep their own word.
    let statusLabel;
    if (isLive) statusLabel = "Live";
    else if (isUpcoming) statusLabel = "Upcoming";
    else if (isClosed) statusLabel = closedLabel; // Cancelled / Postponed / Awarded / Result / …
    else {
        statusLabel = "Finished";
        if (isAet) statusLabel += " \xb7 AET";
        if (isPens) statusLabel += " \xb7 Pens";
    }
    const timeline = [];
    if (match.ht) timeline.push({
        label: "HT",
        score: match.ht
    });
    if (match.cfs) timeline.push({
        label: "FT",
        score: match.cfs,
        active: !isAet
    });
    if (isAet) timeline.push({
        label: "AET",
        score: match.cfs,
        active: true
    });
    return {
        state: state,
        isLive: isLive,
        isUpcoming: isUpcoming,
        isFinished: isFinished,
        winnerSide: winnerSide,
        pens: isFinished && isPens && match.ps ? match.ps : null,
        isAet: isAet,
        competition: match.tournament?.nm || match.league?.nm || "",
        stage: match.ro || "",
        statusLabel: statusLabel,
        home: {
            name: c.htn,
            flag: c.htid ? (0, $3G7m1.getImageUrl)("", "", sport, c.htid) : null,
            score: hs ?? "-",
            form: c.htf
        },
        away: {
            name: c.atn,
            flag: c.atid ? (0, $3G7m1.getImageUrl)("", "", sport, c.atid) : null,
            score: as ?? "-",
            form: c.atf
        },
        timeline: timeline,
        events: $63a37370dc0a1ebe$var$normalizeEvents(events),
        meta: {
            date: $63a37370dc0a1ebe$var$formatMatchDate(match.dt, difference),
            venue: match.venue?.name || match.std || "",
            referee: match.match_official?.official?.name || "",
            attendance: $63a37370dc0a1ebe$var$fmtAttendance(match.attendance ?? match.spectators)
        },
        kickoff: match.dt
    };
};
// ── Small pieces ────────────────────────────────────────────────────────────
const $63a37370dc0a1ebe$var$FormDots = ({ form: form = [] })=>{
    if (!form?.length) return null;
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "eh__form",
        children: form.slice(0, 5).reverse().map((r, i)=>{
            const k = String(r || "").toUpperCase();
            const mod = k === "W" ? "w" : k === "L" ? "l" : "d";
            return /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                className: `eh__dot eh__dot--${mod}`,
                title: k,
                children: k || mod.toUpperCase()
            }, i);
        })
    });
};
const $63a37370dc0a1ebe$var$Flag = ({ flag: flag, name: name })=>/*#__PURE__*/ (0, $lBpE3.jsx)("span", {
        className: "eh__flag",
        children: typeof flag === "string" ? /*#__PURE__*/ (0, $lBpE3.jsx)("img", {
            src: flag,
            alt: name ? `${name} logo` : ""
        }) : flag || null
    });
const $63a37370dc0a1ebe$var$EventIcon = ({ kind: kind })=>kind === "goal" ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
        className: "eh__event-ico eh__event-ico--goal",
        "aria-hidden": "true",
        children: "\u26BD"
    }) : /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
        className: `eh__event-ico eh__event-ico--card eh__card--${kind}`,
        "aria-hidden": "true"
    });
const $63a37370dc0a1ebe$var$EventRow = ({ ev: ev })=>/*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: `eh__event eh__event--${ev.isHome ? "home" : "away"}`,
        children: ev.isHome ? /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsx)($63a37370dc0a1ebe$var$EventIcon, {
                    kind: ev.kind
                }),
                /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                    className: "eh__event-min",
                    children: [
                        ev.mins,
                        "'"
                    ]
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                    className: "eh__event-player",
                    children: ev.player
                })
            ]
        }) : /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                    className: "eh__event-player",
                    children: ev.player
                }),
                /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                    className: "eh__event-min",
                    children: [
                        ev.mins,
                        "'"
                    ]
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)($63a37370dc0a1ebe$var$EventIcon, {
                    kind: ev.kind
                })
            ]
        })
    });
// Live countdown (Days / Hrs / Min / Sec). `targetMs` is the ABSOLUTE kickoff epoch (UTC);
// subtracting Date.now() (also absolute) gives the true remaining time on any device, with zero
// timezone math. `whenText` is the viewer-local kickoff label shown underneath for context.
const $63a37370dc0a1ebe$var$Countdown = ({ targetMs: targetMs, whenText: whenText })=>{
    const calc = ()=>{
        const diff = targetMs - Date.now();
        if (isNaN(diff) || diff <= 0) return {
            d: 0,
            h: 0,
            m: 0,
            s: 0
        };
        return {
            d: Math.floor(diff / 86400000),
            h: Math.floor(diff / 3600000 % 24),
            m: Math.floor(diff / 60000 % 60),
            s: Math.floor(diff / 1000 % 60)
        };
    };
    const [t, setT] = (0, $6cds3.useState)(calc);
    (0, $6cds3.useEffect)(()=>{
        const id = setInterval(()=>setT(calc()), 1000);
        return ()=>clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        targetMs
    ]);
    const cell = (n, l)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
            className: "eh__cd-cell",
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                    className: "eh__cd-num",
                    children: String(n).padStart(2, "0")
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                    className: "eh__cd-lbl",
                    children: l
                })
            ]
        });
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "eh__countdown",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                className: "eh__cd-title",
                children: "Kicks off in"
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "eh__cd-cells",
                children: [
                    cell(t.d, "Days"),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "eh__cd-sep",
                        children: ":"
                    }),
                    cell(t.h, "Hrs"),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "eh__cd-sep",
                        children: ":"
                    }),
                    cell(t.m, "Min"),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "eh__cd-sep",
                        children: ":"
                    }),
                    cell(t.s, "Sec")
                ]
            }),
            whenText ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                className: "eh__cd-when",
                children: whenText
            }) : null
        ]
    });
};
const $63a37370dc0a1ebe$var$Svg = ({ children: children })=>/*#__PURE__*/ (0, $lBpE3.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true",
        children: children
    });
const $63a37370dc0a1ebe$var$ICONS = {
    date: /*#__PURE__*/ (0, $lBpE3.jsxs)($63a37370dc0a1ebe$var$Svg, {
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("rect", {
                x: "3",
                y: "4",
                width: "18",
                height: "18",
                rx: "2"
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                d: "M16 2v4M8 2v4M3 10h18"
            })
        ]
    }),
    venue: /*#__PURE__*/ (0, $lBpE3.jsxs)($63a37370dc0a1ebe$var$Svg, {
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                d: "M12 21s-7-6.4-7-11a7 7 0 0 1 14 0c0 4.6-7 11-7 11z"
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("circle", {
                cx: "12",
                cy: "10",
                r: "2.5"
            })
        ]
    }),
    referee: /*#__PURE__*/ (0, $lBpE3.jsxs)($63a37370dc0a1ebe$var$Svg, {
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("circle", {
                cx: "12",
                cy: "8",
                r: "4"
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                d: "M4 21a8 8 0 0 1 16 0"
            })
        ]
    }),
    attendance: /*#__PURE__*/ (0, $lBpE3.jsxs)($63a37370dc0a1ebe$var$Svg, {
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("circle", {
                cx: "9",
                cy: "7",
                r: "4"
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                d: "M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"
            })
        ]
    })
};
// ── Main component ────────────────────────────────────────────────────────────
const $63a37370dc0a1ebe$var$EditorialHeader = ({ dataId: dataId, baseUrl: baseUrl, sport: sport = "football", difference: difference = "+0", socketUrl: socketUrl, match: matchProp = null, dataClient: dataClient = false, // explicit / demo props:
state: stateProp, competition: competition, stage: stage, status: status, home: home, away: away, timeline: timeline, events: eventsProp, meta: meta, kickoff: kickoff, loadCSS: loadCSS = true })=>{
    const explicit = !!(home && home.name);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === true || loadCSS === "true") (0, $2bSDe.loadStyles)("editorialHeader");
    }, [
        loadCSS
    ]);
    // Dynamic CSS variables — fetch /settings → inject <style id="dynamic-colors">
    (0, $6cds3.useEffect)(()=>{
        if (!baseUrl) return;
        let cancelled = false;
        fetch(`${baseUrl}/settings`, {
            headers: {
                Token: undefined,
                "Content-Type": "application/json",
                Accept: "application/json"
            }
        }).then((r)=>r.ok ? r.json() : Promise.reject(r.statusText)).then((settings)=>{
            if (cancelled) return;
            const css = (0, $2d22661aa7fb4cf1$export$a964851a84ddc42f)(settings);
            let tag = document.getElementById("dynamic-colors");
            if (!tag) {
                tag = document.createElement("style");
                tag.id = "dynamic-colors";
                document.head.appendChild(tag);
            }
            tag.textContent = css;
        }).catch((err)=>console.warn("EditorialHeader: settings load failed \u2014", err));
        return ()=>{
            cancelled = true;
        };
    }, [
        baseUrl
    ]);
    // Data sources (priority): SSR props → hydration DOM → embed self-fetch
    const [match, setMatch] = (0, $6cds3.useState)(matchProp || null);
    const [events, setEvents] = (0, $6cds3.useState)(eventsProp || []);
    // SSR: sync incoming props into state
    (0, $6cds3.useEffect)(()=>{
        if (matchProp) setMatch(matchProp);
    }, [
        matchProp
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (eventsProp) setEvents(eventsProp);
    }, [
        eventsProp
    ]);
    // Hydration: re-read the serialized { headData, data } off the container
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        try {
            const raw = document.querySelector(".microservice-cont")?.getAttribute("data-listingdata");
            if (!raw) return;
            const parsed = JSON.parse(raw);
            if (parsed?.headData?.data) setMatch(parsed.headData.data);
            setEvents(parsed?.data?.summary?.timeline || []);
        } catch (e) {
            console.error("[EditorialHeader] data-listingdata parse error:", e);
        }
    }, [
        dataClient
    ]);
    // Embed: self-fetch head (detail) + events (summary) together
    (0, $6cds3.useEffect)(()=>{
        if (explicit || dataClient || matchProp || !dataId || !baseUrl) return;
        let cancelled = false;
        Promise.all([
            (0, $zSRJd.getData)({
                dataId: dataId,
                dataType: "match",
                baseUrl: baseUrl,
                sport: sport,
                difference: difference
            }),
            (0, $zSRJd.getData)({
                dataId: dataId,
                dataType: "match-summary",
                baseUrl: baseUrl,
                sport: sport,
                difference: difference
            })
        ]).then(([detail, summary])=>{
            if (cancelled) return;
            setMatch(detail?.data || detail?.match || detail || null);
            setEvents(summary?.summary?.timeline || []);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        explicit,
        dataClient,
        matchProp,
        dataId,
        baseUrl,
        sport,
        difference
    ]);
    // Live minute — seed from match.mins (the live-minute field), +1 every 60s while live
    // (reseeded when the socket pushes a new mins/status).
    const isLiveNow = $63a37370dc0a1ebe$var$isLiveStatus(match);
    const [liveMinute, setLiveMinute] = (0, $6cds3.useState)(null);
    const timerRef = (0, $6cds3.useRef)(null);
    (0, $6cds3.useEffect)(()=>{
        clearInterval(timerRef.current);
        const m = parseInt(match?.mins ?? match?.cp, 10);
        if (isLiveNow && !isNaN(m)) {
            setLiveMinute(m);
            timerRef.current = setInterval(()=>setLiveMinute((p)=>p != null ? p + 1 : p), 60000);
        } else setLiveMinute(null);
        return ()=>clearInterval(timerRef.current);
    }, [
        match?.mins,
        match?.cp,
        isLiveNow
    ]);
    // Real-time — subscribe to the match socket; merge score/status, re-fetch events on score change
    const resolvedSocketUrl = explicit ? "" : socketUrl || "https://socket-bolsaas.6lgx.com/";
    const socket = (0, $gtwOm.useSocket)(resolvedSocketUrl);
    const lastScoreRef = (0, $6cds3.useRef)(null);
    (0, $6cds3.useEffect)(()=>{
        if (explicit || !socket || !dataId) return;
        const channel = "FootballMatch";
        const event = `FootballMatchDetails-${dataId}`;
        const handler = (e)=>{
            const incoming = e?.data?.data;
            if (!incoming || String(incoming.id) !== String(dataId)) return;
            setMatch((prev)=>({
                    ...prev || {},
                    ...incoming
                }));
            if (incoming.cfs && incoming.cfs !== lastScoreRef.current && baseUrl) {
                lastScoreRef.current = incoming.cfs;
                (0, $zSRJd.getData)({
                    dataId: dataId,
                    dataType: "match-summary",
                    baseUrl: baseUrl,
                    sport: sport,
                    difference: difference
                }).then((r)=>setEvents(r?.summary?.timeline || []));
            }
        };
        socket.channel(channel)?.listen(event, handler);
        return ()=>{
            try {
                socket.channel(channel)?.stopListening(event, handler);
            } catch (_) {}
        };
    }, [
        socket,
        dataId,
        baseUrl,
        sport,
        difference,
        explicit
    ]);
    // Build the view model
    let view;
    if (explicit) {
        const evList = $63a37370dc0a1ebe$var$normalizeEvents(eventsProp);
        const inferred = stateProp || (/'$/.test(String(status || "")) ? "live" : /ft|full|aet|finished|pens/i.test(String(status || "")) ? "finished" : "upcoming");
        view = {
            state: inferred,
            isLive: inferred === "live",
            isUpcoming: inferred === "upcoming",
            isFinished: inferred === "finished",
            winnerSide: inferred === "finished" && home?.score != null && away?.score != null ? Number(home.score) > Number(away.score) ? "home" : Number(away.score) > Number(home.score) ? "away" : null : null,
            competition: competition,
            stage: stage,
            statusLabel: status,
            home: home || {},
            away: away || {},
            timeline: timeline || [],
            events: evList,
            meta: meta || {},
            kickoff: kickoff
        };
    } else view = $63a37370dc0a1ebe$var$deriveView(match, events, sport, difference, liveMinute);
    if (!view || !explicit && !match) return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "eh eh--loading",
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
            children: "Loading match\u2026"
        })
    });
    const { competition: comp = "", stage: stg = "", statusLabel: statusLabel = "", isLive: isLive = false, isUpcoming: isUpcoming = false, home: H = {}, away: A = {}, timeline: TL = [], events: EV = [], meta: M = {}, state: state = "finished", winnerSide: winnerSide = null, pens: pens = null, isAet: isAet = false } = view;
    const title = [
        comp,
        stg
    ].filter(Boolean).join(" \xb7 ");
    const hasFooter = M && (M.date || M.venue || M.referee || M.attendance);
    // Countdown target — the ABSOLUTE kickoff instant (match.dt is UTC). Date.now() is also
    // absolute, so the remaining time is correct on every device, no timezone math involved.
    let cdTargetMs = null;
    if (isUpcoming && view.kickoff) {
        const ms = $63a37370dc0a1ebe$var$kickoffMs(view.kickoff);
        if (!isNaN(ms)) cdTargetMs = ms;
    }
    // Match-minute timeline layout: place goals + cards on the actual clock.
    // matchEnd = 90 (or 120 when the match ran to extra time). Events that land in
    // the same minute-window share ONE marker + ONE connector line (e.g. a 90'
    // yellow card + a 90' goal show as "90'" once, with the chip and ⚽ together).
    const matchEnd = EV.some((e)=>(parseInt(e.mins, 10) || 0) > 90) ? 120 : 90;
    const GAP_MIN = 3; // events within this many minutes are grouped onto one marker/line
    const MIN_GAP = 0.1; // min horizontal spacing between markers (fraction of the line)
    const mmin = (e)=>parseInt(e.mins, 10) || 0;
    const placed = [];
    [
        "home",
        "away"
    ].forEach((side)=>{
        const arr = EV.filter((e)=>(e.isHome ? "home" : "away") === side); // minute-sorted
        const clusters = [];
        let i = 0;
        while(i < arr.length){
            let j = i;
            while(j + 1 < arr.length && mmin(arr[j + 1]) - mmin(arr[j]) <= GAP_MIN)j++;
            const cluster = arr.slice(i, j + 1);
            const mins = mmin(cluster[0]);
            clusters.push({
                side: side,
                mins: mins,
                frac: Math.max(0, Math.min(1, mins / matchEnd)),
                // full per-event detail — icons on the line + the hover tooltip both read from this
                items: cluster.map((e)=>({
                        kind: e.kind,
                        typ: e.typ,
                        player: e.player,
                        mins: mmin(e)
                    }))
            });
            i = j + 1;
        }
        // Collision avoidance: a busy match (many cards/goals close together) would otherwise pile the
        // markers on top of each other. Nudge any marker sitting within MIN_GAP of the previous one to
        // the right; order + true minute (shown on the label/tooltip) are kept, only the x is adjusted.
        for(let k = 1; k < clusters.length; k++)if (clusters[k].frac < clusters[k - 1].frac + MIN_GAP) clusters[k].frac = clusters[k - 1].frac + MIN_GAP;
        // if the spread pushed the last marker past the end of the line, shift the whole row back left
        const overshoot = clusters.length ? clusters[clusters.length - 1].frac - 1 : 0;
        if (overshoot > 0) clusters.forEach((c)=>c.frac = Math.max(0, c.frac - overshoot));
        placed.push(...clusters);
    });
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: `eh eh--${state}`,
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "eh__top",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "eh__competition",
                        children: title
                    }),
                    statusLabel ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: `eh__status${isLive ? " eh__status--live" : ""}`,
                        children: statusLabel
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "eh__main",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: `eh__team eh__team--home${winnerSide === "home" ? " eh__team--win" : ""}`,
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                className: "eh__id",
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                        className: "eh__nameline",
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: "eh__name",
                                                children: H.name
                                            }),
                                            winnerSide === "home" && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: "eh__trophy",
                                                "aria-hidden": "true",
                                                children: "\uD83C\uDFC6"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)($63a37370dc0a1ebe$var$FormDots, {
                                        form: H.form
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)($63a37370dc0a1ebe$var$Flag, {
                                flag: H.flag,
                                name: H.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "eh__score",
                        children: isUpcoming ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                            className: "eh__vs",
                            children: "VS"
                        }) : /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                    className: "eh__score-line",
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                            className: `eh__score-num${winnerSide === "home" ? " eh__score-num--win" : ""}`,
                                            children: H.score ?? "-"
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                            className: "eh__score-sep",
                                            children: "\u2013"
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                            className: `eh__score-num${winnerSide === "away" ? " eh__score-num--win" : ""}`,
                                            children: A.score ?? "-"
                                        })
                                    ]
                                }),
                                (isAet || pens) && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                    className: "eh__aet",
                                    children: "After Extra Time"
                                }),
                                pens && (()=>{
                                    const [ph = "", pa = ""] = String(pens).split(/[-:]/);
                                    return /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                        className: "eh__pens",
                                        children: [
                                            "PEN ",
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("b", {
                                                children: ph.trim()
                                            }),
                                            " - ",
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("b", {
                                                children: pa.trim()
                                            })
                                        ]
                                    });
                                })()
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: `eh__team eh__team--away${winnerSide === "away" ? " eh__team--win" : ""}`,
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)($63a37370dc0a1ebe$var$Flag, {
                                flag: A.flag,
                                name: A.name
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                className: "eh__id",
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                        className: "eh__nameline",
                                        children: [
                                            winnerSide === "away" && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: "eh__trophy",
                                                "aria-hidden": "true",
                                                children: "\uD83C\uDFC6"
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: "eh__name",
                                                children: A.name
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)($63a37370dc0a1ebe$var$FormDots, {
                                        form: A.form
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            isUpcoming && cdTargetMs != null && /*#__PURE__*/ (0, $lBpE3.jsx)($63a37370dc0a1ebe$var$Countdown, {
                targetMs: cdTargetMs,
                whenText: $63a37370dc0a1ebe$var$kickoffLabel(view.kickoff, difference)
            }),
            !isUpcoming && EV.length > 0 && /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "eh__mtl",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "eh__mtl-line"
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "eh__mtl-tick",
                        style: {
                            left: `calc(10px + (100% - 20px) * ${45 / matchEnd})`
                        },
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                            className: "eh__mtl-tlabel",
                            children: "HT"
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: `eh__mtl-tick${matchEnd === 90 ? " eh__mtl-tick--active" : ""}`,
                        style: {
                            left: `calc(10px + (100% - 20px) * ${90 / matchEnd})`
                        },
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                            className: "eh__mtl-tlabel",
                            children: "FT"
                        })
                    }),
                    matchEnd > 90 && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "eh__mtl-tick eh__mtl-tick--active",
                        style: {
                            left: "calc(100% - 10px)"
                        },
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                            className: "eh__mtl-tlabel",
                            children: "AET"
                        })
                    }),
                    placed.map((c, i)=>{
                        // keep the tooltip inside the card: anchor it left/right for edge markers
                        const tip = c.frac < 0.2 ? "s" : c.frac > 0.8 ? "e" : "c";
                        // aria-label (not title) → screen-reader accessible without a second native tooltip
                        const label = c.items.map((it)=>`${it.mins}' ${it.typ} \u{2014} ${it.player}`).join(", ");
                        return /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                            className: `eh__mev eh__mev--${c.side} eh__mev--tip-${tip}`,
                            style: {
                                left: `calc(10px + (100% - 20px) * ${c.frac})`
                            },
                            "aria-label": label,
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                    className: "eh__mev-min",
                                    children: [
                                        c.mins,
                                        "'"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                    className: "eh__mev-icons",
                                    children: c.items.map((it, k)=>it.kind === "goal" ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                            className: "eh__mev-node eh__mev-node--goal",
                                            "aria-hidden": "true",
                                            children: "\u26BD"
                                        }, k) : /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                            className: `eh__mev-node eh__mev-node--card eh__card--${it.kind}`,
                                            "aria-hidden": "true"
                                        }, k))
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                    className: "eh__mev-tip",
                                    role: "tooltip",
                                    children: c.items.map((it, k)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                            className: "eh__tip-row",
                                            children: [
                                                it.kind === "goal" ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    className: "eh__tip-ico eh__tip-ico--goal",
                                                    "aria-hidden": "true",
                                                    children: "\u26BD"
                                                }) : /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    className: `eh__tip-ico eh__tip-chip eh__card--${it.kind}`,
                                                    "aria-hidden": "true"
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                    className: "eh__tip-txt",
                                                    children: [
                                                        /*#__PURE__*/ (0, $lBpE3.jsx)("b", {
                                                            children: it.player
                                                        }),
                                                        " \xb7 ",
                                                        it.typ,
                                                        " ",
                                                        it.mins,
                                                        "'"
                                                    ]
                                                })
                                            ]
                                        }, k))
                                })
                            ]
                        }, `${c.side}-${c.mins}-${i}`);
                    })
                ]
            }),
            hasFooter && /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "eh__footer",
                children: [
                    M.date && /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                        className: "eh__meta",
                        children: [
                            $63a37370dc0a1ebe$var$ICONS.date,
                            M.date
                        ]
                    }),
                    M.venue && /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                        className: "eh__meta",
                        children: [
                            $63a37370dc0a1ebe$var$ICONS.venue,
                            M.venue
                        ]
                    }),
                    M.referee && /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                        className: "eh__meta",
                        children: [
                            $63a37370dc0a1ebe$var$ICONS.referee,
                            M.referee
                        ]
                    }),
                    M.attendance && /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                        className: "eh__meta",
                        children: [
                            $63a37370dc0a1ebe$var$ICONS.attendance,
                            M.attendance
                        ]
                    })
                ]
            })
        ]
    });
};
var $63a37370dc0a1ebe$export$2e2bcd8739ae039 = $63a37370dc0a1ebe$var$EditorialHeader;


const $0b80bbeb30321bf8$var$MatchWidgetWrap = ({ dataId: dataId, dataType: dataType, sport: sport, difference: difference, head: head, data: data, headData: headData, otherData: otherData, baseUrl: baseUrl, loadCSS: loadCSS, setDataId: setDataId, setDataType: setDataType, setHead: setHead, setLeagueId: setLeagueId, dataClient: dataClient = false, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataTitle: dataTitle, liveCentre: liveCentre = false, socketUrl: socketUrl = "", channel: channel = "FootballMatch", event: event = `FootballMatchDetails` })=>{
    const withHead = (currentTab, Component, props = {})=>head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
            children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $cc0e4da7c5a2120d$export$2e2bcd8739ae039), {
                matchDetail: headData,
                difference: difference,
                sport: sport,
                dataClient: dataClient,
                id: dataId,
                currentTab: currentTab,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                title: dataTitle,
                socketUrl: socketUrl,
                channel: channel,
                event: event + `-${dataId}`,
                children: /*#__PURE__*/ (0, $lBpE3.jsx)(Component, {
                    ...props
                })
            })
        }) : /*#__PURE__*/ (0, $lBpE3.jsx)(Component, {
            ...props,
            title: dataTitle
        });
    switch(dataType){
        case "match-table":
            return withHead("table", (0, $3bb918d7b03f1ba4$export$2e2bcd8739ae039), {
                ServerData: data?.data,
                loadCSS: loadCSS,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                sport: sport
            });
        case "match-h2h":
            return withHead("h2h", (0, $62b4ee31d2bc99dc$export$2e2bcd8739ae039), {
                serverData: data?.data,
                loadCSS: loadCSS,
                setDataType: setDataType,
                setDataId: setDataId,
                setHead: setHead,
                setLeagueId: setLeagueId,
                dataClient: dataClient,
                liveCentre: liveCentre
            });
        case "match-stats":
            return withHead("stats", (0, $ef8eecb0ad76f456$export$2e2bcd8739ae039), {
                data: data?.data,
                loadCSS: loadCSS,
                dataClient: dataClient
            });
        case "match-lineup":
            // Self-contained widget with its own header (crest/coach/formation) — no generic Head wrap.
            return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $7c7ef8b1fa9bd4ec$export$2e2bcd8739ae039), {
                serverData: data?.data,
                dataId: dataId,
                baseUrl: baseUrl,
                sport: sport,
                difference: difference,
                loadCSS: loadCSS,
                dataClient: dataClient
            });
        case "match-info":
            return withHead("info", (0, $254daca3f12a10f3$export$2e2bcd8739ae039), {
                data: data?.summary,
                difference: difference,
                loadCSS: loadCSS,
                dataClient: dataClient,
                matchDetail: headData
            });
        case "match-timeline":
            return withHead("events", (0, $29ddb6bc6c3e1f40$export$2e2bcd8739ae039), {
                data: data?.summary,
                loadCSS: loadCSS,
                dataClient: dataClient,
                matchDetail: headData
            });
        case "match-summary":
            return withHead("events", (0, $5037a3f4b7bc44bc$export$2e2bcd8739ae039), {
                data: data?.summary,
                commData: otherData,
                id: dataId,
                loadCSS: loadCSS,
                dataClient: dataClient
            });
        case "match-com":
            return withHead("commentary", (0, $15e40c9cf1b1f405$export$2e2bcd8739ae039), {
                data: data,
                difference: difference,
                loadCSS: loadCSS,
                dataClient: dataClient,
                id: dataId,
                matchDetail: headData,
                baseUrl: baseUrl
            });
        case "match-news":
            return withHead("news", (0, $4c03dbc6caeb65b2$export$2e2bcd8739ae039), {
                data: data,
                difference: difference,
                loadCSS: loadCSS,
                dataClient: dataClient,
                id: dataId,
                baseUrl: baseUrl
            });
        case "match":
            return head && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $cc0e4da7c5a2120d$export$2e2bcd8739ae039), {
                matchDetail: headData,
                difference: difference,
                sport: sport,
                dataType: dataType,
                setDataType: setDataType,
                setDataId: setDataId,
                setHead: setHead,
                setLeagueId: setLeagueId,
                dataClient: dataClient
            });
        case "match-page":
            return head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $cc0e4da7c5a2120d$export$2e2bcd8739ae039), {
                matchDetail: headData,
                difference: difference,
                sport: sport,
                dataType: dataType,
                setDataType: setDataType,
                setDataId: setDataId,
                setHead: setHead,
                setLeagueId: setLeagueId,
                dataClient: dataClient,
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $bed8b294a9aeadb8$export$2e2bcd8739ae039), {
                    data: data?.data,
                    baseUrl: baseUrl,
                    dataType: dataType,
                    difference: difference,
                    sport: sport,
                    dataId: dataId,
                    commData: otherData,
                    loadCSS: loadCSS,
                    headData: headData,
                    setDataType: setDataType,
                    setDataId: setDataId,
                    setHead: setHead,
                    setLeagueId: setLeagueId
                })
            }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $bed8b294a9aeadb8$export$2e2bcd8739ae039), {
                data: data?.data,
                baseUrl: baseUrl,
                dataType: dataType,
                difference: difference,
                sport: sport,
                dataId: dataId,
                commData: otherData,
                loadCSS: loadCSS,
                setDataType: setDataType,
                setDataId: setDataId,
                setHead: setHead,
                setLeagueId: setLeagueId
            });
        case "match-editorial":
            // Self-contained head: teams/score/status + goals/cards, no <Head> wrapper.
            // Pair the /loadwidget call with head=match so headData carries the detail.
            return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $63a37370dc0a1ebe$export$2e2bcd8739ae039), {
                match: headData?.data,
                events: data?.summary?.timeline,
                sport: sport,
                difference: difference,
                loadCSS: loadCSS,
                dataClient: dataClient,
                dataId: dataId,
                baseUrl: baseUrl,
                socketUrl: socketUrl
            });
        default:
            return /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: "Widget Not Found in football Match!"
            });
    }
};
var $0b80bbeb30321bf8$export$2e2bcd8739ae039 = $0b80bbeb30321bf8$var$MatchWidgetWrap;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $ba5nK = parcelRequire("ba5nK");

var $3G7m1 = parcelRequire("3G7m1");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $3G7m1 = parcelRequire("3G7m1");
// Adjust path if needed
const $a86a20bf38fe5091$var$Tabs = ({ data: data = [], type: type = "", countShow: countShow = false, sport: sport = "football", name: name, id: id, clas: clas = "", state: state = "team", dictionary: dictionary, currentTab: currentTab, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath })=>{
    const getActiveClass = (tabName)=>{
        if (!currentTab) return "";
        if (type === "newsTab") return currentTab.toLowerCase() === tabName?.toLowerCase()?.replace('-', ' ') ? "active" : "";
        const tabKey = tabName.replaceAll("_", "-").toLowerCase();
        return currentTab.toLowerCase() === tabKey || currentTab === "/" && tabName === "My Matches" ? "active" : "";
    };
    return /*#__PURE__*/ (0, $lBpE3.jsx)("nav", {
        className: `main_tab ${clas}`,
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
            className: "nav nav_tabs",
            children: data?.map((val, ind)=>{
                const tabLabel = countShow ? val?.tabName : val?.replaceAll("_", " ");
                const isActive = getActiveClass(tabLabel);
                const getFormattedLink = (val)=>{
                    const base = websiteBaseUrl || "";
                    const path = dataPath || sport;
                    const slug = val.replaceAll("_", "-");
                    return `${base}/${path}/${sport === 'tennis' && state === 'team' ? 'player' : state}/${sport === 'tennis' ? name?.split("-").at(-1)?.trim() : (0, $3G7m1.titleToSlug)(name)}/${id}/${slug}`;
                };
                const link = countShow ? val?.link : getFormattedLink(val);
                const label = countShow ? val?.tabName : (dictionary?.[val?.replaceAll("_", "")] || val.charAt(0).toUpperCase() + val.slice(1)).replaceAll("_", " ");
                return /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                        className: isActive,
                        href: link,
                        children: label
                    })
                }, (0, $3G7m1.uniqueId)(ind));
            })
        })
    });
};
var $a86a20bf38fe5091$export$2e2bcd8739ae039 = $a86a20bf38fe5091$var$Tabs;


const $0881f34d53fa6722$var$LeagMainHead = ({ headData: headData, countary: countary, children: children, dataClient: dataClient, currentTab: currentTab, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, id: id, widgetTitle: widgetTitle, state: state = "league", sport: sport = "football" })=>{
    const [clientHeadData, setClientHeadData] = (0, $6cds3.useState)(null);
    const baseURL = "https://ipublisher-microservices.6lgx.com";
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document.querySelector(".microservice-cont");
        const dataAttr = container?.getAttribute("data-listingdata");
        if (dataAttr) try {
            const parsed = sport === 'golf' && state === 'player' ? JSON.parse(dataAttr)?.data : JSON.parse(dataAttr)?.headData;
            setClientHeadData(parsed);
        } catch (error) {
            console.error("Failed to parse headData:", error);
        }
    }, [
        dataClient
    ]);
    const sourceData = dataClient ? clientHeadData?.data : headData?.data;
    const tabsData = (0, $3G7m1.getTabsData)(dataClient, clientHeadData, headData, sourceData, sport, state) || [];
    const imgId = (0, $3G7m1.getImageId)(state, sport, sourceData);
    const imgUrl = (0, $3G7m1.getImageUrl)(baseURL, state, sport, imgId);
    const title = sourceData?.nm || sourceData?.name;
    const manager = sourceData?.mang;
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "leag_head2",
                children: [
                    widgetTitle && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                        children: widgetTitle
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "leag_main_head",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                className: "up_head",
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                        className: "up_wrap",
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                className: "icon_flag",
                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                    src: imgUrl,
                                                    width: 60,
                                                    height: 60,
                                                    alt: "leag",
                                                    priority: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                                className: "info_wrap",
                                                children: [
                                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                        className: "a",
                                                        children: [
                                                            /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                                className: "name",
                                                                children: title
                                                            }),
                                                            countary && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                className: "country_name",
                                                                children: countary
                                                            })
                                                        ]
                                                    }),
                                                    state === "team" && /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                                                        className: "result_list",
                                                        children: sourceData?.form?.map((result, index)=>/*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                                                className: (0, $3G7m1.getClassForResult)(result),
                                                                children: result
                                                            }, index))
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "more cursor_pointer"
                                    })
                                ]
                            }),
                            manager && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: "venue_wrap",
                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: "lb",
                                                children: "Manager :"
                                            }),
                                            " ",
                                            manager
                                        ]
                                    })
                                })
                            }),
                            state === "player" && sport === 'football' && (manager?.dob !== null || manager?.height || manager?.weight) && sourceData && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: "venue_wrap",
                                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("ul", {
                                    children: [
                                        sourceData?.dob && /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                    className: "lb",
                                                    children: [
                                                        "Date of Birth:",
                                                        " :"
                                                    ]
                                                }),
                                                sourceData?.dob
                                            ]
                                        }),
                                        sourceData?.height && /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                    className: "lb",
                                                    children: [
                                                        "Height:",
                                                        " :"
                                                    ]
                                                }),
                                                `${sourceData?.height} cm`
                                            ]
                                        }),
                                        sourceData?.weight && /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                    className: "lb",
                                                    children: [
                                                        "Weight:",
                                                        " :"
                                                    ]
                                                }),
                                                `${sourceData?.weight} kg`
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    dataClient && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $a86a20bf38fe5091$export$2e2bcd8739ae039), {
                        clas: "main_tab2",
                        data: (0, $3G7m1.buildTabsList)(sport, state, tabsData),
                        sport: sport,
                        name: (0, $3G7m1.titleToSlug)(title),
                        id: id,
                        state: state,
                        currentTab: currentTab,
                        websiteBaseUrl: websiteBaseUrl,
                        dataPath: dataPath
                    })
                ]
            }),
            children
        ]
    });
};
var $0881f34d53fa6722$export$2e2bcd8739ae039 = $0881f34d53fa6722$var$LeagMainHead;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $zSRJd = parcelRequire("zSRJd");

var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $3G7m1 = parcelRequire("3G7m1");

var $kybuc = parcelRequire("kybuc");

var $ba5nK = parcelRequire("ba5nK");


var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");
const $5398424c63d72b5c$var$MatchScores = ({ score: score, winner: winner })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "cl_score",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                className: `score ${winner?.split("-")[0] > winner?.split("-")[1] ? "bold" : ""}`,
                children: score?.split("-")[0]
            }),
            " ",
            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                className: `score ${winner?.split("-")[1] > score?.split("-")[0] ? "bold" : ""}`,
                children: score?.split("-")[1]
            })
        ]
    });
};
var $5398424c63d72b5c$export$2e2bcd8739ae039 = $5398424c63d72b5c$var$MatchScores;



var $XBIJN = parcelRequire("XBIJN");

var $2bSDe = parcelRequire("2bSDe");
const $d7c3bcbf98681d67$var$Matches = ({ data: data, difference: difference, matchType: matchType, loadCSS: loadCSS, sport: sport, setDataId: setDataId, setDataType: setDataType, setHead: setHead, setLeagueId: setLeagueId })=>{
    const handleClick = async (sport, match)=>{
        setDataId(match?.id);
        setDataType("match-page");
        setHead("match");
    };
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("leaguepage");
    }, [
        loadCSS
    ]);
    if (!data) return /*#__PURE__*/ (0, $lBpE3.jsx)("h3", {
        children: "Loading..."
    });
    if (!data || data && data?.length === 0) return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "leg_wrp",
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
            className: "leg_box",
            children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "text-center",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {})
            })
        })
    });
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "leg_wrp",
        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
            className: "leg_box",
            children: [
                matchType === "upcoming" && !data[0]?.nm && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: "leg_head",
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                            className: "name",
                            children: "Upcoming Matches"
                        })
                    })
                }),
                data?.map((league)=>/*#__PURE__*/ (0, $lBpE3.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Fragment, {
                        children: [
                            matchType === "finished" && league?.matches[0].competitors !== null && !league?.lid && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: "leg_head",
                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "name",
                                        children: (0, $3G7m1.convertDateTime)(league?.d)
                                    })
                                })
                            }),
                            league?.lid && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: "leg_head ",
                                style: {
                                    cursor: "pointer"
                                },
                                onClick: ()=>{
                                    setDataId(league?.id);
                                    setDataType("league-page");
                                    setHead("league");
                                    setLeagueId(league?.id);
                                },
                                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                    className: "team_head",
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                            class: "league_logo",
                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                src: `${"https://ipublisher-microservices.6lgx.com"}/public/assets/images/flags/country_${league?.fid}.png`,
                                                height: 23,
                                                width: 23,
                                                alt: "teamLogo",
                                                priority: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: "name",
                                                children: league?.nm
                                            })
                                        })
                                    ]
                                })
                            }),
                            league?.matches.map((match)=>{
                                let score = (0, $XBIJN.MatchOptions)?.footballFTStatuses?.includes(match?.st?.toLowerCase()) ? match?.ft : match?.cfs;
                                let winner = score;
                                if (match?.mins === "FAP") winner = match?.ps;
                                return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
                                    children: match?.competitors !== null && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                        className: "leg_body",
                                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                            className: "leg_row rugby_leg_row finesh false",
                                            onClick: ()=>handleClick(sport, match),
                                            style: {
                                                cursor: "pointer"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    className: "match_list_date_status",
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                        className: "status_wrp",
                                                        children: [
                                                            match?.st === "Delayed" && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                className: "status",
                                                                children: "Dly"
                                                            }),
                                                            match?.st === "Postponed" && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                className: "sts_tg red ",
                                                                children: "PPD"
                                                            }),
                                                            match?.st === "Abandoned" && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                className: "sts_tg red",
                                                                children: "AB"
                                                            }),
                                                            match?.st === "Cancelled" && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                className: "sts_tg red",
                                                                children: "AB"
                                                            }),
                                                            match?.st === "Finished" && match?.mins === "To Finish" ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                className: "status",
                                                                children: "To FT"
                                                            }) : match?.st === "Finished" && match?.mins === "FAP" && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                className: "status red",
                                                                children: "FAP"
                                                            }),
                                                            match?.st === "TF" && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                className: "status red",
                                                                children: "TF"
                                                            }),
                                                            match?.st === "Finished" && match?.mins !== "FAP" && match?.mins !== "FAET" && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                className: "sts_tg",
                                                                children: "Finished"
                                                            }),
                                                            match?.st === "Finished" && match?.mins === "FAET" && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                className: "sts_tg",
                                                                children: "FAET"
                                                            }),
                                                            match?.st === "NSY" && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                className: "sts_tg",
                                                                children: "NSY"
                                                            }),
                                                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                className: "status",
                                                                children: `${(0, $kybuc.DateUtility).dateFormat1(match?.dt)} ${matchType === "upcoming" && match?.st !== "Postponed" && match?.st !== "Abandoned" && match?.st !== "Cancelled" ? "|" : ""}`
                                                            }),
                                                            matchType === "upcoming" && match?.st !== "Postponed" && match?.st !== "Abandoned" && match?.st !== "Cancelled" && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                className: "date",
                                                                children: (0, $kybuc.DateUtility).ConvertCETtoCurrentTimeZone(match?.dt, difference)
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                    className: "leg_inf_inner",
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                                        className: "leg_inf",
                                                        children: [
                                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                                                className: "cl_team",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                        className: "flag",
                                                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                                            src: (0, $3G7m1.getImageUrl)('', '', sport, match?.competitors?.htid),
                                                                            height: 23,
                                                                            width: 23,
                                                                            alt: "teamLogo",
                                                                            priority: false
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                        className: "team_name",
                                                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                            className: `name ${score?.split("-")[0] > score?.split("-")[1] ? "font-weight-bold" : ""}`,
                                                                            children: match?.competitors?.htn
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                                className: "cl_score",
                                                                children: match?.st === "NSY" || match?.st === "Delayed" || match?.st === "Result Only" ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                    className: "vs",
                                                                    children: "VS"
                                                                }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $5398424c63d72b5c$export$2e2bcd8739ae039), {
                                                                    score: score,
                                                                    winner: winner
                                                                }, score)
                                                            }),
                                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                                                className: "cl_team snd_team pr_p",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                        className: "flag",
                                                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                                            src: (0, $3G7m1.getImageUrl)('', '', sport, match?.competitors?.atid),
                                                                            height: 23,
                                                                            width: 23,
                                                                            alt: "teamLogo",
                                                                            priority: false
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                        className: "team_name",
                                                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                            className: `name ${score?.split("-")[0] > score?.split("-")[1] ? "font-weight-bold" : ""}`,
                                                                            children: match?.competitors?.atn
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }, match?.id)
                                });
                            })
                        ]
                    }, league?.lid))
            ]
        })
    });
};
var $d7c3bcbf98681d67$export$2e2bcd8739ae039 = $d7c3bcbf98681d67$var$Matches;





var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");


var $ba5nK = parcelRequire("ba5nK");

var $3G7m1 = parcelRequire("3G7m1");
// import "./FootballSquadTable.scss";
const $b9cf120fcec3bb30$var$FootballSquadTable = ({ defender: defender, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataClient: dataClient = false, sport: sport = "football" })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "global_table striped squad_table",
        children: defender?.length ? /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "Pos"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "Player"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "Apps"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "Min"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "Goals"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "Asst"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
                        children: defender?.map((item, index)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: index + 1
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                            className: "player_inf",
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                    className: "ply_avtar",
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                        src: (0, $3G7m1.getImageUrl)('', '', sport, item?.pid, 'player-pictures'),
                                                        width: 24,
                                                        height: 24,
                                                        alt: "avtar"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                                    className: "ply_des",
                                                    children: [
                                                        /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                                                            href: (0, $3G7m1.teamLeagueInfoUrl)({
                                                                dataClient: dataClient,
                                                                websiteBaseUrl: websiteBaseUrl,
                                                                dataPath: dataPath,
                                                                category: "player",
                                                                sport: sport,
                                                                name: (0, $3G7m1.titleToSlug)(item?.nm),
                                                                id: item?.pid
                                                            }),
                                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                className: "name",
                                                                children: item?.nm
                                                            })
                                                        }),
                                                        item?.dob && /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                            className: "sub_name",
                                                            children: [
                                                                "Dob: ",
                                                                item?.dob
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: item?.apps
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: item?.min
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: item?.gos
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: item?.ast
                                    })
                                ]
                            }, item?.pid))
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {})
    });
};
var $b9cf120fcec3bb30$export$2e2bcd8739ae039 = $b9cf120fcec3bb30$var$FootballSquadTable;



const $00bfdd53a0b434cc$var$TeamSquad = ({ teamSquad: teamSquad, dictionary: dictionary, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataClient: dataClient = false })=>{
    // Check if any squad data exists
    const hasData = teamSquad?.Defender?.length || teamSquad?.Midfielder?.length || teamSquad?.Striker?.length || teamSquad?.Goalkeeper?.length;
    if (!hasData) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {
        text: "No squad data available"
    });
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "squad_block_wrp",
        children: [
            teamSquad?.Goalkeeper?.length > 0 && /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "squad_block",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "squad_block_hd",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                            children: "Goalkeeper"
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)((0, $b9cf120fcec3bb30$export$2e2bcd8739ae039), {
                        defender: teamSquad.Goalkeeper,
                        websiteBaseUrl: websiteBaseUrl,
                        dataPath: dataPath,
                        dataClient: dataClient
                    })
                ]
            }),
            teamSquad?.Defender?.length > 0 && /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "squad_block",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "squad_block_hd",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                            children: "Defender"
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)((0, $b9cf120fcec3bb30$export$2e2bcd8739ae039), {
                        defender: teamSquad.Defender,
                        websiteBaseUrl: websiteBaseUrl,
                        dataPath: dataPath,
                        dataClient: dataClient
                    })
                ]
            }),
            teamSquad?.Midfielder?.length > 0 && /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "squad_block",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "squad_block_hd",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                            children: "Midfielder"
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)((0, $b9cf120fcec3bb30$export$2e2bcd8739ae039), {
                        defender: teamSquad.Midfielder,
                        websiteBaseUrl: websiteBaseUrl,
                        dataPath: dataPath,
                        dataClient: dataClient
                    })
                ]
            }),
            teamSquad?.Striker?.length > 0 && /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "squad_block",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "squad_block_hd",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                            children: "Forward"
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)((0, $b9cf120fcec3bb30$export$2e2bcd8739ae039), {
                        defender: teamSquad.Striker,
                        websiteBaseUrl: websiteBaseUrl,
                        dataPath: dataPath,
                        dataClient: dataClient
                    })
                ]
            })
        ]
    });
};
var $00bfdd53a0b434cc$export$2e2bcd8739ae039 = $00bfdd53a0b434cc$var$TeamSquad;



var $2bSDe = parcelRequire("2bSDe");
// Tab configuration for better maintainability
const $14345f1ffad1bba8$var$TAB_CONFIG = {
    "team-squad": {
        requiresData: true,
        component: "squad"
    },
    "team-upcoming": {
        requiresData: true,
        component: "matches",
        matchType: "upcoming"
    },
    "team-results": {
        requiresData: true,
        component: "matches",
        matchType: "finished"
    },
    "team-news": {
        requiresData: true,
        component: "news",
        newsType: "team"
    },
    "team-stats": {
        requiresData: true,
        component: "stats"
    },
    "team-table": {
        requiresData: true,
        component: "table"
    }
};
const $14345f1ffad1bba8$var$TeamPage = ({ baseUrl: baseUrl, difference: difference, sport: sport = "football", dataId: dataId, loadCSS: loadCSS, headData: headData, setDataId: setDataId, setDataType: setDataType, setHead: setHead, setLeagueId: setLeagueId, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath = "football", dataClient: dataClient = false, squadData: squadData })=>{
    const [active, setActive] = (0, $6cds3.useState)(null);
    const [activeTabData, setActiveTabData] = (0, $6cds3.useState)(null);
    const [isLoading, setIsLoading] = (0, $6cds3.useState)(false);
    const [tabs, setTabs] = (0, $6cds3.useState)([]);
    // Initialize tabs from headData
    (0, $6cds3.useEffect)(()=>{
        if (headData?.tabs?.length > 0) {
            const teamTabs = headData.tabs.map((tab)=>({
                    key: `team-${tab?.replaceAll("_", "-")}`,
                    label: tab.replaceAll("_", " ")
                }));
            setTabs(teamTabs);
            setActive({
                key: `team-${headData.tabs[0]?.replaceAll("_", "-")}`,
                label: headData.tabs[0].replaceAll("_", " ")
            });
        }
    }, [
        headData
    ]);
    // Fetch data for active tab
    const fetchData = (0, $6cds3.useCallback)(async ()=>{
        if (!active?.key) return;
        const tabConfig = $14345f1ffad1bba8$var$TAB_CONFIG[active.key];
        // Handle squad tab separately (uses pre-loaded data)
        if (active.key === "team-squad") {
            setActiveTabData(squadData);
            setIsLoading(false);
            return;
        }
        try {
            setIsLoading(true);
            const params = {
                dataId: dataId,
                dataType: active.key,
                baseUrl: baseUrl,
                sport: sport
            };
            // Add newsType for news tab
            if (tabConfig?.newsType) params.newsType = tabConfig.newsType;
            const data = await (0, $zSRJd.getData)(params);
            setActiveTabData(data);
        } catch (error) {
            console.error("Error fetching data:", error);
            setActiveTabData(null);
        } finally{
            setIsLoading(false);
        }
    }, [
        active?.key,
        dataId,
        baseUrl,
        sport,
        squadData
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (active) fetchData();
    }, [
        active,
        fetchData
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("matchsummary");
    }, [
        loadCSS
    ]);
    // Handle tab click
    const handleTabClick = (key, label)=>{
        if (active?.key !== key) {
            setIsLoading(true);
            setActive({
                key: key,
                label: label
            });
            setActiveTabData(null);
        }
    };
    // Render tab content based on active tab
    const renderTabContent = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
            className: "loading-state",
            children: /*#__PURE__*/ (0, $lBpE3.jsx)("h3", {
                children: "Loading..."
            })
        });
        const tabConfig = $14345f1ffad1bba8$var$TAB_CONFIG[active?.key];
        if (!tabConfig) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {});
        switch(tabConfig.component){
            case "squad":
                return activeTabData ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $00bfdd53a0b434cc$export$2e2bcd8739ae039), {
                    teamSquad: activeTabData,
                    websiteBaseUrl: websiteBaseUrl,
                    dataPath: dataPath,
                    dataClient: dataClient
                }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {
                    text: "No squad data available"
                });
            case "matches":
                return activeTabData?.data ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $d7c3bcbf98681d67$export$2e2bcd8739ae039), {
                    data: activeTabData.data,
                    difference: difference,
                    setDataId: setDataId,
                    setDataType: setDataType,
                    setLeagueId: setLeagueId,
                    setHead: setHead,
                    matchType: tabConfig.matchType,
                    websiteBaseUrl: websiteBaseUrl,
                    dataPath: dataPath,
                    dataClient: dataClient
                }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {
                    text: `No ${tabConfig.matchType} matches found`
                });
            case "news":
                return activeTabData?.data ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $4c03dbc6caeb65b2$export$2e2bcd8739ae039), {
                    data: activeTabData.data,
                    loadCSS: loadCSS,
                    id: dataId,
                    newsType: tabConfig.newsType,
                    sport: sport,
                    baseUrl: baseUrl
                }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {
                    text: "No news available"
                });
            case "stats":
                return activeTabData?.data ? /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: "team_stats_wrp",
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("pre", {
                        children: JSON.stringify(activeTabData.data, null, 2)
                    })
                }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {
                    text: "No stats available"
                });
            case "table":
                return activeTabData?.data ? /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: "team_table_wrp",
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("pre", {
                        children: JSON.stringify(activeTabData.data, null, 2)
                    })
                }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {
                    text: "No table data available"
                });
            default:
                return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {});
        }
    };
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "match-page",
        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
            className: "detail_page",
            children: [
                tabs.length > 0 && /*#__PURE__*/ (0, $lBpE3.jsx)("nav", {
                    className: "inner_tab detail_main_tab",
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                        children: tabs.map(({ key: key, label: label })=>/*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                className: active?.key === key ? "active" : "",
                                onClick: ()=>handleTabClick(key, label),
                                "data-name": key,
                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                    children: label
                                })
                            }, key))
                    })
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: "tab_content",
                    children: renderTabContent()
                })
            ]
        })
    });
};
var $14345f1ffad1bba8$export$2e2bcd8739ae039 = $14345f1ffad1bba8$var$TeamPage;




var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");


var $2bSDe = parcelRequire("2bSDe");

var $gtwOm = parcelRequire("gtwOm");

var $6cds3 = parcelRequire("6cds3");
const $3c0ec22c8e595d87$export$fe816b4ad1554429 = ({ socket: socket, channel: channel, event: event, setData: setData, type: type, allowedLeagues: allowedLeagues })=>{
    (0, $6cds3.useEffect)(()=>{
        if (!socket || !allowedLeagues?.length) return;
        else {
            socket?.channel(channel)?.listen(event, (e)=>{
                const rawData = e?.data;
                let socketData = allowedLeagues ? rawData.filter((l)=>allowedLeagues?.includes(l.lid)) : rawData;
                setData((prevState)=>{
                    let nextState = [];
                    prevState?.forEach((l)=>{
                        let tempLeague = socketData?.find((x)=>x.id === l.id);
                        if (!tempLeague) nextState?.push(l);
                        else {
                            let updatedLeague = {
                                ...l,
                                matches: []
                            };
                            l?.matches?.forEach((m)=>{
                                let tempMatch = tempLeague?.matches?.find((x)=>x.id === m.id);
                                if (!tempMatch) updatedLeague?.matches.push(m);
                                else updatedLeague?.matches.push({
                                    ...m,
                                    st: tempMatch?.st ?? m?.st,
                                    cfs: tempMatch?.cfs ?? m?.cfs,
                                    ft: tempMatch?.ft ?? m?.ft,
                                    ht: tempMatch?.ht ?? m?.ht,
                                    et: tempMatch?.et ?? m?.et,
                                    ps: tempMatch?.ps ?? m?.ps,
                                    cp: tempMatch?.ps ?? m?.cp,
                                    f_time: tempMatch?.f_time ?? m?.f_time,
                                    sut: tempMatch?.sut ?? m?.sut,
                                    sun: tempMatch?.sun ?? m?.sun,
                                    odds: tempMatch?.odds ?? m?.odds
                                });
                            });
                            // Add new matches for live events
                            tempLeague?.matches?.forEach((m)=>{
                                let tempMatch = l?.matches?.find((x)=>x.id === m.id);
                                if (!tempMatch) updatedLeague.matches.push(m);
                            });
                            nextState.push(updatedLeague);
                        }
                    });
                    // Add any new leagues (live only)
                    socketData?.forEach((l)=>{
                        let tempLeague = prevState?.find((x)=>x.id === l.id);
                        if (!tempLeague) nextState.push(l);
                    });
                    // Remove finished/canceled leagues or matches
                    nextState = nextState?.map((l)=>{
                        const finishedMatches = l?.matches?.filter((m)=>[
                                "finished",
                                "finished ap",
                                "finished aet",
                                "awarded",
                                "cancelled",
                                "postponed",
                                "abandoned",
                                "deleted",
                                "result only"
                            ].includes(m?.st?.toLowerCase()));
                        if (finishedMatches?.length === l?.matches?.length) return {
                            ...l,
                            removeLeague: "true"
                        };
                        else {
                            const finishedMatchIds = finishedMatches?.map((m)=>m?.id);
                            return {
                                ...l,
                                matches: l.matches.map((m)=>finishedMatchIds.includes(m.id) ? {
                                        ...m,
                                        removeMatch: "true"
                                    } : m)
                            };
                        }
                    });
                    return nextState;
                });
            });
            return ()=>{
                socket?.channel(channel)?.stopListening(event);
                socket?.connector?.socket?.disconnect();
            };
        }
    }, [
        socket,
        channel,
        event,
        setData,
        type,
        allowedLeagues
    ]);
};



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $ba5nK = parcelRequire("ba5nK");

var $3G7m1 = parcelRequire("3G7m1");
const $466046869518abfc$var$LeagueHead = ({ league: league, updatedData: updatedData, setDataType: setDataType, setDataId: setDataId, setHead: setHead, baseURL: baseURL, matchType: matchType, websiteBaseUrl: websiteBaseUrl, dataClient: dataClient, dataPath: dataPath, design: design })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            matchType === "league" && Array.isArray(league?.matches) && league?.matches[0]?.competitors !== null && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "leg_head",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                    children: updatedData ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "name",
                        children: league?.d
                    }) : /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "name",
                        children: (0, $3G7m1.convertDateTime)(league?.d)
                    })
                })
            }),
            league?.lid && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "leg_head",
                style: {
                    cursor: "pointer"
                },
                onClick: ()=>(0, $3G7m1.navigateToLeague)(league, dataClient, websiteBaseUrl, dataPath),
                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                    className: "team_head",
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                            className: "league_logo",
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                src: `${baseURL}/public/assets/images/flags/country_${league?.fid}.png`,
                                height: 23,
                                width: 23,
                                alt: "teamLogo",
                                priority: false
                            })
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "name",
                                children: league?.nm
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $466046869518abfc$export$2e2bcd8739ae039 = $466046869518abfc$var$LeagueHead;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $ba5nK = parcelRequire("ba5nK");




var $XBIJN = parcelRequire("XBIJN");

var $3G7m1 = parcelRequire("3G7m1");
const $3523fe1ef54d8caf$var$LeagueBody = ({ match: match, matchType: matchType, updatedData: updatedData, difference: difference, Result: Result, sport: sport = "football", websiteBaseUrl: websiteBaseUrl, dataClient: dataClient, dataPath: dataPath, teamid: teamid, design: design, dictionary: dictionary = {} })=>{
    if (!match?.competitors) return null;
    const showTime = matchType === "upcoming" && ![
        "postponed",
        "abandoned",
        "cancelled"
    ].includes(match?.st?.toLowerCase());
    let score = (0, $XBIJN.MatchOptions)?.footballFTStatuses?.some((status)=>status.toLowerCase() === match?.st?.toLowerCase()) ? match?.ft : match?.cfs;
    let winner = score;
    if (match?.mins === "FAP") winner = match?.ps;
    // Check if match is live (case-insensitive)
    const isLive = (0, $XBIJN.MatchOptions)?.footballLiveStatuses?.some((status)=>status.toLowerCase() === match?.st?.toLowerCase());
    // Check if match is finished (case-insensitive)
    const isFinished = (0, $XBIJN.MatchOptions)?.footballFTStatuses?.some((status)=>status.toLowerCase() === match?.st?.toLowerCase());
    // Render status badge based on match status
    const renderStatus = ()=>{
        const status = match?.st?.toLowerCase();
        if (status === "delayed") return /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
            className: "sts_tg",
            children: "Dly"
        });
        if (status === "postponed") return /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
            className: "sts_tg ppd",
            children: "PPD"
        });
        if (status === "nsy" && matchType === "upcoming") return null; // Time will be shown separately
        if (status === "nsy") return /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
            className: "sts_tg",
            children: "NSY"
        });
        if (status === "abandoned") return /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
            className: "sts_tg red",
            children: "AB"
        });
        if (status === "cancelled") return /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
            className: "sts_tg red",
            children: "CAN"
        });
        if (status === "result only") return /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
            className: "sts_tg ppd",
            children: "Result only"
        });
        if (status === "finished" && match?.mins === "To Finish") return /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
            className: "status",
            children: "To FT"
        });
        if (status === "finished" && match?.mins === "FAP") return /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
            className: "sts_tg red",
            children: "FAP"
        });
        if (status === "tf") return /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
            className: "sts_tg red",
            children: "TF"
        });
        if (status === "finished" && match?.mins !== "FAP" && match?.mins !== "FAET") return /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
            className: "sts_tg",
            children: sport === "rugby" || sport === "rugby-union" ? "Finished" : "FT"
        });
        if (status === "finished" && match?.mins === "FAET") return /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
            className: "sts_tg",
            children: "FAET"
        });
        if (status === "finished ap") return /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
            className: "sts_tg",
            children: "FAP"
        });
        if (status === "finished aet") return /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
            className: "sts_tg",
            children: "FAET"
        });
        return (0, $3G7m1.renderStatusTag)(match);
    };
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "leg_body",
        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
            className: `leg_row rugby_leg_row ${isFinished ? "finesh" : ""} ${isLive ? "live" : ""}`,
            onClick: ()=>(0, $3G7m1.navigateToMatch)(match, dataClient, websiteBaseUrl, dataPath),
            style: {
                cursor: "pointer"
            },
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                    className: "match_list_date_status",
                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                        className: "status_wrp",
                        children: [
                            renderStatus(),
                            isLive && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: "live_sts",
                                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                    className: "sts_tg redd",
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                            className: "sts_m_min",
                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3880a40d7a28dcf1$export$2e2bcd8739ae039), {
                                                match: match
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                            className: "sts_m_live",
                                            children: dictionary?.live || "Live"
                                        })
                                    ]
                                })
                            }),
                            sport !== "rugby" && sport !== "rugby-union" && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
                                children: (showTime || updatedData || isFinished) && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                    className: "date",
                                    children: (0, $3G7m1.convertDateDMY)(match?.dt)
                                })
                            }),
                            (match?.st === "NSY" || match?.st === "Result Only") && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $62bf3e42edf85da2$export$2e2bcd8739ae039), {
                                match: match,
                                sport: sport,
                                difference: difference
                            }),
                            (sport === "rugby" || sport === "rugby-union") && /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "date",
                                        children: (0, $3G7m1.convertDateDMY)(match?.dt)
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)((0, $62bf3e42edf85da2$export$2e2bcd8739ae039), {
                                        match: match,
                                        sport: sport,
                                        difference: difference
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                    className: `leg_inf_inner ${Result ? "result_active" : ""}`,
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                            className: "leg_inf",
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                    className: "cl_team",
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                            className: "flag",
                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                src: (0, $3G7m1.getImageUrl)("", "", sport, match?.competitors?.htid),
                                                height: 23,
                                                width: 23,
                                                alt: `${match?.competitors?.htn || "Home team"} logo`
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                            className: "team_name",
                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: `name ${winner?.split("-")[0] > winner?.split("-")[1] ? "font-weight-bold" : ""}`,
                                                children: match?.competitors?.htn
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                    className: "cl_score",
                                    children: [
                                        "NSY",
                                        "Delayed",
                                        "Result Only"
                                    ].includes(match?.st) ? /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: "score",
                                                children: "-"
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: "score",
                                                children: "-"
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $5398424c63d72b5c$export$2e2bcd8739ae039), {
                                        score: score,
                                        winner: winner
                                    }, `${match?.id}-score`)
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                    className: "cl_team snd_team pr_p",
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                            className: "flag",
                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                src: (0, $3G7m1.getImageUrl)("", "", sport, match?.competitors?.atid),
                                                height: 23,
                                                width: 23,
                                                alt: `${match?.competitors?.atn || "Away team"} logo`
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                            className: "team_name",
                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: `name ${winner?.split("-")[1] > winner?.split("-")[0] ? "font-weight-bold" : ""}`,
                                                children: match?.competitors?.atn
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        Result && match?.cp !== "Postponed" && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                            className: "win-td",
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: "icon-wrap",
                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                    className: `icon_status ${(0, $3G7m1.getMatchOutcomeClass)(teamid, match)}`,
                                    children: (0, $3G7m1.getMatchOutcome)(teamid, match)
                                })
                            })
                        })
                    ]
                })
            ]
        })
    }, match?.id);
};
var $3523fe1ef54d8caf$export$2e2bcd8739ae039 = $3523fe1ef54d8caf$var$LeagueBody;


// Helper to get first N matches for initial load
const $9ebb198b8b2c3337$var$firstCountMatches = (data, count = 15)=>{
    if (!data || !Array.isArray(data)) return [];
    let matchCount = 0;
    const result = [];
    for (const league of data){
        if (matchCount >= count) break;
        const leagueMatches = league?.matches || [];
        const remainingCount = count - matchCount;
        if (leagueMatches.length <= remainingCount) {
            result.push(league);
            matchCount += leagueMatches.length;
        } else {
            result.push({
                ...league,
                matches: leagueMatches.slice(0, remainingCount)
            });
            matchCount = count;
        }
    }
    return result;
};
const $9ebb198b8b2c3337$var$LeagueMatches = ({ finalData: finalData, difference: difference, matchType: matchType, loadCSS: loadCSS, setDataId: setDataId, setDataType: setDataType, setHead: setHead, dataClient: dataClient, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath = "football", updatedData: updatedData, Result: Result = false, teamid: teamid, sport: sport = "football", socketUrl: socketUrl = "", channel: channel = "IPUB", event: event = "FootballLiveMatches", type: type, baseUrl: baseUrl, allowedLeagues: allowedLeagues, design: design, initialMatchCount: initialMatchCount = 15, lazyLoad: lazyLoad = true })=>{
    const baseURL = "https://ipublisher-microservices.6lgx.com";
    // Initial paginated data for performance
    const initialData = (0, $6cds3.useMemo)(()=>{
        if (!lazyLoad) return finalData;
        return $9ebb198b8b2c3337$var$firstCountMatches(finalData, initialMatchCount);
    }, [
        finalData,
        initialMatchCount,
        lazyLoad
    ]);
    const [data, setData] = (0, $6cds3.useState)(initialData);
    const [isFullDataLoaded, setIsFullDataLoaded] = (0, $6cds3.useState)(!lazyLoad);
    const socket = (0, $gtwOm.useSocket)(socketUrl);
    (0, $3c0ec22c8e595d87$export$fe816b4ad1554429)({
        socket: socket,
        channel: channel,
        event: event,
        setData: setData,
        type: type,
        allowedLeagues: allowedLeagues
    });
    // Update data when finalData changes
    (0, $6cds3.useEffect)(()=>{
        if (isFullDataLoaded || !lazyLoad) setData(finalData);
        else setData($9ebb198b8b2c3337$var$firstCountMatches(finalData, initialMatchCount));
    }, [
        finalData,
        isFullDataLoaded,
        initialMatchCount,
        lazyLoad
    ]);
    // Load full data on scroll for lazy loading
    (0, $6cds3.useEffect)(()=>{
        if (!lazyLoad || isFullDataLoaded) return;
        const handleScroll = ()=>{
            if (window.scrollY > 0 && !isFullDataLoaded) {
                setData(finalData);
                setIsFullDataLoaded(true);
            }
        };
        window.addEventListener("scroll", handleScroll);
        return ()=>window.removeEventListener("scroll", handleScroll);
    }, [
        isFullDataLoaded,
        finalData,
        lazyLoad
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("leaguepage");
    }, [
        loadCSS
    ]);
    // Separate upcoming and results if needed (must be before early return)
    const upcomingMatches = (0, $6cds3.useMemo)(()=>{
        if (matchType !== "all") return null;
        return data?.filter((league)=>league?.matches?.some((match)=>{
                const status = match?.st?.toLowerCase();
                return status === "ns" || status === "not started" || status === "scheduled";
            }));
    }, [
        data,
        matchType
    ]);
    const resultMatches = (0, $6cds3.useMemo)(()=>{
        if (matchType !== "all") return null;
        return data?.filter((league)=>league?.matches?.some((match)=>{
                const status = match?.st?.toLowerCase();
                return status === "ft" || status === "finished" || status === "ended" || status === "aet" || status === "pen";
            }));
    }, [
        data,
        matchType
    ]);
    if (!data || data?.length === 0) return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "leg_wrp",
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
            className: "leg_box",
            children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "text-center",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {
                    text: type === "live" ? "There are no live games currently in progress" : matchType === "upcoming" ? "No upcoming matches found" : matchType === "results" ? "No results found" : "No matches found"
                })
            })
        })
    });
    // Render a league section
    const renderLeagueSection = (leagues, sectionTitle)=>/*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
            children: [
                sectionTitle && leagues?.length > 0 && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: "leg_section_head",
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                        children: sectionTitle
                    })
                }),
                leagues?.map((league)=>/*#__PURE__*/ (0, $lBpE3.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $466046869518abfc$export$2e2bcd8739ae039), {
                                league: league,
                                updatedData: updatedData,
                                setDataType: setDataType,
                                setDataId: setDataId,
                                setHead: setHead,
                                baseURL: baseURL,
                                matchType: matchType,
                                websiteBaseUrl: websiteBaseUrl,
                                dataClient: dataClient,
                                dataPath: dataPath,
                                design: design
                            }),
                            Array.isArray(league?.matches) && league.matches.map((match)=>/*#__PURE__*/ (0, $lBpE3.jsx)((0, $3523fe1ef54d8caf$export$2e2bcd8739ae039), {
                                    match: match,
                                    matchType: matchType,
                                    updatedData: updatedData,
                                    difference: difference,
                                    Result: Result,
                                    sport: sport,
                                    websiteBaseUrl: websiteBaseUrl,
                                    dataClient: dataClient,
                                    dataPath: dataPath,
                                    teamid: teamid,
                                    design: design
                                }, match?.id))
                        ]
                    }, league?.id))
            ]
        });
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "leg_wrp",
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
            className: "leg_box",
            children: matchType === "all" ? /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                children: [
                    upcomingMatches?.length > 0 && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "leg_section upcoming_section",
                        children: renderLeagueSection(upcomingMatches, "Upcoming Matches")
                    }),
                    resultMatches?.length > 0 && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "leg_section results_section",
                        children: renderLeagueSection(resultMatches)
                    })
                ]
            }) : /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                children: [
                    matchType === "upcoming" && !data[0]?.nm && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "leg_head",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "name",
                                children: "Upcoming Matches"
                            })
                        })
                    }),
                    matchType === "results" && !data[0]?.nm && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "leg_head",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "name",
                                children: "Results"
                            })
                        })
                    }),
                    renderLeagueSection(data)
                ]
            })
        })
    });
};
var $9ebb198b8b2c3337$export$2e2bcd8739ae039 = $9ebb198b8b2c3337$var$LeagueMatches;



var $3G7m1 = parcelRequire("3G7m1");

var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $gtwOm = parcelRequire("gtwOm");

var $2bSDe = parcelRequire("2bSDe");


var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $3G7m1 = parcelRequire("3G7m1");

var $kybuc = parcelRequire("kybuc");

var $ba5nK = parcelRequire("ba5nK");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $3G7m1 = parcelRequire("3G7m1");

var $XBIJN = parcelRequire("XBIJN");
// components/match/TeamRow.js

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $ba5nK = parcelRequire("ba5nK");

var $3G7m1 = parcelRequire("3G7m1");
const $7123c35c662bee42$var$TeamRow = ({ teamName: teamName, teamLogo: teamLogo, isWinner: isWinner, isLive: isLive, sport: sport, baseURL: baseURL, match: match, isHome: isHome })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
        className: "player",
        children: [
            (sport === "basketball" || sport === "cricket" || sport === "icehockey") && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                className: "flag",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                    src: teamLogo,
                    height: 22,
                    width: 22,
                    alt: `${teamName} logo`
                })
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                className: `name ${isWinner ? "bold" : ""}`,
                children: teamName
            }),
            isLive && sport === "cricket" && match?.batid === (isHome ? match?.competitors?.htid : match?.competitors?.atid) ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3G7m1.Icon), {
                type: "bat",
                src: `${baseURL}/public/assets/images/Bat1.png`,
                width: 15,
                height: 14,
                alt: "bat"
            }) : isLive && sport === "cricket" && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3G7m1.Icon), {
                type: "ball",
                src: `${baseURL}/public/assets/images/cricket_Ball.png`,
                width: 14,
                height: 14,
                alt: "ball"
            }),
            match?.fts === (isHome ? "1" : "2") && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                className: "ball",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                    src: `${baseURL}/public/assets/images/tennis_ball.png`,
                    width: 17,
                    height: 17,
                    alt: "ball"
                })
            })
        ]
    });
};
var $7123c35c662bee42$export$2e2bcd8739ae039 = $7123c35c662bee42$var$TeamRow;


// components/match/MatchStatus.js

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");


var $kybuc = parcelRequire("kybuc");

var $3G7m1 = parcelRequire("3G7m1");
const $b82eda70fcdfe10b$var$MatchStatus = ({ match: match, sport: sport, live: live, statusText: statusText, statusClass: statusClass, liveStatusText: liveStatusText, dictionary: dictionary, difference: difference, displayDate: displayDate })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: `match_info_top ${!match?.odds ? "extra" : ""}`,
        children: [
            displayDate && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                className: "date",
                children: (0, $kybuc.DateUtility)?.FormatDateh2h(new Date(match?.dt || match?.d))
            }),
            statusText && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                className: statusClass,
                children: dictionary?.[statusText.replaceAll(" ", "").toLowerCase()] || statusText
            }),
            liveStatusText && sport !== "tennis" && sport !== "basketball" && sport !== "icehockey" ? /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                className: live ? "status red" : "info",
                children: [
                    (sport === "basketball" || sport === "icehockey") && live && /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                        children: [
                            match?.cp,
                            "\xa0-\xa0"
                        ]
                    }),
                    dictionary?.[liveStatusText.replaceAll(" ", "").toLowerCase()] || liveStatusText
                ]
            }) : null,
            sport === "tennis" && live && /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                className: live ? "status red" : "info",
                children: [
                    (0, $3G7m1.GetTennisMatchStatus)(match?.st, match?.cp, match),
                    " -",
                    " ",
                    dictionary?.[liveStatusText.replaceAll(" ", "").toLowerCase()] || liveStatusText
                ]
            }),
            sport === "cricket" && live && /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "time",
                        children: match?.st
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "time",
                        children: (0, $kybuc.DateUtility)?.FormatDateh2h(new Date(match?.ldt))
                    })
                ]
            }),
            sport === "cricket" && (match?.bs === "Delayed" || match?.bs === "Stumps") && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                    className: "status",
                    children: match?.bs
                })
            }),
            sport === "cricket" && match?.st === "Abandoned" && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                    className: "status",
                    children: match?.bs
                })
            }),
            !live && match?.st !== "Finished" && match?.st !== "Finished AET" && match?.st !== "Finished AP" && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $62bf3e42edf85da2$export$2e2bcd8739ae039), {
                match: match,
                sport: sport,
                difference: difference
            })
        ]
    });
};
var $b82eda70fcdfe10b$export$2e2bcd8739ae039 = $b82eda70fcdfe10b$var$MatchStatus;


const $5a09324949c1366c$var$CricketMatchBox = ({ league: league, difference: difference, displayDate: displayDate, dictionary: dictionary, baseURL: baseURL, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataClient: dataClient, sport: sport })=>{
    const handleClick = (match)=>{
        if (dataClient) window.location.href = websiteBaseUrl ? `${websiteBaseUrl}/${dataPath}/match-detail/${(0, $3G7m1.linkName)(match?.competitors?.htn)}-vs-${(0, $3G7m1.linkName)(match?.competitors?.atn)}/${match?.id}/${(0, $3G7m1.seoBaseOpenMatchDetailUrl)(sport, match, "info")}` : `/${dataPath}/match-detail/${(0, $3G7m1.linkName)(match?.competitors?.htn)}-vs-${(0, $3G7m1.linkName)(match?.competitors?.atn)}/${match?.id}/${(0, $3G7m1.seoBaseOpenMatchDetailUrl)(sport, match, "info")}`;
    };
    return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
        children: league?.matches.map((match)=>{
            const tennisScore = [
                "1st set",
                "2nd set",
                "3rd set",
                "4th set",
                "5th set"
            ]?.includes((0, $3G7m1.GetTennisMatchStatus)(match?.st, match?.cp, match)) ? match?.scores?.find((t)=>(0, $3G7m1.ToLowerText)(t?.ty) === "cfs") : match?.scores?.find((t)=>(0, $3G7m1.ToLowerText)(t?.ty) === "finished");
            const homeScore = tennisScore?.nm?.split(":")?.[0]?.trim();
            const awayScore = tennisScore?.nm?.split(":")?.[1]?.trim();
            const live = (0, $XBIJN.MatchOptions)?.basketballLiveStatuses?.includes(match?.st) || match?.bs === "Live";
            const { statusText: statusText, statusClass: statusClass, liveStatusText: liveStatusText } = (0, $3G7m1.getMatchInfo)(match, live, sport);
            const scores = Array.from({
                length: 4
            }, (_, i)=>(0, $3G7m1.extractScores)(match, i + 1));
            const winner = (0, $3G7m1.calculateWinner)(scores);
            const { home: homeLogo, away: awayLogo } = (0, $3G7m1.getTeamLogos)(sport, match);
            return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: `leg_row_basketball ${sport === "cricket" ? "cricket_row" : ""} ${live && "live"}`,
                onClick: ()=>handleClick(match),
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)((0, $b82eda70fcdfe10b$export$2e2bcd8739ae039), {
                        match: match,
                        sport: sport,
                        live: live,
                        statusText: statusText,
                        statusClass: statusClass,
                        liveStatusText: liveStatusText,
                        dictionary: dictionary,
                        difference: difference,
                        displayDate: displayDate
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "row_inner",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: "match_info",
                                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                    className: "basketball_player",
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsx)((0, $7123c35c662bee42$export$2e2bcd8739ae039), {
                                            teamName: match?.competitors?.htn,
                                            teamLogo: homeLogo,
                                            isWinner: winner === "home" || homeScore > awayScore ? "bold" : null,
                                            isLive: live,
                                            sport: sport,
                                            baseURL: baseURL,
                                            match: match,
                                            isHome: true
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)((0, $7123c35c662bee42$export$2e2bcd8739ae039), {
                                            teamName: match?.competitors?.atn,
                                            teamLogo: awayLogo,
                                            isWinner: winner === "away" || homeScore < awayScore ? "bold" : null,
                                            isLive: live,
                                            sport: sport,
                                            baseURL: baseURL,
                                            match: match
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                className: "score_wrp",
                                children: [
                                    (sport === "basketball" || sport === "icehockey") && (0, $3G7m1.renderBasketballScores)(scores, winner, live, match?.cfs, match?.ft),
                                    sport === "tennis" && (0, $3G7m1.renderTennisScores)((0, $3G7m1.GetMatchScores)(match?.scores, (0, $3G7m1.GetTennisMatchStatus)(match?.st, match?.cp, match)), homeScore, awayScore, live),
                                    sport === "cricket" && (0, $3G7m1.renderCricketScores)(match)
                                ]
                            })
                        ]
                    }),
                    sport === "cricket" && match?.st !== "Not Started" && /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "match_info_tft",
                        children: [
                            match?.com ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "lft",
                                children: match?.com
                            }) : "",
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                className: "rgt",
                                children: [
                                    dictionary?.stadium || "Stadium",
                                    " : ",
                                    match?.stad?.nm,
                                    ",",
                                    " ",
                                    match?.stad?.cty
                                ]
                            })
                        ]
                    })
                ]
            }, match?.id);
        })
    });
};
var $5a09324949c1366c$export$2e2bcd8739ae039 = $5a09324949c1366c$var$CricketMatchBox;


const $37581efd145694b6$var$CricketLeagueBox = ({ data: data, difference: difference, displayDate: displayDate, dictionary: dictionary, baseURL: baseURL, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataClient: dataClient, sport: sport, tournamentListing: tournamentListing })=>{
    const handleHeadClick = (head)=>{
        if (dataClient) window.location.href = websiteBaseUrl ? `${websiteBaseUrl}/${dataPath}/league/${(0, $3G7m1.titleToSlug)(head?.nm)}/${head?.id}/info` : `/${dataPath}/league/${(0, $3G7m1.titleToSlug)(head?.nm)}/${head?.id}/info`;
    };
    return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
        children: data?.map((league, index)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "leg_box",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "leg_head",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                            children: tournamentListing !== "tournamentListing" ? /*#__PURE__*/ (0, $lBpE3.jsxs)("a", {
                                href: "#",
                                onClick: (e)=>{
                                    e.preventDefault();
                                    handleHeadClick(league);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                        className: "icon_flag",
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                            src: `${baseURL}/public/assets/images/flags/country_${league?.fid}.png`,
                                            height: 23,
                                            width: 23,
                                            alt: "teamLogo",
                                            priority: false
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "name",
                                        children: league?.nm
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: `name ${league?.d}`,
                                children: (0, $kybuc.DateUtility).FormatDate(new Date(league?.d))
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)((0, $5a09324949c1366c$export$2e2bcd8739ae039), {
                        league: league,
                        difference: difference,
                        displayDate: displayDate,
                        dictionary: dictionary,
                        baseURL: baseURL,
                        websiteBaseUrl: websiteBaseUrl,
                        dataPath: dataPath,
                        dataClient: dataClient,
                        sport: sport
                    })
                ]
            }, index))
    });
};
var $37581efd145694b6$export$2e2bcd8739ae039 = $37581efd145694b6$var$CricketLeagueBox;



var $6cds3 = parcelRequire("6cds3");

var $3G7m1 = parcelRequire("3G7m1");
const $4560629b2e35f6fe$export$f840d0045bf896a6 = (socket, sport, setData, allowedLeagues)=>{
    (0, $6cds3.useEffect)(()=>{
        if (!socket || !allowedLeagues?.length) return;
        let event = "";
        if (sport === "tennis") event = "TTMatchesUpdated";
        else if (sport === "basketball" || sport === "icehockey") event = "BBMatchesUpdated";
        else if (sport === "cricket") event = "CRICMatchesUpdated";
        const channel = socket.channel("IPUB").listen(event, (e)=>{
            console.log("Socket update:", new Date().toLocaleString(), e?.data);
            setData((prevState)=>{
                const rawData = e?.data;
                let socketData;
                if (allowedLeagues) {
                    if (sport === "cricket") {
                        const allowed = allowedLeagues || [];
                        socketData = rawData?.filter((l)=>l.matches?.some((match)=>allowed?.includes(match.competitors?.htid)));
                    } else {
                        const allowed = Array.isArray(allowedLeagues) ? allowedLeagues : allowedLeagues?.data || [];
                        socketData = rawData?.filter((l)=>allowed.includes(l?.lid));
                    }
                } else socketData = rawData;
                let nextState = [];
                // update existing leagues
                prevState?.forEach((l)=>{
                    let tempLeague = socketData.find((x)=>x.id === l.id);
                    if (!tempLeague) nextState.push(l);
                    else {
                        let updatedLeague = {
                            ...l,
                            matches: []
                        };
                        l?.matches.forEach((m)=>{
                            let tempMatch = tempLeague?.matches?.find((x)=>x.id === m.id);
                            updatedLeague.matches.push(tempMatch ? (0, $3G7m1.updateMatches)(m, tempMatch, sport) : m);
                        });
                        // add new live matches dynamically
                        tempLeague.matches.forEach((m)=>{
                            let tempMatch = l?.matches?.find((x)=>x.id === m.id);
                            if (!tempMatch) updatedLeague.matches.push(m);
                        });
                        nextState.push(updatedLeague);
                    }
                });
                // add new leagues
                socketData.forEach((l)=>{
                    if (!prevState.find((x)=>x.id === l.id)) nextState.push(l);
                });
                // filter finished or cancelled matches/leagues
                nextState = nextState.map((l)=>{
                    const finishedMatches = l?.matches?.filter((m)=>[
                            "Finished",
                            "Finished AP",
                            "Finished AET",
                            "Awarded",
                            "Cancelled",
                            "Postponed",
                            "Abandoned",
                            "Deleted",
                            "Result Only",
                            "Stumps"
                        ].includes(m?.st || m?.bs));
                    if (finishedMatches?.length === l?.matches?.length) return {
                        ...l,
                        removeLeague: "true"
                    };
                    const finishedIds = finishedMatches?.map((m)=>m?.id);
                    return {
                        ...l,
                        matches: l.matches.map((m)=>finishedIds.includes(m.id) ? {
                                ...m,
                                removeMatch: "true"
                            } : m)
                    };
                });
                return nextState;
            });
        });
        return ()=>{
            channel?.stopListening(event);
            socket?.connector?.socket.disconnect();
        };
    }, [
        socket,
        sport,
        setData,
        allowedLeagues
    ]);
};


const $7d965bd65420c156$var$CricketLeagueMatches = ({ finalData: finalData, difference: difference, matchType: matchType, loadCSS: loadCSS, dataClient: dataClient, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath = "cricket", type: type = "cricket", sport: sport = "cricket", displayDate: displayDate = false, dictionary: dictionary = {}, socketUrl: socketUrl = "", baseUrl: baseUrl, allowedLeagues: allowedLeagues, tournamentListing: tournamentListing })=>{
    const [data, setData] = (0, $6cds3.useState)(finalData);
    (0, $6cds3.useEffect)(()=>{
        setData(finalData);
    }, [
        finalData
    ]);
    const baseURL = "https://ipublisher-microservices.6lgx.com" ?? "https://ipublisher-microservices.6lgx.com";
    const socket = (0, $gtwOm.useSocket)(socketUrl);
    (0, $4560629b2e35f6fe$export$f840d0045bf896a6)(socket, sport, setData, allowedLeagues);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("leaguepage");
    }, [
        loadCSS
    ]);
    if (!data?.length) return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "leg_wrp",
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
            className: "leg_box",
            children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "text-center",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {})
            })
        })
    });
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "leg_wrp",
        children: [
            matchType === "upcoming" && !data[0]?.nm && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "leg_head",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "name",
                        children: "Upcoming Matches"
                    })
                })
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $37581efd145694b6$export$2e2bcd8739ae039), {
                data: data,
                difference: difference,
                displayDate: displayDate,
                dictionary: dictionary,
                baseURL: baseURL,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                dataClient: dataClient,
                sport: sport,
                tournamentListing: tournamentListing
            })
        ]
    });
};
var $7d965bd65420c156$export$2e2bcd8739ae039 = $7d965bd65420c156$var$CricketLeagueMatches;



var $2bSDe = parcelRequire("2bSDe");
const $3207c25f6468a03b$var$LeagueWrapper = ({ sport: sport, data: data, loadCSS: loadCSS, baseUrl: baseUrl, setDataId: setDataId, setDataType: setDataType, setHead: setHead, dataClient: dataClient, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, title: title, matchType: matchType = "league", updatedData: updatedData = false, difference: difference })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)([]);
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data?.data;
            setClientData(parsed || []);
        } catch (error) {
            console.error("Failed to parse client data:", error);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("livematchdetail");
    }, [
        loadCSS
    ]);
    const finalData = (0, $6cds3.useMemo)(()=>dataClient ? clientData : data, [
        dataClient,
        clientData,
        data
    ]);
    let resp;
    if (updatedData) {
        resp = (0, $3G7m1.transformDataByRound)(finalData);
        resp = resp?.data;
    } else resp = finalData;
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Fragment, {
                children: sport === "football" || sport === "rugby" ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $9ebb198b8b2c3337$export$2e2bcd8739ae039), {
                    finalData: resp,
                    matchType: matchType,
                    loadCSS: loadCSS,
                    sport: sport,
                    baseUrl: baseUrl,
                    setDataId: setDataId,
                    setDataType: setDataType,
                    setHead: setHead,
                    websiteBaseUrl: websiteBaseUrl,
                    dataPath: dataPath,
                    updatedData: updatedData,
                    dataClient: dataClient,
                    difference: difference
                }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $7d965bd65420c156$export$2e2bcd8739ae039), {
                        finalData: resp,
                        matchType: matchType,
                        sport: sport,
                        baseUrl: baseUrl,
                        websiteBaseUrl: websiteBaseUrl,
                        dataPath: dataPath,
                        updatedData: true,
                        dataClient: dataClient,
                        tournamentListing: matchType !== "team" ? "tournamentListing" : "team",
                        difference: difference
                    })
                })
            })
        ]
    });
};
var $3207c25f6468a03b$export$2e2bcd8739ae039 = $3207c25f6468a03b$var$LeagueWrapper;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");
const $a4c3db034095ebf2$var$LeagueTableRow = ({ data: data })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("td", {
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "hi-border",
                        style: {
                            backgroundColor: `${data?.clr}`
                        }
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "d-inline-block align-middle",
                        children: data?.plc
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: "des-wrap",
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "des-text",
                        children: data?.team?.nm || data?.team
                    })
                })
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                children: data?.pld
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                children: data?.w
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                children: data?.d
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                children: data?.l
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                children: data?.scr
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                children: data?.con
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                children: data?.dif
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                children: data?.pts
            })
        ]
    });
};
var $a4c3db034095ebf2$export$2e2bcd8739ae039 = $a4c3db034095ebf2$var$LeagueTableRow;




var $2bSDe = parcelRequire("2bSDe");
const $9b1908741783b4d4$var$StandingTable = ({ data: data, loadCSS: loadCSS, dataClient: dataClient = false, title: title, Groupdata: Groupdata = false })=>{
    const stats = [
        {
            symbol: "P",
            fullForm: "Played"
        },
        {
            symbol: "W",
            fullForm: "Wins"
        },
        {
            symbol: "D",
            fullForm: "Draws"
        },
        {
            symbol: "L",
            fullForm: "Losses"
        },
        {
            symbol: "GF",
            fullForm: "Goals For"
        },
        {
            symbol: "GA",
            fullForm: "Goals Against"
        },
        {
            symbol: "GD",
            fullForm: "Goal Difference"
        },
        {
            symbol: "PTS",
            fullForm: "Points"
        }
    ];
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("leaguestandings");
    }, [
        loadCSS
    ]);
    const sourceData = dataClient ? clientData?.football_tournament_tables : data;
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "global_table standing_table",
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("table", {
                children: sourceData?.length ? /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "#"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "Team"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "P"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "W"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "D"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "L"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "F"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "A"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "GD"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "PTS"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                            children: sourceData?.sort((a, b)=>a?.plc - b?.plc)?.map((t, i)=>/*#__PURE__*/ (0, $lBpE3.jsx)((0, $a4c3db034095ebf2$export$2e2bcd8739ae039), {
                                    data: t
                                }, i))
                        })
                    ]
                }) : /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("tr", {
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {})
                        })
                    })
                })
            }),
            Groupdata && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "bottom_tr",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                    className: "item_list",
                    children: stats.map((item, index)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                    className: "symbol",
                                    children: item.symbol
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                    className: "full-form",
                                    children: item.fullForm
                                })
                            ]
                        }, index))
                })
            })
        ]
    });
};
var $9b1908741783b4d4$export$2e2bcd8739ae039 = $9b1908741783b4d4$var$StandingTable;


const $ce07e0a1d0ca4fc2$var$InfoTable = ({ tableData: tableData })=>{
    const data = tableData?.football_tournament_tables;
    const renderLeagueTable = (data)=>{
        if (!data || data.length === 0) return /*#__PURE__*/ (0, $lBpE3.jsx)("p", {
            children: "No standings found"
        });
        return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $9b1908741783b4d4$export$2e2bcd8739ae039), {
            data: data?.slice(0, 3),
            Groupdata: true
        });
    };
    return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
        children: data?.length > 0 && /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                    children: "Standings"
                }),
                renderLeagueTable(data)
            ]
        })
    });
};
var $ce07e0a1d0ca4fc2$export$2e2bcd8739ae039 = $ce07e0a1d0ca4fc2$var$InfoTable;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");


var $3G7m1 = parcelRequire("3G7m1");

const $4d5692d7c766885d$var$InfoTab = ({ response: response, children: children, baseUrl: baseUrl, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, id: id, matchType: matchType, dataClient: dataClient, sport: sport = "football", difference: difference })=>{
    const upComingsNewData = response?.upcoming;
    const lastMatchNewData = response?.last;
    let lastMatchData;
    if (lastMatchNewData?.length === undefined) {
        const data = (0, $3G7m1.transformDataByRound)(lastMatchNewData);
        lastMatchData = data?.data;
    } else lastMatchData = lastMatchNewData;
    let upComingsData;
    if (upComingsNewData?.length === undefined) {
        const data = (0, $3G7m1.transformDataByRound)(upComingsNewData);
        upComingsData = data?.data;
    } else upComingsData = upComingsNewData;
    const renderLeagueBoxes = (matchesData, teamid)=>{
        if (!matchesData || matchesData?.length === 0) return /*#__PURE__*/ (0, $lBpE3.jsx)("p", {
            children: "No matches found"
        });
        else return /*#__PURE__*/ (0, $lBpE3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Fragment, {
            children: sport === "football" || sport === "rugby" ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $9ebb198b8b2c3337$export$2e2bcd8739ae039), {
                finalData: matchesData,
                matchType: matchType,
                sport: sport,
                baseUrl: baseUrl,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                updatedData: true,
                dataClient: dataClient,
                Result: matchType !== "league" && teamid,
                teamid: teamid || "",
                difference: difference
            }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $7d965bd65420c156$export$2e2bcd8739ae039), {
                    finalData: matchesData,
                    matchType: matchType,
                    sport: sport,
                    baseUrl: baseUrl,
                    websiteBaseUrl: websiteBaseUrl,
                    dataPath: dataPath,
                    updatedData: true,
                    dataClient: dataClient,
                    tournamentListing: matchType !== "team" ? "tournamentListing" : "team",
                    difference: difference
                })
            })
        });
    };
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "info_main_box",
        children: [
            upComingsData?.length > 0 && /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                        children: "Upcoming"
                    }),
                    renderLeagueBoxes(upComingsData)
                ]
            }),
            lastMatchData?.length > 0 && /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                        children: "Latest Scores"
                    }),
                    renderLeagueBoxes(lastMatchData, id)
                ]
            }),
            children
        ]
    });
};
var $4d5692d7c766885d$export$2e2bcd8739ae039 = $4d5692d7c766885d$var$InfoTab;



var $2bSDe = parcelRequire("2bSDe");
const $be5ab0c7cb61a9f3$var$InfoPage = ({ data: data, loadCSS: loadCSS, dataClient: dataClient = false, baseUrl: baseUrl, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, isResult: isResult = false, title: title, id: id, matchType: matchType = "league", sport: sport, difference: difference })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("leagueInfo");
    }, [
        loadCSS
    ]);
    const sourceData = dataClient ? clientData : data;
    const { data: { upcoming: upcoming = [], last: last = [] } = [] } = sourceData || {};
    const table = sourceData?.data?.table || {};
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $4d5692d7c766885d$export$2e2bcd8739ae039), {
                id: id,
                response: {
                    upcoming: upcoming,
                    last: last
                },
                baseUrl: baseUrl,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                matchType: matchType,
                dataClient: dataClient,
                sport: sport,
                difference: difference,
                children: table && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ce07e0a1d0ca4fc2$export$2e2bcd8739ae039), {
                    tableData: table
                })
            })
        ]
    });
};
var $be5ab0c7cb61a9f3$export$2e2bcd8739ae039 = $be5ab0c7cb61a9f3$var$InfoPage;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");
const $fc7294d77b5150c9$var$Dropdown = ({ items: items, placeholder: placeholder = "Select an option", defaultValue: defaultValue, setLeagueSelectedId: setLeagueSelectedId })=>{
    const [open, setOpen] = (0, $6cds3.useState)(false);
    const [selectedId, setSelectedId] = (0, $6cds3.useState)(defaultValue || "");
    const wrapperRef = (0, $6cds3.useRef)(null);
    (0, $6cds3.useEffect)(()=>{
        setSelectedId(defaultValue || "");
    }, [
        defaultValue
    ]);
    const selectedItem = items?.find((item)=>item.id === selectedId);
    (0, $6cds3.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) setOpen(false);
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    const toggleDropdown = ()=>setOpen((prev)=>!prev);
    const handleSelect = (id)=>{
        setLeagueSelectedId(id);
        setSelectedId(id);
        setOpen(false);
    };
    return items?.length ? /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "dropdown_wrapper",
        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
            className: "dropdown_inner",
            ref: wrapperRef,
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                    className: "selected",
                    onClick: toggleDropdown,
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                            className: "selected_text",
                            children: [
                                selectedItem ? selectedItem.name : placeholder,
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                            className: `${"ico_down_arrow arrow"} ${open ? "open" : ""}`
                        })
                    ]
                }),
                open && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: "options",
                    children: items.map(({ id: id, name: name })=>/*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                            className: `${"option"}`,
                            onClick: ()=>handleSelect(id),
                            children: name
                        }, id))
                })
            ]
        })
    }) : null;
};
var $fc7294d77b5150c9$export$2e2bcd8739ae039 = $fc7294d77b5150c9$var$Dropdown;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $ba5nK = parcelRequire("ba5nK");


var $3G7m1 = parcelRequire("3G7m1");
const $3504f56c03457ebd$var$TableTeam = ({ teamTable: teamTable, dictionary: dictionary })=>{
    const rows = teamTable?.football_tournament_tables || [];
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "global_table standing_table",
        children: rows.length > 0 ? /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "#"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: dictionary?.team || "Team"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: dictionary?.played || "P"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: dictionary?.won || "W"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: dictionary?.draw || "D"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: dictionary?.lost || "L"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: dictionary?.goals_for || "F"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: dictionary?.goals_against || "A"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: dictionary?.goal_diff || "GD"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: dictionary?.points || "PTS"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                    children: rows.map((data, index)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                    children: index + 1
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                        className: "des-wrap",
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: "flg_img",
                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                    src: (0, $3G7m1.getImageUrl)('', '', 'football', data?.team_id),
                                                    height: 23,
                                                    width: 23,
                                                    alt: data?.team?.nm || "team logo",
                                                    priority: false
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: "des-text",
                                                children: data?.team?.nm || data?.team || "N/A"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                    children: data?.pld ?? "-"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                    children: data?.w ?? "-"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                    children: data?.d ?? "-"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                    children: data?.l ?? "-"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                    children: data?.scr ?? "-"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                    children: data?.con ?? "-"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                    children: data?.dif ?? "-"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                    children: data?.pts ?? "-"
                                })
                            ]
                        }, data?.team_id || index))
                })
            ]
        }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {})
    });
};
var $3504f56c03457ebd$export$2e2bcd8739ae039 = $3504f56c03457ebd$var$TableTeam;



var $2bSDe = parcelRequire("2bSDe");
const $7a903f87fe1db995$var$TeamTableWrp = ({ data: data, teamId: teamId, baseUrl: baseUrl, dataClient: dataClient, loadCSS: loadCSS, title: title })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)([]);
    const [teamData, setTeamData] = (0, $6cds3.useState)(dataClient ? clientData : data?.standings);
    const [leagueSelectedId, setLeagueSelectedId] = (0, $6cds3.useState)(teamId);
    // Load client-side data (from data-listingdata attribute)
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data;
            setClientData(parsed);
            setTeamData(parsed?.standings);
            setLeagueSelectedId(parsed?.league?.data?.[0]?.id || null);
        } catch (error) {
            console.error("Failed to parse client data:", error);
        }
    }, [
        dataClient
    ]);
    // Fallback to SSR-provided props if not using dataClient
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient && data) {
            setTeamData(data?.standings);
            setLeagueSelectedId(data?.league?.data?.[0]?.id || null);
            setClientData(data);
        }
    }, [
        dataClient,
        data
    ]);
    // Dynamic CSS injection
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("team");
    }, [
        loadCSS
    ]);
    // Fetch updated team table when league selection changes
    (0, $6cds3.useEffect)(()=>{
        if (!leagueSelectedId || !teamId) return;
        const fetchTableData = async ()=>{
            try {
                const res = await fetch(`${baseUrl}/football/team/${teamId}/table?leagueId=${leagueSelectedId}`, {
                    headers: {
                        Token: undefined
                    }
                });
                if (!res.ok) throw new Error(res.statusText);
                const json = await res.json();
                setTeamData(json);
            } catch (err) {
                console.error("Failed to fetch team table:", err);
            }
        };
        fetchTableData();
    }, [
        leagueSelectedId,
        teamId,
        baseUrl
    ]);
    const items = clientData?.league || data?.league;
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            items?.data?.length > 0 && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $fc7294d77b5150c9$export$2e2bcd8739ae039), {
                items: items.data,
                defaultValue: leagueSelectedId,
                setLeagueSelectedId: setLeagueSelectedId
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3504f56c03457ebd$export$2e2bcd8739ae039), {
                teamTable: teamData?.data || []
            })
        ]
    });
};
var $7a903f87fe1db995$export$2e2bcd8739ae039 = $7a903f87fe1db995$var$TeamTableWrp;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");



var $2bSDe = parcelRequire("2bSDe");
const $1790171c006cf770$var$SquadWrp = ({ data: data, teamId: teamId, baseUrl: baseUrl, dataClient: dataClient, loadCSS: loadCSS, title: title, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    const [teamData, setTeamData] = (0, $6cds3.useState)(dataClient ? null : data?.squad);
    const [leagueSelectedId, setLeagueSelectedId] = (0, $6cds3.useState)(dataClient ? null : data?.league?.data?.[0]?.id);
    const items = dataClient ? clientData?.league : data?.league;
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data;
            setClientData(parsed || null);
            setTeamData(parsed?.squad);
            setLeagueSelectedId(parsed?.league?.data?.[0]?.id);
        } catch (error) {
            console.error("Failed to parse client data:", error);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("team");
    }, [
        loadCSS
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (!leagueSelectedId || !teamId || !dataClient) return;
        const fetchTableData = async ()=>{
            try {
                const res = await fetch(`${baseUrl}/football/stat/team/${teamId}/lineup?leagueId=${leagueSelectedId}`, {
                    headers: {
                        Token: undefined
                    }
                });
                if (!res.ok) throw new Error(res.statusText);
                const json = await res.json();
                setTeamData(json || null);
            } catch (err) {
                console.error("Failed to fetch squad:", err);
            }
        };
        fetchTableData();
    }, [
        leagueSelectedId,
        teamId,
        dataClient
    ]);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $fc7294d77b5150c9$export$2e2bcd8739ae039), {
                items: items?.data,
                defaultValue: leagueSelectedId,
                setLeagueSelectedId: setLeagueSelectedId
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $00bfdd53a0b434cc$export$2e2bcd8739ae039), {
                teamSquad: teamData?.data,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                dataClient: dataClient
            })
        ]
    });
};
var $1790171c006cf770$export$2e2bcd8739ae039 = $1790171c006cf770$var$SquadWrp;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

const $2e0daed44cf80b33$var$OffenseDefenseTable = ({ data: data, active: active, setActive: setActive })=>{
    const tableData = active === "offense" ? data?.offense : data?.defence;
    const isOffense = active === "offense";
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "league_block",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "leg_main",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "leg_head",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                            children: "Offense / Defense"
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("nav", {
                        className: "inner_tab",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                            children: [
                                "offense",
                                "defence"
                            ].map((key)=>/*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                    className: active === key ? "active" : "",
                                    onClick: ()=>setActive(key),
                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        children: key === "offense" ? "Top Offense" : "Top Defense"
                                    })
                                }, key))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "global_table striped offense_tbl",
                children: tableData?.length ? /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "#"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "Team"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: isOffense ? "Goals Per Match" : "Conceded Per Match"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: isOffense ? "Goals Scored" : "Conceded Scored"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                            children: tableData?.slice(0, 20).map((team, index)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            children: index + 1
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: "team_name",
                                                children: team?.team?.nm
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            children: isOffense ? team?.gpm : team?.cpm
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            children: isOffense ? team?.sc : team?.cn
                                        })
                                    ]
                                }, index))
                        })
                    ]
                }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $2e0daed44cf80b33$export$2e2bcd8739ae039 = $2e0daed44cf80b33$var$OffenseDefenseTable;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $ba5nK = parcelRequire("ba5nK");

const $91241fbf69058395$var$baseURL = "https://ipublisher-microservices.6lgx.com";
const $91241fbf69058395$var$TeamStatsTable = ({ data: data, active: active, setActive: setActive })=>{
    const statsData = active === "goals" ? data?.offense : data?.cards;
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "league_block",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "leg_main",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "leg_head",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                            children: "Teams Statistics"
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("nav", {
                        className: "inner_tab",
                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                    className: active === "goals" ? "active" : "",
                                    onClick: ()=>setActive("goals"),
                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        children: "Goals"
                                    })
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                    className: active === "cards" ? "active" : "",
                                    onClick: ()=>setActive("cards"),
                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        children: "Card"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "global_table striped offense_tbl",
                children: statsData?.length ? /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "#"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "Team"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "Matches Played"
                                    }),
                                    active === "goals" ? /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "Goals Scored"
                                    }) : /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                    src: `${$91241fbf69058395$var$baseURL}/public/assets/images/svg/card-yellow.svg`,
                                                    width: 12,
                                                    height: 12,
                                                    alt: "card"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                    src: `${$91241fbf69058395$var$baseURL}/public/assets/images/svg/card-yellowred.svg`,
                                                    width: 12,
                                                    height: 12,
                                                    alt: "card"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                    src: `${$91241fbf69058395$var$baseURL}/public/assets/images/svg/card-red.svg`,
                                                    width: 12,
                                                    height: 12,
                                                    alt: "card"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                            children: statsData?.slice(0, 20)?.map((team, index)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            children: index + 1
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: "team_name",
                                                children: team?.team?.nm
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            children: team?.pl
                                        }),
                                        active === "goals" ? /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            children: team?.cn
                                        }) : /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                    children: team?.yc
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                    children: team?.syc
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                    children: team?.rc
                                                })
                                            ]
                                        })
                                    ]
                                }, index))
                        })
                    ]
                }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $91241fbf69058395$export$2e2bcd8739ae039 = $91241fbf69058395$var$TeamStatsTable;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

const $a27b127ad03435f2$var$sumGoals = (data, index, key)=>{
    return data.reduce((sum, item)=>{
        const val = item[key]?.split("-")[index];
        return sum + (val ? parseInt(val, 10) : 0);
    }, 0);
};
const $a27b127ad03435f2$var$GoalCell = ({ goal: goal, keyName: keyName, type: type })=>{
    const val = goal[keyName];
    if (!val) return "-";
    if (type === "scored") return val.split("-")[0];
    if (type === "conceded") return val.split("-")[1];
    return val;
};
const $a27b127ad03435f2$var$SummaryCell = ({ data: data, keyName: keyName, type: type })=>{
    if (type === "scored") return $a27b127ad03435f2$var$sumGoals(data, 0, keyName);
    if (type === "conceded") return $a27b127ad03435f2$var$sumGoals(data, 1, keyName);
    return `${$a27b127ad03435f2$var$sumGoals(data, 0, keyName)}-${$a27b127ad03435f2$var$sumGoals(data, 1, keyName)}`;
};
const $a27b127ad03435f2$var$PercentageCell = ({ data: data, keyName: keyName, type: type })=>{
    const getPercent = (idx)=>{
        const part = $a27b127ad03435f2$var$sumGoals(data, idx, keyName);
        const total = $a27b127ad03435f2$var$sumGoals(data, idx, "sum");
        return total > 0 ? (part / total * 100).toFixed(2) : "0.00";
    };
    if (type === "scored") return `${getPercent(0)}%`;
    if (type === "conceded") return `${getPercent(1)}%`;
    return `${getPercent(0)}%-${getPercent(1)}%`;
};
const $a27b127ad03435f2$var$timeSlots = [
    "q1",
    "q2",
    "q3",
    "q4",
    "q5",
    "q6"
];
const $a27b127ad03435f2$var$GoalsBreakdownTable = ({ data: data, active: active, setActive: setActive })=>{
    const goals = data?.goals || [];
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "league_block",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "leg_main",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "leg_head",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                            children: "Goals"
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("nav", {
                        className: "inner_tab",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                            children: [
                                {
                                    key: "scored",
                                    label: "Goals Scored"
                                },
                                {
                                    key: "conceded",
                                    label: "Goals Conceded"
                                },
                                {
                                    key: "both",
                                    label: "Scored & Conceded"
                                }
                            ].map(({ key: key, label: label })=>/*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                    className: active === key ? "active" : "",
                                    onClick: ()=>setActive(key),
                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        children: label
                                    })
                                }, key))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "global_table striped goals_tbl",
                children: goals.length ? /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "#"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "Team"
                                    }),
                                    $a27b127ad03435f2$var$timeSlots.map((slot, i)=>/*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                            children: [
                                                "0-15",
                                                "16-30",
                                                "31-45",
                                                "46-60",
                                                "61-75",
                                                "76-90"
                                            ][i]
                                        }, i)),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "Sum"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsxs)("tbody", {
                            children: [
                                goals.slice(0, 20).map((goal, index)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: index + 1
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: goal?.name
                                            }),
                                            $a27b127ad03435f2$var$timeSlots.map((slot)=>/*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)($a27b127ad03435f2$var$GoalCell, {
                                                        goal: goal,
                                                        keyName: slot,
                                                        type: active
                                                    })
                                                }, slot)),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)($a27b127ad03435f2$var$GoalCell, {
                                                    goal: goal,
                                                    keyName: "sum",
                                                    type: active
                                                })
                                            })
                                        ]
                                    }, index)),
                                /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            children: "-"
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            children: "Sum"
                                        }),
                                        $a27b127ad03435f2$var$timeSlots.map((slot)=>/*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)($a27b127ad03435f2$var$SummaryCell, {
                                                    data: goals,
                                                    keyName: slot,
                                                    type: active
                                                })
                                            }, slot)),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)($a27b127ad03435f2$var$SummaryCell, {
                                                data: goals,
                                                keyName: "sum",
                                                type: active
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            children: "-"
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            children: "Sum%"
                                        }),
                                        $a27b127ad03435f2$var$timeSlots.map((slot)=>/*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)($a27b127ad03435f2$var$PercentageCell, {
                                                    data: goals,
                                                    keyName: slot,
                                                    type: active
                                                })
                                            }, slot)),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {})
                                    ]
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $a27b127ad03435f2$export$2e2bcd8739ae039 = $a27b127ad03435f2$var$GoalsBreakdownTable;


const $a821ae266245c60d$var$FootballLeagueTeamStats = ({ data: data })=>{
    const [activeOff, setActiveOff] = (0, $6cds3.useState)("offense");
    const [activeTeamStats, setActiveTeamStats] = (0, $6cds3.useState)("goals");
    const [activeGoal, setActiveGoal] = (0, $6cds3.useState)("scored");
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $2e0daed44cf80b33$export$2e2bcd8739ae039), {
                data: data,
                active: activeOff,
                setActive: setActiveOff
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $91241fbf69058395$export$2e2bcd8739ae039), {
                data: data,
                active: activeTeamStats,
                setActive: setActiveTeamStats
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $a27b127ad03435f2$export$2e2bcd8739ae039), {
                data: data,
                active: activeGoal,
                setActive: setActiveGoal
            })
        ]
    });
};
var $a821ae266245c60d$export$2e2bcd8739ae039 = $a821ae266245c60d$var$FootballLeagueTeamStats;




var $2bSDe = parcelRequire("2bSDe");
const $c872d8fa35387784$var$TeamStatsWrp = ({ data: data, teamId: teamId, baseUrl: baseUrl, dataClient: dataClient, loadCSS: loadCSS, title: title })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)([]);
    const [teamData, setTeamData] = (0, $6cds3.useState)(dataClient ? clientData : data);
    const [leagueSelectedId, setLeagueSelectedId] = (0, $6cds3.useState)(dataClient ? clientData?.league?.data?.[0]?.id : data?.league?.data?.[0]?.id);
    const items = dataClient ? clientData?.league : data?.league;
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data;
            setClientData(parsed || []);
            setTeamData(parsed?.squad);
            setLeagueSelectedId(parsed?.league?.data?.[0]?.id);
        } catch (error) {
            console.error("Failed to parse client data:", error);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("team");
    }, [
        loadCSS
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (!leagueSelectedId || !teamId) return;
        const fetchTableData = async ()=>{
            try {
                const res = await fetch(`${baseUrl}/football/stat/team/${teamId}/stats?leagueId=${leagueSelectedId}`, {
                    headers: {
                        Token: undefined
                    }
                });
                if (!res.ok) throw new Error(res.statusText);
                const json = await res.json();
                setTeamData(json || []);
            } catch (err) {
                console.error("Failed to fetch squad:", err);
            }
        };
        fetchTableData();
    }, [
        leagueSelectedId,
        teamId
    ]);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $fc7294d77b5150c9$export$2e2bcd8739ae039), {
                items: items?.data,
                defaultValue: leagueSelectedId,
                setLeagueSelectedId: setLeagueSelectedId
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $a821ae266245c60d$export$2e2bcd8739ae039), {
                data: teamData?.data
            })
        ]
    });
};
var $c872d8fa35387784$export$2e2bcd8739ae039 = $c872d8fa35387784$var$TeamStatsWrp;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");


var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $ba5nK = parcelRequire("ba5nK");


var $3G7m1 = parcelRequire("3G7m1");
const $3e559aa5f101e3ba$var$STATS_CONFIG = {
    scorers: {
        headers: [
            "Players",
            "Pen",
            "G"
        ],
        legend: [
            {
                symbol: "Pen",
                fullForm: "Penalty"
            },
            {
                symbol: "G",
                fullForm: "Goal Scored"
            }
        ],
        dataKey: "goals",
        className: "ft_player_goals",
        getRowData: (item)=>[
                item?.mtchs,
                item?.gs
            ]
    },
    assists: {
        headers: [
            "Players",
            "Pen",
            "A"
        ],
        legend: [
            {
                symbol: "Pen",
                fullForm: "Penalty"
            },
            {
                symbol: "A",
                fullForm: "Assists"
            }
        ],
        dataKey: "assist",
        className: "ft_player_assist",
        getRowData: (item)=>[
                item?.mtchs,
                item?.asit
            ]
    },
    cards: {
        headers: [
            "Player",
            {
                type: "image",
                src: "/assets/images/svg/yellow_card.svg",
                width: 11,
                height: 15
            },
            {
                type: "image",
                src: "/assets/images/svg/multi_card.svg",
                width: 14,
                height: 18
            },
            {
                type: "image",
                src: "/assets/images/svg/red_card.svg",
                width: 11,
                height: 15
            }
        ],
        legend: [
            {
                type: "image",
                src: "/assets/images/svg/yellow_card.svg",
                fullForm: "Yellow Card"
            },
            {
                type: "image",
                src: "/assets/images/svg/multi_card.svg",
                fullForm: "Yellow & Red Card"
            },
            {
                type: "image",
                src: "/assets/images/svg/red_card.svg",
                fullForm: "Red Card"
            }
        ],
        dataKey: "cards",
        className: "ft_player_card",
        getRowData: (item)=>[
                item?.yc,
                item?.syc,
                item?.rc
            ]
    }
};
const $3e559aa5f101e3ba$var$FootballPlyarStats = ({ data: data, active: active, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataClient: dataClient, sport: sport = "football" })=>{
    const baseURL = "https://ipublisher-microservices.6lgx.com";
    const config = $3e559aa5f101e3ba$var$STATS_CONFIG[active] || $3e559aa5f101e3ba$var$STATS_CONFIG.cards;
    const items = data?.[config.dataKey];
    const renderHeader = (header, index)=>{
        if (typeof header === "string") return /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
            children: header
        }, index);
        if (header.type === "image") return /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
            children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "flg",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                    src: `${baseURL}/public${header.src}`,
                    width: header.width,
                    height: header.height,
                    alt: "card"
                })
            })
        }, index);
        return null;
    };
    const renderLegendItem = (item, index)=>{
        if (item.type === "image") return /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                    className: "symbol",
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                        src: `${baseURL}/public${item.src}`,
                        width: 11,
                        height: 15,
                        alt: "card"
                    })
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                    className: "full_form",
                    children: item.fullForm
                })
            ]
        }, index);
        return /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                    className: "symbol",
                    children: item.symbol
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                    className: "full_form",
                    children: item.fullForm
                })
            ]
        }, index);
    };
    if (!items?.length) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: `global_table striped ${config.className}`,
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("tr", {
                            children: config.headers.map(renderHeader)
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                        children: items.slice(0, 20).map((item, index)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                            className: "player_inf",
                                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                                className: "ply_des",
                                                children: [
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                                                        href: (0, $3G7m1.teamLeagueInfoUrl)({
                                                            dataClient: dataClient,
                                                            websiteBaseUrl: websiteBaseUrl,
                                                            dataPath: dataPath,
                                                            category: "player",
                                                            sport: sport,
                                                            name: (0, $3G7m1.titleToSlug)(item?.pn),
                                                            id: item?.player_id
                                                        }),
                                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                            className: "name",
                                                            children: item?.pn
                                                        })
                                                    }),
                                                    active === "scorers" && item?.dob && /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                        className: "sub_name",
                                                        children: [
                                                            "Dob: ",
                                                            item?.dob
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    config.getRowData(item).map((value, idx)=>/*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            children: value
                                        }, idx))
                                ]
                            }, item?.id || index))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "bottom_tr",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                    className: "item_list",
                    children: config.legend.map(renderLegendItem)
                })
            })
        ]
    });
};
var $3e559aa5f101e3ba$export$2e2bcd8739ae039 = $3e559aa5f101e3ba$var$FootballPlyarStats;


// import Link from "next/link";
const $318bb72d1cdf7b3f$var$PlayerStatsInnerWrp = ({ data: data, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataClient: dataClient })=>{
    const [active, setActive] = (0, $6cds3.useState)("scorers");
    const tabs = [
        {
            id: "scorers",
            label: "Top Scorers"
        },
        {
            id: "assists",
            label: "Top Assists"
        },
        {
            id: "cards",
            label: "Cards"
        }
    ];
    const handleTabClick = (tabId)=>{
        setActive(tabId);
    };
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "football_player_stats",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("nav", {
                className: "inner_tab",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                    children: tabs?.map((tab)=>/*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                            className: active === tab?.id ? "active" : "",
                            onClick: ()=>handleTabClick(tab?.id),
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                children: tab?.label
                            })
                        }, tab.id))
                })
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3e559aa5f101e3ba$export$2e2bcd8739ae039), {
                data: data,
                active: active,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                dataClient: dataClient
            })
        ]
    });
};
var $318bb72d1cdf7b3f$export$2e2bcd8739ae039 = $318bb72d1cdf7b3f$var$PlayerStatsInnerWrp;



var $2bSDe = parcelRequire("2bSDe");
const $6634c2a571496b47$var$TeamPlayerStatsWrp = ({ data: data, teamId: teamId, baseUrl: baseUrl, dataClient: dataClient, loadCSS: loadCSS, title: title, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)([]);
    const [teamData, setTeamData] = (0, $6cds3.useState)(dataClient ? clientData : data);
    const [leagueSelectedId, setLeagueSelectedId] = (0, $6cds3.useState)(dataClient ? clientData?.league?.data?.[0]?.id : data?.league?.data?.[0]?.id);
    const items = dataClient ? clientData?.league : data?.league;
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data;
            setClientData(parsed || []);
            setTeamData(parsed?.squad);
            setLeagueSelectedId(parsed?.league?.data?.[0]?.id);
        } catch (error) {
            console.error("Failed to parse client data:", error);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("team");
    }, [
        loadCSS
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (!leagueSelectedId || !teamId) return;
        const fetchTableData = async ()=>{
            try {
                const res = await fetch(`${baseUrl}/football/stat/team/${teamId}/player-stats?leagueId=${leagueSelectedId}`, {
                    headers: {
                        Token: undefined
                    }
                });
                if (!res.ok) throw new Error(res.statusText);
                const json = await res.json();
                setTeamData(json || []);
            } catch (err) {
                console.error("Failed to fetch squad:", err);
            }
        };
        fetchTableData();
    }, [
        leagueSelectedId,
        teamId
    ]);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $fc7294d77b5150c9$export$2e2bcd8739ae039), {
                items: items?.data,
                defaultValue: leagueSelectedId,
                setLeagueSelectedId: setLeagueSelectedId
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $318bb72d1cdf7b3f$export$2e2bcd8739ae039), {
                data: teamData?.data,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                dataClient: dataClient
            })
        ]
    });
};
var $6634c2a571496b47$export$2e2bcd8739ae039 = $6634c2a571496b47$var$TeamPlayerStatsWrp;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $3G7m1 = parcelRequire("3G7m1");
const $3811b17f5593aaeb$var$PlayerMatches = ({ dictionary: dictionary = {}, data: data })=>{
    const statLabels = [
        {
            symbol: "OPP",
            fullForm: "Opposite Team"
        },
        {
            symbol: "FC",
            fullForm: "Fouls Committed"
        },
        {
            symbol: "FA",
            fullForm: "Fouls Suffered"
        },
        {
            symbol: "OF",
            fullForm: "Offsides"
        },
        {
            symbol: "YC",
            fullForm: "Yellow Cards"
        },
        {
            symbol: "RC",
            fullForm: "Red Cards"
        }
    ];
    const getMatchOutcomeClass = (outcome)=>{
        let outcomeClass;
        if (outcome === "W") outcomeClass = "win";
        else if (outcome === "L") outcomeClass = "loss";
        else outcomeClass = "draw";
        return outcomeClass;
    };
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "global_table player_matches_tbl",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: dictionary?.date || "Date"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: dictionary?.opp || "Opp"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    className: "team",
                                    children: dictionary?.results || "Results"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "YC"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "RC"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                        children: data?.map((match, index)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: (0, $3G7m1.convertDate)(match?.dt)
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                            className: "cr_name",
                                            children: match?.oppt
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                            className: "result",
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                    className: `icon_status ${getMatchOutcomeClass(match?.type)}`,
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                        children: match?.type
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    children: match?.ft
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: match?.yc
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: match?.rc
                                    })
                                ]
                            }, index))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "bottom_tr",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                    className: "item_list",
                    children: statLabels?.map((item, index)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                    className: "symbol",
                                    children: item.symbol
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                    className: "full-form",
                                    children: item.fullForm
                                })
                            ]
                        }, index))
                })
            })
        ]
    });
};
var $3811b17f5593aaeb$export$2e2bcd8739ae039 = $3811b17f5593aaeb$var$PlayerMatches;





var $2bSDe = parcelRequire("2bSDe");
const $87bc647b9940ee75$var$PlayerInfo = ({ ServerData: ServerData, loadCSS: loadCSS = true, dataClient: dataClient = false, title: title, dictionary: dictionary = {}, showNews: showNews = false, newsData: newsData, baseUrl: baseUrl, sport: sport = "football", playerId: playerId })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    const data = dataClient ? clientData : ServerData || [];
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document?.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("footballplayer");
    }, [
        loadCSS
    ]);
    // Build player fields array for two-column layout
    const buildPlayerFields = ()=>{
        const fields = [];
        if (data?.player?.nm) fields.push({
            label: "Team",
            value: data.player.nm
        });
        if (data?.player?.shirt_no) fields.push({
            label: "Shirt Number",
            value: data.player.shirt_no
        });
        if (data?.player?.foot) fields.push({
            label: "Preferred Foot",
            value: data.player.foot
        });
        if (data?.player?.position) fields.push({
            label: "Position",
            value: data.player.position
        });
        if (data?.player?.residence) fields.push({
            label: "Citizenship",
            value: data.player.residence
        });
        if (data?.player?.market) fields.push({
            label: "Market Value",
            value: data.player.market
        });
        if (data?.player?.dob) fields.push({
            label: "Date of Birth",
            value: data.player.dob
        });
        if (data?.player?.height) fields.push({
            label: "Height",
            value: data.player.height
        });
        if (data?.player?.weight) fields.push({
            label: "Weight",
            value: data.player.weight
        });
        return fields;
    };
    // Render two-column table rows (like bole-saas)
    const renderPlayerInfoRows = ()=>{
        const fields = buildPlayerFields();
        const rows = [];
        for(let i = 0; i < fields.length; i += 2)rows.push(/*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsxs)("td", {
                    children: [
                        fields[i].label,
                        ":"
                    ]
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                    children: fields[i].value
                }),
                fields[i + 1] ? /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsxs)("td", {
                            children: [
                                fields[i + 1].label,
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                            children: fields[i + 1].value
                        })
                    ]
                }) : /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {}),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {})
                    ]
                })
            ]
        }, i));
        return rows;
    };
    const hasPlayerData = data?.player && Object.keys(data.player).length > 0;
    const hasPerformanceData = data?.player_performance?.length > 0;
    if (!hasPlayerData && !hasPerformanceData) return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "player_info",
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {
                text: "No player information available"
            })
        ]
    });
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "player_info",
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            hasPlayerData && /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "info_block",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "leg_head",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                            children: dictionary?.playerInformation || "Player Information"
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "global_table player_info_tbl",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("table", {
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                                children: renderPlayerInfoRows()
                            })
                        })
                    })
                ]
            }),
            hasPerformanceData && /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "info_block",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "leg_head",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                            children: dictionary?.lastMatches || "Last 6 Matches"
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3811b17f5593aaeb$export$2e2bcd8739ae039), {
                        data: data.player_performance
                    })
                ]
            }),
            showNews && newsData?.length > 0 && /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "info_block",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "leg_head",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                            children: dictionary?.relatedNews || "Related News"
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)((0, $4c03dbc6caeb65b2$export$2e2bcd8739ae039), {
                        data: newsData,
                        id: playerId,
                        newsType: "player",
                        sport: sport,
                        baseUrl: baseUrl,
                        limit: 3
                    })
                ]
            })
        ]
    });
};
var $87bc647b9940ee75$export$2e2bcd8739ae039 = $87bc647b9940ee75$var$PlayerInfo;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");


var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $3G7m1 = parcelRequire("3G7m1");

var $ba5nK = parcelRequire("ba5nK");
const $84ffcb1c0b3fa45e$var$PlayerPerformance = ({ data: data })=>{
    const getMatchOutcomeClass = (outcome)=>{
        let outcomeClass;
        if (outcome === "W") outcomeClass = "win";
        else if (outcome === "L") outcomeClass = "loss";
        else outcomeClass = "draw";
        return outcomeClass;
    };
    const baseURL = "https://ipublisher-microservices.6lgx.com";
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "player_performance",
        children: data?.map((item, index)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "performance_round",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("h3", {
                        children: [
                            "Round ",
                            /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                children: item?.rou
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "round_box",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                className: "round_head",
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        children: (0, $3G7m1.convertDate)(item?.dt)
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("ul", {
                                        className: "round_head_ul",
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                        className: "round_image",
                                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                            src: `${baseURL}/public/assets/images/svg/card-yellow.svg`,
                                                            width: 11,
                                                            height: 15,
                                                            alt: "card"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                        children: item?.yc
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                        className: "round_image",
                                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                            src: `${baseURL}/public/assets/images/svg/card-yellowred.svg`,
                                                            width: 13,
                                                            height: 17,
                                                            alt: "card"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                        children: item?.syc
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                        className: "round_image",
                                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                            src: `${baseURL}/public/assets/images/svg/card-red.svg`,
                                                            width: 11,
                                                            height: 15,
                                                            alt: "card"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                        children: item?.rc
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                className: "round_body",
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                        className: "rbody_lft",
                                        children: [
                                            "Opposite Team: ",
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                children: item?.oppt
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                        className: "rbody_rgt",
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                children: item?.ft
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                className: `icon_status ${getMatchOutcomeClass(item?.type)}`,
                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    children: item?.type
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: "round_foot",
                                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("ul", {
                                    className: "round_foot_ul",
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                            children: [
                                                "Starting XI: ",
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                    children: item?.strtxi
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                            children: [
                                                "In: ",
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                    children: item?.in
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                            children: [
                                                "Out: ",
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                    children: item?.out
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                            children: [
                                                "Min Played: ",
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                    children: item?.plyd
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                            children: [
                                                "Goals: ",
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                    children: item?.goals
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                            children: [
                                                "Assists: ",
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                    children: item?.asst
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }, item?.id || index))
    });
};
var $84ffcb1c0b3fa45e$export$2e2bcd8739ae039 = $84ffcb1c0b3fa45e$var$PlayerPerformance;



var $2bSDe = parcelRequire("2bSDe");
"use client";
const $99df54ce73c84c4f$var$PlayerMatchesWrp = ({ data: data, teamId: teamId, baseUrl: baseUrl, dataClient: dataClient, loadCSS: loadCSS, title: title })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)([]);
    const [teamData, setTeamData] = (0, $6cds3.useState)(dataClient ? clientData : data);
    const [leagueSelectedId, setLeagueSelectedId] = (0, $6cds3.useState)(dataClient ? clientData?.league?.data?.[0]?.id : data?.league?.data?.[0]?.id);
    const items = dataClient ? clientData?.league : data?.league;
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data;
            setClientData(parsed || []);
            setTeamData(parsed?.squad);
            setLeagueSelectedId(parsed?.league?.data?.[0]?.id);
        } catch (error) {
            console.error("Failed to parse client data:", error);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("footballplayer");
    }, [
        loadCSS
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (!leagueSelectedId || !teamId) return;
        const fetchTableData = async ()=>{
            try {
                const res = await fetch(`${baseUrl}/football/player/${teamId}/performance?leagueId=${leagueSelectedId}`, {
                    headers: {
                        Token: undefined
                    }
                });
                if (!res.ok) throw new Error(res.statusText);
                const json = await res.json();
                setTeamData(json || []);
            } catch (err) {
                console.error("Failed to fetch squad:", err);
            }
        };
        fetchTableData();
    }, [
        leagueSelectedId,
        teamId
    ]);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            title ? /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }) : null,
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $fc7294d77b5150c9$export$2e2bcd8739ae039), {
                items: items?.data,
                defaultValue: leagueSelectedId,
                setLeagueSelectedId: setLeagueSelectedId
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $84ffcb1c0b3fa45e$export$2e2bcd8739ae039), {
                data: teamData?.data
            })
        ]
    });
};
var $99df54ce73c84c4f$export$2e2bcd8739ae039 = $99df54ce73c84c4f$var$PlayerMatchesWrp;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $3G7m1 = parcelRequire("3G7m1");


var $2bSDe = parcelRequire("2bSDe");
const $31a79158c95bff53$var$PlayerTransferHistory = ({ ServerData: ServerData, loadCSS: loadCSS = true, dataClient: dataClient = false, title: title, dictionary: dictionary = {} })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    const data = dataClient ? clientData : ServerData || [];
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document?.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("footballplayer");
    }, [
        loadCSS
    ]);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "player_transfer_history",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                children: "Transfer History"
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "global_table player_tranfer",
                children: data?.length ? /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: dictionary?.team || "Team"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: dictionary?.timeperiod || "Time Period"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
                                children: data?.slice(0, 20)?.map((item, index)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                        className: `${index === 0 ? "current" : ""}`,
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                    className: "team_name",
                                                    children: item?.ttnm
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: (0, $3G7m1.convertDate)(item?.perd)
                                            })
                                        ]
                                    }, index))
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $31a79158c95bff53$export$2e2bcd8739ae039 = $31a79158c95bff53$var$PlayerTransferHistory;



var $3G7m1 = parcelRequire("3G7m1");
const $e56092a810c2f874$var$TeamWidgetWrap = ({ dataId: dataId, dataType: dataType, sport: sport, difference: difference, head: head, data: data, headData: headData, otherData: otherData, baseUrl: baseUrl, loadCSS: loadCSS, setDataId: setDataId, setDataType: setDataType, setHead: setHead, setLeagueId: setLeagueId, setDate: setDate, date: date, setIsLive: setIsLive, isLive: isLive, dataClient: dataClient = false, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataTitle: dataTitle })=>{
    switch(dataType){
        case "team-page":
            return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
                children: head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0881f34d53fa6722$export$2e2bcd8739ae039), {
                    id: dataId,
                    imgUrl: (0, $3G7m1.getImageUrl)('', '', sport, headData?.id),
                    title: headData?.nm,
                    type: "leagues",
                    manager: headData?.mang,
                    teamPage: true,
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $14345f1ffad1bba8$export$2e2bcd8739ae039), {
                        data: data?.data,
                        baseUrl: baseUrl,
                        dataType: dataType,
                        difference: difference,
                        sport: sport,
                        dataId: dataId,
                        loadCSS: loadCSS,
                        headData: headData,
                        setDataId: setDataId,
                        setDataType: setDataType,
                        setHead: setHead,
                        setLeagueId: setLeagueId
                    })
                }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $14345f1ffad1bba8$export$2e2bcd8739ae039), {
                    data: data?.data,
                    baseUrl: baseUrl,
                    dataType: dataType,
                    difference: difference,
                    sport: sport,
                    dataId: dataId,
                    loadCSS: loadCSS,
                    setDataId: setDataId,
                    setDataType: setDataType,
                    setHead: setHead,
                    setLeagueId: setLeagueId
                })
            });
        case "team-info":
            return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
                children: head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0881f34d53fa6722$export$2e2bcd8739ae039), {
                    id: dataId,
                    headData: headData,
                    baseUrl: baseUrl,
                    state: "team",
                    dataClient: dataClient,
                    currentTab: "info",
                    websiteBaseUrl: websiteBaseUrl,
                    dataPath: dataPath,
                    widgetTitle: dataTitle,
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $be5ab0c7cb61a9f3$export$2e2bcd8739ae039), {
                        id: dataId,
                        sport: sport,
                        data: data,
                        loadCSS: loadCSS,
                        baseUrl: baseUrl,
                        dataClient: dataClient,
                        websiteBaseUrl: websiteBaseUrl,
                        dataPath: dataPath,
                        matchType: "team"
                    })
                }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $be5ab0c7cb61a9f3$export$2e2bcd8739ae039), {
                    id: dataId,
                    sport: sport,
                    data: data,
                    loadCSS: loadCSS,
                    baseUrl: baseUrl,
                    dataClient: dataClient,
                    websiteBaseUrl: websiteBaseUrl,
                    dataPath: dataPath,
                    matchType: "team",
                    title: dataTitle
                })
            });
        case "team-news":
            return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
                children: head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0881f34d53fa6722$export$2e2bcd8739ae039), {
                    id: dataId,
                    headData: headData,
                    baseUrl: baseUrl,
                    state: "team",
                    dataClient: dataClient,
                    currentTab: "news",
                    websiteBaseUrl: websiteBaseUrl,
                    dataPath: dataPath,
                    widgetTitle: dataTitle,
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $4c03dbc6caeb65b2$export$2e2bcd8739ae039), {
                        data: data,
                        difference: difference,
                        loadCSS: loadCSS,
                        dataClient: dataClient,
                        baseUrl: baseUrl,
                        id: dataId,
                        newsType: "team"
                    })
                }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $4c03dbc6caeb65b2$export$2e2bcd8739ae039), {
                    data: data,
                    difference: difference,
                    loadCSS: loadCSS,
                    dataClient: dataClient,
                    title: dataTitle,
                    baseUrl: baseUrl,
                    id: dataId,
                    newsType: "team"
                })
            });
        case "team-finished":
        case "team-results":
            return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
                children: head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0881f34d53fa6722$export$2e2bcd8739ae039), {
                    id: dataId,
                    headData: headData,
                    baseUrl: baseUrl,
                    state: "team",
                    dataClient: dataClient,
                    currentTab: "results",
                    websiteBaseUrl: websiteBaseUrl,
                    dataPath: dataPath,
                    widgetTitle: dataTitle,
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3207c25f6468a03b$export$2e2bcd8739ae039), {
                        sport: sport,
                        data: data?.data,
                        loadCSS: loadCSS,
                        baseUrl: baseUrl,
                        setDataType: setDataType,
                        setDataId: setDataId,
                        setHead: setHead,
                        dataClient: dataClient,
                        websiteBaseUrl: websiteBaseUrl,
                        dataPath: dataPath,
                        matchType: "team",
                        difference: difference
                    })
                }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3207c25f6468a03b$export$2e2bcd8739ae039), {
                    sport: sport,
                    data: data?.data,
                    loadCSS: loadCSS,
                    baseUrl: baseUrl,
                    setDataType: setDataType,
                    setDataId: setDataId,
                    setHead: setHead,
                    dataClient: dataClient,
                    websiteBaseUrl: websiteBaseUrl,
                    dataPath: dataPath,
                    matchType: "team",
                    title: dataTitle,
                    difference: difference
                })
            });
        case "team-upcoming":
            return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
                children: head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0881f34d53fa6722$export$2e2bcd8739ae039), {
                    id: dataId,
                    headData: headData,
                    baseUrl: baseUrl,
                    state: "team",
                    dataClient: dataClient,
                    currentTab: "upcoming",
                    websiteBaseUrl: websiteBaseUrl,
                    dataPath: dataPath,
                    widgetTitle: dataTitle,
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3207c25f6468a03b$export$2e2bcd8739ae039), {
                        sport: sport,
                        data: data?.data,
                        loadCSS: loadCSS,
                        baseUrl: baseUrl,
                        setDataType: setDataType,
                        setDataId: setDataId,
                        setHead: setHead,
                        dataClient: dataClient,
                        websiteBaseUrl: websiteBaseUrl,
                        dataPath: dataPath,
                        matchType: "team",
                        difference: difference
                    })
                }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3207c25f6468a03b$export$2e2bcd8739ae039), {
                    sport: sport,
                    data: data?.data,
                    loadCSS: loadCSS,
                    baseUrl: baseUrl,
                    setDataType: setDataType,
                    setDataId: setDataId,
                    setHead: setHead,
                    dataClient: dataClient,
                    websiteBaseUrl: websiteBaseUrl,
                    dataPath: dataPath,
                    matchType: "team",
                    title: dataTitle,
                    difference: difference
                })
            });
        case "team-standings":
            return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
                children: head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0881f34d53fa6722$export$2e2bcd8739ae039), {
                    id: dataId,
                    headData: headData,
                    baseUrl: baseUrl,
                    state: "team",
                    dataClient: dataClient,
                    currentTab: "table",
                    websiteBaseUrl: websiteBaseUrl,
                    dataPath: dataPath,
                    widgetTitle: dataTitle,
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $7a903f87fe1db995$export$2e2bcd8739ae039), {
                        sport: sport,
                        data: data,
                        teamId: dataId,
                        loadCSS: loadCSS,
                        baseUrl: baseUrl,
                        dataClient: dataClient,
                        websiteBaseUrl: websiteBaseUrl,
                        dataPath: dataPath
                    })
                }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $7a903f87fe1db995$export$2e2bcd8739ae039), {
                    sport: sport,
                    data: data,
                    teamId: dataId,
                    loadCSS: loadCSS,
                    baseUrl: baseUrl,
                    dataClient: dataClient,
                    websiteBaseUrl: websiteBaseUrl,
                    dataPath: dataPath,
                    title: dataTitle
                })
            });
        case "team-squad":
            return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
                children: head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0881f34d53fa6722$export$2e2bcd8739ae039), {
                    id: dataId,
                    headData: headData,
                    baseUrl: baseUrl,
                    state: "team",
                    dataClient: dataClient,
                    currentTab: "squad",
                    websiteBaseUrl: websiteBaseUrl,
                    dataPath: dataPath,
                    widgetTitle: dataTitle,
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $1790171c006cf770$export$2e2bcd8739ae039), {
                        sport: sport,
                        data: data,
                        teamId: dataId,
                        loadCSS: loadCSS,
                        baseUrl: baseUrl,
                        dataClient: dataClient,
                        websiteBaseUrl: websiteBaseUrl,
                        dataPath: dataPath
                    })
                }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $1790171c006cf770$export$2e2bcd8739ae039), {
                    sport: sport,
                    data: data,
                    teamId: dataId,
                    loadCSS: loadCSS,
                    baseUrl: baseUrl,
                    dataClient: dataClient,
                    websiteBaseUrl: websiteBaseUrl,
                    dataPath: dataPath,
                    title: dataTitle
                })
            });
        case "team-stats":
            return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
                children: head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0881f34d53fa6722$export$2e2bcd8739ae039), {
                    id: dataId,
                    headData: headData,
                    baseUrl: baseUrl,
                    state: "team",
                    dataClient: dataClient,
                    currentTab: "stats",
                    websiteBaseUrl: websiteBaseUrl,
                    dataPath: dataPath,
                    widgetTitle: dataTitle,
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $c872d8fa35387784$export$2e2bcd8739ae039), {
                        sport: sport,
                        data: data,
                        teamId: dataId,
                        loadCSS: loadCSS,
                        baseUrl: baseUrl,
                        dataClient: dataClient,
                        websiteBaseUrl: websiteBaseUrl,
                        dataPath: dataPath
                    })
                }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $c872d8fa35387784$export$2e2bcd8739ae039), {
                    sport: sport,
                    data: data,
                    teamId: dataId,
                    loadCSS: loadCSS,
                    baseUrl: baseUrl,
                    dataClient: dataClient,
                    websiteBaseUrl: websiteBaseUrl,
                    dataPath: dataPath
                })
            });
        case "team-player-stats":
            return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
                children: head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0881f34d53fa6722$export$2e2bcd8739ae039), {
                    id: dataId,
                    headData: headData,
                    baseUrl: baseUrl,
                    state: "team",
                    dataClient: dataClient,
                    currentTab: "player stats",
                    websiteBaseUrl: websiteBaseUrl,
                    dataPath: dataPath,
                    widgetTitle: dataTitle,
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $6634c2a571496b47$export$2e2bcd8739ae039), {
                        sport: sport,
                        data: data,
                        teamId: dataId,
                        loadCSS: loadCSS,
                        baseUrl: baseUrl,
                        dataClient: dataClient,
                        websiteBaseUrl: websiteBaseUrl,
                        dataPath: dataPath
                    })
                }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $6634c2a571496b47$export$2e2bcd8739ae039), {
                    sport: sport,
                    data: data,
                    teamId: dataId,
                    loadCSS: loadCSS,
                    baseUrl: baseUrl,
                    dataClient: dataClient,
                    websiteBaseUrl: websiteBaseUrl,
                    dataPath: dataPath
                })
            });
        case "player-info":
            return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
                children: head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0881f34d53fa6722$export$2e2bcd8739ae039), {
                    id: dataId,
                    headData: headData,
                    baseUrl: baseUrl,
                    state: "player",
                    dataClient: dataClient,
                    currentTab: "info",
                    websiteBaseUrl: websiteBaseUrl,
                    dataPath: dataPath,
                    widgetTitle: dataTitle,
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $87bc647b9940ee75$export$2e2bcd8739ae039), {
                        ServerData: data?.data,
                        loadCSS: loadCSS,
                        dataClient: dataClient,
                        difference: difference
                    })
                }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $87bc647b9940ee75$export$2e2bcd8739ae039), {
                    ServerData: data?.data,
                    loadCSS: loadCSS,
                    dataClient: dataClient,
                    difference: difference
                })
            });
        case "player-performance":
            return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
                children: head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0881f34d53fa6722$export$2e2bcd8739ae039), {
                    id: dataId,
                    headData: headData,
                    baseUrl: baseUrl,
                    state: "player",
                    dataClient: dataClient,
                    currentTab: "performance",
                    websiteBaseUrl: websiteBaseUrl,
                    dataPath: dataPath,
                    widgetTitle: dataTitle,
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $99df54ce73c84c4f$export$2e2bcd8739ae039), {
                        sport: sport,
                        data: data,
                        teamId: dataId,
                        loadCSS: loadCSS,
                        baseUrl: baseUrl,
                        dataClient: dataClient,
                        websiteBaseUrl: websiteBaseUrl,
                        dataPath: dataPath
                    })
                }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $99df54ce73c84c4f$export$2e2bcd8739ae039), {
                    ServerData: data?.data,
                    loadCSS: loadCSS,
                    dataClient: dataClient,
                    difference: difference
                })
            });
        case "player-history":
            return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
                children: head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0881f34d53fa6722$export$2e2bcd8739ae039), {
                    id: dataId,
                    headData: headData,
                    baseUrl: baseUrl,
                    state: "player",
                    dataClient: dataClient,
                    currentTab: "transfer_history",
                    websiteBaseUrl: websiteBaseUrl,
                    dataPath: dataPath,
                    widgetTitle: dataTitle,
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $31a79158c95bff53$export$2e2bcd8739ae039), {
                        ServerData: data?.data,
                        loadCSS: loadCSS,
                        dataClient: dataClient,
                        difference: difference
                    })
                }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $31a79158c95bff53$export$2e2bcd8739ae039), {
                    ServerData: data?.data,
                    loadCSS: loadCSS,
                    dataClient: dataClient,
                    difference: difference
                })
            });
        default:
            return /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: "Widget Not Found in football Team!"
            });
    }
};
var $e56092a810c2f874$export$2e2bcd8739ae039 = $e56092a810c2f874$var$TeamWidgetWrap;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");


var $ba5nK = parcelRequire("ba5nK");

var $2bSDe = parcelRequire("2bSDe");
const $699236828680c846$var$TopScorers = ({ data: data, loadCSS: loadCSS, dataClient: dataClient = false, title: title })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("leaguetopscrorers");
    }, [
        loadCSS
    ]);
    const sourceData = dataClient ? clientData : data;
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "top_score_wrp",
        children: sourceData?.length ? /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                    className: "top_score_hd",
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                            children: "Goals"
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                            className: "hd_rgt",
                            children: "PEN"
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                            className: "hd_rgt",
                            children: "GS"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                    className: "item_list",
                    children: sourceData?.map((i)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                    className: "num"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                    className: "country_info",
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                            className: "flag_img",
                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                src: `https://img.sixlogics.com/players/${i?.player?.id}.png`,
                                                width: 18,
                                                height: 18,
                                                alt: "avtar"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                            className: "cr_name",
                                            children: i?.pn || i?.player?.name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                    className: "g_num",
                                    children: i?.pc
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                    className: "g_num",
                                    children: i?.gs
                                })
                            ]
                        }, i?.id))
                })
            ]
        }) : /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
            className: "top_score_hd",
            children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {})
        })
    });
};
var $699236828680c846$export$2e2bcd8739ae039 = $699236828680c846$var$TopScorers;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $zSRJd = parcelRequire("zSRJd");




var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");


var $3G7m1 = parcelRequire("3G7m1");
const $6df608e5abeeef03$var$TopAssists = ({ data: data, dictionary: dictionary, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataClient: dataClient, sport: sport = "football" })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "global_table striped offense_tbl ",
        children: data?.length ? /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "#"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "Players"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "assist"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
                                children: data?.slice(0, 20)?.map((i, index)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: index + 1
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                                                    href: (0, $3G7m1.teamLeagueInfoUrl)({
                                                        dataClient: dataClient,
                                                        websiteBaseUrl: websiteBaseUrl,
                                                        dataPath: dataPath,
                                                        category: "player",
                                                        sport: sport,
                                                        name: (0, $3G7m1.titleToSlug)(i?.pn),
                                                        id: i?.player_id
                                                    }),
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                        className: "cr_name",
                                                        children: i?.pn
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: i?.asit
                                            })
                                        ]
                                    }, index))
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: "bottom_tr",
                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("ul", {
                        className: "item_list",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "symbol",
                                        children: "P"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "full_form",
                                        children: "Game Play"
                                    })
                                ]
                            }),
                            " ",
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "symbol",
                                        children: "G"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "full_form",
                                        children: "Goal Scored"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "symbol",
                                        children: "RK"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "full_form",
                                        children: "Rankings"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "symbol",
                                        children: "A"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "full_form",
                                        children: "Assists"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {})
    });
};
var $6df608e5abeeef03$export$2e2bcd8739ae039 = $6df608e5abeeef03$var$TopAssists;





var $2bSDe = parcelRequire("2bSDe");
// Tab configuration for better maintainability
const $9cc94870d0d030e6$var$TAB_CONFIG = {
    "league-upcoming": {
        component: "matches",
        matchType: "upcoming"
    },
    "league-finished": {
        component: "matches",
        matchType: "finished"
    },
    "league-results": {
        component: "matches",
        matchType: "finished"
    },
    "league-table": {
        component: "standings"
    },
    "league-top-scorers": {
        component: "topScorers"
    },
    "league-top-assists": {
        component: "topAssists"
    },
    "league-news": {
        component: "news",
        newsType: "league"
    },
    "league-stats": {
        component: "stats"
    }
};
const $9cc94870d0d030e6$var$LeaguePage = ({ data: data, baseUrl: baseUrl, difference: difference, sport: sport = "football", dataId: dataId, loadCSS: loadCSS, headData: headData, setDataId: setDataId, setDataType: setDataType, setHead: setHead, setLeagueId: setLeagueId, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath = "football", dataClient: dataClient = false })=>{
    const [active, setActive] = (0, $6cds3.useState)(null);
    const [activeTabData, setActiveTabData] = (0, $6cds3.useState)(null);
    const [tabs, setTabs] = (0, $6cds3.useState)([]);
    const [isLoading, setIsLoading] = (0, $6cds3.useState)(false);
    // Initialize tabs from headData
    (0, $6cds3.useEffect)(()=>{
        if (headData?.tabs?.length > 0) {
            const leagueTabs = headData.tabs.map((tab)=>({
                    key: `league-${tab?.replaceAll("_", "-")}`,
                    label: tab.replaceAll("_", " ")
                }));
            setTabs(leagueTabs);
            setActive({
                key: `league-${headData.tabs[0]?.replaceAll("_", "-")}`,
                label: headData.tabs[0].replaceAll("_", " ")
            });
        }
    }, [
        headData
    ]);
    // Set initial data
    (0, $6cds3.useEffect)(()=>{
        if (data) setActiveTabData(data);
    }, [
        data
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("leaguepage");
    }, [
        loadCSS
    ]);
    // Fetch data for active tab
    const fetchData = (0, $6cds3.useCallback)(async ()=>{
        if (!active?.key) return;
        try {
            setIsLoading(true);
            const tabConfig = $9cc94870d0d030e6$var$TAB_CONFIG[active.key];
            const fetchedData = await (0, $zSRJd.getData)({
                dataId: dataId,
                dataType: active.key,
                baseUrl: baseUrl,
                sport: sport,
                newsType: tabConfig?.newsType || undefined
            });
            setActiveTabData(fetchedData);
        } catch (error) {
            console.error("Error fetching data:", error);
            setActiveTabData(null);
        } finally{
            setIsLoading(false);
        }
    }, [
        active?.key,
        dataId,
        baseUrl,
        sport
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (active) fetchData();
    }, [
        active,
        fetchData
    ]);
    // Handle tab click
    const handleTabClick = (key, label)=>{
        if (active?.key !== key) {
            setIsLoading(true);
            setActive({
                key: key,
                label: label
            });
            setActiveTabData(null);
        }
    };
    // Render tab content based on active tab
    const renderTabContent = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
            className: "loading-state",
            children: /*#__PURE__*/ (0, $lBpE3.jsx)("h3", {
                children: "Loading..."
            })
        });
        const tabConfig = $9cc94870d0d030e6$var$TAB_CONFIG[active?.key];
        if (!tabConfig) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {});
        switch(tabConfig.component){
            case "matches":
                return activeTabData?.data ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $d7c3bcbf98681d67$export$2e2bcd8739ae039), {
                    data: activeTabData.data,
                    difference: difference,
                    matchType: tabConfig.matchType,
                    loadCSS: loadCSS,
                    sport: sport,
                    baseUrl: baseUrl,
                    setDataId: setDataId,
                    setDataType: setDataType,
                    setHead: setHead,
                    setLeagueId: setLeagueId,
                    websiteBaseUrl: websiteBaseUrl,
                    dataPath: dataPath,
                    dataClient: dataClient
                }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {
                    text: `No ${tabConfig.matchType} matches found`
                });
            case "standings":
                return activeTabData?.data?.football_tournament_tables ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $9b1908741783b4d4$export$2e2bcd8739ae039), {
                    data: activeTabData.data.football_tournament_tables,
                    loadCSS: loadCSS
                }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {
                    text: "No standings data available"
                });
            case "topScorers":
                return activeTabData?.data ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $699236828680c846$export$2e2bcd8739ae039), {
                    data: activeTabData.data,
                    loadCSS: loadCSS,
                    sport: sport,
                    websiteBaseUrl: websiteBaseUrl,
                    dataPath: dataPath,
                    dataClient: dataClient
                }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {
                    text: "No top scorers data available"
                });
            case "topAssists":
                return activeTabData?.data ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $6df608e5abeeef03$export$2e2bcd8739ae039), {
                    data: activeTabData.data,
                    loadCSS: loadCSS,
                    sport: sport,
                    websiteBaseUrl: websiteBaseUrl,
                    dataPath: dataPath,
                    dataClient: dataClient
                }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {
                    text: "No top assists data available"
                });
            case "news":
                return activeTabData?.data || activeTabData ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $4c03dbc6caeb65b2$export$2e2bcd8739ae039), {
                    data: activeTabData?.data || activeTabData,
                    loadCSS: loadCSS,
                    newsType: tabConfig.newsType,
                    id: dataId,
                    sport: sport,
                    baseUrl: baseUrl
                }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {
                    text: "No news available"
                });
            case "stats":
                return activeTabData?.data ? /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: "league_stats_wrp",
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("pre", {
                        children: JSON.stringify(activeTabData.data, null, 2)
                    })
                }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {
                    text: "No stats available"
                });
            default:
                return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {});
        }
    };
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "league-page",
        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
            className: "detail_page",
            children: [
                tabs.length > 0 && /*#__PURE__*/ (0, $lBpE3.jsx)("nav", {
                    className: "inner_tab detail_main_tab",
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                        children: tabs.map(({ key: key, label: label })=>/*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                className: active?.key === key ? "active" : "",
                                onClick: ()=>handleTabClick(key, label),
                                "data-name": key,
                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                    children: label
                                })
                            }, key))
                    })
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: "tab_content",
                    children: renderTabContent()
                })
            ]
        })
    });
};
var $9cc94870d0d030e6$export$2e2bcd8739ae039 = $9cc94870d0d030e6$var$LeaguePage;






var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");


var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");


var $3G7m1 = parcelRequire("3G7m1");
const $c269a6526cb7e3da$var$TopScorers = ({ data: data, dictionary: dictionary, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataClient: dataClient, sport: sport = "football" })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "global_table striped offense_tbl top_score_wrp",
        children: data?.length ? /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "#"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "Players"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "P"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "G"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
                                children: data?.slice(0, 20)?.map((i, index)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: index + 1
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                                                    href: (0, $3G7m1.teamLeagueInfoUrl)({
                                                        dataClient: dataClient,
                                                        websiteBaseUrl: websiteBaseUrl,
                                                        dataPath: dataPath,
                                                        category: "player",
                                                        sport: sport,
                                                        name: (0, $3G7m1.titleToSlug)(i?.pn),
                                                        id: i?.player_id
                                                    }),
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                        className: "cr_name",
                                                        children: i?.pn
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: i?.pc
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: i?.gs
                                            })
                                        ]
                                    }, index))
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: "bottom_tr",
                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("ul", {
                        className: "item_list",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "symbol",
                                        children: "P"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "full_form",
                                        children: "Game Play"
                                    })
                                ]
                            }),
                            " ",
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "symbol",
                                        children: "G"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "full_form",
                                        children: "Goal Scored"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "symbol",
                                        children: "RK"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "full_form",
                                        children: "Rankings"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "symbol",
                                        children: "A"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "full_form",
                                        children: "Assists"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {})
    });
};
var $c269a6526cb7e3da$export$2e2bcd8739ae039 = $c269a6526cb7e3da$var$TopScorers;



const $4fc5b62addea62dc$var$FootballLeaguePlayerStats = ({ topScorer: topScorer, topAssists: topAssists, dictionary: dictionary, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataClient: dataClient })=>{
    const [activePlayerStats, setActivePlayerStats] = (0, $6cds3.useState)("scorers");
    const tabs = [
        {
            key: "scorers",
            label: "Top Scorers"
        },
        {
            key: "assists",
            label: "Top Assists"
        }
    ];
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "player_stats",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("nav", {
                className: "inner_tab",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                    children: tabs.map(({ key: key, label: label })=>/*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                            className: `${activePlayerStats === key ? "active" : ""}`,
                            onClick: ()=>setActivePlayerStats(key),
                            "data-name": key,
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                children: label
                            })
                        }, key))
                })
            }),
            activePlayerStats === "scorers" ? /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "leg_head",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                            children: "Scorers"
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)((0, $c269a6526cb7e3da$export$2e2bcd8739ae039), {
                        data: topScorer,
                        dictionary: dictionary,
                        websiteBaseUrl: websiteBaseUrl,
                        dataPath: dataPath,
                        dataClient: dataClient
                    })
                ]
            }) : /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "leg_head",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                            children: "Assists"
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)((0, $6df608e5abeeef03$export$2e2bcd8739ae039), {
                        data: topAssists,
                        dictionary: dictionary,
                        websiteBaseUrl: websiteBaseUrl,
                        dataPath: dataPath,
                        dataClient: dataClient
                    })
                ]
            })
        ]
    });
};
var $4fc5b62addea62dc$export$2e2bcd8739ae039 = $4fc5b62addea62dc$var$FootballLeaguePlayerStats;



var $2bSDe = parcelRequire("2bSDe");
const $3f965b32a4f8cc67$var$FootballLeagueStats = ({ dictionary: dictionary, data: data, loadCSS: loadCSS, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataClient: dataClient = false })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    const [active, setActive] = (0, $6cds3.useState)("team");
    const tabs = [
        {
            key: "team",
            label: "Team Stats"
        },
        {
            key: "player",
            label: "Player Stats"
        }
    ];
    // Load client-side data if needed
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const raw = document.querySelector(".microservice-cont")?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    // Load CSS dynamically
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("leagueStats");
    }, [
        loadCSS
    ]);
    const statsOverview = dataClient ? clientData?.overview : data?.overview;
    const topScorer = dataClient ? clientData?.topScorers : data?.topScorers;
    const topAssists = dataClient ? clientData?.topAssists : data?.topAssists;
    if (dataClient && !clientData) return null;
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("nav", {
                className: "inner_tab",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                    children: tabs.map(({ key: key, label: label })=>/*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                            className: active === key ? "active" : "",
                            onClick: ()=>setActive(key),
                            "data-name": key,
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                children: label
                            })
                        }, key))
                })
            }),
            active === "team" ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $a821ae266245c60d$export$2e2bcd8739ae039), {
                data: statsOverview?.data,
                dictionary: dictionary
            }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $4fc5b62addea62dc$export$2e2bcd8739ae039), {
                topScorer: topScorer?.data,
                topAssists: topAssists?.data,
                dictionary: dictionary,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                dataClient: dataClient
            })
        ]
    });
};
var $3f965b32a4f8cc67$export$2e2bcd8739ae039 = $3f965b32a4f8cc67$var$FootballLeagueStats;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $3G7m1 = parcelRequire("3G7m1");

var $ba5nK = parcelRequire("ba5nK");

const $e470627a1a6f9fbd$var$LeagueTeamTable = ({ data: data, dictionary: dictionary = {}, sport: sport = "football" })=>{
    const sortedData = [
        ...data || []
    ]?.sort((a, b)=>(a?.name || "")?.localeCompare(b?.name || ""))?.slice(0, 20);
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "global_table team_table",
        children: sortedData?.length ? /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "#"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: dictionary?.teams || "Teams"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                    children: sortedData?.map((row, index)=>{
                        return /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                    children: index + 1
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                        className: "des-wrap",
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: "flg_img",
                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                    src: (0, $3G7m1.getImageUrl)('', '', sport, row?.tid),
                                                    height: 23,
                                                    width: 23,
                                                    alt: "teamLogo",
                                                    priority: false
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: "des-text",
                                                children: row?.name
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                                                    href: `/${sport}/team/${(0, $3G7m1.linkName)(row?.name)}/${row?.id}/info`,
                                                    children: "Fixtures"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                                                    href: `/${sport}/team/${(0, $3G7m1.linkName)(row?.name)}/${row?.id}/stats`,
                                                    children: "Stats"
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }, index);
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {})
    });
};
var $e470627a1a6f9fbd$export$2e2bcd8739ae039 = $e470627a1a6f9fbd$var$LeagueTeamTable;



var $2bSDe = parcelRequire("2bSDe");
const $ecd6e6333da3a205$var$LeagueTeamWrapper = ({ data: data, loadCSS: loadCSS, dataClient: dataClient = false, baseUrl: baseUrl, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, title: title, id: id, matchType: matchType = "league", sport: sport })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("livematchdetail");
    }, [
        loadCSS
    ]);
    const sourceData = dataClient ? clientData : data;
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $e470627a1a6f9fbd$export$2e2bcd8739ae039), {
                data: sourceData?.data
            })
        ]
    });
};
var $ecd6e6333da3a205$export$2e2bcd8739ae039 = $ecd6e6333da3a205$var$LeagueTeamWrapper;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $2bSDe = parcelRequire("2bSDe");

var $zSRJd = parcelRequire("zSRJd");

var $3G7m1 = parcelRequire("3G7m1");
/**
 * LeagueTable — modern, self-contained football league-standings widget.
 *
 * Two variants (both render this component):
 *   • detailed-league-table → every group's full standings (all rows, all columns)
 *   • preview-league-table  → the first group's top 5 rows only
 *
 * Data: /league/{id}/table?type=list → an ARRAY of groups, each:
 *   { nm, fid, football_tournament_tables:[ { plc, clr, team:{id,nm,sn}, pld, w, d, l, scr, con, dif, pts } ] }
 * A single-table league returns one group; a cup returns many (e.g. World Cup → 12).
 * No Home/Away split (deliberately omitted). Colours are CMS-token driven.
 *
 * Data source (priority): serverData prop → hydration DOM (data-listingdata) → self-fetch.
 */ // Normalise any wrapper into an array of group objects, or null.
const $ae3537a2b2960473$var$groupsFromRaw = (raw)=>{
    if (!raw || typeof raw !== "object") return null;
    let o = raw;
    for(let i = 0; i < 4; i++){
        if (Array.isArray(o)) break;
        if (o?.football_tournament_tables) {
            o = [
                o
            ]; // single-object (non-list) shape → wrap as one group
            break;
        }
        o = o?.data;
        if (o === undefined || o === null) return null;
    }
    if (!Array.isArray(o)) return null;
    const groups = o.filter((g)=>g && Array.isArray(g.football_tournament_tables));
    return groups.length ? groups : null;
};
const $ae3537a2b2960473$var$numDiff = (n)=>{
    const v = Number(n);
    if (Number.isNaN(v)) return n ?? "";
    return v > 0 ? `+${v}` : `${v}`;
};
// Form is not in the /league/{id}/table payload today, but render it if it
// ever appears (frm / form / recent_form as an array of "W"/"D"/"L").
const $ae3537a2b2960473$var$rowForm = (r)=>{
    const f = r?.frm || r?.form || r?.recent_form;
    return Array.isArray(f) ? f.slice(-5) : null;
};
// "World Cup Group A" → "World Cup" (for the header when there are many groups).
const $ae3537a2b2960473$var$competitionName = (name)=>{
    const stripped = String(name || "").replace(/\s+Group\s+.*$/i, "").trim();
    return stripped || name || "League Table";
};
const $ae3537a2b2960473$var$Crest = ({ src: src, name: name })=>/*#__PURE__*/ (0, $lBpE3.jsx)("span", {
        className: "lt__crest",
        children: src ? /*#__PURE__*/ (0, $lBpE3.jsx)("img", {
            src: src,
            alt: name ? `${name} crest` : "",
            loading: "lazy",
            onError: (e)=>{
                e.currentTarget.style.display = "none";
            }
        }) : null
    });
const $ae3537a2b2960473$var$FormDots = ({ form: form })=>/*#__PURE__*/ (0, $lBpE3.jsx)("span", {
        className: "lt__form",
        children: form.map((r, i)=>{
            const k = String(r || "").toUpperCase().charAt(0);
            const cls = k === "W" ? "win" : k === "L" ? "loss" : "draw";
            return /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                className: `lt__fdot lt__fdot--${cls}`,
                children: k
            }, i);
        })
    });
// One group's table. `offset`/`limit` render a page slice (used by the preview pager).
const $ae3537a2b2960473$var$GroupTable = ({ group: group, sport: sport, offset: offset = 0, limit: limit = Infinity, subhead: subhead = false })=>{
    const allRows = [
        ...group.football_tournament_tables || []
    ].sort((a, b)=>(a?.plc ?? 0) - (b?.plc ?? 0));
    const rows = allRows.slice(offset, offset + limit);
    if (!rows.length) return null;
    const hasForm = allRows.some((r)=>$ae3537a2b2960473$var$rowForm(r));
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "lt__grp",
        children: [
            subhead ? /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "lt__group",
                children: group.nm
            }) : null,
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "lt__scroll",
                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                    className: "lt__table",
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        className: "lt__c-rank",
                                        children: "#"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        className: "lt__c-team",
                                        children: "Team"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        className: "lt__c-num",
                                        children: "P"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        className: "lt__c-num",
                                        children: "W"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        className: "lt__c-num",
                                        children: "D"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        className: "lt__c-num",
                                        children: "L"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        className: "lt__c-num lt__c-ga",
                                        children: "F"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        className: "lt__c-num lt__c-ga",
                                        children: "A"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        className: "lt__c-num lt__c-diff",
                                        children: "GD"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        className: "lt__c-pts",
                                        children: "PTS"
                                    }),
                                    hasForm ? /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        className: "lt__c-form",
                                        children: "Form"
                                    }) : null
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                            children: rows.map((r, i)=>{
                                const team = r?.team || {};
                                const name = team.nm || team.sn || "\u2014";
                                const code = team.code || team.sn || null;
                                const crest = team.id ? (0, $3G7m1.getImageUrl)("", "", sport, team.id) : null;
                                const form = $ae3537a2b2960473$var$rowForm(r);
                                return /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                    className: "lt__row",
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            className: "lt__c-rank",
                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: "lt__rankno",
                                                children: r?.plc ?? i + 1
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            className: "lt__c-team",
                                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                className: "lt__team",
                                                children: [
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)($ae3537a2b2960473$var$Crest, {
                                                        src: crest,
                                                        name: name
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                        className: "lt__tmeta",
                                                        children: [
                                                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                className: "lt__tname",
                                                                children: name
                                                            }),
                                                            code ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                className: "lt__tcode",
                                                                children: code
                                                            }) : null
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            className: "lt__c-num",
                                            children: r?.pld
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            className: "lt__c-num",
                                            children: r?.w
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            className: "lt__c-num",
                                            children: r?.d
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            className: "lt__c-num",
                                            children: r?.l
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            className: "lt__c-num lt__c-ga",
                                            children: r?.scr
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            className: "lt__c-num lt__c-ga",
                                            children: r?.con
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            className: "lt__c-num lt__c-diff",
                                            children: $ae3537a2b2960473$var$numDiff(r?.dif)
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            className: "lt__c-pts",
                                            children: r?.pts
                                        }),
                                        hasForm ? /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            className: "lt__c-form",
                                            children: form ? /*#__PURE__*/ (0, $lBpE3.jsx)($ae3537a2b2960473$var$FormDots, {
                                                form: form
                                            }) : null
                                        }) : null
                                    ]
                                }, r?.team_id ?? i);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $ae3537a2b2960473$var$LeagueTable = ({ variant: variant = "detailed", dataId: dataId, baseUrl: baseUrl, sport: sport = "football", serverData: serverData = null, data: dataProp = null, dataClient: dataClient = false, loadCSS: loadCSS = true })=>{
    const isPreview = variant === "preview";
    (0, $6cds3.useEffect)(()=>{
        (0, $2bSDe.loadStyles)("leagueTableWidget");
    }, []);
    const [groups, setGroups] = (0, $6cds3.useState)($ae3537a2b2960473$var$groupsFromRaw(serverData || dataProp));
    const [page, setPage] = (0, $6cds3.useState)(0); // preview pagination
    (0, $6cds3.useEffect)(()=>{
        const g = $ae3537a2b2960473$var$groupsFromRaw(serverData || dataProp);
        if (g) setGroups(g);
    }, [
        serverData,
        dataProp
    ]);
    // Hydration: re-read the serialized payload off the container.
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        try {
            const el = document.querySelector(".microservice-cont");
            const parsed = JSON.parse(el?.getAttribute("data-listingdata") || "null");
            const g = $ae3537a2b2960473$var$groupsFromRaw(parsed?.data);
            if (g) setGroups(g);
        } catch (_) {}
    }, [
        dataClient
    ]);
    // Self-fetch fallback — runs whenever we still have no groups (embed mode, OR hydration mode
    // when the serialized data-listingdata read didn't yield a table). NOT gated on dataClient, so
    // a failed/empty hydration payload can never leave the widget stuck on "Loading…".
    (0, $6cds3.useEffect)(()=>{
        if (groups || !dataId || !baseUrl) return;
        let cancelled = false;
        (0, $zSRJd.getData)({
            dataId: dataId,
            dataType: "detailed-league-table",
            baseUrl: baseUrl,
            sport: sport
        }).then((res)=>{
            if (cancelled) return;
            const g = $ae3537a2b2960473$var$groupsFromRaw(res);
            if (g) setGroups(g);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        groups,
        dataId,
        baseUrl,
        sport
    ]);
    if (!groups) return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "lt lt--loading",
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
            children: "Loading table\u2026"
        })
    });
    const multi = groups.length > 1;
    const title = multi ? $ae3537a2b2960473$var$competitionName(groups[0]?.nm) : groups[0]?.nm || "League Table";
    const fid = groups[0]?.fid;
    const flag = fid ? (0, $3G7m1.getImageUrl)(baseUrl, "league", sport, fid) : null;
    // Preview pagination. Multi-group competitions (e.g. World Cup) page by GROUP —
    // one group per page; a single-table league pages by ROWS — 5 per page.
    const PAGE = 5;
    const previewMulti = isPreview && multi;
    const rowTotal = groups[0]?.football_tournament_tables?.length || 0;
    const totalPages = previewMulti ? groups.length : Math.max(1, Math.ceil(rowTotal / PAGE));
    const pg = Math.min(page, totalPages - 1);
    const start = pg * PAGE;
    const end = Math.min(start + PAGE, rowTotal);
    const rangeLabel = previewMulti ? `Group ${pg + 1} of ${groups.length}` : rowTotal > PAGE ? `Showing ${start + 1}\u{2013}${end} of ${rowTotal}` : null;
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: `lt lt--${variant}`,
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "lt__head",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                        className: "lt__head-l",
                        children: [
                            flag ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "lt__logo",
                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("img", {
                                    src: flag,
                                    alt: "",
                                    onError: (e)=>{
                                        e.currentTarget.parentElement.style.display = "none";
                                    }
                                })
                            }) : null,
                            /*#__PURE__*/ (0, $lBpE3.jsx)("h3", {
                                className: "lt__title",
                                children: title
                            })
                        ]
                    }),
                    isPreview && rangeLabel ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "lt__range",
                        children: rangeLabel
                    }) : null
                ]
            }),
            isPreview ? /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                children: [
                    previewMulti ? /*#__PURE__*/ (0, $lBpE3.jsx)($ae3537a2b2960473$var$GroupTable, {
                        group: groups[pg],
                        sport: sport,
                        subhead: true
                    }) : /*#__PURE__*/ (0, $lBpE3.jsx)($ae3537a2b2960473$var$GroupTable, {
                        group: groups[0],
                        sport: sport,
                        offset: start,
                        limit: PAGE
                    }),
                    totalPages > 1 ? /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "lt__pager",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                type: "button",
                                className: "lt__pg-arrow",
                                disabled: pg === 0,
                                onClick: ()=>setPage(pg - 1),
                                "aria-label": "Previous",
                                children: "\u2039"
                            }),
                            Array.from({
                                length: totalPages
                            }).map((_, i)=>/*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                    type: "button",
                                    className: `lt__pg${i === pg ? " lt__pg--on" : ""}`,
                                    onClick: ()=>setPage(i),
                                    children: i + 1
                                }, i)),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                type: "button",
                                className: "lt__pg-arrow",
                                disabled: pg === totalPages - 1,
                                onClick: ()=>setPage(pg + 1),
                                "aria-label": "Next",
                                children: "\u203A"
                            })
                        ]
                    }) : null
                ]
            }) : groups.map((g, i)=>/*#__PURE__*/ (0, $lBpE3.jsx)($ae3537a2b2960473$var$GroupTable, {
                    group: g,
                    sport: sport,
                    subhead: multi
                }, g.id ?? i))
        ]
    });
};
var $ae3537a2b2960473$export$2e2bcd8739ae039 = $ae3537a2b2960473$var$LeagueTable;


const $bfca3c622e7e75bf$var$LeagueWidgetWrap = ({ dataId: dataId, dataType: dataType, sport: sport, difference: difference, head: head, data: data, headData: headData, otherData: otherData, baseUrl: baseUrl, loadCSS: loadCSS, setDataId: setDataId, setDataType: setDataType, setHead: setHead, setLeagueId: setLeagueId, setDate: setDate, date: date, setIsLive: setIsLive, isLive: isLive, dataSSR: dataSSR, dataClient: dataClient = false, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataTitle: dataTitle, liveCentre: liveCentre = false })=>{
    const renderWithHead = (tab, Component, componentProps = {})=>{
        return head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0881f34d53fa6722$export$2e2bcd8739ae039), {
            id: dataId,
            headData: headData,
            baseUrl: baseUrl,
            type: "leagues",
            dataClient: dataClient,
            currentTab: tab,
            websiteBaseUrl: websiteBaseUrl,
            dataPath: dataPath,
            widgetTitle: dataTitle,
            children: /*#__PURE__*/ (0, $lBpE3.jsx)(Component, {
                ...componentProps
            })
        }) : /*#__PURE__*/ (0, $lBpE3.jsx)(Component, {
            ...componentProps,
            title: dataTitle
        });
    };
    switch(dataType){
        // Self-contained modern standings widget (own header, no <Head> wrap, no Home/Away tabs).
        case "detailed-league-table":
            return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ae3537a2b2960473$export$2e2bcd8739ae039), {
                variant: "detailed",
                serverData: data,
                dataId: dataId,
                baseUrl: baseUrl,
                sport: sport,
                loadCSS: loadCSS,
                dataClient: dataClient
            });
        // Compact preview — first group, top 5 rows with pagination.
        case "preview-league-table":
            return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ae3537a2b2960473$export$2e2bcd8739ae039), {
                variant: "preview",
                serverData: data,
                dataId: dataId,
                baseUrl: baseUrl,
                sport: sport,
                loadCSS: loadCSS,
                dataClient: dataClient
            });
        case "league-standings":
            return renderWithHead("table", (0, $9b1908741783b4d4$export$2e2bcd8739ae039), {
                data: data?.data?.football_tournament_tables || data?.football_tournament_tables,
                loadCSS: loadCSS,
                dataClient: dataClient
            });
        case "league-top-scorers":
            return renderWithHead("top_scorers", (0, $699236828680c846$export$2e2bcd8739ae039), {
                data: data?.data,
                loadCSS: loadCSS,
                dataClient: dataClient
            });
        case "league-news":
            return renderWithHead("news", (0, $4c03dbc6caeb65b2$export$2e2bcd8739ae039), {
                data: data,
                difference: difference,
                loadCSS: loadCSS,
                dataClient: dataClient,
                baseUrl: baseUrl,
                id: dataId,
                newsType: "league"
            });
        case "league-upcoming":
            return renderWithHead("upcoming", (0, $3207c25f6468a03b$export$2e2bcd8739ae039), {
                sport: sport,
                data: data?.data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                setDataType: setDataType,
                setDataId: setDataId,
                setHead: setHead,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                updatedData: true,
                difference: difference
            });
        case "league-results":
        case "league-finished":
            return renderWithHead("results", (0, $3207c25f6468a03b$export$2e2bcd8739ae039), {
                sport: sport,
                data: data?.data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                setDataType: setDataType,
                setDataId: setDataId,
                setHead: setHead,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                updatedData: true,
                difference: difference
            });
        case "league-stats":
            return renderWithHead("stats", (0, $3f965b32a4f8cc67$export$2e2bcd8739ae039), {
                sport: sport,
                data: data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                setDataType: setDataType,
                setDataId: setDataId,
                setHead: setHead,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath
            });
        case "league-info":
            return renderWithHead("info", (0, $be5ab0c7cb61a9f3$export$2e2bcd8739ae039), {
                id: dataId,
                sport: sport,
                data: data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                setDataType: setDataType,
                setDataId: setDataId,
                setHead: setHead,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath
            });
        case "league-teams":
            return renderWithHead("teams", (0, $ecd6e6333da3a205$export$2e2bcd8739ae039), {
                id: dataId,
                sport: sport,
                data: data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                setDataType: setDataType,
                setDataId: setDataId,
                setHead: setHead,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath
            });
        case "league-page":
            return head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0881f34d53fa6722$export$2e2bcd8739ae039), {
                id: dataId,
                imgUrl: `https://cms.cyberstate-tech.com/api/v1/public/assets/images/flags/country_${headData?.football_category?.fid}.png`,
                title: headData?.nm,
                type: "leagues",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $9cc94870d0d030e6$export$2e2bcd8739ae039), {
                    data: data?.data,
                    baseUrl: baseUrl,
                    dataType: dataType,
                    difference: difference,
                    sport: sport,
                    dataId: dataId,
                    loadCSS: loadCSS,
                    headData: headData,
                    type: "leagues",
                    setDataId: setDataId,
                    setDataType: setDataType,
                    setHead: setHead
                })
            }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $9cc94870d0d030e6$export$2e2bcd8739ae039), {
                data: data?.data,
                baseUrl: baseUrl,
                dataType: dataType,
                difference: difference,
                sport: sport,
                dataId: dataId,
                loadCSS: loadCSS,
                setDataId: setDataId,
                setDataType: setDataType,
                setHead: setHead
            });
        default:
            return /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: "Widget Not Found in football League!"
            });
    }
};
var $bfca3c622e7e75bf$export$2e2bcd8739ae039 = $bfca3c622e7e75bf$var$LeagueWidgetWrap;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");
function $7ea79c0838f0a9da$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $7ea79c0838f0a9da$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $7ea79c0838f0a9da$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $7ea79c0838f0a9da$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $7ea79c0838f0a9da$export$2e2bcd8739ae039 = $7ea79c0838f0a9da$export$4f5d2d50c9deca37;



var $lBpE3 = parcelRequire("lBpE3");
var $5e657ee88a806ce9$exports = {};
'use strict';
var $a4ea214ca28898c0$exports = {};
'use strict';
const $a4ea214ca28898c0$var$copyProperty = (to, from, property, ignoreNonConfigurable)=>{
    // `Function#length` should reflect the parameters of `to` not `from` since we keep its body.
    // `Function#prototype` is non-writable and non-configurable so can never be modified.
    if (property === 'length' || property === 'prototype') return;
    // `Function#arguments` and `Function#caller` should not be copied. They were reported to be present in `Reflect.ownKeys` for some devices in React Native (#41), so we explicitly ignore them here.
    if (property === 'arguments' || property === 'caller') return;
    const toDescriptor = Object.getOwnPropertyDescriptor(to, property);
    const fromDescriptor = Object.getOwnPropertyDescriptor(from, property);
    if (!$a4ea214ca28898c0$var$canCopyProperty(toDescriptor, fromDescriptor) && ignoreNonConfigurable) return;
    Object.defineProperty(to, property, fromDescriptor);
};
// `Object.defineProperty()` throws if the property exists, is not configurable and either:
//  - one its descriptors is changed
//  - it is non-writable and its value is changed
const $a4ea214ca28898c0$var$canCopyProperty = function(toDescriptor, fromDescriptor) {
    return toDescriptor === undefined || toDescriptor.configurable || toDescriptor.writable === fromDescriptor.writable && toDescriptor.enumerable === fromDescriptor.enumerable && toDescriptor.configurable === fromDescriptor.configurable && (toDescriptor.writable || toDescriptor.value === fromDescriptor.value);
};
const $a4ea214ca28898c0$var$changePrototype = (to, from)=>{
    const fromPrototype = Object.getPrototypeOf(from);
    if (fromPrototype === Object.getPrototypeOf(to)) return;
    Object.setPrototypeOf(to, fromPrototype);
};
const $a4ea214ca28898c0$var$wrappedToString = (withName, fromBody)=>`/* Wrapped ${withName}*/\n${fromBody}`;
const $a4ea214ca28898c0$var$toStringDescriptor = Object.getOwnPropertyDescriptor(Function.prototype, 'toString');
const $a4ea214ca28898c0$var$toStringName = Object.getOwnPropertyDescriptor(Function.prototype.toString, 'name');
// We call `from.toString()` early (not lazily) to ensure `from` can be garbage collected.
// We use `bind()` instead of a closure for the same reason.
// Calling `from.toString()` early also allows caching it in case `to.toString()` is called several times.
const $a4ea214ca28898c0$var$changeToString = (to, from, name)=>{
    const withName = name === '' ? '' : `with ${name.trim()}() `;
    const newToString = $a4ea214ca28898c0$var$wrappedToString.bind(null, withName, from.toString());
    // Ensure `to.toString.toString` is non-enumerable and has the same `same`
    Object.defineProperty(newToString, 'name', $a4ea214ca28898c0$var$toStringName);
    Object.defineProperty(to, 'toString', {
        ...$a4ea214ca28898c0$var$toStringDescriptor,
        value: newToString
    });
};
const $a4ea214ca28898c0$var$mimicFn = (to, from, { ignoreNonConfigurable: ignoreNonConfigurable = false } = {})=>{
    const { name: name } = to;
    for (const property of Reflect.ownKeys(from))$a4ea214ca28898c0$var$copyProperty(to, from, property, ignoreNonConfigurable);
    $a4ea214ca28898c0$var$changePrototype(to, from);
    $a4ea214ca28898c0$var$changeToString(to, from, name);
    return to;
};
$a4ea214ca28898c0$exports = $a4ea214ca28898c0$var$mimicFn;


var $a3eb166920e9a25b$exports = {};
"use strict";
var $a3eb166920e9a25b$var$__awaiter = $a3eb166920e9a25b$exports && $a3eb166920e9a25b$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function(resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a3eb166920e9a25b$var$__importDefault = $a3eb166920e9a25b$exports && $a3eb166920e9a25b$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($a3eb166920e9a25b$exports, "__esModule", {
    value: true
});

const $a3eb166920e9a25b$var$p_defer_1 = $a3eb166920e9a25b$var$__importDefault((parcelRequire("73TcF")));
function $a3eb166920e9a25b$var$mapAgeCleaner(map, property = 'maxAge') {
    let processingKey;
    let processingTimer;
    let processingDeferred;
    const cleanup = ()=>$a3eb166920e9a25b$var$__awaiter(this, void 0, void 0, function*() {
            if (processingKey !== undefined) // If we are already processing an item, we can safely exit
            return;
            const setupTimer = (item)=>$a3eb166920e9a25b$var$__awaiter(this, void 0, void 0, function*() {
                    processingDeferred = $a3eb166920e9a25b$var$p_defer_1.default();
                    const delay = item[1][property] - Date.now();
                    if (delay <= 0) {
                        // Remove the item immediately if the delay is equal to or below 0
                        map.delete(item[0]);
                        processingDeferred.resolve();
                        return;
                    }
                    // Keep track of the current processed key
                    processingKey = item[0];
                    processingTimer = setTimeout(()=>{
                        // Remove the item when the timeout fires
                        map.delete(item[0]);
                        if (processingDeferred) processingDeferred.resolve();
                    }, delay);
                    // tslint:disable-next-line:strict-type-predicates
                    if (typeof processingTimer.unref === 'function') // Don't hold up the process from exiting
                    processingTimer.unref();
                    return processingDeferred.promise;
                });
            try {
                for (const entry of map)yield setupTimer(entry);
            } catch (_a) {
            // Do nothing if an error occurs, this means the timer was cleaned up and we should stop processing
            }
            processingKey = undefined;
        });
    const reset = ()=>{
        processingKey = undefined;
        if (processingTimer !== undefined) {
            clearTimeout(processingTimer);
            processingTimer = undefined;
        }
        if (processingDeferred !== undefined) {
            processingDeferred.reject(undefined);
            processingDeferred = undefined;
        }
    };
    const originalSet = map.set.bind(map);
    map.set = (key, value)=>{
        if (map.has(key)) // If the key already exist, remove it so we can add it back at the end of the map.
        map.delete(key);
        // Call the original `map.set`
        const result = originalSet(key, value);
        // If we are already processing a key and the key added is the current processed key, stop processing it
        if (processingKey && processingKey === key) reset();
        // Always run the cleanup method in case it wasn't started yet
        cleanup(); // tslint:disable-line:no-floating-promises
        return result;
    };
    cleanup(); // tslint:disable-line:no-floating-promises
    return map;
}
$a3eb166920e9a25b$exports.default = $a3eb166920e9a25b$var$mapAgeCleaner;
// Add support for CJS
$a3eb166920e9a25b$exports = $a3eb166920e9a25b$var$mapAgeCleaner;
$a3eb166920e9a25b$exports.default = $a3eb166920e9a25b$var$mapAgeCleaner;


const $5e657ee88a806ce9$var$decoratorInstanceMap = new WeakMap();
const $5e657ee88a806ce9$var$cacheStore = new WeakMap();
/**
[Memoize](https://en.wikipedia.org/wiki/Memoization) functions - An optimization used to speed up consecutive function calls by caching the result of calls with identical input.

@param fn - Function to be memoized.

@example
```
import mem = require('mem');

let i = 0;
const counter = () => ++i;
const memoized = mem(counter);

memoized('foo');
//=> 1

// Cached as it's the same arguments
memoized('foo');
//=> 1

// Not cached anymore as the arguments changed
memoized('bar');
//=> 2

memoized('bar');
//=> 2
```
*/ const $5e657ee88a806ce9$var$mem = (fn, { cacheKey: cacheKey, cache: cache = new Map(), maxAge: maxAge } = {})=>{
    if (typeof maxAge === 'number') // TODO: Drop after https://github.com/SamVerschueren/map-age-cleaner/issues/5
    // @ts-expect-error
    $a3eb166920e9a25b$exports(cache);
    const memoized = function(...arguments_) {
        const key = cacheKey ? cacheKey(arguments_) : arguments_[0];
        const cacheItem = cache.get(key);
        if (cacheItem) return cacheItem.data;
        const result = fn.apply(this, arguments_);
        cache.set(key, {
            data: result,
            maxAge: maxAge ? Date.now() + maxAge : Number.POSITIVE_INFINITY
        });
        return result;
    };
    $a4ea214ca28898c0$exports(memoized, fn, {
        ignoreNonConfigurable: true
    });
    $5e657ee88a806ce9$var$cacheStore.set(memoized, cache);
    return memoized;
};
/**
@returns A [decorator](https://github.com/tc39/proposal-decorators) to memoize class methods or static class methods.

@example
```
import mem = require('mem');

class Example {
    index = 0

    @mem.decorator()
    counter() {
        return ++this.index;
    }
}

class ExampleWithOptions {
    index = 0

    @mem.decorator({maxAge: 1000})
    counter() {
        return ++this.index;
    }
}
```
*/ $5e657ee88a806ce9$var$mem.decorator = (options = {})=>(target, propertyKey, descriptor)=>{
        const input = target[propertyKey];
        if (typeof input !== 'function') throw new TypeError('The decorated value must be a function');
        delete descriptor.value;
        delete descriptor.writable;
        descriptor.get = function() {
            if (!$5e657ee88a806ce9$var$decoratorInstanceMap.has(this)) {
                const value = $5e657ee88a806ce9$var$mem(input, options);
                $5e657ee88a806ce9$var$decoratorInstanceMap.set(this, value);
                return value;
            }
            return $5e657ee88a806ce9$var$decoratorInstanceMap.get(this);
        };
    };
/**
Clear all cached data of a memoized function.

@param fn - Memoized function.
*/ $5e657ee88a806ce9$var$mem.clear = (fn)=>{
    const cache = $5e657ee88a806ce9$var$cacheStore.get(fn);
    if (!cache) throw new TypeError('Can\'t clear a function that was not memoized!');
    if (typeof cache.clear !== 'function') throw new TypeError('The cache Map can\'t be cleared!');
    cache.clear();
};
$5e657ee88a806ce9$exports = $5e657ee88a806ce9$var$mem;


function $9b825e302066192a$var$isString(el) {
    return typeof el === 'string';
}
function $9b825e302066192a$var$isUnique(el, index, arr) {
    return arr.indexOf(el) === index;
}
function $9b825e302066192a$var$isAllLowerCase(el) {
    return el.toLowerCase() === el;
}
function $9b825e302066192a$var$fixCommas(el) {
    return el.indexOf(',') === -1 ? el : el.split(',');
}
function $9b825e302066192a$var$normalizeLocale(locale) {
    if (!locale) return locale;
    if (locale === 'C' || locale === 'posix' || locale === 'POSIX') return 'en-US';
    // If there's a dot (.) in the locale, it's likely in the format of "en-US.UTF-8", so we only take the first part
    if (locale.indexOf('.') !== -1) {
        var _a = locale.split('.')[0], actualLocale = _a === void 0 ? '' : _a;
        return $9b825e302066192a$var$normalizeLocale(actualLocale);
    }
    // If there's an at sign (@) in the locale, it's likely in the format of "en-US@posix", so we only take the first part
    if (locale.indexOf('@') !== -1) {
        var _b = locale.split('@')[0], actualLocale = _b === void 0 ? '' : _b;
        return $9b825e302066192a$var$normalizeLocale(actualLocale);
    }
    // If there's a dash (-) in the locale and it's not all lower case, it's already in the format of "en-US", so we return it
    if (locale.indexOf('-') === -1 || !$9b825e302066192a$var$isAllLowerCase(locale)) return locale;
    var _c = locale.split('-'), splitEl1 = _c[0], _d = _c[1], splitEl2 = _d === void 0 ? '' : _d;
    return "".concat(splitEl1, "-").concat(splitEl2.toUpperCase());
}
function $9b825e302066192a$var$getUserLocalesInternal(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.useFallbackLocale, useFallbackLocale = _c === void 0 ? true : _c, _d = _b.fallbackLocale, fallbackLocale = _d === void 0 ? 'en-US' : _d;
    var languageList = [];
    if (typeof navigator !== 'undefined') {
        var rawLanguages = navigator.languages || [];
        var languages = [];
        for(var _i = 0, rawLanguages_1 = rawLanguages; _i < rawLanguages_1.length; _i++){
            var rawLanguagesItem = rawLanguages_1[_i];
            languages = languages.concat($9b825e302066192a$var$fixCommas(rawLanguagesItem));
        }
        var rawLanguage = navigator.language;
        var language = rawLanguage ? $9b825e302066192a$var$fixCommas(rawLanguage) : rawLanguage;
        languageList = languageList.concat(languages, language);
    }
    if (useFallbackLocale) languageList.push(fallbackLocale);
    return languageList.filter($9b825e302066192a$var$isString).map($9b825e302066192a$var$normalizeLocale).filter($9b825e302066192a$var$isUnique);
}
var $9b825e302066192a$export$2709d88c05bbce73 = (0, (/*@__PURE__*/$parcel$interopDefault($5e657ee88a806ce9$exports)))($9b825e302066192a$var$getUserLocalesInternal, {
    cacheKey: JSON.stringify
});
function $9b825e302066192a$var$getUserLocaleInternal(options) {
    return $9b825e302066192a$export$2709d88c05bbce73(options)[0] || null;
}
var $9b825e302066192a$export$a6ea185b366483aa = (0, (/*@__PURE__*/$parcel$interopDefault($5e657ee88a806ce9$exports)))($9b825e302066192a$var$getUserLocaleInternal, {
    cacheKey: JSON.stringify
});
var $9b825e302066192a$export$2e2bcd8739ae039 = $9b825e302066192a$export$a6ea185b366483aa;


/**
 * Utils
 */ function $f2e53ae88e17687e$var$makeGetEdgeOfNeighbor(getPeriod, getEdgeOfPeriod, defaultOffset) {
    return function makeGetEdgeOfNeighborInternal(date, offset) {
        if (offset === void 0) offset = defaultOffset;
        var previousPeriod = getPeriod(date) + offset;
        return getEdgeOfPeriod(previousPeriod);
    };
}
function $f2e53ae88e17687e$var$makeGetEnd(getBeginOfNextPeriod) {
    return function makeGetEndInternal(date) {
        return new Date(getBeginOfNextPeriod(date).getTime() - 1);
    };
}
function $f2e53ae88e17687e$var$makeGetRange(getStart, getEnd) {
    return function makeGetRangeInternal(date) {
        return [
            getStart(date),
            getEnd(date)
        ];
    };
}
function $f2e53ae88e17687e$export$5846dc2d57a5c860(date) {
    if (date instanceof Date) return date.getFullYear();
    if (typeof date === 'number') return date;
    var year = parseInt(date, 10);
    if (typeof date === 'string' && !isNaN(year)) return year;
    throw new Error("Failed to get year from date: ".concat(date, "."));
}
function $f2e53ae88e17687e$export$6ce1b5acc29cb53b(date) {
    if (date instanceof Date) return date.getMonth();
    throw new Error("Failed to get month from date: ".concat(date, "."));
}
function $f2e53ae88e17687e$export$a8575fd59bc333e3(date) {
    if (date instanceof Date) return date.getMonth() + 1;
    throw new Error("Failed to get human-readable month from date: ".concat(date, "."));
}
function $f2e53ae88e17687e$export$aa350b96d91cd94(date) {
    if (date instanceof Date) return date.getDate();
    throw new Error("Failed to get year from date: ".concat(date, "."));
}
function $f2e53ae88e17687e$export$257b40f71c07d58f(date) {
    if (date instanceof Date) return date.getHours();
    if (typeof date === 'string') {
        var datePieces = date.split(':');
        if (datePieces.length >= 2) {
            var hoursString = datePieces[0];
            if (hoursString) {
                var hours = parseInt(hoursString, 10);
                if (!isNaN(hours)) return hours;
            }
        }
    }
    throw new Error("Failed to get hours from date: ".concat(date, "."));
}
function $f2e53ae88e17687e$export$b7f1bc3ea3ac4145(date) {
    if (date instanceof Date) return date.getMinutes();
    if (typeof date === 'string') {
        var datePieces = date.split(':');
        if (datePieces.length >= 2) {
            var minutesString = datePieces[1] || '0';
            var minutes = parseInt(minutesString, 10);
            if (!isNaN(minutes)) return minutes;
        }
    }
    throw new Error("Failed to get minutes from date: ".concat(date, "."));
}
function $f2e53ae88e17687e$export$5e9417507ff28427(date) {
    if (date instanceof Date) return date.getSeconds();
    if (typeof date === 'string') {
        var datePieces = date.split(':');
        if (datePieces.length >= 2) {
            var secondsWithMillisecondsString = datePieces[2] || '0';
            var seconds = parseInt(secondsWithMillisecondsString, 10);
            if (!isNaN(seconds)) return seconds;
        }
    }
    throw new Error("Failed to get seconds from date: ".concat(date, "."));
}
function $f2e53ae88e17687e$export$b8e4380f312797af(date) {
    if (date instanceof Date) return date.getMilliseconds();
    if (typeof date === 'string') {
        var datePieces = date.split(':');
        if (datePieces.length >= 2) {
            var secondsWithMillisecondsString = datePieces[2] || '0';
            var millisecondsString = secondsWithMillisecondsString.split('.')[1] || '0';
            var milliseconds = parseInt(millisecondsString, 10);
            if (!isNaN(milliseconds)) return milliseconds;
        }
    }
    throw new Error("Failed to get seconds from date: ".concat(date, "."));
}
function $f2e53ae88e17687e$export$34dd42d02ca37c6b(date) {
    var year = $f2e53ae88e17687e$export$5846dc2d57a5c860(date);
    var centuryStartYear = year + (-year + 1) % 100;
    var centuryStartDate = new Date();
    centuryStartDate.setFullYear(centuryStartYear, 0, 1);
    centuryStartDate.setHours(0, 0, 0, 0);
    return centuryStartDate;
}
var $f2e53ae88e17687e$export$e65b64b0f80e225a = $f2e53ae88e17687e$var$makeGetEdgeOfNeighbor($f2e53ae88e17687e$export$5846dc2d57a5c860, $f2e53ae88e17687e$export$34dd42d02ca37c6b, -100);
var $f2e53ae88e17687e$export$3e300bd96d747c8a = $f2e53ae88e17687e$var$makeGetEdgeOfNeighbor($f2e53ae88e17687e$export$5846dc2d57a5c860, $f2e53ae88e17687e$export$34dd42d02ca37c6b, 100);
var $f2e53ae88e17687e$export$43c2109e18ca667b = $f2e53ae88e17687e$var$makeGetEnd($f2e53ae88e17687e$export$3e300bd96d747c8a);
var $f2e53ae88e17687e$export$4d124431cf7f00b5 = $f2e53ae88e17687e$var$makeGetEdgeOfNeighbor($f2e53ae88e17687e$export$5846dc2d57a5c860, $f2e53ae88e17687e$export$43c2109e18ca667b, -100);
var $f2e53ae88e17687e$export$2663e0ade48d35a9 = $f2e53ae88e17687e$var$makeGetEdgeOfNeighbor($f2e53ae88e17687e$export$5846dc2d57a5c860, $f2e53ae88e17687e$export$43c2109e18ca667b, 100);
var $f2e53ae88e17687e$export$a4332dc3f9de051f = $f2e53ae88e17687e$var$makeGetRange($f2e53ae88e17687e$export$34dd42d02ca37c6b, $f2e53ae88e17687e$export$43c2109e18ca667b);
function $f2e53ae88e17687e$export$8bb35b885d308e78(date) {
    var year = $f2e53ae88e17687e$export$5846dc2d57a5c860(date);
    var decadeStartYear = year + (-year + 1) % 10;
    var decadeStartDate = new Date();
    decadeStartDate.setFullYear(decadeStartYear, 0, 1);
    decadeStartDate.setHours(0, 0, 0, 0);
    return decadeStartDate;
}
var $f2e53ae88e17687e$export$e43f83f55f1766fa = $f2e53ae88e17687e$var$makeGetEdgeOfNeighbor($f2e53ae88e17687e$export$5846dc2d57a5c860, $f2e53ae88e17687e$export$8bb35b885d308e78, -10);
var $f2e53ae88e17687e$export$8266d1a140c33d17 = $f2e53ae88e17687e$var$makeGetEdgeOfNeighbor($f2e53ae88e17687e$export$5846dc2d57a5c860, $f2e53ae88e17687e$export$8bb35b885d308e78, 10);
var $f2e53ae88e17687e$export$aa0bfba5bfc33956 = $f2e53ae88e17687e$var$makeGetEnd($f2e53ae88e17687e$export$8266d1a140c33d17);
var $f2e53ae88e17687e$export$93edec1b41903921 = $f2e53ae88e17687e$var$makeGetEdgeOfNeighbor($f2e53ae88e17687e$export$5846dc2d57a5c860, $f2e53ae88e17687e$export$aa0bfba5bfc33956, -10);
var $f2e53ae88e17687e$export$112141384c9d3d6b = $f2e53ae88e17687e$var$makeGetEdgeOfNeighbor($f2e53ae88e17687e$export$5846dc2d57a5c860, $f2e53ae88e17687e$export$aa0bfba5bfc33956, 10);
var $f2e53ae88e17687e$export$35cef0a1278b17e1 = $f2e53ae88e17687e$var$makeGetRange($f2e53ae88e17687e$export$8bb35b885d308e78, $f2e53ae88e17687e$export$aa0bfba5bfc33956);
function $f2e53ae88e17687e$export$bbcf6a6951bb3c3a(date) {
    var year = $f2e53ae88e17687e$export$5846dc2d57a5c860(date);
    var yearStartDate = new Date();
    yearStartDate.setFullYear(year, 0, 1);
    yearStartDate.setHours(0, 0, 0, 0);
    return yearStartDate;
}
var $f2e53ae88e17687e$export$97fe927b771a6825 = $f2e53ae88e17687e$var$makeGetEdgeOfNeighbor($f2e53ae88e17687e$export$5846dc2d57a5c860, $f2e53ae88e17687e$export$bbcf6a6951bb3c3a, -1);
var $f2e53ae88e17687e$export$fed82860795beff7 = $f2e53ae88e17687e$var$makeGetEdgeOfNeighbor($f2e53ae88e17687e$export$5846dc2d57a5c860, $f2e53ae88e17687e$export$bbcf6a6951bb3c3a, 1);
var $f2e53ae88e17687e$export$248ddd7fb95e4a56 = $f2e53ae88e17687e$var$makeGetEnd($f2e53ae88e17687e$export$fed82860795beff7);
var $f2e53ae88e17687e$export$639fe5fbfbb704d0 = $f2e53ae88e17687e$var$makeGetEdgeOfNeighbor($f2e53ae88e17687e$export$5846dc2d57a5c860, $f2e53ae88e17687e$export$248ddd7fb95e4a56, -1);
var $f2e53ae88e17687e$export$952396487caf69e5 = $f2e53ae88e17687e$var$makeGetEdgeOfNeighbor($f2e53ae88e17687e$export$5846dc2d57a5c860, $f2e53ae88e17687e$export$248ddd7fb95e4a56, 1);
var $f2e53ae88e17687e$export$17e213d8c10b7032 = $f2e53ae88e17687e$var$makeGetRange($f2e53ae88e17687e$export$bbcf6a6951bb3c3a, $f2e53ae88e17687e$export$248ddd7fb95e4a56);
/**
 * Month
 */ function $f2e53ae88e17687e$var$makeGetEdgeOfNeighborMonth(getEdgeOfPeriod, defaultOffset) {
    return function makeGetEdgeOfNeighborMonthInternal(date, offset) {
        if (offset === void 0) offset = defaultOffset;
        var year = $f2e53ae88e17687e$export$5846dc2d57a5c860(date);
        var month = $f2e53ae88e17687e$export$6ce1b5acc29cb53b(date) + offset;
        var previousPeriod = new Date();
        previousPeriod.setFullYear(year, month, 1);
        previousPeriod.setHours(0, 0, 0, 0);
        return getEdgeOfPeriod(previousPeriod);
    };
}
function $f2e53ae88e17687e$export$c7002b157c9b9e95(date) {
    var year = $f2e53ae88e17687e$export$5846dc2d57a5c860(date);
    var month = $f2e53ae88e17687e$export$6ce1b5acc29cb53b(date);
    var monthStartDate = new Date();
    monthStartDate.setFullYear(year, month, 1);
    monthStartDate.setHours(0, 0, 0, 0);
    return monthStartDate;
}
var $f2e53ae88e17687e$export$e1815383d4029267 = $f2e53ae88e17687e$var$makeGetEdgeOfNeighborMonth($f2e53ae88e17687e$export$c7002b157c9b9e95, -1);
var $f2e53ae88e17687e$export$21b7c773284d5b43 = $f2e53ae88e17687e$var$makeGetEdgeOfNeighborMonth($f2e53ae88e17687e$export$c7002b157c9b9e95, 1);
var $f2e53ae88e17687e$export$6f306f93ccbcd612 = $f2e53ae88e17687e$var$makeGetEnd($f2e53ae88e17687e$export$21b7c773284d5b43);
var $f2e53ae88e17687e$export$b4b5df1ab9a8303b = $f2e53ae88e17687e$var$makeGetEdgeOfNeighborMonth($f2e53ae88e17687e$export$6f306f93ccbcd612, -1);
var $f2e53ae88e17687e$export$98f1c9e60dc0189 = $f2e53ae88e17687e$var$makeGetEdgeOfNeighborMonth($f2e53ae88e17687e$export$6f306f93ccbcd612, 1);
var $f2e53ae88e17687e$export$c59fdbf3ad20e694 = $f2e53ae88e17687e$var$makeGetRange($f2e53ae88e17687e$export$c7002b157c9b9e95, $f2e53ae88e17687e$export$6f306f93ccbcd612);
/**
 * Day
 */ function $f2e53ae88e17687e$var$makeGetEdgeOfNeighborDay(getEdgeOfPeriod, defaultOffset) {
    return function makeGetEdgeOfNeighborDayInternal(date, offset) {
        if (offset === void 0) offset = defaultOffset;
        var year = $f2e53ae88e17687e$export$5846dc2d57a5c860(date);
        var month = $f2e53ae88e17687e$export$6ce1b5acc29cb53b(date);
        var day = $f2e53ae88e17687e$export$aa350b96d91cd94(date) + offset;
        var previousPeriod = new Date();
        previousPeriod.setFullYear(year, month, day);
        previousPeriod.setHours(0, 0, 0, 0);
        return getEdgeOfPeriod(previousPeriod);
    };
}
function $f2e53ae88e17687e$export$ef6b506418c2b397(date) {
    var year = $f2e53ae88e17687e$export$5846dc2d57a5c860(date);
    var month = $f2e53ae88e17687e$export$6ce1b5acc29cb53b(date);
    var day = $f2e53ae88e17687e$export$aa350b96d91cd94(date);
    var dayStartDate = new Date();
    dayStartDate.setFullYear(year, month, day);
    dayStartDate.setHours(0, 0, 0, 0);
    return dayStartDate;
}
var $f2e53ae88e17687e$export$4f27323eaab2ccfd = $f2e53ae88e17687e$var$makeGetEdgeOfNeighborDay($f2e53ae88e17687e$export$ef6b506418c2b397, -1);
var $f2e53ae88e17687e$export$78c5682078b46db4 = $f2e53ae88e17687e$var$makeGetEdgeOfNeighborDay($f2e53ae88e17687e$export$ef6b506418c2b397, 1);
var $f2e53ae88e17687e$export$7b798396f3e38cd7 = $f2e53ae88e17687e$var$makeGetEnd($f2e53ae88e17687e$export$78c5682078b46db4);
var $f2e53ae88e17687e$export$fde0c09caefdfd4a = $f2e53ae88e17687e$var$makeGetEdgeOfNeighborDay($f2e53ae88e17687e$export$7b798396f3e38cd7, -1);
var $f2e53ae88e17687e$export$f991202e82da93a1 = $f2e53ae88e17687e$var$makeGetEdgeOfNeighborDay($f2e53ae88e17687e$export$7b798396f3e38cd7, 1);
var $f2e53ae88e17687e$export$adb5aef569605e64 = $f2e53ae88e17687e$var$makeGetRange($f2e53ae88e17687e$export$ef6b506418c2b397, $f2e53ae88e17687e$export$7b798396f3e38cd7);
function $f2e53ae88e17687e$export$f645ddd439eb259d(date) {
    return $f2e53ae88e17687e$export$aa350b96d91cd94($f2e53ae88e17687e$export$6f306f93ccbcd612(date));
}
function $f2e53ae88e17687e$var$padStart(num, val) {
    if (val === void 0) val = 2;
    var numStr = "".concat(num);
    if (numStr.length >= val) return num;
    return "0000".concat(numStr).slice(-val);
}
function $f2e53ae88e17687e$export$aefe158a7bd76d23(date) {
    var hours = $f2e53ae88e17687e$var$padStart($f2e53ae88e17687e$export$257b40f71c07d58f(date));
    var minutes = $f2e53ae88e17687e$var$padStart($f2e53ae88e17687e$export$b7f1bc3ea3ac4145(date));
    return "".concat(hours, ":").concat(minutes);
}
function $f2e53ae88e17687e$export$52113457154e5fc(date) {
    var hours = $f2e53ae88e17687e$var$padStart($f2e53ae88e17687e$export$257b40f71c07d58f(date));
    var minutes = $f2e53ae88e17687e$var$padStart($f2e53ae88e17687e$export$b7f1bc3ea3ac4145(date));
    var seconds = $f2e53ae88e17687e$var$padStart($f2e53ae88e17687e$export$5e9417507ff28427(date));
    return "".concat(hours, ":").concat(minutes, ":").concat(seconds);
}
function $f2e53ae88e17687e$export$6f885d58ae224c35(date) {
    var year = $f2e53ae88e17687e$var$padStart($f2e53ae88e17687e$export$5846dc2d57a5c860(date), 4);
    var month = $f2e53ae88e17687e$var$padStart($f2e53ae88e17687e$export$a8575fd59bc333e3(date));
    return "".concat(year, "-").concat(month);
}
function $f2e53ae88e17687e$export$ce780a31b7197841(date) {
    var year = $f2e53ae88e17687e$var$padStart($f2e53ae88e17687e$export$5846dc2d57a5c860(date), 4);
    var month = $f2e53ae88e17687e$var$padStart($f2e53ae88e17687e$export$a8575fd59bc333e3(date));
    var day = $f2e53ae88e17687e$var$padStart($f2e53ae88e17687e$export$aa350b96d91cd94(date));
    return "".concat(year, "-").concat(month, "-").concat(day);
}
function $f2e53ae88e17687e$export$98f36b76519fd86(date) {
    return "".concat($f2e53ae88e17687e$export$ce780a31b7197841(date), "T").concat($f2e53ae88e17687e$export$52113457154e5fc(date));
}


var $aed4b5c73cbdc652$export$26fa441040070c35 = {
    GREGORY: 'gregory',
    HEBREW: 'hebrew',
    ISLAMIC: 'islamic',
    ISO_8601: 'iso8601'
};
var $aed4b5c73cbdc652$export$e4e5576db5b8e30f = {
    gregory: [
        'en-CA',
        'en-US',
        'es-AR',
        'es-BO',
        'es-CL',
        'es-CO',
        'es-CR',
        'es-DO',
        'es-EC',
        'es-GT',
        'es-HN',
        'es-MX',
        'es-NI',
        'es-PA',
        'es-PE',
        'es-PR',
        'es-SV',
        'es-VE',
        'pt-BR'
    ],
    hebrew: [
        'he',
        'he-IL'
    ],
    islamic: [
        // ar-LB, ar-MA intentionally missing
        'ar',
        'ar-AE',
        'ar-BH',
        'ar-DZ',
        'ar-EG',
        'ar-IQ',
        'ar-JO',
        'ar-KW',
        'ar-LY',
        'ar-OM',
        'ar-QA',
        'ar-SA',
        'ar-SD',
        'ar-SY',
        'ar-YE',
        'dv',
        'dv-MV',
        'ps',
        'ps-AR'
    ]
};
var $aed4b5c73cbdc652$export$ecc24ef5795d74f8 = [
    0,
    1,
    2,
    3,
    4,
    5,
    6
];



var $cbd6275857017435$var$formatterCache = new Map();
function $cbd6275857017435$var$getFormatter(options) {
    return function formatter(locale, date) {
        var localeWithDefault = locale || (0, $9b825e302066192a$export$2e2bcd8739ae039)();
        if (!$cbd6275857017435$var$formatterCache.has(localeWithDefault)) $cbd6275857017435$var$formatterCache.set(localeWithDefault, new Map());
        var formatterCacheLocale = $cbd6275857017435$var$formatterCache.get(localeWithDefault);
        if (!formatterCacheLocale.has(options)) formatterCacheLocale.set(options, new Intl.DateTimeFormat(localeWithDefault || undefined, options).format);
        return formatterCacheLocale.get(options)(date);
    };
}
/**
 * Changes the hour in a Date to ensure right date formatting even if DST is messed up.
 * Workaround for bug in WebKit and Firefox with historical dates.
 * For more details, see:
 * https://bugs.chromium.org/p/chromium/issues/detail?id=750465
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1385643
 *
 * @param {Date} date Date.
 * @returns {Date} Date with hour set to 12.
 */ function $cbd6275857017435$var$toSafeHour(date) {
    var safeDate = new Date(date);
    return new Date(safeDate.setHours(12));
}
function $cbd6275857017435$var$getSafeFormatter(options) {
    return function(locale, date) {
        return $cbd6275857017435$var$getFormatter(options)(locale, $cbd6275857017435$var$toSafeHour(date));
    };
}
var $cbd6275857017435$var$formatDateOptions = {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric'
};
var $cbd6275857017435$var$formatDayOptions = {
    day: 'numeric'
};
var $cbd6275857017435$var$formatLongDateOptions = {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
};
var $cbd6275857017435$var$formatMonthOptions = {
    month: 'long'
};
var $cbd6275857017435$var$formatMonthYearOptions = {
    month: 'long',
    year: 'numeric'
};
var $cbd6275857017435$var$formatShortWeekdayOptions = {
    weekday: 'short'
};
var $cbd6275857017435$var$formatWeekdayOptions = {
    weekday: 'long'
};
var $cbd6275857017435$var$formatYearOptions = {
    year: 'numeric'
};
var $cbd6275857017435$export$3ae94a2503e890a1 = $cbd6275857017435$var$getSafeFormatter($cbd6275857017435$var$formatDateOptions);
var $cbd6275857017435$export$a7f242eff11c1345 = $cbd6275857017435$var$getSafeFormatter($cbd6275857017435$var$formatDayOptions);
var $cbd6275857017435$export$322b36d80aef60ca = $cbd6275857017435$var$getSafeFormatter($cbd6275857017435$var$formatLongDateOptions);
var $cbd6275857017435$export$d0536c8e7f45796e = $cbd6275857017435$var$getSafeFormatter($cbd6275857017435$var$formatMonthOptions);
var $cbd6275857017435$export$18f8ccbe37e54acd = $cbd6275857017435$var$getSafeFormatter($cbd6275857017435$var$formatMonthYearOptions);
var $cbd6275857017435$export$7ebe25e42481bc02 = $cbd6275857017435$var$getSafeFormatter($cbd6275857017435$var$formatShortWeekdayOptions);
var $cbd6275857017435$export$407180b957f39d7e = $cbd6275857017435$var$getSafeFormatter($cbd6275857017435$var$formatWeekdayOptions);
var $cbd6275857017435$export$2979e79cc7cbf15b = $cbd6275857017435$var$getSafeFormatter($cbd6275857017435$var$formatYearOptions);


var $95358a6a51be7b32$var$SUNDAY = (0, $aed4b5c73cbdc652$export$ecc24ef5795d74f8)[0];
var $95358a6a51be7b32$var$FRIDAY = (0, $aed4b5c73cbdc652$export$ecc24ef5795d74f8)[5];
var $95358a6a51be7b32$var$SATURDAY = (0, $aed4b5c73cbdc652$export$ecc24ef5795d74f8)[6];
function $95358a6a51be7b32$export$2061056d06d7cdf7(date, calendarType) {
    if (calendarType === void 0) calendarType = (0, $aed4b5c73cbdc652$export$26fa441040070c35).ISO_8601;
    var weekday = date.getDay();
    switch(calendarType){
        case (0, $aed4b5c73cbdc652$export$26fa441040070c35).ISO_8601:
            // Shifts days of the week so that Monday is 0, Sunday is 6
            return (weekday + 6) % 7;
        case (0, $aed4b5c73cbdc652$export$26fa441040070c35).ISLAMIC:
            return (weekday + 1) % 7;
        case (0, $aed4b5c73cbdc652$export$26fa441040070c35).HEBREW:
        case (0, $aed4b5c73cbdc652$export$26fa441040070c35).GREGORY:
            return weekday;
        default:
            throw new Error('Unsupported calendar type.');
    }
}
function $95358a6a51be7b32$export$5fc0cc931278f768(date) {
    var beginOfCentury = (0, $f2e53ae88e17687e$export$34dd42d02ca37c6b)(date);
    return (0, $f2e53ae88e17687e$export$5846dc2d57a5c860)(beginOfCentury);
}
function $95358a6a51be7b32$export$59fb6e4ffa904295(date) {
    var beginOfDecade = (0, $f2e53ae88e17687e$export$8bb35b885d308e78)(date);
    return (0, $f2e53ae88e17687e$export$5846dc2d57a5c860)(beginOfDecade);
}
function $95358a6a51be7b32$export$84e707e5f485f282(date, calendarType) {
    if (calendarType === void 0) calendarType = (0, $aed4b5c73cbdc652$export$26fa441040070c35).ISO_8601;
    var year = (0, $f2e53ae88e17687e$export$5846dc2d57a5c860)(date);
    var monthIndex = (0, $f2e53ae88e17687e$export$6ce1b5acc29cb53b)(date);
    var day = date.getDate() - $95358a6a51be7b32$export$2061056d06d7cdf7(date, calendarType);
    return new Date(year, monthIndex, day);
}
function $95358a6a51be7b32$export$b59889984706b7a7(date, calendarType) {
    if (calendarType === void 0) calendarType = (0, $aed4b5c73cbdc652$export$26fa441040070c35).ISO_8601;
    var calendarTypeForWeekNumber = calendarType === (0, $aed4b5c73cbdc652$export$26fa441040070c35).GREGORY ? (0, $aed4b5c73cbdc652$export$26fa441040070c35).GREGORY : (0, $aed4b5c73cbdc652$export$26fa441040070c35).ISO_8601;
    var beginOfWeek = $95358a6a51be7b32$export$84e707e5f485f282(date, calendarType);
    var year = (0, $f2e53ae88e17687e$export$5846dc2d57a5c860)(date) + 1;
    var dayInWeekOne;
    var beginOfFirstWeek;
    // Look for the first week one that does not come after a given date
    do {
        dayInWeekOne = new Date(year, 0, calendarTypeForWeekNumber === (0, $aed4b5c73cbdc652$export$26fa441040070c35).ISO_8601 ? 4 : 1);
        beginOfFirstWeek = $95358a6a51be7b32$export$84e707e5f485f282(dayInWeekOne, calendarType);
        year -= 1;
    }while (date < beginOfFirstWeek);
    return Math.round((beginOfWeek.getTime() - beginOfFirstWeek.getTime()) / (8.64e7 * 7)) + 1;
}
function $95358a6a51be7b32$export$700a64ae37cbc741(rangeType, date) {
    switch(rangeType){
        case 'century':
            return (0, $f2e53ae88e17687e$export$34dd42d02ca37c6b)(date);
        case 'decade':
            return (0, $f2e53ae88e17687e$export$8bb35b885d308e78)(date);
        case 'year':
            return (0, $f2e53ae88e17687e$export$bbcf6a6951bb3c3a)(date);
        case 'month':
            return (0, $f2e53ae88e17687e$export$c7002b157c9b9e95)(date);
        case 'day':
            return (0, $f2e53ae88e17687e$export$ef6b506418c2b397)(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $95358a6a51be7b32$export$fac7f4c8b12617ff(rangeType, date) {
    switch(rangeType){
        case 'century':
            return (0, $f2e53ae88e17687e$export$e65b64b0f80e225a)(date);
        case 'decade':
            return (0, $f2e53ae88e17687e$export$e43f83f55f1766fa)(date);
        case 'year':
            return (0, $f2e53ae88e17687e$export$97fe927b771a6825)(date);
        case 'month':
            return (0, $f2e53ae88e17687e$export$e1815383d4029267)(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $95358a6a51be7b32$export$19193c1f2d841d47(rangeType, date) {
    switch(rangeType){
        case 'century':
            return (0, $f2e53ae88e17687e$export$3e300bd96d747c8a)(date);
        case 'decade':
            return (0, $f2e53ae88e17687e$export$8266d1a140c33d17)(date);
        case 'year':
            return (0, $f2e53ae88e17687e$export$fed82860795beff7)(date);
        case 'month':
            return (0, $f2e53ae88e17687e$export$21b7c773284d5b43)(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $95358a6a51be7b32$export$b514bf5935bed2bf(rangeType, date) {
    switch(rangeType){
        case 'decade':
            return (0, $f2e53ae88e17687e$export$e43f83f55f1766fa)(date, -100);
        case 'year':
            return (0, $f2e53ae88e17687e$export$97fe927b771a6825)(date, -10);
        case 'month':
            return (0, $f2e53ae88e17687e$export$e1815383d4029267)(date, -12);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $95358a6a51be7b32$export$2805b7ce8402b644(rangeType, date) {
    switch(rangeType){
        case 'decade':
            return (0, $f2e53ae88e17687e$export$8266d1a140c33d17)(date, 100);
        case 'year':
            return (0, $f2e53ae88e17687e$export$fed82860795beff7)(date, 10);
        case 'month':
            return (0, $f2e53ae88e17687e$export$21b7c773284d5b43)(date, 12);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $95358a6a51be7b32$export$946298ccd438a697(rangeType, date) {
    switch(rangeType){
        case 'century':
            return (0, $f2e53ae88e17687e$export$43c2109e18ca667b)(date);
        case 'decade':
            return (0, $f2e53ae88e17687e$export$aa0bfba5bfc33956)(date);
        case 'year':
            return (0, $f2e53ae88e17687e$export$248ddd7fb95e4a56)(date);
        case 'month':
            return (0, $f2e53ae88e17687e$export$6f306f93ccbcd612)(date);
        case 'day':
            return (0, $f2e53ae88e17687e$export$7b798396f3e38cd7)(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $95358a6a51be7b32$export$3030eb755e02a078(rangeType, date) {
    switch(rangeType){
        case 'century':
            return (0, $f2e53ae88e17687e$export$4d124431cf7f00b5)(date);
        case 'decade':
            return (0, $f2e53ae88e17687e$export$93edec1b41903921)(date);
        case 'year':
            return (0, $f2e53ae88e17687e$export$639fe5fbfbb704d0)(date);
        case 'month':
            return (0, $f2e53ae88e17687e$export$b4b5df1ab9a8303b)(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $95358a6a51be7b32$export$d34b1dc45bd5f1d3(rangeType, date) {
    switch(rangeType){
        case 'decade':
            return (0, $f2e53ae88e17687e$export$93edec1b41903921)(date, -100);
        case 'year':
            return (0, $f2e53ae88e17687e$export$639fe5fbfbb704d0)(date, -10);
        case 'month':
            return (0, $f2e53ae88e17687e$export$b4b5df1ab9a8303b)(date, -12);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $95358a6a51be7b32$export$fef151b94550e9f5(rangeType, date) {
    switch(rangeType){
        case 'century':
            return (0, $f2e53ae88e17687e$export$a4332dc3f9de051f)(date);
        case 'decade':
            return (0, $f2e53ae88e17687e$export$35cef0a1278b17e1)(date);
        case 'year':
            return (0, $f2e53ae88e17687e$export$17e213d8c10b7032)(date);
        case 'month':
            return (0, $f2e53ae88e17687e$export$c59fdbf3ad20e694)(date);
        case 'day':
            return (0, $f2e53ae88e17687e$export$adb5aef569605e64)(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $95358a6a51be7b32$export$3a3e6dbcaf74641d(rangeType, date1, date2) {
    var rawNextValue = [
        date1,
        date2
    ].sort(function(a, b) {
        return a.getTime() - b.getTime();
    });
    return [
        $95358a6a51be7b32$export$700a64ae37cbc741(rangeType, rawNextValue[0]),
        $95358a6a51be7b32$export$946298ccd438a697(rangeType, rawNextValue[1])
    ];
}
function $95358a6a51be7b32$var$toYearLabel(locale, formatYear, dates) {
    return dates.map(function(date) {
        return (formatYear || (0, $cbd6275857017435$export$2979e79cc7cbf15b))(locale, date);
    }).join(" \u2013 ");
}
function $95358a6a51be7b32$export$a05bb87f2c518835(locale, formatYear, date) {
    return $95358a6a51be7b32$var$toYearLabel(locale, formatYear, (0, $f2e53ae88e17687e$export$a4332dc3f9de051f)(date));
}
function $95358a6a51be7b32$export$2e69ef6076209750(locale, formatYear, date) {
    return $95358a6a51be7b32$var$toYearLabel(locale, formatYear, (0, $f2e53ae88e17687e$export$35cef0a1278b17e1)(date));
}
function $95358a6a51be7b32$export$12e2595dc60a5d5(date) {
    return date.getDay() === new Date().getDay();
}
function $95358a6a51be7b32$export$618d60ea299da42(date, calendarType) {
    if (calendarType === void 0) calendarType = (0, $aed4b5c73cbdc652$export$26fa441040070c35).ISO_8601;
    var weekday = date.getDay();
    switch(calendarType){
        case (0, $aed4b5c73cbdc652$export$26fa441040070c35).ISLAMIC:
        case (0, $aed4b5c73cbdc652$export$26fa441040070c35).HEBREW:
            return weekday === $95358a6a51be7b32$var$FRIDAY || weekday === $95358a6a51be7b32$var$SATURDAY;
        case (0, $aed4b5c73cbdc652$export$26fa441040070c35).ISO_8601:
        case (0, $aed4b5c73cbdc652$export$26fa441040070c35).GREGORY:
            return weekday === $95358a6a51be7b32$var$SATURDAY || weekday === $95358a6a51be7b32$var$SUNDAY;
        default:
            throw new Error('Unsupported calendar type.');
    }
}



'use client';
var $55737e1d85a8bba5$var$className = 'react-calendar__navigation';
function $55737e1d85a8bba5$export$2e2bcd8739ae039(_a) {
    var activeStartDate = _a.activeStartDate, drillUp = _a.drillUp, _b = _a.formatMonthYear, formatMonthYear = _b === void 0 ? (0, $cbd6275857017435$export$18f8ccbe37e54acd) : _b, _c = _a.formatYear, formatYear = _c === void 0 ? (0, $cbd6275857017435$export$2979e79cc7cbf15b) : _c, locale = _a.locale, maxDate = _a.maxDate, minDate = _a.minDate, _d = _a.navigationAriaLabel, navigationAriaLabel = _d === void 0 ? '' : _d, navigationAriaLive = _a.navigationAriaLive, navigationLabel = _a.navigationLabel, _e = _a.next2AriaLabel, next2AriaLabel = _e === void 0 ? '' : _e, _f = _a.next2Label, next2Label = _f === void 0 ? "\xbb" : _f, _g = _a.nextAriaLabel, nextAriaLabel = _g === void 0 ? '' : _g, _h = _a.nextLabel, nextLabel = _h === void 0 ? "\u203A" : _h, _j = _a.prev2AriaLabel, prev2AriaLabel = _j === void 0 ? '' : _j, _k = _a.prev2Label, prev2Label = _k === void 0 ? "\xab" : _k, _l = _a.prevAriaLabel, prevAriaLabel = _l === void 0 ? '' : _l, _m = _a.prevLabel, prevLabel = _m === void 0 ? "\u2039" : _m, setActiveStartDate = _a.setActiveStartDate, showDoubleView = _a.showDoubleView, view = _a.view, views = _a.views;
    var drillUpAvailable = views.indexOf(view) > 0;
    var shouldShowPrevNext2Buttons = view !== 'century';
    var previousActiveStartDate = (0, $95358a6a51be7b32$export$fac7f4c8b12617ff)(view, activeStartDate);
    var previousActiveStartDate2 = shouldShowPrevNext2Buttons ? (0, $95358a6a51be7b32$export$b514bf5935bed2bf)(view, activeStartDate) : undefined;
    var nextActiveStartDate = (0, $95358a6a51be7b32$export$19193c1f2d841d47)(view, activeStartDate);
    var nextActiveStartDate2 = shouldShowPrevNext2Buttons ? (0, $95358a6a51be7b32$export$2805b7ce8402b644)(view, activeStartDate) : undefined;
    var prevButtonDisabled = function() {
        if (previousActiveStartDate.getFullYear() < 0) return true;
        var previousActiveEndDate = (0, $95358a6a51be7b32$export$3030eb755e02a078)(view, activeStartDate);
        return minDate && minDate >= previousActiveEndDate;
    }();
    var prev2ButtonDisabled = shouldShowPrevNext2Buttons && function() {
        if (previousActiveStartDate2.getFullYear() < 0) return true;
        var previousActiveEndDate = (0, $95358a6a51be7b32$export$d34b1dc45bd5f1d3)(view, activeStartDate);
        return minDate && minDate >= previousActiveEndDate;
    }();
    var nextButtonDisabled = maxDate && maxDate < nextActiveStartDate;
    var next2ButtonDisabled = shouldShowPrevNext2Buttons && maxDate && maxDate < nextActiveStartDate2;
    function onClickPrevious() {
        setActiveStartDate(previousActiveStartDate, 'prev');
    }
    function onClickPrevious2() {
        setActiveStartDate(previousActiveStartDate2, 'prev2');
    }
    function onClickNext() {
        setActiveStartDate(nextActiveStartDate, 'next');
    }
    function onClickNext2() {
        setActiveStartDate(nextActiveStartDate2, 'next2');
    }
    function renderLabel(date) {
        var label = function() {
            switch(view){
                case 'century':
                    return (0, $95358a6a51be7b32$export$a05bb87f2c518835)(locale, formatYear, date);
                case 'decade':
                    return (0, $95358a6a51be7b32$export$2e69ef6076209750)(locale, formatYear, date);
                case 'year':
                    return formatYear(locale, date);
                case 'month':
                    return formatMonthYear(locale, date);
                default:
                    throw new Error("Invalid view: ".concat(view, "."));
            }
        }();
        return navigationLabel ? navigationLabel({
            date: date,
            label: label,
            locale: locale || (0, $9b825e302066192a$export$a6ea185b366483aa)() || undefined,
            view: view
        }) : label;
    }
    function renderButton() {
        var labelClassName = "".concat($55737e1d85a8bba5$var$className, "__label");
        return (0, $lBpE3.jsxs)("button", {
            "aria-label": navigationAriaLabel,
            "aria-live": navigationAriaLive,
            className: labelClassName,
            disabled: !drillUpAvailable,
            onClick: drillUp,
            style: {
                flexGrow: 1
            },
            type: "button",
            children: [
                (0, $lBpE3.jsx)("span", {
                    className: "".concat(labelClassName, "__labelText ").concat(labelClassName, "__labelText--from"),
                    children: renderLabel(activeStartDate)
                }),
                showDoubleView ? (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                    children: [
                        (0, $lBpE3.jsx)("span", {
                            className: "".concat(labelClassName, "__divider"),
                            children: " \u2013 "
                        }),
                        (0, $lBpE3.jsx)("span", {
                            className: "".concat(labelClassName, "__labelText ").concat(labelClassName, "__labelText--to"),
                            children: renderLabel(nextActiveStartDate)
                        })
                    ]
                }) : null
            ]
        });
    }
    return (0, $lBpE3.jsxs)("div", {
        className: $55737e1d85a8bba5$var$className,
        children: [
            prev2Label !== null && shouldShowPrevNext2Buttons ? (0, $lBpE3.jsx)("button", {
                "aria-label": prev2AriaLabel,
                className: "".concat($55737e1d85a8bba5$var$className, "__arrow ").concat($55737e1d85a8bba5$var$className, "__prev2-button"),
                disabled: prev2ButtonDisabled,
                onClick: onClickPrevious2,
                type: "button",
                children: prev2Label
            }) : null,
            prevLabel !== null && (0, $lBpE3.jsx)("button", {
                "aria-label": prevAriaLabel,
                className: "".concat($55737e1d85a8bba5$var$className, "__arrow ").concat($55737e1d85a8bba5$var$className, "__prev-button"),
                disabled: prevButtonDisabled,
                onClick: onClickPrevious,
                type: "button",
                children: prevLabel
            }),
            renderButton(),
            nextLabel !== null && (0, $lBpE3.jsx)("button", {
                "aria-label": nextAriaLabel,
                className: "".concat($55737e1d85a8bba5$var$className, "__arrow ").concat($55737e1d85a8bba5$var$className, "__next-button"),
                disabled: nextButtonDisabled,
                onClick: onClickNext,
                type: "button",
                children: nextLabel
            }),
            next2Label !== null && shouldShowPrevNext2Buttons ? (0, $lBpE3.jsx)("button", {
                "aria-label": next2AriaLabel,
                className: "".concat($55737e1d85a8bba5$var$className, "__arrow ").concat($55737e1d85a8bba5$var$className, "__next2-button"),
                disabled: next2ButtonDisabled,
                onClick: onClickNext2,
                type: "button",
                children: next2Label
            }) : null
        ]
    });
}



var $lBpE3 = parcelRequire("lBpE3");

var $lBpE3 = parcelRequire("lBpE3");


var $lBpE3 = parcelRequire("lBpE3");

var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");
var $accf05ff08c09d5e$var$__assign = undefined && undefined.__assign || function() {
    $accf05ff08c09d5e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $accf05ff08c09d5e$var$__assign.apply(this, arguments);
};
var $accf05ff08c09d5e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $accf05ff08c09d5e$var$toPercent(num) {
    return "".concat(num, "%");
}
function $accf05ff08c09d5e$export$2e2bcd8739ae039(_a) {
    var children = _a.children, className = _a.className, count = _a.count, direction = _a.direction, offset = _a.offset, style = _a.style, wrap = _a.wrap, otherProps = $accf05ff08c09d5e$var$__rest(_a, [
        "children",
        "className",
        "count",
        "direction",
        "offset",
        "style",
        "wrap"
    ]);
    return (0, $lBpE3.jsx)("div", $accf05ff08c09d5e$var$__assign({
        className: className,
        style: $accf05ff08c09d5e$var$__assign({
            display: 'flex',
            flexDirection: direction,
            flexWrap: wrap ? 'wrap' : 'nowrap'
        }, style)
    }, otherProps, {
        children: (0, $6cds3.Children).map(children, function(child, index) {
            var marginInlineStart = offset && index === 0 ? $accf05ff08c09d5e$var$toPercent(100 * offset / count) : null;
            return (0, $6cds3.cloneElement)(child, $accf05ff08c09d5e$var$__assign($accf05ff08c09d5e$var$__assign({}, child.props), {
                style: {
                    flexBasis: $accf05ff08c09d5e$var$toPercent(100 / count),
                    flexShrink: 0,
                    flexGrow: 0,
                    overflow: 'hidden',
                    marginLeft: marginInlineStart,
                    marginInlineStart: marginInlineStart,
                    marginInlineEnd: 0
                }
            }));
        })
    }));
}



function $61ee086d3773f64e$export$cf95c51b03f10bae(value, min, max) {
    if (min && min > value) return min;
    if (max && max < value) return max;
    return value;
}
function $61ee086d3773f64e$export$7c4e06fee2f75722(value, range) {
    return range[0] <= value && range[1] >= value;
}
function $61ee086d3773f64e$export$eecb2aa703319c46(greaterRange, smallerRange) {
    return greaterRange[0] <= smallerRange[0] && greaterRange[1] >= smallerRange[1];
}
function $61ee086d3773f64e$export$2e215bb7f5401ba1(range1, range2) {
    return $61ee086d3773f64e$export$7c4e06fee2f75722(range1[0], range2) || $61ee086d3773f64e$export$7c4e06fee2f75722(range1[1], range2);
}
function $61ee086d3773f64e$var$getRangeClassNames(valueRange, dateRange, baseClassName) {
    var isRange = $61ee086d3773f64e$export$2e215bb7f5401ba1(dateRange, valueRange);
    var classes = [];
    if (isRange) {
        classes.push(baseClassName);
        var isRangeStart = $61ee086d3773f64e$export$7c4e06fee2f75722(valueRange[0], dateRange);
        var isRangeEnd = $61ee086d3773f64e$export$7c4e06fee2f75722(valueRange[1], dateRange);
        if (isRangeStart) classes.push("".concat(baseClassName, "Start"));
        if (isRangeEnd) classes.push("".concat(baseClassName, "End"));
        if (isRangeStart && isRangeEnd) classes.push("".concat(baseClassName, "BothEnds"));
    }
    return classes;
}
function $61ee086d3773f64e$var$isCompleteValue(value) {
    if (Array.isArray(value)) return value[0] !== null && value[1] !== null;
    return value !== null;
}
function $61ee086d3773f64e$export$8b25b190354ee282(args) {
    if (!args) throw new Error('args is required');
    var value = args.value, date = args.date, hover = args.hover;
    var className = 'react-calendar__tile';
    var classes = [
        className
    ];
    if (!date) return classes;
    var now = new Date();
    var dateRange = function() {
        if (Array.isArray(date)) return date;
        var dateType = args.dateType;
        if (!dateType) throw new Error('dateType is required when date is not an array of two dates');
        return (0, $95358a6a51be7b32$export$fef151b94550e9f5)(dateType, date);
    }();
    if ($61ee086d3773f64e$export$7c4e06fee2f75722(now, dateRange)) classes.push("".concat(className, "--now"));
    if (!value || !$61ee086d3773f64e$var$isCompleteValue(value)) return classes;
    var valueRange = function() {
        if (Array.isArray(value)) return value;
        var valueType = args.valueType;
        if (!valueType) throw new Error('valueType is required when value is not an array of two dates');
        return (0, $95358a6a51be7b32$export$fef151b94550e9f5)(valueType, value);
    }();
    if ($61ee086d3773f64e$export$eecb2aa703319c46(valueRange, dateRange)) classes.push("".concat(className, "--active"));
    else if ($61ee086d3773f64e$export$2e215bb7f5401ba1(valueRange, dateRange)) classes.push("".concat(className, "--hasActive"));
    var valueRangeClassNames = $61ee086d3773f64e$var$getRangeClassNames(valueRange, dateRange, "".concat(className, "--range"));
    classes.push.apply(classes, valueRangeClassNames);
    var valueArray = Array.isArray(value) ? value : [
        value
    ];
    if (hover && valueArray.length === 1) {
        var hoverRange = hover > valueRange[0] ? [
            valueRange[0],
            hover
        ] : [
            hover,
            valueRange[0]
        ];
        var hoverRangeClassNames = $61ee086d3773f64e$var$getRangeClassNames(hoverRange, dateRange, "".concat(className, "--hover"));
        classes.push.apply(classes, hoverRangeClassNames);
    }
    return classes;
}


function $e12323ff6d5798c2$export$2e2bcd8739ae039(_a) {
    var className = _a.className, _b = _a.count, count = _b === void 0 ? 3 : _b, dateTransform = _a.dateTransform, dateType = _a.dateType, end = _a.end, hover = _a.hover, offset = _a.offset, renderTile = _a.renderTile, start = _a.start, _c = _a.step, step = _c === void 0 ? 1 : _c, value = _a.value, valueType = _a.valueType;
    var tiles = [];
    for(var point = start; point <= end; point += step){
        var date = dateTransform(point);
        tiles.push(renderTile({
            classes: (0, $61ee086d3773f64e$export$8b25b190354ee282)({
                date: date,
                dateType: dateType,
                hover: hover,
                value: value,
                valueType: valueType
            }),
            date: date
        }));
    }
    return (0, $lBpE3.jsx)((0, $accf05ff08c09d5e$export$2e2bcd8739ae039), {
        className: className,
        count: count,
        offset: offset,
        wrap: true,
        children: tiles
    });
}



var $lBpE3 = parcelRequire("lBpE3");


var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

function $7f194ffb82ff9c74$export$2e2bcd8739ae039(props) {
    var activeStartDate = props.activeStartDate, children = props.children, classes = props.classes, date = props.date, formatAbbr = props.formatAbbr, locale = props.locale, maxDate = props.maxDate, maxDateTransform = props.maxDateTransform, minDate = props.minDate, minDateTransform = props.minDateTransform, onClick = props.onClick, onMouseOver = props.onMouseOver, style = props.style, tileClassNameProps = props.tileClassName, tileContentProps = props.tileContent, tileDisabled = props.tileDisabled, view = props.view;
    var tileClassName = (0, $6cds3.useMemo)(function() {
        var args = {
            activeStartDate: activeStartDate,
            date: date,
            view: view
        };
        return typeof tileClassNameProps === 'function' ? tileClassNameProps(args) : tileClassNameProps;
    }, [
        activeStartDate,
        date,
        tileClassNameProps,
        view
    ]);
    var tileContent = (0, $6cds3.useMemo)(function() {
        var args = {
            activeStartDate: activeStartDate,
            date: date,
            view: view
        };
        return typeof tileContentProps === 'function' ? tileContentProps(args) : tileContentProps;
    }, [
        activeStartDate,
        date,
        tileContentProps,
        view
    ]);
    return (0, $lBpE3.jsxs)("button", {
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(classes, tileClassName),
        disabled: minDate && minDateTransform(minDate) > date || maxDate && maxDateTransform(maxDate) < date || (tileDisabled === null || tileDisabled === void 0 ? void 0 : tileDisabled({
            activeStartDate: activeStartDate,
            date: date,
            view: view
        })),
        onClick: onClick ? function(event) {
            return onClick(date, event);
        } : undefined,
        onFocus: onMouseOver ? function() {
            return onMouseOver(date);
        } : undefined,
        onMouseOver: onMouseOver ? function() {
            return onMouseOver(date);
        } : undefined,
        style: style,
        type: "button",
        children: [
            formatAbbr ? (0, $lBpE3.jsx)("abbr", {
                "aria-label": formatAbbr(locale, date),
                children: children
            }) : children,
            tileContent
        ]
    });
}




var $3f5961991255625c$var$__assign = undefined && undefined.__assign || function() {
    $3f5961991255625c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3f5961991255625c$var$__assign.apply(this, arguments);
};
var $3f5961991255625c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $3f5961991255625c$var$className = 'react-calendar__century-view__decades__decade';
function $3f5961991255625c$export$2e2bcd8739ae039(_a) {
    var _b = _a.classes, classes = _b === void 0 ? [] : _b, currentCentury = _a.currentCentury, _c = _a.formatYear, formatYear = _c === void 0 ? (0, $cbd6275857017435$export$2979e79cc7cbf15b) : _c, otherProps = $3f5961991255625c$var$__rest(_a, [
        "classes",
        "currentCentury",
        "formatYear"
    ]);
    var date = otherProps.date, locale = otherProps.locale;
    var classesProps = [];
    if (classes) classesProps.push.apply(classesProps, classes);
    if ($3f5961991255625c$var$className) classesProps.push($3f5961991255625c$var$className);
    if ((0, $f2e53ae88e17687e$export$34dd42d02ca37c6b)(date).getFullYear() !== currentCentury) classesProps.push("".concat($3f5961991255625c$var$className, "--neighboringCentury"));
    return (0, $lBpE3.jsx)((0, $7f194ffb82ff9c74$export$2e2bcd8739ae039), $3f5961991255625c$var$__assign({}, otherProps, {
        classes: classesProps,
        maxDateTransform: (0, $f2e53ae88e17687e$export$aa0bfba5bfc33956),
        minDateTransform: (0, $f2e53ae88e17687e$export$8bb35b885d308e78),
        view: "century",
        children: (0, $95358a6a51be7b32$export$2e69ef6076209750)(locale, formatYear, date)
    }));
}



var $17ac396d9d8b2d72$var$__assign = undefined && undefined.__assign || function() {
    $17ac396d9d8b2d72$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $17ac396d9d8b2d72$var$__assign.apply(this, arguments);
};
var $17ac396d9d8b2d72$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $17ac396d9d8b2d72$export$2e2bcd8739ae039(props) {
    var activeStartDate = props.activeStartDate, hover = props.hover, showNeighboringCentury = props.showNeighboringCentury, value = props.value, valueType = props.valueType, otherProps = $17ac396d9d8b2d72$var$__rest(props, [
        "activeStartDate",
        "hover",
        "showNeighboringCentury",
        "value",
        "valueType"
    ]);
    var start = (0, $95358a6a51be7b32$export$5fc0cc931278f768)(activeStartDate);
    var end = start + (showNeighboringCentury ? 119 : 99);
    return (0, $lBpE3.jsx)((0, $e12323ff6d5798c2$export$2e2bcd8739ae039), {
        className: "react-calendar__century-view__decades",
        dateTransform: (0, $f2e53ae88e17687e$export$8bb35b885d308e78),
        dateType: "decade",
        end: end,
        hover: hover,
        renderTile: function(_a) {
            var date = _a.date, otherTileProps = $17ac396d9d8b2d72$var$__rest(_a, [
                "date"
            ]);
            return (0, $lBpE3.jsx)((0, $3f5961991255625c$export$2e2bcd8739ae039), $17ac396d9d8b2d72$var$__assign({}, otherProps, otherTileProps, {
                activeStartDate: activeStartDate,
                currentCentury: start,
                date: date
            }), date.getTime());
        },
        start: start,
        step: 10,
        value: value,
        valueType: valueType
    });
}


var $25798cb1bda33c91$var$__assign = undefined && undefined.__assign || function() {
    $25798cb1bda33c91$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $25798cb1bda33c91$var$__assign.apply(this, arguments);
};
function $25798cb1bda33c91$export$2e2bcd8739ae039(props) {
    function renderDecades() {
        return (0, $lBpE3.jsx)((0, $17ac396d9d8b2d72$export$2e2bcd8739ae039), $25798cb1bda33c91$var$__assign({}, props));
    }
    return (0, $lBpE3.jsx)("div", {
        className: "react-calendar__century-view",
        children: renderDecades()
    });
}



var $lBpE3 = parcelRequire("lBpE3");

var $lBpE3 = parcelRequire("lBpE3");



var $lBpE3 = parcelRequire("lBpE3");



var $f4c4d07657657dce$var$__assign = undefined && undefined.__assign || function() {
    $f4c4d07657657dce$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f4c4d07657657dce$var$__assign.apply(this, arguments);
};
var $f4c4d07657657dce$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f4c4d07657657dce$var$className = 'react-calendar__decade-view__years__year';
function $f4c4d07657657dce$export$2e2bcd8739ae039(_a) {
    var _b = _a.classes, classes = _b === void 0 ? [] : _b, currentDecade = _a.currentDecade, _c = _a.formatYear, formatYear = _c === void 0 ? (0, $cbd6275857017435$export$2979e79cc7cbf15b) : _c, otherProps = $f4c4d07657657dce$var$__rest(_a, [
        "classes",
        "currentDecade",
        "formatYear"
    ]);
    var date = otherProps.date, locale = otherProps.locale;
    var classesProps = [];
    if (classes) classesProps.push.apply(classesProps, classes);
    if ($f4c4d07657657dce$var$className) classesProps.push($f4c4d07657657dce$var$className);
    if ((0, $f2e53ae88e17687e$export$8bb35b885d308e78)(date).getFullYear() !== currentDecade) classesProps.push("".concat($f4c4d07657657dce$var$className, "--neighboringDecade"));
    return (0, $lBpE3.jsx)((0, $7f194ffb82ff9c74$export$2e2bcd8739ae039), $f4c4d07657657dce$var$__assign({}, otherProps, {
        classes: classesProps,
        maxDateTransform: (0, $f2e53ae88e17687e$export$248ddd7fb95e4a56),
        minDateTransform: (0, $f2e53ae88e17687e$export$bbcf6a6951bb3c3a),
        view: "decade",
        children: formatYear(locale, date)
    }));
}



var $2bfbbb24a246e7d5$var$__assign = undefined && undefined.__assign || function() {
    $2bfbbb24a246e7d5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2bfbbb24a246e7d5$var$__assign.apply(this, arguments);
};
var $2bfbbb24a246e7d5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $2bfbbb24a246e7d5$export$2e2bcd8739ae039(props) {
    var activeStartDate = props.activeStartDate, hover = props.hover, showNeighboringDecade = props.showNeighboringDecade, value = props.value, valueType = props.valueType, otherProps = $2bfbbb24a246e7d5$var$__rest(props, [
        "activeStartDate",
        "hover",
        "showNeighboringDecade",
        "value",
        "valueType"
    ]);
    var start = (0, $95358a6a51be7b32$export$59fb6e4ffa904295)(activeStartDate);
    var end = start + (showNeighboringDecade ? 11 : 9);
    return (0, $lBpE3.jsx)((0, $e12323ff6d5798c2$export$2e2bcd8739ae039), {
        className: "react-calendar__decade-view__years",
        dateTransform: (0, $f2e53ae88e17687e$export$bbcf6a6951bb3c3a),
        dateType: "year",
        end: end,
        hover: hover,
        renderTile: function(_a) {
            var date = _a.date, otherTileProps = $2bfbbb24a246e7d5$var$__rest(_a, [
                "date"
            ]);
            return (0, $lBpE3.jsx)((0, $f4c4d07657657dce$export$2e2bcd8739ae039), $2bfbbb24a246e7d5$var$__assign({}, otherProps, otherTileProps, {
                activeStartDate: activeStartDate,
                currentDecade: start,
                date: date
            }), date.getTime());
        },
        start: start,
        value: value,
        valueType: valueType
    });
}


var $e2fc7de71b5f02cb$var$__assign = undefined && undefined.__assign || function() {
    $e2fc7de71b5f02cb$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e2fc7de71b5f02cb$var$__assign.apply(this, arguments);
};
function $e2fc7de71b5f02cb$export$2e2bcd8739ae039(props) {
    function renderYears() {
        return (0, $lBpE3.jsx)((0, $2bfbbb24a246e7d5$export$2e2bcd8739ae039), $e2fc7de71b5f02cb$var$__assign({}, props));
    }
    return (0, $lBpE3.jsx)("div", {
        className: "react-calendar__decade-view",
        children: renderYears()
    });
}



var $lBpE3 = parcelRequire("lBpE3");

var $lBpE3 = parcelRequire("lBpE3");



var $lBpE3 = parcelRequire("lBpE3");



var $0a0d0bfd1a5f9c75$var$__assign = undefined && undefined.__assign || function() {
    $0a0d0bfd1a5f9c75$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0a0d0bfd1a5f9c75$var$__assign.apply(this, arguments);
};
var $0a0d0bfd1a5f9c75$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0a0d0bfd1a5f9c75$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $0a0d0bfd1a5f9c75$var$className = 'react-calendar__year-view__months__month';
function $0a0d0bfd1a5f9c75$export$2e2bcd8739ae039(_a) {
    var _b = _a.classes, classes = _b === void 0 ? [] : _b, _c = _a.formatMonth, formatMonth = _c === void 0 ? (0, $cbd6275857017435$export$d0536c8e7f45796e) : _c, _d = _a.formatMonthYear, formatMonthYear = _d === void 0 ? (0, $cbd6275857017435$export$18f8ccbe37e54acd) : _d, otherProps = $0a0d0bfd1a5f9c75$var$__rest(_a, [
        "classes",
        "formatMonth",
        "formatMonthYear"
    ]);
    var date = otherProps.date, locale = otherProps.locale;
    return (0, $lBpE3.jsx)((0, $7f194ffb82ff9c74$export$2e2bcd8739ae039), $0a0d0bfd1a5f9c75$var$__assign({}, otherProps, {
        classes: $0a0d0bfd1a5f9c75$var$__spreadArray($0a0d0bfd1a5f9c75$var$__spreadArray([], classes, true), [
            $0a0d0bfd1a5f9c75$var$className
        ], false),
        formatAbbr: formatMonthYear,
        maxDateTransform: (0, $f2e53ae88e17687e$export$6f306f93ccbcd612),
        minDateTransform: (0, $f2e53ae88e17687e$export$c7002b157c9b9e95),
        view: "year",
        children: formatMonth(locale, date)
    }));
}


var $109d989e63d92fec$var$__assign = undefined && undefined.__assign || function() {
    $109d989e63d92fec$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $109d989e63d92fec$var$__assign.apply(this, arguments);
};
var $109d989e63d92fec$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $109d989e63d92fec$export$2e2bcd8739ae039(props) {
    var activeStartDate = props.activeStartDate, hover = props.hover, value = props.value, valueType = props.valueType, otherProps = $109d989e63d92fec$var$__rest(props, [
        "activeStartDate",
        "hover",
        "value",
        "valueType"
    ]);
    var start = 0;
    var end = 11;
    var year = (0, $f2e53ae88e17687e$export$5846dc2d57a5c860)(activeStartDate);
    return (0, $lBpE3.jsx)((0, $e12323ff6d5798c2$export$2e2bcd8739ae039), {
        className: "react-calendar__year-view__months",
        dateTransform: function(monthIndex) {
            var date = new Date();
            date.setFullYear(year, monthIndex, 1);
            return (0, $f2e53ae88e17687e$export$c7002b157c9b9e95)(date);
        },
        dateType: "month",
        end: end,
        hover: hover,
        renderTile: function(_a) {
            var date = _a.date, otherTileProps = $109d989e63d92fec$var$__rest(_a, [
                "date"
            ]);
            return (0, $lBpE3.jsx)((0, $0a0d0bfd1a5f9c75$export$2e2bcd8739ae039), $109d989e63d92fec$var$__assign({}, otherProps, otherTileProps, {
                activeStartDate: activeStartDate,
                date: date
            }), date.getTime());
        },
        start: start,
        value: value,
        valueType: valueType
    });
}


var $404dfbcd85bfaddc$var$__assign = undefined && undefined.__assign || function() {
    $404dfbcd85bfaddc$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $404dfbcd85bfaddc$var$__assign.apply(this, arguments);
};
function $404dfbcd85bfaddc$export$2e2bcd8739ae039(props) {
    function renderMonths() {
        return (0, $lBpE3.jsx)((0, $109d989e63d92fec$export$2e2bcd8739ae039), $404dfbcd85bfaddc$var$__assign({}, props));
    }
    return (0, $lBpE3.jsx)("div", {
        className: "react-calendar__year-view",
        children: renderMonths()
    });
}



var $lBpE3 = parcelRequire("lBpE3");


var $lBpE3 = parcelRequire("lBpE3");



var $lBpE3 = parcelRequire("lBpE3");




var $16cfa03d94e29c5c$var$__assign = undefined && undefined.__assign || function() {
    $16cfa03d94e29c5c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $16cfa03d94e29c5c$var$__assign.apply(this, arguments);
};
var $16cfa03d94e29c5c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $16cfa03d94e29c5c$var$className = 'react-calendar__month-view__days__day';
function $16cfa03d94e29c5c$export$2e2bcd8739ae039(_a) {
    var calendarType = _a.calendarType, _b = _a.classes, classes = _b === void 0 ? [] : _b, currentMonthIndex = _a.currentMonthIndex, _c = _a.formatDay, formatDay = _c === void 0 ? (0, $cbd6275857017435$export$a7f242eff11c1345) : _c, _d = _a.formatLongDate, formatLongDate = _d === void 0 ? (0, $cbd6275857017435$export$322b36d80aef60ca) : _d, otherProps = $16cfa03d94e29c5c$var$__rest(_a, [
        "calendarType",
        "classes",
        "currentMonthIndex",
        "formatDay",
        "formatLongDate"
    ]);
    var date = otherProps.date, locale = otherProps.locale;
    var classesProps = [];
    if (classes) classesProps.push.apply(classesProps, classes);
    if ($16cfa03d94e29c5c$var$className) classesProps.push($16cfa03d94e29c5c$var$className);
    if ((0, $95358a6a51be7b32$export$618d60ea299da42)(date, calendarType)) classesProps.push("".concat($16cfa03d94e29c5c$var$className, "--weekend"));
    if (date.getMonth() !== currentMonthIndex) classesProps.push("".concat($16cfa03d94e29c5c$var$className, "--neighboringMonth"));
    return (0, $lBpE3.jsx)((0, $7f194ffb82ff9c74$export$2e2bcd8739ae039), $16cfa03d94e29c5c$var$__assign({}, otherProps, {
        classes: classesProps,
        formatAbbr: formatLongDate,
        maxDateTransform: (0, $f2e53ae88e17687e$export$7b798396f3e38cd7),
        minDateTransform: (0, $f2e53ae88e17687e$export$ef6b506418c2b397),
        view: "month",
        children: formatDay(locale, date)
    }));
}



var $d7d08c8febb6466c$var$__assign = undefined && undefined.__assign || function() {
    $d7d08c8febb6466c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d7d08c8febb6466c$var$__assign.apply(this, arguments);
};
var $d7d08c8febb6466c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $d7d08c8febb6466c$export$2e2bcd8739ae039(props) {
    var activeStartDate = props.activeStartDate, calendarType = props.calendarType, hover = props.hover, showFixedNumberOfWeeks = props.showFixedNumberOfWeeks, showNeighboringMonth = props.showNeighboringMonth, value = props.value, valueType = props.valueType, otherProps = $d7d08c8febb6466c$var$__rest(props, [
        "activeStartDate",
        "calendarType",
        "hover",
        "showFixedNumberOfWeeks",
        "showNeighboringMonth",
        "value",
        "valueType"
    ]);
    var year = (0, $f2e53ae88e17687e$export$5846dc2d57a5c860)(activeStartDate);
    var monthIndex = (0, $f2e53ae88e17687e$export$6ce1b5acc29cb53b)(activeStartDate);
    var hasFixedNumberOfWeeks = showFixedNumberOfWeeks || showNeighboringMonth;
    var dayOfWeek = (0, $95358a6a51be7b32$export$2061056d06d7cdf7)(activeStartDate, calendarType);
    var offset = hasFixedNumberOfWeeks ? 0 : dayOfWeek;
    /**
     * Defines on which day of the month the grid shall start. If we simply show current
     * month, we obviously start on day one, but if showNeighboringMonth is set to
     * true, we need to find the beginning of the week the first day of the month is in.
     */ var start = (hasFixedNumberOfWeeks ? -dayOfWeek : 0) + 1;
    /**
     * Defines on which day of the month the grid shall end. If we simply show current
     * month, we need to stop on the last day of the month, but if showNeighboringMonth
     * is set to true, we need to find the end of the week the last day of the month is in.
     */ var end = function() {
        if (showFixedNumberOfWeeks) // Always show 6 weeks
        return start + 42 - 1;
        var daysInMonth = (0, $f2e53ae88e17687e$export$f645ddd439eb259d)(activeStartDate);
        if (showNeighboringMonth) {
            var activeEndDate = new Date();
            activeEndDate.setFullYear(year, monthIndex, daysInMonth);
            activeEndDate.setHours(0, 0, 0, 0);
            var daysUntilEndOfTheWeek = 7 - (0, $95358a6a51be7b32$export$2061056d06d7cdf7)(activeEndDate, calendarType) - 1;
            return daysInMonth + daysUntilEndOfTheWeek;
        }
        return daysInMonth;
    }();
    return (0, $lBpE3.jsx)((0, $e12323ff6d5798c2$export$2e2bcd8739ae039), {
        className: "react-calendar__month-view__days",
        count: 7,
        dateTransform: function(day) {
            var date = new Date();
            date.setFullYear(year, monthIndex, day);
            return (0, $f2e53ae88e17687e$export$ef6b506418c2b397)(date);
        },
        dateType: "day",
        hover: hover,
        end: end,
        renderTile: function(_a) {
            var date = _a.date, otherTileProps = $d7d08c8febb6466c$var$__rest(_a, [
                "date"
            ]);
            return (0, $lBpE3.jsx)((0, $16cfa03d94e29c5c$export$2e2bcd8739ae039), $d7d08c8febb6466c$var$__assign({}, otherProps, otherTileProps, {
                activeStartDate: activeStartDate,
                calendarType: calendarType,
                currentMonthIndex: monthIndex,
                date: date
            }), date.getTime());
        },
        offset: offset,
        start: start,
        value: value,
        valueType: valueType
    });
}



var $lBpE3 = parcelRequire("lBpE3");





var $3abc3146f467f8e1$var$className = 'react-calendar__month-view__weekdays';
var $3abc3146f467f8e1$var$weekdayClassName = "".concat($3abc3146f467f8e1$var$className, "__weekday");
function $3abc3146f467f8e1$export$2e2bcd8739ae039(props) {
    var calendarType = props.calendarType, _a = props.formatShortWeekday, formatShortWeekday = _a === void 0 ? (0, $cbd6275857017435$export$7ebe25e42481bc02) : _a, _b = props.formatWeekday, formatWeekday = _b === void 0 ? (0, $cbd6275857017435$export$407180b957f39d7e) : _b, locale = props.locale, onMouseLeave = props.onMouseLeave;
    var anyDate = new Date();
    var beginOfMonth = (0, $f2e53ae88e17687e$export$c7002b157c9b9e95)(anyDate);
    var year = (0, $f2e53ae88e17687e$export$5846dc2d57a5c860)(beginOfMonth);
    var monthIndex = (0, $f2e53ae88e17687e$export$6ce1b5acc29cb53b)(beginOfMonth);
    var weekdays = [];
    for(var weekday = 1; weekday <= 7; weekday += 1){
        var weekdayDate = new Date(year, monthIndex, weekday - (0, $95358a6a51be7b32$export$2061056d06d7cdf7)(beginOfMonth, calendarType));
        var abbr = formatWeekday(locale, weekdayDate);
        weekdays.push((0, $lBpE3.jsx)("div", {
            className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)($3abc3146f467f8e1$var$weekdayClassName, (0, $95358a6a51be7b32$export$12e2595dc60a5d5)(weekdayDate) && "".concat($3abc3146f467f8e1$var$weekdayClassName, "--current"), (0, $95358a6a51be7b32$export$618d60ea299da42)(weekdayDate, calendarType) && "".concat($3abc3146f467f8e1$var$weekdayClassName, "--weekend")),
            children: (0, $lBpE3.jsx)("abbr", {
                "aria-label": abbr,
                title: abbr,
                children: formatShortWeekday(locale, weekdayDate).replace('.', '')
            })
        }, weekday));
    }
    return (0, $lBpE3.jsx)((0, $accf05ff08c09d5e$export$2e2bcd8739ae039), {
        className: $3abc3146f467f8e1$var$className,
        count: 7,
        onFocus: onMouseLeave,
        onMouseOver: onMouseLeave,
        children: weekdays
    });
}



var $lBpE3 = parcelRequire("lBpE3");


var $lBpE3 = parcelRequire("lBpE3");
var $ce43abf495bad9a4$var$__assign = undefined && undefined.__assign || function() {
    $ce43abf495bad9a4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ce43abf495bad9a4$var$__assign.apply(this, arguments);
};
var $ce43abf495bad9a4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ce43abf495bad9a4$var$className = 'react-calendar__tile';
function $ce43abf495bad9a4$export$2e2bcd8739ae039(props) {
    var onClickWeekNumber = props.onClickWeekNumber, weekNumber = props.weekNumber;
    var children = (0, $lBpE3.jsx)("span", {
        children: weekNumber
    });
    if (onClickWeekNumber) {
        var date_1 = props.date, onClickWeekNumber_1 = props.onClickWeekNumber, weekNumber_1 = props.weekNumber, otherProps = $ce43abf495bad9a4$var$__rest(props, [
            "date",
            "onClickWeekNumber",
            "weekNumber"
        ]);
        return (0, $lBpE3.jsx)("button", $ce43abf495bad9a4$var$__assign({}, otherProps, {
            className: $ce43abf495bad9a4$var$className,
            onClick: function(event) {
                return onClickWeekNumber_1(weekNumber_1, date_1, event);
            },
            type: "button",
            children: children
        }));
    // biome-ignore lint/style/noUselessElse: TypeScript is unhappy if we remove this else
    } else {
        var date = props.date, onClickWeekNumber_2 = props.onClickWeekNumber, weekNumber_2 = props.weekNumber, otherProps = $ce43abf495bad9a4$var$__rest(props, [
            "date",
            "onClickWeekNumber",
            "weekNumber"
        ]);
        return (0, $lBpE3.jsx)("div", $ce43abf495bad9a4$var$__assign({}, otherProps, {
            className: $ce43abf495bad9a4$var$className,
            children: children
        }));
    }
}




function $d8e178863735bdae$export$2e2bcd8739ae039(props) {
    var activeStartDate = props.activeStartDate, calendarType = props.calendarType, onClickWeekNumber = props.onClickWeekNumber, onMouseLeave = props.onMouseLeave, showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;
    var numberOfWeeks = function() {
        if (showFixedNumberOfWeeks) return 6;
        var numberOfDays = (0, $f2e53ae88e17687e$export$f645ddd439eb259d)(activeStartDate);
        var startWeekday = (0, $95358a6a51be7b32$export$2061056d06d7cdf7)(activeStartDate, calendarType);
        var days = numberOfDays - (7 - startWeekday);
        return 1 + Math.ceil(days / 7);
    }();
    var dates = function() {
        var year = (0, $f2e53ae88e17687e$export$5846dc2d57a5c860)(activeStartDate);
        var monthIndex = (0, $f2e53ae88e17687e$export$6ce1b5acc29cb53b)(activeStartDate);
        var day = (0, $f2e53ae88e17687e$export$aa350b96d91cd94)(activeStartDate);
        var result = [];
        for(var index = 0; index < numberOfWeeks; index += 1)result.push((0, $95358a6a51be7b32$export$84e707e5f485f282)(new Date(year, monthIndex, day + index * 7), calendarType));
        return result;
    }();
    var weekNumbers = dates.map(function(date) {
        return (0, $95358a6a51be7b32$export$b59889984706b7a7)(date, calendarType);
    });
    return (0, $lBpE3.jsx)((0, $accf05ff08c09d5e$export$2e2bcd8739ae039), {
        className: "react-calendar__month-view__weekNumbers",
        count: numberOfWeeks,
        direction: "column",
        onFocus: onMouseLeave,
        onMouseOver: onMouseLeave,
        style: {
            flexBasis: 'calc(100% * (1 / 8)',
            flexShrink: 0
        },
        children: weekNumbers.map(function(weekNumber, weekIndex) {
            var date = dates[weekIndex];
            if (!date) throw new Error('date is not defined');
            return (0, $lBpE3.jsx)((0, $ce43abf495bad9a4$export$2e2bcd8739ae039), {
                date: date,
                onClickWeekNumber: onClickWeekNumber,
                weekNumber: weekNumber
            }, weekNumber);
        })
    });
}



var $fdabbd2f395eb96a$var$__assign = undefined && undefined.__assign || function() {
    $fdabbd2f395eb96a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fdabbd2f395eb96a$var$__assign.apply(this, arguments);
};
var $fdabbd2f395eb96a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $fdabbd2f395eb96a$var$getCalendarTypeFromLocale(locale) {
    if (locale) for(var _i = 0, _a = Object.entries((0, $aed4b5c73cbdc652$export$e4e5576db5b8e30f)); _i < _a.length; _i++){
        var _b = _a[_i], calendarType = _b[0], locales = _b[1];
        if (locales.includes(locale)) return calendarType;
    }
    return (0, $aed4b5c73cbdc652$export$26fa441040070c35).ISO_8601;
}
function $fdabbd2f395eb96a$export$2e2bcd8739ae039(props) {
    var activeStartDate = props.activeStartDate, locale = props.locale, onMouseLeave = props.onMouseLeave, showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;
    var _a = props.calendarType, calendarType = _a === void 0 ? $fdabbd2f395eb96a$var$getCalendarTypeFromLocale(locale) : _a, formatShortWeekday = props.formatShortWeekday, formatWeekday = props.formatWeekday, onClickWeekNumber = props.onClickWeekNumber, showWeekNumbers = props.showWeekNumbers, childProps = $fdabbd2f395eb96a$var$__rest(props, [
        "calendarType",
        "formatShortWeekday",
        "formatWeekday",
        "onClickWeekNumber",
        "showWeekNumbers"
    ]);
    function renderWeekdays() {
        return (0, $lBpE3.jsx)((0, $3abc3146f467f8e1$export$2e2bcd8739ae039), {
            calendarType: calendarType,
            formatShortWeekday: formatShortWeekday,
            formatWeekday: formatWeekday,
            locale: locale,
            onMouseLeave: onMouseLeave
        });
    }
    function renderWeekNumbers() {
        if (!showWeekNumbers) return null;
        return (0, $lBpE3.jsx)((0, $d8e178863735bdae$export$2e2bcd8739ae039), {
            activeStartDate: activeStartDate,
            calendarType: calendarType,
            onClickWeekNumber: onClickWeekNumber,
            onMouseLeave: onMouseLeave,
            showFixedNumberOfWeeks: showFixedNumberOfWeeks
        });
    }
    function renderDays() {
        return (0, $lBpE3.jsx)((0, $d7d08c8febb6466c$export$2e2bcd8739ae039), $fdabbd2f395eb96a$var$__assign({
            calendarType: calendarType
        }, childProps));
    }
    var className = 'react-calendar__month-view';
    return (0, $lBpE3.jsx)("div", {
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)(className, showWeekNumbers ? "".concat(className, "--weekNumbers") : ''),
        children: (0, $lBpE3.jsxs)("div", {
            style: {
                display: 'flex',
                alignItems: 'flex-end'
            },
            children: [
                renderWeekNumbers(),
                (0, $lBpE3.jsxs)("div", {
                    style: {
                        flexGrow: 1,
                        width: '100%'
                    },
                    children: [
                        renderWeekdays(),
                        renderDays()
                    ]
                })
            ]
        })
    });
}




'use client';
var $23ae35e3a266cd09$var$__assign = undefined && undefined.__assign || function() {
    $23ae35e3a266cd09$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $23ae35e3a266cd09$var$__assign.apply(this, arguments);
};
var $23ae35e3a266cd09$var$baseClassName = 'react-calendar';
var $23ae35e3a266cd09$var$allViews = [
    'century',
    'decade',
    'year',
    'month'
];
var $23ae35e3a266cd09$var$allValueTypes = [
    'decade',
    'year',
    'month',
    'day'
];
var $23ae35e3a266cd09$var$defaultMinDate = new Date();
$23ae35e3a266cd09$var$defaultMinDate.setFullYear(1, 0, 1);
$23ae35e3a266cd09$var$defaultMinDate.setHours(0, 0, 0, 0);
var $23ae35e3a266cd09$var$defaultMaxDate = new Date(8.64e15);
function $23ae35e3a266cd09$var$toDate(value) {
    if (value instanceof Date) return value;
    return new Date(value);
}
/**
 * Returns views array with disallowed values cut off.
 */ function $23ae35e3a266cd09$var$getLimitedViews(minDetail, maxDetail) {
    return $23ae35e3a266cd09$var$allViews.slice($23ae35e3a266cd09$var$allViews.indexOf(minDetail), $23ae35e3a266cd09$var$allViews.indexOf(maxDetail) + 1);
}
/**
 * Determines whether a given view is allowed with currently applied settings.
 */ function $23ae35e3a266cd09$var$isViewAllowed(view, minDetail, maxDetail) {
    var views = $23ae35e3a266cd09$var$getLimitedViews(minDetail, maxDetail);
    return views.indexOf(view) !== -1;
}
/**
 * Gets either provided view if allowed by minDetail and maxDetail, or gets
 * the default view if not allowed.
 */ function $23ae35e3a266cd09$var$getView(view, minDetail, maxDetail) {
    if (!view) return maxDetail;
    if ($23ae35e3a266cd09$var$isViewAllowed(view, minDetail, maxDetail)) return view;
    return maxDetail;
}
/**
 * Returns value type that can be returned with currently applied settings.
 */ function $23ae35e3a266cd09$var$getValueType(view) {
    var index = $23ae35e3a266cd09$var$allViews.indexOf(view);
    return $23ae35e3a266cd09$var$allValueTypes[index];
}
function $23ae35e3a266cd09$var$getValue(value, index) {
    var rawValue = Array.isArray(value) ? value[index] : value;
    if (!rawValue) return null;
    var valueDate = $23ae35e3a266cd09$var$toDate(rawValue);
    if (Number.isNaN(valueDate.getTime())) throw new Error("Invalid date: ".concat(value));
    return valueDate;
}
function $23ae35e3a266cd09$var$getDetailValue(_a, index) {
    var value = _a.value, minDate = _a.minDate, maxDate = _a.maxDate, maxDetail = _a.maxDetail;
    var valuePiece = $23ae35e3a266cd09$var$getValue(value, index);
    if (!valuePiece) return null;
    var valueType = $23ae35e3a266cd09$var$getValueType(maxDetail);
    var detailValueFrom = function() {
        switch(index){
            case 0:
                return (0, $95358a6a51be7b32$export$700a64ae37cbc741)(valueType, valuePiece);
            case 1:
                return (0, $95358a6a51be7b32$export$946298ccd438a697)(valueType, valuePiece);
            default:
                throw new Error("Invalid index value: ".concat(index));
        }
    }();
    return (0, $61ee086d3773f64e$export$cf95c51b03f10bae)(detailValueFrom, minDate, maxDate);
}
var $23ae35e3a266cd09$var$getDetailValueFrom = function(args) {
    return $23ae35e3a266cd09$var$getDetailValue(args, 0);
};
var $23ae35e3a266cd09$var$getDetailValueTo = function(args) {
    return $23ae35e3a266cd09$var$getDetailValue(args, 1);
};
var $23ae35e3a266cd09$var$getDetailValueArray = function(args) {
    return [
        $23ae35e3a266cd09$var$getDetailValueFrom,
        $23ae35e3a266cd09$var$getDetailValueTo
    ].map(function(fn) {
        return fn(args);
    });
};
function $23ae35e3a266cd09$var$getActiveStartDate(_a) {
    var maxDate = _a.maxDate, maxDetail = _a.maxDetail, minDate = _a.minDate, minDetail = _a.minDetail, value = _a.value, view = _a.view;
    var rangeType = $23ae35e3a266cd09$var$getView(view, minDetail, maxDetail);
    var valueFrom = $23ae35e3a266cd09$var$getDetailValueFrom({
        value: value,
        minDate: minDate,
        maxDate: maxDate,
        maxDetail: maxDetail
    }) || new Date();
    return (0, $95358a6a51be7b32$export$700a64ae37cbc741)(rangeType, valueFrom);
}
function $23ae35e3a266cd09$var$getInitialActiveStartDate(_a) {
    var activeStartDate = _a.activeStartDate, defaultActiveStartDate = _a.defaultActiveStartDate, defaultValue = _a.defaultValue, defaultView = _a.defaultView, maxDate = _a.maxDate, maxDetail = _a.maxDetail, minDate = _a.minDate, minDetail = _a.minDetail, value = _a.value, view = _a.view;
    var rangeType = $23ae35e3a266cd09$var$getView(view, minDetail, maxDetail);
    var valueFrom = activeStartDate || defaultActiveStartDate;
    if (valueFrom) return (0, $95358a6a51be7b32$export$700a64ae37cbc741)(rangeType, valueFrom);
    return $23ae35e3a266cd09$var$getActiveStartDate({
        maxDate: maxDate,
        maxDetail: maxDetail,
        minDate: minDate,
        minDetail: minDetail,
        value: value || defaultValue,
        view: view || defaultView
    });
}
function $23ae35e3a266cd09$var$getIsSingleValue(value) {
    return value && (!Array.isArray(value) || value.length === 1);
}
function $23ae35e3a266cd09$var$areDatesEqual(date1, date2) {
    return date1 instanceof Date && date2 instanceof Date && date1.getTime() === date2.getTime();
}
var $23ae35e3a266cd09$var$Calendar = (0, $6cds3.forwardRef)(function Calendar(props, ref) {
    var activeStartDateProps = props.activeStartDate, allowPartialRange = props.allowPartialRange, calendarType = props.calendarType, className = props.className, defaultActiveStartDate = props.defaultActiveStartDate, defaultValue = props.defaultValue, defaultView = props.defaultView, formatDay = props.formatDay, formatLongDate = props.formatLongDate, formatMonth = props.formatMonth, formatMonthYear = props.formatMonthYear, formatShortWeekday = props.formatShortWeekday, formatWeekday = props.formatWeekday, formatYear = props.formatYear, _a = props.goToRangeStartOnSelect, goToRangeStartOnSelect = _a === void 0 ? true : _a, inputRef = props.inputRef, locale = props.locale, _b = props.maxDate, maxDate = _b === void 0 ? $23ae35e3a266cd09$var$defaultMaxDate : _b, _c = props.maxDetail, maxDetail = _c === void 0 ? 'month' : _c, _d = props.minDate, minDate = _d === void 0 ? $23ae35e3a266cd09$var$defaultMinDate : _d, _e = props.minDetail, minDetail = _e === void 0 ? 'century' : _e, navigationAriaLabel = props.navigationAriaLabel, navigationAriaLive = props.navigationAriaLive, navigationLabel = props.navigationLabel, next2AriaLabel = props.next2AriaLabel, next2Label = props.next2Label, nextAriaLabel = props.nextAriaLabel, nextLabel = props.nextLabel, onActiveStartDateChange = props.onActiveStartDateChange, onChangeProps = props.onChange, onClickDay = props.onClickDay, onClickDecade = props.onClickDecade, onClickMonth = props.onClickMonth, onClickWeekNumber = props.onClickWeekNumber, onClickYear = props.onClickYear, onDrillDown = props.onDrillDown, onDrillUp = props.onDrillUp, onViewChange = props.onViewChange, prev2AriaLabel = props.prev2AriaLabel, prev2Label = props.prev2Label, prevAriaLabel = props.prevAriaLabel, prevLabel = props.prevLabel, _f = props.returnValue, returnValue = _f === void 0 ? 'start' : _f, selectRange = props.selectRange, showDoubleView = props.showDoubleView, showFixedNumberOfWeeks = props.showFixedNumberOfWeeks, _g = props.showNavigation, showNavigation = _g === void 0 ? true : _g, showNeighboringCentury = props.showNeighboringCentury, showNeighboringDecade = props.showNeighboringDecade, _h = props.showNeighboringMonth, showNeighboringMonth = _h === void 0 ? true : _h, showWeekNumbers = props.showWeekNumbers, tileClassName = props.tileClassName, tileContent = props.tileContent, tileDisabled = props.tileDisabled, valueProps = props.value, viewProps = props.view;
    var _j = (0, $6cds3.useState)(defaultActiveStartDate), activeStartDateState = _j[0], setActiveStartDateState = _j[1];
    var _k = (0, $6cds3.useState)(null), hoverState = _k[0], setHoverState = _k[1];
    var _l = (0, $6cds3.useState)(Array.isArray(defaultValue) ? defaultValue.map(function(el) {
        return el !== null ? $23ae35e3a266cd09$var$toDate(el) : null;
    }) : defaultValue !== null && defaultValue !== undefined ? $23ae35e3a266cd09$var$toDate(defaultValue) : null), valueState = _l[0], setValueState = _l[1];
    var _m = (0, $6cds3.useState)(defaultView), viewState = _m[0], setViewState = _m[1];
    var activeStartDate = activeStartDateProps || activeStartDateState || $23ae35e3a266cd09$var$getInitialActiveStartDate({
        activeStartDate: activeStartDateProps,
        defaultActiveStartDate: defaultActiveStartDate,
        defaultValue: defaultValue,
        defaultView: defaultView,
        maxDate: maxDate,
        maxDetail: maxDetail,
        minDate: minDate,
        minDetail: minDetail,
        value: valueProps,
        view: viewProps
    });
    var value = function() {
        var rawValue = function() {
            // In the middle of range selection, use value from state
            if (selectRange && $23ae35e3a266cd09$var$getIsSingleValue(valueState)) return valueState;
            return valueProps !== undefined ? valueProps : valueState;
        }();
        if (!rawValue) return null;
        return Array.isArray(rawValue) ? rawValue.map(function(el) {
            return el !== null ? $23ae35e3a266cd09$var$toDate(el) : null;
        }) : rawValue !== null ? $23ae35e3a266cd09$var$toDate(rawValue) : null;
    }();
    var valueType = $23ae35e3a266cd09$var$getValueType(maxDetail);
    var view = $23ae35e3a266cd09$var$getView(viewProps || viewState, minDetail, maxDetail);
    var views = $23ae35e3a266cd09$var$getLimitedViews(minDetail, maxDetail);
    var hover = selectRange ? hoverState : null;
    var drillDownAvailable = views.indexOf(view) < views.length - 1;
    var drillUpAvailable = views.indexOf(view) > 0;
    var getProcessedValue = (0, $6cds3.useCallback)(function(value) {
        var processFunction = function() {
            switch(returnValue){
                case 'start':
                    return $23ae35e3a266cd09$var$getDetailValueFrom;
                case 'end':
                    return $23ae35e3a266cd09$var$getDetailValueTo;
                case 'range':
                    return $23ae35e3a266cd09$var$getDetailValueArray;
                default:
                    throw new Error('Invalid returnValue.');
            }
        }();
        return processFunction({
            maxDate: maxDate,
            maxDetail: maxDetail,
            minDate: minDate,
            value: value
        });
    }, [
        maxDate,
        maxDetail,
        minDate,
        returnValue
    ]);
    var setActiveStartDate = (0, $6cds3.useCallback)(function(nextActiveStartDate, action) {
        setActiveStartDateState(nextActiveStartDate);
        var args = {
            action: action,
            activeStartDate: nextActiveStartDate,
            value: value,
            view: view
        };
        if (onActiveStartDateChange && !$23ae35e3a266cd09$var$areDatesEqual(activeStartDate, nextActiveStartDate)) onActiveStartDateChange(args);
    }, [
        activeStartDate,
        onActiveStartDateChange,
        value,
        view
    ]);
    var onClickTile = (0, $6cds3.useCallback)(function(value, event) {
        var callback = function() {
            switch(view){
                case 'century':
                    return onClickDecade;
                case 'decade':
                    return onClickYear;
                case 'year':
                    return onClickMonth;
                case 'month':
                    return onClickDay;
                default:
                    throw new Error("Invalid view: ".concat(view, "."));
            }
        }();
        if (callback) callback(value, event);
    }, [
        onClickDay,
        onClickDecade,
        onClickMonth,
        onClickYear,
        view
    ]);
    var drillDown = (0, $6cds3.useCallback)(function(nextActiveStartDate, event) {
        if (!drillDownAvailable) return;
        onClickTile(nextActiveStartDate, event);
        var nextView = views[views.indexOf(view) + 1];
        if (!nextView) throw new Error('Attempted to drill down from the lowest view.');
        setActiveStartDateState(nextActiveStartDate);
        setViewState(nextView);
        var args = {
            action: 'drillDown',
            activeStartDate: nextActiveStartDate,
            value: value,
            view: nextView
        };
        if (onActiveStartDateChange && !$23ae35e3a266cd09$var$areDatesEqual(activeStartDate, nextActiveStartDate)) onActiveStartDateChange(args);
        if (onViewChange && view !== nextView) onViewChange(args);
        if (onDrillDown) onDrillDown(args);
    }, [
        activeStartDate,
        drillDownAvailable,
        onActiveStartDateChange,
        onClickTile,
        onDrillDown,
        onViewChange,
        value,
        view,
        views
    ]);
    var drillUp = (0, $6cds3.useCallback)(function() {
        if (!drillUpAvailable) return;
        var nextView = views[views.indexOf(view) - 1];
        if (!nextView) throw new Error('Attempted to drill up from the highest view.');
        var nextActiveStartDate = (0, $95358a6a51be7b32$export$700a64ae37cbc741)(nextView, activeStartDate);
        setActiveStartDateState(nextActiveStartDate);
        setViewState(nextView);
        var args = {
            action: 'drillUp',
            activeStartDate: nextActiveStartDate,
            value: value,
            view: nextView
        };
        if (onActiveStartDateChange && !$23ae35e3a266cd09$var$areDatesEqual(activeStartDate, nextActiveStartDate)) onActiveStartDateChange(args);
        if (onViewChange && view !== nextView) onViewChange(args);
        if (onDrillUp) onDrillUp(args);
    }, [
        activeStartDate,
        drillUpAvailable,
        onActiveStartDateChange,
        onDrillUp,
        onViewChange,
        value,
        view,
        views
    ]);
    var onChange = (0, $6cds3.useCallback)(function(rawNextValue, event) {
        var previousValue = value;
        onClickTile(rawNextValue, event);
        var isFirstValueInRange = selectRange && !$23ae35e3a266cd09$var$getIsSingleValue(previousValue);
        var nextValue;
        if (selectRange) {
            // Range selection turned on
            if (isFirstValueInRange) // Value has 0 or 2 elements - either way we're starting a new array
            // First value
            nextValue = (0, $95358a6a51be7b32$export$700a64ae37cbc741)(valueType, rawNextValue);
            else {
                if (!previousValue) throw new Error('previousValue is required');
                if (Array.isArray(previousValue)) throw new Error('previousValue must not be an array');
                // Second value
                nextValue = (0, $95358a6a51be7b32$export$3a3e6dbcaf74641d)(valueType, previousValue, rawNextValue);
            }
        } else // Range selection turned off
        nextValue = getProcessedValue(rawNextValue);
        var nextActiveStartDate = // Range selection turned off
        !selectRange || // Range selection turned on, first value
        isFirstValueInRange || // Range selection turned on, second value, goToRangeStartOnSelect toggled on
        goToRangeStartOnSelect ? $23ae35e3a266cd09$var$getActiveStartDate({
            maxDate: maxDate,
            maxDetail: maxDetail,
            minDate: minDate,
            minDetail: minDetail,
            value: nextValue,
            view: view
        }) : null;
        event.persist();
        setActiveStartDateState(nextActiveStartDate);
        setValueState(nextValue);
        var args = {
            action: 'onChange',
            activeStartDate: nextActiveStartDate,
            value: nextValue,
            view: view
        };
        if (onActiveStartDateChange && !$23ae35e3a266cd09$var$areDatesEqual(activeStartDate, nextActiveStartDate)) onActiveStartDateChange(args);
        if (onChangeProps) {
            if (selectRange) {
                var isSingleValue = $23ae35e3a266cd09$var$getIsSingleValue(nextValue);
                if (!isSingleValue) onChangeProps(nextValue || null, event);
                else if (allowPartialRange) {
                    if (Array.isArray(nextValue)) throw new Error('value must not be an array');
                    onChangeProps([
                        nextValue || null,
                        null
                    ], event);
                }
            } else onChangeProps(nextValue || null, event);
        }
    }, [
        activeStartDate,
        allowPartialRange,
        getProcessedValue,
        goToRangeStartOnSelect,
        maxDate,
        maxDetail,
        minDate,
        minDetail,
        onActiveStartDateChange,
        onChangeProps,
        onClickTile,
        selectRange,
        value,
        valueType,
        view
    ]);
    function onMouseOver(nextHover) {
        setHoverState(nextHover);
    }
    function onMouseLeave() {
        setHoverState(null);
    }
    (0, $6cds3.useImperativeHandle)(ref, function() {
        return {
            activeStartDate: activeStartDate,
            drillDown: drillDown,
            drillUp: drillUp,
            onChange: onChange,
            setActiveStartDate: setActiveStartDate,
            value: value,
            view: view
        };
    }, [
        activeStartDate,
        drillDown,
        drillUp,
        onChange,
        setActiveStartDate,
        value,
        view
    ]);
    function renderContent(next) {
        var currentActiveStartDate = next ? (0, $95358a6a51be7b32$export$19193c1f2d841d47)(view, activeStartDate) : (0, $95358a6a51be7b32$export$700a64ae37cbc741)(view, activeStartDate);
        var onClick = drillDownAvailable ? drillDown : onChange;
        var commonProps = {
            activeStartDate: currentActiveStartDate,
            hover: hover,
            locale: locale,
            maxDate: maxDate,
            minDate: minDate,
            onClick: onClick,
            onMouseOver: selectRange ? onMouseOver : undefined,
            tileClassName: tileClassName,
            tileContent: tileContent,
            tileDisabled: tileDisabled,
            value: value,
            valueType: valueType
        };
        switch(view){
            case 'century':
                return (0, $lBpE3.jsx)((0, $25798cb1bda33c91$export$2e2bcd8739ae039), $23ae35e3a266cd09$var$__assign({
                    formatYear: formatYear,
                    showNeighboringCentury: showNeighboringCentury
                }, commonProps));
            case 'decade':
                return (0, $lBpE3.jsx)((0, $e2fc7de71b5f02cb$export$2e2bcd8739ae039), $23ae35e3a266cd09$var$__assign({
                    formatYear: formatYear,
                    showNeighboringDecade: showNeighboringDecade
                }, commonProps));
            case 'year':
                return (0, $lBpE3.jsx)((0, $404dfbcd85bfaddc$export$2e2bcd8739ae039), $23ae35e3a266cd09$var$__assign({
                    formatMonth: formatMonth,
                    formatMonthYear: formatMonthYear
                }, commonProps));
            case 'month':
                return (0, $lBpE3.jsx)((0, $fdabbd2f395eb96a$export$2e2bcd8739ae039), $23ae35e3a266cd09$var$__assign({
                    calendarType: calendarType,
                    formatDay: formatDay,
                    formatLongDate: formatLongDate,
                    formatShortWeekday: formatShortWeekday,
                    formatWeekday: formatWeekday,
                    onClickWeekNumber: onClickWeekNumber,
                    onMouseLeave: selectRange ? onMouseLeave : undefined,
                    showFixedNumberOfWeeks: typeof showFixedNumberOfWeeks !== 'undefined' ? showFixedNumberOfWeeks : showDoubleView,
                    showNeighboringMonth: showNeighboringMonth,
                    showWeekNumbers: showWeekNumbers
                }, commonProps));
            default:
                throw new Error("Invalid view: ".concat(view, "."));
        }
    }
    function renderNavigation() {
        if (!showNavigation) return null;
        return (0, $lBpE3.jsx)((0, $55737e1d85a8bba5$export$2e2bcd8739ae039), {
            activeStartDate: activeStartDate,
            drillUp: drillUp,
            formatMonthYear: formatMonthYear,
            formatYear: formatYear,
            locale: locale,
            maxDate: maxDate,
            minDate: minDate,
            navigationAriaLabel: navigationAriaLabel,
            navigationAriaLive: navigationAriaLive,
            navigationLabel: navigationLabel,
            next2AriaLabel: next2AriaLabel,
            next2Label: next2Label,
            nextAriaLabel: nextAriaLabel,
            nextLabel: nextLabel,
            prev2AriaLabel: prev2AriaLabel,
            prev2Label: prev2Label,
            prevAriaLabel: prevAriaLabel,
            prevLabel: prevLabel,
            setActiveStartDate: setActiveStartDate,
            showDoubleView: showDoubleView,
            view: view,
            views: views
        });
    }
    var valueArray = Array.isArray(value) ? value : [
        value
    ];
    return (0, $lBpE3.jsxs)("div", {
        className: (0, $7ea79c0838f0a9da$export$2e2bcd8739ae039)($23ae35e3a266cd09$var$baseClassName, selectRange && valueArray.length === 1 && "".concat($23ae35e3a266cd09$var$baseClassName, "--selectRange"), showDoubleView && "".concat($23ae35e3a266cd09$var$baseClassName, "--doubleView"), className),
        ref: inputRef,
        children: [
            renderNavigation(),
            (0, $lBpE3.jsxs)("div", {
                className: "".concat($23ae35e3a266cd09$var$baseClassName, "__viewContainer"),
                onBlur: selectRange ? onMouseLeave : undefined,
                onMouseLeave: selectRange ? onMouseLeave : undefined,
                children: [
                    renderContent(),
                    showDoubleView ? renderContent(true) : null
                ]
            })
        ]
    });
});
var $23ae35e3a266cd09$export$2e2bcd8739ae039 = $23ae35e3a266cd09$var$Calendar;







var $ae38c732148a79a8$export$2e2bcd8739ae039 = (0, $23ae35e3a266cd09$export$2e2bcd8739ae039);



var $kybuc = parcelRequire("kybuc");

var $3G7m1 = parcelRequire("3G7m1");
const $ae6da4c629a61795$var$FilterDate = ({ sport: sport = "football", dictionary: dictionary = {}, setDate: setDate, date: date, setIsLive: setIsLive, isLive: isLive, dataClient: dataClient, websiteBaseUrl: websiteBaseUrl = false, dataPath: dataPath })=>{
    const [showCalendar, setShowCalendar] = (0, $6cds3.useState)(false);
    const [value, setValue] = (0, $6cds3.useState)((0, $3G7m1.getCurrentDate)());
    const calendarRef = (0, $6cds3.useRef)(null);
    const todayDate = new Date().toISOString().split("T")[0];
    const nextDates = (0, $3G7m1.getNextSevenDays)(dictionary);
    const normalizedSport = (0, $3G7m1.normalizeSport)(sport);
    const handleChange = (selectedDate)=>{
        const formatted = (0, $kybuc.DateUtility)?.ConvertDate(selectedDate);
        if (dataClient) redirectToDate(formatted);
        else {
            setValue(selectedDate);
            setDate(formatted);
            setShowCalendar(false);
            setIsLive(false);
        }
    };
    const handleLiveClick = ()=>{
        if (dataClient) redirectToDate("live");
        else {
            setIsLive(true);
            setDate(todayDate);
        }
    };
    const redirectToDate = (slug)=>{
        const url = (0, $3G7m1.makeDateUrl)({
            websiteBaseUrl: websiteBaseUrl,
            dataPath: dataPath,
            sport: normalizedSport,
            slug: slug
        });
        window.location.href = url;
    };
    (0, $6cds3.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (calendarRef.current && !calendarRef.current.contains(event.target)) setShowCalendar(false);
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "days_nav_wrap",
        ref: calendarRef,
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: `live_btn_link ${isLive === "true" ? "active" : ""}`,
                onClick: handleLiveClick,
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("i", {
                        className: "ico_live"
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        children: dictionary?.live || "Live"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                className: "days_nav",
                children: nextDates.map(({ slugDate: slugDate, day: day, date: label }, index)=>{
                    const isActive = slugDate === date;
                    const handleDateClick = ()=>{
                        if (dataClient) redirectToDate(slugDate);
                        else {
                            setDate(slugDate);
                            setIsLive(false);
                        }
                    };
                    return /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                            className: isActive ? isLive === 'true' ? "today" : "active" : "test",
                            onClick: handleDateClick,
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                    className: "day",
                                    children: dictionary?.[day.toLowerCase()] || day
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                    className: "date",
                                    children: label
                                })
                            ]
                        })
                    }, index);
                })
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                className: "calendar_opener",
                onClick: ()=>setShowCalendar(!showCalendar),
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("i", {
                    className: "ico_calendar"
                })
            }),
            showCalendar && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ae38c732148a79a8$export$2e2bcd8739ae039), {
                onChange: handleChange,
                className: "calendar_container",
                value: value,
                prev2Label: null,
                next2Label: null,
                minDetail: "month"
            })
        ]
    });
};
var $ae6da4c629a61795$export$2e2bcd8739ae039 = $ae6da4c629a61795$var$FilterDate;





var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");


var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $3G7m1 = parcelRequire("3G7m1");

var $kybuc = parcelRequire("kybuc");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $ba5nK = parcelRequire("ba5nK");

var $3G7m1 = parcelRequire("3G7m1");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $kybuc = parcelRequire("kybuc");
const $899c41275de4426f$var$GolfTimeConverter = ({ timeValue: timeValue })=>{
    const isValidDateString = (value)=>{
        if (typeof value !== 'string') return false;
        const isoString = value.replace(' ', 'T') + 'Z';
        const date = new Date(isoString);
        return !isNaN(date.getTime());
    };
    const formattedTime = isValidDateString(timeValue) ? (0, $kybuc.DateUtility)?.FormatTime(timeValue?.replace(' ', 'T') + 'Z') : timeValue;
    return /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
        children: formattedTime
    });
};
var $899c41275de4426f$export$2e2bcd8739ae039 = $899c41275de4426f$var$GolfTimeConverter;


const $55e257430c2889be$var$GolfMatch = ({ data: data, sport: sport = "golf", websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataClient: dataClient })=>{
    const baseURL = "https://ipublisher-microservices.6lgx.com" ?? "https://ipublisher-microservices.6lgx.com";
    const numEntries = 4;
    const entries = data?.scores?.slice(0, numEntries);
    const placeholders = Array(numEntries - entries.length).fill("-");
    const allEntries = [
        ...entries,
        ...placeholders
    ];
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                children: data?.pos || "-"
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: "country_name_wrp",
                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("a", {
                        href: (0, $3G7m1.teamLeagueInfoUrl)({
                            dataClient: dataClient,
                            websiteBaseUrl: websiteBaseUrl,
                            dataPath: dataPath,
                            category: "player",
                            sport: sport,
                            name: (0, $3G7m1.titleToSlug)(data?.nm),
                            id: data?.id,
                            tab: 'player-card'
                        }),
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: "flag_img",
                                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                    src: `${baseURL}/assets/images/flags/country_${data?.fid}.png`,
                                    width: 22,
                                    height: 22
                                })
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                className: "cr_name",
                                children: [
                                    data?.nm,
                                    "."
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                children: data?.par || "-"
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $899c41275de4426f$export$2e2bcd8739ae039), {
                timeValue: data?.teet
            }),
            allEntries?.map((entry, index)=>/*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                    children: entry.ft || "-"
                }, (0, $3G7m1.uniqueId)(index))),
            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                children: data?.strk
            })
        ]
    });
};
var $55e257430c2889be$export$2e2bcd8739ae039 = $55e257430c2889be$var$GolfMatch;


const $522b7f2f1386103b$var$GolfListTable = ({ data: data, index: index, sport: sport = "golf", websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataClient: dataClient })=>{
    const HeadingTag = index === 0 ? "h1" : "h2";
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "golf_block",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "golf_head",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                    href: (0, $3G7m1.teamLeagueInfoUrl)({
                        dataClient: dataClient,
                        websiteBaseUrl: websiteBaseUrl,
                        dataPath: dataPath,
                        category: "league",
                        sport: sport,
                        name: (0, $3G7m1.titleToSlug)(data?.nm),
                        id: data?.id
                    }),
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)(HeadingTag, {
                        children: `${data?.nm}`
                    })
                })
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "golf_head_table",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "section_lft",
                        children: (0, $kybuc.DateUtility)?.formatTo12HourTime(data?.st)
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("ul", {
                        className: "section_rgt",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                children: data?.par && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "rgt_text",
                                        children: `Par: ${data?.par}`
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                children: data?.prs && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "rgt_text",
                                        children: `Prize Money: ${data?.prs}`
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "global_table striped golf_listing_table",
                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "#"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "Player"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "P"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "T"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "R1"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "R2"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "R3"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "R4"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "STROKES"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {})
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                            children: data?.matches?.map((match, index)=>/*#__PURE__*/ (0, $lBpE3.jsx)((0, $55e257430c2889be$export$2e2bcd8739ae039), {
                                    data: match,
                                    count: index + 1,
                                    websiteBaseUrl: websiteBaseUrl,
                                    dataPath: dataPath,
                                    sport: sport,
                                    dataClient: dataClient
                                }, (0, $3G7m1.uniqueId)(index)))
                        })
                    ]
                })
            })
        ]
    });
};
var $522b7f2f1386103b$export$2e2bcd8739ae039 = $522b7f2f1386103b$var$GolfListTable;



var $3G7m1 = parcelRequire("3G7m1");

var $2bSDe = parcelRequire("2bSDe");
const $ac1fe2e4a51e05b1$var$GolfLeagueMatches = ({ data: data, difference: difference, loadCSS: loadCSS, dataClient: dataClient, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath = "golf", type: type = "golf", sport: sport = "golf", dictionary: dictionary = {} })=>{
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("golf");
    }, [
        loadCSS
    ]);
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "golf_listing",
        children: data?.length ? data?.map((tour, ind)=>/*#__PURE__*/ (0, $lBpE3.jsx)((0, $522b7f2f1386103b$export$2e2bcd8739ae039), {
                data: tour,
                index: ind,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                sport: sport,
                difference: difference,
                dataClient: dataClient
            }, (0, $3G7m1.uniqueId)(ind))) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {
            text: type === true ? 'There are no live games currently in progress' : 'No matches found'
        })
    });
};
var $ac1fe2e4a51e05b1$export$2e2bcd8739ae039 = $ac1fe2e4a51e05b1$var$GolfLeagueMatches;



var $2bSDe = parcelRequire("2bSDe");

var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");


var $2bSDe = parcelRequire("2bSDe");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $ba5nK = parcelRequire("ba5nK");
const $f04108642bc3a008$var$RaceInfoHeader = ({ courseName: courseName, country: country, numberOfRaces: numberOfRaces })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "leg_head",
        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("h2", {
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                    href: `/`,
                    type: "league",
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("i", {
                        className: "icon_flag",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                            src: `/assets/images/flags/${country?.toLowerCase().replace(/\s/g, "-") || "default"}.png`,
                            alt: `${country} flag`,
                            width: 22,
                            height: 22,
                            priority: false
                        })
                    })
                }),
                /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                    className: "des",
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                            className: "name",
                            children: courseName
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                            className: "sb_inf",
                            children: [
                                "(",
                                numberOfRaces,
                                " Races)"
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $f04108642bc3a008$export$2e2bcd8739ae039 = $f04108642bc3a008$var$RaceInfoHeader;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $3G7m1 = parcelRequire("3G7m1");

var $kybuc = parcelRequire("kybuc");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");
const $3db92c49e9d1693c$var$RaceCardItem = ({ race: race, lnk: lnk })=>{
    if (!race) return null;
    const { nm: nm = "Race Name", dis: dis = "", nor: nor = "", rc: rc = "" } = race;
    // const raceTime = time || "—";
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "race_card_item",
        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("a", {
            href: lnk,
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                    className: "desc",
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                            className: "desc_title",
                            children: nm
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                            className: "desc_sb_inf",
                            children: [
                                nor ? `${nor} Runners` : "",
                                rc ? `, ${rc}` : "",
                                dis ? `, ${dis}` : ""
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("i", {
                    className: "ico ico_right_arrow_bold"
                })
            ]
        })
    });
};
var $3db92c49e9d1693c$export$2e2bcd8739ae039 = $3db92c49e9d1693c$var$RaceCardItem;


const $ab97000809c6e439$var$RaceCard = ({ weather: weather, going: going, races: races, cnm: cnm, dt: dt, sport: sport, dataClient: dataClient, dataPath: dataPath, websiteBaseUrl: websiteBaseUrl })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "race_cards",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "race_cards_hd",
                children: [
                    going && /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                        className: "cards_hd_lft",
                        children: [
                            "Going: ",
                            going
                        ]
                    }),
                    weather && /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                        className: "cards_hd_rgt",
                        children: [
                            "Weather: ",
                            weather
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "race_cards_lst",
                children: races?.map((race, index)=>{
                    const basePath = websiteBaseUrl || "";
                    const pathSegment = dataPath || sport;
                    const lnk = dataClient ? `${basePath}/${pathSegment}/race-cards/${(0, $3G7m1.titleToSlug)(cnm)}/${(0, $kybuc.DateUtility).ConvertDate1(dt)}/${race?.meeting_id}/${race?.id}/${(0, $3G7m1.titleToSlug)(race?.nm)}` : '#';
                    return /*#__PURE__*/ (0, $lBpE3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Fragment, {
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3db92c49e9d1693c$export$2e2bcd8739ae039), {
                            race: race,
                            lnk: lnk
                        })
                    }, index);
                })
            })
        ]
    });
};
var $ab97000809c6e439$export$2e2bcd8739ae039 = $ab97000809c6e439$var$RaceCard;


// import "./RaceCards.scss";
const $6b95097cbff16598$var$RaceLeagueBox = ({ league: league, sport: sport, dataClient: dataClient, dataPath: dataPath, websiteBaseUrl: websiteBaseUrl })=>{
    const { races: races = [], cnm: cnm, go: go, dt: dt, nor: nor, co: co, wea: wea } = league;
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $f04108642bc3a008$export$2e2bcd8739ae039), {
                courseName: cnm,
                country: co,
                date: dt,
                numberOfRaces: nor
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ab97000809c6e439$export$2e2bcd8739ae039), {
                races: races,
                weather: wea,
                going: go,
                cnm: cnm,
                dt: dt,
                sport: sport,
                dataClient: dataClient,
                dataPath: dataPath,
                websiteBaseUrl: websiteBaseUrl
            })
        ]
    });
};
var $6b95097cbff16598$export$2e2bcd8739ae039 = $6b95097cbff16598$var$RaceLeagueBox;


// import "./RaceCards.scss";
const $37f0cda63bfcc771$var$RaceCards = ({ data: data = [], sport: sport, dataClient: dataClient, dataPath: dataPath, websiteBaseUrl: websiteBaseUrl })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "leg_wrp",
        children: data?.length > 0 ? data?.map((item, index)=>{
            return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "leg_box",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $6b95097cbff16598$export$2e2bcd8739ae039), {
                    league: item,
                    sport: sport,
                    dataClient: dataClient,
                    dataPath: dataPath,
                    websiteBaseUrl: websiteBaseUrl
                })
            }, index);
        }) : null
    });
};
var $37f0cda63bfcc771$export$2e2bcd8739ae039 = $37f0cda63bfcc771$var$RaceCards;


const $88d82327bc390cb2$var$HorseRacingLeagueMatches = ({ data: data, difference: difference, loadCSS: loadCSS, dataClient: dataClient, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath = "horse-racing", type: type = "horse-racing", sport: sport = "horse-racing", dictionary: dictionary = {} })=>{
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("horse-racing");
    }, [
        loadCSS
    ]);
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "golf_listing",
        children: data?.length ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $37f0cda63bfcc771$export$2e2bcd8739ae039), {
            data: data,
            sport: sport,
            dataClient: dataClient,
            dataPath: dataPath,
            websiteBaseUrl: websiteBaseUrl
        }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {
            text: type === true ? 'There are no live games currently in progress' : 'No matches found'
        })
    });
};
var $88d82327bc390cb2$export$2e2bcd8739ae039 = $88d82327bc390cb2$var$HorseRacingLeagueMatches;


const $3ff7d166fed572f5$var$MatchListing = ({ sport: sport, data: data, difference: difference, matchType: matchType, loadCSS: loadCSS, baseUrl: baseUrl, setDataId: setDataId, setDataType: setDataType, setHead: setHead, setDate: setDate, date: date, isLive: isLive, dataClient: dataClient, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, socketUrl: socketUrl = "", channel: channel = "IPUB", event: event = "FootballLiveMatches" })=>{
    const [isLoading, setIsLoading] = (0, $6cds3.useState)(false);
    const [clientData, setClientData] = (0, $6cds3.useState)([]);
    let [allowedLeagues, setAllowedLeagues] = (0, $6cds3.useState)([]);
    (0, $6cds3.useEffect)(()=>{
        const fetchTableData = async ()=>{
            try {
                const res = await fetch(`${baseUrl}/tenant-allow-leagues?sport=${sport}`, {
                    headers: {
                        Token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9"
                    }
                });
                if (!res.ok) throw new Error(res.statusText);
                const json = await res.json();
                setAllowedLeagues(json?.data || null);
            } catch (err) {
                console.error("Failed to fetch squad:", err);
            }
        };
        fetchTableData();
    }, [
        sport
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document?.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data?.data;
            setClientData(parsed || []);
        } catch (error) {
            console.error("Failed to parse client data:", error);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("livematchdetail");
    }, [
        loadCSS
    ]);
    const finalData = dataClient ? clientData : data;
    let sportComponent;
    switch(sport){
        case "football":
        case "rugby":
            sportComponent = /*#__PURE__*/ (0, $lBpE3.jsx)((0, $9ebb198b8b2c3337$export$2e2bcd8739ae039), {
                finalData: finalData,
                difference: difference,
                matchType: matchType,
                loadCSS: loadCSS,
                sport: sport,
                baseUrl: baseUrl,
                setDataId: setDataId,
                setDataType: setDataType,
                setHead: setHead,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                dataClient: dataClient,
                socketUrl: socketUrl,
                channel: channel,
                event: event,
                isLive: isLive,
                allowedLeagues: allowedLeagues
            });
            break;
        case "tennis":
        case "cricket":
        case "basketball":
        case "icehockey":
            sportComponent = /*#__PURE__*/ (0, $lBpE3.jsx)((0, $7d965bd65420c156$export$2e2bcd8739ae039), {
                finalData: finalData,
                difference: difference,
                matchType: matchType,
                loadCSS: loadCSS,
                sport: sport,
                baseUrl: baseUrl,
                setDataId: setDataId,
                setDataType: setDataType,
                setHead: setHead,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                dataClient: dataClient,
                socketUrl: socketUrl,
                allowedLeagues: allowedLeagues
            });
            break;
        case "golf":
            sportComponent = /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ac1fe2e4a51e05b1$export$2e2bcd8739ae039), {
                data: finalData,
                difference: difference,
                matchType: matchType,
                loadCSS: loadCSS,
                sport: sport,
                baseUrl: baseUrl,
                setDataId: setDataId,
                setDataType: setDataType,
                setHead: setHead,
                type: isLive,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                dataClient: dataClient
            });
            break;
        case "horseracing":
            sportComponent = /*#__PURE__*/ (0, $lBpE3.jsx)((0, $88d82327bc390cb2$export$2e2bcd8739ae039), {
                data: finalData,
                difference: difference,
                matchType: matchType,
                loadCSS: loadCSS,
                sport: sport,
                baseUrl: baseUrl,
                setDataId: setDataId,
                setDataType: setDataType,
                setHead: setHead,
                type: isLive,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                dataClient: dataClient
            });
            break;
        default:
            sportComponent = /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: "This Sport is currently Not Available"
            });
    }
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ae6da4c629a61795$export$2e2bcd8739ae039), {
                sport: sport,
                setIsLoading: setIsLoading,
                setDate: setDate,
                date: date,
                // setIsLive={setIsLive}
                isLive: isLive,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath
            }),
            sportComponent
        ]
    });
};
var $3ff7d166fed572f5$export$2e2bcd8739ae039 = $3ff7d166fed572f5$var$MatchListing;



const $79f81462860edff5$var$FootballWidgets = ({ dataId: dataId, dataType: dataType, sport: sport, difference: difference, head: head, data: data, headData: headData, baseUrl: baseUrl, loadCSS: loadCSS, setDataId: setDataId, setDataType: setDataType, setHead: setHead, setDate: setDate, date: date, setIsLive: setIsLive, isLive: isLive, dataClient: dataClient = false, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataTitle: dataTitle })=>{
    const props = {
        dataId: dataId,
        dataType: dataType,
        sport: sport,
        difference: difference,
        head: head,
        data: data,
        headData: headData,
        baseUrl: baseUrl,
        loadCSS: loadCSS,
        setDataId: setDataId,
        setDataType: setDataType,
        setHead: setHead,
        setDate: setDate,
        date: date,
        setIsLive: setIsLive,
        isLive: isLive,
        dataClient: dataClient,
        websiteBaseUrl: websiteBaseUrl,
        dataPath: dataPath,
        dataTitle: dataTitle
    };
    // Only run on client
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(()=>{
        const loadSettings = async ()=>{
            try {
                const res = await fetch(`${baseUrl}/settings`, {
                    headers: {
                        Token: undefined,
                        "Content-Type": "application/json",
                        Accept: "application/json"
                    }
                });
                if (!res.ok) throw new Error(res.statusText);
                const settings = await res.json();
                const cssVars = (0, $2d22661aa7fb4cf1$export$a964851a84ddc42f)(settings);
                const styleTag = document.createElement("style");
                styleTag.textContent = cssVars;
                document.head.appendChild(styleTag);
                document.querySelectorAll(".microservice-cont")?.forEach((el)=>el?.classList.add("hydrated"));
                // Cleanup in React.StrictMode / HMR
                return ()=>{
                    if (document.head.contains(styleTag)) document.head.removeChild(styleTag);
                };
            } catch (err) {
                console.error("\u26A0\uFE0F Failed to load dynamic CSS settings:", err);
            }
        };
        loadSettings();
    }, [
        baseUrl
    ]);
    // Routing to the right widget wrapper
    if (dataType?.startsWith("match")) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0b80bbeb30321bf8$export$2e2bcd8739ae039), {
        ...props,
        socketUrl: "https://socket-bolsaas.6lgx.com/"
    });
    if (dataType?.startsWith("league-") || dataType === "detailed-league-table" || dataType === "preview-league-table") return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $bfca3c622e7e75bf$export$2e2bcd8739ae039), {
        ...props
    });
    if (dataType?.startsWith("team-") || dataType?.startsWith("player-")) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $e56092a810c2f874$export$2e2bcd8739ae039), {
        ...props
    });
    if (dataType === "live-match-detail" || dataType === "live-centre") return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3ff7d166fed572f5$export$2e2bcd8739ae039), {
        sport: sport,
        data: data?.data,
        difference: difference,
        matchType: "all",
        loadCSS: loadCSS,
        baseUrl: baseUrl,
        dataType: dataType,
        setDataType: setDataType,
        setDataId: setDataId,
        setHead: setHead,
        setDate: setDate,
        date: date,
        setIsLive: setIsLive,
        isLive: isLive,
        dataClient: dataClient,
        websiteBaseUrl: websiteBaseUrl,
        dataPath: dataPath,
        socketUrl: "https://socket-bolsaas.6lgx.com/"
    });
    return /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
        children: "\u26A0\uFE0F Widget Not Found in football!"
    });
};
var $79f81462860edff5$export$2e2bcd8739ae039 = $79f81462860edff5$var$FootballWidgets;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");


var $3G7m1 = parcelRequire("3G7m1");

var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $ba5nK = parcelRequire("ba5nK");

var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");
const $e11abfa9b8f1d2b9$var$CountdownTimer = ({ targetDate: targetDate })=>{
    const calculateTimeLeft = ()=>{
        const now = new Date();
        const diff = new Date(targetDate) - now;
        if (diff <= 0) return {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0
        };
        const days = Math.floor(diff / 86400000);
        const hours = Math.floor(diff % 86400000 / 3600000);
        const minutes = Math.floor(diff % 3600000 / 60000);
        const seconds = Math.floor(diff % 60000 / 1000);
        return {
            days: days,
            hours: hours,
            minutes: minutes,
            seconds: seconds
        };
    };
    const [timeLeft, setTimeLeft] = (0, $6cds3.useState)(calculateTimeLeft);
    (0, $6cds3.useEffect)(()=>{
        const interval = setInterval(()=>{
            setTimeLeft(calculateTimeLeft());
        }, 1000);
        return ()=>clearInterval(interval); // Clean up the interval on component unmount
    }, []);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "counter_mian",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                className: "text",
                children: "Countdown to Kick off"
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("ul", {
                className: "countdown",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "countdown-number",
                                children: timeLeft.days
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "countdown-label",
                                children: "Days"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "countdown-number",
                                children: timeLeft.hours
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "countdown-label",
                                children: "Hours"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "countdown-number",
                                children: timeLeft.minutes
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "countdown-label",
                                children: "Mins"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "countdown-number",
                                children: timeLeft.seconds
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "countdown-label",
                                children: "Secs"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $e11abfa9b8f1d2b9$export$2e2bcd8739ae039 = $e11abfa9b8f1d2b9$var$CountdownTimer;



var $3G7m1 = parcelRequire("3G7m1");

const $bceb63835f1e2ba3$var$CricketMatchDetailHead = ({ data: data, sport: sport = "cricket", websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataClient: dataClient, dictionary: dictionary = {}, show_cricket_animation: show_cricket_animation, socketUrl: socketUrl, channel: channel, event: event })=>{
    const baseURL = "https://ipublisher-microservices.6lgx.com" ?? "https://ipublisher-microservices.6lgx.com";
    const [match, setMatch] = (0, $6cds3.useState)(data);
    const scores = [];
    const imageUrl = (0, $3G7m1.getMatchImageUrl)(sport, match?.competitors?.[sport === "tennis" ? "hpid" : "htid"]);
    const awayImage = (0, $3G7m1.getMatchImageUrl)(sport, match?.competitors?.[sport === "tennis" ? "apid" : "atid"]);
    if (sport === "basketball") for(let i = 1; i <= 4; i++)scores.push((0, $3G7m1.extractScores)(match, i));
    (0, $71a398d188e2be3b$export$69d32079ada77858)({
        socketUrl: socketUrl,
        channel: channel,
        event: event,
        sport: sport,
        setMatch: setMatch
    });
    (0, $6cds3.useEffect)(()=>{
        setMatch(data);
    }, [
        data
    ]);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "cricket_detail_head",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "detail_head_top",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: `${match?.bs === "Live" ? "stats_tag red" : "stats_tag"}`,
                        children: dictionary?.[match?.bs?.toLowerCase()] || match?.bs
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("a", {
                            href: (0, $3G7m1.teamLeagueInfoUrl)({
                                dataClient: dataClient,
                                websiteBaseUrl: websiteBaseUrl,
                                dataPath: dataPath,
                                category: "league",
                                sport: sport,
                                name: match?.tournament?.nm,
                                id: match?.tournament?.id
                            }),
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                    className: "icon_flag",
                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                        src: `${baseURL}/assets/images/flags/country_${match?.tournament?.football_category?.fid || match?.tournament?.fid}.png`,
                                        alt: "flag",
                                        width: 22,
                                        height: 22,
                                        priority: false
                                    })
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                    className: "name_wrp",
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                            className: "name",
                                            children: match?.tournament?.nm
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                            className: "sub_info_mtch",
                                            children: match?.mno
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            show_cricket_animation === 1 ? /*#__PURE__*/ (0, $lBpE3.jsx)("iframe", {
                className: "ifrmae-widget",
                src: `https://widgets.thesports01.com/en/cricket?profile=8nq2kc475czulqy&uuid=${match?.aimId}`,
                bis_size: '{"x":459,"y":249,"w":746,"h":520,"abs_x":459,"abs_y":249}',
                title: "Cricket Match Animation"
            }) : null,
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "detail_head_bdy",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "detail_bdy_inner",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("ul", {
                                className: "team_info",
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                className: "team_info_name",
                                                children: [
                                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("a", {
                                                        href: (0, $3G7m1.teamLeagueInfoUrl)({
                                                            dataClient: dataClient,
                                                            websiteBaseUrl: websiteBaseUrl,
                                                            dataPath: dataPath,
                                                            category: sport === 'tennis' ? 'player' : 'team',
                                                            sport: sport,
                                                            name: match?.competitors?.htn,
                                                            id: match?.competitors?.htid
                                                        }),
                                                        className: "team_name",
                                                        children: [
                                                            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                                className: "flag",
                                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                                    src: imageUrl,
                                                                    height: 30,
                                                                    width: 30,
                                                                    alt: "homeLogo",
                                                                    priority: false
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                className: "name",
                                                                children: match?.competitors?.htn
                                                            })
                                                        ]
                                                    }),
                                                    match?.bs === "Live" && (match?.batid === match?.competitors?.htid ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3G7m1.Icon), {
                                                        type: "bat",
                                                        src: `${baseURL}/assets/images/Bat1.png`,
                                                        width: 15,
                                                        height: 14,
                                                        alt: "bat"
                                                    }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3G7m1.Icon), {
                                                        type: "ball",
                                                        src: `${baseURL}/assets/images/cricket_Ball.png`,
                                                        width: 14,
                                                        height: 14,
                                                        alt: "ball"
                                                    }))
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                className: "team_info_score",
                                                children: [
                                                    match?.ho ? /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                        className: "over",
                                                        children: [
                                                            match?.ho,
                                                            " Ov "
                                                        ]
                                                    }) : null,
                                                    match?.hs
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                className: "team_info_name",
                                                children: [
                                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("a", {
                                                        href: (0, $3G7m1.teamLeagueInfoUrl)({
                                                            dataClient: dataClient,
                                                            websiteBaseUrl: websiteBaseUrl,
                                                            dataPath: dataPath,
                                                            category: sport === 'tennis' ? 'player' : 'team',
                                                            sport: sport,
                                                            name: match?.competitors?.atn,
                                                            id: match?.competitors?.atid
                                                        }),
                                                        className: "team_name",
                                                        children: [
                                                            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                                className: "flag",
                                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                                    src: awayImage,
                                                                    height: 30,
                                                                    width: 30,
                                                                    alt: "awayLogo",
                                                                    priority: false
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                className: "name",
                                                                children: match?.competitors?.atn
                                                            })
                                                        ]
                                                    }),
                                                    match?.bs === "Live" && (match?.batid === match?.competitors?.atid ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3G7m1.Icon), {
                                                        type: "bat",
                                                        src: `${baseURL}/assets/images/Bat1.png`,
                                                        width: 15,
                                                        height: 14,
                                                        alt: "bat"
                                                    }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3G7m1.Icon), {
                                                        type: "ball",
                                                        src: `${baseURL}/assets/images/cricket_Ball.png`,
                                                        width: 14,
                                                        height: 14,
                                                        alt: "ball"
                                                    }))
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                className: "team_info_score",
                                                children: [
                                                    match?.ao ? /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                        className: "over",
                                                        children: [
                                                            match?.ao,
                                                            " Ov "
                                                        ]
                                                    }) : null,
                                                    match?.as
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            match?.bs === "Scheduled" ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $e11abfa9b8f1d2b9$export$2e2bcd8739ae039), {
                                targetDate: match?.ldt
                            }) : null
                        ]
                    }),
                    (match?.bs === "Live" || match?.bs === "Delayed") && match?.stat !== "" ? /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "match_stats",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("p", {
                            children: match?.stat
                        })
                    }) : null,
                    match?.bs === "Finished" ? /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "detail_head_finsed",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: "match_stats_finsed",
                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("p", {
                                    children: match?.com
                                })
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: "match_stats_finsed",
                                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("ul", {
                                    className: "inf_mch",
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("i", {
                                                    className: "ico ico_calandar02"
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    children: match?.mno
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: "inf_mch_txt",
                                                children: (0, $3G7m1.convertDate)(match?.ldt)
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : null,
                    match?.bs === "Scheduled" ? /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "detail_head_finsed detail_head_upcomming",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                            className: "match_stats_finsed ",
                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("ul", {
                                className: "inf_mch",
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("i", {
                                                className: "ico ico_calandar02"
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                children: match?.mno
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                            className: "inf_mch_txt",
                                            children: (0, $3G7m1.convertDate)(match?.ldt)
                                        })
                                    })
                                ]
                            })
                        })
                    }) : null
                ]
            }),
            match?.bs === "Live" ? match?.rr || match?.rrr || match?.lforr || match?.resb?.length ? /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "detail_head_tft",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("ul", {
                        className: "runlist_inf",
                        children: [
                            match?.rr ? /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        children: "CRR:"
                                    }),
                                    match?.rr
                                ]
                            }) : null,
                            match?.rrr ? /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        children: "RRR:"
                                    }),
                                    " ",
                                    match?.rrr
                                ]
                            }) : null,
                            match?.lforr ? /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        children: "Last 5 ov (RR):"
                                    }),
                                    " ",
                                    match?.lforr
                                ]
                            }) : null
                        ]
                    }),
                    match?.resb?.length ? /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                        className: "ball_inf",
                        children: match?.resb?.map((item, index)=>{
                            const isLastBallOfOver = (over)=>{
                                const [, ballInOver] = over?.toString().split(".").map(Number);
                                return ballInOver === 6;
                            };
                            return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                        className: `${item?.d_score === "4" || item?.d_score === "6" ? "boundary" : item?.d_score === "W" ? "wicket" : ""}`,
                                        children: item?.d_score
                                    }, index),
                                    isLastBallOfOver(item?.over) && /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                        className: "change_over",
                                        children: "-"
                                    }, index + 100)
                                ]
                            });
                        })
                    }) : null
                ]
            }) : null : null
        ]
    });
};
var $bceb63835f1e2ba3$export$2e2bcd8739ae039 = $bceb63835f1e2ba3$var$CricketMatchDetailHead;


const $724589132fb1fe86$var$CricketMatchHead = ({ matchDetail: matchDetail, difference: difference, sport: sport, setDataId: setDataId, setDataType: setDataType, setHead: setHead, setLeagueId: setLeagueId, dataClient: dataClient, children: children, id: id, currentTab: currentTab, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, title: title, show_cricket_animation: show_cricket_animation, socketUrl: socketUrl, channel: channel, event: event })=>{
    const [clientHeadData, setClientHeadData] = (0, $6cds3.useState)(null);
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document.querySelector(".microservice-cont");
        const dataAttr = container?.getAttribute("data-listingdata");
        if (dataAttr) try {
            const parsed = JSON.parse(dataAttr)?.headData;
            setClientHeadData(parsed);
        } catch (error) {
            console.error("Failed to parse headData:", error);
        }
    }, [
        dataClient
    ]);
    const matchData = dataClient ? clientHeadData?.data : matchDetail?.data;
    const tabsData = dataClient ? clientHeadData?.tabs : matchDetail?.tabs;
    const referee = matchData?.match_official?.official?.name;
    const venue = matchData?.venue;
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "detail_page",
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "detail_head",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)((0, $bceb63835f1e2ba3$export$2e2bcd8739ae039), {
                        sport: sport,
                        data: matchData,
                        difference: difference,
                        referee: referee,
                        venue: venue,
                        setDataId: setDataId,
                        setDataType: setDataType,
                        setHead: setHead,
                        setLeagueId: setLeagueId,
                        websiteBaseUrl: websiteBaseUrl,
                        dataPath: dataPath,
                        dataClient: dataClient,
                        show_cricket_animation: show_cricket_animation,
                        socketUrl: socketUrl,
                        channel: channel,
                        event: event
                    }),
                    dataClient && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $4b47714d98d2fa0e$export$2e2bcd8739ae039), {
                        tabs: (0, $3G7m1.processMyArr)(tabsData) || [],
                        id: id,
                        currentTab: currentTab,
                        websiteBaseUrl: websiteBaseUrl,
                        dataPath: dataPath,
                        name: `${(0, $3G7m1.linkName)(matchData?.competitors?.htn)}-vs-${(0, $3G7m1.linkName)(matchData?.competitors?.atn)}`,
                        sport: sport
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "detail_page_tabs",
                children: children
            })
        ]
    });
};
var $724589132fb1fe86$export$2e2bcd8739ae039 = $724589132fb1fe86$var$CricketMatchHead;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $kybuc = parcelRequire("kybuc");

var $3G7m1 = parcelRequire("3G7m1");

var $2bSDe = parcelRequire("2bSDe");
// import "./Table.scss";
// import "./CricketInfoTable.scss";
const $cc5a7e25ee5750e6$var$CricketInfoTable = ({ ServerData: ServerData, difference: difference, dictionary: dictionary = {}, loadCSS: loadCSS = true, dataClient: dataClient = false, title: title })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    const data = dataClient ? clientData : ServerData;
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document?.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("cricketmatch");
    }, [
        loadCSS
    ]);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            title ? /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }) : null,
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "leg_head",
                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("h2", {
                            children: [
                                " ",
                                dictionary?.matchinfo || "Match Info"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "global_table cr_macth_info",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("table", {
                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: dictionary?.event || "Event"
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: data?.evt
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("td", {
                                                children: [
                                                    " ",
                                                    dictionary?.thismatch || "This Match"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: data?.type || "-"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("td", {
                                                children: [
                                                    " ",
                                                    dictionary?.starts || "Starts",
                                                    " (venue)"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("td", {
                                                children: [
                                                    (0, $3G7m1.convertDateTime)(data?.ldt),
                                                    ",",
                                                    (0, $kybuc.DateUtility).ConvertCETtoCurrentTimeZone(data?.ldt, difference)
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("td", {
                                                children: [
                                                    dictionary?.starts || "Starts",
                                                    " (GMT)"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("td", {
                                                children: [
                                                    (0, $3G7m1.convertDateTime)(data?.gdt),
                                                    ",",
                                                    (0, $kybuc.DateUtility).ConvertCETtoCurrentTimeZone(data?.gdt, difference)
                                                ]
                                            })
                                        ]
                                    }),
                                    data?.ts_win && /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: dictionary?.toss || "Toss"
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("td", {
                                                children: [
                                                    data?.ts_win,
                                                    " ",
                                                    dictionary?.wonthetossandchoseto || "won the toss and chose to",
                                                    " ",
                                                    data?.elc
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("td", {
                                                children: [
                                                    " ",
                                                    dictionary?.country || "Country"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: data?.stad?.ctry
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("td", {
                                                children: [
                                                    " ",
                                                    dictionary?.city || "City"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: data?.stad?.cty
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("td", {
                                                children: [
                                                    " ",
                                                    dictionary?.venue || "Venue"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: data?.stad?.nm
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("td", {
                                                children: [
                                                    " ",
                                                    dictionary?.umpire || "Umpire"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("td", {
                                                children: [
                                                    data?.match_umpires?.find((umpire)=>umpire.pos === "first")?.umpire?.nm || "-",
                                                    " ",
                                                    "\xa0",
                                                    data?.match_umpires?.find((umpire)=>umpire.pos === "second")?.umpire?.nm || "-"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("td", {
                                                children: [
                                                    " ",
                                                    dictionary?.tvumpire || "TV Umpire"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: data?.match_umpires?.find((umpire)=>umpire.pos === "tv_umpire")?.umpire?.nm || "-"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("td", {
                                                children: [
                                                    " ",
                                                    dictionary?.referee || "Referee",
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: data?.match_umpires?.find((umpire)=>umpire.pos === "referee")?.umpire?.nm || "-"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $cc5a7e25ee5750e6$export$2e2bcd8739ae039 = $cc5a7e25ee5750e6$var$CricketInfoTable;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");


var $ba5nK = parcelRequire("ba5nK");

var $2bSDe = parcelRequire("2bSDe");

var $6cds3 = parcelRequire("6cds3");

var $gtwOm = parcelRequire("gtwOm");
const $831550cdc4639fd0$export$c3fb10d1039348e = (socketUrl, matchId)=>{
    const [liveData, setLiveData] = (0, $6cds3.useState)(null);
    const socket = (0, $gtwOm.useSocket)(socketUrl);
    (0, $6cds3.useEffect)(()=>{
        if (socket && matchId) {
            const channelName = "CricketMatch";
            const eventName = `CricketMatchLive-${matchId}`;
            socket.channel(channelName).listen(eventName, (newData)=>{
                console.log("Socket data received:", newData);
                setLiveData(newData?.data?.data || null);
            });
            return ()=>{
                socket?.connector?.socket.disconnect();
            };
        }
    }, [
        socket,
        matchId
    ]);
    return liveData;
};


const $6153c5386be14844$var$LiveScoreCard = ({ ServerData: ServerData, loadCSS: loadCSS = true, dataClient: dataClient = false, title: title, socketUrl: socketUrl, matchId: matchId })=>{
    const baseURL = "https://ipublisher-microservices.6lgx.com" ?? "https://ipublisher-microservices.6lgx.com";
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    const matchData = dataClient ? clientData : ServerData;
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document?.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("cricketmatch");
    }, [
        loadCSS
    ]);
    const liveData = (0, $831550cdc4639fd0$export$c3fb10d1039348e)(socketUrl, matchId);
    const data = liveData ?? matchData;
    const hasData = data && (data?.active_bats?.length > 0 || data?.active_bowls?.length > 0);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            title ? /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }) : null,
            hasData ? /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "global_table cr_macth_scorecard live_sts",
                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                    children: "Batsman"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                    children: "R"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                    children: "B"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                    children: "4s"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                    children: "6s"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                    children: "SR"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                                    children: data?.active_bats?.map((player, i)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                            className: `${player?.ty === "Not Out" || player?.actv === 1 ? "not_out" : ""}`,
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                                        className: "bastman_td",
                                                        children: [
                                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                                className: "name",
                                                                children: [
                                                                    player?.player?.name,
                                                                    " ",
                                                                    player?.is_wick_k ? " (WK)" : null,
                                                                    player?.is_cap ? " (C)" : null,
                                                                    player?.actv === 1 ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                        className: "bat_ico",
                                                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                                            src: `${baseURL}/public/assets/images/Bat1.png`,
                                                                            width: 15,
                                                                            height: 14,
                                                                            alt: "bat"
                                                                        })
                                                                    }) : null
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                                className: "bow_inf",
                                                                children: [
                                                                    player?.fielder && ` ${player?.ty === "Catch OUT " ? "c " : "o "} ${player?.fielder?.nm} `,
                                                                    player?.ty,
                                                                    player?.bowler && ` b ${player?.bowler?.nm}`
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                        children: player?.sc
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                    children: player?.bls
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                    children: player?.fr
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                    children: player?.sx
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                    children: Number(player?.rr).toFixed(2)
                                                })
                                            ]
                                        }, i))
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "global_table cr_macth_scorecard live_sts",
                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                    children: "Bowlers"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                    children: "O"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                    children: "M"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                    children: "R"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                    children: "WD"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                    children: "ER"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                                    children: data?.active_bowls?.map((player, i)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                            className: `${player?.actv === 1 ? "not_out" : ""}`,
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                        className: "name",
                                                        children: [
                                                            player?.player?.name,
                                                            player?.actv === 1 ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                className: "bat_ico",
                                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                                    src: `${baseURL}/public/assets/images/cricket_Ball.png`,
                                                                    width: 14,
                                                                    height: 14,
                                                                    alt: "bat"
                                                                })
                                                            }) : null
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                    children: player?.ovs
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                    children: player?.mdns
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                    children: player?.sc
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                    children: player?.wckts
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                    children: Number(player?.rr).toFixed(2)
                                                })
                                            ]
                                        }, i))
                                })
                            ]
                        })
                    }),
                    data?.last_wicket ? /*#__PURE__*/ (0, $lBpE3.jsxs)("ul", {
                        className: "live_inf_sts",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                children: [
                                    "L\u2019bat: ",
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        children: `${data?.last_wicket?.batsman?.name} `
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                children: [
                                    "FoW:",
                                    " ",
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        children: `${data?.last_wicket?.sc} / ${data?.last_wicket?.num} (${data?.last_wicket?.bla} Ov) `
                                    })
                                ]
                            })
                        ]
                    }) : null
                ]
            }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {})
        ]
    });
};
var $6153c5386be14844$export$2e2bcd8739ae039 = $6153c5386be14844$var$LiveScoreCard;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $ba5nK = parcelRequire("ba5nK");

var $3G7m1 = parcelRequire("3G7m1");

var $2bSDe = parcelRequire("2bSDe");
const $57ae3d733cdaddd5$var$CricketStandings = ({ ServerData: ServerData, loadCSS: loadCSS = true, dataClient: dataClient = false, title: title, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, sport: sport = "cricket", dictionary: dictionary = {} })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    const data = dataClient ? clientData : ServerData;
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document?.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("cricketmatch");
    }, [
        loadCSS
    ]);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            title ? /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }) : null,
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "global_table cr_standing_table",
                children: data?.data?.length > 0 ? data?.data?.map((group, groupIndex)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                                className: "cr_title",
                                children: data.data.length < 2 ? "" : group[0]?.grp ?? `Group ${groupIndex + 1}`
                            }),
                            " ",
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                    children: "#"
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                        children: dictionary?.teams || "Teams"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                    children: "MP"
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                    children: "W"
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                    children: "D"
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                    children: "L"
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                    children: "TP"
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                    children: "PTS"
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                    children: dictionary?.form || "FORM"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                                        children: group.map((team, index)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                        children: index + 1
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                                                            href: (0, $3G7m1.teamLeagueInfoUrl)({
                                                                dataClient: dataClient,
                                                                websiteBaseUrl: websiteBaseUrl,
                                                                dataPath: dataPath,
                                                                category: "team",
                                                                sport: sport,
                                                                name: team?.tnm,
                                                                id: team?.tid
                                                            }),
                                                            className: "team_name",
                                                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                                                className: "bolar_team",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                                        className: "ico_flag",
                                                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                                            src: `https://cric.livescoring.cc/teamflags/${team?.tid}.png`,
                                                                            width: 22,
                                                                            height: 22
                                                                        }, team?.tid)
                                                                    }),
                                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                        className: "name",
                                                                        children: team?.tnm
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                        children: team?.mt
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                        children: team?.wo
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                        children: team?.dr
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                        children: team?.lo
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                        children: team?.pos
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                        children: team?.pts
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                                                            className: "prev_match_status",
                                                            children: team?.prem?.map((w, i)=>/*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                                                    className: w === "W" ? "win" : w === "D" ? "draw" : "loss",
                                                                    children: w
                                                                }, i))
                                                        })
                                                    })
                                                ]
                                            }, index))
                                    })
                                ]
                            })
                        ]
                    }, groupIndex)) : /*#__PURE__*/ (0, $lBpE3.jsx)("p", {
                    children: "No data Found..."
                })
            })
        ]
    });
};
var $57ae3d733cdaddd5$export$2e2bcd8739ae039 = $57ae3d733cdaddd5$var$CricketStandings;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");
const $811e55a24e3734b4$var$TestMatchTabs = ({ items: items, activeItem: activeItem, onClick: onClick })=>/*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
        className: "cr_tab_btns",
        children: items?.map((item)=>/*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                    className: `cr_tab_btn ${activeItem === item.value ? 'active' : ''}`,
                    onClick: ()=>onClick(item.value),
                    children: item.label
                })
            }, item.value))
    });
var $811e55a24e3734b4$export$2e2bcd8739ae039 = $811e55a24e3734b4$var$TestMatchTabs;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");


var $ba5nK = parcelRequire("ba5nK");

var $3G7m1 = parcelRequire("3G7m1");
const $7e0f7f2c3301f0f7$var$ScoreCard = ({ data: data, dictionary: dictionary, dataClient: dataClient = false, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, sport: sport = "cricket" })=>{
    const baseURL = "https://ipublisher-microservices.6lgx.com";
    const getPlayerUrl = (player)=>{
        if (!dataClient || !player?.player?.pid) return null;
        const basePath = websiteBaseUrl || "";
        const pathSegment = dataPath || (0, $3G7m1.getUrlSport)(sport);
        return `${basePath}/${pathSegment}/player/${(0, $3G7m1.linkName)(player?.player?.nm)}/${player?.player?.pid}/info`;
    };
    const hasData = data && (data.batting?.length > 0 || data.bowling?.length > 0);
    return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
        children: hasData ? /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: "global_table cr_macth_scorecard",
                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("strong", {
                                                children: [
                                                    dictionary?.batsman || "Batsman",
                                                    " "
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                children: "R"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                children: "B"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                children: "4s"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                children: "6s"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                children: "SR"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("tbody", {
                                children: [
                                    data?.batting?.map((player, i)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                            className: `${player?.ty === "Not Out" || player?.actv === 1 ? "not_out" : ""}`,
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                                        className: "bastman_td",
                                                        children: [
                                                            getPlayerUrl(player) ? /*#__PURE__*/ (0, $lBpE3.jsxs)("a", {
                                                                href: getPlayerUrl(player),
                                                                className: "name player-link",
                                                                children: [
                                                                    player?.player?.nm,
                                                                    " ",
                                                                    player?.is_wick_k ? " (WK)" : null,
                                                                    player?.is_cap ? " (C)" : null,
                                                                    player?.actv === 1 ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                        className: "bat_ico",
                                                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                                            src: `${baseURL}/public/assets/images/Bat1.png`,
                                                                            width: 15,
                                                                            height: 14,
                                                                            alt: "bat"
                                                                        })
                                                                    }) : null
                                                                ]
                                                            }) : /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                                className: "name",
                                                                children: [
                                                                    player?.player?.nm,
                                                                    " ",
                                                                    player?.is_wick_k ? " (WK)" : null,
                                                                    player?.is_cap ? " (C)" : null,
                                                                    player?.actv === 1 ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                        className: "bat_ico",
                                                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                                            src: `${baseURL}/public/assets/images/Bat1.png`,
                                                                            width: 15,
                                                                            height: 14,
                                                                            alt: "bat"
                                                                        })
                                                                    }) : null
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                                className: "bow_inf",
                                                                children: [
                                                                    player?.fielder && ` ${player?.ty === "Catch OUT " ? "c " : "o "} ${player?.fielder?.nm} `,
                                                                    player?.ty,
                                                                    player?.bowler && ` b ${player?.bowler?.nm}`
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                    children: player?.ft
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                    children: player?.bls
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                    children: player?.fr
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                    children: player?.sx
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                    children: Number(player?.rr).toFixed(2)
                                                })
                                            ]
                                        }, (0, $3G7m1.uniqueId)(i))),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            colSpan: 6,
                                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                                className: "toal_plyer_cr",
                                                children: [
                                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                                children: [
                                                                    " ",
                                                                    dictionary?.total || "Total",
                                                                    " :"
                                                                ]
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                                children: data?.sc
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                                children: [
                                                                    " ",
                                                                    dictionary?.extras || "Extras",
                                                                    ":"
                                                                ]
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                                children: data?.extr
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                children: "B:"
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                                children: data?.b
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                children: "LB:"
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                                children: data?.lb
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                children: "NB:"
                                                            }),
                                                            /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                                children: data?.nb
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                                children: "W:"
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                                children: data?.w
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: "global_table cr_macth_scorecard",
                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("strong", {
                                                children: [
                                                    " ",
                                                    dictionary?.bowlers || "Bowlers"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                children: "O"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                children: "M"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                children: "R"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                children: "W"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                children: "NB"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                children: "WD"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                children: "ER"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                                children: data?.bowling?.map((player, i)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                        className: `${player?.actv === 1 ? "not_out" : ""}`,
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: getPlayerUrl(player) ? /*#__PURE__*/ (0, $lBpE3.jsxs)("a", {
                                                    href: getPlayerUrl(player),
                                                    className: "name player-link",
                                                    children: [
                                                        player?.player?.nm,
                                                        player?.actv === 1 ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                            className: "bat_ico",
                                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                                src: `${baseURL}/public/assets/images/cricket_Ball.png`,
                                                                width: 14,
                                                                height: 14,
                                                                alt: "ball"
                                                            })
                                                        }) : null
                                                    ]
                                                }) : /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                    className: "name",
                                                    children: [
                                                        player?.player?.nm,
                                                        player?.actv === 1 ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                            className: "bat_ico",
                                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                                src: `${baseURL}/public/assets/images/cricket_Ball.png`,
                                                                width: 14,
                                                                height: 14,
                                                                alt: "ball"
                                                            })
                                                        }) : null
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: player?.ovs
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: player?.mdns
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: player?.ft
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: player?.nb
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: player?.wd
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: player?.wckts
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: Number(player?.rr).toFixed(2)
                                            })
                                        ]
                                    }, i))
                            })
                        ]
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {
            text: `${dictionary?.norecordfound || "no record found"}!`
        })
    });
};
var $7e0f7f2c3301f0f7$export$2e2bcd8739ae039 = $7e0f7f2c3301f0f7$var$ScoreCard;



var $2bSDe = parcelRequire("2bSDe");

var $6cds3 = parcelRequire("6cds3");

var $gtwOm = parcelRequire("gtwOm");
const $e41dd628d48b4717$export$bec3e352ce3caf85 = (socketUrl, matchId)=>{
    const [scorecardData, setScorecardData] = (0, $6cds3.useState)(null);
    const socket = (0, $gtwOm.useSocket)(socketUrl);
    (0, $6cds3.useEffect)(()=>{
        if (socket && matchId) {
            console.log("Cricket Scorecard socket connected");
            const channelName = "CricketMatch";
            const eventName = `CricketMatchScorecard-${matchId}`;
            socket.channel(channelName).listen(eventName, (newData)=>{
                console.log("Socket data received:", newData);
                setScorecardData(newData?.data);
            });
            return ()=>{
                socket?.connector?.socket.disconnect();
            };
        }
    }, [
        socket,
        matchId
    ]);
    return scorecardData;
};


const $6c068de86bb78459$var$CricketScorecardTable = ({ ServerData: ServerData, loadCSS: loadCSS = true, dataClient: dataClient = false, title: title, dictionary: dictionary = {}, socketUrl: socketUrl, matchId: matchId })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    const matchData = dataClient ? clientData : ServerData;
    const socketData = (0, $e41dd628d48b4717$export$bec3e352ce3caf85)(socketUrl, matchId);
    const scorecardData = socketData ?? matchData;
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document?.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data;
            setActive(items[items.length - 1]?.value);
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("cricketmatch");
    }, [
        loadCSS
    ]);
    const homeTeamLineup = scorecardData?.data?.[0];
    const awayTeamLineup = scorecardData?.data?.[1];
    const homeTeamLineup2 = scorecardData?.data?.[2];
    const awayTeamLineup2 = scorecardData?.data?.[3];
    const getScoreCardData = ()=>{
        switch(active){
            case "home":
                return homeTeamLineup;
            case "home2":
                return homeTeamLineup2;
            case "away":
                return awayTeamLineup;
            case "away2":
                return awayTeamLineup2;
            default:
                break;
        }
    };
    const items = [
        homeTeamLineup && {
            value: "home",
            label: homeTeamLineup?.team?.nm + (homeTeamLineup2 ? " 1st Inn" : "")
        },
        awayTeamLineup && {
            value: "away",
            label: awayTeamLineup?.team?.nm + (awayTeamLineup2 ? " 1st Inn" : "")
        },
        homeTeamLineup2 && {
            value: "home2",
            label: homeTeamLineup2?.team?.nm + " 2nd Inn"
        },
        awayTeamLineup2 && {
            value: "away2",
            label: awayTeamLineup2?.team?.nm + " 2nd Inn"
        }
    ].filter(Boolean);
    const [active, setActive] = (0, $6cds3.useState)(items[items.length - 1]?.value || undefined);
    (0, $6cds3.useEffect)(()=>{
        if (!active && items.length > 0) setActive(items[items.length - 1].value);
    }, [
        items,
        active
    ]);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            title ? /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }) : null,
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $811e55a24e3734b4$export$2e2bcd8739ae039), {
                items: items,
                activeItem: active,
                onClick: setActive
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $7e0f7f2c3301f0f7$export$2e2bcd8739ae039), {
                data: getScoreCardData(),
                dictionary: dictionary
            })
        ]
    });
};
var $6c068de86bb78459$export$2e2bcd8739ae039 = $6c068de86bb78459$var$CricketScorecardTable;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $ba5nK = parcelRequire("ba5nK");
const $704dac99dc351cfc$var$CricketTable = ({ data: data })=>{
    return data?.fallOfWickets?.map((player, index)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsxs)("td", {
                    children: [
                        player?.bl,
                        " Ov"
                    ]
                }),
                /*#__PURE__*/ (0, $lBpE3.jsxs)("td", {
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                            className: "bolar_team",
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                    className: "ico_flag",
                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                        src: `https://cric.livescoring.cc/teamflags/${player?.tid}.png`,
                                        width: 22,
                                        height: 22
                                    }, player?.tid)
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                    className: "name",
                                    children: player?.batsman?.nm
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                            className: "bow_inf",
                            children: [
                                "b ",
                                player?.bowler?.nm
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                    children: player?.ft
                })
            ]
        }, index));
};
var $704dac99dc351cfc$export$2e2bcd8739ae039 = $704dac99dc351cfc$var$CricketTable;




var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

const $6626dbcc9f3bbb0c$var$InningsTabsAndTable = ({ children: children, active: active, homeTeamLineup2: homeTeamLineup2, awayTeamLineup2: awayTeamLineup2, subActive: subActive, setSubActive: setSubActive })=>{
    const shouldShowTabs = active === "home" && homeTeamLineup2 || active === "away" && awayTeamLineup2;
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("tbody", {
        children: [
            shouldShowTabs && /*#__PURE__*/ (0, $lBpE3.jsx)("tr", {
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                    colSpan: 6,
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $811e55a24e3734b4$export$2e2bcd8739ae039), {
                        items: [
                            {
                                value: "1st innings",
                                label: "1st innings"
                            },
                            {
                                value: "2nd innings",
                                label: "2nd innings"
                            }
                        ],
                        activeItem: subActive,
                        onClick: setSubActive
                    })
                })
            }),
            children
        ]
    });
};
var $6626dbcc9f3bbb0c$export$2e2bcd8739ae039 = $6626dbcc9f3bbb0c$var$InningsTabsAndTable;



var $2bSDe = parcelRequire("2bSDe");
const $d5d7a1ae5a1cacdc$var$CricketFallOfWickets = ({ ServerData: ServerData, loadCSS: loadCSS = true, dataClient: dataClient = false, title: title })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    const data = dataClient ? clientData : ServerData?.data;
    const [active, setActive] = (0, $6cds3.useState)(null);
    const [subActive, setSubActive] = (0, $6cds3.useState)(null);
    const homeTeamLineup = data?.[0];
    const awayTeamLineup = data?.[1];
    const homeTeamLineup2 = data?.[2];
    const awayTeamLineup2 = data?.[3];
    (0, $6cds3.useEffect)(()=>{
        const hasSecondInningsHome = !!homeTeamLineup2;
        const hasSecondInningsAway = !!awayTeamLineup2;
        if (hasSecondInningsAway || awayTeamLineup) {
            setActive("away");
            setSubActive(hasSecondInningsAway ? "2nd innings" : "1st innings");
        } else if (hasSecondInningsHome || homeTeamLineup) {
            setActive("home");
            setSubActive(hasSecondInningsHome ? "2nd innings" : null);
        }
    }, [
        homeTeamLineup,
        awayTeamLineup,
        homeTeamLineup2,
        awayTeamLineup2
    ]);
    const getScoreCardData = ()=>{
        if (active === "home") return subActive === "1st innings" ? homeTeamLineup : homeTeamLineup2 ? homeTeamLineup2 : homeTeamLineup;
        return subActive === "1st innings" ? awayTeamLineup : awayTeamLineup2 ? awayTeamLineup2 : awayTeamLineup;
    };
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document?.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("cricketmatch");
    }, [
        loadCSS
    ]);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            title ? /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }) : null,
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $811e55a24e3734b4$export$2e2bcd8739ae039), {
                items: [
                    homeTeamLineup?.name && {
                        value: "home",
                        label: homeTeamLineup?.name
                    },
                    awayTeamLineup?.name && {
                        value: "away",
                        label: awayTeamLineup?.name
                    }
                ].filter(Boolean),
                activeItem: active,
                onClick: setActive,
                mainTab: true
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "global_table cr_macth_scorecard fall_of_wickets",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("table", {
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $6626dbcc9f3bbb0c$export$2e2bcd8739ae039), {
                        active: active,
                        homeTeamLineup2: homeTeamLineup2,
                        awayTeamLineup2: awayTeamLineup2,
                        subActive: subActive,
                        setSubActive: setSubActive,
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $704dac99dc351cfc$export$2e2bcd8739ae039), {
                            data: getScoreCardData()
                        })
                    })
                })
            })
        ]
    });
};
var $d5d7a1ae5a1cacdc$export$2e2bcd8739ae039 = $d5d7a1ae5a1cacdc$var$CricketFallOfWickets;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

const $07618ceace7cf616$var$CricketPlayerTable = ({ team1Players: team1Players, team2Players: team2Players })=>{
    const maxLength = Math.max(team1Players?.length, team2Players?.length);
    return maxLength > 0 ? /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
        children: Array.from({
            length: maxLength
        })?.map((_, index)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                        children: team1Players?.[index] ? /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                            className: "player_inf",
                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                className: "ply_des",
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "name",
                                        children: team1Players[index]?.nm
                                    }),
                                    team1Players[index]?.pos && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "sub_name",
                                        children: team1Players[index]?.pos
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                            children: "-"
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                        children: team2Players?.[index] ? /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                            className: "player_inf",
                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                className: "ply_des",
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "name",
                                        children: team2Players[index]?.nm
                                    }),
                                    team2Players[index]?.pos && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "sub_name",
                                        children: team2Players[index]?.pos
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                            children: "-"
                        })
                    })
                ]
            }, index))
    }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {});
};
var $07618ceace7cf616$export$2e2bcd8739ae039 = $07618ceace7cf616$var$CricketPlayerTable;



var $2bSDe = parcelRequire("2bSDe");
const $71b96c13f9230644$var$CricketTeamTable = ({ ServerData: ServerData, loadCSS: loadCSS = true, dataClient: dataClient = false, title: title })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    const data = dataClient ? clientData?.data : ServerData?.data;
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document?.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("cricketmatch");
    }, [
        loadCSS
    ]);
    const teams = data?.teams;
    const team_squards = data?.team_squards;
    const team1Id = data?.teams?.team1?.id;
    const team2Id = data?.teams?.team2?.id;
    const team1Players = team_squards?.filter((player)=>player.team_id === team1Id)?.map((player)=>player?.player);
    const team2Players = team_squards?.filter((player)=>player.team_id === team2Id)?.map((player)=>player?.player);
    const items = [
        {
            value: "Playing Xl",
            label: "Playing Xl"
        },
        {
            value: "Squad",
            label: "Squad"
        }
    ].filter(Boolean);
    const [active, setActive] = (0, $6cds3.useState)("Playing Xl");
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            title ? /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }) : null,
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $811e55a24e3734b4$export$2e2bcd8739ae039), {
                items: items,
                activeItem: active,
                onClick: setActive
            }),
            data?.team_squards?.length ? /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "global_table striped ft_player_team",
                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: data?.teams?.team1?.code
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: data?.teams?.team2?.code
                                    })
                                ]
                            })
                        }),
                        active === "Playing Xl" ? /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                            children: [
                                " ",
                                /*#__PURE__*/ (0, $lBpE3.jsx)((0, $07618ceace7cf616$export$2e2bcd8739ae039), {
                                    team1Players: teams?.team1?.cricLineups,
                                    team2Players: teams?.team2?.cricLineups
                                }),
                                " "
                            ]
                        }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $07618ceace7cf616$export$2e2bcd8739ae039), {
                            team1Players: team1Players,
                            team2Players: team2Players
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {})
        ]
    });
};
var $71b96c13f9230644$export$2e2bcd8739ae039 = $71b96c13f9230644$var$CricketTeamTable;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");


var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");
const $8c7a7acd9ce83453$var$CommentaryByOver = ({ data: data, selectedInnings: selectedInnings })=>{
    const filtered = data?.filter((item)=>item?.inor === selectedInnings);
    const grouped = filtered?.reduce((acc, item)=>{
        const over = Math.floor(item?.ovr);
        if (!acc[over]) acc[over] = [];
        acc[over]?.push(item);
        return acc;
    }, {});
    const sortedOvers = Object.keys(grouped).sort((a, b)=>b - a)?.map((key)=>({
            over: key,
            deliveries: grouped[key]?.sort((a, b)=>b?.ovr - a?.ovr)
        }));
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "commentary-container",
        children: sortedOvers?.map(({ over: over, deliveries: deliveries })=>{
            const firstWithBowler = deliveries.find((d)=>d?.player?.name);
            const bowler = firstWithBowler?.player?.name ?? "";
            const runs = deliveries.reduce((sum, d)=>sum + d?.sc, 0);
            const wickets = deliveries.filter((d)=>d?.dsc === "W").length;
            return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "over-block",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "over-header",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("strong", {
                                children: [
                                    "Over ",
                                    Number(over) + 1
                                ]
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                className: "bowler-stats",
                                children: [
                                    bowler,
                                    " ",
                                    runs,
                                    " Runs, ",
                                    wickets,
                                    " Wickets"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                        className: "over-commentary-list",
                        children: deliveries?.map((ball)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                className: `comment `,
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                        className: "left_inner",
                                        children: ball?.dsc !== "I" ? /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                            className: "ball-label",
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                    className: `ball-dsc ${ball?.dsc === "W" ? "wicket" : ball?.dsc === "4" || ball?.dsc === "6" ? "boundary" : ""}`,
                                                    children: [
                                                        ball?.dsc,
                                                        " "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    className: "ball-ovr",
                                                    children: ball?.ovr
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $lBpE3.jsx)("i", {
                                            className: "head_ico ico_Vector1"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                        className: "comment-body",
                                        children: [
                                            ball?.player?.name && ball?.batsman?.name && /*#__PURE__*/ (0, $lBpE3.jsxs)("strong", {
                                                children: [
                                                    ball?.player?.name,
                                                    " to ",
                                                    ball?.batsman?.name
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("p", {
                                                children: ball?.text
                                            })
                                        ]
                                    })
                                ]
                            }, ball?.id))
                    })
                ]
            }, over);
        })
    });
};
var $8c7a7acd9ce83453$export$2e2bcd8739ae039 = $8c7a7acd9ce83453$var$CommentaryByOver;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $ba5nK = parcelRequire("ba5nK");
const $156727016f93c631$var$baseURL = "https://ipublisher-microservices.6lgx.com" ?? "https://ipublisher-microservices.6lgx.com";
const $156727016f93c631$var$Loader = ({ width: width = "55", height: height = "90" })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        style: {
            textAlign: "center",
            height: "100vh"
        },
        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
            src: `${$156727016f93c631$var$baseURL}/public//assets/images/svg/loader.svg`,
            width: width,
            height: height
        })
    });
};
var $156727016f93c631$export$2e2bcd8739ae039 = $156727016f93c631$var$Loader;



var $2bSDe = parcelRequire("2bSDe");
const $81eddbcdf59e9d0a$var$CricketCommentaryWrap = ({ ServerData: ServerData, matchId: matchId, loadCSS: loadCSS = true, dataClient: dataClient = false, baseUrl: baseUrl, title: title })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    const tabsData = dataClient ? clientData?.data : ServerData?.data;
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document?.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("cricketmatch");
    }, [
        loadCSS
    ]);
    const items = tabsData?.map((item)=>({
            label: item?.cap,
            value: item?.ord
        }));
    const [activeItem, setActiveItem] = (0, $6cds3.useState)(null);
    const [commentaryData, setCommentaryData] = (0, $6cds3.useState)({});
    const [pageCount, setPageCount] = (0, $6cds3.useState)(1);
    const [isLoading, setIsLoading] = (0, $6cds3.useState)(false);
    const handleLoadMore = async ()=>{
        try {
            const res = await fetch(`${baseUrl}/cricket/match/${matchId}/commentary?page=${pageCount + 1}&inning=${activeItem}`);
            const data = await res.json();
            setCommentaryData((prevState)=>({
                    ...prevState,
                    data: [
                        ...prevState?.data || [],
                        ...data.data
                    ],
                    metadata: data.metadata
                }));
            setPageCount((prevPage)=>prevPage + 1);
        } catch (err) {
            console.error("Failed to load more commentary:", err);
        }
    };
    (0, $6cds3.useEffect)(()=>{
        if (!activeItem) return;
        setIsLoading(true);
        async function fetchData() {
            const newData = await fetch(`${baseUrl}/cricket/match/${matchId}/commentary?inning=${activeItem}`);
            const data = await newData.json();
            setCommentaryData(data);
            setIsLoading(false);
        }
        fetchData();
    }, [
        activeItem
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (!activeItem && items?.length) {
            setActiveItem(items.at(-1).value);
            setPageCount(1);
        }
    }, [
        items
    ]);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $811e55a24e3734b4$export$2e2bcd8739ae039), {
                items: items,
                activeItem: activeItem,
                onClick: setActiveItem
            }),
            isLoading ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $156727016f93c631$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)((0, $8c7a7acd9ce83453$export$2e2bcd8739ae039), {
                        data: commentaryData?.data || [],
                        selectedInnings: activeItem
                    }),
                    commentaryData?.metadata?.pagination?.last_page > pageCount ? /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "text_center",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                            className: "button button_primary",
                            onClick: ()=>handleLoadMore(),
                            children: "Load More"
                        })
                    }) : null
                ]
            })
        ]
    });
};
var $81eddbcdf59e9d0a$export$2e2bcd8739ae039 = $81eddbcdf59e9d0a$var$CricketCommentaryWrap;


const $8886411c643dce23$var$CricketMatchWidgetWrap = (props)=>{
    const { dataId: dataId, dataType: dataType, head: head, data: data, headData: headData, sport: sport, difference: difference, loadCSS: loadCSS, dataClient: dataClient, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataTitle: dataTitle, baseUrl: baseUrl, show_cricket_animation: show_cricket_animation = 0, socketUrl: socketUrl = "", channel: channel = "CricketMatch", event: event = `CricketMatchDetails` } = props;
    const renderHeadWrap = (currentTab, children)=>head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $724589132fb1fe86$export$2e2bcd8739ae039), {
            matchDetail: headData,
            difference: difference,
            sport: sport,
            dataClient: dataClient,
            id: dataId,
            currentTab: currentTab,
            websiteBaseUrl: websiteBaseUrl,
            dataPath: dataPath,
            title: dataTitle,
            show_cricket_animation: show_cricket_animation,
            socketUrl: socketUrl,
            channel: channel,
            event: event + `-${dataId}`,
            children: children
        }) : children;
    switch(dataType){
        case "cricket-match-info":
            return renderHeadWrap("info", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $cc5a7e25ee5750e6$export$2e2bcd8739ae039), {
                ServerData: data?.data,
                loadCSS: loadCSS,
                dataClient: dataClient,
                difference: difference,
                title: dataTitle
            }));
        case "cricket-match-live":
            return renderHeadWrap("live", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $6153c5386be14844$export$2e2bcd8739ae039), {
                ServerData: data?.data,
                loadCSS: loadCSS,
                dataClient: dataClient,
                difference: difference,
                title: dataTitle,
                socketUrl: socketUrl,
                matchId: dataId
            }));
        case "cricket-match-standings":
            return renderHeadWrap("standings", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $57ae3d733cdaddd5$export$2e2bcd8739ae039), {
                ServerData: data,
                loadCSS: loadCSS,
                dataClient: dataClient,
                difference: difference,
                title: dataTitle,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath
            }));
        case "cricket-match-scorecard":
            return renderHeadWrap("scorecard", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $6c068de86bb78459$export$2e2bcd8739ae039), {
                ServerData: data,
                loadCSS: loadCSS,
                dataClient: dataClient,
                difference: difference,
                title: dataTitle,
                socketUrl: socketUrl,
                matchId: dataId
            }));
        case "cricket-match-wickets":
            return renderHeadWrap("fall_of_wickets", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $d5d7a1ae5a1cacdc$export$2e2bcd8739ae039), {
                ServerData: data,
                loadCSS: loadCSS,
                dataClient: dataClient,
                difference: difference,
                title: dataTitle
            }));
        case "cricket-match-teams":
            return renderHeadWrap("teams", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $71b96c13f9230644$export$2e2bcd8739ae039), {
                ServerData: data,
                loadCSS: loadCSS,
                dataClient: dataClient,
                difference: difference,
                title: dataTitle
            }));
        case "cricket-match-com":
            return renderHeadWrap("commentary", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $81eddbcdf59e9d0a$export$2e2bcd8739ae039), {
                ServerData: data,
                loadCSS: loadCSS,
                dataClient: dataClient,
                difference: difference,
                title: dataTitle,
                matchId: dataId,
                baseUrl: baseUrl
            }));
        case "cricket-match":
            return head && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $724589132fb1fe86$export$2e2bcd8739ae039), {
                matchDetail: headData,
                difference: difference,
                sport: sport,
                dataClient: dataClient,
                id: dataId,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                title: dataTitle
            });
        default:
            return /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: "Cricket Match Widget Not Found!"
            });
    }
};
var $8886411c643dce23$export$2e2bcd8739ae039 = $8886411c643dce23$var$CricketMatchWidgetWrap;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");




const $7612d14e98209fa8$var$CricketLeagueWidgetWrap = (props)=>{
    const { dataId: dataId, dataType: dataType, head: head, data: data, headData: headData, baseUrl: baseUrl, sport: sport, difference: difference, loadCSS: loadCSS, dataClient: dataClient, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataTitle: dataTitle, setDataType: setDataType, setDataId: setDataId, setHead: setHead } = props;
    const renderHeadWrap = (currentTab, children)=>head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0881f34d53fa6722$export$2e2bcd8739ae039), {
            id: dataId,
            headData: headData,
            baseUrl: baseUrl,
            sport: "cricket",
            dataClient: dataClient,
            currentTab: currentTab,
            websiteBaseUrl: websiteBaseUrl,
            dataPath: dataPath,
            widgetTitle: dataTitle,
            children: children
        }) : children;
    switch(dataType){
        case "cricket-league-info":
            return renderHeadWrap("info", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $be5ab0c7cb61a9f3$export$2e2bcd8739ae039), {
                id: dataId,
                sport: sport,
                data: data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                setDataType: setDataType,
                setDataId: setDataId,
                setHead: setHead,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath
            }));
        case "cricket-league-upcoming":
            return renderHeadWrap("upcoming", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3207c25f6468a03b$export$2e2bcd8739ae039), {
                sport: sport,
                data: data?.data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                difference: difference
            }));
        case "cricket-league-results":
            return renderHeadWrap("results", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3207c25f6468a03b$export$2e2bcd8739ae039), {
                sport: sport,
                data: data?.data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                difference: difference
            }));
        case "cricket-league-standings":
            return renderHeadWrap("table", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $57ae3d733cdaddd5$export$2e2bcd8739ae039), {
                ServerData: data,
                loadCSS: loadCSS,
                dataClient: dataClient,
                difference: difference,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                sport: "cricket"
            }));
        default:
            return /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: "Cricket League Widget Not Found!"
            });
    }
};
var $7612d14e98209fa8$export$2e2bcd8739ae039 = $7612d14e98209fa8$var$CricketLeagueWidgetWrap;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");



const $311c7504b65a9f45$var$CricketTeamWidgetWrap = (props)=>{
    const { dataId: dataId, dataType: dataType, head: head, data: data, headData: headData, baseUrl: baseUrl, sport: sport, loadCSS: loadCSS, dataClient: dataClient, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataTitle: dataTitle, setDataType: setDataType, setDataId: setDataId, setHead: setHead, difference: difference } = props;
    const renderHeadWrap = (currentTab, children)=>head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0881f34d53fa6722$export$2e2bcd8739ae039), {
            id: dataId,
            headData: headData,
            baseUrl: baseUrl,
            sport: "cricket",
            state: "team",
            dataClient: dataClient,
            currentTab: currentTab,
            websiteBaseUrl: websiteBaseUrl,
            dataPath: dataPath,
            widgetTitle: dataTitle,
            children: children
        }) : children;
    switch(dataType){
        case "cricket-team-info":
            return renderHeadWrap("info", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $be5ab0c7cb61a9f3$export$2e2bcd8739ae039), {
                id: dataId,
                sport: sport,
                data: data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                setDataType: setDataType,
                setDataId: setDataId,
                setHead: setHead,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                matchType: "team"
            }));
        case "cricket-team-upcoming":
            return renderHeadWrap("upcoming", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3207c25f6468a03b$export$2e2bcd8739ae039), {
                sport: sport,
                data: data?.data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                matchType: "team",
                difference: difference
            }));
        case "cricket-team-results":
            return renderHeadWrap("results", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3207c25f6468a03b$export$2e2bcd8739ae039), {
                sport: sport,
                data: data?.data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                matchType: "team",
                difference: difference
            }));
        default:
            return /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: "Cricket Team Widget Not Found!"
            });
    }
};
var $311c7504b65a9f45$export$2e2bcd8739ae039 = $311c7504b65a9f45$var$CricketTeamWidgetWrap;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $ba5nK = parcelRequire("ba5nK");

var $3G7m1 = parcelRequire("3G7m1");

var $2bSDe = parcelRequire("2bSDe");
const $b481f672be71e4de$var$CricketPlayerDetailHead = ({ ServerData: ServerData, dictionary: dictionary = {}, loadCSS: loadCSS = true, dataClient: dataClient = false, title: title, sport: sport = "cricket" })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document?.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("cricketplayer");
    }, [
        loadCSS
    ]);
    const data = dataClient ? clientData : ServerData;
    const playerData = data?.data;
    if (!playerData) return null;
    const { nm: nm, role: role, age: age, basty: basty, bosty: bosty, gender: gender, born: born, pid: pid } = playerData;
    const imgUrl = `https://cric.livescoring.cc/playerimages/${pid}.png`;
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "leag_main_head player-head",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "up_head",
                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                            className: "up_wrap",
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                    className: "icon_flag",
                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                        src: imgUrl,
                                        width: 60,
                                        height: 60,
                                        alt: "player",
                                        priority: true
                                    })
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                    className: "info_wrap",
                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                                        className: "a",
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                            className: "name",
                                            children: nm
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "venue_wrap",
                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                            className: "lb",
                                            children: [
                                                dictionary?.dateOfBirth || "Date of Birth",
                                                " :"
                                            ]
                                        }),
                                        born ? `${(0, $3G7m1.getAgeString)(born)}` : "-"
                                    ]
                                }),
                                gender && /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                            className: "lb",
                                            children: [
                                                dictionary?.gender || "Gender",
                                                " :"
                                            ]
                                        }),
                                        gender || "-"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                            className: "lb",
                                            children: [
                                                dictionary?.age || "Age",
                                                " :"
                                            ]
                                        }),
                                        age === null ? "-" : age
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "venue_wrap",
                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                            className: "lb",
                                            children: [
                                                dictionary?.role || "Role",
                                                " :"
                                            ]
                                        }),
                                        role || "-"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                            className: "lb",
                                            children: [
                                                dictionary?.bowlingStyle || "Bowling Style",
                                                " :"
                                            ]
                                        }),
                                        bosty || "-"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                            className: "lb",
                                            children: [
                                                dictionary?.battingStyle || "Batting Style",
                                                " :"
                                            ]
                                        }),
                                        basty || "-"
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $b481f672be71e4de$export$2e2bcd8739ae039 = $b481f672be71e4de$var$CricketPlayerDetailHead;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $3G7m1 = parcelRequire("3G7m1");

var $2bSDe = parcelRequire("2bSDe");
const $e969a5d868b3bce8$var$CricketPlayerInfo = ({ ServerData: ServerData, dictionary: dictionary = {}, loadCSS: loadCSS = true, dataClient: dataClient = false, title: title, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, sport: sport = "cricket" })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document?.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("cricketplayer");
    }, [
        loadCSS
    ]);
    const data = dataClient ? clientData : ServerData;
    console.log(data, 'data');
    const playerData = data?.data;
    if (!playerData) return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "cricket-player-info-card no-data",
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("p", {
            children: dictionary?.noPlayerInfo || "No player information available"
        })
    });
    const { bplc: bplc, edu: edu, teams: teams } = playerData;
    const getTeamUrl = (team)=>{
        if (!dataClient) return "#";
        const basePath = websiteBaseUrl || "";
        const pathSegment = dataPath || (0, $3G7m1.getUrlSport)(sport);
        return `${basePath}/${pathSegment}/team/${(0, $3G7m1.linkName)(team?.name)}/${team?.id}/info`;
    };
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "cricket-player-info-card",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "card-header",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                            className: "player-name-section",
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                                className: "player-name",
                                children: dictionary?.overview || "Overview"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "card-body",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                className: "player-details-grid",
                                children: [
                                    bplc && /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                        className: "detail-item",
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: "label",
                                                children: dictionary?.birthplace || "Birthplace"
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: "value",
                                                children: bplc
                                            })
                                        ]
                                    }),
                                    edu && edu !== "-" && /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                        className: "detail-item",
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: "label",
                                                children: dictionary?.education || "Education"
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: "value",
                                                children: edu
                                            })
                                        ]
                                    })
                                ]
                            }),
                            teams && teams.length > 0 && /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                className: "player-teams-section",
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("h3", {
                                        className: "section-title",
                                        children: dictionary?.teamsRepresented || "Teams Represented"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                        className: "teams-grid",
                                        children: teams.map((team)=>/*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                                                href: getTeamUrl(team),
                                                className: "team-card",
                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    className: "team-name",
                                                    children: team.name
                                                })
                                            }, team.id))
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $e969a5d868b3bce8$export$2e2bcd8739ae039 = $e969a5d868b3bce8$var$CricketPlayerInfo;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $2bSDe = parcelRequire("2bSDe");
const $49e6adf60f8e52e4$var$CricketPlayerStats = ({ ServerData: ServerData, dictionary: dictionary = {}, loadCSS: loadCSS = true, dataClient: dataClient = false, title: title })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    const [selectedFormat, setSelectedFormat] = (0, $6cds3.useState)("all");
    const [selectedType, setSelectedType] = (0, $6cds3.useState)("batting");
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document?.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("cricketplayer");
    }, [
        loadCSS
    ]);
    const data = dataClient ? clientData : ServerData;
    const statsData = data?.data;
    if (!statsData || statsData.length === 0) return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "cricket-player-stats",
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
            className: "no-data-message",
            children: dictionary?.noStats || "No statistics available"
        })
    });
    const battingStats = statsData[0]?.batting_stats || [];
    const bowlingStats = statsData[1]?.bowling_stats || [];
    // Get unique formats
    const formats = [
        "all",
        ...new Set(battingStats.map((stat)=>stat.for))
    ];
    const formatValue = (value)=>{
        if (value === null || value === undefined || value === "") return "-";
        return value;
    };
    // Filter stats based on selected format
    const getFilteredStats = (stats)=>{
        if (selectedFormat === "all") return stats;
        return stats.filter((stat)=>stat.for === selectedFormat);
    };
    const filteredBattingStats = getFilteredStats(battingStats);
    const filteredBowlingStats = getFilteredStats(bowlingStats);
    const renderBattingTable = ()=>/*#__PURE__*/ (0, $lBpE3.jsx)("div", {
            className: "stats-table-wrapper",
            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                className: "stats-table",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: dictionary?.format || "Format"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: dictionary?.mat || "Mat"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: dictionary?.inn || "Inn"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: dictionary?.no || "NO"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: dictionary?.runs || "Runs"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: dictionary?.hs || "HS"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: dictionary?.avg || "Avg"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: dictionary?.sr || "SR"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: dictionary?.hundreds || "100s"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: dictionary?.fifties || "50s"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: dictionary?.fours || "4s"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: dictionary?.sixes || "6s"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: dictionary?.ct || "Ct"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: dictionary?.st || "St"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                        children: filteredBattingStats.map((stat, index)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        className: "format-cell",
                                        children: formatValue(stat.for)
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: formatValue(stat.mats)
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: formatValue(stat.inn)
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: formatValue(stat.nots)
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        className: "highlight-cell",
                                        children: formatValue(stat.runs)
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: formatValue(stat.hsco)
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        className: "highlight-cell",
                                        children: formatValue(stat.bavg)
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: formatValue(stat.srate)
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: formatValue(stat.cen)
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: formatValue(stat.fif)
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: formatValue(stat.four)
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: formatValue(stat.six)
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: formatValue(stat.cats)
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: formatValue(stat.stps)
                                    })
                                ]
                            }, index))
                    })
                ]
            })
        });
    const renderBowlingTable = ()=>/*#__PURE__*/ (0, $lBpE3.jsx)("div", {
            className: "stats-table-wrapper",
            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                className: "stats-table",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: dictionary?.format || "Format"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: dictionary?.mat || "Mat"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: dictionary?.inn || "Inn"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: dictionary?.balls || "Balls"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: dictionary?.runs || "Runs"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: dictionary?.wkts || "Wkts"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: dictionary?.bbi || "BBI"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: dictionary?.bbm || "BBM"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: dictionary?.avg || "Avg"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: dictionary?.econ || "Econ"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: dictionary?.sr || "SR"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: dictionary?.fourW || "4w"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: dictionary?.fiveW || "5w"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: dictionary?.tenW || "10w"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                        children: filteredBowlingStats.map((stat, index)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        className: "format-cell",
                                        children: formatValue(stat.for)
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: formatValue(stat.mats)
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: formatValue(stat.inn)
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: formatValue(stat.bal)
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: formatValue(stat.runs)
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        className: "highlight-cell",
                                        children: formatValue(stat.wkts)
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: formatValue(stat.bbowinn)
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: formatValue(stat.bbowlingmat)
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        className: "highlight-cell",
                                        children: formatValue(stat.boavg)
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: formatValue(stat.erate)
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: formatValue(stat.bostkrat)
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: formatValue(stat.wkt4)
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: formatValue(stat.wkt5)
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: formatValue(stat.wkt10)
                                    })
                                ]
                            }, index))
                    })
                ]
            })
        });
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "cricket-player-stats",
                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                    className: "stats-card",
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                            className: "stats-card-header",
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("h3", {
                                    className: "stats-title",
                                    children: dictionary?.careerStats || "Career Statistics"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                    className: "stats-filters",
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                            className: "filter-group",
                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("select", {
                                                className: "stats-dropdown",
                                                value: selectedFormat,
                                                onChange: (e)=>setSelectedFormat(e.target.value),
                                                children: formats.map((format)=>/*#__PURE__*/ (0, $lBpE3.jsx)("option", {
                                                        value: format,
                                                        children: format === "all" ? dictionary?.allFormats || "All Formats" : format
                                                    }, format))
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                            className: "filter-group",
                                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("select", {
                                                className: "stats-dropdown",
                                                value: selectedType,
                                                onChange: (e)=>setSelectedType(e.target.value),
                                                children: [
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("option", {
                                                        value: "batting",
                                                        children: dictionary?.batting || "Batting"
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("option", {
                                                        value: "bowling",
                                                        children: dictionary?.bowling || "Bowling"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                            className: "stats-card-body",
                            children: selectedType === "batting" ? renderBattingTable() : renderBowlingTable()
                        })
                    ]
                })
            })
        ]
    });
};
var $49e6adf60f8e52e4$export$2e2bcd8739ae039 = $49e6adf60f8e52e4$var$CricketPlayerStats;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $2bSDe = parcelRequire("2bSDe");
const $8d793b0b8600cf5b$var$CricketPlayerMatches = ({ ServerData: ServerData, dictionary: dictionary = {}, loadCSS: loadCSS = true, dataClient: dataClient = false, title: title })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    const [selectedFormat, setSelectedFormat] = (0, $6cds3.useState)("all");
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document?.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("cricketplayer");
    }, [
        loadCSS
    ]);
    const data = dataClient ? clientData : ServerData;
    const matchesData = data?.data;
    if (!matchesData || matchesData.length === 0) return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "cricket-player-matches",
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
            className: "no-data-message",
            children: dictionary?.noMatches || "No matches available"
        })
    });
    // Get all formats from tournaments
    const allFormats = [
        "all"
    ];
    matchesData.forEach((tournament)=>{
        tournament.matches?.forEach((match)=>{
            if (match.mty && !allFormats.includes(match.mty)) allFormats.push(match.mty);
        });
    });
    const formatValue = (value)=>{
        if (value === null || value === undefined || value === "") return "-";
        return value;
    };
    const formatDate = (dateString)=>{
        if (!dateString) return "-";
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = date.toLocaleString("en-US", {
            month: "short"
        });
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };
    const getFilteredMatches = ()=>{
        let allMatches = [];
        matchesData.forEach((tournament)=>{
            tournament.matches?.forEach((match)=>{
                allMatches.push({
                    ...match,
                    tournamentName: tournament.nm
                });
            });
        });
        if (selectedFormat !== "all") allMatches = allMatches.filter((match)=>match.mty === selectedFormat);
        return allMatches;
    };
    const filteredMatches = getFilteredMatches();
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "cricket-player-matches",
                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                    className: "matches-card",
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                            className: "matches-card-header",
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("h3", {
                                    className: "matches-title",
                                    children: dictionary?.recentMatches || "Recent Matches - Player"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                    className: "matches-filters",
                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("select", {
                                        className: "matches-dropdown",
                                        value: selectedFormat,
                                        onChange: (e)=>setSelectedFormat(e.target.value),
                                        children: allFormats.map((format)=>/*#__PURE__*/ (0, $lBpE3.jsx)("option", {
                                                value: format,
                                                children: format === "all" ? dictionary?.allFormats || "All Formats" : format
                                            }, format))
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                            className: "matches-card-body",
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: "matches-table-wrapper",
                                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                                    className: "matches-table",
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                        children: dictionary?.match || "Match"
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                        children: dictionary?.bat || "Bat"
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                        children: dictionary?.date || "Date"
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                        children: dictionary?.ground || "Ground"
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                        children: dictionary?.format || "Format"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                                            children: filteredMatches.map((match, index)=>{
                                                const homeTeam = match.competitors?.htn || "";
                                                const awayTeam = match.competitors?.atn || "";
                                                const matchName = `${homeTeam} vs ${awayTeam}`;
                                                const ground = match.stad?.cty || "-";
                                                return /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                            className: "match-name-cell",
                                                            children: matchName
                                                        }),
                                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                            className: "bat-cell",
                                                            children: formatValue(match.mno)
                                                        }),
                                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                            children: formatDate(match.d)
                                                        }),
                                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                            children: ground
                                                        }),
                                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                            className: "format-cell",
                                                            children: formatValue(match.mty)
                                                        })
                                                    ]
                                                }, index);
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $8d793b0b8600cf5b$export$2e2bcd8739ae039 = $8d793b0b8600cf5b$var$CricketPlayerMatches;


const $785a5a7613db6429$var$CricketPlayerWidgetWrap = ({ dataId: dataId, dataType: dataType, sport: sport, data: data, headData: headData, loadCSS: loadCSS, dataClient: dataClient = false, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataTitle: dataTitle, head: head })=>{
    const commonProps = {
        ServerData: data,
        loadCSS: loadCSS,
        dataClient: dataClient,
        websiteBaseUrl: websiteBaseUrl,
        dataPath: dataPath,
        sport: sport,
        title: dataTitle
    };
    const headProps = {
        ServerData: headData,
        loadCSS: loadCSS,
        dataClient: dataClient,
        websiteBaseUrl: websiteBaseUrl,
        dataPath: dataPath,
        sport: sport
    };
    const showHead = head === "player";
    // Player Detail Head (header with photo, name, stats)
    if (dataType === "cricket-player-head") return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $b481f672be71e4de$export$2e2bcd8739ae039), {
        ...commonProps
    });
    // Player Info (overview, birthplace, education, teams)
    if (dataType === "cricket-player-info") return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            showHead && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $b481f672be71e4de$export$2e2bcd8739ae039), {
                ...headProps
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $e969a5d868b3bce8$export$2e2bcd8739ae039), {
                ...commonProps
            })
        ]
    });
    // Player Stats (batting/bowling statistics with format filters)
    if (dataType === "cricket-player-stats") return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            showHead && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $b481f672be71e4de$export$2e2bcd8739ae039), {
                ...headProps
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $49e6adf60f8e52e4$export$2e2bcd8739ae039), {
                ...commonProps
            })
        ]
    });
    // Player Matches (recent matches with format filter)
    if (dataType === "cricket-player-matches") return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            showHead && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $b481f672be71e4de$export$2e2bcd8739ae039), {
                ...headProps
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $8d793b0b8600cf5b$export$2e2bcd8739ae039), {
                ...commonProps
            })
        ]
    });
    return /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
        children: "Cricket Player Widget Not Found!"
    });
};
var $785a5a7613db6429$export$2e2bcd8739ae039 = $785a5a7613db6429$var$CricketPlayerWidgetWrap;


const $fe795af5b52e44e5$var$CricketWidgets = ({ dataId: dataId, dataType: dataType, sport: sport, difference: difference, head: head, data: data, headData: headData, baseUrl: baseUrl, loadCSS: loadCSS, setDataId: setDataId, setDataType: setDataType, setHead: setHead, setDate: setDate, date: date, setIsLive: setIsLive, isLive: isLive, dataClient: dataClient = false, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataTitle: dataTitle })=>{
    const showCricketAnimationRef = (0, $6cds3.useRef)(null);
    (0, $6cds3.useEffect)(()=>{
        const loadSettings = async ()=>{
            try {
                const res = await fetch(`${baseUrl}/settings`, {
                    headers: {
                        Token: undefined,
                        "Content-Type": "application/json",
                        Accept: "application/json"
                    }
                });
                if (!res.ok) throw new Error(res.statusText);
                const settings = await res.json();
                const cssVars = (0, $2d22661aa7fb4cf1$export$a964851a84ddc42f)(settings);
                showCricketAnimationRef.current = settings?.data?.show_cricket_animation;
                const styleTag = document.createElement("style");
                styleTag.textContent = cssVars;
                document.head.appendChild(styleTag);
                document.querySelectorAll(".microservice-cont")?.forEach((el)=>el?.classList.add("hydrated"));
                return ()=>{
                    if (document.head.contains(styleTag)) document.head.removeChild(styleTag);
                };
            } catch (err) {
                console.error("Failed to load settings:", err);
            }
        };
        loadSettings();
    }, [
        baseUrl
    ]);
    const commonProps = {
        dataId: dataId,
        dataType: dataType,
        sport: sport,
        difference: difference,
        head: head,
        data: data,
        headData: headData,
        baseUrl: baseUrl,
        loadCSS: loadCSS,
        setDataId: setDataId,
        setDataType: setDataType,
        setHead: setHead,
        setDate: setDate,
        date: date,
        setIsLive: setIsLive,
        isLive: isLive,
        dataClient: dataClient,
        websiteBaseUrl: websiteBaseUrl,
        dataPath: dataPath,
        dataTitle: dataTitle,
        show_cricket_animation: showCricketAnimationRef.current
    };
    if (dataType === "live-match-detail" || dataType === "live-centre") return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3ff7d166fed572f5$export$2e2bcd8739ae039), {
        ...commonProps,
        data: data?.data,
        matchType: "all",
        socketUrl: "https://socket-bolsaas.6lgx.com/"
    });
    if (dataType?.startsWith("cricket-match")) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $8886411c643dce23$export$2e2bcd8739ae039), {
        ...commonProps,
        socketUrl: "https://socket-bolsaas.6lgx.com/"
    });
    if (dataType?.startsWith("cricket-league-")) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $7612d14e98209fa8$export$2e2bcd8739ae039), {
        ...commonProps
    });
    if (dataType?.startsWith("cricket-team-")) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $311c7504b65a9f45$export$2e2bcd8739ae039), {
        ...commonProps
    });
    if (dataType?.startsWith("cricket-player-")) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $785a5a7613db6429$export$2e2bcd8739ae039), {
        ...commonProps
    });
    return /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
        children: "Widget Not Found!"
    });
};
var $fe795af5b52e44e5$export$2e2bcd8739ae039 = $fe795af5b52e44e5$var$CricketWidgets;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");


var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $3G7m1 = parcelRequire("3G7m1");

var $ba5nK = parcelRequire("ba5nK");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $ba5nK = parcelRequire("ba5nK");

var $3G7m1 = parcelRequire("3G7m1");
const $89c22cc1c01feb79$var$PreMatches = ({ data: data, sport: sport = "tennis" })=>{
    // Get player image URL - use teamImage utility if headersList is provide
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "lineupbox",
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
            className: "global_table player_lineup_t",
            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {}),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "Players"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "Rank"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("tbody", {
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                            className: "players_inf",
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                    className: "avtar",
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                        src: (0, $3G7m1.getImageUrl)('', '', 'tennis', data?.commentary?.competitors?.hpid),
                                                        height: 18,
                                                        width: 18,
                                                        alt: "homePlayer",
                                                        priority: false
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                    className: "avtar_inf",
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                        className: "name small",
                                                        children: data?.player?.[0]?.nm
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                                            className: "prev_match_status",
                                            children: data?.player?.[0]?.pre_matches?.map((w, i)=>/*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                                    className: `${w === "W" ? "win" : "loss"}`,
                                                    children: w
                                                }, w + i))
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                            className: "count_num",
                                            children: data?.player?.[0]?.rank || "-"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                            className: "players_inf",
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                    className: "avtar",
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                        src: (0, $3G7m1.getImageUrl)('', '', 'tennis', data?.commentary?.competitors?.apid),
                                                        height: 18,
                                                        width: 18,
                                                        alt: "awayPlayer",
                                                        priority: false
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                    className: "avtar_inf",
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                        className: "name small",
                                                        children: data?.player?.[1]?.nm
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                                            className: "prev_match_status",
                                            children: data?.player?.[1]?.pre_matches?.map((w, i)=>/*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                                    className: `${w === "W" ? "win" : "loss"}`,
                                                    children: w
                                                }, w + i))
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                            className: "count_num",
                                            children: data?.player?.[1]?.rank || "-"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $89c22cc1c01feb79$export$2e2bcd8739ae039 = $89c22cc1c01feb79$var$PreMatches;



var $2bSDe = parcelRequire("2bSDe");
const $29686a7899b24a3b$var$TennisInfoTable = ({ ServerData: ServerData, difference: difference, dictionary: dictionary = {}, loadCSS: loadCSS = true, dataClient: dataClient = false, title: title, sport: sport = "tennis" })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    const data = dataClient ? clientData : ServerData;
    const matchScore = (0, $3G7m1.GetMatchScores)(data?.commentary?.scores, (0, $3G7m1.GetTennisMatchStatus)(data?.st, data?.cp));
    // Get player image URL - use teamImage utility if headersList is provided
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document?.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS) (0, $2bSDe.loadStyles)("tennismatchinfo");
    }, [
        loadCSS
    ]);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            title ? /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }) : null,
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "commentary_tennis",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "lineupbox",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                            className: "global_table player_sets",
                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                    children: "Sets"
                                                }),
                                                (matchScore?.s1away || matchScore?.s1home) && /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                    children: "1st"
                                                }),
                                                (matchScore?.s2away || matchScore?.s2home) && /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                    children: "2nd"
                                                }),
                                                (matchScore?.s3away || matchScore?.s3home) && /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                    children: "3rd"
                                                }),
                                                (matchScore?.s4away || matchScore?.s4home) && /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                    children: "4th"
                                                }),
                                                (matchScore?.s5away || matchScore?.s5home) && /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                    children: "5th"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("tbody", {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                                            className: "players_inf",
                                                            children: [
                                                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                                    className: "avtar",
                                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                                        src: (0, $3G7m1.getImageUrl)('', '', 'tennis', data?.commentary?.competitors?.hpid),
                                                                        height: 18,
                                                                        width: 18,
                                                                        alt: "homePlayer",
                                                                        priority: false
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                                    className: "avtar_inf",
                                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                                        className: "name small",
                                                                        children: data?.commentary?.competitors?.htn
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    matchScore?.s1home && /*#__PURE__*/ (0, $lBpE3.jsxs)("td", {
                                                        children: [
                                                            matchScore?.s1home,
                                                            /*#__PURE__*/ (0, $lBpE3.jsx)("sup", {
                                                                children: matchScore?.s1hometb
                                                            })
                                                        ]
                                                    }),
                                                    matchScore?.s2home && /*#__PURE__*/ (0, $lBpE3.jsxs)("td", {
                                                        children: [
                                                            matchScore?.s2home,
                                                            /*#__PURE__*/ (0, $lBpE3.jsx)("sup", {
                                                                children: matchScore?.s2hometb
                                                            })
                                                        ]
                                                    }),
                                                    matchScore?.s3home && /*#__PURE__*/ (0, $lBpE3.jsxs)("td", {
                                                        children: [
                                                            matchScore?.s3home,
                                                            /*#__PURE__*/ (0, $lBpE3.jsx)("sup", {
                                                                children: matchScore?.s3hometb
                                                            })
                                                        ]
                                                    }),
                                                    matchScore?.s4home && /*#__PURE__*/ (0, $lBpE3.jsxs)("td", {
                                                        children: [
                                                            matchScore?.s4home,
                                                            /*#__PURE__*/ (0, $lBpE3.jsx)("sup", {
                                                                children: matchScore?.s4hometb
                                                            })
                                                        ]
                                                    }),
                                                    matchScore?.s5home && /*#__PURE__*/ (0, $lBpE3.jsxs)("td", {
                                                        children: [
                                                            matchScore?.s5home,
                                                            /*#__PURE__*/ (0, $lBpE3.jsx)("sup", {
                                                                children: matchScore?.s5hometb
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                                            className: "players_inf",
                                                            children: [
                                                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                                    className: "avtar",
                                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                                        src: (0, $3G7m1.getImageUrl)('', '', 'tennis', data?.commentary?.competitors?.apid),
                                                                        height: 18,
                                                                        width: 18,
                                                                        alt: "awayPlayer",
                                                                        priority: false
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                                    className: "avtar_inf",
                                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                                        className: "name small",
                                                                        children: data?.commentary?.competitors?.atn
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    matchScore?.s1away && /*#__PURE__*/ (0, $lBpE3.jsxs)("td", {
                                                        children: [
                                                            matchScore?.s1away,
                                                            /*#__PURE__*/ (0, $lBpE3.jsx)("sup", {
                                                                children: matchScore?.s1awaytb
                                                            })
                                                        ]
                                                    }),
                                                    matchScore?.s2away && /*#__PURE__*/ (0, $lBpE3.jsxs)("td", {
                                                        children: [
                                                            matchScore?.s2away,
                                                            /*#__PURE__*/ (0, $lBpE3.jsx)("sup", {
                                                                children: matchScore?.s2awaytb
                                                            })
                                                        ]
                                                    }),
                                                    matchScore?.s3away && /*#__PURE__*/ (0, $lBpE3.jsxs)("td", {
                                                        children: [
                                                            matchScore?.s3away,
                                                            /*#__PURE__*/ (0, $lBpE3.jsx)("sup", {
                                                                children: matchScore?.s3awaytb
                                                            })
                                                        ]
                                                    }),
                                                    matchScore?.s4away && /*#__PURE__*/ (0, $lBpE3.jsxs)("td", {
                                                        children: [
                                                            matchScore?.s4away,
                                                            /*#__PURE__*/ (0, $lBpE3.jsx)("sup", {
                                                                children: matchScore?.s4awaytb
                                                            })
                                                        ]
                                                    }),
                                                    matchScore?.s5away && /*#__PURE__*/ (0, $lBpE3.jsxs)("td", {
                                                        children: [
                                                            matchScore?.s5away,
                                                            /*#__PURE__*/ (0, $lBpE3.jsx)("sup", {
                                                                children: matchScore?.s5awaytb
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)((0, $89c22cc1c01feb79$export$2e2bcd8739ae039), {
                        data: data,
                        sport: sport
                    })
                ]
            })
        ]
    });
};
var $29686a7899b24a3b$export$2e2bcd8739ae039 = $29686a7899b24a3b$var$TennisInfoTable;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");



var $3G7m1 = parcelRequire("3G7m1");

var $2bSDe = parcelRequire("2bSDe");
const $a7f915bbbe91f518$var$TennisStats = ({ data: data, loadCSS: loadCSS = true, dataClient: dataClient = false, title: title })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    const [selectedSet, setSelectedSet] = (0, $6cds3.useState)("all_sets");
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document?.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("tennisstats");
    }, [
        loadCSS
    ]);
    const matchStats = dataClient ? clientData : data;
    if (!matchStats) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {});
    // Dynamically get all available sets from matchStats (excluding 'match')
    const allSets = Object.keys(matchStats).filter((key)=>key !== "match" && matchStats[key] && typeof matchStats[key] === "object");
    const getStatsCategories = ()=>{
        const serviceStatsKeys = new Set();
        const pointsStatsKeys = new Set();
        allSets.forEach((setKey)=>{
            const setData = matchStats[setKey];
            if (setData) {
                // Extract stats from service, return, and games categories
                [
                    "service",
                    "return",
                    "games"
                ].forEach((category)=>{
                    if (setData[category]) Object.keys(setData[category]).forEach((statKey)=>{
                        serviceStatsKeys.add(statKey);
                    });
                });
                // Extract stats from points category
                if (setData.points) Object.keys(setData.points).forEach((statKey)=>{
                    pointsStatsKeys.add(statKey);
                });
            }
        });
        return {
            serviceStatsKeys: Array.from(serviceStatsKeys),
            pointsStatsKeys: Array.from(pointsStatsKeys)
        };
    };
    const { serviceStatsKeys: serviceStatsKeys, pointsStatsKeys: pointsStatsKeys } = getStatsCategories();
    // Get service stats based on selected set
    const getServiceStats = ()=>{
        if (selectedSet === "all_sets") {
            const combined = {};
            allSets.forEach((setKey)=>{
                const setData = matchStats[setKey];
                if (setData) Object.keys(setData).forEach((category)=>{
                    if (setData[category]) Object.keys(setData[category]).forEach((statKey)=>{
                        if (serviceStatsKeys.includes(statKey)) {
                            if (!combined[statKey]) combined[statKey] = {
                                ht: 0,
                                at: 0
                            };
                            combined[statKey].ht += setData[category][statKey]?.ht || 0;
                            combined[statKey].at += setData[category][statKey]?.at || 0;
                        }
                    });
                });
            });
            return combined;
        }
        const setData = matchStats[selectedSet];
        if (!setData) return {};
        const serviceStats = {};
        Object.keys(setData).forEach((category)=>{
            if (setData[category]) Object.keys(setData[category]).forEach((statKey)=>{
                if (serviceStatsKeys.includes(statKey)) serviceStats[statKey] = setData[category][statKey];
            });
        });
        return serviceStats;
    };
    // Get points stats based on selected set
    const getPointsStats = ()=>{
        if (selectedSet === "all_sets") {
            const combined = {};
            allSets.forEach((setKey)=>{
                const setData = matchStats[setKey];
                if (setData) Object.keys(setData).forEach((category)=>{
                    if (setData[category]) Object.keys(setData[category]).forEach((statKey)=>{
                        if (pointsStatsKeys.includes(statKey)) {
                            if (!combined[statKey]) combined[statKey] = {
                                ht: 0,
                                at: 0
                            };
                            combined[statKey].ht += setData[category][statKey]?.ht || 0;
                            combined[statKey].at += setData[category][statKey]?.at || 0;
                        }
                    });
                });
            });
            return combined;
        }
        const setData = matchStats[selectedSet];
        if (!setData) return {};
        const pointsStats = {};
        Object.keys(setData).forEach((category)=>{
            if (setData[category]) Object.keys(setData[category]).forEach((statKey)=>{
                if (pointsStatsKeys.includes(statKey)) pointsStats[statKey] = setData[category][statKey];
            });
        });
        return pointsStats;
    };
    const serviceStats = getServiceStats();
    const pointsStats = getPointsStats();
    // Filter out service stats with zero values and convert to array format
    const filteredServiceStats = Object.keys(serviceStats).filter((key)=>{
        const stat = serviceStats[key];
        return stat && (stat.ht !== 0 || stat.at !== 0);
    }).map((key)=>({
            type: key,
            ht: serviceStats[key].ht,
            at: serviceStats[key].at,
            htPercent: (0, $3G7m1.calculatePercentagestats)(serviceStats[key].ht, serviceStats[key].at),
            atPercent: (0, $3G7m1.calculatePercentagestats)(serviceStats[key].at, serviceStats[key].ht)
        }));
    // Filter out points stats with zero values and convert to array format
    const filteredPointsStats = Object.keys(pointsStats).filter((key)=>{
        const stat = pointsStats[key];
        return stat && (stat.ht !== 0 || stat.at !== 0);
    }).map((key)=>({
            type: key,
            ht: pointsStats[key].ht,
            at: pointsStats[key].at,
            htPercent: (0, $3G7m1.calculatePercentagestats)(pointsStats[key].ht, pointsStats[key].at),
            atPercent: (0, $3G7m1.calculatePercentagestats)(pointsStats[key].at, pointsStats[key].ht)
        }));
    // Show all sets that exist in matchStats
    const availableSets = Object.keys(matchStats).filter((key)=>matchStats[key] && typeof matchStats[key] === "object");
    const sets = [
        {
            key: "all_sets",
            label: "All"
        },
        ...availableSets.map((set)=>({
                key: set,
                label: set === "match" ? "Match" : set.replace("_", " ").replace(/\b\w/g, (l)=>l.toUpperCase())
            }))
    ];
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "tennis_stats_container",
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            availableSets.length > 0 && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "stats_filters",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: "set_selector",
                    children: sets.map((set)=>/*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                            className: `filter_button ${selectedSet === set.key ? "active" : ""}`,
                            onClick: ()=>setSelectedSet(set.key),
                            children: set.label
                        }, set.key))
                })
            }),
            filteredServiceStats.length > 0 && /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "stats_title",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                            children: "Service"
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "stats-holder",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $f79ba49286473462$export$2e2bcd8739ae039), {
                            stats: filteredServiceStats
                        })
                    })
                ]
            }),
            filteredPointsStats.length > 0 && /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "stats_title",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                            children: "Points"
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "stats-holder",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $f79ba49286473462$export$2e2bcd8739ae039), {
                            stats: filteredPointsStats
                        })
                    })
                ]
            }),
            filteredServiceStats.length === 0 && filteredPointsStats.length === 0 && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {})
        ]
    });
};
var $a7f915bbbe91f518$export$2e2bcd8739ae039 = $a7f915bbbe91f518$var$TennisStats;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");


var $2bSDe = parcelRequire("2bSDe");
const $154c75a0dedb8b05$var$TennisRankings = ({ data: data, loadCSS: loadCSS = true, dataClient: dataClient = false, title: title })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document?.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("tennisrankings");
    }, [
        loadCSS
    ]);
    const rankingData = dataClient ? clientData : data;
    if (!rankingData || !Array.isArray(rankingData) || rankingData.length === 0) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "tennis_rankings_container",
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "global_table ranking_tbl",
                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "#"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "Player"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "Age"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "+/-"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "TP"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "Drop."
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "NB"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsxs)("tbody", {
                            children: [
                                rankingData.map((item, index)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: item.rank || item.id || index + 1
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: item.player || item.name || item.nm || "-"
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: item.age || "-"
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                className: item.plusMinus?.includes("+") ? "positive" : item.plusMinus?.includes("-") ? "negative" : "",
                                                children: item.plusMinus || item.plus_minus || "-"
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: item.totalPoints || item.tp || item.tournaments_played || "-"
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: item.dropPoints || item.drop || item.dropping || "-"
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: item.netPoints || item.nb || item.next_best || "-"
                                            })
                                        ]
                                    }, item.id || index)),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        colSpan: 7,
                                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("ul", {
                                            className: "ranking_list",
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                            children: "OP"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                            children: "Official Points"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                            children: "Drop."
                                                        }),
                                                        /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                            children: "Dropping"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                            children: "TP"
                                                        }),
                                                        /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                            children: "Tourn Played"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                            children: "NB"
                                                        }),
                                                        /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                            children: "Next Best"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $154c75a0dedb8b05$export$2e2bcd8739ae039 = $154c75a0dedb8b05$var$TennisRankings;


const $b9aa85f5e85340fc$var$TennisMatchWidgetWrap = (props)=>{
    const { dataId: dataId, dataType: dataType, head: head, data: data, headData: headData, sport: sport, difference: difference, loadCSS: loadCSS, dataClient: dataClient, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataTitle: dataTitle, socketUrl: socketUrl, channel: channel, event: event } = props;
    const renderHeadWrap = (currentTab, children)=>head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $cc0e4da7c5a2120d$export$2e2bcd8739ae039), {
            matchDetail: headData,
            difference: difference,
            sport: sport,
            dataClient: dataClient,
            id: dataId,
            currentTab: currentTab,
            websiteBaseUrl: websiteBaseUrl,
            dataPath: dataPath,
            title: dataTitle,
            socketUrl: socketUrl,
            channel: channel,
            event: event,
            children: children
        }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
            children: children
        });
    switch(dataType){
        case "tennis-match-info":
            return renderHeadWrap("info", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $29686a7899b24a3b$export$2e2bcd8739ae039), {
                ServerData: data?.data,
                loadCSS: loadCSS,
                dataClient: dataClient,
                difference: difference,
                title: dataTitle,
                sport: sport
            }));
        case "tennis-match":
            return head && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $cc0e4da7c5a2120d$export$2e2bcd8739ae039), {
                matchDetail: headData,
                difference: difference,
                sport: sport,
                dataClient: dataClient,
                id: dataId,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                title: dataTitle
            });
        case "tennis-match-stats":
            return renderHeadWrap("stats", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $a7f915bbbe91f518$export$2e2bcd8739ae039), {
                data: data?.data,
                loadCSS: loadCSS,
                dataClient: dataClient,
                title: dataTitle
            }));
        case "tennis-rankings":
            return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $154c75a0dedb8b05$export$2e2bcd8739ae039), {
                data: data?.data,
                loadCSS: loadCSS,
                dataClient: dataClient,
                title: dataTitle
            });
        default:
            return /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: "Tennis Match Widget Not Found!"
            });
    }
};
var $b9aa85f5e85340fc$export$2e2bcd8739ae039 = $b9aa85f5e85340fc$var$TennisMatchWidgetWrap;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");



const $fecd27f2ac6c1c14$var$TennisLeagueWidgetWrap = (props)=>{
    const { dataId: dataId, dataType: dataType, head: head, data: data, headData: headData, baseUrl: baseUrl, sport: sport, difference: difference, loadCSS: loadCSS, dataClient: dataClient, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataTitle: dataTitle, setDataType: setDataType, setDataId: setDataId, setHead: setHead } = props;
    const renderHeadWrap = (currentTab, children)=>head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0881f34d53fa6722$export$2e2bcd8739ae039), {
            id: dataId,
            headData: headData,
            baseUrl: baseUrl,
            sport: "tennis",
            dataClient: dataClient,
            currentTab: currentTab,
            websiteBaseUrl: websiteBaseUrl,
            dataPath: dataPath,
            widgetTitle: dataTitle,
            children: children
        }) : children;
    switch(dataType){
        case "tennis-league-info":
            return renderHeadWrap("info", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $be5ab0c7cb61a9f3$export$2e2bcd8739ae039), {
                id: dataId,
                sport: sport,
                data: data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                setDataType: setDataType,
                setDataId: setDataId,
                setHead: setHead,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                difference: difference
            }));
        case "tennis-league-upcoming":
            return renderHeadWrap("upcoming", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3207c25f6468a03b$export$2e2bcd8739ae039), {
                sport: sport,
                data: data?.data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                difference: difference
            }));
        case "tennis-league-results":
            return renderHeadWrap("results", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3207c25f6468a03b$export$2e2bcd8739ae039), {
                sport: sport,
                data: data?.data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                difference: difference
            }));
        default:
            return /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: "Tennis League Widget Not Found!"
            });
    }
};
var $fecd27f2ac6c1c14$export$2e2bcd8739ae039 = $fecd27f2ac6c1c14$var$TennisLeagueWidgetWrap;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");



const $0fb42d92574c267a$var$TennisPlayerWidgetWrap = (props)=>{
    const { dataId: dataId, dataType: dataType, head: head, data: data, headData: headData, baseUrl: baseUrl, sport: sport, loadCSS: loadCSS, dataClient: dataClient, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataTitle: dataTitle, setDataType: setDataType, setDataId: setDataId, setHead: setHead, difference: difference } = props;
    const renderHeadWrap = (currentTab, children)=>head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0881f34d53fa6722$export$2e2bcd8739ae039), {
            id: dataId,
            headData: headData,
            baseUrl: baseUrl,
            sport: "tennis",
            state: "team",
            dataClient: dataClient,
            currentTab: currentTab,
            websiteBaseUrl: websiteBaseUrl,
            dataPath: dataPath,
            widgetTitle: dataTitle,
            children: children
        }) : children;
    switch(dataType){
        case "tennis-player-info":
            return renderHeadWrap("info", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $be5ab0c7cb61a9f3$export$2e2bcd8739ae039), {
                id: dataId,
                sport: sport,
                data: data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                setDataType: setDataType,
                setDataId: setDataId,
                setHead: setHead,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                matchType: "team"
            }));
        case "tennis-player-upcoming":
            return renderHeadWrap("upcoming", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3207c25f6468a03b$export$2e2bcd8739ae039), {
                sport: sport,
                data: data?.data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                matchType: "team",
                difference: difference
            }));
        case "tennis-player-results":
            return renderHeadWrap("results", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3207c25f6468a03b$export$2e2bcd8739ae039), {
                sport: sport,
                data: data?.data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                matchType: "team",
                difference: difference
            }));
        default:
            return /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: "Tennis Player Widget Not Found!"
            });
    }
};
var $0fb42d92574c267a$export$2e2bcd8739ae039 = $0fb42d92574c267a$var$TennisPlayerWidgetWrap;


const $6ab262639247c8ff$var$TennisWidgets = ({ dataId: dataId, dataType: dataType, sport: sport, difference: difference, head: head, data: data, headData: headData, baseUrl: baseUrl, loadCSS: loadCSS, setDataId: setDataId, setDataType: setDataType, setHead: setHead, setDate: setDate, date: date, setIsLive: setIsLive, isLive: isLive, dataClient: dataClient = false, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataTitle: dataTitle })=>{
    (0, $6cds3.useEffect)(()=>{
        const loadSettings = async ()=>{
            try {
                const res = await fetch(`${baseUrl}/settings`, {
                    headers: {
                        Token: undefined,
                        "Content-Type": "application/json",
                        Accept: "application/json"
                    }
                });
                if (!res.ok) throw new Error(res.statusText);
                const settings = await res.json();
                const cssVars = (0, $2d22661aa7fb4cf1$export$a964851a84ddc42f)(settings);
                const styleTag = document.createElement("style");
                styleTag.textContent = cssVars;
                document.head.appendChild(styleTag);
                document.querySelectorAll(".microservice-cont")?.forEach((el)=>el?.classList.add("hydrated"));
                return ()=>{
                    if (document.head.contains(styleTag)) document.head.removeChild(styleTag);
                };
            } catch (err) {
                console.error("Failed to load settings:", err);
            }
        };
        loadSettings();
    }, [
        baseUrl
    ]);
    const commonProps = {
        dataId: dataId,
        dataType: dataType,
        sport: sport,
        difference: difference,
        head: head,
        data: data,
        headData: headData,
        baseUrl: baseUrl,
        loadCSS: loadCSS,
        setDataId: setDataId,
        setDataType: setDataType,
        setHead: setHead,
        setDate: setDate,
        date: date,
        setIsLive: setIsLive,
        isLive: isLive,
        dataClient: dataClient,
        websiteBaseUrl: websiteBaseUrl,
        dataPath: dataPath,
        dataTitle: dataTitle
    };
    if (dataType === "live-match-detail" || dataType === "live-centre") return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3ff7d166fed572f5$export$2e2bcd8739ae039), {
        ...commonProps,
        data: data?.data,
        matchType: "all",
        socketUrl: "https://socket-bolsaas.6lgx.com/"
    });
    if (dataType?.startsWith("tennis-match") || dataType === "tennis-rankings") return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $b9aa85f5e85340fc$export$2e2bcd8739ae039), {
        ...commonProps,
        socketUrl: "https://socket-bolsaas.6lgx.com/",
        channel: "TennisMatch",
        event: `TennisDetails-${dataId}`
    });
    if (dataType?.startsWith("tennis-league-")) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $fecd27f2ac6c1c14$export$2e2bcd8739ae039), {
        ...commonProps
    });
    if (dataType?.startsWith("tennis-player-")) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0fb42d92574c267a$export$2e2bcd8739ae039), {
        ...commonProps
    });
    return /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
        children: "Widget Not Found in Tennis !"
    });
};
var $6ab262639247c8ff$export$2e2bcd8739ae039 = $6ab262639247c8ff$var$TennisWidgets;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");


var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $ba5nK = parcelRequire("ba5nK");

var $2bSDe = parcelRequire("2bSDe");

var $3G7m1 = parcelRequire("3G7m1");
const $f0180e90a4461695$var$BasketballInfoTable = ({ ServerData: ServerData, dictionary: dictionary = {}, loadCSS: loadCSS = true, dataClient: dataClient = false, title: title, sport: sport = "basketball" })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    const rawData = dataClient ? clientData : ServerData;
    // Handle both { data: {...} } and direct data structure
    const data = rawData?.data || rawData;
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document?.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS) (0, $2bSDe.loadStyles)("basketballinfo");
    }, [
        loadCSS
    ]);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            title ? /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }) : null,
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "basketball_info_container",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "basket_tv",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                            className: "global_table striped player_lineup",
                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                    children: "Rounds"
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                    children: "Q1"
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                    children: "Q2"
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                    children: "Q3"
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                    children: "Q4"
                                                }),
                                                data?.ot && /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                    children: "OT"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("tbody", {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                                            className: "players_inf",
                                                            children: [
                                                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                                    className: "avtar",
                                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                                        src: (0, $3G7m1.getImageUrl)('', '', sport, data?.competitors?.htid),
                                                                        width: 26,
                                                                        height: 26,
                                                                        alt: "home team"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                                    className: "avtar_inf",
                                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                                        className: "name",
                                                                        children: data?.competitors?.htn
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                        children: data?.q1 !== "" ? data?.q1?.split("-")?.[0] : "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                        children: data?.q2 !== "" ? data?.q2?.split("-")?.[0] : "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                        children: data?.q3 !== "" ? data?.q3?.split("-")?.[0] : "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                        children: data?.q4 !== "" ? data?.q4?.split("-")?.[0] : "-"
                                                    }),
                                                    data?.ot && /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                        children: data?.ot?.split("-")?.[0] || "-"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                                            className: "players_inf",
                                                            children: [
                                                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                                    className: "avtar",
                                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                                        src: (0, $3G7m1.getImageUrl)('', '', sport, data?.competitors?.atid),
                                                                        width: 26,
                                                                        height: 26,
                                                                        alt: "away team"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                                    className: "avtar_inf",
                                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                                        className: "name",
                                                                        children: data?.competitors?.atn
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                        children: data?.q1 !== "" ? data?.q1?.split("-")?.[1] : "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                        children: data?.q2 !== "" ? data?.q2?.split("-")?.[1] : "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                        children: data?.q3 !== "" ? data?.q3?.split("-")?.[1] : "-"
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                        children: data?.q4 !== "" ? data?.q4?.split("-")?.[1] : "-"
                                                    }),
                                                    data?.ot && /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                        children: data?.ot?.split("-")?.[1] || "-"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "basket_tv",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: "leg_head",
                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                                    children: "Venue"
                                })
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: "global_table striped basket_venue_table",
                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("table", {
                                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tbody", {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                        children: "Stadium:"
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                        children: data?.venue?.name || "-"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                        children: "Capacity:"
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                        children: data?.venue?.capacity || "-"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $f0180e90a4461695$export$2e2bcd8739ae039 = $f0180e90a4461695$var$BasketballInfoTable;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");



var $3G7m1 = parcelRequire("3G7m1");

var $2bSDe = parcelRequire("2bSDe");
const $6772cb51d4c3d10c$var$BasketballStats = ({ data: data, loadCSS: loadCSS = true, dataClient: dataClient = false, title: title })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    const [selectedQuarter, setSelectedQuarter] = (0, $6cds3.useState)("all");
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document?.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS) (0, $2bSDe.loadStyles)("basketballstats");
    }, [
        loadCSS
    ]);
    const matchStats = dataClient ? clientData : data;
    if (!matchStats) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {});
    // Get available quarters from data
    const getAvailableQuarters = ()=>{
        const quarters = [
            "all"
        ];
        if (matchStats?.q1) quarters.push("q1");
        if (matchStats?.q2) quarters.push("q2");
        if (matchStats?.q3) quarters.push("q3");
        if (matchStats?.q4) quarters.push("q4");
        if (matchStats?.ot) quarters.push("ot");
        return quarters;
    };
    const availableQuarters = getAvailableQuarters();
    // Get stats for selected quarter or all
    const getStatsForQuarter = ()=>{
        const statsData = selectedQuarter === "all" ? matchStats?.stats || matchStats : matchStats?.[selectedQuarter]?.stats || matchStats?.[selectedQuarter];
        if (!statsData) return [];
        // Common basketball stats to display
        const statKeys = [
            {
                key: "free_throws",
                label: "Free Throws"
            },
            {
                key: "two_pointers",
                label: "2 Pointers"
            },
            {
                key: "three_pointers",
                label: "3 Pointers"
            },
            {
                key: "field_goals",
                label: "Field Goals"
            },
            {
                key: "rebounds",
                label: "Rebounds"
            },
            {
                key: "defensive_rebounds",
                label: "Defensive Rebounds"
            },
            {
                key: "offensive_rebounds",
                label: "Offensive Rebounds"
            },
            {
                key: "assists",
                label: "Assists"
            },
            {
                key: "turnovers",
                label: "Turnovers"
            },
            {
                key: "blocks",
                label: "Blocks"
            },
            {
                key: "fouls",
                label: "Fouls"
            },
            {
                key: "steals",
                label: "Steals"
            },
            {
                key: "max_points_in_row",
                label: "Max Points in a Row"
            },
            {
                key: "time_spent_in_lead",
                label: "Time Spent in Lead"
            },
            {
                key: "biggest_lead",
                label: "Biggest Lead"
            }
        ];
        const formattedStats = [];
        statKeys.forEach(({ key: key, label: label })=>{
            const stat = statsData[key];
            if (stat && (stat.ht !== undefined || stat.at !== undefined)) {
                const htVal = stat.ht || 0;
                const atVal = stat.at || 0;
                formattedStats.push({
                    type: label,
                    ht: htVal,
                    at: atVal,
                    htPercent: (0, $3G7m1.calculatePercentagestats)(htVal, atVal),
                    atPercent: (0, $3G7m1.calculatePercentagestats)(atVal, htVal)
                });
            }
        });
        return formattedStats;
    };
    const stats = getStatsForQuarter();
    const quarterLabels = {
        all: "All",
        q1: "Q1",
        q2: "Q2",
        q3: "Q3",
        q4: "Q4",
        ot: "OT"
    };
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "basketball_stats_container",
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            availableQuarters.length > 1 && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "stats_filters",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: "quarter_selector",
                    children: availableQuarters.map((quarter)=>/*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                            className: `filter_button ${selectedQuarter === quarter ? "active" : ""}`,
                            onClick: ()=>setSelectedQuarter(quarter),
                            children: quarterLabels[quarter]
                        }, quarter))
                })
            }),
            stats.length > 0 ? /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "stats-holder",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $f79ba49286473462$export$2e2bcd8739ae039), {
                    stats: stats
                })
            }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {})
        ]
    });
};
var $6772cb51d4c3d10c$export$2e2bcd8739ae039 = $6772cb51d4c3d10c$var$BasketballStats;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");


var $2bSDe = parcelRequire("2bSDe");
const $5a62ea38aa5fc767$var$BasketballLineup = ({ data: data, loadCSS: loadCSS = true, dataClient: dataClient = false, title: title })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    const [activeTeam, setActiveTeam] = (0, $6cds3.useState)("home");
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document?.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS) (0, $2bSDe.loadStyles)("basketballlineup");
    }, [
        loadCSS
    ]);
    const lineupData = dataClient ? clientData : data;
    if (!lineupData) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {});
    const homeTeamLineup = lineupData?.home_team?.lineup || [];
    const awayTeamLineup = lineupData?.away_team?.lineup || [];
    const homeTeamName = lineupData?.home_team?.nm || "Home";
    const awayTeamName = lineupData?.away_team?.nm || "Away";
    const currentLineup = activeTeam === "home" ? homeTeamLineup : awayTeamLineup;
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "basketball_lineup_container",
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "lineupbox",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("nav", {
                        className: "inner_tab",
                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                    className: activeTeam === "home" ? "active" : "",
                                    onClick: ()=>setActiveTeam("home"),
                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                                        href: "#",
                                        children: homeTeamName
                                    })
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                    className: activeTeam === "away" ? "active" : "",
                                    onClick: ()=>setActiveTeam("away"),
                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                                        href: "#",
                                        children: awayTeamName
                                    })
                                })
                            ]
                        })
                    }),
                    currentLineup.length > 0 ? /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "global_table player_lineup",
                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                children: "Players"
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                children: "OR"
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                children: "SNO"
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                                children: "POS"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                                    children: currentLineup.map((player, index)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                        className: "players_inf",
                                                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                                            className: "avtar_inf",
                                                            children: [
                                                                /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                                    className: "name",
                                                                    children: player?.player?.nm || player?.nm || "-"
                                                                }),
                                                                player?.pos && /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                                    className: "inf",
                                                                    children: [
                                                                        player?.goals && /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                                            className: "count",
                                                                            children: player?.goals
                                                                        }),
                                                                        player?.pos
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                    children: player?.ord || "-"
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                    children: player?.sno || "-"
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                    children: player?.mpos || player?.pos || "-"
                                                })
                                            ]
                                        }, player?.player_id || index))
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {
                        text: "No lineup data available"
                    })
                ]
            })
        ]
    });
};
var $5a62ea38aa5fc767$export$2e2bcd8739ae039 = $5a62ea38aa5fc767$var$BasketballLineup;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");




var $2bSDe = parcelRequire("2bSDe");
const $71d7d65f5226d9ff$var$BasketballH2H = ({ data: data, loadCSS: loadCSS = true, dataClient: dataClient = false, title: title, sport: sport = "basketball" })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    const [activeTab, setActiveTab] = (0, $6cds3.useState)("meetings");
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document?.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS) {
            (0, $2bSDe.loadStyles)("h2h");
            (0, $2bSDe.loadStyles)("basketballh2h");
        }
    }, [
        loadCSS
    ]);
    const h2hData = dataClient ? clientData : data;
    console.log(clientData, data);
    // Set initial active tab based on available data
    (0, $6cds3.useEffect)(()=>{
        if (h2hData) {
            if (h2hData?.h2h?.length) setActiveTab("meetings");
            else if (h2hData?.home_team?.team) setActiveTab("home");
            else if (h2hData?.away_team?.team) setActiveTab("away");
        }
    }, [
        h2hData
    ]);
    if (!h2hData) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {});
    const getTableProps = ()=>{
        switch(activeTab){
            case "meetings":
                return {
                    data: h2hData?.h2h,
                    plays: false,
                    team: "",
                    team_id: ""
                };
            case "home":
                return {
                    data: h2hData?.home_team?.tournament,
                    plays: true,
                    team: h2hData?.home_team?.team,
                    team_id: h2hData?.home_team?.id
                };
            case "away":
                return {
                    data: h2hData?.away_team?.tournament,
                    plays: true,
                    team: h2hData?.away_team?.team,
                    team_id: h2hData?.away_team?.id
                };
            default:
                return {
                    data: null,
                    plays: false,
                    team: ""
                };
        }
    };
    const tableProps = getTableProps();
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "basketball_h2h_container",
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("nav", {
                className: "inner_tab",
                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("ul", {
                    children: [
                        h2hData?.h2h?.length > 0 && /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                            className: activeTab === "meetings" ? "active" : "",
                            onClick: ()=>setActiveTab("meetings"),
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                                href: "#",
                                children: "H2H"
                            })
                        }),
                        h2hData?.home_team?.team && /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                            className: activeTab === "home" ? "active" : "",
                            onClick: ()=>setActiveTab("home"),
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                                href: "#",
                                children: h2hData?.home_team?.team
                            })
                        }),
                        h2hData?.away_team?.team && /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                            className: activeTab === "away" ? "active" : "",
                            onClick: ()=>setActiveTab("away"),
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                                href: "#",
                                children: h2hData?.away_team?.team
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $68b69bd46a4c06c0$export$2e2bcd8739ae039), {
                ...tableProps,
                sport: sport
            }),
            h2hData?.h2h_stats?.wins && h2hData?.h2h_stats?.draws && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $9440fa542a51decf$export$2e2bcd8739ae039), {
                title: "Match",
                drawLable: true,
                t1Score: h2hData?.h2h_stats?.wins?.t1,
                t2Score: h2hData?.h2h_stats?.wins?.t2,
                t1P: h2hData?.h2h_stats?.wins?.t1p,
                t2P: h2hData?.h2h_stats?.wins?.t2p,
                drawScore: h2hData?.h2h_stats?.draws?.tot,
                drawP: h2hData?.h2h_stats?.draws?.perct
            }),
            h2hData?.h2h_stats?.ht_leading && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $9440fa542a51decf$export$2e2bcd8739ae039), {
                title: "Leading At HT",
                t1Score: h2hData?.h2h_stats?.ht_leading?.t1,
                t2Score: h2hData?.h2h_stats?.ht_leading?.t2,
                t1P: h2hData?.h2h_stats?.ht_leading?.t1p,
                t2P: h2hData?.h2h_stats?.ht_leading?.t2p
            }),
            h2hData?.h2h_stats?.ht_drawing && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $9440fa542a51decf$export$2e2bcd8739ae039), {
                title: "Drawing At HT",
                t1Score: h2hData?.h2h_stats?.ht_drawing?.t1,
                t2Score: h2hData?.h2h_stats?.ht_drawing?.t2,
                t1P: h2hData?.h2h_stats?.ht_drawing?.t1p,
                t2P: h2hData?.h2h_stats?.ht_drawing?.t2p
            }),
            h2hData?.h2h_stats?.ht_losing && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $9440fa542a51decf$export$2e2bcd8739ae039), {
                title: "Losing At HT",
                t1Score: h2hData?.h2h_stats?.ht_losing?.t1,
                t2Score: h2hData?.h2h_stats?.ht_losing?.t2,
                t1P: h2hData?.h2h_stats?.ht_losing?.t1p,
                t2P: h2hData?.h2h_stats?.ht_losing?.t2p
            })
        ]
    });
};
var $71d7d65f5226d9ff$export$2e2bcd8739ae039 = $71d7d65f5226d9ff$var$BasketballH2H;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $3G7m1 = parcelRequire("3G7m1");

var $2bSDe = parcelRequire("2bSDe");

var $ba5nK = parcelRequire("ba5nK");

const $b2e81ea8fdb5e4ad$var$BasketballMatchTable = ({ data: data, loadCSS: loadCSS = true, dataClient: dataClient = false, title: title, sport: sport = "basketball", websiteBaseUrl: websiteBaseUrl, dataPath: dataPath })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document?.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS) (0, $2bSDe.loadStyles)("leaguestandings");
    }, [
        loadCSS
    ]);
    const tableData = dataClient ? clientData : data;
    if (!tableData?.length) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "global_table standing_table rugby",
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "#"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        children: "Teams"
                                    })
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "P"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "W"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "L"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "D"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "FORM"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                        children: tableData?.map((t, index)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: t?.pc
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                                            href: (0, $3G7m1.teamLeagueInfoUrl)({
                                                dataClient: dataClient,
                                                websiteBaseUrl: websiteBaseUrl,
                                                dataPath: dataPath,
                                                category: "team",
                                                sport: sport,
                                                name: t?.nm || t?.team?.nm,
                                                id: t?.team_id || t?.team?.id
                                            }),
                                            className: "team_name",
                                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                                className: "bolar_team",
                                                children: [
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                        className: "ico_flag",
                                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                            src: (0, $3G7m1.getImageUrl)("", "", sport, t?.team_id || t?.team?.id),
                                                            width: 22,
                                                            height: 22
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                        className: "name",
                                                        children: t?.nm || t?.team?.nm
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: t?.pl
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: t?.wo
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: t?.lo
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: t?.dr
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                                            className: "prev_match_status",
                                            children: t?.lfm?.map((w, idx)=>/*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                                    className: `${w === "W" ? "win" : w === "L" ? "loss" : "draw"}`,
                                                    children: w
                                                }, idx))
                                        })
                                    })
                                ]
                            }, index))
                    })
                ]
            })
        ]
    });
};
var $b2e81ea8fdb5e4ad$export$2e2bcd8739ae039 = $b2e81ea8fdb5e4ad$var$BasketballMatchTable;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $2bSDe = parcelRequire("2bSDe");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $3G7m1 = parcelRequire("3G7m1");

var $ba5nK = parcelRequire("ba5nK");
const $40a89cdae52e045c$var$BasketballRounds = ({ score: score, data: data, sport: sport = "basketball" })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "lineupbox",
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
            className: "global_table player_lineup",
            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "Rounds"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "Q1"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "Q2"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "Q3"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "Q4"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("tbody", {
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                            className: "players_inf",
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                    className: "avtar",
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                        src: (0, $3G7m1.getImageUrl)("", "", sport, data?.htid),
                                                        width: 26,
                                                        height: 26,
                                                        alt: "player"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                    className: "avtar_inf",
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                        className: "name small",
                                                        children: data?.htn
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    score.map((h, i)=>/*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            children: h?.hScore
                                        }, data?.htid + i))
                                ]
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                            className: "players_inf",
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                    className: "avtar",
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                        src: (0, $3G7m1.getImageUrl)("", "", sport, data?.atid),
                                                        width: 26,
                                                        height: 26,
                                                        alt: "player"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                    className: "avtar_inf",
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                        className: "name small",
                                                        children: data?.atn
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    score.map((h, i)=>/*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            children: h?.aScore
                                        }, data?.atid + i))
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $40a89cdae52e045c$export$2e2bcd8739ae039 = $40a89cdae52e045c$var$BasketballRounds;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $3G7m1 = parcelRequire("3G7m1");

var $ba5nK = parcelRequire("ba5nK");
const $ef49c0c0d32feef9$var$BasketballTeamScoreBox = ({ data: data, sport: sport = "basketball" })=>{
    if (!data || data.length < 2) return null;
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "lineupbox",
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
            className: "global_table team_lineup",
            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "#"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "Team"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {}),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "W - L"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("tbody", {
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                            className: "count_num",
                                            children: data[0]?.pts
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                            className: "players_inf",
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                    className: "avtar",
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                        src: (0, $3G7m1.getImageUrl)("", "", sport, data[0]?.team_id),
                                                        width: 26,
                                                        height: 26,
                                                        alt: "player"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                    className: "avtar_inf",
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                        className: "name small",
                                                        children: data[0]?.team?.nm
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                                            className: "prev_match_status",
                                            children: (data[0]?.lfm || []).map((w, i)=>/*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                                    className: `${w === "W" ? "win" : "loss"}`,
                                                    children: w
                                                }, w + i))
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("td", {
                                        children: [
                                            data[0]?.wo,
                                            " - ",
                                            data[0]?.lo
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                            className: "count_num",
                                            children: data[1]?.pts
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                            className: "players_inf",
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                    className: "avtar",
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                        src: (0, $3G7m1.getImageUrl)("", "", sport, data[1]?.team_id),
                                                        width: 26,
                                                        height: 26,
                                                        alt: "player"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                    className: "avtar_inf",
                                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                        className: "name small",
                                                        children: data[1]?.team?.nm
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                                            className: "prev_match_status",
                                            children: (data[1]?.lfm || []).map((w, i)=>/*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                                    className: `${w === "W" ? "win" : "loss"}`,
                                                    children: w
                                                }, w + i))
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("td", {
                                        children: [
                                            data[1]?.wo,
                                            " - ",
                                            data[1]?.lo
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $ef49c0c0d32feef9$export$2e2bcd8739ae039 = $ef49c0c0d32feef9$var$BasketballTeamScoreBox;



const $7a0f525eae5276b8$var$BasketballScoring = ({ data: data, loadCSS: loadCSS = true, dataClient: dataClient = false, title: title, sport: sport = "basketball" })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document?.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS) {
            (0, $2bSDe.loadStyles)("basketballlineup");
            (0, $2bSDe.loadStyles)("basketballscoring");
        }
    }, [
        loadCSS
    ]);
    const scoringData = dataClient ? clientData : data;
    if (!scoringData) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {});
    const extractScores = (summary, quarter)=>{
        const score = summary?.[`q${quarter}`]?.split("-") || [];
        return {
            hScore: score[0] || "0",
            aScore: score[1] || "0"
        };
    };
    const scores = [];
    for(let i = 1; i <= 4; i++)scores.push(extractScores(scoringData?.summary, i));
    const hasRoundsData = scoringData?.summary?.competitors;
    const hasLeagueTableData = scoringData?.league_table?.length > 0;
    if (!hasRoundsData && !hasLeagueTableData) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {
        text: "No scoring data available"
    });
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "basketball_scoring_container",
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            hasRoundsData && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $40a89cdae52e045c$export$2e2bcd8739ae039), {
                score: scores,
                data: scoringData?.summary?.competitors,
                sport: sport
            }),
            hasLeagueTableData && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ef49c0c0d32feef9$export$2e2bcd8739ae039), {
                data: scoringData?.league_table,
                sport: sport
            })
        ]
    });
};
var $7a0f525eae5276b8$export$2e2bcd8739ae039 = $7a0f525eae5276b8$var$BasketballScoring;


const $ec1078a643790c4c$var$BasketballMatchWidgetWrap = (props)=>{
    const { dataId: dataId, dataType: dataType, head: head, data: data, headData: headData, sport: sport, difference: difference, loadCSS: loadCSS, dataClient: dataClient, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataTitle: dataTitle, socketUrl: socketUrl, channel: channel, event: event } = props;
    const renderHeadWrap = (currentTab, children)=>head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $cc0e4da7c5a2120d$export$2e2bcd8739ae039), {
            matchDetail: headData,
            difference: difference,
            sport: sport,
            dataClient: dataClient,
            id: dataId,
            currentTab: currentTab,
            websiteBaseUrl: websiteBaseUrl,
            dataPath: dataPath,
            title: dataTitle,
            socketUrl: socketUrl,
            channel: channel,
            event: event,
            children: children
        }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
            children: children
        });
    switch(dataType){
        case "basketball-match-info":
            return renderHeadWrap("info", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $f0180e90a4461695$export$2e2bcd8739ae039), {
                ServerData: data,
                loadCSS: loadCSS,
                dataClient: dataClient,
                difference: difference,
                title: dataTitle,
                sport: sport
            }));
        case "basketball-match":
            return head && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $cc0e4da7c5a2120d$export$2e2bcd8739ae039), {
                matchDetail: headData,
                difference: difference,
                sport: sport,
                dataClient: dataClient,
                id: dataId,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                title: dataTitle
            });
        case "basketball-match-stats":
            return renderHeadWrap("stats", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $6772cb51d4c3d10c$export$2e2bcd8739ae039), {
                data: data?.data,
                loadCSS: loadCSS,
                dataClient: dataClient,
                title: dataTitle
            }));
        case "basketball-match-lineup":
            return renderHeadWrap("lineup", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $5a62ea38aa5fc767$export$2e2bcd8739ae039), {
                data: data?.data,
                loadCSS: loadCSS,
                dataClient: dataClient,
                title: dataTitle
            }));
        case "basketball-match-h2h":
            return renderHeadWrap("h2h", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $71d7d65f5226d9ff$export$2e2bcd8739ae039), {
                data: data?.data,
                loadCSS: loadCSS,
                dataClient: dataClient,
                title: dataTitle,
                sport: sport
            }));
        case "basketball-match-table":
            return renderHeadWrap("table", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $b2e81ea8fdb5e4ad$export$2e2bcd8739ae039), {
                data: data?.data,
                loadCSS: loadCSS,
                dataClient: dataClient,
                title: dataTitle,
                sport: sport,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath
            }));
        case "basketball-match-scoring":
            return renderHeadWrap("scorings", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $7a0f525eae5276b8$export$2e2bcd8739ae039), {
                data: data?.data,
                loadCSS: loadCSS,
                dataClient: dataClient,
                title: dataTitle,
                sport: sport
            }));
        default:
            return /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: "Basketball Match Widget Not Found!"
            });
    }
};
var $ec1078a643790c4c$export$2e2bcd8739ae039 = $ec1078a643790c4c$var$BasketballMatchWidgetWrap;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");



const $38d7d30513161ab0$var$BasketballTeamWidgetWrap = (props)=>{
    const { dataId: dataId, dataType: dataType, head: head, data: data, headData: headData, baseUrl: baseUrl, sport: sport, loadCSS: loadCSS, dataClient: dataClient, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataTitle: dataTitle, setDataType: setDataType, setDataId: setDataId, setHead: setHead, difference: difference } = props;
    const renderHeadWrap = (currentTab, children)=>head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0881f34d53fa6722$export$2e2bcd8739ae039), {
            id: dataId,
            headData: headData,
            baseUrl: baseUrl,
            sport: "basketball",
            state: "team",
            dataClient: dataClient,
            currentTab: currentTab,
            websiteBaseUrl: websiteBaseUrl,
            dataPath: dataPath,
            widgetTitle: dataTitle,
            children: children
        }) : children;
    switch(dataType){
        case "basketball-team-info":
            return renderHeadWrap("info", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $be5ab0c7cb61a9f3$export$2e2bcd8739ae039), {
                id: dataId,
                sport: sport,
                data: data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                setDataType: setDataType,
                setDataId: setDataId,
                setHead: setHead,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                matchType: "team"
            }));
        case "basketball-team-upcoming":
            return renderHeadWrap("upcoming", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3207c25f6468a03b$export$2e2bcd8739ae039), {
                sport: sport,
                data: data?.data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                matchType: "team",
                difference: difference
            }));
        case "basketball-team-results":
            return renderHeadWrap("results", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3207c25f6468a03b$export$2e2bcd8739ae039), {
                sport: sport,
                data: data?.data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                matchType: "team",
                difference: difference
            }));
        default:
            return /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: "Basketball Player Widget Not Found!"
            });
    }
};
var $38d7d30513161ab0$export$2e2bcd8739ae039 = $38d7d30513161ab0$var$BasketballTeamWidgetWrap;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");




var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $3G7m1 = parcelRequire("3G7m1");

var $2bSDe = parcelRequire("2bSDe");
const $11abeec9ba643dbd$var$BasketballStandingTable = ({ ServerData: ServerData, loadCSS: loadCSS = true, dataClient: dataClient = false, title: title, sport: sport = "basketball", websiteBaseUrl: websiteBaseUrl, dataPath: dataPath })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    const data = dataClient ? clientData : ServerData;
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document?.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("leaguestandings");
    }, [
        loadCSS
    ]);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "global_table standing_table rugby",
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "#"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        children: "Teams"
                                    })
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "P"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "W"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "L"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "STR"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "GB"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "PCT"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "FORM"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                        children: data?.data?.table?.length && data?.data?.table.map((t, index)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: t?.pc
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                                            href: (0, $3G7m1.teamLeagueInfoUrl)({
                                                dataClient: dataClient,
                                                websiteBaseUrl: websiteBaseUrl,
                                                dataPath: dataPath,
                                                category: "team",
                                                sport: sport,
                                                name: t?.team?.nm,
                                                id: t?.team?.id
                                            }),
                                            children: t?.team?.nm
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: t?.pl
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: t?.wo
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: t?.lo
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: t?.sc
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: t?.df
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: t?.cc
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                                            className: "prev_match_status",
                                            children: t.lfm.map((w, index)=>/*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                                    className: `${w === "W" ? "win" : "loss"}`,
                                                    children: w
                                                }, index))
                                        })
                                    })
                                ]
                            }, index))
                    })
                ]
            })
        ]
    });
};
var $11abeec9ba643dbd$export$2e2bcd8739ae039 = $11abeec9ba643dbd$var$BasketballStandingTable;


const $a19fe76a09d9df12$var$BasketballLeagueWidgetWrap = (props)=>{
    const { dataId: dataId, dataType: dataType, head: head, data: data, headData: headData, baseUrl: baseUrl, sport: sport, difference: difference, loadCSS: loadCSS, dataClient: dataClient, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataTitle: dataTitle, setDataType: setDataType, setDataId: setDataId, setHead: setHead } = props;
    const renderHeadWrap = (currentTab, children)=>head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0881f34d53fa6722$export$2e2bcd8739ae039), {
            id: dataId,
            headData: headData,
            baseUrl: baseUrl,
            sport: "basketball",
            dataClient: dataClient,
            currentTab: currentTab,
            websiteBaseUrl: websiteBaseUrl,
            dataPath: dataPath,
            widgetTitle: dataTitle,
            children: children
        }) : children;
    switch(dataType){
        case "basketball-league-info":
            return renderHeadWrap("info", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $be5ab0c7cb61a9f3$export$2e2bcd8739ae039), {
                id: dataId,
                sport: sport,
                data: data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                setDataType: setDataType,
                setDataId: setDataId,
                setHead: setHead,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                difference: difference
            }));
        case "basketball-league-upcoming":
            return renderHeadWrap("upcoming", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3207c25f6468a03b$export$2e2bcd8739ae039), {
                sport: sport,
                data: data?.data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                difference: difference
            }));
        case "basketball-league-results":
            return renderHeadWrap("results", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3207c25f6468a03b$export$2e2bcd8739ae039), {
                sport: sport,
                data: data?.data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                difference: difference
            }));
        case "basketball-league-standings":
            return renderHeadWrap("table", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $11abeec9ba643dbd$export$2e2bcd8739ae039), {
                sport: sport,
                ServerData: data,
                loadCSS: loadCSS,
                dataClient: dataClient
            }));
        default:
            return /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: "Basketball League Widget Not Found!"
            });
    }
};
var $a19fe76a09d9df12$export$2e2bcd8739ae039 = $a19fe76a09d9df12$var$BasketballLeagueWidgetWrap;


const $7dede4de5c0be374$var$BasketballWidgets = ({ dataId: dataId, dataType: dataType, sport: sport, difference: difference, head: head, data: data, headData: headData, baseUrl: baseUrl, loadCSS: loadCSS, setDataId: setDataId, setDataType: setDataType, setHead: setHead, setDate: setDate, date: date, setIsLive: setIsLive, isLive: isLive, dataClient: dataClient = false, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataTitle: dataTitle })=>{
    (0, $6cds3.useEffect)(()=>{
        const loadSettings = async ()=>{
            try {
                const res = await fetch(`${baseUrl}/settings`, {
                    headers: {
                        Token: undefined,
                        "Content-Type": "application/json",
                        Accept: "application/json"
                    }
                });
                if (!res.ok) throw new Error(res.statusText);
                const settings = await res.json();
                const cssVars = (0, $2d22661aa7fb4cf1$export$a964851a84ddc42f)(settings);
                const styleTag = document.createElement("style");
                styleTag.textContent = cssVars;
                document.head.appendChild(styleTag);
                document.querySelectorAll(".microservice-cont")?.forEach((el)=>el?.classList.add("hydrated"));
                return ()=>{
                    if (document.head.contains(styleTag)) document.head.removeChild(styleTag);
                };
            } catch (err) {
                console.error("Failed to load settings:", err);
            }
        };
        loadSettings();
    }, [
        baseUrl
    ]);
    const commonProps = {
        dataId: dataId,
        dataType: dataType,
        sport: sport,
        difference: difference,
        head: head,
        data: data,
        headData: headData,
        baseUrl: baseUrl,
        loadCSS: loadCSS,
        setDataId: setDataId,
        setDataType: setDataType,
        setHead: setHead,
        setDate: setDate,
        date: date,
        setIsLive: setIsLive,
        isLive: isLive,
        dataClient: dataClient,
        websiteBaseUrl: websiteBaseUrl,
        dataPath: dataPath,
        dataTitle: dataTitle
    };
    if (dataType === "live-match-detail" || dataType === "live-centre") return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3ff7d166fed572f5$export$2e2bcd8739ae039), {
        ...commonProps,
        data: data?.data,
        matchType: "all",
        socketUrl: "https://socket-bolsaas.6lgx.com/"
    });
    if (dataType?.startsWith("basketball-match")) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ec1078a643790c4c$export$2e2bcd8739ae039), {
        ...commonProps,
        socketUrl: "https://socket-bolsaas.6lgx.com/",
        channel: "BasketballMatch",
        event: `BasketballMatchDetails-${dataId}`
    });
    if (dataType?.startsWith("basketball-league-")) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $a19fe76a09d9df12$export$2e2bcd8739ae039), {
        ...commonProps
    });
    if (dataType?.startsWith("basketball-team-")) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $38d7d30513161ab0$export$2e2bcd8739ae039), {
        ...commonProps
    });
    return /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
        children: "Widget Not Found in Basketball !"
    });
};
var $7dede4de5c0be374$export$2e2bcd8739ae039 = $7dede4de5c0be374$var$BasketballWidgets;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");


var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");


var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $ba5nK = parcelRequire("ba5nK");
const $ef288dcf5591be8b$var$SummaryBox = ({ title: title, score: score, data: data })=>{
    const baseURL = "https://ipublisher-microservices.6lgx.com";
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "summary_box",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "summary_box_head",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                        className: "title",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "points",
                        children: score
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                className: "incident_summary",
                children: data?.length ? data?.map((item, index)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                        className: item?.isH === 0 ? "reverse" : "",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                className: "mints",
                                children: [
                                    item?.mins,
                                    "'"
                                ]
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "icon_wrp",
                                children: item?.ty === "MISSED" ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                    src: `${baseURL}/public/assets/images/error.png`,
                                    width: 17,
                                    height: 18,
                                    alt: "icon"
                                }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                    src: `${baseURL}/public/assets/images/${item?.ty === "Goal" ? "icehockey.svg" : item?.ty === "SUB" ? "changer.png" : "union.png"}`,
                                    width: 17,
                                    height: 18,
                                    alt: "icon"
                                })
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "name",
                                children: item?.pl?.name
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "subName",
                                children: item?.ty
                            })
                        ]
                    }, item?.ty + index)) : /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                    children: "No Goal"
                })
            })
        ]
    });
};
var $ef288dcf5591be8b$export$2e2bcd8739ae039 = $ef288dcf5591be8b$var$SummaryBox;



var $2bSDe = parcelRequire("2bSDe");
parcelRequire("6cds3");
const $f57f8ed825d80043$export$32607eddd8650965 = (matchData)=>{
    if (!matchData) return [];
    return [
        {
            title: "1st Half",
            score: matchData?.first_half_score ?? "",
            events: matchData?.first_half_events || matchData?.events?.first_half_events || []
        },
        {
            title: "2nd Half",
            score: matchData?.second_half_score ?? "",
            events: matchData?.second_half_events || matchData?.events?.second_half_events || []
        }
    ];
};


const $87c3af3a55dfe0e4$var$RugbyInfo = ({ ServerData: ServerData, dictionary: dictionary = {}, loadCSS: loadCSS = true, dataClient: dataClient = false, title: title, baseUrl: baseUrl })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    const data = (0, $6cds3.useMemo)(()=>dataClient ? clientData : ServerData, [
        clientData,
        ServerData,
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        try {
            const raw = document?.querySelector(".microservice-cont")?.getAttribute("data-listingdata");
            if (!raw) return;
            const parsed = JSON.parse(raw)?.data?.data;
            setClientData(parsed ?? null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("rugby");
    }, [
        loadCSS
    ]);
    const halves = (0, $f57f8ed825d80043$export$32607eddd8650965)(data);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "rugby_summary",
                children: data ? halves?.map((half, index)=>/*#__PURE__*/ (0, $lBpE3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Fragment, {
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ef288dcf5591be8b$export$2e2bcd8739ae039), {
                            title: half?.title,
                            score: half?.score,
                            data: half?.events
                        }, half?.title)
                    }, index)) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $87c3af3a55dfe0e4$export$2e2bcd8739ae039 = $87c3af3a55dfe0e4$var$RugbyInfo;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");


var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $3G7m1 = parcelRequire("3G7m1");
function $f33e9175b1ddfd05$export$2e2bcd8739ae039({ home: home, away: away, title: title }) {
    const [show, setShow] = (0, $6cds3.useState)(true);
    const handleClick = ()=>{
        setShow(!show);
    };
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "lineup_box",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                className: "lineup_box_opener",
                onClick: handleClick,
                children: title
            }),
            show && /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "lineup_columns",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                        className: "list_lineup",
                        children: home?.map((player, i)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "lineup_num",
                                        children: player?.sno
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "lin_name",
                                        children: title === "Substitute" ? player?.pin_nm : player?.player?.nm
                                    })
                                ]
                            }, (0, $3G7m1.uniqueId)(player?.sno) + i))
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                        className: "list_lineup reverse",
                        children: away?.map((player, i)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "lineup_num",
                                        children: player?.sno
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "lin_name",
                                        children: title === "Substitute" ? player?.pin_nm : player?.player?.nm
                                    })
                                ]
                            }, (0, $3G7m1.uniqueId)(player?.sno) + i))
                    })
                ]
            })
        ]
    });
}



var $2bSDe = parcelRequire("2bSDe");
const $b5787f6af7c59db2$var$RugbyLineup = ({ ServerData: ServerData, dictionary: dictionary = {}, loadCSS: loadCSS = true, dataClient: dataClient = false, title: title })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    const data = (0, $6cds3.useMemo)(()=>dataClient ? clientData : ServerData, [
        clientData,
        ServerData,
        dataClient
    ]);
    const homeLineups = data?.data?.home_team?.lineup || [];
    const awayLineups = data?.data?.away_team?.lineup || [];
    const homeSubs = data?.data?.home_team?.substitutions || [];
    const awaySubs = data?.data?.away_team?.substitutions || [];
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        try {
            const raw = document?.querySelector(".microservice-cont")?.getAttribute("data-listingdata");
            if (!raw) return;
            const parsed = JSON.parse(raw)?.data;
            setClientData(parsed ?? null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("rugby");
    }, [
        loadCSS
    ]);
    const hasLineups = homeLineups.length > 0 || awayLineups.length > 0;
    const hasSubs = homeSubs.length > 0 || awaySubs.length > 0;
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            data?.data ? /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "markets_box_wrp",
                children: [
                    hasLineups && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $f33e9175b1ddfd05$export$2e2bcd8739ae039), {
                        home: homeLineups,
                        away: awayLineups,
                        title: "Starting Lineups"
                    }),
                    hasSubs && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $f33e9175b1ddfd05$export$2e2bcd8739ae039), {
                        home: homeSubs,
                        away: awaySubs,
                        title: "Substitutes"
                    })
                ]
            }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {})
        ]
    });
};
var $b5787f6af7c59db2$export$2e2bcd8739ae039 = $b5787f6af7c59db2$var$RugbyLineup;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");




var $2bSDe = parcelRequire("2bSDe");
const $45f0f348f0b81d30$var$RugbyTable = ({ ServerData: ServerData, dictionary: dictionary = {}, loadCSS: loadCSS = true, dataClient: dataClient = false, title: title, sport: sport, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    const data = (0, $6cds3.useMemo)(()=>dataClient ? clientData : ServerData, [
        clientData,
        ServerData,
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        try {
            const raw = document?.querySelector(".microservice-cont")?.getAttribute("data-listingdata");
            if (!raw) return;
            const parsed = JSON.parse(raw)?.data?.data;
            setClientData(parsed ?? null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("rugby");
    }, [
        loadCSS
    ]);
    const hasTable = data?.table?.length > 0;
    const hasGroups = data?.groups?.length > 0;
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            hasTable ? /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "global_table standing_table",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $4bcd16ab9296460a$export$2e2bcd8739ae039), {
                    table: data.table,
                    teams: data.teams,
                    sport: sport,
                    websiteBaseUrl: websiteBaseUrl,
                    dataClient: dataClient,
                    dataPath: dataPath
                })
            }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {}),
            hasGroups && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $98fe7d82f4d00250$export$2e2bcd8739ae039), {
                groups: data.groups
            })
        ]
    });
};
var $45f0f348f0b81d30$export$2e2bcd8739ae039 = $45f0f348f0b81d30$var$RugbyTable;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $2bSDe = parcelRequire("2bSDe");

var $zSRJd = parcelRequire("zSRJd");

var $3G7m1 = parcelRequire("3G7m1");

var $gtwOm = parcelRequire("gtwOm");
/**
 * RugbyMatchHead — a self-contained, live rugby match-header widget.
 *
 * Adapts to match state via a single status resolver (never scatters `st === …` checks):
 *   • Upcoming (NSY)                 → kickoff label + "VS" + live countdown
 *   • Live (Live/1st half/2nd half…) → red status tag + running score
 *   • Finished / Finished AP / AET   → "Finished" / "FAP" / "FAET" + final score, winner bold
 *   • Abandoned / Postponed / …      → the off-status word, final/known score
 *
 * Data: rugby/match/{id}/detail → `.data` (competitors, ft/cfs, dt, tournament, venue, …).
 * Live: socket channel "RugbyMatch", event "RugbyMatchDetails-{id}" → payload replaces match.
 */ const $063c45f5c2f0ccc7$var$MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
const $063c45f5c2f0ccc7$var$pad2 = (n)=>String(n).padStart(2, "0");
// Feed `dt` is a UTC wall-clock string with no zone suffix — append "Z" so it parses as UTC,
// then read it in the viewer's device timezone (or an explicit +N offset) for a correct instant.
const $063c45f5c2f0ccc7$var$kickoffMs = (dt)=>{
    if (!dt) return NaN;
    let s = String(dt).trim().replace(" ", "T");
    if (!/[zZ]$|[+\-]\d{2}:?\d{2}$/.test(s)) s += "Z";
    return new Date(s).getTime();
};
const $063c45f5c2f0ccc7$var$kickoffParts = (dt, difference)=>{
    const base = $063c45f5c2f0ccc7$var$kickoffMs(dt);
    if (isNaN(base)) return null;
    const offH = parseInt(String(difference ?? "").replace("+", ""), 10) || 0;
    const d = offH !== 0 ? new Date(base + offH * 3600000) : new Date(base);
    const g = offH !== 0 ? {
        date: d.getUTCDate(),
        month: d.getUTCMonth(),
        year: d.getUTCFullYear(),
        h: d.getUTCHours(),
        m: d.getUTCMinutes()
    } : {
        date: d.getDate(),
        month: d.getMonth(),
        year: d.getFullYear(),
        h: d.getHours(),
        m: d.getMinutes()
    };
    return g;
};
const $063c45f5c2f0ccc7$var$formatMatchDate = (dt, difference)=>{
    const p = $063c45f5c2f0ccc7$var$kickoffParts(dt, difference);
    return p ? `${p.date} ${$063c45f5c2f0ccc7$var$MONTHS[p.month]} ${p.year}` : "";
};
const $063c45f5c2f0ccc7$var$kickoffLabel = (dt, difference)=>{
    const p = $063c45f5c2f0ccc7$var$kickoffParts(dt, difference);
    return p ? `${p.date} ${$063c45f5c2f0ccc7$var$MONTHS[p.month]} \xb7 ${$063c45f5c2f0ccc7$var$pad2(p.h)}:${$063c45f5c2f0ccc7$var$pad2(p.m)}` : "Upcoming";
};
const $063c45f5c2f0ccc7$var$splitScore = (s)=>typeof s === "string" && s.includes("-") ? s.split("-").map((x)=>x.trim()) : [
        null,
        null
    ];
// ── Rugby status resolver — single source of truth for every scenario ──────────
const $063c45f5c2f0ccc7$var$RUGBY_LIVE = [
    "live",
    "1st half",
    "2nd half",
    "half time",
    "inprogress",
    "et 1st half",
    "et 2nd half"
];
const $063c45f5c2f0ccc7$var$RUGBY_FINISHED = {
    finished: "Finished",
    "finished ap": "FAP",
    "finished aet": "FAET",
    "full time": "Finished"
};
const $063c45f5c2f0ccc7$var$RUGBY_OFF = {
    cancelled: "Cancelled",
    postponed: "Postponed",
    abandoned: "Abandoned",
    deleted: "Cancelled",
    interrupted: "Interrupted",
    "result only": "Result"
};
const $063c45f5c2f0ccc7$var$resolveRugbyStatus = (stRaw)=>{
    const st = String(stRaw || "").trim();
    const low = st.toLowerCase();
    if (!st || low === "nsy") return {
        phase: "upcoming",
        label: "Upcoming",
        live: false
    };
    if ($063c45f5c2f0ccc7$var$RUGBY_LIVE.includes(low)) return {
        phase: "live",
        label: "Live",
        live: true
    };
    if ($063c45f5c2f0ccc7$var$RUGBY_FINISHED[low]) return {
        phase: "finished",
        label: $063c45f5c2f0ccc7$var$RUGBY_FINISHED[low],
        live: false
    };
    if ($063c45f5c2f0ccc7$var$RUGBY_OFF[low]) return {
        phase: "off",
        label: $063c45f5c2f0ccc7$var$RUGBY_OFF[low],
        live: false
    };
    return {
        phase: "finished",
        label: st,
        live: false
    }; // safe fallback: show the raw word
};
const $063c45f5c2f0ccc7$var$matchFromRaw = (raw)=>raw?.data ?? raw ?? null;
// ── Small pieces ───────────────────────────────────────────────────────────────
const $063c45f5c2f0ccc7$var$FormDots = ({ form: form = [] })=>{
    if (!form?.length) return null;
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "rmh__form",
        children: form.slice(0, 5).reverse().map((r, i)=>{
            const k = String(r || "").toUpperCase();
            const mod = k === "W" ? "w" : k === "L" ? "l" : "d";
            return /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                className: `rmh__dot rmh__dot--${mod}`,
                title: k,
                children: k || mod.toUpperCase()
            }, i);
        })
    });
};
const $063c45f5c2f0ccc7$var$Flag = ({ flag: flag, name: name })=>/*#__PURE__*/ (0, $lBpE3.jsx)("span", {
        className: "rmh__flag",
        children: typeof flag === "string" ? /*#__PURE__*/ (0, $lBpE3.jsx)("img", {
            src: flag,
            alt: name ? `${name} logo` : ""
        }) : flag || null
    });
const $063c45f5c2f0ccc7$var$Countdown = ({ targetMs: targetMs, whenText: whenText })=>{
    const calc = ()=>{
        const diff = targetMs - Date.now();
        if (isNaN(diff) || diff <= 0) return {
            d: 0,
            h: 0,
            m: 0,
            s: 0
        };
        return {
            d: Math.floor(diff / 86400000),
            h: Math.floor(diff / 3600000 % 24),
            m: Math.floor(diff / 60000 % 60),
            s: Math.floor(diff / 1000 % 60)
        };
    };
    const [t, setT] = (0, $6cds3.useState)(calc);
    (0, $6cds3.useEffect)(()=>{
        const id = setInterval(()=>setT(calc()), 1000);
        return ()=>clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        targetMs
    ]);
    const cell = (n, l)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
            className: "rmh__cd-cell",
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                    className: "rmh__cd-num",
                    children: String(n).padStart(2, "0")
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                    className: "rmh__cd-lbl",
                    children: l
                })
            ]
        });
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "rmh__countdown",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                className: "rmh__cd-title",
                children: "Kicks off in"
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "rmh__cd-cells",
                children: [
                    cell(t.d, "Days"),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "rmh__cd-sep",
                        children: ":"
                    }),
                    cell(t.h, "Hrs"),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "rmh__cd-sep",
                        children: ":"
                    }),
                    cell(t.m, "Min"),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "rmh__cd-sep",
                        children: ":"
                    }),
                    cell(t.s, "Sec")
                ]
            }),
            whenText ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                className: "rmh__cd-when",
                children: whenText
            }) : null
        ]
    });
};
const $063c45f5c2f0ccc7$var$Svg = ({ children: children })=>/*#__PURE__*/ (0, $lBpE3.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true",
        children: children
    });
const $063c45f5c2f0ccc7$var$ICONS = {
    date: /*#__PURE__*/ (0, $lBpE3.jsxs)($063c45f5c2f0ccc7$var$Svg, {
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("rect", {
                x: "3",
                y: "4",
                width: "18",
                height: "18",
                rx: "2"
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                d: "M16 2v4M8 2v4M3 10h18"
            })
        ]
    }),
    venue: /*#__PURE__*/ (0, $lBpE3.jsxs)($063c45f5c2f0ccc7$var$Svg, {
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                d: "M12 21s-7-6.4-7-11a7 7 0 0 1 14 0c0 4.6-7 11-7 11z"
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("circle", {
                cx: "12",
                cy: "10",
                r: "2.5"
            })
        ]
    }),
    referee: /*#__PURE__*/ (0, $lBpE3.jsxs)($063c45f5c2f0ccc7$var$Svg, {
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("circle", {
                cx: "12",
                cy: "8",
                r: "4"
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                d: "M4 21a8 8 0 0 1 16 0"
            })
        ]
    })
};
// ── Main component ───────────────────────────────────────────────────────────
const $063c45f5c2f0ccc7$var$RugbyMatchHead = ({ serverData: serverData = null, data: dataProp = null, dataId: dataId, baseUrl: baseUrl, sport: sport = "rugby", difference: difference = "+0", socketUrl: socketUrl, channel: channel = "RugbyMatch", event: event, loadCSS: loadCSS = true, dataClient: dataClient = false })=>{
    // Always load the widget's stylesheet — SSR passes loadCSS=false (it inlines interactives/
    // editorial CSS only), so gating on loadCSS would leave this standalone widget unstyled.
    (0, $6cds3.useEffect)(()=>{
        (0, $2bSDe.loadStyles)("rugbyMatchHead");
    }, []);
    const [match, setMatch] = (0, $6cds3.useState)(()=>$063c45f5c2f0ccc7$var$matchFromRaw(serverData || dataProp));
    // SSR props → state
    (0, $6cds3.useEffect)(()=>{
        const m = $063c45f5c2f0ccc7$var$matchFromRaw(serverData || dataProp);
        if (m) setMatch(m);
    }, [
        serverData,
        dataProp
    ]);
    // Hydration: re-read serialized data off the container
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        try {
            const raw = document.querySelector(".microservice-cont")?.getAttribute("data-listingdata");
            if (!raw) return;
            const parsed = JSON.parse(raw);
            const m = parsed?.headData?.data || parsed?.data?.data || parsed?.data;
            if (m) setMatch(m);
        } catch (_) {}
    }, [
        dataClient
    ]);
    // Embed: self-fetch the match detail
    (0, $6cds3.useEffect)(()=>{
        if (dataClient || match || !dataId || !baseUrl) return;
        let cancelled = false;
        (0, $zSRJd.getData)({
            dataId: dataId,
            dataType: "rugby-match-detail",
            baseUrl: baseUrl,
            sport: sport,
            difference: difference
        }).then((res)=>{
            if (cancelled) return;
            const m = $063c45f5c2f0ccc7$var$matchFromRaw(res);
            if (m) setMatch(m);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        dataClient,
        match,
        dataId,
        baseUrl,
        sport,
        difference
    ]);
    // Real-time: subscribe to the rugby match socket; payload replaces the match object.
    const resolvedSocketUrl = socketUrl || "https://socket-bolsaas.6lgx.com/";
    const socket = (0, $gtwOm.useSocket)(resolvedSocketUrl);
    (0, $6cds3.useEffect)(()=>{
        if (!socket || !dataId) return;
        const evName = event || `RugbyMatchDetails-${dataId}`;
        const handler = (e)=>{
            const incoming = $063c45f5c2f0ccc7$var$matchFromRaw(e?.data) || e?.data;
            if (!incoming) return;
            if (incoming.id != null && String(incoming.id) !== String(dataId)) return;
            setMatch((prev)=>({
                    ...prev || {},
                    ...incoming
                }));
        };
        socket.channel(channel)?.listen(evName, handler);
        return ()=>{
            try {
                socket.channel(channel)?.stopListening(evName, handler);
            } catch (_) {}
        };
    }, [
        socket,
        dataId,
        channel,
        event
    ]);
    if (!match) return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "rmh rmh--loading",
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
            children: "Loading match\u2026"
        })
    });
    const c = match.competitors || {};
    const { phase: phase, label: label, live: live } = $063c45f5c2f0ccc7$var$resolveRugbyStatus(match.st);
    const isUpcoming = phase === "upcoming";
    // Running/final score: cfs (current) while live, else ft (full-time), else fs.
    const scoreStr = (live ? match.cfs : match.ft) || match.ft || match.cfs || match.fs || "";
    const [hs, as] = $063c45f5c2f0ccc7$var$splitScore(scoreStr);
    // Winner (finished/off with a decided score): higher side wins; equal = draw (no winner).
    let winnerSide = null;
    if (!isUpcoming && !live) {
        const nh = parseInt(hs, 10);
        const na = parseInt(as, 10);
        if (!isNaN(nh) && !isNaN(na)) winnerSide = nh > na ? "home" : na > nh ? "away" : null;
    }
    const home = {
        name: c.htn,
        flag: c.htid ? (0, $3G7m1.getImageUrl)("", "", sport, c.htid) : null,
        score: hs ?? "-",
        form: c.htf
    };
    const away = {
        name: c.atn,
        flag: c.atid ? (0, $3G7m1.getImageUrl)("", "", sport, c.atid) : null,
        score: as ?? "-",
        form: c.atf
    };
    const competition = match.tournament?.nm || match.league?.nm || "";
    const stage = match.ro || "";
    const title = [
        competition,
        stage
    ].filter(Boolean).join(" \xb7 ");
    // League logo — country flag keyed by the tournament's fid (repo convention).
    const leagueFid = match.tournament?.fid || match.tournament?.football_category?.fid || match.league?.fid;
    const leagueLogo = leagueFid ? `${"https://ipublisher-microservices.6lgx.com"}/public/assets/images/flags/country_${leagueFid}.png` : null;
    const meta = {
        date: $063c45f5c2f0ccc7$var$formatMatchDate(match.dt, difference),
        venue: match.venue?.name || match.std || "",
        referee: match.match_official?.official?.name || ""
    };
    const hasFooter = meta.date || meta.venue || meta.referee;
    const cdTargetMs = isUpcoming ? $063c45f5c2f0ccc7$var$kickoffMs(match.dt) : NaN;
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: `rmh rmh--${phase}`,
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "rmh__top",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                        className: "rmh__competition",
                        children: [
                            leagueLogo ? /*#__PURE__*/ (0, $lBpE3.jsx)("img", {
                                className: "rmh__comp-logo",
                                src: leagueLogo,
                                alt: "",
                                onError: (e)=>{
                                    e.currentTarget.style.display = "none";
                                }
                            }) : null,
                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "rmh__comp-name",
                                children: title
                            })
                        ]
                    }),
                    !isUpcoming && label ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: `rmh__status${live ? " rmh__status--live" : ""}`,
                        children: label
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "rmh__main",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: `rmh__team${winnerSide === "home" ? " rmh__team--win" : ""}`,
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)($063c45f5c2f0ccc7$var$Flag, {
                                flag: home.flag,
                                name: home.name
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "rmh__name",
                                children: home.name
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)($063c45f5c2f0ccc7$var$FormDots, {
                                form: home.form
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "rmh__score",
                        children: [
                            isUpcoming ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "rmh__vs",
                                children: "VS"
                            }) : /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                className: "rmh__score-line",
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: `rmh__score-num${winnerSide === "home" ? " rmh__score-num--win" : ""}`,
                                        children: home.score ?? "-"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "rmh__score-sep",
                                        children: "\u2013"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: `rmh__score-num${winnerSide === "away" ? " rmh__score-num--win" : ""}`,
                                        children: away.score ?? "-"
                                    })
                                ]
                            }),
                            match.ht && !isUpcoming ? /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                className: "rmh__ht",
                                children: [
                                    "HT ",
                                    match.ht
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: `rmh__team${winnerSide === "away" ? " rmh__team--win" : ""}`,
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)($063c45f5c2f0ccc7$var$Flag, {
                                flag: away.flag,
                                name: away.name
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "rmh__name",
                                children: away.name
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)($063c45f5c2f0ccc7$var$FormDots, {
                                form: away.form
                            })
                        ]
                    })
                ]
            }),
            isUpcoming && !isNaN(cdTargetMs) && /*#__PURE__*/ (0, $lBpE3.jsx)($063c45f5c2f0ccc7$var$Countdown, {
                targetMs: cdTargetMs,
                whenText: $063c45f5c2f0ccc7$var$kickoffLabel(match.dt, difference)
            }),
            hasFooter && /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "rmh__footer",
                children: [
                    meta.date && /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                        className: "rmh__meta",
                        children: [
                            $063c45f5c2f0ccc7$var$ICONS.date,
                            meta.date
                        ]
                    }),
                    meta.venue && /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                        className: "rmh__meta",
                        children: [
                            $063c45f5c2f0ccc7$var$ICONS.venue,
                            meta.venue
                        ]
                    }),
                    meta.referee && /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                        className: "rmh__meta",
                        children: [
                            $063c45f5c2f0ccc7$var$ICONS.referee,
                            meta.referee
                        ]
                    })
                ]
            })
        ]
    });
};
var $063c45f5c2f0ccc7$export$2e2bcd8739ae039 = $063c45f5c2f0ccc7$var$RugbyMatchHead;


const $752e529bc1c5317b$var$RugbyMatchWidgetWrap = (props)=>{
    const { dataId: dataId, dataType: dataType, head: head, data: data, headData: headData, sport: sport, difference: difference, loadCSS: loadCSS, dataClient: dataClient, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataTitle: dataTitle, baseUrl: baseUrl, socketUrl: socketUrl, channel: channel, event: event } = props;
    const renderHeadWrap = (currentTab, children)=>head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $cc0e4da7c5a2120d$export$2e2bcd8739ae039), {
            matchDetail: headData,
            difference: difference,
            sport: sport,
            dataClient: dataClient,
            id: dataId,
            currentTab: currentTab,
            websiteBaseUrl: websiteBaseUrl,
            dataPath: dataPath,
            title: dataTitle,
            socketUrl: socketUrl,
            channel: channel,
            event: event,
            children: children
        }) : children;
    switch(dataType){
        // Self-contained, live rugby match-header widget (own header — not wrapped in <Head/>).
        case "rugby-match-detail":
            return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $063c45f5c2f0ccc7$export$2e2bcd8739ae039), {
                serverData: data?.data,
                dataId: dataId,
                baseUrl: baseUrl,
                sport: sport,
                difference: difference,
                loadCSS: loadCSS,
                dataClient: dataClient,
                socketUrl: socketUrl,
                channel: channel,
                event: event
            });
        case "rugby-match-info":
            return renderHeadWrap("info", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $87c3af3a55dfe0e4$export$2e2bcd8739ae039), {
                ServerData: data?.data,
                loadCSS: loadCSS,
                dataClient: dataClient,
                difference: difference,
                title: !head && dataTitle,
                baseUrl: baseUrl,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath
            }));
        case "rugby-match-lineup":
            return renderHeadWrap("lineup", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $b5787f6af7c59db2$export$2e2bcd8739ae039), {
                ServerData: data,
                loadCSS: loadCSS,
                dataClient: dataClient,
                difference: difference,
                title: !head && dataTitle,
                baseUrl: baseUrl,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath
            }));
        case "rugby-match-standings":
            return renderHeadWrap("standings", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $45f0f348f0b81d30$export$2e2bcd8739ae039), {
                ServerData: data?.data,
                loadCSS: loadCSS,
                dataClient: dataClient,
                difference: difference,
                title: !head && dataTitle,
                baseUrl: baseUrl,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath
            }));
        case "rugby-match":
            return head && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $cc0e4da7c5a2120d$export$2e2bcd8739ae039), {
                matchDetail: headData,
                difference: difference,
                sport: sport,
                dataClient: dataClient,
                id: dataId,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                title: dataTitle
            });
        default:
            return /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: "Rugby Match Widget Not Found!"
            });
    }
};
var $752e529bc1c5317b$export$2e2bcd8739ae039 = $752e529bc1c5317b$var$RugbyMatchWidgetWrap;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");




var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");


var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $3G7m1 = parcelRequire("3G7m1");
const $3ada10857fb9af24$var$RugbyTableRow = ({ data: data, sport: sport = "rugby", websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataClient: dataClient })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                    className: "d-inline-block align-middle",
                    children: data?.plc
                })
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: "des-wrap",
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                        href: (0, $3G7m1.teamLeagueInfoUrl)({
                            dataClient: dataClient,
                            websiteBaseUrl: websiteBaseUrl,
                            dataPath: dataPath,
                            category: "team",
                            sport: sport,
                            name: data?.team?.nm,
                            id: data?.team?.id
                        }),
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                            className: "des-text",
                            children: data?.team?.nm || data?.team
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                children: data?.pl
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                children: data?.wo
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                children: data?.dr
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                children: data?.lo
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                children: data?.pc
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                children: data?.pts
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                    className: "prev_match_status",
                    children: data.lfm.map((w, i)=>/*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                            className: `${w === 'W' ? 'win' : 'loss'}`,
                            children: w
                        }, i))
                })
            })
        ]
    });
};
var $3ada10857fb9af24$export$2e2bcd8739ae039 = $3ada10857fb9af24$var$RugbyTableRow;



var $2bSDe = parcelRequire("2bSDe");
const $210f1c77df0fd3f1$var$RugbyStandingTable = ({ ServerData: ServerData, dictionary: dictionary = {}, loadCSS: loadCSS = true, dataClient: dataClient = false, title: title, sport: sport = "rugby", websiteBaseUrl: websiteBaseUrl, dataPath: dataPath })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    const data = (0, $6cds3.useMemo)(()=>{
        const source = dataClient ? clientData : ServerData;
        return source?.data?.table ?? null;
    }, [
        clientData,
        ServerData,
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        try {
            const raw = document?.querySelector(".microservice-cont")?.getAttribute("data-listingdata");
            if (!raw) return;
            const parsed = JSON.parse(raw)?.data;
            setClientData(parsed ?? null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("rugby");
    }, [
        loadCSS
    ]);
    const sortedData = (0, $6cds3.useMemo)(()=>{
        return Array.isArray(data) ? [
            ...data
        ].sort((a, b)=>a?.plc - b?.plc) : [];
    }, [
        data
    ]);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            sortedData.length > 0 ? /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "global_table standing_table rugby",
                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "#"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                            children: "Teams"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "MP"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "W"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "D"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "L"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "TP"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "PTS"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "FORM"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                            children: sortedData.map((team, index)=>/*#__PURE__*/ (0, $lBpE3.jsx)((0, $3ada10857fb9af24$export$2e2bcd8739ae039), {
                                    data: team,
                                    index: index,
                                    sport: sport,
                                    websiteBaseUrl: websiteBaseUrl,
                                    dataPath: dataPath,
                                    dataClient: dataClient
                                }, team?.id || index))
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {})
        ]
    });
};
var $210f1c77df0fd3f1$export$2e2bcd8739ae039 = $210f1c77df0fd3f1$var$RugbyStandingTable;


const $69b47b091d330493$var$RugbyLeagueWidgetWrap = (props)=>{
    const { dataId: dataId, dataType: dataType, head: head, data: data, headData: headData, baseUrl: baseUrl, sport: sport, difference: difference, loadCSS: loadCSS, dataClient: dataClient, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataTitle: dataTitle, setDataType: setDataType, setDataId: setDataId, setHead: setHead } = props;
    const renderHeadWrap = (currentTab, children)=>head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0881f34d53fa6722$export$2e2bcd8739ae039), {
            id: dataId,
            headData: headData,
            baseUrl: baseUrl,
            sport: "rugby",
            dataClient: dataClient,
            currentTab: currentTab,
            websiteBaseUrl: websiteBaseUrl,
            dataPath: dataPath,
            widgetTitle: dataTitle,
            children: children
        }) : children;
    switch(dataType){
        case "rugby-league-info":
            return renderHeadWrap("info", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $be5ab0c7cb61a9f3$export$2e2bcd8739ae039), {
                id: dataId,
                sport: sport,
                data: data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                setDataType: setDataType,
                setDataId: setDataId,
                setHead: setHead,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                difference: difference
            }));
        case "rugby-league-upcoming":
            return renderHeadWrap("upcoming", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3207c25f6468a03b$export$2e2bcd8739ae039), {
                sport: sport,
                data: data?.data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                difference: difference
            }));
        case "rugby-league-results":
            return renderHeadWrap("results", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3207c25f6468a03b$export$2e2bcd8739ae039), {
                sport: sport,
                data: data?.data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                difference: difference,
                showTime: true
            }));
        case "rugby-league-standings":
            return renderHeadWrap("table", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $210f1c77df0fd3f1$export$2e2bcd8739ae039), {
                sport: sport,
                ServerData: data,
                loadCSS: loadCSS,
                dataClient: dataClient
            }));
        default:
            return /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: "Rugby League Widget Not Found!"
            });
    }
};
var $69b47b091d330493$export$2e2bcd8739ae039 = $69b47b091d330493$var$RugbyLeagueWidgetWrap;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");



const $6585a695453e30d0$var$RugbyTeamWidgetWrap = (props)=>{
    const { dataId: dataId, dataType: dataType, head: head, data: data, headData: headData, baseUrl: baseUrl, sport: sport, loadCSS: loadCSS, dataClient: dataClient, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataTitle: dataTitle, setDataType: setDataType, setDataId: setDataId, setHead: setHead, difference: difference } = props;
    const renderHeadWrap = (currentTab, children)=>head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0881f34d53fa6722$export$2e2bcd8739ae039), {
            id: dataId,
            headData: headData,
            baseUrl: baseUrl,
            sport: "rugby",
            state: "team",
            dataClient: dataClient,
            currentTab: currentTab,
            websiteBaseUrl: websiteBaseUrl,
            dataPath: dataPath,
            widgetTitle: dataTitle,
            children: children
        }) : children;
    switch(dataType){
        case "rugby-team-info":
            return renderHeadWrap("info", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $be5ab0c7cb61a9f3$export$2e2bcd8739ae039), {
                id: dataId,
                sport: sport,
                data: data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                setDataType: setDataType,
                setDataId: setDataId,
                setHead: setHead,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                matchType: "team"
            }));
        case "rugby-team-upcoming":
            return renderHeadWrap("upcoming", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3207c25f6468a03b$export$2e2bcd8739ae039), {
                sport: sport,
                data: data?.data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                matchType: "team",
                difference: difference
            }));
        case "rugby-team-results":
            return renderHeadWrap("results", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3207c25f6468a03b$export$2e2bcd8739ae039), {
                sport: sport,
                data: data?.data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                matchType: "team",
                difference: difference
            }));
        default:
            return /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: "Rugby Team Widget Not Found!"
            });
    }
};
var $6585a695453e30d0$export$2e2bcd8739ae039 = $6585a695453e30d0$var$RugbyTeamWidgetWrap;


const $91bd757537afc7e6$var$RugbyWidgets = ({ dataId: dataId, dataType: dataType, sport: sport, difference: difference, head: head, data: data, headData: headData, baseUrl: baseUrl, loadCSS: loadCSS, setDataId: setDataId, setDataType: setDataType, setHead: setHead, setDate: setDate, date: date, setIsLive: setIsLive, isLive: isLive, dataClient: dataClient = false, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataTitle: dataTitle })=>{
    const props = {
        dataId: dataId,
        dataType: dataType,
        sport: sport,
        difference: difference,
        head: head,
        data: data,
        headData: headData,
        baseUrl: baseUrl,
        loadCSS: loadCSS,
        setDataId: setDataId,
        setDataType: setDataType,
        setHead: setHead,
        setDate: setDate,
        date: date,
        setIsLive: setIsLive,
        isLive: isLive,
        dataClient: dataClient,
        websiteBaseUrl: websiteBaseUrl,
        dataPath: dataPath,
        dataTitle: dataTitle
    };
    // Only run on client
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(()=>{
        const loadSettings = async ()=>{
            try {
                const res = await fetch(`${baseUrl}/settings`, {
                    headers: {
                        Token: undefined,
                        "Content-Type": "application/json",
                        Accept: "application/json"
                    }
                });
                if (!res.ok) throw new Error(res.statusText);
                const settings = await res.json();
                const cssVars = (0, $2d22661aa7fb4cf1$export$a964851a84ddc42f)(settings);
                const styleTag = document.createElement("style");
                styleTag.textContent = cssVars;
                document.head.appendChild(styleTag);
                document.querySelectorAll(".microservice-cont")?.forEach((el)=>el?.classList.add("hydrated"));
                // Cleanup in React.StrictMode / HMR
                return ()=>{
                    if (document.head.contains(styleTag)) document.head.removeChild(styleTag);
                };
            } catch (err) {
                console.error("\u26A0\uFE0F Failed to load dynamic CSS settings:", err);
            }
        };
        loadSettings();
    }, [
        baseUrl
    ]);
    if (dataType?.startsWith("rugby-match")) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $752e529bc1c5317b$export$2e2bcd8739ae039), {
        ...props,
        channel: "RugbyMatch",
        event: `RugbyMatchDetails-${dataId}`
    });
    if (dataType?.startsWith("rugby-league-")) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $69b47b091d330493$export$2e2bcd8739ae039), {
        ...props
    });
    if (dataType?.startsWith("rugby-team-")) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $6585a695453e30d0$export$2e2bcd8739ae039), {
        ...props
    });
    if (dataType === "live-match-detail" || dataType === "live-centre") return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3ff7d166fed572f5$export$2e2bcd8739ae039), {
        sport: sport,
        data: data?.data,
        difference: difference,
        matchType: "all",
        loadCSS: loadCSS,
        baseUrl: baseUrl,
        dataType: dataType,
        setDataType: setDataType,
        setDataId: setDataId,
        setHead: setHead,
        setDate: setDate,
        date: date,
        setIsLive: setIsLive,
        isLive: isLive,
        dataClient: dataClient,
        websiteBaseUrl: websiteBaseUrl,
        dataPath: dataPath,
        socketUrl: "https://socket-bolsaas.6lgx.com/"
    });
    return /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
        children: "\u26A0\uFE0F Widget Not Found in Rugby!"
    });
};
var $91bd757537afc7e6$export$2e2bcd8739ae039 = $91bd757537afc7e6$var$RugbyWidgets;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");


var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

const $d98c005da78468a1$var$GolfInfoWrapper = ({ sport: sport, data: data, difference: difference, matchType: matchType, loadCSS: loadCSS, baseUrl: baseUrl, setDataId: setDataId, setDataType: setDataType, setHead: setHead, isLive: isLive, dataClient: dataClient, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)([]);
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data?.data;
            setClientData(parsed || []);
        } catch (error) {
            console.error("Failed to parse client data:", error);
        }
    }, [
        dataClient
    ]);
    const finalData = dataClient ? clientData : data;
    return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ac1fe2e4a51e05b1$export$2e2bcd8739ae039), {
            data: finalData,
            difference: difference,
            matchType: matchType,
            loadCSS: loadCSS,
            sport: sport,
            baseUrl: baseUrl,
            setDataId: setDataId,
            setDataType: setDataType,
            setHead: setHead,
            type: isLive,
            websiteBaseUrl: websiteBaseUrl,
            dataPath: dataPath,
            dataClient: dataClient
        })
    });
};
var $d98c005da78468a1$export$2e2bcd8739ae039 = $d98c005da78468a1$var$GolfInfoWrapper;



const $c390483846296092$var$GolfLeagueWidgetWrap = (props)=>{
    const { dataId: dataId, dataType: dataType, head: head, data: data, headData: headData, baseUrl: baseUrl, sport: sport, difference: difference, loadCSS: loadCSS, dataClient: dataClient, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataTitle: dataTitle, setDataType: setDataType, setDataId: setDataId, setHead: setHead } = props;
    const renderHeadWrap = (currentTab, children)=>head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0881f34d53fa6722$export$2e2bcd8739ae039), {
            id: dataId,
            headData: headData,
            baseUrl: baseUrl,
            sport: "golf",
            dataClient: dataClient,
            currentTab: currentTab,
            websiteBaseUrl: websiteBaseUrl,
            dataPath: dataPath,
            widgetTitle: dataTitle,
            children: children
        }) : children;
    switch(dataType){
        case "golf-league-info":
            return renderHeadWrap("info", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $d98c005da78468a1$export$2e2bcd8739ae039), {
                id: dataId,
                sport: sport,
                data: data?.data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                setDataType: setDataType,
                setDataId: setDataId,
                setHead: setHead,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                difference: difference
            }));
        case "golf-league-news":
            return renderHeadWrap("info", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $4c03dbc6caeb65b2$export$2e2bcd8739ae039), {
                id: dataId,
                sport: sport,
                data: data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                setDataType: setDataType,
                setDataId: setDataId,
                setHead: setHead,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                difference: difference
            }));
        default:
            return /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: "golf League Widget Not Found!"
            });
    }
};
var $c390483846296092$export$2e2bcd8739ae039 = $c390483846296092$var$GolfLeagueWidgetWrap;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");


var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");
const $35de09f889b03741$var$GolfScoreInfo = ()=>{
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("ul", {
        className: "inf_golf_circ",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "circle"
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "circle_text",
                        children: "Double-Eagle"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                className: "eagle",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "circle"
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "circle_text",
                        children: "Eagle"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                className: "birdie",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "circle"
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "circle_text",
                        children: "Birdie"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                className: "par",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "circle"
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "circle_text",
                        children: "Par"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                className: "bogey",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "circle"
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "circle_text",
                        children: "Bogey"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                className: "dou_bogey",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "circle"
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "circle_text",
                        children: "Double-Bogey"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                className: "three_bagey",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "circle"
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "circle_text",
                        children: "3+ Bogey"
                    })
                ]
            })
        ]
    });
};
var $35de09f889b03741$export$2e2bcd8739ae039 = $35de09f889b03741$var$GolfScoreInfo;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");
const $34d1cf4d5416b069$var$PlayerCard = ({ title: title, children: children })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "player_card",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "leg_head",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                    children: title
                })
            }),
            children
        ]
    });
};
var $34d1cf4d5416b069$export$2e2bcd8739ae039 = $34d1cf4d5416b069$var$PlayerCard;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $ba5nK = parcelRequire("ba5nK");

var $3G7m1 = parcelRequire("3G7m1");
const $4bf7451b8dea8ca2$var$GolfRoundTable = ({ data: data, name: name, fid: fid })=>{
    const baseURL = "https://ipublisher-microservices.6lgx.com" ?? "https://ipublisher-microservices.6lgx.com";
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "global_table golf_round_table",
        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {}),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "Hole"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "1"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "2"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "3"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "4"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "5"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "6"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "7"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "8"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "9"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "10"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "11"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "12"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "13"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "14"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "15"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "16"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "17"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "18"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $lBpE3.jsxs)("tbody", {
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {}),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                    children: "Par"
                                }),
                                data?.map((par, index)=>/*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: par?.par || '-'
                                    }, par?.par + par?.pts + index))
                            ]
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                        className: "player_name_wrp",
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                className: "flag_img",
                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                    src: `${baseURL}/public/assets/images/flags/country_${fid}.png`,
                                                    width: 32,
                                                    height: 32
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: "cr_name",
                                                children: name
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                    children: "Score"
                                }),
                                data?.map((pts, index)=>/*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                            className: `round_num ${(0, $3G7m1.getScoreColor)(pts?.pts || 0, pts?.par || 0)}`,
                                            children: pts?.pts || '-'
                                        })
                                    }, (0, $3G7m1.uniqueId)(index)))
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $4bf7451b8dea8ca2$export$2e2bcd8739ae039 = $4bf7451b8dea8ca2$var$GolfRoundTable;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $ba5nK = parcelRequire("ba5nK");
const $f54c5722441ac45c$var$GolfScoreTable = ({ data: data })=>{
    const baseURL = "https://ipublisher-microservices.6lgx.com" ?? "https://ipublisher-microservices.6lgx.com";
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "global_table golf_score_table",
        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {}),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "P"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "THRU"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "Today"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "R1"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "R2"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "R3"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "R4"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                children: "STROKES"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                    className: "player_name_wrp",
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                            className: "flag_img",
                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                src: `${baseURL}/public/assets/images/flags/country_${data?.fid}.png`,
                                                width: 32,
                                                height: 32
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                            className: "cr_name",
                                            children: data?.nm
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                    children: data?.score?.par
                                })
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                children: data?.teet || '-'
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                children: data?.score?.tdy || '-'
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                children: data?.score?.r1 || '-'
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                children: data?.score?.r2 || '-'
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                children: data?.score?.r3 || '-'
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                children: data?.score?.r4 || '-'
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                children: data?.score?.tot || '-'
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $f54c5722441ac45c$export$2e2bcd8739ae039 = $f54c5722441ac45c$var$GolfScoreTable;


const $aa2d2779363a42c9$var$GolfRounds = ({ data: data })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $34d1cf4d5416b069$export$2e2bcd8739ae039), {
                title: "Score",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $f54c5722441ac45c$export$2e2bcd8739ae039), {
                    data: data
                })
            }),
            data?.rounds?.R1 && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $34d1cf4d5416b069$export$2e2bcd8739ae039), {
                title: "Round 1",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $4bf7451b8dea8ca2$export$2e2bcd8739ae039), {
                    data: data?.rounds?.R1,
                    name: data?.nm,
                    fid: data?.fid
                })
            }),
            data?.rounds?.R2 && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $34d1cf4d5416b069$export$2e2bcd8739ae039), {
                title: "Round 2",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $4bf7451b8dea8ca2$export$2e2bcd8739ae039), {
                    data: data?.rounds?.R2,
                    name: data?.nm,
                    fid: data?.fid
                })
            }),
            data?.rounds?.R3 && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $34d1cf4d5416b069$export$2e2bcd8739ae039), {
                title: "Round 3",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $4bf7451b8dea8ca2$export$2e2bcd8739ae039), {
                    data: data?.rounds?.R3,
                    name: data?.nm,
                    fid: data?.fid
                })
            }),
            data?.rounds?.R4 && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $34d1cf4d5416b069$export$2e2bcd8739ae039), {
                title: "Round 4",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $4bf7451b8dea8ca2$export$2e2bcd8739ae039), {
                    data: data?.rounds?.R4,
                    name: data?.nm,
                    fid: data?.fid
                })
            })
        ]
    });
};
var $aa2d2779363a42c9$export$2e2bcd8739ae039 = $aa2d2779363a42c9$var$GolfRounds;



var $2bSDe = parcelRequire("2bSDe");
const $8e8d075bd4b73e07$var$PlayersDetail = ({ data: data, dataClient: dataClient, loadCSS: loadCSS })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)([]);
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data?.data;
            setClientData(parsed || []);
        } catch (error) {
            console.error("Failed to parse client data:", error);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("golf");
    }, [
        loadCSS
    ]);
    const finalData = dataClient ? clientData : data;
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "golf_players_detail",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $aa2d2779363a42c9$export$2e2bcd8739ae039), {
                data: finalData
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $35de09f889b03741$export$2e2bcd8739ae039), {})
        ]
    });
};
var $8e8d075bd4b73e07$export$2e2bcd8739ae039 = $8e8d075bd4b73e07$var$PlayersDetail;


const $8345df7936bcf1cd$var$GolfPlayerWidgetWrap = (props)=>{
    const { dataId: dataId, dataType: dataType, head: head, data: data, baseUrl: baseUrl, sport: sport, loadCSS: loadCSS, dataClient: dataClient, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataTitle: dataTitle } = props;
    const renderHeadWrap = (currentTab, children)=>head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0881f34d53fa6722$export$2e2bcd8739ae039), {
            id: dataId,
            headData: data,
            baseUrl: baseUrl,
            sport: sport,
            state: "player",
            dataClient: dataClient,
            currentTab: currentTab,
            websiteBaseUrl: websiteBaseUrl,
            dataPath: dataPath,
            widgetTitle: dataTitle,
            children: children
        }) : children;
    switch(dataType){
        case "golf-player-card":
            return renderHeadWrap("player card", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $8e8d075bd4b73e07$export$2e2bcd8739ae039), {
                data: data?.data,
                dataClient: dataClient,
                loadCSS: loadCSS
            }));
        default:
            return /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: "golf Player Widget Not Found!"
            });
    }
};
var $8345df7936bcf1cd$export$2e2bcd8739ae039 = $8345df7936bcf1cd$var$GolfPlayerWidgetWrap;


// New wrapper components
const $e6f666b350f200a3$var$GolfWidgets = ({ dataId: dataId, dataType: dataType, sport: sport, difference: difference, head: head, data: data, headData: headData, baseUrl: baseUrl, loadCSS: loadCSS, setDataId: setDataId, setDataType: setDataType, setHead: setHead, setDate: setDate, date: date, setIsLive: setIsLive, isLive: isLive, dataClient: dataClient = false, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataTitle: dataTitle })=>{
    (0, $6cds3.useEffect)(()=>{
        const loadSettings = async ()=>{
            try {
                const res = await fetch(`${baseUrl}/settings`, {
                    headers: {
                        Token: undefined,
                        "Content-Type": "application/json",
                        Accept: "application/json"
                    }
                });
                if (!res.ok) throw new Error(res.statusText);
                const settings = await res.json();
                const cssVars = (0, $2d22661aa7fb4cf1$export$a964851a84ddc42f)(settings);
                const styleTag = document.createElement("style");
                styleTag.textContent = cssVars;
                document.head.appendChild(styleTag);
                document.querySelectorAll(".microservice-cont")?.forEach((el)=>el?.classList.add("hydrated"));
                return ()=>{
                    if (document.head.contains(styleTag)) document.head.removeChild(styleTag);
                };
            } catch (err) {
                console.error("Failed to load settings:", err);
            }
        };
        loadSettings();
    }, [
        baseUrl
    ]);
    const commonProps = {
        dataId: dataId,
        dataType: dataType,
        sport: sport,
        difference: difference,
        head: head,
        data: data,
        headData: headData,
        baseUrl: baseUrl,
        loadCSS: loadCSS,
        setDataId: setDataId,
        setDataType: setDataType,
        setHead: setHead,
        setDate: setDate,
        date: date,
        setIsLive: setIsLive,
        isLive: isLive,
        dataClient: dataClient,
        websiteBaseUrl: websiteBaseUrl,
        dataPath: dataPath,
        dataTitle: dataTitle
    };
    if (dataType === "live-match-detail" || dataType === "live-centre") return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3ff7d166fed572f5$export$2e2bcd8739ae039), {
        ...commonProps,
        data: data?.data,
        matchType: "all"
    });
    if (dataType?.startsWith("golf-player")) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $8345df7936bcf1cd$export$2e2bcd8739ae039), {
        ...commonProps
    });
    if (dataType?.startsWith("golf-league-")) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $c390483846296092$export$2e2bcd8739ae039), {
        ...commonProps
    });
    return /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
        children: "Widget Not Found in Golf !"
    });
};
var $e6f666b350f200a3$export$2e2bcd8739ae039 = $e6f666b350f200a3$var$GolfWidgets;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $2bSDe = parcelRequire("2bSDe");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $ba5nK = parcelRequire("ba5nK");
const $1447e1a749103860$var$RaceCourseLeagueHead = ({ nm: nm = "Racecourse", nor: nor = 0, flag: flag = "/assets/images/flaq.png", link: link = "/" })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "leg_head",
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("a", {
                href: link,
                type: "league",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("i", {
                        className: "icon_flag",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                            src: flag,
                            alt: `${nm} flag`,
                            width: 22,
                            height: 22,
                            priority: false
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "des",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "name",
                                children: nm
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                className: "sb_inf",
                                children: [
                                    "(",
                                    nor,
                                    " Races)"
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $1447e1a749103860$export$2e2bcd8739ae039 = $1447e1a749103860$var$RaceCourseLeagueHead;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $ba5nK = parcelRequire("ba5nK");
const $c264b5cf3bef6105$var$RacecourseRow = ({ number: number, horse: horse })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "racecourse_row",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "rec_col form_num",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "num",
                        children: number
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "form_num",
                        children: horse?.ffg
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "rec_col",
                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                    className: "hors_rce",
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                            className: "img",
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                src: horse?.surl || `/assets/images/jack.png`,
                                alt: "horse",
                                width: 28,
                                height: 36,
                                priority: false
                            })
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                            className: "hors_des",
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                    className: "name",
                                    children: [
                                        horse?.nm,
                                        " ",
                                        horse?.dlst ? `(${horse?.dlst})` : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                    className: "catagory_hors",
                                    children: horse?.col
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "rec_col",
                children: horse?.age
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "rec_col",
                children: horse?.wei
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "rec_col",
                children: horse?.or
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "rec_col",
                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("ul", {
                    className: "jocker_tran",
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                    children: "J:"
                                }),
                                " ",
                                horse?.joc ? horse?.joc : "N/A"
                            ]
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                    children: "T:"
                                }),
                                " ",
                                horse?.tra
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $c264b5cf3bef6105$export$2e2bcd8739ae039 = $c264b5cf3bef6105$var$RacecourseRow;


const $e0fc95cda8fa6226$var$Racecourse = ({ raceData: raceData })=>{
    const race = raceData?.[0] || [];
    const { nm: nm = "Racecourse", nor: nor = 0, co: co = "Unknown Country", runner: runner = [] } = race;
    const flagPath = `/assets/images/flags/${co.toLowerCase().replace(/\s/g, "-")}.png`;
    const linkPath = `/race-cards/${nm.toLowerCase().replace(/\s/g, "-")}`;
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "leg_box",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $1447e1a749103860$export$2e2bcd8739ae039), {
                nm: nm ? nm : "",
                nor: nor,
                flag: flagPath,
                link: linkPath
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "racecourse",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "racecourse_hd",
                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                            className: "racecourse_row",
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                    className: "rec_col form_num",
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                            className: "num",
                                            children: "1"
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                            className: "sr_num",
                                            children: "0513"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                    className: "rec_col",
                                    children: "Horse Racing"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                    className: "rec_col",
                                    children: "Age"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                    className: "rec_col",
                                    children: "Weight"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                    className: "rec_col",
                                    children: "OR"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                    className: "rec_col",
                                    children: "Jockey/Trainer"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "racecourse_bdy",
                        children: runner?.length > 0 ? runner?.map((horse, index)=>/*#__PURE__*/ (0, $lBpE3.jsx)((0, $c264b5cf3bef6105$export$2e2bcd8739ae039), {
                                number: index + 1,
                                horse: horse
                            }, horse?.id || index)) : /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                            className: "no_runner",
                            children: "No horses available"
                        })
                    })
                ]
            })
        ]
    });
};
var $e0fc95cda8fa6226$export$2e2bcd8739ae039 = $e0fc95cda8fa6226$var$Racecourse;


const $73af155efa7323a1$var$HorseRacingCard = ({ data: data, dataClient: dataClient, loadCSS: loadCSS })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)([]);
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data;
            setClientData(parsed || []);
        } catch (error) {
            console.error("Failed to parse client data:", error);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("horse");
    }, [
        loadCSS
    ]);
    const finalData = dataClient ? clientData : data;
    const safeRaceData = {
        ...finalData?.data,
        runner: Array.isArray(finalData?.data?.runner) ? finalData?.data?.runner : []
    };
    return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $e0fc95cda8fa6226$export$2e2bcd8739ae039), {
        raceData: safeRaceData
    });
};
var $73af155efa7323a1$export$2e2bcd8739ae039 = $73af155efa7323a1$var$HorseRacingCard;


// New wrapper components
const $d708060ad8e5ccf4$var$HorseRacingWidget = ({ dataId: dataId, dataType: dataType, sport: sport, difference: difference, head: head, data: data, headData: headData, baseUrl: baseUrl, loadCSS: loadCSS, setDataId: setDataId, setDataType: setDataType, setHead: setHead, setDate: setDate, date: date, setIsLive: setIsLive, isLive: isLive, dataClient: dataClient = false, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataTitle: dataTitle })=>{
    (0, $6cds3.useEffect)(()=>{
        const loadSettings = async ()=>{
            try {
                const res = await fetch(`${baseUrl}/settings`, {
                    headers: {
                        Token: undefined,
                        "Content-Type": "application/json",
                        Accept: "application/json"
                    }
                });
                if (!res.ok) throw new Error(res.statusText);
                const settings = await res.json();
                const cssVars = (0, $2d22661aa7fb4cf1$export$a964851a84ddc42f)(settings);
                const styleTag = document.createElement("style");
                styleTag.textContent = cssVars;
                document.head.appendChild(styleTag);
                document.querySelectorAll(".microservice-cont")?.forEach((el)=>el?.classList.add("hydrated"));
                return ()=>{
                    if (document.head.contains(styleTag)) document.head.removeChild(styleTag);
                };
            } catch (err) {
                console.error("Failed to load settings:", err);
            }
        };
        loadSettings();
    }, [
        baseUrl
    ]);
    const commonProps = {
        dataId: dataId,
        dataType: dataType,
        sport: sport,
        difference: difference,
        head: head,
        data: data,
        headData: headData,
        baseUrl: baseUrl,
        loadCSS: loadCSS,
        setDataId: setDataId,
        setDataType: setDataType,
        setHead: setHead,
        setDate: setDate,
        date: date,
        setIsLive: setIsLive,
        isLive: isLive,
        dataClient: dataClient,
        websiteBaseUrl: websiteBaseUrl,
        dataPath: dataPath,
        dataTitle: dataTitle
    };
    if (dataType === "horse-racing-live") return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3ff7d166fed572f5$export$2e2bcd8739ae039), {
        ...commonProps,
        data: data?.data,
        matchType: "all"
    });
    if (dataType === "horse-racing-cards") return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $73af155efa7323a1$export$2e2bcd8739ae039), {
        ...commonProps
    });
    return /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
        children: "Widget Not Found in Horse Racing !!"
    });
};
var $d708060ad8e5ccf4$export$2e2bcd8739ae039 = $d708060ad8e5ccf4$var$HorseRacingWidget;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");


var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $ba5nK = parcelRequire("ba5nK");

var $3G7m1 = parcelRequire("3G7m1");

var $2bSDe = parcelRequire("2bSDe");
const $56f078a9b3b09f86$var$IceHockeyDetailInfo = ({ ServerData: ServerData, sport: sport, loadCSS: loadCSS, dataClient: dataClient, difference: difference, title: title, summary: summary, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    const data = dataClient ? clientData : ServerData;
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document?.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.headData?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("icehockeyMatch");
    }, [
        loadCSS
    ]);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        children: [
            title ? /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }) : null,
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "basket_tv",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: "global_table striped player_lineup",
                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                            children: "Rounds"
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                            children: "P1"
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                            children: "P2"
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                            children: "P3"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                                    className: "players_inf",
                                                    children: [
                                                        /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                            className: "avtar",
                                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                                src: (0, $3G7m1.getMatchImageUrl)(sport, data?.competitors?.htid),
                                                                width: 26,
                                                                height: 26,
                                                                alt: "team"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                            className: "avtar_inf",
                                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                                                                href: (0, $3G7m1.teamLeagueInfoUrl)({
                                                                    dataClient: dataClient,
                                                                    websiteBaseUrl: websiteBaseUrl,
                                                                    dataPath: dataPath,
                                                                    category: "team",
                                                                    sport: sport,
                                                                    name: data?.competitors?.htn,
                                                                    id: data?.competitors?.htid
                                                                }),
                                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                                    className: "name",
                                                                    children: data?.competitors?.htn
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: data?.p1?.split("-")[0] || "-"
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: data?.p2?.split("-")[0] || "-"
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: data?.p3?.split("-")[0] || "-"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                                    className: "players_inf",
                                                    children: [
                                                        /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                            className: "avtar",
                                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                                src: (0, $3G7m1.getMatchImageUrl)("icehockey", data?.competitors?.atid),
                                                                width: 26,
                                                                height: 26,
                                                                alt: "team"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                            className: "avtar_inf",
                                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                                                                href: (0, $3G7m1.teamLeagueInfoUrl)({
                                                                    dataClient: dataClient,
                                                                    websiteBaseUrl: websiteBaseUrl,
                                                                    dataPath: dataPath,
                                                                    category: "team",
                                                                    sport: sport,
                                                                    name: data?.competitors?.atn,
                                                                    id: data?.competitors?.atid
                                                                }),
                                                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("strong", {
                                                                    className: "name",
                                                                    children: data?.competitors?.atn
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: data?.p1?.split("-")[1] || "-"
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: data?.p2?.split("-")[1] || "-"
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                                children: data?.p3?.split("-")[1] || "-"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $56f078a9b3b09f86$export$2e2bcd8739ae039 = $56f078a9b3b09f86$var$IceHockeyDetailInfo;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");



var $3G7m1 = parcelRequire("3G7m1");

var $2bSDe = parcelRequire("2bSDe");
const $82d32db324d3d529$var$IceHockeyStats = ({ data: data, loadCSS: loadCSS = true, dataClient: dataClient = false, title: title })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    const [selectedPeriod, setSelectedPeriod] = (0, $6cds3.useState)("all");
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document?.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS) (0, $2bSDe.loadStyles)("matchstat");
    }, [
        loadCSS
    ]);
    const matchStats = dataClient ? clientData : data;
    if (!matchStats) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {});
    // Get available periods from data
    const getAvailablePeriods = ()=>{
        const periods = [
            "all"
        ];
        if (matchStats?.p1) periods.push("p1");
        if (matchStats?.p2) periods.push("p2");
        if (matchStats?.p3) periods.push("p3");
        if (matchStats?.ot) periods.push("ot");
        return periods;
    };
    const availablePeriods = getAvailablePeriods();
    // Get stats for selected period or all
    const getStatsForPeriod = ()=>{
        const statsData = selectedPeriod === "all" ? matchStats?.stats || matchStats : matchStats?.[selectedPeriod]?.stats || matchStats?.[selectedPeriod];
        if (!statsData) return [];
        // Common ice hockey stats to display
        const statKeys = [
            {
                key: "shots_on_goal",
                label: "Shots on Goal"
            },
            {
                key: "shots",
                label: "Shots"
            },
            {
                key: "blocked_shots",
                label: "Blocked Shots"
            },
            {
                key: "power_plays",
                label: "Power Plays"
            },
            {
                key: "power_play_goals",
                label: "Power Play Goals"
            },
            {
                key: "penalty_minutes",
                label: "Penalty Minutes"
            },
            {
                key: "hits",
                label: "Hits"
            },
            {
                key: "faceoffs_won",
                label: "Faceoffs Won"
            },
            {
                key: "giveaways",
                label: "Giveaways"
            },
            {
                key: "takeaways",
                label: "Takeaways"
            },
            {
                key: "saves",
                label: "Saves"
            },
            {
                key: "save_percentage",
                label: "Save %"
            }
        ];
        const formattedStats = [];
        statKeys.forEach(({ key: key, label: label })=>{
            const stat = statsData[key];
            if (stat && (stat.ht !== undefined || stat.at !== undefined)) {
                const htVal = stat.ht || 0;
                const atVal = stat.at || 0;
                formattedStats.push({
                    type: label,
                    ht: htVal,
                    at: atVal,
                    htPercent: (0, $3G7m1.calculatePercentagestats)(htVal, atVal),
                    atPercent: (0, $3G7m1.calculatePercentagestats)(atVal, htVal)
                });
            }
        });
        return formattedStats;
    };
    const stats = getStatsForPeriod();
    const periodLabels = {
        all: "All",
        p1: "P1",
        p2: "P2",
        p3: "P3",
        ot: "OT"
    };
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "icehockey_stats_container",
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            availablePeriods.length > 1 && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "stats_filters",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: "period_selector",
                    children: availablePeriods.map((period)=>/*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                            className: `filter_button ${selectedPeriod === period ? "active" : ""}`,
                            onClick: ()=>setSelectedPeriod(period),
                            children: periodLabels[period]
                        }, period))
                })
            }),
            stats.length > 0 ? /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "stats-holder",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $f79ba49286473462$export$2e2bcd8739ae039), {
                    stats: stats
                })
            }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {})
        ]
    });
};
var $82d32db324d3d529$export$2e2bcd8739ae039 = $82d32db324d3d529$var$IceHockeyStats;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");




var $2bSDe = parcelRequire("2bSDe");
const $d8429a315b74c12a$var$IceHockeyH2H = ({ data: data, loadCSS: loadCSS = true, dataClient: dataClient = false, title: title, sport: sport = "icehockey" })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    const [activeTab, setActiveTab] = (0, $6cds3.useState)("meetings");
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document?.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS) (0, $2bSDe.loadStyles)("h2h");
    }, [
        loadCSS
    ]);
    const h2hData = dataClient ? clientData : data;
    // Set initial active tab based on available data
    (0, $6cds3.useEffect)(()=>{
        if (h2hData) {
            if (h2hData?.h2h?.length) setActiveTab("meetings");
            else if (h2hData?.home_team?.team) setActiveTab("home");
            else if (h2hData?.away_team?.team) setActiveTab("away");
        }
    }, [
        h2hData
    ]);
    if (!h2hData) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {});
    const getTableProps = ()=>{
        switch(activeTab){
            case "meetings":
                return {
                    data: h2hData?.h2h,
                    plays: false,
                    team: "",
                    team_id: ""
                };
            case "home":
                return {
                    data: h2hData?.home_team?.tournament,
                    plays: true,
                    team: h2hData?.home_team?.team,
                    team_id: h2hData?.home_team?.id
                };
            case "away":
                return {
                    data: h2hData?.away_team?.tournament,
                    plays: true,
                    team: h2hData?.away_team?.team,
                    team_id: h2hData?.away_team?.id
                };
            default:
                return {
                    data: null,
                    plays: false,
                    team: ""
                };
        }
    };
    const tableProps = getTableProps();
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "icehockey_h2h_container",
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("nav", {
                className: "inner_tab",
                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("ul", {
                    children: [
                        h2hData?.h2h?.length > 0 && /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                            className: activeTab === "meetings" ? "active" : "",
                            onClick: ()=>setActiveTab("meetings"),
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                                href: "#",
                                children: "H2H"
                            })
                        }),
                        h2hData?.home_team?.team && /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                            className: activeTab === "home" ? "active" : "",
                            onClick: ()=>setActiveTab("home"),
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                                href: "#",
                                children: h2hData?.home_team?.team
                            })
                        }),
                        h2hData?.away_team?.team && /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                            className: activeTab === "away" ? "active" : "",
                            onClick: ()=>setActiveTab("away"),
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                                href: "#",
                                children: h2hData?.away_team?.team
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $68b69bd46a4c06c0$export$2e2bcd8739ae039), {
                ...tableProps,
                sport: sport
            }),
            h2hData?.h2h_stats?.wins && h2hData?.h2h_stats?.draws && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $9440fa542a51decf$export$2e2bcd8739ae039), {
                title: "Match",
                drawLable: true,
                t1Score: h2hData?.h2h_stats?.wins?.t1,
                t2Score: h2hData?.h2h_stats?.wins?.t2,
                t1P: h2hData?.h2h_stats?.wins?.t1p,
                t2P: h2hData?.h2h_stats?.wins?.t2p,
                drawScore: h2hData?.h2h_stats?.draws?.tot,
                drawP: h2hData?.h2h_stats?.draws?.perct
            }),
            h2hData?.h2h_stats?.ht_leading && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $9440fa542a51decf$export$2e2bcd8739ae039), {
                title: "Leading At HT",
                t1Score: h2hData?.h2h_stats?.ht_leading?.t1,
                t2Score: h2hData?.h2h_stats?.ht_leading?.t2,
                t1P: h2hData?.h2h_stats?.ht_leading?.t1p,
                t2P: h2hData?.h2h_stats?.ht_leading?.t2p
            }),
            h2hData?.h2h_stats?.ht_drawing && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $9440fa542a51decf$export$2e2bcd8739ae039), {
                title: "Drawing At HT",
                t1Score: h2hData?.h2h_stats?.ht_drawing?.t1,
                t2Score: h2hData?.h2h_stats?.ht_drawing?.t2,
                t1P: h2hData?.h2h_stats?.ht_drawing?.t1p,
                t2P: h2hData?.h2h_stats?.ht_drawing?.t2p
            }),
            h2hData?.h2h_stats?.ht_losing && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $9440fa542a51decf$export$2e2bcd8739ae039), {
                title: "Losing At HT",
                t1Score: h2hData?.h2h_stats?.ht_losing?.t1,
                t2Score: h2hData?.h2h_stats?.ht_losing?.t2,
                t1P: h2hData?.h2h_stats?.ht_losing?.t1p,
                t2P: h2hData?.h2h_stats?.ht_losing?.t2p
            })
        ]
    });
};
var $d8429a315b74c12a$export$2e2bcd8739ae039 = $d8429a315b74c12a$var$IceHockeyH2H;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $3G7m1 = parcelRequire("3G7m1");

var $2bSDe = parcelRequire("2bSDe");

var $ba5nK = parcelRequire("ba5nK");

const $3386fd48e4eb3278$var$IceHockeyMatchTable = ({ data: data, loadCSS: loadCSS = true, dataClient: dataClient = false, title: title, sport: sport = "icehockey", websiteBaseUrl: websiteBaseUrl, dataPath: dataPath })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document?.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS) (0, $2bSDe.loadStyles)("leaguestandings");
    }, [
        loadCSS
    ]);
    const rawData = dataClient ? clientData : data;
    console.log(rawData);
    const tableData = rawData || rawData;
    if (!tableData?.length) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0ce20e138f099eec$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "global_table standing_table rugby",
        children: [
            title && /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: title
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "#"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        children: "Teams"
                                    })
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "P"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "W"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "L"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "D"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "GF"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "GA"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "PTS"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                    children: "FORM"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                        children: tableData?.map((t, index)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: t?.pc || t?.plc
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                                            href: (0, $3G7m1.teamLeagueInfoUrl)({
                                                dataClient: dataClient,
                                                websiteBaseUrl: websiteBaseUrl,
                                                dataPath: dataPath,
                                                category: "team",
                                                sport: sport,
                                                name: t?.nm || t?.team?.nm || t?.tnam,
                                                id: t?.team_id || t?.team?.id || t?.tid
                                            }),
                                            className: "team_name",
                                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                                className: "bolar_team",
                                                children: [
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                                        className: "ico_flag",
                                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                            src: (0, $3G7m1.getImageUrl)("", "", sport, t?.team_id || t?.team?.id || t?.tid),
                                                            width: 22,
                                                            height: 22
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                        className: "name",
                                                        children: t?.nm || t?.team?.nm || t?.tnam
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: t?.pl || t?.ply
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: t?.wo || t?.wins
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: t?.lo || t?.los
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: t?.dr || t?.dra
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: t?.gf || t?.gol_f
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: t?.ga || t?.gol_ag
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: t?.pts
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                                            className: "prev_match_status",
                                            children: (t?.lfm || t?.form?.split(""))?.map((w, idx)=>/*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                                                    className: `${w === "W" ? "win" : w === "L" ? "loss" : "draw"}`,
                                                    children: w
                                                }, idx))
                                        })
                                    })
                                ]
                            }, index))
                    })
                ]
            })
        ]
    });
};
var $3386fd48e4eb3278$export$2e2bcd8739ae039 = $3386fd48e4eb3278$var$IceHockeyMatchTable;


const $b60f3a43d35daacb$var$IceHockeyMatchWidgetWrap = (props)=>{
    const { dataId: dataId, dataType: dataType, head: head, data: data, headData: headData, sport: sport, difference: difference, loadCSS: loadCSS, dataClient: dataClient, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataTitle: dataTitle, socketUrl: socketUrl, channel: channel, event: event } = props;
    const renderHeadWrap = (currentTab, children)=>head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $cc0e4da7c5a2120d$export$2e2bcd8739ae039), {
            matchDetail: headData,
            difference: difference,
            sport: sport,
            dataClient: dataClient,
            id: dataId,
            currentTab: currentTab,
            websiteBaseUrl: websiteBaseUrl,
            dataPath: dataPath,
            title: dataTitle,
            socketUrl: socketUrl,
            channel: channel,
            event: event,
            children: children
        }) : children;
    switch(dataType){
        case "icehockey-match-info":
            return renderHeadWrap("info", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $56f078a9b3b09f86$export$2e2bcd8739ae039), {
                ServerData: headData?.data,
                loadCSS: loadCSS,
                dataClient: dataClient,
                difference: difference,
                title: dataTitle,
                sport: sport,
                summary: data?.data,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath
            }));
        case "icehockey-match":
            return head && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $cc0e4da7c5a2120d$export$2e2bcd8739ae039), {
                matchDetail: headData,
                difference: difference,
                sport: sport,
                dataClient: dataClient,
                id: dataId,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                title: dataTitle
            });
        case "icehockey-match-stats":
            return renderHeadWrap("stats", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $82d32db324d3d529$export$2e2bcd8739ae039), {
                data: data?.data,
                loadCSS: loadCSS,
                dataClient: dataClient,
                title: dataTitle
            }));
        case "icehockey-match-h2h":
            return renderHeadWrap("h2h", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $d8429a315b74c12a$export$2e2bcd8739ae039), {
                data: data?.data,
                loadCSS: loadCSS,
                dataClient: dataClient,
                title: dataTitle,
                sport: sport
            }));
        case "icehockey-match-table":
            return renderHeadWrap("table", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3386fd48e4eb3278$export$2e2bcd8739ae039), {
                data: data?.data,
                loadCSS: loadCSS,
                dataClient: dataClient,
                title: dataTitle,
                sport: sport,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath
            }));
        default:
            return /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: "Ice Hockey Match Widget Not Found!"
            });
    }
};
var $b60f3a43d35daacb$export$2e2bcd8739ae039 = $b60f3a43d35daacb$var$IceHockeyMatchWidgetWrap;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");




var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $2bSDe = parcelRequire("2bSDe");

var $ba5nK = parcelRequire("ba5nK");


var $3G7m1 = parcelRequire("3G7m1");
const $43838ee395459504$var$IceHockeyStandingTable = ({ ServerData: ServerData, loadCSS: loadCSS = true, dataClient: dataClient = false, title: title, sport: sport = "icehockey", websiteBaseUrl: websiteBaseUrl, dataPath: dataPath })=>{
    const [clientData, setClientData] = (0, $6cds3.useState)(null);
    const data = dataClient ? clientData : ServerData;
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        const container = document?.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;
        try {
            const parsed = JSON.parse(raw)?.data?.data;
            setClientData(parsed || null);
        } catch (err) {
            console.error("Failed to parse data-listingdata:", err);
        }
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === "true") (0, $2bSDe.loadStyles)("leaguestandings");
    }, [
        loadCSS
    ]);
    const items = Object?.keys(data || {})?.map((key)=>({
            label: key,
            value: key
        })) || [];
    const [activeItem, setActiveItem] = (0, $6cds3.useState)(items[0]?.label || null);
    const getFilteredData = (activeItem)=>{
        if (!data || !activeItem) return [];
        return data[activeItem] || [];
    };
    (0, $6cds3.useEffect)(()=>{
        if (items.length > 0 && !activeItem) setActiveItem(items[0].value);
    }, [
        items,
        activeItem
    ]);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $811e55a24e3734b4$export$2e2bcd8739ae039), {
                items: items,
                activeItem: activeItem,
                onClick: setActiveItem
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: `global_table   ice_team_table`,
                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "#"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "Teams"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "P"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "W"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "D"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "L"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "W(AET)"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "L(AET)"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "W(AP)"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "L(AP)"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "F"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "AG"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "DIFF"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        children: "PTS"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                            children: getFilteredData(activeItem)?.map((row, i)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsxs)("td", {
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    className: "hi-border",
                                                    style: {
                                                        backgroundColor: `${row?.clr}`
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    className: "d-inline-block align-middle",
                                                    children: row?.plc
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                                                href: (0, $3G7m1.teamLeagueInfoUrl)({
                                                    dataClient: dataClient,
                                                    websiteBaseUrl: websiteBaseUrl,
                                                    dataPath: dataPath,
                                                    category: "team",
                                                    sport: sport,
                                                    name: row?.tnam,
                                                    id: row?.tid
                                                }),
                                                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                                    className: "des-wrap",
                                                    children: [
                                                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                            className: "flg_img",
                                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                                                src: (0, $3G7m1.getImageUrl)('', '', sport, row?.tid),
                                                                height: 23,
                                                                width: 23,
                                                                alt: "teamLogo",
                                                                priority: false
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                            className: "des-text",
                                                            children: row?.tnam
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            children: row?.ply
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            children: row?.wins
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            children: row?.dra
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            children: row?.los
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            children: row?.w_aet
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            children: row?.los_aet
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            children: row?.wi_ap
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            children: row?.los_ap
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            children: row?.gol_f
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            children: row?.gol_ag
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            children: row?.gol_dif
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            children: row?.pts
                                        })
                                    ]
                                }, i))
                        })
                    ]
                })
            })
        ]
    });
};
var $43838ee395459504$export$2e2bcd8739ae039 = $43838ee395459504$var$IceHockeyStandingTable;


const $d3d07baf91f78f00$var$IceHockeyLeagueWidgetWrap = (props)=>{
    const { dataId: dataId, dataType: dataType, head: head, data: data, headData: headData, baseUrl: baseUrl, sport: sport, difference: difference, loadCSS: loadCSS, dataClient: dataClient, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataTitle: dataTitle, setDataType: setDataType, setDataId: setDataId, setHead: setHead } = props;
    const renderHeadWrap = (currentTab, children)=>head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0881f34d53fa6722$export$2e2bcd8739ae039), {
            id: dataId,
            headData: headData,
            baseUrl: baseUrl,
            sport: "icehockey",
            dataClient: dataClient,
            currentTab: currentTab,
            websiteBaseUrl: websiteBaseUrl,
            dataPath: dataPath,
            widgetTitle: dataTitle,
            children: children
        }) : children;
    switch(dataType){
        case "icehockey-league-info":
            return renderHeadWrap("info", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $be5ab0c7cb61a9f3$export$2e2bcd8739ae039), {
                id: dataId,
                sport: sport,
                data: data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                setDataType: setDataType,
                setDataId: setDataId,
                setHead: setHead,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                difference: difference
            }));
        case "icehockey-league-upcoming":
            return renderHeadWrap("upcoming", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3207c25f6468a03b$export$2e2bcd8739ae039), {
                sport: sport,
                data: data?.data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                difference: difference
            }));
        case "icehockey-league-results":
            return renderHeadWrap("results", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3207c25f6468a03b$export$2e2bcd8739ae039), {
                sport: sport,
                data: data?.data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                difference: difference
            }));
        case "icehockey-league-standings":
            return renderHeadWrap("table", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $43838ee395459504$export$2e2bcd8739ae039), {
                sport: sport,
                ServerData: data?.data,
                loadCSS: loadCSS,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath
            }));
        default:
            return /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: "Basketball League Widget Not Found!"
            });
    }
};
var $d3d07baf91f78f00$export$2e2bcd8739ae039 = $d3d07baf91f78f00$var$IceHockeyLeagueWidgetWrap;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");



const $1dc0ddac6f039e4a$var$IceHockeyTeamWidgetWrap = (props)=>{
    const { dataId: dataId, dataType: dataType, head: head, data: data, headData: headData, baseUrl: baseUrl, sport: sport, loadCSS: loadCSS, dataClient: dataClient, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataTitle: dataTitle, setDataType: setDataType, setDataId: setDataId, setHead: setHead, difference: difference } = props;
    const renderHeadWrap = (currentTab, children)=>head ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0881f34d53fa6722$export$2e2bcd8739ae039), {
            id: dataId,
            headData: headData,
            baseUrl: baseUrl,
            sport: "icehockey",
            state: "team",
            dataClient: dataClient,
            currentTab: currentTab,
            websiteBaseUrl: websiteBaseUrl,
            dataPath: dataPath,
            widgetTitle: dataTitle,
            children: children
        }) : children;
    switch(dataType){
        case "icehockey-team-info":
            return renderHeadWrap("info", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $be5ab0c7cb61a9f3$export$2e2bcd8739ae039), {
                id: dataId,
                sport: sport,
                data: data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                setDataType: setDataType,
                setDataId: setDataId,
                setHead: setHead,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                matchType: "team"
            }));
        case "icehockey-team-upcoming":
            return renderHeadWrap("upcoming", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3207c25f6468a03b$export$2e2bcd8739ae039), {
                sport: sport,
                data: data?.data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                matchType: "team",
                difference: difference
            }));
        case "icehockey-team-results":
            return renderHeadWrap("results", /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3207c25f6468a03b$export$2e2bcd8739ae039), {
                sport: sport,
                data: data?.data,
                loadCSS: loadCSS,
                baseUrl: baseUrl,
                dataClient: dataClient,
                websiteBaseUrl: websiteBaseUrl,
                dataPath: dataPath,
                matchType: "team",
                difference: difference
            }));
        default:
            return /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: "Ice Hockey Team Widget Not Found!"
            });
    }
};
var $1dc0ddac6f039e4a$export$2e2bcd8739ae039 = $1dc0ddac6f039e4a$var$IceHockeyTeamWidgetWrap;


const $a63d2f8c41fc1b1a$var$IceHockeyWidgets = ({ dataId: dataId, dataType: dataType, sport: sport, difference: difference, head: head, data: data, headData: headData, baseUrl: baseUrl, loadCSS: loadCSS, setDataId: setDataId, setDataType: setDataType, setHead: setHead, setDate: setDate, date: date, setIsLive: setIsLive, isLive: isLive, dataClient: dataClient = false, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dataTitle: dataTitle })=>{
    (0, $6cds3.useEffect)(()=>{
        const loadSettings = async ()=>{
            try {
                const res = await fetch(`${baseUrl}/settings`, {
                    headers: {
                        Token: undefined,
                        "Content-Type": "application/json",
                        Accept: "application/json"
                    }
                });
                if (!res.ok) throw new Error(res.statusText);
                const settings = await res.json();
                const cssVars = (0, $2d22661aa7fb4cf1$export$a964851a84ddc42f)(settings);
                const styleTag = document.createElement("style");
                styleTag.textContent = cssVars;
                document.head.appendChild(styleTag);
                document.querySelectorAll(".microservice-cont")?.forEach((el)=>el?.classList.add("hydrated"));
                return ()=>{
                    if (document.head.contains(styleTag)) document.head.removeChild(styleTag);
                };
            } catch (err) {
                console.error("Failed to load settings:", err);
            }
        };
        loadSettings();
    }, [
        baseUrl
    ]);
    const commonProps = {
        dataId: dataId,
        dataType: dataType,
        sport: sport,
        difference: difference,
        head: head,
        data: data,
        headData: headData,
        baseUrl: baseUrl,
        loadCSS: loadCSS,
        setDataId: setDataId,
        setDataType: setDataType,
        setHead: setHead,
        setDate: setDate,
        date: date,
        setIsLive: setIsLive,
        isLive: isLive,
        dataClient: dataClient,
        websiteBaseUrl: websiteBaseUrl,
        dataPath: dataPath,
        dataTitle: dataTitle
    };
    if (dataType === "live-match-detail" || dataType === "live-centre") return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3ff7d166fed572f5$export$2e2bcd8739ae039), {
        ...commonProps,
        data: data?.data,
        matchType: "all"
    });
    if (dataType?.startsWith("icehockey-match")) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $b60f3a43d35daacb$export$2e2bcd8739ae039), {
        ...commonProps
    });
    if (dataType?.startsWith("icehockey-league-")) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $d3d07baf91f78f00$export$2e2bcd8739ae039), {
        ...commonProps
    });
    if (dataType?.startsWith("icehockey-team-")) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $1dc0ddac6f039e4a$export$2e2bcd8739ae039), {
        ...commonProps
    });
    return /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
        children: "Widget Not Found in Ice Hockey !"
    });
};
var $a63d2f8c41fc1b1a$export$2e2bcd8739ae039 = $a63d2f8c41fc1b1a$var$IceHockeyWidgets;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $2bSDe = parcelRequire("2bSDe");

var $zSRJd = parcelRequire("zSRJd");

var $R8nvx = parcelRequire("R8nvx");
/**
 * F1ChampionshipStandings — "Classifica Campionato" (F1 championship standings).
 *
 * Two tabs: Drivers (formula1/driver-standings) and Constructors (formula1/team-standings).
 * Self-contained: serverData seeds the drivers tab for SSR; the constructors tab and the
 * embed path self-fetch. No Home/Away, no race selector — just the season standings.
 *
 * Driver row:      { pid, nm, teamId, team, pts, pos, tnm }
 * Constructor row: { teamId, team, pts, pos, tnm }
 */ const $4614504340a979ad$var$rowsFromRaw = (raw)=>{
    const d = raw?.data ?? raw;
    if (Array.isArray(d)) return d;
    if (Array.isArray(d?.data)) return d.data;
    return [];
};
const $4614504340a979ad$var$mapDriver = (r)=>({
        id: r?.pid ?? r?.id,
        name: r?.nm || "",
        team: r?.team || "",
        teamId: r?.teamId,
        pos: r?.pos ?? null,
        pts: r?.pts ?? 0
    });
const $4614504340a979ad$var$mapTeam = (r)=>({
        id: r?.teamId ?? r?.id,
        name: r?.team || "",
        pos: r?.pos ?? null,
        pts: r?.pts ?? 0
    });
const $4614504340a979ad$var$byPos = (a, b)=>(a.pos ?? 1e9) - (b.pos ?? 1e9);
// Images built from ids against the CDN root (no /api/v1). Missing → hidden via onError.
const $4614504340a979ad$var$driverImg = (id)=>id ? `${(0, $R8nvx.getImgUrl)()}/v1/sports/motorsport/driver-pictures/${id}.png` : null;
const $4614504340a979ad$var$teamImg = (id)=>id ? `${(0, $R8nvx.getImgUrl)()}/v1/sports/team-logos/${id}.png` : null;
const $4614504340a979ad$var$podiumClass = (pos)=>pos === 1 ? " f1__row--p1" : pos === 2 ? " f1__row--p2" : pos === 3 ? " f1__row--p3" : "";
const $4614504340a979ad$var$Avatar = ({ src: src, name: name, kind: kind })=>/*#__PURE__*/ (0, $lBpE3.jsx)("span", {
        className: `f1__crest f1__crest--${kind}`,
        children: src ? /*#__PURE__*/ (0, $lBpE3.jsx)("img", {
            src: src,
            alt: name ? `${name}` : "",
            loading: "lazy",
            onError: (e)=>{
                e.currentTarget.style.display = "none";
            }
        }) : null
    });
const $4614504340a979ad$var$F1ChampionshipStandings = ({ serverData: serverData = null, data: dataProp = null, dataId: dataId, baseUrl: baseUrl, sport: sport = "formula1", loadCSS: loadCSS = true, dataClient: dataClient = false, title: title = "Championship Standings" })=>{
    (0, $6cds3.useEffect)(()=>{
        (0, $2bSDe.loadStyles)("f1Standings");
    }, []);
    const seed = $4614504340a979ad$var$rowsFromRaw(serverData || dataProp);
    const [tab, setTab] = (0, $6cds3.useState)("drivers");
    const [expanded, setExpanded] = (0, $6cds3.useState)(false);
    const [drivers, setDrivers] = (0, $6cds3.useState)(()=>seed.map($4614504340a979ad$var$mapDriver).sort($4614504340a979ad$var$byPos));
    const [teams, setTeams] = (0, $6cds3.useState)([]);
    const [season, setSeason] = (0, $6cds3.useState)(()=>seed[0]?.tnm || "");
    const selectTab = (t)=>{
        setTab(t);
        setExpanded(false); // collapse back to the top 5 when switching tabs
    };
    // Hydration: re-read the serialized driver payload off the container.
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        try {
            const el = document.querySelector(".microservice-cont");
            const parsed = JSON.parse(el?.getAttribute("data-listingdata") || "null");
            const rows = $4614504340a979ad$var$rowsFromRaw(parsed?.data);
            if (rows.length) {
                setDrivers(rows.map($4614504340a979ad$var$mapDriver).sort($4614504340a979ad$var$byPos));
                setSeason(rows[0]?.tnm || "");
            }
        } catch (_) {}
    }, [
        dataClient
    ]);
    // Embed: self-fetch drivers if we have none.
    (0, $6cds3.useEffect)(()=>{
        if (drivers.length || !baseUrl) return;
        let cancelled = false;
        (0, $zSRJd.getData)({
            dataType: "f1-driver-standings",
            baseUrl: baseUrl,
            sport: sport
        }).then((res)=>{
            if (cancelled) return;
            const rows = $4614504340a979ad$var$rowsFromRaw(res);
            if (rows.length) {
                setDrivers(rows.map($4614504340a979ad$var$mapDriver).sort($4614504340a979ad$var$byPos));
                setSeason(rows[0]?.tnm || "");
            }
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        drivers.length,
        baseUrl,
        sport
    ]);
    // Constructors are never in the SSR payload — fetch them on the client.
    (0, $6cds3.useEffect)(()=>{
        if (teams.length || !baseUrl) return;
        let cancelled = false;
        (0, $zSRJd.getData)({
            dataType: "f1-team-standings",
            baseUrl: baseUrl,
            sport: sport
        }).then((res)=>{
            if (cancelled) return;
            const rows = $4614504340a979ad$var$rowsFromRaw(res);
            if (rows.length) setTeams(rows.map($4614504340a979ad$var$mapTeam).sort($4614504340a979ad$var$byPos));
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        teams.length,
        baseUrl,
        sport
    ]);
    if (!drivers.length && !teams.length) return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "f1 f1--loading",
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
            children: "Loading standings\u2026"
        })
    });
    const isDrivers = tab === "drivers";
    const rows = isDrivers ? drivers : teams;
    const loadingTab = !isDrivers && !teams.length;
    const shown = expanded ? rows : rows.slice(0, 5); // top 5 until "Show more"
    const canExpand = rows.length > 5;
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "f1",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "f1__head",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("h3", {
                    className: "f1__title",
                    children: title
                })
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "f1__tabs",
                role: "tablist",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                        type: "button",
                        className: `f1__tab${isDrivers ? " f1__tab--on" : ""}`,
                        onClick: ()=>selectTab("drivers"),
                        children: "Drivers"
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                        type: "button",
                        className: `f1__tab${!isDrivers ? " f1__tab--on" : ""}`,
                        onClick: ()=>selectTab("constructors"),
                        children: "Constructors"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: `f1__scroll${expanded ? " f1__scroll--cap" : ""}`,
                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("table", {
                    className: "f1__table",
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        className: "f1__c-pos",
                                        children: "POS"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        className: "f1__c-name",
                                        children: isDrivers ? "DRIVER" : "TEAM"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("th", {
                                        className: "f1__c-pts",
                                        children: "POINTS"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("tbody", {
                            children: loadingTab ? /*#__PURE__*/ (0, $lBpE3.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                    className: "f1__empty",
                                    colSpan: 3,
                                    children: "Loading\u2026"
                                })
                            }) : shown.map((r, i)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("tr", {
                                    className: `f1__row${$4614504340a979ad$var$podiumClass(r.pos)}`,
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            className: "f1__c-pos",
                                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: "f1__pos",
                                                children: r.pos ?? i + 1
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            className: "f1__c-name",
                                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                className: "f1__ent",
                                                children: [
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)($4614504340a979ad$var$Avatar, {
                                                        src: isDrivers ? $4614504340a979ad$var$driverImg(r.id) : $4614504340a979ad$var$teamImg(r.id),
                                                        name: r.name,
                                                        kind: isDrivers ? "driver" : "team"
                                                    }),
                                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                        className: "f1__name",
                                                        children: r.name
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("td", {
                                            className: "f1__c-pts",
                                            children: r.pts
                                        })
                                    ]
                                }, r.id ?? i))
                        })
                    ]
                })
            }),
            canExpand && !loadingTab ? /*#__PURE__*/ (0, $lBpE3.jsxs)("button", {
                type: "button",
                className: "f1__more",
                onClick: ()=>setExpanded((v)=>!v),
                children: [
                    expanded ? "Show less" : "Show more",
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "f1__more-ar",
                        "aria-hidden": "true",
                        children: expanded ? "\u2039" : "\u203A"
                    })
                ]
            }) : null
        ]
    });
};
var $4614504340a979ad$export$2e2bcd8739ae039 = $4614504340a979ad$var$F1ChampionshipStandings;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $2bSDe = parcelRequire("2bSDe");

var $zSRJd = parcelRequire("zSRJd");
/**
 * F1RaceCarousel — F1 race-calendar carousel (Austrian GP / British GP / Belgian GP strip).
 *
 * Calendar comes from formula1/races (sessions/schedules). Podium finish orders come from the
 * per-race endpoint formula1/{id}/races (driver results: pos, nm, team, time, gap, pts) — fetched
 * lazily for the finished races currently in view.
 *   • Windowed 3-up (2 / 1 on narrower widths) with prev/next arrows.
 *   • Finished race → podium (top 5, "Classifica completa" toggles the full order).
 *   • Otherwise → session schedule ("Programma" / "In arrivo"), live session highlighted.
 */ const $e114d59a311b5932$var$MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
const $e114d59a311b5932$var$parseDate = (s)=>{
    if (!s) return null;
    const d = new Date(String(s).replace(" ", "T"));
    return isNaN(d.getTime()) ? null : d;
};
const $e114d59a311b5932$var$fmtRange = (a, b)=>{
    const d1 = $e114d59a311b5932$var$parseDate(a);
    if (!d1) return "";
    const d2 = $e114d59a311b5932$var$parseDate(b) || d1;
    const m1 = $e114d59a311b5932$var$MONTHS[d1.getMonth()];
    if (d1.getMonth() === d2.getMonth()) return d2.getDate() !== d1.getDate() ? `${d1.getDate()} - ${d2.getDate()} ${m1}` : `${d1.getDate()} ${m1}`;
    return `${d1.getDate()} ${m1} - ${d2.getDate()} ${$e114d59a311b5932$var$MONTHS[d2.getMonth()]}`;
};
const $e114d59a311b5932$var$fmtTime = (s)=>{
    const d = $e114d59a311b5932$var$parseDate(s);
    if (!d) return "";
    const day = String(d.getDate()).padStart(2, "0");
    const hh = String(d.getHours()).padStart(2, "0");
    const mm = String(d.getMinutes()).padStart(2, "0");
    return `${day} ${$e114d59a311b5932$var$MONTHS[d.getMonth()]} ${hh}:${mm}`;
};
const $e114d59a311b5932$var$rowsFromRaw = (raw)=>{
    const d = raw?.data ?? raw;
    return Array.isArray(d) ? d : [];
};
const $e114d59a311b5932$var$mapRace = (race)=>{
    const sessions = (race?.race_types || []).filter((s)=>s?.status !== "Deleted").map((s)=>({
            id: s?.id,
            name: s?.nm || "",
            datetime: s?.dt,
            status: s?.status,
            act: s?.act
        }));
    const isCancelled = sessions.length > 0 && sessions.every((s)=>s.status === "Cancelled");
    const isFinished = sessions.length > 0 && sessions.every((s)=>s.status === "Finished");
    const isUpcoming = sessions.some((s)=>s.status === "Not started yet") && !isFinished;
    return {
        id: race?.id,
        name: race?.nm || "",
        startDate: race?.race_start,
        endDate: race?.race_end,
        city: race?.venue?.city || "",
        sessions: sessions,
        isCancelled: isCancelled,
        isFinished: isFinished,
        isUpcoming: isUpcoming
    };
};
const $e114d59a311b5932$var$calendarFromRaw = (raw)=>{
    const races = $e114d59a311b5932$var$rowsFromRaw(raw).map($e114d59a311b5932$var$mapRace).filter((r)=>!r.isCancelled && r.sessions.length);
    races.sort((a, b)=>($e114d59a311b5932$var$parseDate(a.startDate)?.getTime() || 0) - ($e114d59a311b5932$var$parseDate(b.startDate)?.getTime() || 0));
    return races;
};
// Current race = first one not yet finished as of `date` (today), else the last.
const $e114d59a311b5932$var$findCurrentIdx = (cal, dateStr)=>{
    if (!cal.length) return 0;
    const today = $e114d59a311b5932$var$parseDate(dateStr) || new Date();
    const t0 = new Date(today.getFullYear(), today.getMonth(), today.getDate()).getTime();
    const i = cal.findIndex((r)=>{
        const e = $e114d59a311b5932$var$parseDate(r.endDate) || $e114d59a311b5932$var$parseDate(r.startDate);
        return e && e.getTime() >= t0;
    });
    return i < 0 ? cal.length - 1 : i;
};
// per-race endpoint rows → podium { position, name, team, time, gap, points }
const $e114d59a311b5932$var$mapResults = (raw)=>$e114d59a311b5932$var$rowsFromRaw(raw).map((e)=>({
            position: e?.pos,
            name: e?.nm || e?.ply || "",
            team: e?.team || "",
            time: e?.time || "",
            gap: e?.gap || "",
            points: e?.pts ?? 0
        })).filter((r)=>r.name).sort((a, b)=>(a.position ?? 999) - (b.position ?? 999));
// ── Card ────────────────────────────────────────────────────────────────────
const $e114d59a311b5932$var$Card = ({ race: race, results: results, current: current, expanded: expanded, dictionary: dictionary })=>{
    const [showAll, setShowAll] = (0, $6cds3.useState)(false);
    const range = $e114d59a311b5932$var$fmtRange(race.startDate, race.endDate);
    const hasPodium = race.isFinished && Array.isArray(results) && results.length > 0;
    const podium = hasPodium ? showAll ? results : results.slice(0, 5) : [];
    const schedule = [
        ...race.sessions
    ].sort((a, b)=>($e114d59a311b5932$var$parseDate(a.datetime)?.getTime() || 0) - ($e114d59a311b5932$var$parseDate(b.datetime)?.getTime() || 0));
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: `f1c__card${current ? " is-current" : ""}${expanded ? " is-expanded" : ""}`,
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "f1c__card-head",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "f1c__gp",
                        children: race.name
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "f1c__range",
                        children: range
                    })
                ]
            }),
            expanded && (hasPodium ? /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "f1c__body",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                        className: "f1c__podium",
                        children: podium.map((r, i)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                className: "f1c__pod",
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "f1c__pod-pos",
                                        children: r.position ?? i + 1
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "f1c__pod-name",
                                        children: r.name
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "f1c__pod-val",
                                        children: r.position === 1 ? r.time || `${r.points} pts` : r.gap ? `+ ${r.gap}` : r.time
                                    })
                                ]
                            }, i))
                    }),
                    results.length > 5 ? /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                        type: "button",
                        className: "f1c__full",
                        onClick: ()=>setShowAll((v)=>!v),
                        children: showAll ? dictionary?.f1StandingsShort || "Show less \u2039" : dictionary?.f1FullStandings || "Full standings \u203A"
                    }) : null
                ]
            }) : schedule.length ? /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "f1c__body",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                        className: "f1c__sched-label",
                        children: [
                            !current && race.isUpcoming ? dictionary?.f1UpcomingLabel || "Upcoming" // later races → "Upcoming" (In arrivo)
                             : dictionary?.f1ScheduleLabel || "Schedule",
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("ul", {
                        className: "f1c__sched-list",
                        children: schedule.map((s, i)=>{
                            // Green only for a genuinely live session (by status). act=1 in this feed just
                            // flags the "Race" session (all Finished) — not "live" — so we ignore it.
                            const live = /live|progress|running/i.test(s.status || "");
                            return /*#__PURE__*/ (0, $lBpE3.jsxs)("li", {
                                className: `f1c__sess${live ? " is-live" : ""}`,
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "f1c__sess-nm",
                                        children: s.name
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "f1c__sess-dt",
                                        children: $e114d59a311b5932$var$fmtTime(s.datetime)
                                    })
                                ]
                            }, i);
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "f1c__body",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: "f1c__empty",
                    children: dictionary?.f1NoSessionsScheduled || "No sessions scheduled."
                })
            }))
        ]
    });
};
const $e114d59a311b5932$var$F1RaceCarousel = ({ serverData: serverData = null, data: dataProp = null, dataId: dataId, baseUrl: baseUrl, sport: sport = "formula1", loadCSS: loadCSS = true, dataClient: dataClient = false, date: date = null, dictionary: dictionary })=>{
    (0, $6cds3.useEffect)(()=>{
        (0, $2bSDe.loadStyles)("f1RaceCarousel");
    }, []);
    const [calendar, setCalendar] = (0, $6cds3.useState)(()=>$e114d59a311b5932$var$calendarFromRaw(serverData || dataProp));
    const [start, setStart] = (0, $6cds3.useState)(0);
    const [visible, setVisible] = (0, $6cds3.useState)(3);
    const [expanded, setExpanded] = (0, $6cds3.useState)(true); // show all card data by default
    const [results, setResults] = (0, $6cds3.useState)({}); // raceId -> podium rows
    const rootRef = (0, $6cds3.useRef)(null);
    (0, $6cds3.useEffect)(()=>{
        const c = $e114d59a311b5932$var$calendarFromRaw(serverData || dataProp);
        if (c.length) setCalendar(c);
    }, [
        serverData,
        dataProp
    ]);
    // Hydration: re-read the serialized payload off the container.
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        try {
            const el = document.querySelector(".microservice-cont");
            const parsed = JSON.parse(el?.getAttribute("data-listingdata") || "null");
            const c = $e114d59a311b5932$var$calendarFromRaw(parsed?.data);
            if (c.length) setCalendar(c);
        } catch (_) {}
    }, [
        dataClient
    ]);
    // Embed: self-fetch the calendar.
    (0, $6cds3.useEffect)(()=>{
        if (calendar.length || !baseUrl) return;
        let cancelled = false;
        (0, $zSRJd.getData)({
            dataType: "f1-races",
            baseUrl: baseUrl,
            sport: sport
        }).then((res)=>{
            if (cancelled) return;
            const c = $e114d59a311b5932$var$calendarFromRaw(res);
            if (c.length) setCalendar(c);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        calendar.length,
        baseUrl,
        sport
    ]);
    // Responsive: how many cards fit (3 / 2 / 1).
    (0, $6cds3.useEffect)(()=>{
        const calc = ()=>{
            const w = rootRef.current?.offsetWidth || 0;
            setVisible(w > 0 ? w < 560 ? 1 : w < 820 ? 2 : 3 : 3);
        };
        calc();
        window.addEventListener("resize", calc);
        return ()=>window.removeEventListener("resize", calc);
    }, []);
    // Centre the window on the current race (by today's date).
    (0, $6cds3.useEffect)(()=>{
        if (!calendar.length) return;
        const idx = $e114d59a311b5932$var$findCurrentIdx(calendar, date);
        setStart(Math.max(0, Math.min(idx - 1, calendar.length - visible)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        calendar.length
    ]);
    const total = calendar.length;
    const maxStart = Math.max(0, total - visible);
    const s = Math.min(Math.max(0, start), maxStart);
    // Fetch podium results for the finished races currently in view (only when expanded).
    (0, $6cds3.useEffect)(()=>{
        if (!baseUrl || !calendar.length || !expanded) return;
        const win = calendar.slice(s, s + visible);
        const need = win.filter((r)=>r.isFinished && !(r.id in results));
        if (!need.length) return;
        let cancelled = false;
        need.forEach((r)=>{
            (0, $zSRJd.getData)({
                dataId: r.id,
                dataType: "f1-race-results",
                baseUrl: baseUrl,
                sport: sport
            }).then((res)=>{
                if (cancelled) return;
                setResults((prev)=>({
                        ...prev,
                        [r.id]: $e114d59a311b5932$var$mapResults(res)
                    }));
            });
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        s,
        visible,
        calendar,
        baseUrl,
        sport,
        results,
        expanded
    ]);
    if (!calendar.length) return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "f1c f1c--loading",
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
            children: "Loading calendar\u2026"
        })
    });
    const win = calendar.slice(s, s + visible);
    const currentIdx = $e114d59a311b5932$var$findCurrentIdx(calendar, date);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: `f1c${expanded ? " is-expanded" : ""}`,
        ref: rootRef,
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "f1c__viewport",
                children: [
                    total > visible ? /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                        type: "button",
                        className: "f1c__arrow f1c__arrow--prev",
                        disabled: s <= 0,
                        onClick: ()=>setStart(s - 1),
                        "aria-label": "Previous",
                        children: "\u2039"
                    }) : null,
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "f1c__row",
                        children: win.map((race, i)=>/*#__PURE__*/ (0, $lBpE3.jsx)($e114d59a311b5932$var$Card, {
                                race: race,
                                results: results[race.id],
                                current: calendar.indexOf(race) === currentIdx,
                                expanded: expanded,
                                dictionary: dictionary
                            }, race.id ?? i))
                    }),
                    total > visible ? /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                        type: "button",
                        className: "f1c__arrow f1c__arrow--next",
                        disabled: s >= maxStart,
                        onClick: ()=>setStart(s + 1),
                        "aria-label": "Next",
                        children: "\u203A"
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "f1c__more-wrap",
                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("button", {
                    type: "button",
                    className: "f1c__toggle",
                    "aria-expanded": expanded,
                    onClick: ()=>setExpanded((v)=>!v),
                    children: [
                        expanded ? dictionary?.f1ShowLess || "Show less" : dictionary?.f1ShowMore || "Show more",
                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                            className: "f1c__toggle-ic",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("svg", {
                                viewBox: "0 0 16 16",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2.2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                                    d: "M4 6l4 4 4-4"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $e114d59a311b5932$export$2e2bcd8739ae039 = $e114d59a311b5932$var$F1RaceCarousel;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $2bSDe = parcelRequire("2bSDe");

var $zSRJd = parcelRequire("zSRJd");
/**
 * F1RaceDayHero — "Race-day hero": a single Grand Prix detail card.
 *
 *   • Banner: GRAND PRIX tag + venue, GP name, weekend date range.
 *   • Lights Out: the Race session's day + start time (the hero moment).
 *   • Support Programme: every other session grouped by day (FRI/SAT/SUN), cancelled ones marked.
 *
 * Data: formula1/races (list) → pick the race by data-id, else the current race (by today's date).
 */ const $ab26823d9370a6e2$var$MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
const $ab26823d9370a6e2$var$DAY_ABBR = [
    "SUN",
    "MON",
    "TUE",
    "WED",
    "THU",
    "FRI",
    "SAT"
];
const $ab26823d9370a6e2$var$DAY_FULL = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
const $ab26823d9370a6e2$var$parseDate = (s)=>{
    if (!s) return null;
    const d = new Date(String(s).replace(" ", "T"));
    return isNaN(d.getTime()) ? null : d;
};
const $ab26823d9370a6e2$var$fmtRange = (a, b)=>{
    const d1 = $ab26823d9370a6e2$var$parseDate(a);
    if (!d1) return "";
    const d2 = $ab26823d9370a6e2$var$parseDate(b) || d1;
    const m1 = $ab26823d9370a6e2$var$MONTHS[d1.getMonth()];
    if (d1.getMonth() === d2.getMonth()) return d2.getDate() !== d1.getDate() ? `${d1.getDate()} - ${d2.getDate()} ${m1}` : `${d1.getDate()} ${m1}`;
    return `${d1.getDate()} ${m1} - ${d2.getDate()} ${$ab26823d9370a6e2$var$MONTHS[d2.getMonth()]}`;
};
const $ab26823d9370a6e2$var$fmtHM = (s)=>{
    const d = $ab26823d9370a6e2$var$parseDate(s);
    if (!d) return "";
    return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
};
const $ab26823d9370a6e2$var$fmtDayFull = (s)=>{
    const d = $ab26823d9370a6e2$var$parseDate(s);
    if (!d) return "";
    return `${$ab26823d9370a6e2$var$DAY_FULL[d.getDay()]} ${d.getDate()} ${$ab26823d9370a6e2$var$MONTHS[d.getMonth()]}`;
};
const $ab26823d9370a6e2$var$racesFromRaw = (raw)=>{
    const d = raw?.data ?? raw;
    return Array.isArray(d) ? d : [];
};
// Finishing order rows → {pos, name, team, time, gap}. P1's "gap" is the full time; others are +delta.
const $ab26823d9370a6e2$var$mapResults = (raw)=>$ab26823d9370a6e2$var$racesFromRaw(raw).map((e)=>({
            pos: e?.pos,
            name: e?.nm || e?.ply || "",
            team: e?.team || "",
            time: e?.time || "",
            gap: e?.gap || ""
        })).filter((r)=>r.name).sort((a, b)=>(a.pos ?? 999) - (b.pos ?? 999));
// Pick the race by data-id, else the current one (first not finished by `date`, else last).
const $ab26823d9370a6e2$var$pickRace = (races, dataId, dateStr)=>{
    if (!races.length) return null;
    if (dataId != null) {
        const found = races.find((r)=>String(r?.id) === String(dataId));
        if (found) return found;
    }
    const sorted = [
        ...races
    ].sort((a, b)=>($ab26823d9370a6e2$var$parseDate(a.race_start)?.getTime() || 0) - ($ab26823d9370a6e2$var$parseDate(b.race_start)?.getTime() || 0));
    const today = $ab26823d9370a6e2$var$parseDate(dateStr) || new Date();
    const t0 = new Date(today.getFullYear(), today.getMonth(), today.getDate()).getTime();
    const i = sorted.findIndex((r)=>{
        const e = $ab26823d9370a6e2$var$parseDate(r.race_end) || $ab26823d9370a6e2$var$parseDate(r.race_start);
        return e && e.getTime() >= t0;
    });
    return i < 0 ? sorted[sorted.length - 1] : sorted[i];
};
// Support programme grouped by day (chronological), excluding the main Race + deleted sessions.
const $ab26823d9370a6e2$var$buildProgramme = (sessions, raceSession)=>{
    const items = (sessions || []).filter((s)=>s?.status !== "Deleted" && s !== raceSession).sort((a, b)=>($ab26823d9370a6e2$var$parseDate(a.dt)?.getTime() || 0) - ($ab26823d9370a6e2$var$parseDate(b.dt)?.getTime() || 0));
    const groups = [];
    items.forEach((s)=>{
        const d = $ab26823d9370a6e2$var$parseDate(s.dt);
        const key = d ? `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}` : "?";
        let g = groups.find((x)=>x.key === key);
        if (!g) {
            g = {
                key: key,
                label: d ? $ab26823d9370a6e2$var$DAY_ABBR[d.getDay()] : "",
                items: []
            };
            groups.push(g);
        }
        g.items.push(s);
    });
    return groups;
};
const $ab26823d9370a6e2$var$F1RaceDayHero = ({ serverData: serverData = null, data: dataProp = null, dataId: dataId, baseUrl: baseUrl, sport: sport = "formula1", loadCSS: loadCSS = true, dataClient: dataClient = false, date: date = null })=>{
    (0, $6cds3.useEffect)(()=>{
        (0, $2bSDe.loadStyles)("f1RaceDayHero");
    }, []);
    const [races, setRaces] = (0, $6cds3.useState)(()=>$ab26823d9370a6e2$var$racesFromRaw(serverData || dataProp));
    const [results, setResults] = (0, $6cds3.useState)([]);
    const [nowTs, setNowTs] = (0, $6cds3.useState)(null); // ticking clock for the upcoming countdown
    (0, $6cds3.useEffect)(()=>{
        setNowTs(Date.now());
        const t = setInterval(()=>setNowTs(Date.now()), 1000);
        return ()=>clearInterval(t);
    }, []);
    (0, $6cds3.useEffect)(()=>{
        const r = $ab26823d9370a6e2$var$racesFromRaw(serverData || dataProp);
        if (r.length) setRaces(r);
    }, [
        serverData,
        dataProp
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (!dataClient) return;
        try {
            const el = document.querySelector(".microservice-cont");
            const parsed = JSON.parse(el?.getAttribute("data-listingdata") || "null");
            const r = $ab26823d9370a6e2$var$racesFromRaw(parsed?.data);
            if (r.length) setRaces(r);
        } catch (_) {}
    }, [
        dataClient
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (races.length || !baseUrl) return;
        let cancelled = false;
        (0, $zSRJd.getData)({
            dataType: "f1-race-hero",
            baseUrl: baseUrl,
            sport: sport
        }).then((res)=>{
            if (cancelled) return;
            const r = $ab26823d9370a6e2$var$racesFromRaw(res);
            if (r.length) setRaces(r);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        races.length,
        baseUrl,
        sport
    ]);
    const race = $ab26823d9370a6e2$var$pickRace(races, dataId, date);
    const todayStart = (()=>{
        const t = $ab26823d9370a6e2$var$parseDate(date) || new Date();
        return new Date(t.getFullYear(), t.getMonth(), t.getDate()).getTime();
    })();
    const dayStart = (s)=>{
        const d = $ab26823d9370a6e2$var$parseDate(s);
        return d ? new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime() : null;
    };
    // Three states: finished (end < today) · upcoming (start > today) · current (in between).
    const endDay = dayStart(race?.race_end) ?? dayStart(race?.race_start);
    const startDay = dayStart(race?.race_start);
    const raceEnded = endDay != null && endDay < todayStart;
    const isUpcoming = !raceEnded && startDay != null && startDay > todayStart;
    // Race classification (finishing order) — lazy fetch, only for old/finished races.
    (0, $6cds3.useEffect)(()=>{
        if (!race?.id || !baseUrl || !raceEnded) {
            setResults([]);
            return;
        }
        let cancelled = false;
        (0, $zSRJd.getData)({
            dataId: race.id,
            dataType: "f1-race-results",
            baseUrl: baseUrl,
            sport: sport
        }).then((res)=>{
            if (cancelled) return;
            setResults($ab26823d9370a6e2$var$mapResults(res));
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        race?.id,
        baseUrl,
        sport,
        raceEnded
    ]);
    if (!race) return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "f1h f1h--loading",
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
            children: "Loading race\u2026"
        })
    });
    const sessions = (race.race_types || []).filter((s)=>s?.status !== "Deleted");
    const raceSession = sessions.find((s)=>/^race$/i.test(s?.nm || ""));
    const days = $ab26823d9370a6e2$var$buildProgramme(sessions, raceSession);
    const venue = race.venue?.name || "";
    // Countdown to lights out (Race session, else weekend start) for upcoming races.
    const cdTarget = $ab26823d9370a6e2$var$parseDate(raceSession?.dt) || $ab26823d9370a6e2$var$parseDate(race.race_start);
    const cdMs = cdTarget && nowTs != null ? Math.max(0, cdTarget.getTime() - nowTs) : 0;
    const cd = [
        {
            n: Math.floor(cdMs / 86400000),
            u: "Days"
        },
        {
            n: Math.floor(cdMs % 86400000 / 3600000),
            u: "Hrs"
        },
        {
            n: Math.floor(cdMs % 3600000 / 60000),
            u: "Min"
        },
        {
            n: Math.floor(cdMs % 60000 / 1000),
            u: "Sec"
        }
    ];
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "f1h",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "f1h__hero",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "f1h__banner-top",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                className: "f1h__tag",
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("svg", {
                                        className: "f1h__ic",
                                        viewBox: "0 0 24 24",
                                        fill: "currentColor",
                                        "aria-hidden": "true",
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                                                d: "M6 3a1 1 0 0 1 2 0v18a1 1 0 1 1-2 0V3z"
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                                                d: "M8 4l11 4-11 4V4z"
                                            })
                                        ]
                                    }),
                                    "Grand Prix"
                                ]
                            }),
                            venue ? /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                className: "f1h__venue",
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("svg", {
                                        className: "f1h__ic",
                                        viewBox: "0 0 16 16",
                                        fill: "currentColor",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                                            d: "M8 1a5 5 0 0 0-5 5c0 3.5 5 9 5 9s5-5.5 5-9a5 5 0 0 0-5-5zm0 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
                                        })
                                    }),
                                    venue
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("h3", {
                        className: "f1h__title",
                        children: race.nm
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "f1h__range",
                        children: $ab26823d9370a6e2$var$fmtRange(race.race_start, race.race_end)
                    }),
                    raceSession ? /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "f1h__lights",
                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                            className: "f1h__lights-row",
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                    className: "f1h__lights-left",
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                            className: "f1h__lights-lbl",
                                            children: "Lights Out"
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                            className: "f1h__lights-day",
                                            children: $ab26823d9370a6e2$var$fmtDayFull(raceSession.dt)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                    className: "f1h__lights-time",
                                    children: $ab26823d9370a6e2$var$fmtHM(raceSession.dt)
                                })
                            ]
                        })
                    }) : null
                ]
            }),
            isUpcoming ? /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "f1h__cd-sec",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "f1h__prog-lbl",
                        children: "Countdown to Lights Out"
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "f1h__cd",
                        children: cd.map((c, i)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                className: "f1h__cd-box",
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "f1h__cd-num",
                                        children: String(c.n).padStart(2, "0")
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "f1h__cd-unit",
                                        children: c.u
                                    })
                                ]
                            }, i))
                    })
                ]
            }) : null,
            !raceEnded && days.length ? /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "f1h__prog",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "f1h__prog-lbl",
                        children: "Support Programme"
                    }),
                    days.map((g, i)=>/*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                            className: "f1h__day",
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                    className: "f1h__day-lbl",
                                    children: g.label
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                    className: "f1h__day-list",
                                    children: g.items.map((s, j)=>{
                                        const cancelled = s.status === "Cancelled";
                                        return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                            className: `f1h__sess${cancelled ? " is-cancelled" : ""}`,
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                                    className: "f1h__sess-nm",
                                                    children: [
                                                        s.nm,
                                                        cancelled ? /*#__PURE__*/ (0, $lBpE3.jsxs)("svg", {
                                                            className: "f1h__sess-x",
                                                            viewBox: "0 0 16 16",
                                                            fill: "none",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.6",
                                                            "aria-hidden": "true",
                                                            children: [
                                                                /*#__PURE__*/ (0, $lBpE3.jsx)("circle", {
                                                                    cx: "8",
                                                                    cy: "8",
                                                                    r: "6"
                                                                }),
                                                                /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                                                                    d: "M5.5 5.5l5 5",
                                                                    strokeLinecap: "round"
                                                                })
                                                            ]
                                                        }) : null
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                    className: "f1h__sess-time",
                                                    children: $ab26823d9370a6e2$var$fmtHM(s.dt)
                                                })
                                            ]
                                        }, j);
                                    })
                                })
                            ]
                        }, i))
                ]
            }) : null,
            raceEnded && results.length ? /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "f1h__results",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "f1h__prog-lbl",
                        children: "Race Result"
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "f1h__res-list",
                        children: results.map((r, i)=>{
                            const gap = r.pos === 1 ? r.time || r.gap : r.gap ? `+${r.gap}` : "";
                            const podium = r.pos >= 1 && r.pos <= 3 ? ` p${r.pos}` : "";
                            return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                className: "f1h__res-row",
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: `f1h__res-pos${podium}`,
                                        children: r.pos
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                        className: "f1h__res-nm",
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: "f1h__res-name",
                                                children: r.name
                                            }),
                                            r.team ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                                className: "f1h__res-team",
                                                children: r.team
                                            }) : null
                                        ]
                                    }),
                                    gap ? /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "f1h__res-gap",
                                        children: gap
                                    }) : null
                                ]
                            }, i);
                        })
                    })
                ]
            }) : null
        ]
    });
};
var $ab26823d9370a6e2$export$2e2bcd8739ae039 = $ab26823d9370a6e2$var$F1RaceDayHero;


const $008824e77a732d56$var$F1WidgetWrap = ({ dataId: dataId, dataType: dataType, sport: sport, data: data, baseUrl: baseUrl, loadCSS: loadCSS, dataClient: dataClient = false, dataTitle: dataTitle, date: date })=>{
    switch(dataType){
        // "Classifica Campionato" — driver + constructor championship standings.
        case "f1-standings":
        case "f1-championship-standings":
            return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $4614504340a979ad$export$2e2bcd8739ae039), {
                serverData: data?.data,
                dataId: dataId,
                baseUrl: baseUrl,
                sport: sport,
                loadCSS: loadCSS,
                dataClient: dataClient,
                title: dataTitle || "Championship Standings"
            });
        // Race-calendar carousel (podiums / schedules).
        case "f1-races":
        case "f1-race-calendar":
            return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $e114d59a311b5932$export$2e2bcd8739ae039), {
                serverData: data?.data,
                dataId: dataId,
                baseUrl: baseUrl,
                sport: sport,
                loadCSS: loadCSS,
                dataClient: dataClient,
                date: date
            });
        // Race-day hero — a single Grand Prix detail card (data-id = race id, else current race).
        case "f1-race-hero":
        case "f1-race-day":
            return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ab26823d9370a6e2$export$2e2bcd8739ae039), {
                serverData: data?.data,
                dataId: dataId,
                baseUrl: baseUrl,
                sport: sport,
                loadCSS: loadCSS,
                dataClient: dataClient,
                date: date
            });
        default:
            return /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: "Widget Not Found in Formula 1!"
            });
    }
};
var $008824e77a732d56$export$2e2bcd8739ae039 = $008824e77a732d56$var$F1WidgetWrap;



const $c64688258cb3a412$var$Formula1Widgets = ({ dataId: dataId, dataType: dataType, sport: sport, data: data, baseUrl: baseUrl, loadCSS: loadCSS, dataClient: dataClient = false, dataTitle: dataTitle, date: date })=>{
    const props = {
        dataId: dataId,
        dataType: dataType,
        sport: sport,
        data: data,
        baseUrl: baseUrl,
        loadCSS: loadCSS,
        dataClient: dataClient,
        dataTitle: dataTitle,
        date: date
    };
    // Inject the site's dynamic colour tokens (client only), same as other sports.
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(()=>{
        if (!baseUrl) return;
        let styleTag;
        (async ()=>{
            try {
                const res = await fetch(`${baseUrl}/settings`, {
                    headers: {
                        Token: undefined,
                        "Content-Type": "application/json",
                        Accept: "application/json"
                    }
                });
                if (!res.ok) return;
                const settings = await res.json();
                styleTag = document.createElement("style");
                styleTag.textContent = (0, $2d22661aa7fb4cf1$export$a964851a84ddc42f)(settings);
                document.head.appendChild(styleTag);
                document.querySelectorAll(".microservice-cont")?.forEach((el)=>el?.classList.add("hydrated"));
            } catch (err) {
                console.error("\u26A0\uFE0F Failed to load dynamic CSS settings:", err);
            }
        })();
        return ()=>{
            if (styleTag && document.head.contains(styleTag)) document.head.removeChild(styleTag);
        };
    }, [
        baseUrl
    ]);
    if (dataType?.startsWith("f1-") || dataType?.startsWith("formula1-")) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $008824e77a732d56$export$2e2bcd8739ae039), {
        ...props
    });
    return /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
        children: "\u26A0\uFE0F Widget Not Found in Formula 1!"
    });
};
var $c64688258cb3a412$export$2e2bcd8739ae039 = $c64688258cb3a412$var$Formula1Widgets;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $2bSDe = parcelRequire("2bSDe");
/**
 * Helper utilities for the Interactives microservice feature.
 * Loop-feed JSON API, RSS feeds, ad sizing, text formatting.
 */ /**
 * Fetches the loop-feed JSON API and normalises items into a common card shape:
 * { title, link, description, pubDate, image, author, authorImage, service }
 * @param {string} url
 * @returns {Promise<Array>}
 */ const $f917cf413a74f715$export$4300f3e5defc1fa5 = async (url)=>{
    if (!url) return [];
    try {
        const res = await fetch(url);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        const items = Array.isArray(json) ? json : [];
        // Returns true if a URL is a directly playable video file
        const isVideoUrl = (url)=>url && /\.(mp4|webm|m3u8|ogg|mov)(\?|$)/i.test(url);
        return items.map((item)=>{
            const media = item.media || [];
            const service = (item.service || "").toLowerCase();
            const photoMedia = media.find((m)=>m.type === "photo" || m.type === "image");
            // Only treat as video if the URL is a real playable file — not a thumbnail JPEG
            const videoMedia = media.find((m)=>m.type === "video" && isVideoUrl(m.url));
            // For items whose video media entry has a non-playable URL (e.g. Twitter thumb),
            // use that URL as the image fallback instead.
            const thumbMedia = !videoMedia && media.find((m)=>m.type === "video" && m.url);
            const image = photoMedia?.url || videoMedia?.thumbnail || thumbMedia?.url || null;
            const video = videoMedia?.url || null;
            // Extract embed URL from the embed HTML string, e.g. <iframe src='...'></iframe>
            const embedHtml = media.find((m)=>m.embed)?.embed || "";
            const embedMatch = embedHtml.match(/src=['"]([^'"]+)['"]/);
            const embedUrl = embedMatch ? embedMatch[1] : null;
            // Build native embed URLs for Twitter/Instagram posts so the FeedSlider
            // can render them as iframes (the API only gives us the post link, not a
            // playable video file).
            let socialEmbed = null;
            const postUrl = item.url || "";
            if (service === "twitter" || service === "x") {
                // https://twitter.com/user/status/1234  OR  https://x.com/user/status/1234
                const tweetIdMatch = postUrl.match(/\/status\/(\d+)/);
                if (tweetIdMatch) socialEmbed = `https://platform.twitter.com/embed/Tweet.html?id=${tweetIdMatch[1]}&theme=light&autoplay=1&muted=true`;
            } else if (service === "instagram") {
                // https://www.instagram.com/p/ABC123/  OR  /reel/ABC123/
                const igMatch = postUrl.match(/\/(p|reel|tv)\/([A-Za-z0-9_-]+)/);
                if (igMatch) socialEmbed = `https://www.instagram.com/p/${igMatch[2]}/embed/?autoplay=true&muted=true`;
            }
            return {
                title: item.title || $f917cf413a74f715$export$c0fc46c8edd7094a(item.text) || "",
                link: postUrl,
                description: $f917cf413a74f715$export$c0fc46c8edd7094a(item.text) || "",
                pubDate: item.date || item.created || "",
                image: image,
                video: video,
                embedUrl: embedUrl,
                socialEmbed: socialEmbed,
                author: item.author?.name || "",
                authorImage: item.author?.image || null,
                service: service
            };
        });
    } catch (err) {
        console.error("[interactivesHelper] parseLoopFeed error:", err);
        return [];
    }
};
const $f917cf413a74f715$export$cc7c596d1a8cea19 = async (url)=>{
    if (!url) return [];
    try {
        const res = await fetch(url);
        const text = await res.text();
        const parser = new DOMParser();
        const xml = parser.parseFromString(text, "text/xml");
        const items = Array.from(xml.querySelectorAll("item"));
        return items.map((item)=>{
            const get = (tag)=>item.querySelector(tag)?.textContent?.trim() || "";
            const enclosure = item.querySelector("enclosure");
            const mediaThumbnail = item.getElementsByTagNameNS("http://search.yahoo.com/mrss/", "thumbnail")[0] || item.getElementsByTagNameNS("http://search.yahoo.com/mrss/", "content")[0];
            return {
                title: get("title"),
                link: get("link"),
                description: $f917cf413a74f715$export$c0fc46c8edd7094a(get("description")),
                pubDate: get("pubDate"),
                author: get("author") || get("dc:creator"),
                image: enclosure?.getAttribute("url") || mediaThumbnail?.getAttribute("url") || null
            };
        });
    } catch (err) {
        console.error("[interactivesHelper] parseRssFeed error:", err);
        return [];
    }
};
const $f917cf413a74f715$export$c0fc46c8edd7094a = (str)=>{
    if (!str) return "";
    return str.replace(/<[^>]*>/g, "").replace(/&[a-z]+;/gi, " ").trim();
};
const $f917cf413a74f715$export$59a943b34a82e690 = (str, maxLen = 120)=>{
    if (!str) return "";
    if (str.length <= maxLen) return str;
    return str.slice(0, maxLen).trimEnd() + "\u2026";
};
const $f917cf413a74f715$export$2da72629fff8e395 = (dateStr)=>{
    if (!dateStr) return "";
    try {
        const d = new Date(dateStr);
        return d.toLocaleDateString("en-GB", {
            day: "numeric",
            month: "short",
            year: "numeric"
        });
    } catch  {
        return dateStr;
    }
};
const $f917cf413a74f715$export$97e818d0c0b99b04 = (ratio = "300x250")=>{
    const parts = ratio.toLowerCase().split("x");
    const width = parseInt(parts[0], 10) || 300;
    const height = parseInt(parts[1], 10) || 250;
    return {
        width: width,
        height: height
    };
};
const $f917cf413a74f715$export$1c2c427a44c364ab = (attr, containerEl)=>{
    try {
        const el = containerEl || document.querySelector(".microservice-cont");
        return el?.getAttribute(`data-${attr}`) || null;
    } catch  {
        return null;
    }
};



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $2bSDe = parcelRequire("2bSDe");
/**
 * Flexible auto-fill CSS Grid wrapper.
 * Uses `grid-template-columns: repeat(auto-fill, minmax(columns px, 1fr))`
 * so it adapts to any container width.
 */ const $9fa209febf3c141d$var$Grid = ({ columns: columns = 300, gap: gap = 16, className: className = "", children: children, loadCSS: loadCSS = true })=>{
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === true || loadCSS === "true") (0, $2bSDe.loadStyles)("interactivesGrid");
    }, [
        loadCSS
    ]);
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: `interactives-grid ${className}`.trim(),
        style: {
            display: "grid",
            gridTemplateColumns: `repeat(auto-fill, minmax(${columns}px, 1fr))`,
            gap: `${gap}px`
        },
        children: children
    });
};
var $9fa209febf3c141d$export$2e2bcd8739ae039 = $9fa209febf3c141d$var$Grid;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $2bSDe = parcelRequire("2bSDe");


var $ba5nK = parcelRequire("ba5nK");
const $4d00284bfe36dbea$var$SERVICE_ICONS = {
    twitter: "\uD83D\uDC26",
    youtube: "\u25B6",
    instagram: "\uD83D\uDCF8",
    rss: "\uD83D\uDCF0"
};
/**
 * Feed post card. Handles both loop-feed JSON items and classic RSS items.
 * Item shape: { title, link, description, pubDate, image, author, authorImage, service }
 */ const $4d00284bfe36dbea$var$RssCard = ({ item: item = {}, showImage: showImage = true, showDate: showDate = true, showDescription: showDescription = true, descMaxLen: descMaxLen = 140, loadCSS: loadCSS = true, onClick: onClick = null })=>{
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === true || loadCSS === "true") (0, $2bSDe.loadStyles)("interactivesCard");
    }, [
        loadCSS
    ]);
    const { title: title, link: link, description: description, pubDate: pubDate, image: image, video: video, author: author, authorImage: authorImage, service: service } = item;
    // Need at least a title or description to render
    if (!title && !description) return null;
    const displayTitle = title || (0, $f917cf413a74f715$export$59a943b34a82e690)(description, 80);
    const displayDesc = title ? description : null; // don't repeat if title IS the description
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: `interactives-card interactives-card--rss${service ? ` interactives-card--${service}` : ""}`,
        onClick: onClick,
        style: onClick ? {
            cursor: "pointer"
        } : undefined,
        children: [
            showImage && image && /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "interactives-card__image-wrap",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                        src: image,
                        alt: displayTitle,
                        clz: "interactives-card__image",
                        fill: true,
                        objectFit: "cover"
                    }),
                    video && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "interactives-card__play-badge",
                        children: "\u25B6"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "interactives-card__body",
                children: [
                    author && /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "interactives-card__author",
                        children: [
                            authorImage && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                src: authorImage,
                                alt: author,
                                clz: "interactives-card__author-img",
                                width: 20,
                                height: 20
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "interactives-card__author-name",
                                children: author
                            }),
                            service && $4d00284bfe36dbea$var$SERVICE_ICONS[service] && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "interactives-card__service",
                                title: service,
                                children: $4d00284bfe36dbea$var$SERVICE_ICONS[service]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "interactives-card__title",
                        children: displayTitle
                    }),
                    showDate && pubDate && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "interactives-card__date",
                        children: (0, $f917cf413a74f715$export$2da72629fff8e395)(pubDate)
                    }),
                    showDescription && displayDesc && /*#__PURE__*/ (0, $lBpE3.jsx)("p", {
                        className: "interactives-card__desc",
                        children: (0, $f917cf413a74f715$export$59a943b34a82e690)(displayDesc, descMaxLen)
                    })
                ]
            })
        ]
    });
};
var $4d00284bfe36dbea$export$2e2bcd8739ae039 = $4d00284bfe36dbea$var$RssCard;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $2bSDe = parcelRequire("2bSDe");


var $ba5nK = parcelRequire("ba5nK");
/**
 * TwitterCard — renders a tweet-style card with inline muted video preview.
 * Video autoplays muted when 30%+ visible; pauses when scrolled away.
 */ const $83fd4b7707ee2cba$var$TwitterCard = ({ item: item = {}, loadCSS: loadCSS = true, onClick: onClick = null })=>{
    const { description: description, pubDate: pubDate, image: image, video: video, author: author, authorImage: authorImage } = item;
    const videoElRef = (0, $6cds3.useRef)(null); // keeps a direct reference to the <video> DOM node
    const obsRef = (0, $6cds3.useRef)(null); // keeps the IntersectionObserver instance
    const [muted, setMuted] = (0, $6cds3.useState)(true);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === true || loadCSS === "true") (0, $2bSDe.loadStyles)("interactives");
    }, [
        loadCSS
    ]);
    // Callback ref: fires synchronously when the <video> mounts or unmounts.
    const setVideoRef = (0, $6cds3.useCallback)((el)=>{
        videoElRef.current = el;
        // Clean up any previous observer
        if (obsRef.current) {
            obsRef.current.disconnect();
            obsRef.current = null;
        }
        if (!el) return;
        const obs = new IntersectionObserver(([entry])=>{
            if (entry.isIntersecting) el.play().catch(()=>{});
            else el.pause();
        }, {
            threshold: 0.3
        });
        obs.observe(el);
        obsRef.current = obs;
    }, []); // stable — no deps needed
    const toggleMute = (e)=>{
        e.stopPropagation();
        const el = videoElRef.current;
        if (!el) return;
        el.muted = !el.muted;
        setMuted(el.muted);
    };
    const text = description || item.title || "";
    if (!text && !video && !image) return null;
    const hasMedia = Boolean(video || image);
    // ── Text-only: dark gradient bg with floating white tweet card ──
    if (!hasMedia) return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "tw-card tw-card--text-only",
        onClick: onClick,
        style: onClick ? {
            cursor: "pointer"
        } : undefined,
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
            className: "tw-card__text-bg",
            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "tw-card__text-inner",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "tw-card__logo-abs",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("svg", {
                            viewBox: "0 0 24 24",
                            fill: "currentColor",
                            width: "20",
                            height: "20",
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                                d: "M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "tw-card__header",
                        children: [
                            authorImage ? /*#__PURE__*/ (0, $lBpE3.jsx)("img", {
                                src: authorImage,
                                alt: author || "",
                                className: "tw-card__avatar tw-card__avatar--lg",
                                onError: (e)=>{
                                    e.currentTarget.style.display = "none";
                                }
                            }) : /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: "tw-card__avatar tw-card__avatar--lg tw-card__avatar--placeholder",
                                children: "\uD83D\uDC26"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                className: "tw-card__meta",
                                children: [
                                    author && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "tw-card__name",
                                        children: author
                                    }),
                                    pubDate && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "tw-card__date",
                                        children: (0, $f917cf413a74f715$export$2da72629fff8e395)(pubDate)
                                    })
                                ]
                            })
                        ]
                    }),
                    text && /*#__PURE__*/ (0, $lBpE3.jsx)("p", {
                        className: "tw-card__text",
                        children: text
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "tw-card",
        children: [
            video ? /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "tw-card__media",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("video", {
                        ref: setVideoRef,
                        src: video,
                        className: "tw-card__video",
                        muted: true,
                        loop: true,
                        playsInline: true,
                        preload: "metadata",
                        poster: image || undefined
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                        className: "tw-card__mute-btn",
                        onClick: toggleMute,
                        "aria-label": muted ? "Unmute" : "Mute",
                        children: muted ? "\uD83D\uDD07" : "\uD83D\uDD0A"
                    })
                ]
            }) : /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "tw-card__media tw-card__media--image",
                onClick: onClick,
                style: onClick ? {
                    cursor: "pointer"
                } : undefined,
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                    src: image,
                    alt: text,
                    clz: "tw-card__img",
                    fill: true,
                    objectFit: "cover"
                })
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "tw-card__caption-wrap",
                onClick: onClick,
                style: onClick ? {
                    cursor: "pointer"
                } : undefined,
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "tw-card__header",
                        children: [
                            authorImage ? /*#__PURE__*/ (0, $lBpE3.jsx)("img", {
                                src: authorImage,
                                alt: author || "",
                                className: "tw-card__avatar",
                                onError: (e)=>{
                                    e.currentTarget.style.display = "none";
                                }
                            }) : /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: "tw-card__avatar tw-card__avatar--placeholder",
                                children: "\uD83D\uDC26"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                className: "tw-card__meta",
                                children: [
                                    author && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "tw-card__name",
                                        children: author
                                    }),
                                    pubDate && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "tw-card__date",
                                        children: (0, $f917cf413a74f715$export$2da72629fff8e395)(pubDate)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "tw-card__logo",
                                children: "\uD835\uDD4F"
                            })
                        ]
                    }),
                    text && /*#__PURE__*/ (0, $lBpE3.jsx)("p", {
                        className: "tw-card__text",
                        children: text
                    })
                ]
            })
        ]
    });
};
var $83fd4b7707ee2cba$export$2e2bcd8739ae039 = $83fd4b7707ee2cba$var$TwitterCard;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $2bSDe = parcelRequire("2bSDe");


var $ba5nK = parcelRequire("ba5nK");
/**
 * InstagramCard — square-format card with inline muted video or image.
 * Video autoplays muted when 30%+ visible; pauses when scrolled away.
 */ const $6b688d82a981c638$var$InstagramCard = ({ item: item = {}, loadCSS: loadCSS = true, onClick: onClick = null })=>{
    const { description: description, pubDate: pubDate, image: image, video: video, author: author, authorImage: authorImage } = item;
    const videoElRef = (0, $6cds3.useRef)(null); // direct reference to the <video> DOM node
    const obsRef = (0, $6cds3.useRef)(null); // IntersectionObserver instance
    const [muted, setMuted] = (0, $6cds3.useState)(true);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === true || loadCSS === "true") (0, $2bSDe.loadStyles)("interactives");
    }, [
        loadCSS
    ]);
    // Callback ref: fires synchronously when <video> mounts or unmounts.
    const setVideoRef = (0, $6cds3.useCallback)((el)=>{
        videoElRef.current = el;
        if (obsRef.current) {
            obsRef.current.disconnect();
            obsRef.current = null;
        }
        if (!el) return;
        const obs = new IntersectionObserver(([entry])=>{
            if (entry.isIntersecting) el.play().catch(()=>{});
            else el.pause();
        }, {
            threshold: 0.3
        });
        obs.observe(el);
        obsRef.current = obs;
    }, []); // stable — no deps needed
    const toggleMute = (e)=>{
        e.stopPropagation();
        const el = videoElRef.current;
        if (!el) return;
        el.muted = !el.muted;
        setMuted(el.muted);
    };
    const [imgFailed, setImgFailed] = (0, $6cds3.useState)(false);
    const caption = description || item.title || "";
    if (!video && !image && !caption) return null;
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "ig-card",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "ig-card__media",
                children: [
                    video ? /*#__PURE__*/ (0, $lBpE3.jsx)("video", {
                        ref: setVideoRef,
                        src: video,
                        className: "ig-card__video",
                        muted: true,
                        loop: true,
                        playsInline: true,
                        preload: "metadata",
                        poster: image || undefined
                    }) : image && !imgFailed ? /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        onClick: onClick,
                        style: onClick ? {
                            cursor: "pointer",
                            width: "100%",
                            height: "100%"
                        } : undefined,
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("img", {
                            src: image,
                            alt: caption,
                            className: "ig-card__img",
                            style: {
                                width: "100%",
                                height: "100%",
                                objectFit: "cover"
                            },
                            loading: "lazy",
                            onError: ()=>setImgFailed(true)
                        })
                    }) : /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "ig-card__media-placeholder",
                        onClick: onClick,
                        style: onClick ? {
                            cursor: "pointer"
                        } : undefined,
                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("svg", {
                            className: "ig-card__placeholder-icon",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "white",
                            strokeWidth: "1.5",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("rect", {
                                    x: "2",
                                    y: "2",
                                    width: "20",
                                    height: "20",
                                    rx: "5",
                                    ry: "5"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("circle", {
                                    cx: "12",
                                    cy: "12",
                                    r: "5"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("circle", {
                                    cx: "17.5",
                                    cy: "6.5",
                                    r: "1.5",
                                    fill: "white",
                                    stroke: "none"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "ig-card__gradient"
                    }),
                    video && /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                        className: "ig-card__mute-btn",
                        onClick: toggleMute,
                        "aria-label": muted ? "Unmute" : "Mute",
                        children: muted ? "\uD83D\uDD07" : "\uD83D\uDD0A"
                    }),
                    video && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "ig-card__type-icon",
                        children: "\u25B6"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "ig-card__footer",
                onClick: onClick,
                style: onClick ? {
                    cursor: "pointer"
                } : undefined,
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "ig-card__author-row",
                        children: [
                            authorImage ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                src: authorImage,
                                alt: author || "",
                                clz: "ig-card__avatar",
                                width: 28,
                                height: 28
                            }) : /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: "ig-card__avatar ig-card__avatar--placeholder"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                className: "ig-card__author-info",
                                children: [
                                    author && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "ig-card__username",
                                        children: author
                                    }),
                                    pubDate && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "ig-card__date",
                                        children: (0, $f917cf413a74f715$export$2da72629fff8e395)(pubDate)
                                    })
                                ]
                            })
                        ]
                    }),
                    caption && /*#__PURE__*/ (0, $lBpE3.jsx)("p", {
                        className: "ig-card__caption",
                        children: caption.length > 100 ? caption.slice(0, 100).trimEnd() + "\u2026" : caption
                    })
                ]
            })
        ]
    });
};
var $6b688d82a981c638$export$2e2bcd8739ae039 = $6b688d82a981c638$var$InstagramCard;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $2bSDe = parcelRequire("2bSDe");


var $ba5nK = parcelRequire("ba5nK");
/**
 * YoutubeCard — renders a YouTube thumbnail with a play button.
 * Clicking play swaps the thumbnail for the live iframe embed (autoplay).
 * Clicking the card itself (outside the play button) opens the FeedSlider.
 */ const $010f59a8c7c025fa$var$YoutubeCard = ({ item: item = {}, loadCSS: loadCSS = true, onClick: onClick = null })=>{
    const { title: title, description: description, pubDate: pubDate, image: image, embedUrl: embedUrl, author: author, authorImage: authorImage } = item;
    const [playing, setPlaying] = (0, $6cds3.useState)(false);
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === true || loadCSS === "true") (0, $2bSDe.loadStyles)("interactives");
    }, [
        loadCSS
    ]);
    const displayTitle = title || (0, $f917cf413a74f715$export$59a943b34a82e690)(description, 80);
    if (!displayTitle && !image && !embedUrl) return null;
    // Append autoplay=1 to the embed URL when the user clicks play
    const autoplayUrl = embedUrl ? `${embedUrl}${embedUrl.includes("?") ? "&" : "?"}autoplay=1` : null;
    const handlePlay = (e)=>{
        e.stopPropagation(); // don't open the slider
        setPlaying(true);
    };
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "yt-card",
        onClick: onClick,
        style: onClick ? {
            cursor: "pointer"
        } : undefined,
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "yt-card__media",
                children: playing && autoplayUrl ? /*#__PURE__*/ (0, $lBpE3.jsx)("iframe", {
                    className: "yt-card__iframe",
                    src: autoplayUrl,
                    title: displayTitle,
                    frameBorder: "0",
                    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                    allowFullScreen: true,
                    onClick: (e)=>e.stopPropagation()
                }) : /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                    children: [
                        image ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                            src: image,
                            alt: displayTitle,
                            clz: "yt-card__thumb",
                            fill: true,
                            objectFit: "cover"
                        }) : /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                            className: "yt-card__thumb-placeholder"
                        }),
                        embedUrl && /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                            className: "yt-card__play-btn",
                            onClick: handlePlay,
                            "aria-label": "Play video",
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "yt-card__play-icon",
                                children: "\u25B6"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "yt-card__body",
                children: [
                    author && /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "yt-card__author",
                        children: [
                            authorImage ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ba5nK.default), {
                                src: authorImage,
                                alt: author,
                                clz: "yt-card__author-img",
                                width: 20,
                                height: 20
                            }) : /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "yt-card__yt-logo",
                                children: "\u25B6"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "yt-card__author-name",
                                children: author
                            })
                        ]
                    }),
                    displayTitle && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "yt-card__title",
                        children: displayTitle
                    }),
                    pubDate && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        className: "yt-card__date",
                        children: (0, $f917cf413a74f715$export$2da72629fff8e395)(pubDate)
                    })
                ]
            })
        ]
    });
};
var $010f59a8c7c025fa$export$2e2bcd8739ae039 = $010f59a8c7c025fa$var$YoutubeCard;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $2bSDe = parcelRequire("2bSDe");

/**
 * Ad banner widget with configurable size ratio.
 * Supports image ads (via src URL) and iframe embeds.
 *
 * Props:
 *  ratio     - Size string e.g. "300x250", "728x90", "160x600"  (default: "300x250")
 *  src       - Ad image URL or iframe embed URL
 *  link      - Click-through URL (wraps image ads in <a>)
 *  alt       - Alt text for image ads
 *  loadCSS   - Whether to load interactivesAd styles
 */ const $ac979017f50aaaf8$var$AdWidget = ({ ratio: ratio = "300x250", src: src = "", link: link = "", alt: alt = "Advertisement", loadCSS: loadCSS = true })=>{
    const { width: width, height: height } = (0, $f917cf413a74f715$export$97e818d0c0b99b04)(ratio);
    const isIframe = src.includes("iframe") || src.endsWith(".html") || src.includes("doubleclick") || src.includes("googlesyndication");
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === true || loadCSS === "true") (0, $2bSDe.loadStyles)("interactivesAd");
    }, [
        loadCSS
    ]);
    const containerStyle = {
        width: `${width}px`,
        height: `${height}px`,
        maxWidth: "100%",
        overflow: "hidden"
    };
    const renderContent = ()=>{
        if (!src) return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
            className: "interactives-ad__placeholder",
            style: {
                width: "100%",
                height: "100%"
            }
        });
        if (isIframe) return /*#__PURE__*/ (0, $lBpE3.jsx)("iframe", {
            src: src,
            width: width,
            height: height,
            frameBorder: "0",
            scrolling: "no",
            title: alt,
            className: "interactives-ad__iframe"
        });
        const img = /*#__PURE__*/ (0, $lBpE3.jsx)("img", {
            src: src,
            alt: alt,
            width: width,
            height: height,
            className: "interactives-ad__image",
            loading: "lazy"
        });
        return link ? /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
            href: link,
            target: "_blank",
            rel: "noopener noreferrer",
            className: "interactives-ad__link",
            children: img
        }) : img;
    };
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "interactives-ad",
        style: containerStyle,
        "data-ratio": ratio,
        children: renderContent()
    });
};
var $ac979017f50aaaf8$export$2e2bcd8739ae039 = $ac979017f50aaaf8$var$AdWidget;




var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");




/**
 * Dynamic import factory — bundler can't statically analyze these because
 * the function is only called at runtime when the API tells us which name to use.
 * Each entry is a thunk; we only call the one we need.
 *
 * To add a new ad component:
 *  1. Add its name → () => import(...) entry here
 *  2. Add its size to COMPONENT_SIZES
 *  3. Add its props mapping to getComponentProps
 */ const $9c26cc07815fc6a8$var$IMPORT_MAP = {
    MatchHeadWidget: ()=>(parcelRequire("6KgMW")),
    MatchTimeline: ()=>(parcelRequire("a9DWi")),
    MatchStatsWidget: ()=>(parcelRequire("9oD4W")),
    FanVoteWidget: ()=>(parcelRequire("9HvWP"))
};
const $9c26cc07815fc6a8$var$COMPONENT_SIZES = {
    MatchHeadWidget: {
        width: 300,
        height: 250
    },
    MatchTimeline: {
        width: 300,
        height: 600
    },
    MatchStatsWidget: {
        width: 300,
        height: 600
    },
    FanVoteWidget: {
        width: 280,
        height: 364
    }
};
const $9c26cc07815fc6a8$var$getComponentProps = (name, componentData, difference, socketConfig = {})=>{
    if (name === "MatchHeadWidget") return {
        match: componentData?.data,
        difference: difference || "+0",
        loadCSS: false,
        socketUrl: socketConfig.socketUrl || "",
        channel: socketConfig.channel || "",
        event: socketConfig.event || ""
    };
    if (name === "MatchTimeline") return {
        data: componentData?.summary,
        matchDetail: componentData,
        loadCSS: false
    };
    if (name === "MatchStatsWidget") return {
        data: componentData?.stats,
        matchDetail: componentData?.match,
        loadCSS: false
    };
    if (name === "FanVoteWidget") return {
        question: componentData?.question,
        options: componentData?.options,
        category: componentData?.category,
        league: componentData?.league,
        emoji: componentData?.emoji,
        apiUrl: componentData?.apiUrl,
        loadCSS: false
    };
    return {
        loadCSS: false
    };
};
// Module-level cache: name → lazy component (created once, reused on re-renders)
const $9c26cc07815fc6a8$var$lazyCache = {};
const $9c26cc07815fc6a8$var$getLazy = (name)=>{
    if (!$9c26cc07815fc6a8$var$lazyCache[name]) {
        const importer = $9c26cc07815fc6a8$var$IMPORT_MAP[name];
        if (!importer) return null;
        $9c26cc07815fc6a8$var$lazyCache[name] = /*#__PURE__*/ (0, $6cds3.lazy)(importer);
    }
    return $9c26cc07815fc6a8$var$lazyCache[name];
};
/**
 * ComponentAdRenderer
 *
 * Renders a single ad component driven by the API response:
 *   { name: "MatchTimeline", componentData: { ... } }
 *
 * Bundle impact: only the component whose name arrives from the API is ever
 * fetched. The IMPORT_MAP thunks are not executed until getLazy(name) is called.
 */ const $9c26cc07815fc6a8$var$ComponentAdRenderer = ({ name: name, componentData: componentData, difference: difference = "+0", socketConfig: socketConfig = {}, style: style = {} })=>{
    const [Component, setComponent] = (0, $6cds3.useState)(()=>$9c26cc07815fc6a8$var$getLazy(name));
    (0, $6cds3.useEffect)(()=>{
        setComponent(()=>$9c26cc07815fc6a8$var$getLazy(name));
    }, [
        name
    ]);
    if (!Component) {
        console.warn(`[ComponentAdRenderer] Unknown component: "${name}"`);
        return null;
    }
    const { width: width, height: height } = $9c26cc07815fc6a8$var$COMPONENT_SIZES[name] || {
        width: 300,
        height: 300
    };
    const compProps = $9c26cc07815fc6a8$var$getComponentProps(name, componentData, difference, socketConfig);
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        style: {
            maxWidth: width,
            maxHeight: height,
            flexShrink: 0,
            ...style
        },
        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $6cds3.Suspense), {
            fallback: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                style: {
                    width: width,
                    height: height,
                    background: "#f5f5f5",
                    borderRadius: 12
                }
            }),
            children: /*#__PURE__*/ (0, $lBpE3.jsx)(Component, {
                ...compProps
            })
        })
    });
};
var $9c26cc07815fc6a8$export$2e2bcd8739ae039 = $9c26cc07815fc6a8$var$ComponentAdRenderer;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");


var $2bSDe = parcelRequire("2bSDe");




// ── Service icon SVGs ───────────────────────────────────────────────────────
const $882760e121364475$var$SERVICE_ICONS = {
    youtube: /*#__PURE__*/ (0, $lBpE3.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        className: "feed-slider__yt-icon",
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
            d: "M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"
        })
    }),
    twitter: /*#__PURE__*/ (0, $lBpE3.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
            d: "M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
        })
    }),
    instagram: /*#__PURE__*/ (0, $lBpE3.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("rect", {
                x: "2",
                y: "2",
                width: "20",
                height: "20",
                rx: "5",
                ry: "5"
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "5"
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("circle", {
                cx: "17.5",
                cy: "6.5",
                r: "1.5",
                fill: "currentColor",
                stroke: "none"
            })
        ]
    }),
    rss: /*#__PURE__*/ (0, $lBpE3.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                d: "M4 11a9 9 0 0 1 9 9"
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                d: "M4 4a16 16 0 0 1 16 16"
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("circle", {
                cx: "5",
                cy: "19",
                r: "1",
                fill: "currentColor"
            })
        ]
    })
};
const $882760e121364475$var$SERVICE_LABELS = {
    youtube: "YouTube",
    twitter: "X (Twitter)",
    instagram: "Instagram",
    rss: "RSS"
};
const $882760e121364475$var$SERVICE_EMOJIS = {
    twitter: "\uD83D\uDC26",
    youtube: "\u25B6",
    instagram: "\uD83D\uDCF8",
    rss: "\uD83D\uDCF0"
};
// ── Helper: send command to YouTube iframe via postMessage ──────────────
const $882760e121364475$var$ytCommand = (iframeEl, func, args = [])=>{
    if (!iframeEl?.contentWindow) return;
    iframeEl.contentWindow.postMessage(JSON.stringify({
        event: "command",
        func: func,
        args: args
    }), "*");
};
// ── Helper: build YouTube embed URL with API enabled ────────────────────
const $882760e121364475$var$buildEmbedUrl = (url, autoplay)=>{
    if (!url) return "";
    const sep = url.includes("?") ? "&" : "?";
    return `${url}${sep}enablejsapi=1&autoplay=${autoplay ? 1 : 0}&mute=1`;
};
// ── Feed card ─────────────────────────────────────────────────────────────
const $882760e121364475$var$FeedSliderCard = ({ item: item = {}, isActive: isActive, isMobile: isMobile, showCaption: showCaption = true, onClose: onClose = null })=>{
    const { title: title, link: link, description: description, pubDate: pubDate, image: image, video: video, embedUrl: embedUrl, socialEmbed: socialEmbed, author: author, service: service } = item;
    // Native video refs/state
    const videoElRef = (0, $6cds3.useRef)(null);
    const [muted, setMuted] = (0, $6cds3.useState)(true);
    const [paused, setPaused] = (0, $6cds3.useState)(false);
    // YouTube embed ref + state
    const embedRef = (0, $6cds3.useRef)(null);
    const [embedMuted, setEmbedMuted] = (0, $6cds3.useState)(true);
    const [embedPaused, setEmbedPaused] = (0, $6cds3.useState)(false);
    const setVideoRef = (0, $6cds3.useCallback)((el)=>{
        videoElRef.current = el;
        if (!el) return;
        if (isActive) el.play().catch(()=>{});
    }, [
        isActive
    ]);
    // Native video: play/pause on active change
    (0, $6cds3.useEffect)(()=>{
        const el = videoElRef.current;
        if (!el) return;
        if (isActive) {
            el.play().catch(()=>{});
            setPaused(false);
        } else el.pause();
    }, [
        isActive
    ]);
    // YouTube embed: play/pause on active change
    (0, $6cds3.useEffect)(()=>{
        const iframe = embedRef.current;
        if (!iframe) return;
        if (isActive) {
            $882760e121364475$var$ytCommand(iframe, "playVideo");
            setEmbedPaused(false);
        } else $882760e121364475$var$ytCommand(iframe, "pauseVideo");
    }, [
        isActive
    ]);
    // Native video controls
    const toggleMute = (e)=>{
        e.stopPropagation();
        const el = videoElRef.current;
        if (!el) return;
        el.muted = !el.muted;
        setMuted(el.muted);
    };
    const togglePlay = (e)=>{
        e.stopPropagation();
        const el = videoElRef.current;
        if (!el) return;
        if (el.paused) {
            el.play().catch(()=>{});
            setPaused(false);
        } else {
            el.pause();
            setPaused(true);
        }
    };
    // YouTube embed controls
    const toggleEmbedPlay = (e)=>{
        e.stopPropagation();
        const iframe = embedRef.current;
        if (!iframe) return;
        if (embedPaused) {
            $882760e121364475$var$ytCommand(iframe, "playVideo");
            setEmbedPaused(false);
        } else {
            $882760e121364475$var$ytCommand(iframe, "pauseVideo");
            setEmbedPaused(true);
        }
    };
    const toggleEmbedMute = (e)=>{
        e.stopPropagation();
        const iframe = embedRef.current;
        if (!iframe) return;
        if (embedMuted) {
            $882760e121364475$var$ytCommand(iframe, "unMute");
            setEmbedMuted(false);
        } else {
            $882760e121364475$var$ytCommand(iframe, "mute");
            setEmbedMuted(true);
        }
    };
    const hasVideo = Boolean(video);
    const hasEmbed = Boolean(embedUrl);
    const hasSocialEmbed = Boolean(socialEmbed);
    const svc = service?.toLowerCase();
    const isInCompactSlider = Boolean(item._compact);
    const cardClass = [
        "feed-slider__card",
        hasSocialEmbed && "feed-slider__card--social",
        hasEmbed && "feed-slider__card--embed"
    ].filter(Boolean).join(" ");
    const mediaClass = [
        "feed-slider__media",
        hasSocialEmbed && "feed-slider__media--social"
    ].filter(Boolean).join(" ");
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: cardClass,
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: mediaClass,
                children: hasVideo ? /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("video", {
                            ref: setVideoRef,
                            src: video,
                            className: "feed-slider__video",
                            muted: true,
                            loop: true,
                            playsInline: true,
                            preload: "auto",
                            poster: image || undefined,
                            onClick: togglePlay
                        }),
                        !isMobile && /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                    className: "feed-slider__vid-btn feed-slider__vid-btn--mute",
                                    onClick: toggleMute,
                                    "aria-label": muted ? "Unmute" : "Mute",
                                    children: muted ? "\uD83D\uDD07" : "\uD83D\uDD0A"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                    className: "feed-slider__vid-btn feed-slider__vid-btn--play",
                                    onClick: togglePlay,
                                    "aria-label": paused ? "Play" : "Pause",
                                    children: paused ? "\u25B6" : "\u23F8"
                                })
                            ]
                        })
                    ]
                }) : hasEmbed ? /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("iframe", {
                            ref: embedRef,
                            className: "feed-slider__embed",
                            src: isActive ? $882760e121364475$var$buildEmbedUrl(embedUrl, true) : "",
                            title: title || "Video",
                            style: {
                                border: "none"
                            },
                            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                            allowFullScreen: true
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                            className: "feed-slider__embed-tap",
                            onClick: toggleEmbedPlay
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                            className: "feed-slider__embed-bar",
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                    className: "feed-slider__embed-btn",
                                    onClick: toggleEmbedPlay,
                                    "aria-label": embedPaused ? "Play" : "Pause",
                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("svg", {
                                        width: "20",
                                        height: "20",
                                        viewBox: "0 0 24 24",
                                        fill: "currentColor",
                                        children: embedPaused ? /*#__PURE__*/ (0, $lBpE3.jsx)("polygon", {
                                            points: "6 3 20 12 6 21 6 3"
                                        }) : /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                                            d: "M6 4h4v16H6zM14 4h4v16h-4z"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                    className: "feed-slider__embed-btn",
                                    onClick: toggleEmbedMute,
                                    "aria-label": embedMuted ? "Unmute" : "Mute",
                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("svg", {
                                        width: "20",
                                        height: "20",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: embedMuted ? /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                                                    d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("line", {
                                                    x1: "22",
                                                    x2: "16",
                                                    y1: "9",
                                                    y2: "15"
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("line", {
                                                    x1: "16",
                                                    x2: "22",
                                                    y1: "9",
                                                    y2: "15"
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                                                    d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                                                    d: "M16 9a5 5 0 0 1 0 6"
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                                                    d: "M19.364 18.364a9 9 0 0 0 0-12.728"
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }) : hasSocialEmbed ? /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("iframe", {
                            className: "feed-slider__social",
                            src: isActive ? socialEmbed : "",
                            title: title || service || "Post",
                            style: isInCompactSlider ? {
                                border: "none",
                                pointerEvents: "none"
                            } : {
                                border: "none"
                            },
                            scrolling: "no",
                            allow: "autoplay; encrypted-media"
                        }),
                        isMobile && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                            className: "feed-slider__nav-guard"
                        })
                    ]
                }) : image ? /*#__PURE__*/ (0, $lBpE3.jsx)("img", {
                    src: image,
                    alt: title || "",
                    className: "feed-slider__image",
                    onError: (e)=>{
                        e.currentTarget.style.display = "none";
                    }
                }) : /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: `feed-slider__no-media${svc === "instagram" ? " feed-slider__no-media--instagram" : ""}`,
                    children: svc === "instagram" ? /*#__PURE__*/ (0, $lBpE3.jsxs)("svg", {
                        className: "feed-slider__no-media-icon",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "white",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("rect", {
                                x: "2",
                                y: "2",
                                width: "20",
                                height: "20",
                                rx: "5",
                                ry: "5"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("circle", {
                                cx: "12",
                                cy: "12",
                                r: "5"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("circle", {
                                cx: "17.5",
                                cy: "6.5",
                                r: "1.5",
                                fill: "white",
                                stroke: "none"
                            })
                        ]
                    }) : $882760e121364475$var$SERVICE_EMOJIS[svc] || "\uD83D\uDCF0"
                })
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "feed-slider__gradient"
            }),
            isMobile && hasVideo && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "feed-slider__actions",
                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("button", {
                    className: "feed-slider__action-btn",
                    onClick: toggleMute,
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                            className: "feed-slider__action-circle",
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("svg", {
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: muted ? /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                                            d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("line", {
                                            x1: "22",
                                            x2: "16",
                                            y1: "9",
                                            y2: "15"
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("line", {
                                            x1: "16",
                                            x2: "22",
                                            y1: "9",
                                            y2: "15"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                                            d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                                            d: "M16 9a5 5 0 0 1 0 6"
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                                            d: "M19.364 18.364a9 9 0 0 0 0-12.728"
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                            className: "feed-slider__action-label",
                            children: muted ? "Unmute" : "Mute"
                        })
                    ]
                })
            }),
            showCaption && hasSocialEmbed && /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "feed-slider__footer",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "feed-slider__source",
                        children: [
                            $882760e121364475$var$SERVICE_ICONS[svc] && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "feed-slider__source-icon",
                                children: $882760e121364475$var$SERVICE_ICONS[svc]
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "feed-slider__source-text",
                                children: author || $882760e121364475$var$SERVICE_LABELS[svc] || service || ""
                            })
                        ]
                    }),
                    title && /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                        className: "feed-slider__title",
                        children: title
                    }),
                    link && /*#__PURE__*/ (0, $lBpE3.jsxs)("a", {
                        href: link,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: "feed-slider__view-btn",
                        onClick: (e)=>e.stopPropagation(),
                        children: [
                            "View Original",
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("svg", {
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                                        d: "M15 3h6v6"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                                        d: "M10 14 21 3"
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                                        d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            showCaption && !hasSocialEmbed && /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "feed-slider__body",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "feed-slider__body-header",
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                className: "feed-slider__source",
                                children: [
                                    $882760e121364475$var$SERVICE_ICONS[svc] && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "feed-slider__source-icon",
                                        children: $882760e121364475$var$SERVICE_ICONS[svc]
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        className: "feed-slider__source-text",
                                        children: $882760e121364475$var$SERVICE_LABELS[svc] || service || ""
                                    })
                                ]
                            }),
                            onClose && /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                className: "feed-slider__close",
                                onClick: ()=>onClose(),
                                "aria-label": "Close",
                                children: /*#__PURE__*/ (0, $lBpE3.jsxs)("svg", {
                                    width: "16",
                                    height: "16",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                                            d: "M18 6 6 18"
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                                            d: "m6 6 12 12"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    title && /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                        className: "feed-slider__title",
                        children: title
                    }),
                    description && /*#__PURE__*/ (0, $lBpE3.jsx)("p", {
                        className: "feed-slider__desc",
                        children: description
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "feed-slider__body-spacer"
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "feed-slider__body-footer",
                        children: [
                            author && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "feed-slider__author",
                                children: author
                            }),
                            pubDate && /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                className: "feed-slider__date",
                                children: (0, $f917cf413a74f715$export$2da72629fff8e395)(pubDate)
                            }),
                            link && /*#__PURE__*/ (0, $lBpE3.jsxs)("a", {
                                href: link,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                className: "feed-slider__view-btn",
                                onClick: (e)=>e.stopPropagation(),
                                children: [
                                    "View Original",
                                    /*#__PURE__*/ (0, $lBpE3.jsxs)("svg", {
                                        width: "16",
                                        height: "16",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                                                d: "M15 3h6v6"
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                                                d: "M10 14 21 3"
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                                                d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
// ── Ad card ─────────────────────────────────────────────────────────────────
const $882760e121364475$var$AdSlide = ({ adConfig: adConfig, compIndex: compIndex = 0 })=>{
    const renderAd = ()=>{
        if (adConfig?.type === "components") {
            const comps = adConfig.components || [];
            const comp = comps[compIndex % comps.length];
            return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $9c26cc07815fc6a8$export$2e2bcd8739ae039), {
                name: comp.name,
                componentData: comp.componentData,
                difference: adConfig.difference || "+0",
                socketConfig: adConfig.socketConfig
            });
        }
        if (adConfig?.type === "timeline") return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $29ddb6bc6c3e1f40$export$2e2bcd8739ae039), {
            matchId: adConfig.matchId,
            baseUrl: adConfig.baseUrl,
            sport: adConfig.sport || "football",
            loadCSS: false
        });
        return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ac979017f50aaaf8$export$2e2bcd8739ae039), {
            ratio: "300x600",
            src: adConfig?.src || "",
            link: adConfig?.link || "",
            alt: adConfig?.alt || "Advertisement",
            loadCSS: false
        });
    };
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "feed-slider__card feed-slider__card--ad",
        children: renderAd()
    });
};
// ── Build slide sequence ────────────────────────────────────────────────────
const $882760e121364475$var$buildSlides = (feedItems, adConfig, adEvery = 3)=>{
    const slides = [];
    let compCycleIdx = 0;
    feedItems.forEach((item, i)=>{
        slides.push({
            type: "feed",
            item: item
        });
        if (adConfig && (i + 1) % adEvery === 0) {
            const compIndex = adConfig.type === "components" ? compCycleIdx++ : null;
            slides.push({
                type: "ad",
                compIndex: compIndex
            });
        }
    });
    return slides;
};
// ── Detect mobile ───────────────────────────────────────────────────────────
const $882760e121364475$var$useIsMobile = ()=>{
    const [isMobile, setIsMobile] = (0, $6cds3.useState)(()=>typeof window !== "undefined" && window.innerWidth <= 640);
    (0, $6cds3.useEffect)(()=>{
        const mq = window.matchMedia("(max-width: 640px)");
        const handler = (e)=>setIsMobile(e.matches);
        mq.addEventListener("change", handler);
        return ()=>mq.removeEventListener("change", handler);
    }, []);
    return isMobile;
};
// ── Mobile bottom nav bar ───────────────────────────────────────────────────
const $882760e121364475$var$MobileBottomNav = ({ current: current, total: total, onPrev: onPrev, onNext: onNext })=>{
    return /*#__PURE__*/ (0, $6d4849ee44552f5f$exports.createPortal)(/*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "fs-mobile-nav",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                className: "fs-mobile-nav__btn",
                disabled: current === 0,
                onPointerDown: (e)=>{
                    e.stopPropagation();
                    e.preventDefault();
                    onPrev();
                },
                "aria-label": "Previous",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("svg", {
                    width: "20",
                    height: "20",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                        d: "m18 15-6-6-6 6"
                    })
                })
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                className: "fs-mobile-nav__btn",
                disabled: current >= total - 1,
                onPointerDown: (e)=>{
                    e.stopPropagation();
                    e.preventDefault();
                    onNext();
                },
                "aria-label": "Next",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("svg", {
                    width: "20",
                    height: "20",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                        d: "m6 9 6 6 6-6"
                    })
                })
            })
        ]
    }), document.body);
};
// ── Main slider overlay ─────────────────────────────────────────────────────
const $882760e121364475$var$FeedSlider = ({ items: items = [], startIndex: startIndex = 0, onClose: onClose, adConfig: adConfig = null, adEvery: adEvery = 3, onNeedMore: onNeedMore = null, hasMore: hasMore = false, ratio: ratio = "", showCaption: showCaption = true })=>{
    const slides = $882760e121364475$var$buildSlides(items, adConfig, adEvery);
    const isMobile = $882760e121364475$var$useIsMobile();
    // Parse ratio string (e.g. "300x250") into width/height
    const [ratioW, ratioH] = ratio ? ratio.split("x").map(Number) : [
        0,
        0
    ];
    const isCompact = ratioW > 0 && ratioH > 0;
    const initialSlide = (()=>{
        let feedCount = -1;
        for(let i = 0; i < slides.length; i++){
            if (slides[i].type === "feed") feedCount++;
            if (feedCount === startIndex) return i;
        }
        return 0;
    })();
    const [current, setCurrent] = (0, $6cds3.useState)(initialSlide);
    const [showHint, setShowHint] = (0, $6cds3.useState)(true);
    const frameRef = (0, $6cds3.useRef)(null);
    (0, $6cds3.useEffect)(()=>{
        (0, $2bSDe.loadStyles)("interactives");
    }, []);
    // Lock body scroll (only when used as overlay)
    (0, $6cds3.useEffect)(()=>{
        if (!onClose) return;
        const prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return ()=>{
            document.body.style.overflow = prev || "";
        };
    }, [
        onClose
    ]);
    // Hide hint
    (0, $6cds3.useEffect)(()=>{
        const t = setTimeout(()=>setShowHint(false), 2500);
        return ()=>clearTimeout(t);
    }, []);
    const goNext = (0, $6cds3.useCallback)(()=>{
        setCurrent((c)=>c < slides.length - 1 ? c + 1 : c);
    }, [
        slides.length
    ]);
    const goPrev = (0, $6cds3.useCallback)(()=>{
        setCurrent((c)=>c > 0 ? c - 1 : c);
    }, []);
    // Fetch next page
    (0, $6cds3.useEffect)(()=>{
        if (!onNeedMore || !hasMore) return;
        if (current >= slides.length - 3) onNeedMore();
    }, [
        current,
        slides.length,
        onNeedMore,
        hasMore
    ]);
    // Keyboard
    (0, $6cds3.useEffect)(()=>{
        const handler = (e)=>{
            if (e.key === "Escape") onClose?.();
            if (isCompact) {
                if (e.key === "ArrowDown" || e.key === "ArrowRight") goNext();
                if (e.key === "ArrowUp" || e.key === "ArrowLeft") goPrev();
            } else {
                if (e.key === "ArrowRight" || e.key === "ArrowDown") goNext();
                if (e.key === "ArrowLeft" || e.key === "ArrowUp") goPrev();
            }
        };
        document.addEventListener("keydown", handler);
        return ()=>document.removeEventListener("keydown", handler);
    }, [
        goNext,
        goPrev,
        onClose,
        isCompact
    ]);
    if (!slides.length) return null;
    const slide = slides[current];
    const isAd = slide.type === "ad";
    const feedPosition = slides.slice(0, current + 1).filter((s)=>s.type === "feed").length;
    const totalFeed = items.length;
    // ── Compact slider (ratio-based, mobile-style) ──────────────────────────
    if (isCompact) {
        const stripTransform = `translateY(${-current * 100}%)`;
        const inline = !onClose;
        const outerStyle = inline ? {
            position: "relative",
            inset: "auto",
            zIndex: "auto",
            background: "none",
            backdropFilter: "none",
            alignItems: "flex-start",
            justifyContent: "flex-start"
        } : undefined;
        const frameStyle = inline ? {
            width: ratioW,
            height: ratioH,
            maxWidth: "100%",
            boxShadow: "none",
            border: "none"
        } : {
            width: ratioW,
            height: ratioH
        };
        return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "feed-slider feed-slider--compact",
                style: outerStyle,
                children: [
                    !inline && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "feed-slider__backdrop",
                        onClick: ()=>onClose?.()
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "feed-slider__frame",
                        ref: frameRef,
                        style: frameStyle,
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                className: "feed-slider__top-bar",
                                style: inline ? {
                                    justifyContent: "flex-end"
                                } : undefined,
                                children: [
                                    !inline && /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                        className: "feed-slider__close",
                                        onClick: ()=>onClose?.(),
                                        "aria-label": "Close",
                                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("svg", {
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                                                    d: "M18 6 6 18"
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                                                    d: "m6 6 12 12"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                        className: "feed-slider__pills",
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                            className: "feed-slider__counter",
                                            children: isAd ? "Ad" : `${feedPosition} / ${totalFeed}`
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: "feed-slider__strip",
                                style: {
                                    transform: stripTransform
                                },
                                children: slides.map((s, i)=>s.type === "ad" ? /*#__PURE__*/ (0, $lBpE3.jsx)($882760e121364475$var$AdSlide, {
                                        adConfig: adConfig,
                                        compIndex: s.compIndex ?? 0
                                    }, `ad-${i}`) : /*#__PURE__*/ (0, $lBpE3.jsx)($882760e121364475$var$FeedSliderCard, {
                                        item: {
                                            ...s.item,
                                            _compact: true
                                        },
                                        isActive: i === current,
                                        isMobile: true,
                                        showCaption: showCaption
                                    }, i))
                            }),
                            showHint && current < slides.length - 1 && /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                className: "feed-slider__hint",
                                children: [
                                    "\u2191",
                                    " swipe up for next"
                                ]
                            }),
                            current === slides.length - 1 && hasMore && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: "feed-slider__loading-more",
                                children: "Loading\u2026"
                            }),
                            current > 0 && /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                className: "feed-slider__nav feed-slider__nav--prev",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    e.preventDefault();
                                },
                                onPointerDown: (e)=>{
                                    e.stopPropagation();
                                    e.preventDefault();
                                    goPrev();
                                },
                                "aria-label": "Previous",
                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("svg", {
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                                        d: "m18 15-6-6-6 6"
                                    })
                                })
                            }),
                            current < slides.length - 1 && /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                className: "feed-slider__nav feed-slider__nav--next",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    e.preventDefault();
                                },
                                onPointerDown: (e)=>{
                                    e.stopPropagation();
                                    e.preventDefault();
                                    goNext();
                                },
                                "aria-label": "Next",
                                children: /*#__PURE__*/ (0, $lBpE3.jsx)("svg", {
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                                        d: "m6 9 6 6 6-6"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        });
    }
    // ── Default large dialog slider ──────────────────────────────────────────
    const stripTransform = isMobile ? `translateY(${-current * 100}%)` : `translateX(${-current * 100}%)`;
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: "feed-slider",
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: "feed-slider__backdrop",
                        onClick: ()=>onClose?.()
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: "feed-slider__frame",
                        ref: frameRef,
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                className: "feed-slider__top-bar",
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                        className: "feed-slider__pills",
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                            className: "feed-slider__counter",
                                            children: isAd ? "Ad" : `${feedPosition} / ${totalFeed}`
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                        className: "feed-slider__close feed-slider__close--overlay",
                                        onClick: ()=>onClose?.(),
                                        "aria-label": "Close",
                                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("svg", {
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                                                    d: "M18 6 6 18"
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                                                    d: "m6 6 12 12"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: "feed-slider__strip",
                                style: {
                                    transform: stripTransform
                                },
                                children: slides.map((s, i)=>s.type === "ad" ? /*#__PURE__*/ (0, $lBpE3.jsx)($882760e121364475$var$AdSlide, {
                                        adConfig: adConfig,
                                        compIndex: s.compIndex ?? 0
                                    }, `ad-${i}`) : /*#__PURE__*/ (0, $lBpE3.jsx)($882760e121364475$var$FeedSliderCard, {
                                        item: s.item,
                                        isActive: i === current,
                                        isMobile: isMobile,
                                        onClose: onClose
                                    }, i))
                            }),
                            showHint && current < slides.length - 1 && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: "feed-slider__hint",
                                children: isMobile ? "\u2191 swipe up for next" : "\u2190 swipe for more \u2192"
                            }),
                            current === slides.length - 1 && hasMore && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: "feed-slider__loading-more",
                                children: "Loading\u2026"
                            })
                        ]
                    }),
                    current > 0 && /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                        className: "feed-slider__nav feed-slider__nav--prev",
                        onClick: goPrev,
                        "aria-label": "Previous",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("svg", {
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                                d: "m15 18-6-6 6-6"
                            })
                        })
                    }),
                    current < slides.length - 1 && /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                        className: "feed-slider__nav feed-slider__nav--next",
                        onClick: goNext,
                        "aria-label": "Next",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("svg", {
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
                                d: "m9 18 6-6-6-6"
                            })
                        })
                    })
                ]
            }),
            isMobile && /*#__PURE__*/ (0, $lBpE3.jsx)($882760e121364475$var$MobileBottomNav, {
                current: current,
                total: slides.length,
                onPrev: goPrev,
                onNext: goNext
            })
        ]
    });
};
var $882760e121364475$export$2e2bcd8739ae039 = $882760e121364475$var$FeedSlider;


// Default 300x250 ad slot — rendered as a placeholder when no ad src is provided
const $6c05381c7864995e$var$DEFAULT_AD_CONFIG = [
    {
        ratio: "300x250",
        src: "",
        link: "",
        insertAfter: 3
    }
];
const $6c05381c7864995e$var$PAGE_SIZE = 20;
/**
 * Appends limit + offset query params to a feed URL.
 * Works whether the URL already has query params or not.
 */ const $6c05381c7864995e$var$withPagination = (url, limit, offset)=>{
    if (!url) return url;
    const sep = url.includes("?") ? "&" : "?";
    return `${url}${sep}limit=${limit}&offset=${offset}`;
};
/**
 * InteractivesHost — orchestrates the full interactives widget.
 * Assembles a Grid containing RSS cards interleaved with ad slots (300x250 by default).
 * Supports infinite pagination: when the FeedSlider reaches the last slide it
 * automatically fetches the next page from the loop-feed API.
 *
 * Props:
 *  feedUrl       - Loop-feed API base URL
 *  adConfig      - Array of ad objects: [{ ratio, src, link, insertAfter }]
 *  matchHeadConfig - Match head widget config
 *  layout        - Min column width in px for Grid (default: 300)
 *  gap           - Grid gap in px (default: 16)
 *  maxItems      - Max items for the initial grid render (default: 20)
 *  loadCSS       - Load component styles dynamically
 *  dataClient    - If true, reads feedUrl from DOM data attribute
 *  ServerData    - Pre-fetched RSS items array (SSR mode)
 *  dictionary    - i18n strings object
 */ const $6c05381c7864995e$var$InteractivesHost = ({ feedUrl: feedUrlProp = "", adConfig: adConfig = $6c05381c7864995e$var$DEFAULT_AD_CONFIG, layout: layout = 300, gap: gap = 16, maxItems: maxItems = $6c05381c7864995e$var$PAGE_SIZE, loadCSS: loadCSS = true, dataClient: dataClient = false, ServerData: ServerData = null, dictionary: dictionary = {}, sliderRatio: sliderRatio = "", showCaption: showCaption = true, containerEl: containerEl })=>{
    const [items, setItems] = (0, $6cds3.useState)(ServerData || []);
    const [loading, setLoading] = (0, $6cds3.useState)(false);
    const [error, setError] = (0, $6cds3.useState)(null);
    const [sliderIndex, setSliderIndex] = (0, $6cds3.useState)(null);
    // Pagination state
    const [offset, setOffset] = (0, $6cds3.useState)(0);
    const [hasMore, setHasMore] = (0, $6cds3.useState)(true);
    const loadingMore = (0, $6cds3.useRef)(false); // prevents duplicate in-flight fetches
    (0, $6cds3.useEffect)(()=>{
        if (loadCSS === true || loadCSS === "true") (0, $2bSDe.loadStyles)("interactives");
    }, [
        loadCSS
    ]);
    // Resolve the base feed URL (from prop or DOM attribute)
    const resolveFeedUrl = (0, $6cds3.useCallback)(()=>{
        return dataClient ? (0, $f917cf413a74f715$export$1c2c427a44c364ab)("feedurl", containerEl) || feedUrlProp : feedUrlProp;
    }, [
        feedUrlProp,
        dataClient,
        containerEl
    ]);
    // Initial load
    (0, $6cds3.useEffect)(()=>{
        if (ServerData && !dataClient) return;
        const feedUrl = resolveFeedUrl();
        if (!feedUrl) return;
        setLoading(true);
        setError(null);
        (0, $f917cf413a74f715$export$4300f3e5defc1fa5)($6c05381c7864995e$var$withPagination(feedUrl, $6c05381c7864995e$var$PAGE_SIZE, 0)).then((parsed)=>{
            setItems(parsed);
            setOffset($6c05381c7864995e$var$PAGE_SIZE);
            // If the API returned fewer items than requested it has no more pages
            setHasMore(parsed.length >= $6c05381c7864995e$var$PAGE_SIZE);
            setLoading(false);
        }).catch((err)=>{
            console.error("[InteractivesHost] Feed fetch error:", err);
            setError(dictionary.feedError || "Failed to load feed.");
            setLoading(false);
        });
    }, [
        feedUrlProp,
        dataClient
    ]);
    // Called by FeedSlider when the user is near the last slide
    const fetchMore = (0, $6cds3.useCallback)(()=>{
        if (loadingMore.current || !hasMore) return;
        const feedUrl = resolveFeedUrl();
        if (!feedUrl) return;
        loadingMore.current = true;
        (0, $f917cf413a74f715$export$4300f3e5defc1fa5)($6c05381c7864995e$var$withPagination(feedUrl, $6c05381c7864995e$var$PAGE_SIZE, offset)).then((parsed)=>{
            setItems((prev)=>{
                if (parsed.length === 0) {
                    setHasMore(false);
                    return prev;
                }
                // Deduplicate by link — if every returned item already exists, we're at the end
                const existingLinks = new Set(prev.map((i)=>i.link));
                const newItems = parsed.filter((i)=>!existingLinks.has(i.link));
                if (newItems.length === 0) {
                    setHasMore(false);
                    return prev;
                }
                setOffset((o)=>o + $6c05381c7864995e$var$PAGE_SIZE);
                setHasMore(parsed.length >= $6c05381c7864995e$var$PAGE_SIZE);
                return [
                    ...prev,
                    ...newItems
                ];
            });
            loadingMore.current = false;
        }).catch(()=>{
            loadingMore.current = false;
        });
    }, [
        offset,
        hasMore,
        resolveFeedUrl
    ]);
    if (loading) return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "interactives-host interactives-host--loading",
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
            children: dictionary.loading || "Loading\u2026"
        })
    });
    if (error) return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "interactives-host interactives-host--error",
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
            children: error
        })
    });
    if (!items.length) return null;
    /**
   * Build the grid children: interleave ads after every N RSS cards.
   */ const buildChildren = ()=>{
        const children = [];
        let adIndex = 0;
        let feedIdx = 0;
        let compCycleIdx = 0; // cycles through components[] array: 0→1→0→1…
        const defaultInsertAfter = 3;
        items.forEach((item, i)=>{
            const capturedFeedIdx = feedIdx;
            feedIdx++;
            const service = item.service?.toLowerCase();
            let card;
            if (service === "twitter") card = /*#__PURE__*/ (0, $lBpE3.jsx)((0, $83fd4b7707ee2cba$export$2e2bcd8739ae039), {
                item: item,
                loadCSS: false,
                onClick: ()=>setSliderIndex(capturedFeedIdx)
            }, `rss-${i}`);
            else if (service === "instagram") card = /*#__PURE__*/ (0, $lBpE3.jsx)((0, $6b688d82a981c638$export$2e2bcd8739ae039), {
                item: item,
                loadCSS: false,
                onClick: ()=>setSliderIndex(capturedFeedIdx)
            }, `rss-${i}`);
            else if (service === "youtube") card = /*#__PURE__*/ (0, $lBpE3.jsx)((0, $010f59a8c7c025fa$export$2e2bcd8739ae039), {
                item: item,
                loadCSS: false,
                onClick: ()=>setSliderIndex(capturedFeedIdx)
            }, `rss-${i}`);
            else card = /*#__PURE__*/ (0, $lBpE3.jsx)((0, $4d00284bfe36dbea$export$2e2bcd8739ae039), {
                item: item,
                loadCSS: false,
                onClick: ()=>setSliderIndex(capturedFeedIdx)
            }, `rss-${i}`);
            children.push(card);
            // Insert next ad after every `insertAfter` items
            const currentAdConfig = adConfig[adIndex] || adConfig[adConfig.length - 1];
            if (currentAdConfig) {
                const insertAfter = currentAdConfig.insertAfter ?? defaultInsertAfter;
                if ((i + 1) % insertAfter === 0) {
                    if (currentAdConfig.type === "components") {
                        const comps = currentAdConfig.components || [];
                        const comp = comps[compCycleIdx % comps.length];
                        compCycleIdx++;
                        children.push(/*#__PURE__*/ (0, $lBpE3.jsx)((0, $9c26cc07815fc6a8$export$2e2bcd8739ae039), {
                            name: comp.name,
                            componentData: comp.componentData,
                            difference: currentAdConfig.difference || "+0",
                            socketConfig: currentAdConfig.socketConfig
                        }, `ad-${i}`));
                    } else if (currentAdConfig.type === "timeline") children.push(/*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        style: {
                            width: 300,
                            height: 600,
                            overflow: "hidden",
                            flexShrink: 0
                        },
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $29ddb6bc6c3e1f40$export$2e2bcd8739ae039), {
                            matchId: currentAdConfig.matchId,
                            baseUrl: currentAdConfig.baseUrl,
                            sport: currentAdConfig.sport || "football",
                            loadCSS: false
                        })
                    }, `ad-${i}`));
                    else children.push(/*#__PURE__*/ (0, $lBpE3.jsx)((0, $ac979017f50aaaf8$export$2e2bcd8739ae039), {
                        ratio: currentAdConfig.ratio,
                        src: currentAdConfig.src,
                        link: currentAdConfig.link,
                        loadCSS: false
                    }, `ad-${i}`));
                    if (adIndex < adConfig.length - 1) adIndex++;
                }
            }
        });
        return children;
    };
    // ── Compact ratio mode: render slider directly, no grid ──
    if (sliderRatio) return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "interactives-host",
        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $882760e121364475$export$2e2bcd8739ae039), {
            items: items,
            startIndex: 0,
            adConfig: adConfig?.[0] || null,
            onNeedMore: fetchMore,
            hasMore: hasMore,
            ratio: sliderRatio,
            showCaption: showCaption
        })
    });
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "interactives-host",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "interactives-host__grid-wrap",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $9fa209febf3c141d$export$2e2bcd8739ae039), {
                    columns: layout,
                    gap: gap,
                    loadCSS: false,
                    children: buildChildren()
                })
            }),
            sliderIndex !== null && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $882760e121364475$export$2e2bcd8739ae039), {
                items: items,
                startIndex: sliderIndex,
                onClose: ()=>setSliderIndex(null),
                adConfig: adConfig?.[0] || null,
                onNeedMore: fetchMore,
                hasMore: hasMore,
                ratio: sliderRatio,
                showCaption: showCaption
            })
        ]
    });
};
var $6c05381c7864995e$export$2e2bcd8739ae039 = $6c05381c7864995e$var$InteractivesHost;



/**
 * Mock API responses for the component-based ad system.
 * Shape mirrors what the real API will return:
 *   { components: [{ name, props, componentData }] }
 *
 * Three variants based on slider ratio:
 *  MOCK_AD_COMPONENTS        — Default (no ratio): full mix of all components
 *  MOCK_AD_COMPONENTS_300x250 — 300x250 ratio: only MatchHeadWidget (fits 300x250)
 *  MOCK_AD_COMPONENTS_300x600 — 300x600 ratio: only MatchTimeline + MatchStats (fits 300x600)
 */ // ── Shared component data ────────────────────────────────────────────────────
const $c7a1dff880521ff2$var$MATCH_HEAD_1 = {
    name: "MatchHeadWidget",
    props: {
        width: "300px",
        height: "250px"
    },
    componentData: {
        status: 200,
        message: "Match detail",
        data: {
            id: 164720,
            dt: "2025-05-25 15:00:00",
            st: "Finished",
            ro: "Round 38",
            cp: "90",
            ft: "2-0",
            ht: "0-0",
            et: "",
            ps: "",
            cfs: "2-0",
            mins: "FT",
            win: 1,
            tournament_id: 1889,
            std: "Old Trafford",
            competitors: {
                match_id: 164720,
                htid: 20,
                htn: "Manchester United",
                atn: "Aston Villa",
                atid: 12,
                htf: [
                    "D",
                    "W",
                    "W",
                    "W",
                    "W"
                ],
                atf: [
                    "L",
                    "W",
                    "D",
                    "L",
                    "W"
                ]
            },
            match_official: [],
            odds: null,
            venue: {
                id: 10013,
                name: "Old Trafford",
                capacity: "74,310"
            },
            tournament: {
                id: 1889,
                nm: "Premier League",
                sg: "premier-league-1889",
                football_category_id: 907,
                cat: "England",
                football_category: {
                    id: 48,
                    nm: "England",
                    fb_category_id: 907,
                    fid: 60
                }
            }
        }
    }
};
const $c7a1dff880521ff2$var$MATCH_HEAD_2 = {
    name: "MatchHeadWidget",
    props: {
        width: "300px",
        height: "250px"
    },
    componentData: {
        status: 200,
        message: "Match detail",
        data: {
            id: 350868,
            aimId: null,
            dt: "2026-02-18 19:45:00",
            st: "NSY",
            ro: "Round 33",
            cp: "NSY",
            ft: "",
            ht: "",
            et: "",
            ps: "",
            cfs: "",
            mins: "NSY",
            tournament_id: 4336,
            football_venue_id: 10024,
            sut: "0000-00-00 00:00:00",
            sun: "",
            im: "0",
            pm: "0",
            f_time: "2026-02-10 13:05:16",
            ref: "",
            std: "DW Stadium",
            cap: "",
            competitors: {
                match_id: 350868,
                htid: 27,
                htn: "Wigan Athletic",
                atn: "Luton Town",
                atid: 21,
                htf: [
                    "L",
                    "L",
                    "L",
                    "L",
                    "L"
                ],
                atf: [
                    "L",
                    "W",
                    "W",
                    "L",
                    "L"
                ]
            },
            match_official: [],
            odds: null,
            venue: {
                id: 10024,
                name: "DW Stadium",
                capacity: ""
            },
            tournament: {
                id: 4336,
                nm: "League One",
                sg: "league-one-4336",
                football_category_id: 907,
                cat: "England",
                football_category: {
                    id: 48,
                    nm: "England",
                    fb_category_id: 907,
                    fid: 60
                }
            }
        }
    }
};
const $c7a1dff880521ff2$var$MATCH_TIMELINE = {
    name: "MatchTimeline",
    props: {
        width: "300px",
        height: "600px"
    },
    componentData: {
        status: 200,
        message: "Match summary",
        summary: {
            timeline: [
                {
                    sc: "1-0",
                    pl_nm: "Tonali Sandro",
                    mins: 2,
                    typ: "Goal",
                    isH: 1,
                    asst: "Jacob Murphy"
                },
                {
                    pl_nm: "Jackson Nicolas",
                    mins: 33,
                    typ: "Yellow card",
                    isH: 0
                },
                {
                    pl_nm: "Jackson Nicolas",
                    mins: 35,
                    typ: "Red card",
                    isH: 0
                },
                {
                    pl_nm: "Maresca Enzo",
                    mins: 39,
                    typ: "Yellow card",
                    isH: 0
                },
                {
                    pl_nm: "Fernandez Enzo",
                    mins: 45,
                    typ: "Yellow card",
                    isH: 0
                },
                {
                    mins: 0,
                    pl_nm: "",
                    typ: "HT",
                    sc: "1 - 0"
                },
                {
                    pl_in_nm: "James Reece",
                    pl_out_nm: "Madueke Noni",
                    mins: 46,
                    typ: "Sub",
                    isH: 0
                },
                {
                    pl_nm: "Schaer Fabian",
                    mins: 53,
                    typ: "Yellow card",
                    isH: 1
                },
                {
                    pl_in_nm: "Miley Lewis",
                    pl_out_nm: "Botman Sven",
                    mins: 55,
                    typ: "Sub",
                    isH: 1
                },
                {
                    pl_nm: "Murphy Jacob",
                    mins: 64,
                    typ: "Yellow card",
                    isH: 1
                },
                {
                    pl_in_nm: "Krafth Emil",
                    pl_out_nm: "Gordon Anthony",
                    mins: 65,
                    typ: "Sub",
                    isH: 1
                },
                {
                    pl_in_nm: "Sancho Jadon",
                    pl_out_nm: "Chalobah Trevoh",
                    mins: 75,
                    typ: "Sub",
                    isH: 0
                },
                {
                    pl_in_nm: "Gusto Malo",
                    pl_out_nm: "Lavia Romeo",
                    mins: 75,
                    typ: "Sub",
                    isH: 0
                },
                {
                    pl_nm: "Guimaraes Bruno",
                    mins: 84,
                    typ: "Yellow card",
                    isH: 1
                },
                {
                    pl_nm: "Krafth Emil",
                    mins: 89,
                    typ: "Yellow card",
                    isH: 1
                },
                {
                    pl_nm: "Colwill Levi",
                    mins: 90,
                    typ: "Yellow card",
                    isH: 0
                },
                {
                    sc: "2-0",
                    pl_nm: "Guimaraes Bruno",
                    mins: 90,
                    typ: "Goal",
                    isH: 1,
                    asst: "Daniel Burn"
                },
                {
                    pl_in_nm: "Wilson Callum",
                    pl_out_nm: "Isak Alexander",
                    mins: 90,
                    typ: "Sub",
                    isH: 1
                },
                {
                    pl_in_nm: "Longstaff Sean",
                    pl_out_nm: "Guimaraes Bruno",
                    mins: 90,
                    typ: "Sub",
                    isH: 1
                }
            ],
            red_cards: [
                35
            ],
            yellow_cards: [
                33,
                39,
                45,
                53,
                64,
                84,
                89,
                90
            ],
            ref: "",
            std: "St James' Park",
            tv_schedule: []
        },
        data: {
            id: 164720,
            cfs: "2-0",
            competitors: {
                htid: 20,
                htn: "Newcastle United",
                atid: 2,
                atn: "Chelsea"
            },
            tournament: {
                id: 1889,
                nm: "Premier League"
            }
        }
    }
};
const $c7a1dff880521ff2$var$MATCH_STATS = {
    name: "MatchStatsWidget",
    props: {
        width: "300px",
        height: "600px"
    },
    componentData: {
        status: 200,
        message: "Match stats",
        match: {
            data: {
                id: 164720,
                cfs: "2-0",
                st: "Finished",
                competitors: {
                    htid: 20,
                    htn: "Newcastle United",
                    atid: 2,
                    atn: "Chelsea"
                },
                tournament: {
                    id: 1889,
                    nm: "Premier League"
                }
            }
        },
        stats: {
            first_half: {
                shots_on_target: {
                    ht: 2,
                    at: 0,
                    sort: 1
                },
                shots_off_target: {
                    ht: 2,
                    at: 3,
                    sort: 2
                },
                possession_percentage: {
                    ht: 0,
                    at: 0,
                    sort: 3
                },
                corner_kicks: {
                    ht: 2,
                    at: 1,
                    sort: 4
                },
                yellow_cards: {
                    ht: 1,
                    at: 1,
                    sort: 5
                },
                red_cards: {
                    ht: 0,
                    at: 0,
                    sort: 6
                },
                attacks: {
                    ht: 0,
                    at: 0,
                    sort: 7
                },
                dangerous_attacks: {
                    ht: 0,
                    at: 0,
                    sort: 8
                }
            },
            second_half: {
                shots_on_target: {
                    ht: 2,
                    at: 4,
                    sort: 1
                },
                shots_off_target: {
                    ht: 1,
                    at: 5,
                    sort: 2
                },
                possession_percentage: {
                    ht: 0,
                    at: 0,
                    sort: 3
                },
                corner_kicks: {
                    ht: 1,
                    at: 1,
                    sort: 4
                },
                yellow_cards: {
                    ht: 2,
                    at: 1,
                    sort: 5
                },
                red_cards: {
                    ht: 0,
                    at: 0,
                    sort: 6
                },
                attacks: {
                    ht: 0,
                    at: 0,
                    sort: 7
                },
                dangerous_attacks: {
                    ht: 0,
                    at: 0,
                    sort: 8
                }
            },
            total: {
                shots_on_target: {
                    ht: 4,
                    at: 4,
                    sort: 1
                },
                shots_off_target: {
                    ht: 3,
                    at: 8,
                    sort: 2
                },
                possession_percentage: {
                    ht: 29,
                    at: 71,
                    sort: 3
                },
                corner_kicks: {
                    ht: 3,
                    at: 2,
                    sort: 4
                },
                yellow_cards: {
                    ht: 3,
                    at: 2,
                    sort: 5
                },
                red_cards: {
                    ht: 0,
                    at: 0,
                    sort: 6
                },
                attacks: {
                    ht: 0,
                    at: 0,
                    sort: 7
                },
                dangerous_attacks: {
                    ht: 0,
                    at: 0,
                    sort: 8
                }
            }
        }
    }
};
const $c7a1dff880521ff2$var$FAN_VOTE = {
    name: "FanVoteWidget",
    props: {
        width: "300px",
        height: "600px"
    },
    componentData: {
        question: "Who will win the title this season?",
        category: "Fan Vote",
        league: "Premier League",
        emoji: "\u26BD",
        apiUrl: "",
        options: [
            {
                id: "arsenal",
                label: "Arsenal"
            },
            {
                id: "mancity",
                label: "Man City"
            },
            {
                id: "liverpool",
                label: "Liverpool"
            }
        ]
    }
};
const $c7a1dff880521ff2$export$6c683cdfb3dcaafa = {
    components: [
        $c7a1dff880521ff2$var$MATCH_HEAD_1,
        $c7a1dff880521ff2$var$MATCH_TIMELINE,
        $c7a1dff880521ff2$var$MATCH_HEAD_2,
        $c7a1dff880521ff2$var$MATCH_STATS,
        $c7a1dff880521ff2$var$FAN_VOTE
    ]
};
const $c7a1dff880521ff2$export$85bcc6af9f9fd68e = {
    components: [
        $c7a1dff880521ff2$var$MATCH_HEAD_1,
        $c7a1dff880521ff2$var$MATCH_HEAD_2
    ]
};
const $c7a1dff880521ff2$export$1c023ef7998450 = {
    components: [
        $c7a1dff880521ff2$var$MATCH_TIMELINE,
        $c7a1dff880521ff2$var$MATCH_STATS,
        $c7a1dff880521ff2$var$FAN_VOTE
    ]
};


// Default RSS feed URL — can be overridden via data-feedurl attribute or data prop
const $202507578bd7a900$var$DEFAULT_FEED_URL = "https://q.loop-feed.com/v1/topic/cmi5nqc0d0ku6hxyl853a393j/content&service=rss&limit=20";
/**
 * Widget wrapper for the Interactives feature.
 * Routes dataType to the appropriate component.
 *
 * Supported dataTypes:
 *  "interactives-rss"  - RSS feed with 300x250 match head or ad slots
 *
 * DOM attributes consumed:
 *  data-feedurl        - RSS feed URL (defaults to loop-feed API)
 *  data-matchid        - Football match ID to render as the 300x250 match head widget
 *  data-base-url       - API base URL (required when data-matchid is set)
 *  data-difference     - Timezone offset (e.g. "+5")
 *  data-matchsport     - Sport for the match head (default: "football")
 *  data-maxitems       - Max RSS items to show
 */ const $202507578bd7a900$var$InteractivesWidgetWrap = ({ dataType: dataType = "", data: data = null, loadCSS: loadCSS = true, dataClient: dataClient = false, websiteBaseUrl: websiteBaseUrl = "", dataPath: dataPath = "", dictionary: dictionary = {}, containerEl: containerEl })=>{
    switch(dataType){
        case "interactives-rss":
            {
                const adInsertAfter = parseInt((0, $f917cf413a74f715$export$1c2c427a44c364ab)("adafter", containerEl) || "3", 10);
                const difference = (0, $f917cf413a74f715$export$1c2c427a44c364ab)("difference", containerEl) || "+0";
                // Socket config for live match updates in MatchHeadWidget ads
                const socketConfig = data?.socketConfig || {
                    socketUrl: (0, $f917cf413a74f715$export$1c2c427a44c364ab)("socketurl", containerEl) || "",
                    channel: (0, $f917cf413a74f715$export$1c2c427a44c364ab)("channel", containerEl) || "FootballMatch",
                    event: (0, $f917cf413a74f715$export$1c2c427a44c364ab)("event", containerEl) || "FootballMatchDetails"
                };
                // Slider ratio — if set (e.g. "300x250"), compact slider; if empty, large dialog
                const sliderRatio = (0, $f917cf413a74f715$export$1c2c427a44c364ab)("ratio", containerEl) || data?.sliderRatio || "";
                // Pick mock components based on slider ratio
                const mockComponents = sliderRatio === "300x600" ? (0, $c7a1dff880521ff2$export$1c023ef7998450).components : sliderRatio === "300x250" ? (0, $c7a1dff880521ff2$export$85bcc6af9f9fd68e).components : (0, $c7a1dff880521ff2$export$6c683cdfb3dcaafa).components;
                // Component-based ad config — cycles through components array
                // When the real API is ready, replace mock data with the API response.
                const adConfig = data?.adConfig || [
                    {
                        type: "components",
                        components: mockComponents,
                        insertAfter: adInsertAfter,
                        difference: difference,
                        socketConfig: socketConfig
                    }
                ];
                // Caption toggle — "false" hides body/footer overlay in slider cards
                const captionAttr = (0, $f917cf413a74f715$export$1c2c427a44c364ab)("caption", containerEl);
                const showCaption = captionAttr === "false" ? false : data?.showCaption !== false;
                return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $6c05381c7864995e$export$2e2bcd8739ae039), {
                    ServerData: data?.items || null,
                    feedUrl: data?.feedUrl || $202507578bd7a900$var$DEFAULT_FEED_URL,
                    adConfig: adConfig,
                    layout: data?.layout || 300,
                    gap: data?.gap || 16,
                    maxItems: data?.maxItems || 20,
                    loadCSS: loadCSS,
                    dataClient: dataClient,
                    dictionary: dictionary,
                    sliderRatio: sliderRatio,
                    showCaption: showCaption,
                    containerEl: containerEl
                });
            }
        default:
            return null;
    }
};
var $202507578bd7a900$export$2e2bcd8739ae039 = $202507578bd7a900$var$InteractivesWidgetWrap;


const $69276d19e2e86d10$var$InteractivesWidgets = ({ dataType: dataType, data: data, loadCSS: loadCSS, dataClient: dataClient = false, websiteBaseUrl: websiteBaseUrl, dataPath: dataPath, dictionary: dictionary, containerEl: containerEl })=>{
    if (dataType?.startsWith("interactives-")) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $202507578bd7a900$export$2e2bcd8739ae039), {
        dataType: dataType,
        data: data,
        loadCSS: loadCSS,
        dataClient: dataClient,
        websiteBaseUrl: websiteBaseUrl,
        dataPath: dataPath,
        dictionary: dictionary || {},
        containerEl: containerEl
    });
    return null;
};
var $69276d19e2e86d10$export$2e2bcd8739ae039 = $69276d19e2e86d10$var$InteractivesWidgets;


const $8a8505084357b98e$var$mountWidget = (container)=>{
    if (!container) return;
    const props = {
        dataId: container.getAttribute("data-id"),
        dataType: container.getAttribute("data-type"),
        sport: container.getAttribute("data-sport"),
        difference: container.getAttribute("data-difference"),
        baseUrl: container.getAttribute("data-base-url"),
        head: container.getAttribute("data-head"),
        date: container.getAttribute("data-date"),
        loadCSS: container.getAttribute("data-loadcss"),
        isLive: container.getAttribute("data-live"),
        dataTest: container.getAttribute("data-listingdata"),
        dataSSR: container.getAttribute("data-ssr"),
        websiteBaseUrl: container.getAttribute("data-websiteurl"),
        dataPath: container.getAttribute("data-path"),
        dataTitle: container.getAttribute("data-title"),
        dataClient: true
    };
    const sport = props.sport;
    // Interactives: client-only, no hydration — use createRoot
    if (sport === "interactives") {
        const root = (0, (/*@__PURE__*/$parcel$interopDefault($64d0b1ebdd6bcffe$exports))).createRoot(container);
        root.render(/*#__PURE__*/ (0, $lBpE3.jsx)((0, $69276d19e2e86d10$export$2e2bcd8739ae039), {
            dataType: props.dataType,
            data: null,
            loadCSS: props.loadCSS,
            dataClient: true,
            websiteBaseUrl: props.websiteBaseUrl,
            dataPath: props.dataPath,
            containerEl: container
        }));
        container.classList.add("hydrated");
        return;
    }
    const widgetMap = {
        cricket: (0, $fe795af5b52e44e5$export$2e2bcd8739ae039),
        football: (0, $79f81462860edff5$export$2e2bcd8739ae039),
        rugby: (0, $91bd757537afc7e6$export$2e2bcd8739ae039),
        tennis: (0, $6ab262639247c8ff$export$2e2bcd8739ae039),
        basketball: (0, $7dede4de5c0be374$export$2e2bcd8739ae039),
        golf: (0, $e6f666b350f200a3$export$2e2bcd8739ae039),
        horseracing: (0, $d708060ad8e5ccf4$export$2e2bcd8739ae039),
        icehockey: (0, $a63d2f8c41fc1b1a$export$2e2bcd8739ae039),
        formula1: (0, $c64688258cb3a412$export$2e2bcd8739ae039)
    };
    const WidgetComponent = widgetMap[sport];
    if (WidgetComponent) {
        (0, (/*@__PURE__*/$parcel$interopDefault($64d0b1ebdd6bcffe$exports))).hydrateRoot(container, /*#__PURE__*/ (0, $lBpE3.jsx)(WidgetComponent, {
            ...props
        }));
        container.classList.add("hydrated");
    } else console.warn(`No widget found for sport: ${sport}`);
};
// Mount all widgets on initial page load
document.querySelectorAll(".microservice-cont:not(.hydrated)").forEach($8a8505084357b98e$var$mountWidget);
// Expose for dynamically injected widgets (e.g. Next.js)
window.__MICRO_MOUNT = $8a8505084357b98e$var$mountWidget;

})();
//# sourceMappingURL=client.js.map
